/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as StaffImport } from './routes/_staff'
import { Route as StacktraceImport } from './routes/_stacktrace'
import { Route as IndividualImport } from './routes/_individual'
import { Route as IdpSsoMockImport } from './routes/_idp-sso-mock'
import { Route as CockpitMockImport } from './routes/_cockpit-mock'
import { Route as ChatImport } from './routes/_chat'
import { Route as IndexImport } from './routes/index'
import { Route as MeIndexImport } from './routes/me/index'
import { Route as StaffIdManagementsImport } from './routes/_staff/id-managements'
import { Route as StaffAppsImport } from './routes/_staff/apps'
import { Route as StacktraceQaOperationsCoreImport } from './routes/_stacktrace/qa-operations-core'
import { Route as StacktraceProductPlanningCoreImport } from './routes/_stacktrace/product-planning-core'
import { Route as StacktracePlanningOperationsCoreImport } from './routes/_stacktrace/planning-operations-core'
import { Route as Oauth2LogoutIndexImport } from './routes/oauth2/logout/index'
import { Route as Oauth2LoginIndexImport } from './routes/oauth2/login/index'
import { Route as Oauth2ErrorIndexImport } from './routes/oauth2/error/index'
import { Route as Oauth2ConsentIndexImport } from './routes/oauth2/consent/index'
import { Route as AuthSignInIndexImport } from './routes/auth/sign-in/index'
import { Route as AuthPasswordResetIndexImport } from './routes/auth/password-reset/index'
import { Route as AccountSsoIndexImport } from './routes/account/sso/index'
import { Route as StaffSettingsIndexImport } from './routes/_staff/settings/index'
import { Route as StaffOrganizationIndexImport } from './routes/_staff/organization/index'
import { Route as StaffItOperationCoreIndexImport } from './routes/_staff/it-operation-core/index'
import { Route as StaffCockpitIndexImport } from './routes/_staff/cockpit/index'
import { Route as StacktraceTestAssetsIndexImport } from './routes/_stacktrace/test-assets/index'
import { Route as StacktraceProductsIndexImport } from './routes/_stacktrace/products/index'
import { Route as StacktraceProductionIndexImport } from './routes/_stacktrace/production/index'
import { Route as StacktraceDevelopmentTicketsIndexImport } from './routes/_stacktrace/development-tickets/index'
import { Route as IndividualIndividualIndexImport } from './routes/_individual/individual/index'
import { Route as CockpitMockCockpitMockIndexImport } from './routes/_cockpit-mock/cockpit-mock/index'
import { Route as ChatChatIndexImport } from './routes/_chat/chat/index'
import { Route as StaffTimeAndAttendanceLayoutImport } from './routes/_staff/time-and-attendance/_layout'
import { Route as StaffSupplierListImport } from './routes/_staff/supplier/_list'
import { Route as StaffStorageFilesListImport } from './routes/_staff/storage-files/_list'
import { Route as StaffStarlinksLayoutImport } from './routes/_staff/starlinks/_layout'
import { Route as StaffSoftwareLayoutImport } from './routes/_staff/software/_layout'
import { Route as StaffPublicIdsListImport } from './routes/_staff/public-ids/_list'
import { Route as StaffPublicIdsIdImport } from './routes/_staff/public-ids/$id'
import { Route as StaffPlacesLayoutImport } from './routes/_staff/places/_layout'
import { Route as StaffPeopleListImport } from './routes/_staff/people/_list'
import { Route as StaffPayrollLayoutImport } from './routes/_staff/payroll/_layout'
import { Route as StaffPayrollEngineLayoutImport } from './routes/_staff/payroll-engine/_layout'
import { Route as StaffPayrollCoreLayoutImport } from './routes/_staff/payroll-core/_layout'
import { Route as StaffOrganizationListImport } from './routes/_staff/organization/_list'
import { Route as StaffNetworksLayoutImport } from './routes/_staff/networks/_layout'
import { Route as StaffMarketplaceStoreImport } from './routes/_staff/marketplace/_store'
import { Route as StaffLicensesListImport } from './routes/_staff/licenses/_list'
import { Route as StaffLaborCoreYearEndAdjustmentConfirmationImport } from './routes/_staff/labor-core/year-end-adjustment-confirmation'
import { Route as StaffLaborCorePersonTargetsImport } from './routes/_staff/labor-core/person-targets'
import { Route as StaffLaborCoreGovernmentApplicationConfirmationImport } from './routes/_staff/labor-core/government-application-confirmation'
import { Route as StaffLaborCoreContractTargetsImport } from './routes/_staff/labor-core/contract-targets'
import { Route as StaffLaborCoreAnchorDateImport } from './routes/_staff/labor-core/anchor-date'
import { Route as StaffLaborCorePackagesImport } from './routes/_staff/labor-core/_packages'
import { Route as StaffItOperationCoreSelfReportConfirmationImport } from './routes/_staff/it-operation-core/self-report-confirmation'
import { Route as StaffItOperationCoreAnchorDateImport } from './routes/_staff/it-operation-core/anchor-date'
import { Route as StaffItOperationCoreRootImport } from './routes/_staff/it-operation-core/_root'
import { Route as StaffItOperationCoreDetailImport } from './routes/_staff/it-operation-core/_detail'
import { Route as StaffIdsLayoutImport } from './routes/_staff/ids/_layout'
import { Route as StaffIdManagementsSplatImport } from './routes/_staff/id-managements/$'
import { Route as StaffGaOperationCorePackagesImport } from './routes/_staff/ga-operation-core/_packages'
import { Route as StaffFleetsLayoutImport } from './routes/_staff/fleets/_layout'
import { Route as StaffEquipmentLayoutImport } from './routes/_staff/equipment/_layout'
import { Route as StaffDevicesListImport } from './routes/_staff/devices/_list'
import { Route as StaffDealListImport } from './routes/_staff/deal/_list'
import { Route as StaffContractorCorePersonTargetsImport } from './routes/_staff/contractor-core/person-targets'
import { Route as StaffContractorCoreContractTargetsImport } from './routes/_staff/contractor-core/contract-targets'
import { Route as StaffContractorCoreAnchorDateImport } from './routes/_staff/contractor-core/anchor-date'
import { Route as StaffContractorCorePackagesImport } from './routes/_staff/contractor-core/_packages'
import { Route as StaffContractListImport } from './routes/_staff/contract/_list'
import { Route as StaffCertificationListImport } from './routes/_staff/certification/_list'
import { Route as StaffBusinessPartnerListImport } from './routes/_staff/business-partner/_list'
import { Route as StaffBusinessOperationEventsListImport } from './routes/_staff/business-operation-events/_list'
import { Route as StaffAttendancesLayoutImport } from './routes/_staff/attendances/_layout'
import { Route as StaffAttendanceEngineLayoutImport } from './routes/_staff/attendance-engine/_layout'
import { Route as StaffAttendanceCoreLayoutImport } from './routes/_staff/attendance-core/_layout'
import { Route as StaffAppsSplatImport } from './routes/_staff/apps/$'
import { Route as StaffAccessesLayoutImport } from './routes/_staff/accesses/_layout'
import { Route as StacktraceValuesLayoutImport } from './routes/_stacktrace/values/_layout'
import { Route as StacktraceTestSuitesLayoutImport } from './routes/_stacktrace/test-suites/_layout'
import { Route as StacktraceTestSetsLayoutImport } from './routes/_stacktrace/test-sets/_layout'
import { Route as StacktraceProductRoadmapLayoutImport } from './routes/_stacktrace/product-roadmap/_layout'
import { Route as StacktraceIssuesLayoutImport } from './routes/_stacktrace/issues/_layout'
import { Route as IndividualIndividualPortalImport } from './routes/_individual/individual/portal'
import { Route as IndividualIndividualProfileImport } from './routes/_individual/individual/_profile'
import { Route as StaffPlacesImportCsvRouteImport } from './routes/_staff/places/import-csv/route'
import { Route as StaffItOperationCoreDeviceInventoryRouteImport } from './routes/_staff/it-operation-core/device-inventory/route'
import { Route as StacktraceValuesImportCsvRouteImport } from './routes/_stacktrace/values/import-csv/route'
import { Route as StacktraceIssuesImportCsvRouteImport } from './routes/_stacktrace/issues/import-csv/route'
import { Route as StacktraceDevelopmentTicketsImportCsvRouteImport } from './routes/_stacktrace/development-tickets/import-csv/route'
import { Route as AuthSignInErrorIndexImport } from './routes/auth/sign-in/error/index'
import { Route as AuthInvitationInvitationCodeIndexImport } from './routes/auth/invitation/$invitationCode/index'
import { Route as StaffTimeAndAttendanceLayoutIndexImport } from './routes/_staff/time-and-attendance/_layout/index'
import { Route as StaffSupplierListIndexImport } from './routes/_staff/supplier/_list/index'
import { Route as StaffStorageFilesListIndexImport } from './routes/_staff/storage-files/_list/index'
import { Route as StaffStarlinksLayoutIndexImport } from './routes/_staff/starlinks/_layout/index'
import { Route as StaffSoftwareAddIndexImport } from './routes/_staff/software/add/index'
import { Route as StaffSettingsPersonsIndexImport } from './routes/_staff/settings/persons/index'
import { Route as StaffSettingsPermissionAndRolesIndexImport } from './routes/_staff/settings/permission-and-roles/index'
import { Route as StaffSettingsContractingCorporationProfileIndexImport } from './routes/_staff/settings/contracting-corporation-profile/index'
import { Route as StaffPublicIdsAddIndexImport } from './routes/_staff/public-ids/add/index'
import { Route as StaffPublicIdsListIndexImport } from './routes/_staff/public-ids/_list/index'
import { Route as StaffPublicIdsIdIndexImport } from './routes/_staff/public-ids/$id/index'
import { Route as StaffPlacesAddIndexImport } from './routes/_staff/places/add/index'
import { Route as StaffPlacesAddSelectIndexImport } from './routes/_staff/places/add-select/index'
import { Route as StaffPlacesLayoutIndexImport } from './routes/_staff/places/_layout/index'
import { Route as StaffPersonExternalHrSaasIndexImport } from './routes/_staff/person/external-hr-saas/index'
import { Route as StaffPersonAddIndexImport } from './routes/_staff/person/add/index'
import { Route as StaffPersonAddPersonCertificationIndexImport } from './routes/_staff/person/add-person-certification/index'
import { Route as StaffPayrollLayoutIndexImport } from './routes/_staff/payroll/_layout/index'
import { Route as StaffPayrollEngineLayoutIndexImport } from './routes/_staff/payroll-engine/_layout/index'
import { Route as StaffPayrollCoreLayoutIndexImport } from './routes/_staff/payroll-core/_layout/index'
import { Route as StaffOrganizationPlanIndexImport } from './routes/_staff/organization/plan/index'
import { Route as StaffNetworksAddIndexImport } from './routes/_staff/networks/add/index'
import { Route as StaffNetworksLayoutIndexImport } from './routes/_staff/networks/_layout/index'
import { Route as StaffMarketplaceUnavailableIndexImport } from './routes/_staff/marketplace/unavailable/index'
import { Route as StaffMarketplaceCartIndexImport } from './routes/_staff/marketplace/cart/index'
import { Route as StaffLicensesAddIndexImport } from './routes/_staff/licenses/add/index'
import { Route as StaffLaborCorePackagesIndexImport } from './routes/_staff/labor-core/_packages/index'
import { Route as StaffItOperationCorePersonTargetsIndexImport } from './routes/_staff/it-operation-core/person-targets/index'
import { Route as StaffItOperationCoreDeviceTargetsIndexImport } from './routes/_staff/it-operation-core/device-targets/index'
import { Route as StaffIdsLayoutIndexImport } from './routes/_staff/ids/_layout/index'
import { Route as StaffGaOperationCorePackagesIndexImport } from './routes/_staff/ga-operation-core/_packages/index'
import { Route as StaffFleetsAddIndexImport } from './routes/_staff/fleets/add/index'
import { Route as StaffFleetsAddSelectIndexImport } from './routes/_staff/fleets/add-select/index'
import { Route as StaffEquipmentImportCsvIndexImport } from './routes/_staff/equipment/import-csv/index'
import { Route as StaffEquipmentAddIndexImport } from './routes/_staff/equipment/add/index'
import { Route as StaffEquipmentAddSelectIndexImport } from './routes/_staff/equipment/add-select/index'
import { Route as StaffEquipmentLayoutIndexImport } from './routes/_staff/equipment/_layout/index'
import { Route as StaffDevicesExternalItSaasIndexImport } from './routes/_staff/devices/external-it-saas/index'
import { Route as StaffDevicesAddIndexImport } from './routes/_staff/devices/add/index'
import { Route as StaffDeviceCatalogAddIndexImport } from './routes/_staff/device-catalog/add/index'
import { Route as StaffDealAddIndexImport } from './routes/_staff/deal/add/index'
import { Route as StaffDealListIndexImport } from './routes/_staff/deal/_list/index'
import { Route as StaffContractorCorePackagesIndexImport } from './routes/_staff/contractor-core/_packages/index'
import { Route as StaffContractAddIndexImport } from './routes/_staff/contract/add/index'
import { Route as StaffContractListIndexImport } from './routes/_staff/contract/_list/index'
import { Route as StaffCertificationAddIndexImport } from './routes/_staff/certification/add/index'
import { Route as StaffBusinessPartnerAddIndexImport } from './routes/_staff/business-partner/add/index'
import { Route as StaffBusinessPartnerListIndexImport } from './routes/_staff/business-partner/_list/index'
import { Route as StaffBusinessOperationEventsListIndexImport } from './routes/_staff/business-operation-events/_list/index'
import { Route as StaffBusinessOperationEventsEventInstanceIdIndexImport } from './routes/_staff/business-operation-events/$eventInstanceId/index'
import { Route as StaffAttendancesLayoutIndexImport } from './routes/_staff/attendances/_layout/index'
import { Route as StaffAttendanceEngineLayoutIndexImport } from './routes/_staff/attendance-engine/_layout/index'
import { Route as StaffAttendanceCoreLayoutIndexImport } from './routes/_staff/attendance-core/_layout/index'
import { Route as StaffAccessesLayoutIndexImport } from './routes/_staff/accesses/_layout/index'
import { Route as StacktraceValuesAddIndexImport } from './routes/_stacktrace/values/add/index'
import { Route as StacktraceValuesAddSelectIndexImport } from './routes/_stacktrace/values/add-select/index'
import { Route as StacktraceValuesLayoutIndexImport } from './routes/_stacktrace/values/_layout/index'
import { Route as StacktraceTestSuitesLayoutIndexImport } from './routes/_stacktrace/test-suites/_layout/index'
import { Route as StacktraceTestSetsLayoutIndexImport } from './routes/_stacktrace/test-sets/_layout/index'
import { Route as StacktraceProductsAddIndexImport } from './routes/_stacktrace/products/add/index'
import { Route as StacktraceProductsAddSelectIndexImport } from './routes/_stacktrace/products/add-select/index'
import { Route as StacktraceProductRoadmapLayoutIndexImport } from './routes/_stacktrace/product-roadmap/_layout/index'
import { Route as StacktraceIssuesExternalIntegrationsIndexImport } from './routes/_stacktrace/issues/external-integrations/index'
import { Route as StacktraceIssuesAddIndexImport } from './routes/_stacktrace/issues/add/index'
import { Route as StacktraceIssuesAddSelectIndexImport } from './routes/_stacktrace/issues/add-select/index'
import { Route as StacktraceIssuesLayoutIndexImport } from './routes/_stacktrace/issues/_layout/index'
import { Route as StacktraceDevelopmentTicketsExternalIntegrationsIndexImport } from './routes/_stacktrace/development-tickets/external-integrations/index'
import { Route as StacktraceDevelopmentTicketsAddIndexImport } from './routes/_stacktrace/development-tickets/add/index'
import { Route as StacktraceDevelopmentTicketsAddSelectIndexImport } from './routes/_stacktrace/development-tickets/add-select/index'
import { Route as IndividualIndividualPortalIndexImport } from './routes/_individual/individual/portal/index'
import { Route as IdpSsoMockIdpSsoGoogleWorkspaceIndexImport } from './routes/_idp-sso-mock/idp-sso/google-workspace/index'
import { Route as ChatChatNewIndexImport } from './routes/_chat/chat/new/index'
import { Route as ChatChatSessionIdIndexImport } from './routes/_chat/chat/$sessionId/index'
import { Route as StaffUsersUserIdLayoutImport } from './routes/_staff/users/$userId/_layout'
import { Route as StaffSupplierSupplierIdLayoutImport } from './routes/_staff/supplier/$supplierId/_layout'
import { Route as StaffStarlinksIdLayoutImport } from './routes/_staff/starlinks/$id/_layout'
import { Route as StaffSoftwareLayoutIntegrationsImport } from './routes/_staff/software/_layout/integrations'
import { Route as StaffSoftwareIdIdImport } from './routes/_staff/software/$id/_$id'
import { Route as StaffSettingsPersonsListImport } from './routes/_staff/settings/persons/_list'
import { Route as StaffSettingsPermissionAndRolesListImport } from './routes/_staff/settings/permission-and-roles/_list'
import { Route as StaffSettingsPermissionAndRolesFormImport } from './routes/_staff/settings/permission-and-roles/_form'
import { Route as StaffSettingsPermissionAndRolesDetailImport } from './routes/_staff/settings/permission-and-roles/_detail'
import { Route as StaffSettingsContractingCorporationProfileLayoutImport } from './routes/_staff/settings/contracting-corporation-profile/_layout'
import { Route as StaffPlacesLayoutOverviewImport } from './routes/_staff/places/_layout/overview'
import { Route as StaffPlacesIdLayoutImport } from './routes/_staff/places/$id/_layout'
import { Route as StaffPersonIdProfileImport } from './routes/_staff/person/$id/_profile'
import { Route as StaffPeopleListSalaryAndPaymentImport } from './routes/_staff/people/_list/salary-and-payment'
import { Route as StaffPeopleListRuleAndPolicyImport } from './routes/_staff/people/_list/rule-and-policy'
import { Route as StaffPeopleListPeopleGraphImport } from './routes/_staff/people/_list/people-graph'
import { Route as StaffPeopleListCommunityImport } from './routes/_staff/people/_list/community'
import { Route as StaffPeopleListAlertsImport } from './routes/_staff/people/_list/alerts'
import { Route as StaffOrganizationIdLayoutImport } from './routes/_staff/organization/$id/_layout'
import { Route as StaffNetworksIdLayoutImport } from './routes/_staff/networks/$id/_layout'
import { Route as StaffLicensesIdProfileImport } from './routes/_staff/licenses/$id/_profile'
import { Route as StaffLaborCoreSettingsEgovCallbackImport } from './routes/_staff/labor-core/settings/egov-callback'
import { Route as StaffLaborCorePackagesSettingsImport } from './routes/_staff/labor-core/_packages/settings'
import { Route as StaffItOperationCoreDeviceInventoryDetailImport } from './routes/_staff/it-operation-core/device-inventory/detail'
import { Route as StaffItOperationCoreDeviceInventoryDataImport } from './routes/_staff/it-operation-core/device-inventory/data'
import { Route as StaffFleetsLayoutSettingsImport } from './routes/_staff/fleets/_layout/settings'
import { Route as StaffFleetsLayoutRuleAndPolicyImport } from './routes/_staff/fleets/_layout/rule-and-policy'
import { Route as StaffFleetsLayoutOverviewImport } from './routes/_staff/fleets/_layout/overview'
import { Route as StaffFleetsLayoutAlertsImport } from './routes/_staff/fleets/_layout/alerts'
import { Route as StaffFleetsIdLayoutImport } from './routes/_staff/fleets/$id/_layout'
import { Route as StaffEquipmentIdLayoutImport } from './routes/_staff/equipment/$id/_layout'
import { Route as StaffDevicesListRuleAndPolicyImport } from './routes/_staff/devices/_list/rule-and-policy'
import { Route as StaffDevicesListOperationActivityImport } from './routes/_staff/devices/_list/operation-activity'
import { Route as StaffDevicesListAlertsImport } from './routes/_staff/devices/_list/alerts'
import { Route as StaffDevicesIdLayoutImport } from './routes/_staff/devices/$id/_layout'
import { Route as StaffDealDealIdLayoutImport } from './routes/_staff/deal/$dealId/_layout'
import { Route as StaffContractIdLayoutImport } from './routes/_staff/contract/$id/_layout'
import { Route as StaffCertificationIdLayoutImport } from './routes/_staff/certification/$id/_layout'
import { Route as StaffBusinessPartnerIdLayoutImport } from './routes/_staff/business-partner/$id/_layout'
import { Route as StaffBusinessOperationEventsListSettingsImport } from './routes/_staff/business-operation-events/_list/settings'
import { Route as StaffBusinessOperationEventsListRuleAndPolicyImport } from './routes/_staff/business-operation-events/_list/rule-and-policy'
import { Route as StaffBusinessOperationEventsListOverviewImport } from './routes/_staff/business-operation-events/_list/overview'
import { Route as StaffBusinessOperationEventsListOperationActivityImport } from './routes/_staff/business-operation-events/_list/operation-activity'
import { Route as StaffBusinessOperationEventsListConfigImport } from './routes/_staff/business-operation-events/_list/config'
import { Route as StaffBusinessOperationEventsListArchiveImport } from './routes/_staff/business-operation-events/_list/archive'
import { Route as StaffAppIntegrationsIdIdImport } from './routes/_staff/app-integrations/$id/_$id'
import { Route as StacktraceValuesIdLayoutImport } from './routes/_stacktrace/values/$id/_layout'
import { Route as StacktraceTestSuitesIdLayoutImport } from './routes/_stacktrace/test-suites/$id/_layout'
import { Route as StacktraceTestSetsIdLayoutImport } from './routes/_stacktrace/test-sets/$id/_layout'
import { Route as StacktraceProductsIdLayoutImport } from './routes/_stacktrace/products/$id/_layout'
import { Route as StacktraceProductionProductionIdLayoutImport } from './routes/_stacktrace/production/$productionId/_layout'
import { Route as StacktraceProductRoadmapRoadmapIdLayoutImport } from './routes/_stacktrace/product-roadmap/$roadmapId/_layout'
import { Route as StacktraceIssuesIdLayoutImport } from './routes/_stacktrace/issues/$id/_layout'
import { Route as StacktraceDevelopmentTicketsTicketIdLayoutImport } from './routes/_stacktrace/development-tickets/$ticketId/_layout'
import { Route as StaffSoftwareLayoutPeopleRouteImport } from './routes/_staff/software/_layout/people/route'
import { Route as StaffSoftwareIdImportCsvRouteImport } from './routes/_staff/software/$id/import-csv/route'
import { Route as StaffPublicIdsImportCsvPublicIdTypeRouteImport } from './routes/_staff/public-ids/import-csv/$publicIdType/route'
import { Route as StaffPlacesLayoutSettingsRouteImport } from './routes/_staff/places/_layout/settings/route'
import { Route as StaffPersonImportCsvWorkerTypeRouteImport } from './routes/_staff/person/import-csv/$workerType/route'
import { Route as StaffItOperationCoreRootPackagesRouteImport } from './routes/_staff/it-operation-core/_root/packages/route'
import { Route as StaffItOperationCoreRootInHousePackagesRouteImport } from './routes/_staff/it-operation-core/_root/in-house-packages/route'
import { Route as StaffDevicesImportCsvDeviceTypeRouteImport } from './routes/_staff/devices/import-csv/$deviceType/route'
import { Route as StaffBusinessPartnerImportCsvIndividualRouteImport } from './routes/_staff/business-partner/import-csv/individual/route'
import { Route as StaffBusinessPartnerImportCsvCorporationRouteImport } from './routes/_staff/business-partner/import-csv/corporation/route'
import { Route as StaffAppIntegrationsImportCsvIdRouteImport } from './routes/_staff/app-integrations/import-csv/$id/route'
import { Route as StaffLicensesListIndexRouteImport } from './routes/_staff/licenses/_list/index/route'
import { Route as StaffCertificationListIndexRouteImport } from './routes/_staff/certification/_list/index/route'
import { Route as StaffTimeAndAttendanceLayoutAttendanceLinksIndexImport } from './routes/_staff/time-and-attendance/_layout/attendance-links/index'
import { Route as StaffSupplierListSettingsIndexImport } from './routes/_staff/supplier/_list/settings/index'
import { Route as StaffStorageFilesListSettingsIndexImport } from './routes/_staff/storage-files/_list/settings/index'
import { Route as StaffStorageFilesListFoldersIndexImport } from './routes/_staff/storage-files/_list/folders/index'
import { Route as StaffStorageFilesListFilesIndexImport } from './routes/_staff/storage-files/_list/files/index'
import { Route as StaffStarlinksLayoutUserTerminalsIndexImport } from './routes/_staff/starlinks/_layout/user-terminals/index'
import { Route as StaffStarlinksLayoutAlertsIndexImport } from './routes/_staff/starlinks/_layout/alerts/index'
import { Route as StaffSoftwareAddTypeIndexImport } from './routes/_staff/software/add/$type/index'
import { Route as StaffSoftwareLayoutSettingsIndexImport } from './routes/_staff/software/_layout/settings/index'
import { Route as StaffSoftwareLayoutRuleAndPolicyIndexImport } from './routes/_staff/software/_layout/rule-and-policy/index'
import { Route as StaffSoftwareLayoutRegistryIndexImport } from './routes/_staff/software/_layout/registry/index'
import { Route as StaffSoftwareLayoutPeopleIndexImport } from './routes/_staff/software/_layout/people/index'
import { Route as StaffSoftwareLayoutOperationActivityIndexImport } from './routes/_staff/software/_layout/operation-activity/index'
import { Route as StaffSoftwareLayoutLibraryIndexImport } from './routes/_staff/software/_layout/library/index'
import { Route as StaffSoftwareIdIdIndexImport } from './routes/_staff/software/$id/_$id/index'
import { Route as StaffSettingsPersonsInviteIndexImport } from './routes/_staff/settings/persons/invite/index'
import { Route as StaffSettingsDataConnectorOutboundIndexImport } from './routes/_staff/settings/data-connector/outbound/index'
import { Route as StaffSettingsDataConnectorInboundIndexImport } from './routes/_staff/settings/data-connector/inbound/index'
import { Route as StaffPublicIdsListSettingsIndexImport } from './routes/_staff/public-ids/_list/settings/index'
import { Route as StaffPublicIdsListRulesAndPoliciesIndexImport } from './routes/_staff/public-ids/_list/rules-and-policies/index'
import { Route as StaffPublicIdsListRegistryIndexImport } from './routes/_staff/public-ids/_list/registry/index'
import { Route as StaffPublicIdsListOperationActivityIndexImport } from './routes/_staff/public-ids/_list/operation-activity/index'
import { Route as StaffPublicIdsListMembersIndexImport } from './routes/_staff/public-ids/_list/members/index'
import { Route as StaffPublicIdsListAlertsIndexImport } from './routes/_staff/public-ids/_list/alerts/index'
import { Route as StaffPublicIdsIdFilesIndexImport } from './routes/_staff/public-ids/$id/files/index'
import { Route as StaffPublicIdsIdDetailsIndexImport } from './routes/_staff/public-ids/$id/details/index'
import { Route as StaffProfileDeviceIdIndexImport } from './routes/_staff/profile/device/$id/index'
import { Route as StaffPlacesLayoutSettingsIndexImport } from './routes/_staff/places/_layout/settings/index'
import { Route as StaffPersonAutomapIngesterWorkerTypeIndexImport } from './routes/_staff/person/automap-ingester/$workerType/index'
import { Route as StaffPersonAddWorkerTypeIndexImport } from './routes/_staff/person/add/$workerType/index'
import { Route as StaffPersonAddPersonCertificationCertificationKindIndexImport } from './routes/_staff/person/add-person-certification/$certificationKind/index'
import { Route as StaffPeopleListWorkforceIndexImport } from './routes/_staff/people/_list/workforce/index'
import { Route as StaffPeopleListSettingsIndexImport } from './routes/_staff/people/_list/settings/index'
import { Route as StaffPeopleListOperationActivityIndexImport } from './routes/_staff/people/_list/operation-activity/index'
import { Route as StaffPeopleListAlumniIndexImport } from './routes/_staff/people/_list/alumni/index'
import { Route as StaffPayrollLayoutSettingsIndexImport } from './routes/_staff/payroll/_layout/settings/index'
import { Route as StaffPayrollLayoutRuleAndPolicyIndexImport } from './routes/_staff/payroll/_layout/rule-and-policy/index'
import { Route as StaffPayrollLayoutPaySlipsIndexImport } from './routes/_staff/payroll/_layout/pay-slips/index'
import { Route as StaffPayrollLayoutOverviewIndexImport } from './routes/_staff/payroll/_layout/overview/index'
import { Route as StaffPayrollLayoutAlertsIndexImport } from './routes/_staff/payroll/_layout/alerts/index'
import { Route as StaffPayrollEngineLayoutPayrollUnitsIndexImport } from './routes/_staff/payroll-engine/_layout/payroll-units/index'
import { Route as StaffPayrollEngineLayoutPayrollStructuresIndexImport } from './routes/_staff/payroll-engine/_layout/payroll-structures/index'
import { Route as StaffPayrollEngineLayoutLogicComponentsIndexImport } from './routes/_staff/payroll-engine/_layout/logic-components/index'
import { Route as StaffPayrollEngineLayoutItemsIndexImport } from './routes/_staff/payroll-engine/_layout/items/index'
import { Route as StaffPayrollCoreLayoutPersonTargetsIndexImport } from './routes/_staff/payroll-core/_layout/person-targets/index'
import { Route as StaffPayrollCoreLayoutOperationPackagesIndexImport } from './routes/_staff/payroll-core/_layout/operation-packages/index'
import { Route as StaffPayrollCoreLayoutDashboardIndexImport } from './routes/_staff/payroll-core/_layout/dashboard/index'
import { Route as StaffPayrollCoreLayoutConfigIndexImport } from './routes/_staff/payroll-core/_layout/config/index'
import { Route as StaffPayrollCoreLayoutArchiveIndexImport } from './routes/_staff/payroll-core/_layout/archive/index'
import { Route as StaffOrganizationPlanCreateIndexImport } from './routes/_staff/organization/plan/create/index'
import { Route as StaffOrganizationPlanIdIndexImport } from './routes/_staff/organization/plan/$id/index'
import { Route as StaffOrganizationListSettingsIndexImport } from './routes/_staff/organization/_list/settings/index'
import { Route as StaffOrganizationListRulePolicyIndexImport } from './routes/_staff/organization/_list/rule-policy/index'
import { Route as StaffOrganizationListHistoryIndexImport } from './routes/_staff/organization/_list/history/index'
import { Route as StaffOrganizationListCostIndexImport } from './routes/_staff/organization/_list/cost/index'
import { Route as StaffOrganizationListChartIndexImport } from './routes/_staff/organization/_list/chart/index'
import { Route as StaffOrganizationListAlertIndexImport } from './routes/_staff/organization/_list/alert/index'
import { Route as StaffOrganizationIdLayoutIndexImport } from './routes/_staff/organization/$id/_layout/index'
import { Route as StaffMarketplaceSalesOrdersOrderIdIndexImport } from './routes/_staff/marketplace/sales-orders/$orderId/index'
import { Route as StaffLicensesAddAllocationTypeIndexImport } from './routes/_staff/licenses/add/$allocationType/index'
import { Route as StaffLicensesListSettingsIndexImport } from './routes/_staff/licenses/_list/settings/index'
import { Route as StaffLicensesListRuleAndPolicyIndexImport } from './routes/_staff/licenses/_list/rule-and-policy/index'
import { Route as StaffLicensesListPeopleIndexImport } from './routes/_staff/licenses/_list/people/index'
import { Route as StaffLicensesListOperationActivityIndexImport } from './routes/_staff/licenses/_list/operation-activity/index'
import { Route as StaffLicensesListInventoryIndexImport } from './routes/_staff/licenses/_list/inventory/index'
import { Route as StaffLicensesListContractAndCostIndexImport } from './routes/_staff/licenses/_list/contract-and-cost/index'
import { Route as StaffLicensesListAlertsIndexImport } from './routes/_staff/licenses/_list/alerts/index'
import { Route as StaffLaborCoreConfigPatternIdIndexImport } from './routes/_staff/labor-core/config/$patternId/index'
import { Route as StaffLaborCorePackagesSettingsIndexImport } from './routes/_staff/labor-core/_packages/settings/index'
import { Route as StaffLaborCorePackagesConfigsIndexImport } from './routes/_staff/labor-core/_packages/configs/index'
import { Route as StaffLaborCorePackagesArchivesIndexImport } from './routes/_staff/labor-core/_packages/archives/index'
import { Route as StaffItOperationCoreSelfReportPatternsPatternIdIndexImport } from './routes/_staff/it-operation-core/self-report-patterns/$patternId/index'
import { Route as StaffItOperationCoreConfigPatternIdIndexImport } from './routes/_staff/it-operation-core/config/$patternId/index'
import { Route as StaffItOperationCoreRootPackagesIndexImport } from './routes/_staff/it-operation-core/_root/packages/index'
import { Route as StaffItOperationCoreRootInHousePackagesIndexImport } from './routes/_staff/it-operation-core/_root/in-house-packages/index'
import { Route as StaffItOperationCoreRootConfigIndexImport } from './routes/_staff/it-operation-core/_root/config/index'
import { Route as StaffItOperationCoreRootArchivesIndexImport } from './routes/_staff/it-operation-core/_root/archives/index'
import { Route as StaffIdsGroupIdAddIndexImport } from './routes/_staff/ids/group-id/add/index'
import { Route as StaffIdsLayoutPeopleIndexImport } from './routes/_staff/ids/_layout/people/index'
import { Route as StaffGaOperationCoreConfigPatternIdIndexImport } from './routes/_staff/ga-operation-core/config/$patternId/index'
import { Route as StaffGaOperationCorePackagesConfigsIndexImport } from './routes/_staff/ga-operation-core/_packages/configs/index'
import { Route as StaffGaOperationCorePackagesArchivesIndexImport } from './routes/_staff/ga-operation-core/_packages/archives/index'
import { Route as StaffFleetsLayoutListIndexImport } from './routes/_staff/fleets/_layout/_list/index'
import { Route as StaffEquipmentLayoutSettingsIndexImport } from './routes/_staff/equipment/_layout/settings/index'
import { Route as StaffEquipmentLayoutItemsIndexImport } from './routes/_staff/equipment/_layout/items/index'
import { Route as StaffEquipmentLayoutAlertsIndexImport } from './routes/_staff/equipment/_layout/alerts/index'
import { Route as StaffDevicesAddCatalogIndexImport } from './routes/_staff/devices/add/catalog/index'
import { Route as StaffDevicesAddDeviceTypeIndexImport } from './routes/_staff/devices/add/$deviceType/index'
import { Route as StaffDevicesListSettingsIndexImport } from './routes/_staff/devices/_list/settings/index'
import { Route as StaffDevicesListPeopleIndexImport } from './routes/_staff/devices/_list/people/index'
import { Route as StaffDevicesListInventoryIndexImport } from './routes/_staff/devices/_list/inventory/index'
import { Route as StaffDevicesListInventoriesIndexImport } from './routes/_staff/devices/_list/inventories/index'
import { Route as StaffDevicesIdLayoutIndexImport } from './routes/_staff/devices/$id/_layout/index'
import { Route as StaffDeviceCatalogAddDeviceTypeIndexImport } from './routes/_staff/device-catalog/add/$deviceType/index'
import { Route as StaffDealAddDirectionIndexImport } from './routes/_staff/deal/add/$direction/index'
import { Route as StaffContractorCoreConfigPatternIdIndexImport } from './routes/_staff/contractor-core/config/$patternId/index'
import { Route as StaffContractorCorePackagesConfigsIndexImport } from './routes/_staff/contractor-core/_packages/configs/index'
import { Route as StaffContractorCorePackagesArchivesIndexImport } from './routes/_staff/contractor-core/_packages/archives/index'
import { Route as StaffContractImportCsvContractTypeIndexImport } from './routes/_staff/contract/import-csv/$contractType/index'
import { Route as StaffContractAddSubscriptionIndexImport } from './routes/_staff/contract/add/subscription/index'
import { Route as StaffCockpitTaskTaskIdIndexImport } from './routes/_staff/cockpit/task/$taskId/index'
import { Route as StaffCockpitApprovalIdIndexImport } from './routes/_staff/cockpit/approval/$id/index'
import { Route as StaffCertificationAddCertificationKindIndexImport } from './routes/_staff/certification/add/$certificationKind/index'
import { Route as StaffCertificationListSettingsIndexImport } from './routes/_staff/certification/_list/settings/index'
import { Route as StaffCertificationListPeopleIndexImport } from './routes/_staff/certification/_list/people/index'
import { Route as StaffBusinessPartnerAddBusinessPartnerTypeIndexImport } from './routes/_staff/business-partner/add/$businessPartnerType/index'
import { Route as StaffBusinessPartnerListTerminatedIndexImport } from './routes/_staff/business-partner/_list/terminated/index'
import { Route as StaffAttendancesLayoutSettingsIndexImport } from './routes/_staff/attendances/_layout/settings/index'
import { Route as StaffAttendancesLayoutRuleAndPolicyIndexImport } from './routes/_staff/attendances/_layout/rule-and-policy/index'
import { Route as StaffAttendancesLayoutOverviewIndexImport } from './routes/_staff/attendances/_layout/overview/index'
import { Route as StaffAttendancesLayoutOperationActivityIndexImport } from './routes/_staff/attendances/_layout/operation-activity/index'
import { Route as StaffAttendancesLayoutEmployeesIndexImport } from './routes/_staff/attendances/_layout/employees/index'
import { Route as StaffAttendancesLayoutClockingRecordsIndexImport } from './routes/_staff/attendances/_layout/clocking-records/index'
import { Route as StaffAttendancesLayoutAlertsIndexImport } from './routes/_staff/attendances/_layout/alerts/index'
import { Route as StaffAttendanceEngineLayoutLogicComponentsIndexImport } from './routes/_staff/attendance-engine/_layout/logic-components/index'
import { Route as StaffAttendanceEngineLayoutItemsIndexImport } from './routes/_staff/attendance-engine/_layout/items/index'
import { Route as StaffAttendanceEngineLayoutAttendanceUnitsIndexImport } from './routes/_staff/attendance-engine/_layout/attendance-units/index'
import { Route as StaffAttendanceEngineLayoutAttendanceStructuresIndexImport } from './routes/_staff/attendance-engine/_layout/attendance-structures/index'
import { Route as StaffAttendanceCoreLayoutOperationPackagesIndexImport } from './routes/_staff/attendance-core/_layout/operation-packages/index'
import { Route as StaffAttendanceCoreLayoutDashboardIndexImport } from './routes/_staff/attendance-core/_layout/dashboard/index'
import { Route as StaffAttendanceCoreLayoutConfigIndexImport } from './routes/_staff/attendance-core/_layout/config/index'
import { Route as StaffAttendanceCoreLayoutArchiveIndexImport } from './routes/_staff/attendance-core/_layout/archive/index'
import { Route as StaffAccessesLayoutSettingsIndexImport } from './routes/_staff/accesses/_layout/settings/index'
import { Route as StaffAccessesLayoutListIndexImport } from './routes/_staff/accesses/_layout/list/index'
import { Route as StaffAccessesLayoutAlertsIndexImport } from './routes/_staff/accesses/_layout/alerts/index'
import { Route as StacktraceValuesIdLayoutIndexImport } from './routes/_stacktrace/values/$id/_layout/index'
import { Route as StacktraceTestSuitesIdLayoutIndexImport } from './routes/_stacktrace/test-suites/$id/_layout/index'
import { Route as StacktraceTestSetsIdLayoutIndexImport } from './routes/_stacktrace/test-sets/$id/_layout/index'
import { Route as StacktraceProductsIdLayoutIndexImport } from './routes/_stacktrace/products/$id/_layout/index'
import { Route as StacktraceProductionProductionIdLayoutIndexImport } from './routes/_stacktrace/production/$productionId/_layout/index'
import { Route as StacktraceProductRoadmapRoadmapIdLayoutIndexImport } from './routes/_stacktrace/product-roadmap/$roadmapId/_layout/index'
import { Route as StacktraceIssuesLayoutOverviewIndexImport } from './routes/_stacktrace/issues/_layout/overview/index'
import { Route as StacktraceIssuesIdLayoutIndexImport } from './routes/_stacktrace/issues/$id/_layout/index'
import { Route as StacktraceDevelopmentTicketsTicketIdLayoutIndexImport } from './routes/_stacktrace/development-tickets/$ticketId/_layout/index'
import { Route as IndividualIndividualTaskIdIndexImport } from './routes/_individual/individual/task/$id/index'
import { Route as IndividualIndividualPortalRequestsIndexImport } from './routes/_individual/individual/portal/requests/index'
import { Route as IndividualIndividualPortalLookupIndexImport } from './routes/_individual/individual/portal/lookup/index'
import { Route as IndividualIndividualPortalApprovalsIndexImport } from './routes/_individual/individual/portal/approvals/index'
import { Route as IndividualIndividualOperationPackageIdIndexImport } from './routes/_individual/individual/operation-package/$id/index'
import { Route as IndividualIndividualTasksRequestTasksIndexImport } from './routes/_individual/individual/_tasks/request-tasks/index'
import { Route as IndividualIndividualTasksOperationTasksIndexImport } from './routes/_individual/individual/_tasks/operation-tasks/index'
import { Route as IndividualIndividualTasksApprovalTasksIndexImport } from './routes/_individual/individual/_tasks/approval-tasks/index'
import { Route as StaffStorageFilesFoldersIdIdImport } from './routes/_staff/storage-files/folders/$id/_$id'
import { Route as StaffStorageFilesFilesIdIdImport } from './routes/_staff/storage-files/files/$id/_$id'
import { Route as StaffStarlinksLayoutPlaceholdersOperationActivityImport } from './routes/_staff/starlinks/_layout/_placeholders/operation-activity'
import { Route as StaffStarlinksLayoutPlaceholdersMarketplaceImport } from './routes/_staff/starlinks/_layout/_placeholders/marketplace'
import { Route as StaffStarlinksLayoutPlaceholdersBillingAndCostImport } from './routes/_staff/starlinks/_layout/_placeholders/billing-and-cost'
import { Route as StaffSoftwareLayoutContractAndCostContractAndCostImport } from './routes/_staff/software/_layout/contract-and-cost/_contract-and-cost'
import { Route as StaffSoftwareLayoutAlertsAlertsImport } from './routes/_staff/software/_layout/alerts/_alerts'
import { Route as StaffSoftwareIdIdProfilesImport } from './routes/_staff/software/$id/_$id/profiles'
import { Route as StaffSoftwareIdIdGroupsImport } from './routes/_staff/software/$id/_$id/groups'
import { Route as StaffSettingsPersonsListAccountImport } from './routes/_staff/settings/persons/_list/_account'
import { Route as StaffProfileDeviceIdSplatImport } from './routes/_staff/profile/device/$id/$'
import { Route as StaffPlacesLayoutPlaceholdersStoreImport } from './routes/_staff/places/_layout/_placeholders/store'
import { Route as StaffPlacesLayoutPlaceholdersRuleAndPolicyImport } from './routes/_staff/places/_layout/_placeholders/rule-and-policy'
import { Route as StaffPlacesLayoutPlaceholdersPeopleImport } from './routes/_staff/places/_layout/_placeholders/people'
import { Route as StaffPlacesLayoutPlaceholdersOperationActivityImport } from './routes/_staff/places/_layout/_placeholders/operation-activity'
import { Route as StaffPlacesLayoutPlaceholdersContractAndCostImport } from './routes/_staff/places/_layout/_placeholders/contract-and-cost'
import { Route as StaffPlacesLayoutPlaceholdersAlertsImport } from './routes/_staff/places/_layout/_placeholders/alerts'
import { Route as StaffPersonAlumniIdProfileImport } from './routes/_staff/person/alumni/$id/_profile'
import { Route as StaffPersonAddWorkerTypeCompletedImport } from './routes/_staff/person/add/$workerType/completed'
import { Route as StaffPersonAddPersonCertificationCertificationKindCompletedImport } from './routes/_staff/person/add-person-certification/$certificationKind/completed'
import { Route as StaffPayrollLayoutContractAndCostContractAndCostImport } from './routes/_staff/payroll/_layout/contract-and-cost/_contract-and-cost'
import { Route as StaffNetworksLayoutPlaceholdersSettingsImport } from './routes/_staff/networks/_layout/_placeholders/settings'
import { Route as StaffNetworksLayoutPlaceholdersRuleAndPolicyImport } from './routes/_staff/networks/_layout/_placeholders/rule-and-policy'
import { Route as StaffNetworksLayoutPlaceholdersOverviewImport } from './routes/_staff/networks/_layout/_placeholders/overview'
import { Route as StaffNetworksLayoutPlaceholdersOperationActivityImport } from './routes/_staff/networks/_layout/_placeholders/operation-activity'
import { Route as StaffNetworksLayoutPlaceholdersContractAndCostImport } from './routes/_staff/networks/_layout/_placeholders/contract-and-cost'
import { Route as StaffNetworksLayoutPlaceholdersAlertsImport } from './routes/_staff/networks/_layout/_placeholders/alerts'
import { Route as StaffMarketplaceSentOrdersOrderIdLayoutImport } from './routes/_staff/marketplace/sent-orders/$orderId/_layout'
import { Route as StaffLicensesAddAllocationTypeCompletedImport } from './routes/_staff/licenses/add/$allocationType/completed'
import { Route as StaffLaborCoreSettingsProfileProfileIdImport } from './routes/_staff/labor-core/settings/profile.$profileId'
import { Route as StaffItOperationCoreRootPackagesPackageIdImport } from './routes/_staff/it-operation-core/_root/packages/$packageId'
import { Route as StaffItOperationCoreRootInHousePackagesPackageIdImport } from './routes/_staff/it-operation-core/_root/in-house-packages/$packageId'
import { Route as StaffIdsGroupIdIdIdImport } from './routes/_staff/ids/group-id/$id/_$id'
import { Route as StaffIdsLayoutPlaceholdersSettingsImport } from './routes/_staff/ids/_layout/_placeholders/settings'
import { Route as StaffIdsLayoutPlaceholdersRuleAndPolicyImport } from './routes/_staff/ids/_layout/_placeholders/rule-and-policy'
import { Route as StaffIdsLayoutPlaceholdersOverviewImport } from './routes/_staff/ids/_layout/_placeholders/overview'
import { Route as StaffIdsLayoutPlaceholdersOperationActivityImport } from './routes/_staff/ids/_layout/_placeholders/operation-activity'
import { Route as StaffIdsLayoutPlaceholdersGroupIdImport } from './routes/_staff/ids/_layout/_placeholders/group-id'
import { Route as StaffIdsLayoutPlaceholdersAlertsImport } from './routes/_staff/ids/_layout/_placeholders/alerts'
import { Route as StaffEquipmentItemsIdDetailImport } from './routes/_staff/equipment/items/$id/_detail'
import { Route as StaffEquipmentLayoutPlaceholdersSettingsImport } from './routes/_staff/equipment/_layout/_placeholders/settings'
import { Route as StaffEquipmentLayoutPlaceholdersRuleAndPolicyImport } from './routes/_staff/equipment/_layout/_placeholders/rule-and-policy'
import { Route as StaffEquipmentLayoutPlaceholdersOverviewImport } from './routes/_staff/equipment/_layout/_placeholders/overview'
import { Route as StaffDevicesAddDeviceTypeCompletedImport } from './routes/_staff/devices/add/$deviceType/completed'
import { Route as StaffDevicesListContractAndCostContractAndCostImport } from './routes/_staff/devices/_list/contract-and-cost/_contract-and-cost'
import { Route as StaffDeviceCatalogDraftIdLayoutImport } from './routes/_staff/device-catalog/draft/$id/_layout'
import { Route as StaffDeviceCatalogAddDeviceTypeCompletedImport } from './routes/_staff/device-catalog/add/$deviceType/completed'
import { Route as StaffDeviceCatalogActiveIdLayoutImport } from './routes/_staff/device-catalog/active/$id/_layout'
import { Route as StaffDealAddDirectionCompletedImport } from './routes/_staff/deal/add/$direction/completed'
import { Route as StaffContractAddSubscriptionCompletedImport } from './routes/_staff/contract/add/subscription/completed'
import { Route as StaffCertificationSpecialtyCertificationIdLayoutImport } from './routes/_staff/certification/specialty-certification/$id/_layout'
import { Route as StaffCertificationHandlingCertificationIdLayoutImport } from './routes/_staff/certification/handling-certification/$id/_layout'
import { Route as StaffCertificationAddCertificationKindCompletedImport } from './routes/_staff/certification/add/$certificationKind/completed'
import { Route as StaffBusinessPartnerAddBusinessPartnerTypeCompletedImport } from './routes/_staff/business-partner/add/$businessPartnerType/completed'
import { Route as StaffAppIntegrationsIdIdSplatImport } from './routes/_staff/app-integrations/$id/_$id/$'
import { Route as StaffAccessesLayoutPlaceholdersSoftwareImport } from './routes/_staff/accesses/_layout/_placeholders/software'
import { Route as StaffAccessesLayoutPlaceholdersOverviewImport } from './routes/_staff/accesses/_layout/_placeholders/overview'
import { Route as StaffAccessesLayoutPlaceholdersContractAndCostImport } from './routes/_staff/accesses/_layout/_placeholders/contract-and-cost'
import { Route as IndividualIndividualTaskIdApprovalDialogImport } from './routes/_individual/individual/task/$id/approval-dialog'
import { Route as IndividualIndividualProfileMyProfileLayoutImport } from './routes/_individual/individual/_profile/my-profile/_layout'
import { Route as StaffSupplierListPlaceholdersRuleAndPolicyRouteImport } from './routes/_staff/supplier/_list/_placeholders/rule-and-policy/route'
import { Route as StaffSupplierListPlaceholdersOverviewRouteImport } from './routes/_staff/supplier/_list/_placeholders/overview/route'
import { Route as StaffSupplierListPlaceholdersOperationActivityRouteImport } from './routes/_staff/supplier/_list/_placeholders/operation-activity/route'
import { Route as StaffSupplierListPlaceholdersContractAndCostRouteImport } from './routes/_staff/supplier/_list/_placeholders/contract-and-cost/route'
import { Route as StaffSupplierListPlaceholdersAlertsRouteImport } from './routes/_staff/supplier/_list/_placeholders/alerts/route'
import { Route as StaffSupplierSupplierIdLayoutSettingsRouteImport } from './routes/_staff/supplier/$supplierId/_layout/settings/route'
import { Route as StaffSupplierSupplierIdLayoutRulesAndPolicyRouteImport } from './routes/_staff/supplier/$supplierId/_layout/rules-and-policy/route'
import { Route as StaffSupplierSupplierIdLayoutFilesRouteImport } from './routes/_staff/supplier/$supplierId/_layout/files/route'
import { Route as StaffSoftwareLayoutMarketplaceIdRouteImport } from './routes/_staff/software/_layout/marketplace/$id/route'
import { Route as StaffPayrollLayoutPaySlipsEmployeeIdRouteImport } from './routes/_staff/payroll/_layout/pay-slips/$employeeId/route'
import { Route as StaffDealDealIdLayoutStructureRouteImport } from './routes/_staff/deal/$dealId/_layout/structure/route'
import { Route as StaffDealDealIdLayoutFlowRouteImport } from './routes/_staff/deal/$dealId/_layout/flow/route'
import { Route as StaffContractListPlaceholdersPeopleRouteImport } from './routes/_staff/contract/_list/_placeholders/people/route'
import { Route as StaffContractListPlaceholdersOverviewRouteImport } from './routes/_staff/contract/_list/_placeholders/overview/route'
import { Route as StaffContractListPlaceholdersOperationActivityRouteImport } from './routes/_staff/contract/_list/_placeholders/operation-activity/route'
import { Route as StaffContractListPlaceholdersContractAndCostRouteImport } from './routes/_staff/contract/_list/_placeholders/contract-and-cost/route'
import { Route as StaffContractListPlaceholdersAlertsRouteImport } from './routes/_staff/contract/_list/_placeholders/alerts/route'
import { Route as StaffCertificationListPlaceholdersRuleAndPolicyRouteImport } from './routes/_staff/certification/_list/_placeholders/rule-and-policy/route'
import { Route as StaffCertificationListPlaceholdersOverviewRouteImport } from './routes/_staff/certification/_list/_placeholders/overview/route'
import { Route as StaffCertificationListPlaceholdersOperationActivityRouteImport } from './routes/_staff/certification/_list/_placeholders/operation-activity/route'
import { Route as StaffCertificationListPlaceholdersAlertsRouteImport } from './routes/_staff/certification/_list/_placeholders/alerts/route'
import { Route as StaffBusinessPartnerListPlaceholdersSettingsRouteImport } from './routes/_staff/business-partner/_list/_placeholders/settings/route'
import { Route as StaffBusinessPartnerListPlaceholdersRuleAndPolicyRouteImport } from './routes/_staff/business-partner/_list/_placeholders/rule-and-policy/route'
import { Route as StaffBusinessPartnerListPlaceholdersOperationActivityRouteImport } from './routes/_staff/business-partner/_list/_placeholders/operation-activity/route'
import { Route as StaffBusinessPartnerListPlaceholdersContractAndCostRouteImport } from './routes/_staff/business-partner/_list/_placeholders/contract-and-cost/route'
import { Route as StaffBusinessPartnerListPlaceholdersAlertsRouteImport } from './routes/_staff/business-partner/_list/_placeholders/alerts/route'
import { Route as StaffAttendancesLayoutClockingRecordsEmployeeIdRouteImport } from './routes/_staff/attendances/_layout/clocking-records/$employeeId/route'
import { Route as IndividualIndividualPortalLookupPaySlipRouteImport } from './routes/_individual/individual/portal/lookup/pay-slip/route'
import { Route as IndividualIndividualPortalLookupClockingRecordRouteImport } from './routes/_individual/individual/portal/lookup/clocking-record/route'
import { Route as StaffPersonIdProfileIndexRouteImport } from './routes/_staff/person/$id/_profile/index/route'
import { Route as StaffUsersUserIdLayoutSessionsIndexImport } from './routes/_staff/users/$userId/_layout/sessions/index'
import { Route as StaffUsersUserIdLayoutIdentityIndexImport } from './routes/_staff/users/$userId/_layout/_identity/index'
import { Route as StaffTimeAndAttendanceLayoutAttendanceLinksPlaceIdIndexImport } from './routes/_staff/time-and-attendance/_layout/attendance-links/$placeId/index'
import { Route as StaffTimeAndAttendanceLayoutListSummaryIndexImport } from './routes/_staff/time-and-attendance/_layout/_list/summary/index'
import { Route as StaffSupplierListSettingsSupplierSubcategoriesIndexImport } from './routes/_staff/supplier/_list/settings/supplier-subcategories/index'
import { Route as StaffSupplierListSettingsSupplierCategoriesIndexImport } from './routes/_staff/supplier/_list/settings/supplier-categories/index'
import { Route as StaffSupplierListSettingsProcurementCategoriesIndexImport } from './routes/_staff/supplier/_list/settings/procurement-categories/index'
import { Route as StaffSupplierSupplierIdLayoutIndexIndexImport } from './routes/_staff/supplier/$supplierId/_layout/_index/index'
import { Route as StaffSoftwareCustomSaasAddCustomSaasTypeIndexImport } from './routes/_staff/software/custom-saas/add/$customSaasType/index'
import { Route as StaffSoftwareLayoutLibrarySearchIndexImport } from './routes/_staff/software/_layout/library/search/index'
import { Route as StaffSoftwareLayoutContractAndCostContractAndCostIndexImport } from './routes/_staff/software/_layout/contract-and-cost/_contract-and-cost/index'
import { Route as StaffSoftwareLayoutAlertsAlertsIndexImport } from './routes/_staff/software/_layout/alerts/_alerts/index'
import { Route as StaffSoftwareIdIdSettingsIndexImport } from './routes/_staff/software/$id/_$id/settings/index'
import { Route as StaffSoftwareIdIdRuleAndPolicyIndexImport } from './routes/_staff/software/$id/_$id/rule-and-policy/index'
import { Route as StaffSoftwareIdIdDetailIndexImport } from './routes/_staff/software/$id/_$id/detail/index'
import { Route as StaffSoftwareIdIdArchitectureIndexImport } from './routes/_staff/software/$id/_$id/architecture/index'
import { Route as StaffSoftwareIdIdAlertsIndexImport } from './routes/_staff/software/$id/_$id/alerts/index'
import { Route as StaffSoftwareIdIdActivityMonitoringIndexImport } from './routes/_staff/software/$id/_$id/activity-monitoring/index'
import { Route as StaffSoftwareIdIdAccountsIndexImport } from './routes/_staff/software/$id/_$id/accounts/index'
import { Route as StaffSettingsPersonsListSettingsIndexImport } from './routes/_staff/settings/persons/_list/settings/index'
import { Route as StaffSettingsPermissionAndRolesListRolesIndexImport } from './routes/_staff/settings/permission-and-roles/_list/roles/index'
import { Route as StaffSettingsPermissionAndRolesListProductPermissionsIndexImport } from './routes/_staff/settings/permission-and-roles/_list/product-permissions/index'
import { Route as StaffSettingsPermissionAndRolesListPeopleGroupsIndexImport } from './routes/_staff/settings/permission-and-roles/_list/people-groups/index'
import { Route as StaffSettingsPermissionAndRolesListCategoryPermissionsIndexImport } from './routes/_staff/settings/permission-and-roles/_list/category-permissions/index'
import { Route as StaffSettingsContractingCorporationProfileLayoutShareholdersIndexImport } from './routes/_staff/settings/contracting-corporation-profile/_layout/shareholders/index'
import { Route as StaffSettingsContractingCorporationProfileLayoutRegistrationIndexImport } from './routes/_staff/settings/contracting-corporation-profile/_layout/registration/index'
import { Route as StaffSettingsContractingCorporationProfileLayoutHistoryIndexImport } from './routes/_staff/settings/contracting-corporation-profile/_layout/history/index'
import { Route as StaffSettingsContractingCorporationProfileLayoutGroupCompaniesIndexImport } from './routes/_staff/settings/contracting-corporation-profile/_layout/group-companies/index'
import { Route as StaffSettingsContractingCorporationProfileLayoutCorporateOverviewIndexImport } from './routes/_staff/settings/contracting-corporation-profile/_layout/corporate-overview/index'
import { Route as StaffSettingsContractingCorporationProfileLayoutContactPointsIndexImport } from './routes/_staff/settings/contracting-corporation-profile/_layout/contact-points/index'
import { Route as StaffSettingsContractingCorporationProfileLayoutBoardMemberIndexImport } from './routes/_staff/settings/contracting-corporation-profile/_layout/board-member/index'
import { Route as StaffPlacesLayoutSettingsPlaceSubCodesIndexImport } from './routes/_staff/places/_layout/settings/place-sub-codes/index'
import { Route as StaffPlacesIdLayoutLaborCoreIndexImport } from './routes/_staff/places/$id/_layout/labor-core/index'
import { Route as StaffPlacesIdLayoutAdministratorsIndexImport } from './routes/_staff/places/$id/_layout/administrators/index'
import { Route as StaffPersonExternalHrSaasAppIntegrationIdPreviewIndexImport } from './routes/_staff/person/external-hr-saas/$appIntegrationId/preview/index'
import { Route as StaffPersonIdProfilePublicIdIndexImport } from './routes/_staff/person/$id/_profile/public-id/index'
import { Route as StaffPersonIdProfilePersonalInformationIndexImport } from './routes/_staff/person/$id/_profile/personal-information/index'
import { Route as StaffPersonIdProfileOperationActivityIndexImport } from './routes/_staff/person/$id/_profile/operation-activity/index'
import { Route as StaffPersonIdProfileHistoryIndexImport } from './routes/_staff/person/$id/_profile/history/index'
import { Route as StaffPersonIdProfileEquipmentIndexImport } from './routes/_staff/person/$id/_profile/equipment/index'
import { Route as StaffPersonIdProfileEmployeeInformationIndexImport } from './routes/_staff/person/$id/_profile/employee-information/index'
import { Route as StaffPersonIdProfileEducationAndQualificationIndexImport } from './routes/_staff/person/$id/_profile/education-and-qualification/index'
import { Route as StaffPersonIdProfileDevicesIndexImport } from './routes/_staff/person/$id/_profile/devices/index'
import { Route as StaffPersonIdProfileContractorInformationIndexImport } from './routes/_staff/person/$id/_profile/contractor-information/index'
import { Route as StaffPersonIdProfileAppsIndexImport } from './routes/_staff/person/$id/_profile/apps/index'
import { Route as StaffPeopleListSettingsWorkModeIndexImport } from './routes/_staff/people/_list/settings/work-mode/index'
import { Route as StaffPeopleListSettingsRetirementReasonsIndexImport } from './routes/_staff/people/_list/settings/retirement-reasons/index'
import { Route as StaffPeopleListSettingsPositionsIndexImport } from './routes/_staff/people/_list/settings/positions/index'
import { Route as StaffPeopleListSettingsPlaceSocialInsurancesIndexImport } from './routes/_staff/people/_list/settings/place-social-insurances/index'
import { Route as StaffPeopleListSettingsJobTypesIndexImport } from './routes/_staff/people/_list/settings/job-types/index'
import { Route as StaffPeopleListSettingsJobTitlesIndexImport } from './routes/_staff/people/_list/settings/job-titles/index'
import { Route as StaffPeopleListSettingsJobLevelsIndexImport } from './routes/_staff/people/_list/settings/job-levels/index'
import { Route as StaffPeopleListSettingsJobGradesIndexImport } from './routes/_staff/people/_list/settings/job-grades/index'
import { Route as StaffPeopleListSettingsJobFunctionsIndexImport } from './routes/_staff/people/_list/settings/job-functions/index'
import { Route as StaffPeopleListSettingsJobCompetenciesIndexImport } from './routes/_staff/people/_list/settings/job-competencies/index'
import { Route as StaffPeopleListSettingsHealthInsuranceAssociationsIndexImport } from './routes/_staff/people/_list/settings/health-insurance-associations/index'
import { Route as StaffPeopleListSettingsGradesIndexImport } from './routes/_staff/people/_list/settings/grades/index'
import { Route as StaffPeopleListSettingsEmploymentTypesIndexImport } from './routes/_staff/people/_list/settings/employment-types/index'
import { Route as StaffPeopleListSettingsEmployeeSubIdNamesIndexImport } from './routes/_staff/people/_list/settings/employee-sub-id-names/index'
import { Route as StaffPeopleListSettingsContractorTypesIndexImport } from './routes/_staff/people/_list/settings/contractor-types/index'
import { Route as StaffPeopleListSettingsContractEndReasonsIndexImport } from './routes/_staff/people/_list/settings/contract-end-reasons/index'
import { Route as StaffPeopleListSettingsCollaboratorTypesIndexImport } from './routes/_staff/people/_list/settings/collaborator-types/index'
import { Route as StaffPeopleListSettingsBoardMemberTypesIndexImport } from './routes/_staff/people/_list/settings/board-member-types/index'
import { Route as StaffPayrollLayoutContractAndCostContractAndCostIndexImport } from './routes/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/index'
import { Route as StaffPayrollEngineLayoutPayrollUnitsUnitIdIndexImport } from './routes/_staff/payroll-engine/_layout/payroll-units/$unitId/index'
import { Route as StaffPayrollEngineLayoutLogicComponentsComponentIdIndexImport } from './routes/_staff/payroll-engine/_layout/logic-components/$componentId/index'
import { Route as StaffPayrollEngineLayoutItemsComponentIdIndexImport } from './routes/_staff/payroll-engine/_layout/items/$componentId/index'
import { Route as StaffOrganizationPlanIdTransfersIndexImport } from './routes/_staff/organization/plan/$id/transfers/index'
import { Route as StaffOrganizationPlanIdAddIndexImport } from './routes/_staff/organization/plan/$id/add/index'
import { Route as StaffOrganizationIdLayoutHistoryIndexImport } from './routes/_staff/organization/$id/_layout/history/index'
import { Route as StaffMarketplaceSentOrdersOrderIdLayoutIndexImport } from './routes/_staff/marketplace/sent-orders/$orderId/_layout/index'
import { Route as StaffMarketplaceStoreStoreStarlinksIndexImport } from './routes/_staff/marketplace/_store/store/starlinks/index'
import { Route as StaffMarketplaceStoreStoreSentOrdersIndexImport } from './routes/_staff/marketplace/_store/store/sent-orders/index'
import { Route as StaffMarketplaceStoreStoreSalesOrdersIndexImport } from './routes/_staff/marketplace/_store/store/sales-orders/index'
import { Route as StaffMarketplaceStoreStoreLicensesIndexImport } from './routes/_staff/marketplace/_store/store/licenses/index'
import { Route as StaffMarketplaceStoreStoreDevicesIndexImport } from './routes/_staff/marketplace/_store/store/devices/index'
import { Route as StaffLicensesIdProfileServicePlansIndexImport } from './routes/_staff/licenses/$id/_profile/service-plans/index'
import { Route as StaffLicensesIdProfileRuleAndPolicyIndexImport } from './routes/_staff/licenses/$id/_profile/rule-and-policy/index'
import { Route as StaffLicensesIdProfilePeopleIndexImport } from './routes/_staff/licenses/$id/_profile/people/index'
import { Route as StaffLicensesIdProfileAssignmentsIndexImport } from './routes/_staff/licenses/$id/_profile/assignments/index'
import { Route as StaffItOperationCoreDetailOperationInstancesInstanceIdIndexImport } from './routes/_staff/it-operation-core/_detail/operation-instances/$instanceId/index'
import { Route as StaffIdsGroupIdAddFromScratchIndexImport } from './routes/_staff/ids/group-id/add/from-scratch/index'
import { Route as StaffIdsGroupIdIdIdIndexImport } from './routes/_staff/ids/group-id/$id/_$id/index'
import { Route as StaffEquipmentItemsIdDetailIndexImport } from './routes/_staff/equipment/items/$id/_detail/index'
import { Route as StaffEquipmentLayoutSettingsEquipmentTypesIndexImport } from './routes/_staff/equipment/_layout/settings/equipment-types/index'
import { Route as StaffEquipmentLayoutSettingsEquipmentItemsIndexImport } from './routes/_staff/equipment/_layout/settings/equipment-items/index'
import { Route as StaffDevicesExternalItSaasAppIntegrationIdPreviewIndexImport } from './routes/_staff/devices/external-it-saas/$appIntegrationId/preview/index'
import { Route as StaffDevicesAddCatalogDeviceTypeIndexImport } from './routes/_staff/devices/add/catalog/$deviceType/index'
import { Route as StaffDevicesListSettingsCatalogIndexImport } from './routes/_staff/devices/_list/settings/catalog/index'
import { Route as StaffDevicesListContractAndCostContractAndCostIndexImport } from './routes/_staff/devices/_list/contract-and-cost/_contract-and-cost/index'
import { Route as StaffDevicesIdLayoutStatusIndexImport } from './routes/_staff/devices/$id/_layout/status/index'
import { Route as StaffDevicesIdLayoutProfileIndexImport } from './routes/_staff/devices/$id/_layout/profile/index'
import { Route as StaffDevicesIdLayoutMdmIndexImport } from './routes/_staff/devices/$id/_layout/mdm/index'
import { Route as StaffDevicesIdLayoutLifecycleIndexImport } from './routes/_staff/devices/$id/_layout/lifecycle/index'
import { Route as StaffDevicesIdLayoutHistoryIndexImport } from './routes/_staff/devices/$id/_layout/history/index'
import { Route as StaffDevicesIdLayoutFilesIndexImport } from './routes/_staff/devices/$id/_layout/files/index'
import { Route as StaffDevicesIdLayoutControlIndexImport } from './routes/_staff/devices/$id/_layout/control/index'
import { Route as StaffDealDealIdLayoutIndexIndexImport } from './routes/_staff/deal/$dealId/_layout/_index/index'
import { Route as StaffCertificationListSettingsSpecialtyCategoryIndexImport } from './routes/_staff/certification/_list/settings/specialty-category/index'
import { Route as StaffCertificationListSettingsSpecialtyCategoryLevelIndexImport } from './routes/_staff/certification/_list/settings/specialty-category-level/index'
import { Route as StaffCertificationListSettingsIssuingOrganizationIndexImport } from './routes/_staff/certification/_list/settings/issuing-organization/index'
import { Route as StaffCertificationIdLayoutSpecialtyCertificationsIndexImport } from './routes/_staff/certification/$id/_layout/specialty-certifications/index'
import { Route as StaffCertificationIdLayoutHandlingCertificationsIndexImport } from './routes/_staff/certification/$id/_layout/handling-certifications/index'
import { Route as StaffCertificationIdLayoutCertificationHoldersIndexImport } from './routes/_staff/certification/$id/_layout/certification-holders/index'
import { Route as StaffCertificationIdLayoutIndexIndexImport } from './routes/_staff/certification/$id/_layout/_index/index'
import { Route as StaffBusinessPartnerIdLayoutAddressAndContactIndexImport } from './routes/_staff/business-partner/$id/_layout/address-and-contact/index'
import { Route as StaffBusinessPartnerIdLayoutIndexIndexImport } from './routes/_staff/business-partner/$id/_layout/_index/index'
import { Route as StaffAttendanceEngineLayoutLogicComponentsComponentIdIndexImport } from './routes/_staff/attendance-engine/_layout/logic-components/$componentId/index'
import { Route as StaffAttendanceEngineLayoutItemsComponentIdIndexImport } from './routes/_staff/attendance-engine/_layout/items/$componentId/index'
import { Route as StaffAttendanceEngineLayoutAttendanceUnitsUnitIdIndexImport } from './routes/_staff/attendance-engine/_layout/attendance-units/$unitId/index'
import { Route as StaffAccessesLayoutListTraceableAppIdIndexImport } from './routes/_staff/accesses/_layout/list/$traceableAppId/index'
import { Route as StacktraceValuesIdLayoutProductScopeIndexImport } from './routes/_stacktrace/values/$id/_layout/product-scope/index'
import { Route as StacktraceValuesIdLayoutHistoryIndexImport } from './routes/_stacktrace/values/$id/_layout/history/index'
import { Route as StacktraceTestSuitesIdLayoutTestSetIndexImport } from './routes/_stacktrace/test-suites/$id/_layout/test-set/index'
import { Route as StacktraceTestSuitesIdLayoutTargetFunctionsIndexImport } from './routes/_stacktrace/test-suites/$id/_layout/target-functions/index'
import { Route as StacktraceTestSuitesIdLayoutOverviewIndexImport } from './routes/_stacktrace/test-suites/$id/_layout/overview/index'
import { Route as StacktraceTestSuitesIdLayoutIssuesIndexImport } from './routes/_stacktrace/test-suites/$id/_layout/issues/index'
import { Route as StacktraceTestSuitesIdLayoutDocumentIndexImport } from './routes/_stacktrace/test-suites/$id/_layout/document/index'
import { Route as StacktraceTestSetsIdLayoutTargetFunctionsIndexImport } from './routes/_stacktrace/test-sets/$id/_layout/target-functions/index'
import { Route as StacktraceTestSetsIdLayoutConditionsIndexImport } from './routes/_stacktrace/test-sets/$id/_layout/conditions/index'
import { Route as StacktraceProductsIdLayoutProductScopeIndexImport } from './routes/_stacktrace/products/$id/_layout/product-scope/index'
import { Route as StacktraceProductionProductionIdLayoutValueIndexImport } from './routes/_stacktrace/production/$productionId/_layout/value/index'
import { Route as StacktraceProductionProductionIdLayoutQualityScopeIndexImport } from './routes/_stacktrace/production/$productionId/_layout/quality-scope/index'
import { Route as StacktraceProductionProductionIdLayoutProductScopeIndexImport } from './routes/_stacktrace/production/$productionId/_layout/product-scope/index'
import { Route as StacktraceProductionProductionIdLayoutIssueScopeIndexImport } from './routes/_stacktrace/production/$productionId/_layout/issue-scope/index'
import { Route as StacktraceProductionProductionIdLayoutDevScopeIndexImport } from './routes/_stacktrace/production/$productionId/_layout/dev-scope/index'
import { Route as StacktraceProductRoadmapRoadmapIdLayoutHistoryIndexImport } from './routes/_stacktrace/product-roadmap/$roadmapId/_layout/history/index'
import { Route as StacktraceProductRoadmapRoadmapIdLayoutDetailIndexImport } from './routes/_stacktrace/product-roadmap/$roadmapId/_layout/detail/index'
import { Route as StacktraceIssuesIdLayoutHistoryIndexImport } from './routes/_stacktrace/issues/$id/_layout/history/index'
import { Route as StacktraceDevelopmentTicketsTicketIdLayoutHistoryIndexImport } from './routes/_stacktrace/development-tickets/$ticketId/_layout/history/index'
import { Route as IndividualIndividualTaskIdApprovalIndexImport } from './routes/_individual/individual/task/$id/approval/index'
import { Route as StaffSoftwareIdIdContractAndCostContractAndCostImport } from './routes/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost'
import { Route as StaffSettingsDataConnectorOutboundDataPipelineListImport } from './routes/_staff/settings/data-connector/outbound/data-pipeline/_list'
import { Route as StaffSettingsDataConnectorInboundDataPipelineListImport } from './routes/_staff/settings/data-connector/inbound/data-pipeline/_list'
import { Route as StaffSettingsDataConnectorInboundAggregateDataPipelineListImport } from './routes/_staff/settings/data-connector/inbound/aggregate-data-pipeline/_list'
import { Route as StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutImport } from './routes/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout'
import { Route as StaffMarketplaceSentOrdersOrderIdLayoutActivitiesImport } from './routes/_staff/marketplace/sent-orders/$orderId/_layout/activities'
import { Route as StaffLicensesIdServicePlansLicenseServiceIdDetailImport } from './routes/_staff/licenses/$id/service-plans/$licenseServiceId/_detail'
import { Route as StaffItOperationCoreRootInHousePackagesPackageIdStartTargetsImport } from './routes/_staff/it-operation-core/_root/in-house-packages/$packageId/start-targets'
import { Route as StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutImport } from './routes/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout'
import { Route as StaffIdsGroupIdAddFromScratchCompletedImport } from './routes/_staff/ids/group-id/add/from-scratch/completed'
import { Route as StaffDevicesAddCatalogDeviceTypeCompletedImport } from './routes/_staff/devices/add/catalog/$deviceType/completed'
import { Route as StaffBusinessPartnerIdLayoutBpRoleInfoLayoutImport } from './routes/_staff/business-partner/$id/_layout/bp-role-info/_layout'
import { Route as StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutImport } from './routes/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout'
import { Route as StacktraceTestSuitesIdLayoutTestReviewLayoutImport } from './routes/_stacktrace/test-suites/$id/_layout/test-review/_layout'
import { Route as StacktraceTestSuitesIdLayoutTestPlanLayoutImport } from './routes/_stacktrace/test-suites/$id/_layout/test-plan/_layout'
import { Route as StacktraceProductsIdScopeNodeIdLayoutImport } from './routes/_stacktrace/products/$id/scope/$nodeId/_layout'
import { Route as StaffContractIdLayoutPlaceholdersRuleAndPolicyRouteImport } from './routes/_staff/contract/$id/_layout/_placeholders/rule-and-policy/route'
import { Route as StaffContractIdLayoutPlaceholdersRiskProvisionsRouteImport } from './routes/_staff/contract/$id/_layout/_placeholders/risk-provisions/route'
import { Route as StaffContractIdLayoutPlaceholdersOperationActivityRouteImport } from './routes/_staff/contract/$id/_layout/_placeholders/operation-activity/route'
import { Route as StaffContractIdLayoutPlaceholdersHistoryRouteImport } from './routes/_staff/contract/$id/_layout/_placeholders/history/route'
import { Route as StaffContractIdLayoutPlaceholdersApprovalInfoRouteImport } from './routes/_staff/contract/$id/_layout/_placeholders/approval-info/route'
import { Route as StaffPersonAlumniIdProfileIndexRouteImport } from './routes/_staff/person/alumni/$id/_profile/index/route'
import { Route as IndividualIndividualProfileMyProfileLayoutIndexRouteImport } from './routes/_individual/individual/_profile/my-profile/_layout/index/route'
import { Route as StaffTimeAndAttendanceLayoutListSummaryMonthlyPlaceIndexImport } from './routes/_staff/time-and-attendance/_layout/_list/summary/monthly-place/index'
import { Route as StaffTimeAndAttendanceLayoutListSummaryMonthlyPersonIndexImport } from './routes/_staff/time-and-attendance/_layout/_list/summary/monthly-person/index'
import { Route as StaffTimeAndAttendanceLayoutListSummaryDailyPlaceIndexImport } from './routes/_staff/time-and-attendance/_layout/_list/summary/daily-place/index'
import { Route as StaffStorageFilesFoldersIdIdUsersIndexImport } from './routes/_staff/storage-files/folders/$id/_$id/users/index'
import { Route as StaffStorageFilesFoldersIdIdFilesIndexImport } from './routes/_staff/storage-files/folders/$id/_$id/files/index'
import { Route as StaffSoftwareLayoutLibraryDetailSoftwareLibraryIdIndexImport } from './routes/_staff/software/_layout/library/detail/$softwareLibraryId/index'
import { Route as StaffSoftwareLayoutLibraryCategoryCategoryIndexImport } from './routes/_staff/software/_layout/library/category/$category/index'
import { Route as StaffSoftwareLayoutContractAndCostContractAndCostPaymentIndexImport } from './routes/_staff/software/_layout/contract-and-cost/_contract-and-cost/payment/index'
import { Route as StaffSoftwareLayoutContractAndCostContractAndCostCostIndexImport } from './routes/_staff/software/_layout/contract-and-cost/_contract-and-cost/cost/index'
import { Route as StaffSoftwareLayoutAlertsAlertsViolatedRoleIndexImport } from './routes/_staff/software/_layout/alerts/_alerts/violated-role/index'
import { Route as StaffSoftwareLayoutAlertsAlertsViolatedAssignmentIndexImport } from './routes/_staff/software/_layout/alerts/_alerts/violated-assignment/index'
import { Route as StaffSoftwareLayoutAlertsAlertsNoWorkerIndexImport } from './routes/_staff/software/_layout/alerts/_alerts/no-worker/index'
import { Route as StaffSoftwareLayoutAlertsAlertsNoUserIndexImport } from './routes/_staff/software/_layout/alerts/_alerts/no-user/index'
import { Route as StaffSoftwareLayoutAlertsAlertsInactiveUserIndexImport } from './routes/_staff/software/_layout/alerts/_alerts/inactive-user/index'
import { Route as StaffSoftwareLayoutAlertsAlertsAlumniIndexImport } from './routes/_staff/software/_layout/alerts/_alerts/alumni/index'
import { Route as StaffSoftwareIdIdSettingsStatusIndexImport } from './routes/_staff/software/$id/_$id/settings/status/index'
import { Route as StaffSoftwareIdIdSettingsRoleIndexImport } from './routes/_staff/software/$id/_$id/settings/role/index'
import { Route as StaffSoftwareIdIdSettingsIntegrationIndexImport } from './routes/_staff/software/$id/_$id/settings/integration/index'
import { Route as StaffSoftwareIdIdContractAndCostContractAndCostIndexImport } from './routes/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/index'
import { Route as StaffSettingsPersonsListAccountStaffIndexImport } from './routes/_staff/settings/persons/_list/_account/staff/index'
import { Route as StaffSettingsPersonsListAccountIndividualIndexImport } from './routes/_staff/settings/persons/_list/_account/individual/index'
import { Route as StaffSettingsPermissionAndRolesFormRolesNewIndexImport } from './routes/_staff/settings/permission-and-roles/_form/roles/new/index'
import { Route as StaffSettingsPermissionAndRolesFormProductPermissionsNewIndexImport } from './routes/_staff/settings/permission-and-roles/_form/product-permissions/new/index'
import { Route as StaffSettingsPermissionAndRolesFormPeopleGroupsNewIndexImport } from './routes/_staff/settings/permission-and-roles/_form/people-groups/new/index'
import { Route as StaffSettingsPermissionAndRolesFormCategoryPermissionsNewIndexImport } from './routes/_staff/settings/permission-and-roles/_form/category-permissions/new/index'
import { Route as StaffSettingsPermissionAndRolesDetailRolesIdIndexImport } from './routes/_staff/settings/permission-and-roles/_detail/roles/$id/index'
import { Route as StaffSettingsPermissionAndRolesDetailProductPermissionsIdIndexImport } from './routes/_staff/settings/permission-and-roles/_detail/product-permissions/$id/index'
import { Route as StaffSettingsPermissionAndRolesDetailPeopleGroupsIdIndexImport } from './routes/_staff/settings/permission-and-roles/_detail/people-groups/$id/index'
import { Route as StaffSettingsPermissionAndRolesDetailCategoryPermissionsIdIndexImport } from './routes/_staff/settings/permission-and-roles/_detail/category-permissions/$id/index'
import { Route as StaffSettingsDataConnectorOutboundDataPipelineAddIndexImport } from './routes/_staff/settings/data-connector/outbound/data-pipeline/add/index'
import { Route as StaffSettingsDataConnectorOutboundDataPipelineListIndexImport } from './routes/_staff/settings/data-connector/outbound/data-pipeline/_list/index'
import { Route as StaffSettingsDataConnectorInboundDataPipelineAddIndexImport } from './routes/_staff/settings/data-connector/inbound/data-pipeline/add/index'
import { Route as StaffSettingsDataConnectorInboundDataPipelineListIndexImport } from './routes/_staff/settings/data-connector/inbound/data-pipeline/_list/index'
import { Route as StaffSettingsDataConnectorInboundAggregateDataPipelineAddIndexImport } from './routes/_staff/settings/data-connector/inbound/aggregate-data-pipeline/add/index'
import { Route as StaffSettingsDataConnectorInboundAggregateDataPipelineListIndexImport } from './routes/_staff/settings/data-connector/inbound/aggregate-data-pipeline/_list/index'
import { Route as StaffPersonAlumniIdProfilePublicIdIndexImport } from './routes/_staff/person/alumni/$id/_profile/public-id/index'
import { Route as StaffPersonAlumniIdProfilePersonalInformationIndexImport } from './routes/_staff/person/alumni/$id/_profile/personal-information/index'
import { Route as StaffPersonAlumniIdProfileOperationActivityIndexImport } from './routes/_staff/person/alumni/$id/_profile/operation-activity/index'
import { Route as StaffPersonAlumniIdProfileHistoryIndexImport } from './routes/_staff/person/alumni/$id/_profile/history/index'
import { Route as StaffPersonAlumniIdProfileEquipmentIndexImport } from './routes/_staff/person/alumni/$id/_profile/equipment/index'
import { Route as StaffPersonAlumniIdProfileEmployeeInformationIndexImport } from './routes/_staff/person/alumni/$id/_profile/employee-information/index'
import { Route as StaffPersonAlumniIdProfileEducationAndQualificationIndexImport } from './routes/_staff/person/alumni/$id/_profile/education-and-qualification/index'
import { Route as StaffPersonAlumniIdProfileDevicesIndexImport } from './routes/_staff/person/alumni/$id/_profile/devices/index'
import { Route as StaffPersonAlumniIdProfileContractorInformationIndexImport } from './routes/_staff/person/alumni/$id/_profile/contractor-information/index'
import { Route as StaffPersonAlumniIdProfileAppsIndexImport } from './routes/_staff/person/alumni/$id/_profile/apps/index'
import { Route as StaffPersonIdProfileFamilyFamilyPersonIdIndexImport } from './routes/_staff/person/$id/_profile/family/$familyPersonId/index'
import { Route as StaffPayrollLayoutContractAndCostContractAndCostPaymentIndexImport } from './routes/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/payment/index'
import { Route as StaffPayrollLayoutContractAndCostContractAndCostDealIndexImport } from './routes/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/deal/index'
import { Route as StaffPayrollLayoutContractAndCostContractAndCostCostIndexImport } from './routes/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/cost/index'
import { Route as StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutIndexImport } from './routes/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout/index'
import { Route as StaffOrganizationPlanIdEditUnitIdIndexImport } from './routes/_staff/organization/plan/$id/edit/$unitId/index'
import { Route as StaffMarketplaceStoreStoreStarlinksProductIdIndexImport } from './routes/_staff/marketplace/_store/store/starlinks/$productId/index'
import { Route as StaffMarketplaceStoreStoreLicensesProductIdIndexImport } from './routes/_staff/marketplace/_store/store/licenses/$productId/index'
import { Route as StaffMarketplaceStoreStoreDevicesProductIdIndexImport } from './routes/_staff/marketplace/_store/store/devices/$productId/index'
import { Route as StaffIdsGroupIdIdIdSoftwaresIndexImport } from './routes/_staff/ids/group-id/$id/_$id/softwares/index'
import { Route as StaffIdsGroupIdIdIdSecurityAndAuthIndexImport } from './routes/_staff/ids/group-id/$id/_$id/security-and-auth/index'
import { Route as StaffIdsGroupIdIdIdRuleAndPolicyIndexImport } from './routes/_staff/ids/group-id/$id/_$id/rule-and-policy/index'
import { Route as StaffIdsGroupIdIdIdMembersIndexImport } from './routes/_staff/ids/group-id/$id/_$id/members/index'
import { Route as StaffIdsGroupIdIdIdDevicesIndexImport } from './routes/_staff/ids/group-id/$id/_$id/devices/index'
import { Route as StaffIdsGroupIdIdIdDetailIndexImport } from './routes/_staff/ids/group-id/$id/_$id/detail/index'
import { Route as StaffEquipmentItemsIdDetailRuleAndPolicyIndexImport } from './routes/_staff/equipment/items/$id/_detail/rule-and-policy/index'
import { Route as StaffEquipmentItemsIdDetailInventoryIndexImport } from './routes/_staff/equipment/items/$id/_detail/inventory/index'
import { Route as StaffEquipmentItemsIdDetailAlertsIndexImport } from './routes/_staff/equipment/items/$id/_detail/alerts/index'
import { Route as StaffDevicesListContractAndCostContractAndCostPaymentIndexImport } from './routes/_staff/devices/_list/contract-and-cost/_contract-and-cost/payment/index'
import { Route as StaffDevicesListContractAndCostContractAndCostCostIndexImport } from './routes/_staff/devices/_list/contract-and-cost/_contract-and-cost/cost/index'
import { Route as StaffDeviceCatalogDraftIdLayoutProfileIndexImport } from './routes/_staff/device-catalog/draft/$id/_layout/profile/index'
import { Route as StaffDeviceCatalogActiveIdLayoutProfileIndexImport } from './routes/_staff/device-catalog/active/$id/_layout/profile/index'
import { Route as StaffCertificationSpecialtyCertificationIdLayoutHandlingCertificationsIndexImport } from './routes/_staff/certification/specialty-certification/$id/_layout/handling-certifications/index'
import { Route as StaffCertificationSpecialtyCertificationIdLayoutCertificationHoldersIndexImport } from './routes/_staff/certification/specialty-certification/$id/_layout/certification-holders/index'
import { Route as StaffCertificationSpecialtyCertificationIdLayoutIndexIndexImport } from './routes/_staff/certification/specialty-certification/$id/_layout/_index/index'
import { Route as StaffCertificationHandlingCertificationIdLayoutCertificationHoldersIndexImport } from './routes/_staff/certification/handling-certification/$id/_layout/certification-holders/index'
import { Route as StaffCertificationHandlingCertificationIdLayoutIndexIndexImport } from './routes/_staff/certification/handling-certification/$id/_layout/_index/index'
import { Route as StaffBusinessPartnerIdLayoutBpRoleInfoLayoutIndexImport } from './routes/_staff/business-partner/$id/_layout/bp-role-info/_layout/index'
import { Route as StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutIndexImport } from './routes/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout/index'
import { Route as StaffAccessesLayoutAlertsDormancySoftwareIdIndexImport } from './routes/_staff/accesses/_layout/alerts/dormancy/$softwareId/index'
import { Route as StaffAccessesLayoutAlertsDetailShadowItAppIdIndexImport } from './routes/_staff/accesses/_layout/alerts/detail/$shadowItAppId/index'
import { Route as StacktraceTestSuitesIdLayoutTestReviewLayoutIndexImport } from './routes/_stacktrace/test-suites/$id/_layout/test-review/_layout/index'
import { Route as StacktraceTestSuitesIdLayoutTestPlanLayoutIndexImport } from './routes/_stacktrace/test-suites/$id/_layout/test-plan/_layout/index'
import { Route as StacktraceProductsIdScopeNodeIdLayoutIndexImport } from './routes/_stacktrace/products/$id/scope/$nodeId/_layout/index'
import { Route as StacktraceProductionProductionIdLayoutValueEditIndexImport } from './routes/_stacktrace/production/$productionId/_layout/value/edit/index'
import { Route as StacktraceProductionProductionIdLayoutIssueScopeEditIndexImport } from './routes/_stacktrace/production/$productionId/_layout/issue-scope/edit/index'
import { Route as StacktraceProductionProductionIdLayoutDevScopeEditIndexImport } from './routes/_stacktrace/production/$productionId/_layout/dev-scope/edit/index'
import { Route as IndividualIndividualOperationPackageIdTargetTargetIdIndexImport } from './routes/_individual/individual/operation-package/$id/target/$targetId/index'
import { Route as IndividualIndividualOperationPackageIdPatternPatternIdIndexImport } from './routes/_individual/individual/operation-package/$id/pattern/$patternId/index'
import { Route as IndividualIndividualContractIdSignatureRequestSignatureRequestIdIndexImport } from './routes/_individual/individual/contract/$id/signature-request/$signatureRequestId/index'
import { Route as IndividualIndividualProfileMyProfileLayoutSoftwaresIndexImport } from './routes/_individual/individual/_profile/my-profile/_layout/softwares/index'
import { Route as IndividualIndividualProfileMyProfileLayoutEducationAndQualificationIndexImport } from './routes/_individual/individual/_profile/my-profile/_layout/education-and-qualification/index'
import { Route as IndividualIndividualProfileMyProfileLayoutDevicesIndexImport } from './routes/_individual/individual/_profile/my-profile/_layout/devices/index'
import { Route as StaffSoftwareLayoutContractAndCostContractAndCostDealDealImport } from './routes/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal'
import { Route as StaffSettingsDataConnectorOutboundDataPipelineIdDetailImport } from './routes/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail'
import { Route as StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailImport } from './routes/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail'
import { Route as StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailImport } from './routes/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail'
import { Route as StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutImport } from './routes/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout'
import { Route as StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutImport } from './routes/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout'
import { Route as StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutImport } from './routes/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout'
import { Route as StaffDevicesListContractAndCostContractAndCostDealDealImport } from './routes/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal'
import { Route as StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostImport } from './routes/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost'
import { Route as IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutImport } from './routes/_individual/individual/_profile/certifications/specialty-certifications/$id/_layout'
import { Route as IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutImport } from './routes/_individual/individual/_profile/certifications/handling-certifications/$id/_layout'
import { Route as IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutImport } from './routes/_individual/individual/_profile/certifications/base-certifications/$id/_layout'
import { Route as StaffSoftwareLayoutMarketplaceIdInstallFinishIndexImport } from './routes/_staff/software/_layout/marketplace/$id/install.finish/index'
import { Route as StaffSoftwareLayoutLibraryCategoryCategorySearchIndexImport } from './routes/_staff/software/_layout/library/category/$category/search/index'
import { Route as StaffSoftwareLayoutContractAndCostContractAndCostPaymentPeriodIndexImport } from './routes/_staff/software/_layout/contract-and-cost/_contract-and-cost/payment/$period/index'
import { Route as StaffSoftwareLayoutContractAndCostContractAndCostDealDealIndexImport } from './routes/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/index'
import { Route as StaffSoftwareLayoutContractAndCostContractAndCostCostPeriodIndexImport } from './routes/_staff/software/_layout/contract-and-cost/_contract-and-cost/cost/$period/index'
import { Route as StaffSoftwareIdIdContractAndCostContractAndCostPaymentIndexImport } from './routes/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/payment/index'
import { Route as StaffSoftwareIdIdContractAndCostContractAndCostCostIndexImport } from './routes/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/cost/index'
import { Route as StaffSettingsPermissionAndRolesFormRolesIdEditIndexImport } from './routes/_staff/settings/permission-and-roles/_form/roles/$id/edit/index'
import { Route as StaffSettingsPermissionAndRolesFormProductPermissionsIdEditIndexImport } from './routes/_staff/settings/permission-and-roles/_form/product-permissions/$id/edit/index'
import { Route as StaffSettingsPermissionAndRolesFormPeopleGroupsIdEditIndexImport } from './routes/_staff/settings/permission-and-roles/_form/people-groups/$id/edit/index'
import { Route as StaffSettingsPermissionAndRolesFormCategoryPermissionsIdEditIndexImport } from './routes/_staff/settings/permission-and-roles/_form/category-permissions/$id/edit/index'
import { Route as StaffPayrollLayoutContractAndCostContractAndCostPaymentPeriodIndexImport } from './routes/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/payment/$period/index'
import { Route as StaffPayrollLayoutContractAndCostContractAndCostCostPeriodIndexImport } from './routes/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/cost/$period/index'
import { Route as StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutStructureIndexImport } from './routes/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout/structure/index'
import { Route as StaffLicensesIdServicePlansLicenseServiceIdDetailAccountsIndexImport } from './routes/_staff/licenses/$id/service-plans/$licenseServiceId/_detail/accounts/index'
import { Route as StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutOperationActivityIndexImport } from './routes/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/operation-activity/index'
import { Route as StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDetailIndexImport } from './routes/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/detail/index'
import { Route as StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDataIndexImport } from './routes/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/data/index'
import { Route as StaffDevicesListContractAndCostContractAndCostPaymentPeriodIndexImport } from './routes/_staff/devices/_list/contract-and-cost/_contract-and-cost/payment/$period/index'
import { Route as StaffDevicesListContractAndCostContractAndCostDealDealIndexImport } from './routes/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/index'
import { Route as StaffDevicesListContractAndCostContractAndCostCostPeriodIndexImport } from './routes/_staff/devices/_list/contract-and-cost/_contract-and-cost/cost/$period/index'
import { Route as StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostIndexImport } from './routes/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/index'
import { Route as StaffBusinessPartnerIdLayoutBpRoleInfoLayoutBpRoleIndexImport } from './routes/_staff/business-partner/$id/_layout/bp-role-info/_layout/$bpRole/index'
import { Route as StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutStructureIndexImport } from './routes/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout/structure/index'
import { Route as StacktraceProductsIdScopeNodeIdLayoutValueIndexImport } from './routes/_stacktrace/products/$id/scope/$nodeId/_layout/value/index'
import { Route as StaffSoftwareIdIdContractAndCostContractAndCostDealDealImport } from './routes/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal'
import { Route as StaffSoftwareLayoutContractAndCostContractAndCostDealDealVendorInvoiceIndexImport } from './routes/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/index'
import { Route as StaffSoftwareLayoutContractAndCostContractAndCostDealDealPaymentIndexImport } from './routes/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/payment/index'
import { Route as StaffSoftwareLayoutContractAndCostContractAndCostDealDealOrderIndexImport } from './routes/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/order/index'
import { Route as StaffSoftwareLayoutContractAndCostContractAndCostDealDealEstimateIndexImport } from './routes/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/estimate/index'
import { Route as StaffSoftwareLayoutContractAndCostContractAndCostDealDealContractIndexImport } from './routes/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/contract/index'
import { Route as StaffSoftwareLayoutContractAndCostContractAndCostDealDealAllIndexImport } from './routes/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/all/index'
import { Route as StaffSoftwareIdIdContractAndCostContractAndCostPaymentPeriodIndexImport } from './routes/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/payment/$period/index'
import { Route as StaffSoftwareIdIdContractAndCostContractAndCostDealDealIndexImport } from './routes/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/index'
import { Route as StaffSoftwareIdIdContractAndCostContractAndCostCostPeriodIndexImport } from './routes/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/cost/$period/index'
import { Route as StaffSettingsDataConnectorOutboundDataPipelineIdDetailExecutionResultsIndexImport } from './routes/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/execution-results/index'
import { Route as StaffSettingsDataConnectorOutboundDataPipelineIdDetailExecutionPlanIndexImport } from './routes/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/execution-plan/index'
import { Route as StaffSettingsDataConnectorOutboundDataPipelineIdDetailDataLinkSettingsIndexImport } from './routes/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/data-link-settings/index'
import { Route as StaffSettingsDataConnectorOutboundDataPipelineIdDetailBasicSettingsIndexImport } from './routes/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/basic-settings/index'
import { Route as StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailExecutionResultsIndexImport } from './routes/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/execution-results/index'
import { Route as StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailExecutionPlanIndexImport } from './routes/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/execution-plan/index'
import { Route as StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailDataLinkSettingsIndexImport } from './routes/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/data-link-settings/index'
import { Route as StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailBasicSettingsIndexImport } from './routes/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/basic-settings/index'
import { Route as StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailTasksIndexImport } from './routes/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/tasks/index'
import { Route as StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailPrioritySettingIndexImport } from './routes/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/priority-setting/index'
import { Route as StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailExecutionPlanIndexImport } from './routes/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/execution-plan/index'
import { Route as StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailBasicInfoIndexImport } from './routes/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/basic-info/index'
import { Route as StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutIndexIndexImport } from './routes/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout/_index/index'
import { Route as StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutIndexIndexImport } from './routes/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout/_index/index'
import { Route as StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutIndexIndexImport } from './routes/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout/_index/index'
import { Route as StaffDevicesListContractAndCostContractAndCostDealDealVendorInvoiceIndexImport } from './routes/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/index'
import { Route as StaffDevicesListContractAndCostContractAndCostDealDealPaymentIndexImport } from './routes/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/payment/index'
import { Route as StaffDevicesListContractAndCostContractAndCostDealDealOrderIndexImport } from './routes/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/order/index'
import { Route as StaffDevicesListContractAndCostContractAndCostDealDealEstimateIndexImport } from './routes/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/estimate/index'
import { Route as StaffDevicesListContractAndCostContractAndCostDealDealContractIndexImport } from './routes/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/contract/index'
import { Route as StaffDevicesListContractAndCostContractAndCostDealDealAllIndexImport } from './routes/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/all/index'
import { Route as StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostPaymentIndexImport } from './routes/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/payment/index'
import { Route as StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostCostIndexImport } from './routes/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/cost/index'
import { Route as IndividualIndividualTaskIdOperationPackageCommonFormFormIdIndexImport } from './routes/_individual/individual/task/$id/_operation-package/_common/form/$formId/index'
import { Route as IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutIndexIndexImport } from './routes/_individual/individual/_profile/certifications/specialty-certifications/$id/_layout/_index/index'
import { Route as IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutIndexIndexImport } from './routes/_individual/individual/_profile/certifications/handling-certifications/$id/_layout/_index/index'
import { Route as IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutIndexIndexImport } from './routes/_individual/individual/_profile/certifications/base-certifications/$id/_layout/_index/index'
import { Route as StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailImport } from './routes/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/_task-detail'
import { Route as StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport } from './routes/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile'
import { Route as StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport } from './routes/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile'
import { Route as StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealImport } from './routes/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal'
import { Route as StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport } from './routes/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile'
import { Route as StaffSoftwareIdIdContractAndCostContractAndCostDealDealVendorInvoiceIndexImport } from './routes/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/index'
import { Route as StaffSoftwareIdIdContractAndCostContractAndCostDealDealPaymentIndexImport } from './routes/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/payment/index'
import { Route as StaffSoftwareIdIdContractAndCostContractAndCostDealDealOrderIndexImport } from './routes/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/order/index'
import { Route as StaffSoftwareIdIdContractAndCostContractAndCostDealDealEstimateIndexImport } from './routes/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/estimate/index'
import { Route as StaffSoftwareIdIdContractAndCostContractAndCostDealDealContractIndexImport } from './routes/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/contract/index'
import { Route as StaffSoftwareIdIdContractAndCostContractAndCostDealDealAllIndexImport } from './routes/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/all/index'
import { Route as StaffSettingsDataConnectorInboundAggregateDataPipelineIdTasksTaskIdChunksIndexImport } from './routes/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/index'
import { Route as StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexImport } from './routes/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/index'
import { Route as StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexImport } from './routes/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/index'
import { Route as StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostPaymentPeriodIndexImport } from './routes/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/payment/$period/index'
import { Route as StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealIndexImport } from './routes/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/index'
import { Route as StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostCostPeriodIndexImport } from './routes/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/cost/$period/index'
import { Route as StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexImport } from './routes/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/index'
import { Route as StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport } from './routes/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile'
import { Route as StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailChunksIndexImport } from './routes/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/_task-detail/chunks/index'
import { Route as StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexImport } from './routes/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/index'
import { Route as StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexImport } from './routes/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/index'
import { Route as StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealVendorInvoiceIndexImport } from './routes/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/index'
import { Route as StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealPaymentIndexImport } from './routes/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/payment/index'
import { Route as StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealOrderIndexImport } from './routes/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/order/index'
import { Route as StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealEstimateIndexImport } from './routes/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/estimate/index'
import { Route as StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealContractIndexImport } from './routes/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/contract/index'
import { Route as StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealAllIndexImport } from './routes/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/all/index'
import { Route as StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexImport } from './routes/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/index'
import { Route as StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexImport } from './routes/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/index'
import { Route as StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdChunksChunkIdResultIndexImport } from './routes/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/chunks/$chunkId/result/index'
import { Route as StaffSettingsDataConnectorInboundAggregateDataPipelineIdTasksTaskIdChunksChunkIdResultIndexImport } from './routes/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/$chunkId/result/index'
import { Route as StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexImport } from './routes/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/index'

// Create Virtual Routes

const StaffTimeAndAttendanceImport = createFileRoute(
  '/_staff/time-and-attendance',
)()
const StaffSupplierImport = createFileRoute('/_staff/supplier')()
const StaffStorageFilesImport = createFileRoute('/_staff/storage-files')()
const StaffStarlinksImport = createFileRoute('/_staff/starlinks')()
const StaffSoftwareImport = createFileRoute('/_staff/software')()
const StaffPublicIdsImport = createFileRoute('/_staff/public-ids')()
const StaffPlacesImport = createFileRoute('/_staff/places')()
const StaffPeopleImport = createFileRoute('/_staff/people')()
const StaffPayrollImport = createFileRoute('/_staff/payroll')()
const StaffPayrollEngineImport = createFileRoute('/_staff/payroll-engine')()
const StaffPayrollCoreImport = createFileRoute('/_staff/payroll-core')()
const StaffOrganizationImport = createFileRoute('/_staff/organization')()
const StaffNetworksImport = createFileRoute('/_staff/networks')()
const StaffMarketplaceImport = createFileRoute('/_staff/marketplace')()
const StaffLicensesImport = createFileRoute('/_staff/licenses')()
const StaffLaborCoreImport = createFileRoute('/_staff/labor-core')()
const StaffItOperationCoreImport = createFileRoute(
  '/_staff/it-operation-core',
)()
const StaffIdsImport = createFileRoute('/_staff/ids')()
const StaffGaOperationCoreImport = createFileRoute(
  '/_staff/ga-operation-core',
)()
const StaffFleetsImport = createFileRoute('/_staff/fleets')()
const StaffEquipmentImport = createFileRoute('/_staff/equipment')()
const StaffDevicesImport = createFileRoute('/_staff/devices')()
const StaffDealImport = createFileRoute('/_staff/deal')()
const StaffContractorCoreImport = createFileRoute('/_staff/contractor-core')()
const StaffContractImport = createFileRoute('/_staff/contract')()
const StaffCertificationImport = createFileRoute('/_staff/certification')()
const StaffBusinessPartnerImport = createFileRoute('/_staff/business-partner')()
const StaffBusinessOperationEventsImport = createFileRoute(
  '/_staff/business-operation-events',
)()
const StaffAttendancesImport = createFileRoute('/_staff/attendances')()
const StaffAttendanceEngineImport = createFileRoute(
  '/_staff/attendance-engine',
)()
const StaffAttendanceCoreImport = createFileRoute('/_staff/attendance-core')()
const StaffAccessesImport = createFileRoute('/_staff/accesses')()
const StacktraceValuesImport = createFileRoute('/_stacktrace/values')()
const StacktraceTestSuitesImport = createFileRoute('/_stacktrace/test-suites')()
const StacktraceTestSetsImport = createFileRoute('/_stacktrace/test-sets')()
const StacktraceProductRoadmapImport = createFileRoute(
  '/_stacktrace/product-roadmap',
)()
const StacktraceIssuesImport = createFileRoute('/_stacktrace/issues')()
const IndividualIndividualImport = createFileRoute('/_individual/individual')()
const StaffUsersUserIdImport = createFileRoute('/_staff/users/$userId')()
const StaffSupplierSupplierIdImport = createFileRoute(
  '/_staff/supplier/$supplierId',
)()
const StaffStarlinksIdImport = createFileRoute('/_staff/starlinks/$id')()
const StaffSoftwareIdImport = createFileRoute('/_staff/software/$id')()
const StaffSettingsPersonsImport = createFileRoute('/_staff/settings/persons')()
const StaffSettingsPermissionAndRolesImport = createFileRoute(
  '/_staff/settings/permission-and-roles',
)()
const StaffSettingsContractingCorporationProfileImport = createFileRoute(
  '/_staff/settings/contracting-corporation-profile',
)()
const StaffPlacesIdImport = createFileRoute('/_staff/places/$id')()
const StaffPersonIdImport = createFileRoute('/_staff/person/$id')()
const StaffOrganizationIdImport = createFileRoute('/_staff/organization/$id')()
const StaffNetworksIdImport = createFileRoute('/_staff/networks/$id')()
const StaffLicensesIdImport = createFileRoute('/_staff/licenses/$id')()
const StaffFleetsIdImport = createFileRoute('/_staff/fleets/$id')()
const StaffEquipmentIdImport = createFileRoute('/_staff/equipment/$id')()
const StaffDevicesIdImport = createFileRoute('/_staff/devices/$id')()
const StaffDealDealIdImport = createFileRoute('/_staff/deal/$dealId')()
const StaffContractIdImport = createFileRoute('/_staff/contract/$id')()
const StaffCertificationIdImport = createFileRoute(
  '/_staff/certification/$id',
)()
const StaffBusinessPartnerIdImport = createFileRoute(
  '/_staff/business-partner/$id',
)()
const StaffAppIntegrationsIdImport = createFileRoute(
  '/_staff/app-integrations/$id',
)()
const StacktraceValuesIdImport = createFileRoute('/_stacktrace/values/$id')()
const StacktraceTestSuitesIdImport = createFileRoute(
  '/_stacktrace/test-suites/$id',
)()
const StacktraceTestSetsIdImport = createFileRoute(
  '/_stacktrace/test-sets/$id',
)()
const StacktraceProductsIdImport = createFileRoute(
  '/_stacktrace/products/$id',
)()
const StacktraceProductionProductionIdImport = createFileRoute(
  '/_stacktrace/production/$productionId',
)()
const StacktraceProductRoadmapRoadmapIdImport = createFileRoute(
  '/_stacktrace/product-roadmap/$roadmapId',
)()
const StacktraceIssuesIdImport = createFileRoute('/_stacktrace/issues/$id')()
const StacktraceDevelopmentTicketsTicketIdImport = createFileRoute(
  '/_stacktrace/development-tickets/$ticketId',
)()
const StaffLaborCoreGroupNameLazyImport = createFileRoute(
  '/_staff/labor-core/group-name',
)()
const StaffStorageFilesFoldersIdImport = createFileRoute(
  '/_staff/storage-files/folders/$id',
)()
const StaffStorageFilesFilesIdImport = createFileRoute(
  '/_staff/storage-files/files/$id',
)()
const StaffSoftwareLayoutContractAndCostImport = createFileRoute(
  '/_staff/software/_layout/contract-and-cost',
)()
const StaffSoftwareLayoutAlertsImport = createFileRoute(
  '/_staff/software/_layout/alerts',
)()
const StaffPersonAlumniIdImport = createFileRoute('/_staff/person/alumni/$id')()
const StaffPayrollLayoutContractAndCostImport = createFileRoute(
  '/_staff/payroll/_layout/contract-and-cost',
)()
const StaffMarketplaceSentOrdersOrderIdImport = createFileRoute(
  '/_staff/marketplace/sent-orders/$orderId',
)()
const StaffIdsGroupIdIdImport = createFileRoute('/_staff/ids/group-id/$id')()
const StaffEquipmentItemsIdImport = createFileRoute(
  '/_staff/equipment/items/$id',
)()
const StaffDevicesListContractAndCostImport = createFileRoute(
  '/_staff/devices/_list/contract-and-cost',
)()
const StaffDeviceCatalogDraftIdImport = createFileRoute(
  '/_staff/device-catalog/draft/$id',
)()
const StaffDeviceCatalogActiveIdImport = createFileRoute(
  '/_staff/device-catalog/active/$id',
)()
const StaffCertificationSpecialtyCertificationIdImport = createFileRoute(
  '/_staff/certification/specialty-certification/$id',
)()
const StaffCertificationHandlingCertificationIdImport = createFileRoute(
  '/_staff/certification/handling-certification/$id',
)()
const IndividualIndividualProfileMyProfileImport = createFileRoute(
  '/_individual/individual/_profile/my-profile',
)()
const StaffSupplierListSettingsRouteLazyImport = createFileRoute(
  '/_staff/supplier/_list/settings',
)()
const StaffPeopleListSettingsRouteLazyImport = createFileRoute(
  '/_staff/people/_list/settings',
)()
const StaffEquipmentLayoutSettingsRouteLazyImport = createFileRoute(
  '/_staff/equipment/_layout/settings',
)()
const StaffDevicesListSettingsRouteLazyImport = createFileRoute(
  '/_staff/devices/_list/settings',
)()
const StaffCertificationListSettingsRouteLazyImport = createFileRoute(
  '/_staff/certification/_list/settings',
)()
const StaffSoftwareLayoutIndexRouteLazyImport = createFileRoute(
  '/_staff/software/_layout/',
)()
const StaffPeopleListIndexRouteLazyImport = createFileRoute(
  '/_staff/people/_list/',
)()
const StaffDevicesListIndexRouteLazyImport = createFileRoute(
  '/_staff/devices/_list/',
)()
const StaffSoftwareIdIdContractAndCostImport = createFileRoute(
  '/_staff/software/$id/_$id/contract-and-cost',
)()
const StaffSettingsDataConnectorOutboundDataPipelineImport = createFileRoute(
  '/_staff/settings/data-connector/outbound/data-pipeline',
)()
const StaffSettingsDataConnectorInboundDataPipelineImport = createFileRoute(
  '/_staff/settings/data-connector/inbound/data-pipeline',
)()
const StaffSettingsDataConnectorInboundAggregateDataPipelineImport =
  createFileRoute(
    '/_staff/settings/data-connector/inbound/aggregate-data-pipeline',
  )()
const StaffPayrollEngineLayoutPayrollStructuresStructureIdImport =
  createFileRoute(
    '/_staff/payroll-engine/_layout/payroll-structures/$structureId',
  )()
const StaffLicensesIdServicePlansLicenseServiceIdImport = createFileRoute(
  '/_staff/licenses/$id/service-plans/$licenseServiceId',
)()
const StaffItOperationCoreDetailOperationInstancesInstanceIdImport =
  createFileRoute(
    '/_staff/it-operation-core/_detail/operation-instances/$instanceId',
  )()
const StaffBusinessPartnerIdLayoutBpRoleInfoImport = createFileRoute(
  '/_staff/business-partner/$id/_layout/bp-role-info',
)()
const StaffAttendanceEngineLayoutAttendanceStructuresStructureIdImport =
  createFileRoute(
    '/_staff/attendance-engine/_layout/attendance-structures/$structureId',
  )()
const StacktraceTestSuitesIdLayoutTestReviewImport = createFileRoute(
  '/_stacktrace/test-suites/$id/_layout/test-review',
)()
const StacktraceTestSuitesIdLayoutTestPlanImport = createFileRoute(
  '/_stacktrace/test-suites/$id/_layout/test-plan',
)()
const StacktraceProductsIdScopeNodeIdImport = createFileRoute(
  '/_stacktrace/products/$id/scope/$nodeId',
)()
const StaffLicensesIdProfileIndexLazyImport = createFileRoute(
  '/_staff/licenses/$id/_profile/',
)()
const StaffEquipmentIdLayoutIndexLazyImport = createFileRoute(
  '/_staff/equipment/$id/_layout/',
)()
const StaffSoftwareIdIdSettingsRouteLazyImport = createFileRoute(
  '/_staff/software/$id/_$id/settings',
)()
const StaffSoftwareLayoutContractAndCostContractAndCostDealImport =
  createFileRoute(
    '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal',
  )()
const StaffSettingsDataConnectorOutboundDataPipelineIdImport = createFileRoute(
  '/_staff/settings/data-connector/outbound/data-pipeline/$id',
)()
const StaffSettingsDataConnectorInboundDataPipelineIdImport = createFileRoute(
  '/_staff/settings/data-connector/inbound/data-pipeline/$id',
)()
const StaffSettingsDataConnectorInboundAggregateDataPipelineIdImport =
  createFileRoute(
    '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id',
  )()
const StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdImport =
  createFileRoute(
    '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId',
  )()
const StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdImport =
  createFileRoute(
    '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId',
  )()
const StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdImport =
  createFileRoute(
    '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId',
  )()
const StaffDevicesListContractAndCostContractAndCostDealImport =
  createFileRoute(
    '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal',
  )()
const StaffDeviceCatalogActiveIdLayoutContractAndCostImport = createFileRoute(
  '/_staff/device-catalog/active/$id/_layout/contract-and-cost',
)()
const IndividualIndividualProfileCertificationsSpecialtyCertificationsIdImport =
  createFileRoute(
    '/_individual/individual/_profile/certifications/specialty-certifications/$id',
  )()
const IndividualIndividualProfileCertificationsHandlingCertificationsIdImport =
  createFileRoute(
    '/_individual/individual/_profile/certifications/handling-certifications/$id',
  )()
const IndividualIndividualProfileCertificationsBaseCertificationsIdImport =
  createFileRoute(
    '/_individual/individual/_profile/certifications/base-certifications/$id',
  )()
const StaffStorageFilesFoldersIdIdIndexLazyImport = createFileRoute(
  '/_staff/storage-files/folders/$id/_$id/',
)()
const StaffStorageFilesFilesIdIdIndexLazyImport = createFileRoute(
  '/_staff/storage-files/files/$id/_$id/',
)()
const StaffStarlinksIdLayoutDetailIndexLazyImport = createFileRoute(
  '/_staff/starlinks/$id/_layout/detail/',
)()
const StaffStarlinksIdLayoutOverviewIndexLazyImport = createFileRoute(
  '/_staff/starlinks/$id/_layout/_overview/',
)()
const StaffPlacesIdLayoutProfileIndexLazyImport = createFileRoute(
  '/_staff/places/$id/_layout/_profile/',
)()
const StaffPayrollLayoutPaySlipsEmployeeIdIndexLazyImport = createFileRoute(
  '/_staff/payroll/_layout/pay-slips/$employeeId/',
)()
const StaffNetworksIdLayoutProfileIndexLazyImport = createFileRoute(
  '/_staff/networks/$id/_layout/_profile/',
)()
const StaffFleetsIdLayoutProfileIndexLazyImport = createFileRoute(
  '/_staff/fleets/$id/_layout/_profile/',
)()
const StaffEquipmentIdLayoutStatusIndexLazyImport = createFileRoute(
  '/_staff/equipment/$id/_layout/status/',
)()
const StaffEquipmentIdLayoutLifecycleIndexLazyImport = createFileRoute(
  '/_staff/equipment/$id/_layout/lifecycle/',
)()
const StaffContractIdLayoutStructureIndexLazyImport = createFileRoute(
  '/_staff/contract/$id/_layout/structure/',
)()
const StaffContractIdLayoutIndexIndexLazyImport = createFileRoute(
  '/_staff/contract/$id/_layout/_index/',
)()
const StaffAttendancesLayoutClockingRecordsEmployeeIdIndexLazyImport =
  createFileRoute('/_staff/attendances/_layout/clocking-records/$employeeId/')()
const IndividualIndividualPortalLookupPaySlipIndexLazyImport = createFileRoute(
  '/_individual/individual/portal/lookup/pay-slip/',
)()
const IndividualIndividualPortalLookupClockingRecordIndexLazyImport =
  createFileRoute('/_individual/individual/portal/lookup/clocking-record/')()
const StaffPayrollLayoutPaySlipsEmployeeIdSettingsLazyImport = createFileRoute(
  '/_staff/payroll/_layout/pay-slips/$employeeId/settings',
)()
const StaffPayrollLayoutPaySlipsEmployeeIdOverviewLazyImport = createFileRoute(
  '/_staff/payroll/_layout/pay-slips/$employeeId/overview',
)()
const StaffPayrollLayoutPaySlipsEmployeeIdHistoryLazyImport = createFileRoute(
  '/_staff/payroll/_layout/pay-slips/$employeeId/history',
)()
const StaffPayrollLayoutPaySlipsEmployeeIdFilesLazyImport = createFileRoute(
  '/_staff/payroll/_layout/pay-slips/$employeeId/files',
)()
const StaffPayrollLayoutPaySlipsEmployeeIdAlertsLazyImport = createFileRoute(
  '/_staff/payroll/_layout/pay-slips/$employeeId/alerts',
)()
const StaffAttendancesLayoutClockingRecordsEmployeeIdSettingsLazyImport =
  createFileRoute(
    '/_staff/attendances/_layout/clocking-records/$employeeId/settings',
  )()
const StaffAttendancesLayoutClockingRecordsEmployeeIdScheduleLazyImport =
  createFileRoute(
    '/_staff/attendances/_layout/clocking-records/$employeeId/schedule',
  )()
const StaffAttendancesLayoutClockingRecordsEmployeeIdOverviewLazyImport =
  createFileRoute(
    '/_staff/attendances/_layout/clocking-records/$employeeId/overview',
  )()
const StaffAttendancesLayoutClockingRecordsEmployeeIdFilesLazyImport =
  createFileRoute(
    '/_staff/attendances/_layout/clocking-records/$employeeId/files',
  )()
const StaffAttendancesLayoutClockingRecordsEmployeeIdAlertsLazyImport =
  createFileRoute(
    '/_staff/attendances/_layout/clocking-records/$employeeId/alerts',
  )()
const IndividualIndividualPortalLookupPaySlipOverviewLazyImport =
  createFileRoute('/_individual/individual/portal/lookup/pay-slip/overview')()
const IndividualIndividualPortalLookupPaySlipHistoryLazyImport =
  createFileRoute('/_individual/individual/portal/lookup/pay-slip/history')()
const IndividualIndividualPortalLookupPaySlipFilesLazyImport = createFileRoute(
  '/_individual/individual/portal/lookup/pay-slip/files',
)()
const IndividualIndividualPortalLookupPaySlipAlertsLazyImport = createFileRoute(
  '/_individual/individual/portal/lookup/pay-slip/alerts',
)()
const IndividualIndividualPortalLookupClockingRecordScheduleLazyImport =
  createFileRoute(
    '/_individual/individual/portal/lookup/clocking-record/schedule',
  )()
const IndividualIndividualPortalLookupClockingRecordOverviewLazyImport =
  createFileRoute(
    '/_individual/individual/portal/lookup/clocking-record/overview',
  )()
const IndividualIndividualPortalLookupClockingRecordFilesLazyImport =
  createFileRoute(
    '/_individual/individual/portal/lookup/clocking-record/files',
  )()
const IndividualIndividualPortalLookupClockingRecordAlertsLazyImport =
  createFileRoute(
    '/_individual/individual/portal/lookup/clocking-record/alerts',
  )()
const StaffSoftwareIdIdContractAndCostContractAndCostDealImport =
  createFileRoute(
    '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal',
  )()
const StaffEquipmentItemsIdDetailProfileIndexLazyImport = createFileRoute(
  '/_staff/equipment/items/$id/_detail/profile/',
)()
const StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdImport =
  createFileRoute(
    '/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId',
  )()
const StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdImport =
  createFileRoute(
    '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId',
  )()
const StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdImport =
  createFileRoute(
    '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId',
  )()
const StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealImport =
  createFileRoute(
    '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal',
  )()
const StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdImport =
  createFileRoute(
    '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId',
  )()
const StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdImport =
  createFileRoute(
    '/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId',
  )()

// Create/Update Routes

const StaffRoute = StaffImport.update({
  id: '/_staff',
  getParentRoute: () => rootRoute,
} as any)

const StacktraceRoute = StacktraceImport.update({
  id: '/_stacktrace',
  getParentRoute: () => rootRoute,
} as any)

const IndividualRoute = IndividualImport.update({
  id: '/_individual',
  getParentRoute: () => rootRoute,
} as any)

const IdpSsoMockRoute = IdpSsoMockImport.update({
  id: '/_idp-sso-mock',
  getParentRoute: () => rootRoute,
} as any)

const CockpitMockRoute = CockpitMockImport.update({
  id: '/_cockpit-mock',
  getParentRoute: () => rootRoute,
} as any)

const ChatRoute = ChatImport.update({
  id: '/_chat',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const StaffTimeAndAttendanceRoute = StaffTimeAndAttendanceImport.update({
  id: '/time-and-attendance',
  path: '/time-and-attendance',
  getParentRoute: () => StaffRoute,
} as any)

const StaffSupplierRoute = StaffSupplierImport.update({
  id: '/supplier',
  path: '/supplier',
  getParentRoute: () => StaffRoute,
} as any)

const StaffStorageFilesRoute = StaffStorageFilesImport.update({
  id: '/storage-files',
  path: '/storage-files',
  getParentRoute: () => StaffRoute,
} as any)

const StaffStarlinksRoute = StaffStarlinksImport.update({
  id: '/starlinks',
  path: '/starlinks',
  getParentRoute: () => StaffRoute,
} as any)

const StaffSoftwareRoute = StaffSoftwareImport.update({
  id: '/software',
  path: '/software',
  getParentRoute: () => StaffRoute,
} as any)

const StaffPublicIdsRoute = StaffPublicIdsImport.update({
  id: '/public-ids',
  path: '/public-ids',
  getParentRoute: () => StaffRoute,
} as any)

const StaffPlacesRoute = StaffPlacesImport.update({
  id: '/places',
  path: '/places',
  getParentRoute: () => StaffRoute,
} as any)

const StaffPeopleRoute = StaffPeopleImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => StaffRoute,
} as any)

const StaffPayrollRoute = StaffPayrollImport.update({
  id: '/payroll',
  path: '/payroll',
  getParentRoute: () => StaffRoute,
} as any)

const StaffPayrollEngineRoute = StaffPayrollEngineImport.update({
  id: '/payroll-engine',
  path: '/payroll-engine',
  getParentRoute: () => StaffRoute,
} as any)

const StaffPayrollCoreRoute = StaffPayrollCoreImport.update({
  id: '/payroll-core',
  path: '/payroll-core',
  getParentRoute: () => StaffRoute,
} as any)

const StaffOrganizationRoute = StaffOrganizationImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => StaffRoute,
} as any)

const StaffNetworksRoute = StaffNetworksImport.update({
  id: '/networks',
  path: '/networks',
  getParentRoute: () => StaffRoute,
} as any)

const StaffMarketplaceRoute = StaffMarketplaceImport.update({
  id: '/marketplace',
  path: '/marketplace',
  getParentRoute: () => StaffRoute,
} as any)

const StaffLicensesRoute = StaffLicensesImport.update({
  id: '/licenses',
  path: '/licenses',
  getParentRoute: () => StaffRoute,
} as any)

const StaffLaborCoreRoute = StaffLaborCoreImport.update({
  id: '/labor-core',
  path: '/labor-core',
  getParentRoute: () => StaffRoute,
} as any)

const StaffItOperationCoreRoute = StaffItOperationCoreImport.update({
  id: '/it-operation-core',
  path: '/it-operation-core',
  getParentRoute: () => StaffRoute,
} as any)

const StaffIdsRoute = StaffIdsImport.update({
  id: '/ids',
  path: '/ids',
  getParentRoute: () => StaffRoute,
} as any)

const StaffGaOperationCoreRoute = StaffGaOperationCoreImport.update({
  id: '/ga-operation-core',
  path: '/ga-operation-core',
  getParentRoute: () => StaffRoute,
} as any)

const StaffFleetsRoute = StaffFleetsImport.update({
  id: '/fleets',
  path: '/fleets',
  getParentRoute: () => StaffRoute,
} as any)

const StaffEquipmentRoute = StaffEquipmentImport.update({
  id: '/equipment',
  path: '/equipment',
  getParentRoute: () => StaffRoute,
} as any)

const StaffDevicesRoute = StaffDevicesImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => StaffRoute,
} as any)

const StaffDealRoute = StaffDealImport.update({
  id: '/deal',
  path: '/deal',
  getParentRoute: () => StaffRoute,
} as any)

const StaffContractorCoreRoute = StaffContractorCoreImport.update({
  id: '/contractor-core',
  path: '/contractor-core',
  getParentRoute: () => StaffRoute,
} as any)

const StaffContractRoute = StaffContractImport.update({
  id: '/contract',
  path: '/contract',
  getParentRoute: () => StaffRoute,
} as any)

const StaffCertificationRoute = StaffCertificationImport.update({
  id: '/certification',
  path: '/certification',
  getParentRoute: () => StaffRoute,
} as any)

const StaffBusinessPartnerRoute = StaffBusinessPartnerImport.update({
  id: '/business-partner',
  path: '/business-partner',
  getParentRoute: () => StaffRoute,
} as any)

const StaffBusinessOperationEventsRoute =
  StaffBusinessOperationEventsImport.update({
    id: '/business-operation-events',
    path: '/business-operation-events',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffAttendancesRoute = StaffAttendancesImport.update({
  id: '/attendances',
  path: '/attendances',
  getParentRoute: () => StaffRoute,
} as any)

const StaffAttendanceEngineRoute = StaffAttendanceEngineImport.update({
  id: '/attendance-engine',
  path: '/attendance-engine',
  getParentRoute: () => StaffRoute,
} as any)

const StaffAttendanceCoreRoute = StaffAttendanceCoreImport.update({
  id: '/attendance-core',
  path: '/attendance-core',
  getParentRoute: () => StaffRoute,
} as any)

const StaffAccessesRoute = StaffAccessesImport.update({
  id: '/accesses',
  path: '/accesses',
  getParentRoute: () => StaffRoute,
} as any)

const StacktraceValuesRoute = StacktraceValuesImport.update({
  id: '/values',
  path: '/values',
  getParentRoute: () => StacktraceRoute,
} as any)

const StacktraceTestSuitesRoute = StacktraceTestSuitesImport.update({
  id: '/test-suites',
  path: '/test-suites',
  getParentRoute: () => StacktraceRoute,
} as any)

const StacktraceTestSetsRoute = StacktraceTestSetsImport.update({
  id: '/test-sets',
  path: '/test-sets',
  getParentRoute: () => StacktraceRoute,
} as any)

const StacktraceProductRoadmapRoute = StacktraceProductRoadmapImport.update({
  id: '/product-roadmap',
  path: '/product-roadmap',
  getParentRoute: () => StacktraceRoute,
} as any)

const StacktraceIssuesRoute = StacktraceIssuesImport.update({
  id: '/issues',
  path: '/issues',
  getParentRoute: () => StacktraceRoute,
} as any)

const IndividualIndividualRoute = IndividualIndividualImport.update({
  id: '/individual',
  path: '/individual',
  getParentRoute: () => IndividualRoute,
} as any)

const MeIndexRoute = MeIndexImport.update({
  id: '/me/',
  path: '/me/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/me/index.lazy').then((d) => d.Route))

const StaffIdManagementsRoute = StaffIdManagementsImport.update({
  id: '/id-managements',
  path: '/id-managements',
  getParentRoute: () => StaffRoute,
} as any)

const StaffAppsRoute = StaffAppsImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => StaffRoute,
} as any)

const StacktraceQaOperationsCoreRoute = StacktraceQaOperationsCoreImport.update(
  {
    id: '/qa-operations-core',
    path: '/qa-operations-core',
    getParentRoute: () => StacktraceRoute,
  } as any,
)

const StacktraceProductPlanningCoreRoute =
  StacktraceProductPlanningCoreImport.update({
    id: '/product-planning-core',
    path: '/product-planning-core',
    getParentRoute: () => StacktraceRoute,
  } as any)

const StacktracePlanningOperationsCoreRoute =
  StacktracePlanningOperationsCoreImport.update({
    id: '/planning-operations-core',
    path: '/planning-operations-core',
    getParentRoute: () => StacktraceRoute,
  } as any)

const StaffUsersUserIdRoute = StaffUsersUserIdImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => StaffRoute,
} as any)

const StaffSupplierSupplierIdRoute = StaffSupplierSupplierIdImport.update({
  id: '/$supplierId',
  path: '/$supplierId',
  getParentRoute: () => StaffSupplierRoute,
} as any)

const StaffStarlinksIdRoute = StaffStarlinksIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffStarlinksRoute,
} as any)

const StaffSoftwareIdRoute = StaffSoftwareIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffSoftwareRoute,
} as any)

const StaffSettingsPersonsRoute = StaffSettingsPersonsImport.update({
  id: '/settings/persons',
  path: '/settings/persons',
  getParentRoute: () => StaffRoute,
} as any)

const StaffSettingsPermissionAndRolesRoute =
  StaffSettingsPermissionAndRolesImport.update({
    id: '/settings/permission-and-roles',
    path: '/settings/permission-and-roles',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffSettingsContractingCorporationProfileRoute =
  StaffSettingsContractingCorporationProfileImport.update({
    id: '/settings/contracting-corporation-profile',
    path: '/settings/contracting-corporation-profile',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffPlacesIdRoute = StaffPlacesIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffPlacesRoute,
} as any)

const StaffPersonIdRoute = StaffPersonIdImport.update({
  id: '/person/$id',
  path: '/person/$id',
  getParentRoute: () => StaffRoute,
} as any)

const StaffOrganizationIdRoute = StaffOrganizationIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffOrganizationRoute,
} as any)

const StaffNetworksIdRoute = StaffNetworksIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffNetworksRoute,
} as any)

const StaffLicensesIdRoute = StaffLicensesIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffLicensesRoute,
} as any)

const StaffFleetsIdRoute = StaffFleetsIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffFleetsRoute,
} as any)

const StaffEquipmentIdRoute = StaffEquipmentIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffEquipmentRoute,
} as any)

const StaffDevicesIdRoute = StaffDevicesIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffDevicesRoute,
} as any)

const StaffDealDealIdRoute = StaffDealDealIdImport.update({
  id: '/$dealId',
  path: '/$dealId',
  getParentRoute: () => StaffDealRoute,
} as any)

const StaffContractIdRoute = StaffContractIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffContractRoute,
} as any)

const StaffCertificationIdRoute = StaffCertificationIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffCertificationRoute,
} as any)

const StaffBusinessPartnerIdRoute = StaffBusinessPartnerIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffBusinessPartnerRoute,
} as any)

const StaffAppIntegrationsIdRoute = StaffAppIntegrationsIdImport.update({
  id: '/app-integrations/$id',
  path: '/app-integrations/$id',
  getParentRoute: () => StaffRoute,
} as any)

const StacktraceValuesIdRoute = StacktraceValuesIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StacktraceValuesRoute,
} as any)

const StacktraceTestSuitesIdRoute = StacktraceTestSuitesIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StacktraceTestSuitesRoute,
} as any)

const StacktraceTestSetsIdRoute = StacktraceTestSetsIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StacktraceTestSetsRoute,
} as any)

const StacktraceProductsIdRoute = StacktraceProductsIdImport.update({
  id: '/products/$id',
  path: '/products/$id',
  getParentRoute: () => StacktraceRoute,
} as any)

const StacktraceProductionProductionIdRoute =
  StacktraceProductionProductionIdImport.update({
    id: '/production/$productionId',
    path: '/production/$productionId',
    getParentRoute: () => StacktraceRoute,
  } as any)

const StacktraceProductRoadmapRoadmapIdRoute =
  StacktraceProductRoadmapRoadmapIdImport.update({
    id: '/$roadmapId',
    path: '/$roadmapId',
    getParentRoute: () => StacktraceProductRoadmapRoute,
  } as any)

const StacktraceIssuesIdRoute = StacktraceIssuesIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StacktraceIssuesRoute,
} as any)

const StacktraceDevelopmentTicketsTicketIdRoute =
  StacktraceDevelopmentTicketsTicketIdImport.update({
    id: '/development-tickets/$ticketId',
    path: '/development-tickets/$ticketId',
    getParentRoute: () => StacktraceRoute,
  } as any)

const Oauth2LogoutIndexRoute = Oauth2LogoutIndexImport.update({
  id: '/oauth2/logout/',
  path: '/oauth2/logout/',
  getParentRoute: () => rootRoute,
} as any)

const Oauth2LoginIndexRoute = Oauth2LoginIndexImport.update({
  id: '/oauth2/login/',
  path: '/oauth2/login/',
  getParentRoute: () => rootRoute,
} as any)

const Oauth2ErrorIndexRoute = Oauth2ErrorIndexImport.update({
  id: '/oauth2/error/',
  path: '/oauth2/error/',
  getParentRoute: () => rootRoute,
} as any)

const Oauth2ConsentIndexRoute = Oauth2ConsentIndexImport.update({
  id: '/oauth2/consent/',
  path: '/oauth2/consent/',
  getParentRoute: () => rootRoute,
} as any)

const AuthSignInIndexRoute = AuthSignInIndexImport.update({
  id: '/auth/sign-in/',
  path: '/auth/sign-in/',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/auth/sign-in/index.lazy').then((d) => d.Route),
)

const AuthPasswordResetIndexRoute = AuthPasswordResetIndexImport.update({
  id: '/auth/password-reset/',
  path: '/auth/password-reset/',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/auth/password-reset/index.lazy').then((d) => d.Route),
)

const AccountSsoIndexRoute = AccountSsoIndexImport.update({
  id: '/account/sso/',
  path: '/account/sso/',
  getParentRoute: () => rootRoute,
} as any)

const StaffSettingsIndexRoute = StaffSettingsIndexImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => StaffRoute,
} as any)

const StaffOrganizationIndexRoute = StaffOrganizationIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffOrganizationRoute,
} as any)

const StaffItOperationCoreIndexRoute = StaffItOperationCoreIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffItOperationCoreRoute,
} as any)

const StaffCockpitIndexRoute = StaffCockpitIndexImport.update({
  id: '/cockpit/',
  path: '/cockpit/',
  getParentRoute: () => StaffRoute,
} as any)

const StacktraceTestAssetsIndexRoute = StacktraceTestAssetsIndexImport.update({
  id: '/test-assets/',
  path: '/test-assets/',
  getParentRoute: () => StacktraceRoute,
} as any).lazy(() =>
  import('./routes/_stacktrace/test-assets/index.lazy').then((d) => d.Route),
)

const StacktraceProductsIndexRoute = StacktraceProductsIndexImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => StacktraceRoute,
} as any).lazy(() =>
  import('./routes/_stacktrace/products/index.lazy').then((d) => d.Route),
)

const StacktraceProductionIndexRoute = StacktraceProductionIndexImport.update({
  id: '/production/',
  path: '/production/',
  getParentRoute: () => StacktraceRoute,
} as any).lazy(() =>
  import('./routes/_stacktrace/production/index.lazy').then((d) => d.Route),
)

const StacktraceDevelopmentTicketsIndexRoute =
  StacktraceDevelopmentTicketsIndexImport.update({
    id: '/development-tickets/',
    path: '/development-tickets/',
    getParentRoute: () => StacktraceRoute,
  } as any).lazy(() =>
    import('./routes/_stacktrace/development-tickets/index.lazy').then(
      (d) => d.Route,
    ),
  )

const IndividualIndividualIndexRoute = IndividualIndividualIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => IndividualIndividualRoute,
} as any)

const CockpitMockCockpitMockIndexRoute =
  CockpitMockCockpitMockIndexImport.update({
    id: '/cockpit-mock/',
    path: '/cockpit-mock/',
    getParentRoute: () => CockpitMockRoute,
  } as any)

const ChatChatIndexRoute = ChatChatIndexImport.update({
  id: '/chat/',
  path: '/chat/',
  getParentRoute: () => ChatRoute,
} as any)

const StaffLaborCoreGroupNameLazyRoute =
  StaffLaborCoreGroupNameLazyImport.update({
    id: '/group-name',
    path: '/group-name',
    getParentRoute: () => StaffLaborCoreRoute,
  } as any).lazy(() =>
    import('./routes/_staff/labor-core/group-name.lazy').then((d) => d.Route),
  )

const StaffTimeAndAttendanceLayoutRoute =
  StaffTimeAndAttendanceLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StaffTimeAndAttendanceRoute,
  } as any)

const StaffSupplierListRoute = StaffSupplierListImport.update({
  id: '/_list',
  getParentRoute: () => StaffSupplierRoute,
} as any)

const StaffStorageFilesListRoute = StaffStorageFilesListImport.update({
  id: '/_list',
  getParentRoute: () => StaffStorageFilesRoute,
} as any)

const StaffStarlinksLayoutRoute = StaffStarlinksLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffStarlinksRoute,
} as any)

const StaffSoftwareLayoutRoute = StaffSoftwareLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffSoftwareRoute,
} as any)

const StaffPublicIdsListRoute = StaffPublicIdsListImport.update({
  id: '/_list',
  getParentRoute: () => StaffPublicIdsRoute,
} as any)

const StaffPublicIdsIdRoute = StaffPublicIdsIdImport.update({
  id: '/public-ids/$id',
  path: '/public-ids/$id',
  getParentRoute: () => StaffRoute,
} as any)

const StaffPlacesLayoutRoute = StaffPlacesLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffPlacesRoute,
} as any)

const StaffPeopleListRoute = StaffPeopleListImport.update({
  id: '/_list',
  getParentRoute: () => StaffPeopleRoute,
} as any)

const StaffPayrollLayoutRoute = StaffPayrollLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffPayrollRoute,
} as any)

const StaffPayrollEngineLayoutRoute = StaffPayrollEngineLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffPayrollEngineRoute,
} as any)

const StaffPayrollCoreLayoutRoute = StaffPayrollCoreLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffPayrollCoreRoute,
} as any)

const StaffOrganizationListRoute = StaffOrganizationListImport.update({
  id: '/_list',
  getParentRoute: () => StaffOrganizationRoute,
} as any)

const StaffNetworksLayoutRoute = StaffNetworksLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffNetworksRoute,
} as any)

const StaffMarketplaceStoreRoute = StaffMarketplaceStoreImport.update({
  id: '/_store',
  getParentRoute: () => StaffMarketplaceRoute,
} as any)

const StaffLicensesListRoute = StaffLicensesListImport.update({
  id: '/_list',
  getParentRoute: () => StaffLicensesRoute,
} as any)

const StaffLaborCoreYearEndAdjustmentConfirmationRoute =
  StaffLaborCoreYearEndAdjustmentConfirmationImport.update({
    id: '/year-end-adjustment-confirmation',
    path: '/year-end-adjustment-confirmation',
    getParentRoute: () => StaffLaborCoreRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/labor-core/year-end-adjustment-confirmation.lazy'
    ).then((d) => d.Route),
  )

const StaffLaborCorePersonTargetsRoute =
  StaffLaborCorePersonTargetsImport.update({
    id: '/person-targets',
    path: '/person-targets',
    getParentRoute: () => StaffLaborCoreRoute,
  } as any).lazy(() =>
    import('./routes/_staff/labor-core/person-targets.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffLaborCoreGovernmentApplicationConfirmationRoute =
  StaffLaborCoreGovernmentApplicationConfirmationImport.update({
    id: '/government-application-confirmation',
    path: '/government-application-confirmation',
    getParentRoute: () => StaffLaborCoreRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/labor-core/government-application-confirmation.lazy'
    ).then((d) => d.Route),
  )

const StaffLaborCoreContractTargetsRoute =
  StaffLaborCoreContractTargetsImport.update({
    id: '/contract-targets',
    path: '/contract-targets',
    getParentRoute: () => StaffLaborCoreRoute,
  } as any).lazy(() =>
    import('./routes/_staff/labor-core/contract-targets.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffLaborCoreAnchorDateRoute = StaffLaborCoreAnchorDateImport.update({
  id: '/anchor-date',
  path: '/anchor-date',
  getParentRoute: () => StaffLaborCoreRoute,
} as any).lazy(() =>
  import('./routes/_staff/labor-core/anchor-date.lazy').then((d) => d.Route),
)

const StaffLaborCorePackagesRoute = StaffLaborCorePackagesImport.update({
  id: '/_packages',
  getParentRoute: () => StaffLaborCoreRoute,
} as any)

const StaffItOperationCoreSelfReportConfirmationRoute =
  StaffItOperationCoreSelfReportConfirmationImport.update({
    id: '/self-report-confirmation',
    path: '/self-report-confirmation',
    getParentRoute: () => StaffItOperationCoreRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/it-operation-core/self-report-confirmation.lazy'
    ).then((d) => d.Route),
  )

const StaffItOperationCoreAnchorDateRoute =
  StaffItOperationCoreAnchorDateImport.update({
    id: '/anchor-date',
    path: '/anchor-date',
    getParentRoute: () => StaffItOperationCoreRoute,
  } as any).lazy(() =>
    import('./routes/_staff/it-operation-core/anchor-date.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffItOperationCoreRootRoute = StaffItOperationCoreRootImport.update({
  id: '/_root',
  getParentRoute: () => StaffItOperationCoreRoute,
} as any)

const StaffItOperationCoreDetailRoute = StaffItOperationCoreDetailImport.update(
  {
    id: '/_detail',
    getParentRoute: () => StaffItOperationCoreRoute,
  } as any,
)

const StaffIdsLayoutRoute = StaffIdsLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffIdsRoute,
} as any)

const StaffIdManagementsSplatRoute = StaffIdManagementsSplatImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => StaffIdManagementsRoute,
} as any)

const StaffGaOperationCorePackagesRoute =
  StaffGaOperationCorePackagesImport.update({
    id: '/_packages',
    getParentRoute: () => StaffGaOperationCoreRoute,
  } as any)

const StaffFleetsLayoutRoute = StaffFleetsLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffFleetsRoute,
} as any)

const StaffEquipmentLayoutRoute = StaffEquipmentLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffEquipmentRoute,
} as any)

const StaffDevicesListRoute = StaffDevicesListImport.update({
  id: '/_list',
  getParentRoute: () => StaffDevicesRoute,
} as any)

const StaffDealListRoute = StaffDealListImport.update({
  id: '/_list',
  getParentRoute: () => StaffDealRoute,
} as any)

const StaffContractorCorePersonTargetsRoute =
  StaffContractorCorePersonTargetsImport.update({
    id: '/person-targets',
    path: '/person-targets',
    getParentRoute: () => StaffContractorCoreRoute,
  } as any).lazy(() =>
    import('./routes/_staff/contractor-core/person-targets.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffContractorCoreContractTargetsRoute =
  StaffContractorCoreContractTargetsImport.update({
    id: '/contract-targets',
    path: '/contract-targets',
    getParentRoute: () => StaffContractorCoreRoute,
  } as any).lazy(() =>
    import('./routes/_staff/contractor-core/contract-targets.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffContractorCoreAnchorDateRoute =
  StaffContractorCoreAnchorDateImport.update({
    id: '/anchor-date',
    path: '/anchor-date',
    getParentRoute: () => StaffContractorCoreRoute,
  } as any).lazy(() =>
    import('./routes/_staff/contractor-core/anchor-date.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffContractorCorePackagesRoute =
  StaffContractorCorePackagesImport.update({
    id: '/_packages',
    getParentRoute: () => StaffContractorCoreRoute,
  } as any)

const StaffContractListRoute = StaffContractListImport.update({
  id: '/_list',
  getParentRoute: () => StaffContractRoute,
} as any)

const StaffCertificationListRoute = StaffCertificationListImport.update({
  id: '/_list',
  getParentRoute: () => StaffCertificationRoute,
} as any)

const StaffBusinessPartnerListRoute = StaffBusinessPartnerListImport.update({
  id: '/_list',
  getParentRoute: () => StaffBusinessPartnerRoute,
} as any)

const StaffBusinessOperationEventsListRoute =
  StaffBusinessOperationEventsListImport.update({
    id: '/_list',
    getParentRoute: () => StaffBusinessOperationEventsRoute,
  } as any)

const StaffAttendancesLayoutRoute = StaffAttendancesLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffAttendancesRoute,
} as any)

const StaffAttendanceEngineLayoutRoute =
  StaffAttendanceEngineLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StaffAttendanceEngineRoute,
  } as any)

const StaffAttendanceCoreLayoutRoute = StaffAttendanceCoreLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffAttendanceCoreRoute,
} as any)

const StaffAppsSplatRoute = StaffAppsSplatImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => StaffAppsRoute,
} as any)

const StaffAccessesLayoutRoute = StaffAccessesLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffAccessesRoute,
} as any)

const StacktraceValuesLayoutRoute = StacktraceValuesLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StacktraceValuesRoute,
} as any)

const StacktraceTestSuitesLayoutRoute = StacktraceTestSuitesLayoutImport.update(
  {
    id: '/_layout',
    getParentRoute: () => StacktraceTestSuitesRoute,
  } as any,
)

const StacktraceTestSetsLayoutRoute = StacktraceTestSetsLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StacktraceTestSetsRoute,
} as any)

const StacktraceProductRoadmapLayoutRoute =
  StacktraceProductRoadmapLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StacktraceProductRoadmapRoute,
  } as any)

const StacktraceIssuesLayoutRoute = StacktraceIssuesLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StacktraceIssuesRoute,
} as any)

const IndividualIndividualPortalRoute = IndividualIndividualPortalImport.update(
  {
    id: '/portal',
    path: '/portal',
    getParentRoute: () => IndividualIndividualRoute,
  } as any,
)

const IndividualIndividualProfileRoute =
  IndividualIndividualProfileImport.update({
    id: '/_profile',
    getParentRoute: () => IndividualIndividualRoute,
  } as any)

const StaffPlacesImportCsvRouteRoute = StaffPlacesImportCsvRouteImport.update({
  id: '/places/import-csv',
  path: '/places/import-csv',
  getParentRoute: () => StaffRoute,
} as any)

const StaffItOperationCoreDeviceInventoryRouteRoute =
  StaffItOperationCoreDeviceInventoryRouteImport.update({
    id: '/it-operation-core/device-inventory',
    path: '/it-operation-core/device-inventory',
    getParentRoute: () => StaffRoute,
  } as any)

const StacktraceValuesImportCsvRouteRoute =
  StacktraceValuesImportCsvRouteImport.update({
    id: '/values/import-csv',
    path: '/values/import-csv',
    getParentRoute: () => StacktraceRoute,
  } as any)

const StacktraceIssuesImportCsvRouteRoute =
  StacktraceIssuesImportCsvRouteImport.update({
    id: '/issues/import-csv',
    path: '/issues/import-csv',
    getParentRoute: () => StacktraceRoute,
  } as any)

const StacktraceDevelopmentTicketsImportCsvRouteRoute =
  StacktraceDevelopmentTicketsImportCsvRouteImport.update({
    id: '/development-tickets/import-csv',
    path: '/development-tickets/import-csv',
    getParentRoute: () => StacktraceRoute,
  } as any)

const StaffStorageFilesFoldersIdRoute = StaffStorageFilesFoldersIdImport.update(
  {
    id: '/folders/$id',
    path: '/folders/$id',
    getParentRoute: () => StaffStorageFilesRoute,
  } as any,
)

const StaffStorageFilesFilesIdRoute = StaffStorageFilesFilesIdImport.update({
  id: '/files/$id',
  path: '/files/$id',
  getParentRoute: () => StaffStorageFilesRoute,
} as any)

const StaffSoftwareLayoutContractAndCostRoute =
  StaffSoftwareLayoutContractAndCostImport.update({
    id: '/contract-and-cost',
    path: '/contract-and-cost',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any)

const StaffSoftwareLayoutAlertsRoute = StaffSoftwareLayoutAlertsImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => StaffSoftwareLayoutRoute,
} as any)

const StaffPersonAlumniIdRoute = StaffPersonAlumniIdImport.update({
  id: '/person/alumni/$id',
  path: '/person/alumni/$id',
  getParentRoute: () => StaffRoute,
} as any)

const StaffPayrollLayoutContractAndCostRoute =
  StaffPayrollLayoutContractAndCostImport.update({
    id: '/contract-and-cost',
    path: '/contract-and-cost',
    getParentRoute: () => StaffPayrollLayoutRoute,
  } as any)

const StaffMarketplaceSentOrdersOrderIdRoute =
  StaffMarketplaceSentOrdersOrderIdImport.update({
    id: '/sent-orders/$orderId',
    path: '/sent-orders/$orderId',
    getParentRoute: () => StaffMarketplaceRoute,
  } as any)

const StaffIdsGroupIdIdRoute = StaffIdsGroupIdIdImport.update({
  id: '/group-id/$id',
  path: '/group-id/$id',
  getParentRoute: () => StaffIdsRoute,
} as any)

const StaffEquipmentItemsIdRoute = StaffEquipmentItemsIdImport.update({
  id: '/items/$id',
  path: '/items/$id',
  getParentRoute: () => StaffEquipmentRoute,
} as any)

const StaffDevicesListContractAndCostRoute =
  StaffDevicesListContractAndCostImport.update({
    id: '/contract-and-cost',
    path: '/contract-and-cost',
    getParentRoute: () => StaffDevicesListRoute,
  } as any)

const StaffDeviceCatalogDraftIdRoute = StaffDeviceCatalogDraftIdImport.update({
  id: '/device-catalog/draft/$id',
  path: '/device-catalog/draft/$id',
  getParentRoute: () => StaffRoute,
} as any)

const StaffDeviceCatalogActiveIdRoute = StaffDeviceCatalogActiveIdImport.update(
  {
    id: '/device-catalog/active/$id',
    path: '/device-catalog/active/$id',
    getParentRoute: () => StaffRoute,
  } as any,
)

const StaffCertificationSpecialtyCertificationIdRoute =
  StaffCertificationSpecialtyCertificationIdImport.update({
    id: '/specialty-certification/$id',
    path: '/specialty-certification/$id',
    getParentRoute: () => StaffCertificationRoute,
  } as any)

const StaffCertificationHandlingCertificationIdRoute =
  StaffCertificationHandlingCertificationIdImport.update({
    id: '/handling-certification/$id',
    path: '/handling-certification/$id',
    getParentRoute: () => StaffCertificationRoute,
  } as any)

const IndividualIndividualProfileMyProfileRoute =
  IndividualIndividualProfileMyProfileImport.update({
    id: '/my-profile',
    path: '/my-profile',
    getParentRoute: () => IndividualIndividualProfileRoute,
  } as any)

const AuthSignInErrorIndexRoute = AuthSignInErrorIndexImport.update({
  id: '/auth/sign-in/error/',
  path: '/auth/sign-in/error/',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/auth/sign-in/error/index.lazy').then((d) => d.Route),
)

const AuthInvitationInvitationCodeIndexRoute =
  AuthInvitationInvitationCodeIndexImport.update({
    id: '/auth/invitation/$invitationCode/',
    path: '/auth/invitation/$invitationCode/',
    getParentRoute: () => rootRoute,
  } as any).lazy(() =>
    import('./routes/auth/invitation/$invitationCode/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffTimeAndAttendanceLayoutIndexRoute =
  StaffTimeAndAttendanceLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffTimeAndAttendanceLayoutRoute,
  } as any)

const StaffSupplierListIndexRoute = StaffSupplierListIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffSupplierListRoute,
} as any).lazy(() =>
  import('./routes/_staff/supplier/_list/index.lazy').then((d) => d.Route),
)

const StaffStorageFilesListIndexRoute = StaffStorageFilesListIndexImport.update(
  {
    id: '/',
    path: '/',
    getParentRoute: () => StaffStorageFilesListRoute,
  } as any,
)

const StaffStarlinksLayoutIndexRoute = StaffStarlinksLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffStarlinksLayoutRoute,
} as any).lazy(() =>
  import('./routes/_staff/starlinks/_layout/index.lazy').then((d) => d.Route),
)

const StaffSoftwareAddIndexRoute = StaffSoftwareAddIndexImport.update({
  id: '/add/',
  path: '/add/',
  getParentRoute: () => StaffSoftwareRoute,
} as any)

const StaffSettingsPersonsIndexRoute = StaffSettingsPersonsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffSettingsPersonsRoute,
} as any)

const StaffSettingsPermissionAndRolesIndexRoute =
  StaffSettingsPermissionAndRolesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffSettingsPermissionAndRolesRoute,
  } as any)

const StaffSettingsContractingCorporationProfileIndexRoute =
  StaffSettingsContractingCorporationProfileIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffSettingsContractingCorporationProfileRoute,
  } as any)

const StaffPublicIdsAddIndexRoute = StaffPublicIdsAddIndexImport.update({
  id: '/add/',
  path: '/add/',
  getParentRoute: () => StaffPublicIdsRoute,
} as any)

const StaffPublicIdsListIndexRoute = StaffPublicIdsListIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffPublicIdsListRoute,
} as any)

const StaffPublicIdsIdIndexRoute = StaffPublicIdsIdIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffPublicIdsIdRoute,
} as any)

const StaffPlacesAddIndexRoute = StaffPlacesAddIndexImport.update({
  id: '/add/',
  path: '/add/',
  getParentRoute: () => StaffPlacesRoute,
} as any)

const StaffPlacesAddSelectIndexRoute = StaffPlacesAddSelectIndexImport.update({
  id: '/add-select/',
  path: '/add-select/',
  getParentRoute: () => StaffPlacesRoute,
} as any)

const StaffPlacesLayoutIndexRoute = StaffPlacesLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffPlacesLayoutRoute,
} as any).lazy(() =>
  import('./routes/_staff/places/_layout/index.lazy').then((d) => d.Route),
)

const StaffPersonExternalHrSaasIndexRoute =
  StaffPersonExternalHrSaasIndexImport.update({
    id: '/person/external-hr-saas/',
    path: '/person/external-hr-saas/',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffPersonAddIndexRoute = StaffPersonAddIndexImport.update({
  id: '/person/add/',
  path: '/person/add/',
  getParentRoute: () => StaffRoute,
} as any)

const StaffPersonAddPersonCertificationIndexRoute =
  StaffPersonAddPersonCertificationIndexImport.update({
    id: '/person/add-person-certification/',
    path: '/person/add-person-certification/',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffPayrollLayoutIndexRoute = StaffPayrollLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffPayrollLayoutRoute,
} as any)

const StaffPayrollEngineLayoutIndexRoute =
  StaffPayrollEngineLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffPayrollEngineLayoutRoute,
  } as any)

const StaffPayrollCoreLayoutIndexRoute =
  StaffPayrollCoreLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffPayrollCoreLayoutRoute,
  } as any)

const StaffOrganizationPlanIndexRoute = StaffOrganizationPlanIndexImport.update(
  {
    id: '/plan/',
    path: '/plan/',
    getParentRoute: () => StaffOrganizationRoute,
  } as any,
)

const StaffNetworksAddIndexRoute = StaffNetworksAddIndexImport.update({
  id: '/add/',
  path: '/add/',
  getParentRoute: () => StaffNetworksRoute,
} as any)

const StaffNetworksLayoutIndexRoute = StaffNetworksLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffNetworksLayoutRoute,
} as any).lazy(() =>
  import('./routes/_staff/networks/_layout/index.lazy').then((d) => d.Route),
)

const StaffMarketplaceUnavailableIndexRoute =
  StaffMarketplaceUnavailableIndexImport.update({
    id: '/unavailable/',
    path: '/unavailable/',
    getParentRoute: () => StaffMarketplaceRoute,
  } as any)

const StaffMarketplaceCartIndexRoute = StaffMarketplaceCartIndexImport.update({
  id: '/cart/',
  path: '/cart/',
  getParentRoute: () => StaffMarketplaceRoute,
} as any)

const StaffLicensesAddIndexRoute = StaffLicensesAddIndexImport.update({
  id: '/add/',
  path: '/add/',
  getParentRoute: () => StaffLicensesRoute,
} as any)

const StaffLaborCorePackagesIndexRoute =
  StaffLaborCorePackagesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffLaborCorePackagesRoute,
  } as any).lazy(() =>
    import('./routes/_staff/labor-core/_packages/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffItOperationCorePersonTargetsIndexRoute =
  StaffItOperationCorePersonTargetsIndexImport.update({
    id: '/person-targets/',
    path: '/person-targets/',
    getParentRoute: () => StaffItOperationCoreRoute,
  } as any).lazy(() =>
    import('./routes/_staff/it-operation-core/person-targets/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffItOperationCoreDeviceTargetsIndexRoute =
  StaffItOperationCoreDeviceTargetsIndexImport.update({
    id: '/device-targets/',
    path: '/device-targets/',
    getParentRoute: () => StaffItOperationCoreRoute,
  } as any).lazy(() =>
    import('./routes/_staff/it-operation-core/device-targets/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffIdsLayoutIndexRoute = StaffIdsLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffIdsLayoutRoute,
} as any).lazy(() =>
  import('./routes/_staff/ids/_layout/index.lazy').then((d) => d.Route),
)

const StaffGaOperationCorePackagesIndexRoute =
  StaffGaOperationCorePackagesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffGaOperationCorePackagesRoute,
  } as any).lazy(() =>
    import('./routes/_staff/ga-operation-core/_packages/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffFleetsAddIndexRoute = StaffFleetsAddIndexImport.update({
  id: '/add/',
  path: '/add/',
  getParentRoute: () => StaffFleetsRoute,
} as any)

const StaffFleetsAddSelectIndexRoute = StaffFleetsAddSelectIndexImport.update({
  id: '/add-select/',
  path: '/add-select/',
  getParentRoute: () => StaffFleetsRoute,
} as any)

const StaffEquipmentImportCsvIndexRoute =
  StaffEquipmentImportCsvIndexImport.update({
    id: '/import-csv/',
    path: '/import-csv/',
    getParentRoute: () => StaffEquipmentRoute,
  } as any)

const StaffEquipmentAddIndexRoute = StaffEquipmentAddIndexImport.update({
  id: '/add/',
  path: '/add/',
  getParentRoute: () => StaffEquipmentRoute,
} as any)

const StaffEquipmentAddSelectIndexRoute =
  StaffEquipmentAddSelectIndexImport.update({
    id: '/add-select/',
    path: '/add-select/',
    getParentRoute: () => StaffEquipmentRoute,
  } as any)

const StaffEquipmentLayoutIndexRoute = StaffEquipmentLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffEquipmentLayoutRoute,
} as any).lazy(() =>
  import('./routes/_staff/equipment/_layout/index.lazy').then((d) => d.Route),
)

const StaffDevicesExternalItSaasIndexRoute =
  StaffDevicesExternalItSaasIndexImport.update({
    id: '/external-it-saas/',
    path: '/external-it-saas/',
    getParentRoute: () => StaffDevicesRoute,
  } as any)

const StaffDevicesAddIndexRoute = StaffDevicesAddIndexImport.update({
  id: '/add/',
  path: '/add/',
  getParentRoute: () => StaffDevicesRoute,
} as any)

const StaffDeviceCatalogAddIndexRoute = StaffDeviceCatalogAddIndexImport.update(
  {
    id: '/device-catalog/add/',
    path: '/device-catalog/add/',
    getParentRoute: () => StaffRoute,
  } as any,
)

const StaffDealAddIndexRoute = StaffDealAddIndexImport.update({
  id: '/add/',
  path: '/add/',
  getParentRoute: () => StaffDealRoute,
} as any).lazy(() =>
  import('./routes/_staff/deal/add/index.lazy').then((d) => d.Route),
)

const StaffDealListIndexRoute = StaffDealListIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffDealListRoute,
} as any).lazy(() =>
  import('./routes/_staff/deal/_list/index.lazy').then((d) => d.Route),
)

const StaffContractorCorePackagesIndexRoute =
  StaffContractorCorePackagesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffContractorCorePackagesRoute,
  } as any).lazy(() =>
    import('./routes/_staff/contractor-core/_packages/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffContractAddIndexRoute = StaffContractAddIndexImport.update({
  id: '/add/',
  path: '/add/',
  getParentRoute: () => StaffContractRoute,
} as any)

const StaffContractListIndexRoute = StaffContractListIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffContractListRoute,
} as any).lazy(() =>
  import('./routes/_staff/contract/_list/index.lazy').then((d) => d.Route),
)

const StaffCertificationAddIndexRoute = StaffCertificationAddIndexImport.update(
  {
    id: '/add/',
    path: '/add/',
    getParentRoute: () => StaffCertificationRoute,
  } as any,
)

const StaffBusinessPartnerAddIndexRoute =
  StaffBusinessPartnerAddIndexImport.update({
    id: '/add/',
    path: '/add/',
    getParentRoute: () => StaffBusinessPartnerRoute,
  } as any)

const StaffBusinessPartnerListIndexRoute =
  StaffBusinessPartnerListIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffBusinessPartnerListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/business-partner/_list/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffBusinessOperationEventsListIndexRoute =
  StaffBusinessOperationEventsListIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffBusinessOperationEventsListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/business-operation-events/_list/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffBusinessOperationEventsEventInstanceIdIndexRoute =
  StaffBusinessOperationEventsEventInstanceIdIndexImport.update({
    id: '/$eventInstanceId/',
    path: '/$eventInstanceId/',
    getParentRoute: () => StaffBusinessOperationEventsRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/business-operation-events/$eventInstanceId/index.lazy'
    ).then((d) => d.Route),
  )

const StaffAttendancesLayoutIndexRoute =
  StaffAttendancesLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffAttendancesLayoutRoute,
  } as any)

const StaffAttendanceEngineLayoutIndexRoute =
  StaffAttendanceEngineLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffAttendanceEngineLayoutRoute,
  } as any)

const StaffAttendanceCoreLayoutIndexRoute =
  StaffAttendanceCoreLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffAttendanceCoreLayoutRoute,
  } as any)

const StaffAccessesLayoutIndexRoute = StaffAccessesLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffAccessesLayoutRoute,
} as any)

const StacktraceValuesAddIndexRoute = StacktraceValuesAddIndexImport.update({
  id: '/add/',
  path: '/add/',
  getParentRoute: () => StacktraceValuesRoute,
} as any)

const StacktraceValuesAddSelectIndexRoute =
  StacktraceValuesAddSelectIndexImport.update({
    id: '/add-select/',
    path: '/add-select/',
    getParentRoute: () => StacktraceValuesRoute,
  } as any)

const StacktraceValuesLayoutIndexRoute =
  StacktraceValuesLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StacktraceValuesLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_stacktrace/values/_layout/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StacktraceTestSuitesLayoutIndexRoute =
  StacktraceTestSuitesLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StacktraceTestSuitesLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_stacktrace/test-suites/_layout/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StacktraceTestSetsLayoutIndexRoute =
  StacktraceTestSetsLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StacktraceTestSetsLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_stacktrace/test-sets/_layout/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StacktraceProductsAddIndexRoute = StacktraceProductsAddIndexImport.update(
  {
    id: '/products/add/',
    path: '/products/add/',
    getParentRoute: () => StacktraceRoute,
  } as any,
)

const StacktraceProductsAddSelectIndexRoute =
  StacktraceProductsAddSelectIndexImport.update({
    id: '/products/add-select/',
    path: '/products/add-select/',
    getParentRoute: () => StacktraceRoute,
  } as any)

const StacktraceProductRoadmapLayoutIndexRoute =
  StacktraceProductRoadmapLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StacktraceProductRoadmapLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_stacktrace/product-roadmap/_layout/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StacktraceIssuesExternalIntegrationsIndexRoute =
  StacktraceIssuesExternalIntegrationsIndexImport.update({
    id: '/external-integrations/',
    path: '/external-integrations/',
    getParentRoute: () => StacktraceIssuesRoute,
  } as any)

const StacktraceIssuesAddIndexRoute = StacktraceIssuesAddIndexImport.update({
  id: '/add/',
  path: '/add/',
  getParentRoute: () => StacktraceIssuesRoute,
} as any)

const StacktraceIssuesAddSelectIndexRoute =
  StacktraceIssuesAddSelectIndexImport.update({
    id: '/add-select/',
    path: '/add-select/',
    getParentRoute: () => StacktraceIssuesRoute,
  } as any)

const StacktraceIssuesLayoutIndexRoute =
  StacktraceIssuesLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StacktraceIssuesLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_stacktrace/issues/_layout/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StacktraceDevelopmentTicketsExternalIntegrationsIndexRoute =
  StacktraceDevelopmentTicketsExternalIntegrationsIndexImport.update({
    id: '/development-tickets/external-integrations/',
    path: '/development-tickets/external-integrations/',
    getParentRoute: () => StacktraceRoute,
  } as any)

const StacktraceDevelopmentTicketsAddIndexRoute =
  StacktraceDevelopmentTicketsAddIndexImport.update({
    id: '/development-tickets/add/',
    path: '/development-tickets/add/',
    getParentRoute: () => StacktraceRoute,
  } as any)

const StacktraceDevelopmentTicketsAddSelectIndexRoute =
  StacktraceDevelopmentTicketsAddSelectIndexImport.update({
    id: '/development-tickets/add-select/',
    path: '/development-tickets/add-select/',
    getParentRoute: () => StacktraceRoute,
  } as any)

const IndividualIndividualPortalIndexRoute =
  IndividualIndividualPortalIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => IndividualIndividualPortalRoute,
  } as any)

const IdpSsoMockIdpSsoGoogleWorkspaceIndexRoute =
  IdpSsoMockIdpSsoGoogleWorkspaceIndexImport.update({
    id: '/idp-sso/google-workspace/',
    path: '/idp-sso/google-workspace/',
    getParentRoute: () => IdpSsoMockRoute,
  } as any)

const ChatChatNewIndexRoute = ChatChatNewIndexImport.update({
  id: '/chat/new/',
  path: '/chat/new/',
  getParentRoute: () => ChatRoute,
} as any)

const ChatChatSessionIdIndexRoute = ChatChatSessionIdIndexImport.update({
  id: '/chat/$sessionId/',
  path: '/chat/$sessionId/',
  getParentRoute: () => ChatRoute,
} as any)

const StaffSupplierListSettingsRouteLazyRoute =
  StaffSupplierListSettingsRouteLazyImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => StaffSupplierListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/supplier/_list/settings/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPeopleListSettingsRouteLazyRoute =
  StaffPeopleListSettingsRouteLazyImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => StaffPeopleListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/people/_list/settings/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffEquipmentLayoutSettingsRouteLazyRoute =
  StaffEquipmentLayoutSettingsRouteLazyImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => StaffEquipmentLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/equipment/_layout/settings/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffDevicesListSettingsRouteLazyRoute =
  StaffDevicesListSettingsRouteLazyImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => StaffDevicesListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/devices/_list/settings/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffCertificationListSettingsRouteLazyRoute =
  StaffCertificationListSettingsRouteLazyImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => StaffCertificationListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/certification/_list/settings/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffSoftwareLayoutIndexRouteLazyRoute =
  StaffSoftwareLayoutIndexRouteLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/software/_layout/index/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPeopleListIndexRouteLazyRoute =
  StaffPeopleListIndexRouteLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffPeopleListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/people/_list/index/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffDevicesListIndexRouteLazyRoute =
  StaffDevicesListIndexRouteLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffDevicesListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/devices/_list/index/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffUsersUserIdLayoutRoute = StaffUsersUserIdLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffUsersUserIdRoute,
} as any)

const StaffSupplierSupplierIdLayoutRoute =
  StaffSupplierSupplierIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StaffSupplierSupplierIdRoute,
  } as any)

const StaffStarlinksIdLayoutRoute = StaffStarlinksIdLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffStarlinksIdRoute,
} as any)

const StaffSoftwareLayoutIntegrationsRoute =
  StaffSoftwareLayoutIntegrationsImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any)

const StaffSoftwareIdIdRoute = StaffSoftwareIdIdImport.update({
  id: '/_$id',
  getParentRoute: () => StaffSoftwareIdRoute,
} as any)

const StaffSettingsPersonsListRoute = StaffSettingsPersonsListImport.update({
  id: '/_list',
  getParentRoute: () => StaffSettingsPersonsRoute,
} as any)

const StaffSettingsPermissionAndRolesListRoute =
  StaffSettingsPermissionAndRolesListImport.update({
    id: '/_list',
    getParentRoute: () => StaffSettingsPermissionAndRolesRoute,
  } as any)

const StaffSettingsPermissionAndRolesFormRoute =
  StaffSettingsPermissionAndRolesFormImport.update({
    id: '/_form',
    getParentRoute: () => StaffSettingsPermissionAndRolesRoute,
  } as any)

const StaffSettingsPermissionAndRolesDetailRoute =
  StaffSettingsPermissionAndRolesDetailImport.update({
    id: '/_detail',
    getParentRoute: () => StaffSettingsPermissionAndRolesRoute,
  } as any)

const StaffSettingsContractingCorporationProfileLayoutRoute =
  StaffSettingsContractingCorporationProfileLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StaffSettingsContractingCorporationProfileRoute,
  } as any)

const StaffPlacesLayoutOverviewRoute = StaffPlacesLayoutOverviewImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => StaffPlacesLayoutRoute,
} as any).lazy(() =>
  import('./routes/_staff/places/_layout/overview.lazy').then((d) => d.Route),
)

const StaffPlacesIdLayoutRoute = StaffPlacesIdLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffPlacesIdRoute,
} as any)

const StaffPersonIdProfileRoute = StaffPersonIdProfileImport.update({
  id: '/_profile',
  getParentRoute: () => StaffPersonIdRoute,
} as any)

const StaffPeopleListSalaryAndPaymentRoute =
  StaffPeopleListSalaryAndPaymentImport.update({
    id: '/salary-and-payment',
    path: '/salary-and-payment',
    getParentRoute: () => StaffPeopleListRoute,
  } as any)

const StaffPeopleListRuleAndPolicyRoute =
  StaffPeopleListRuleAndPolicyImport.update({
    id: '/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffPeopleListRoute,
  } as any)

const StaffPeopleListPeopleGraphRoute = StaffPeopleListPeopleGraphImport.update(
  {
    id: '/people-graph',
    path: '/people-graph',
    getParentRoute: () => StaffPeopleListRoute,
  } as any,
)

const StaffPeopleListCommunityRoute = StaffPeopleListCommunityImport.update({
  id: '/community',
  path: '/community',
  getParentRoute: () => StaffPeopleListRoute,
} as any)

const StaffPeopleListAlertsRoute = StaffPeopleListAlertsImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => StaffPeopleListRoute,
} as any)

const StaffOrganizationIdLayoutRoute = StaffOrganizationIdLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffOrganizationIdRoute,
} as any)

const StaffNetworksIdLayoutRoute = StaffNetworksIdLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffNetworksIdRoute,
} as any)

const StaffLicensesIdProfileRoute = StaffLicensesIdProfileImport.update({
  id: '/_profile',
  getParentRoute: () => StaffLicensesIdRoute,
} as any)

const StaffLaborCoreSettingsEgovCallbackRoute =
  StaffLaborCoreSettingsEgovCallbackImport.update({
    id: '/settings/egov-callback',
    path: '/settings/egov-callback',
    getParentRoute: () => StaffLaborCoreRoute,
  } as any)

const StaffLaborCorePackagesSettingsRoute =
  StaffLaborCorePackagesSettingsImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => StaffLaborCorePackagesRoute,
  } as any)

const StaffItOperationCoreDeviceInventoryDetailRoute =
  StaffItOperationCoreDeviceInventoryDetailImport.update({
    id: '/detail',
    path: '/detail',
    getParentRoute: () => StaffItOperationCoreDeviceInventoryRouteRoute,
  } as any)

const StaffItOperationCoreDeviceInventoryDataRoute =
  StaffItOperationCoreDeviceInventoryDataImport.update({
    id: '/data',
    path: '/data',
    getParentRoute: () => StaffItOperationCoreDeviceInventoryRouteRoute,
  } as any)

const StaffFleetsLayoutSettingsRoute = StaffFleetsLayoutSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => StaffFleetsLayoutRoute,
} as any)

const StaffFleetsLayoutRuleAndPolicyRoute =
  StaffFleetsLayoutRuleAndPolicyImport.update({
    id: '/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffFleetsLayoutRoute,
  } as any)

const StaffFleetsLayoutOverviewRoute = StaffFleetsLayoutOverviewImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => StaffFleetsLayoutRoute,
} as any)

const StaffFleetsLayoutAlertsRoute = StaffFleetsLayoutAlertsImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => StaffFleetsLayoutRoute,
} as any)

const StaffFleetsIdLayoutRoute = StaffFleetsIdLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffFleetsIdRoute,
} as any)

const StaffEquipmentIdLayoutRoute = StaffEquipmentIdLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffEquipmentIdRoute,
} as any)

const StaffDevicesListRuleAndPolicyRoute =
  StaffDevicesListRuleAndPolicyImport.update({
    id: '/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffDevicesListRoute,
  } as any)

const StaffDevicesListOperationActivityRoute =
  StaffDevicesListOperationActivityImport.update({
    id: '/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffDevicesListRoute,
  } as any)

const StaffDevicesListAlertsRoute = StaffDevicesListAlertsImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => StaffDevicesListRoute,
} as any)

const StaffDevicesIdLayoutRoute = StaffDevicesIdLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffDevicesIdRoute,
} as any)

const StaffDealDealIdLayoutRoute = StaffDealDealIdLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffDealDealIdRoute,
} as any)

const StaffContractIdLayoutRoute = StaffContractIdLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffContractIdRoute,
} as any)

const StaffCertificationIdLayoutRoute = StaffCertificationIdLayoutImport.update(
  {
    id: '/_layout',
    getParentRoute: () => StaffCertificationIdRoute,
  } as any,
)

const StaffBusinessPartnerIdLayoutRoute =
  StaffBusinessPartnerIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StaffBusinessPartnerIdRoute,
  } as any)

const StaffBusinessOperationEventsListSettingsRoute =
  StaffBusinessOperationEventsListSettingsImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => StaffBusinessOperationEventsListRoute,
  } as any)

const StaffBusinessOperationEventsListRuleAndPolicyRoute =
  StaffBusinessOperationEventsListRuleAndPolicyImport.update({
    id: '/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffBusinessOperationEventsListRoute,
  } as any)

const StaffBusinessOperationEventsListOverviewRoute =
  StaffBusinessOperationEventsListOverviewImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => StaffBusinessOperationEventsListRoute,
  } as any)

const StaffBusinessOperationEventsListOperationActivityRoute =
  StaffBusinessOperationEventsListOperationActivityImport.update({
    id: '/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffBusinessOperationEventsListRoute,
  } as any)

const StaffBusinessOperationEventsListConfigRoute =
  StaffBusinessOperationEventsListConfigImport.update({
    id: '/config',
    path: '/config',
    getParentRoute: () => StaffBusinessOperationEventsListRoute,
  } as any)

const StaffBusinessOperationEventsListArchiveRoute =
  StaffBusinessOperationEventsListArchiveImport.update({
    id: '/archive',
    path: '/archive',
    getParentRoute: () => StaffBusinessOperationEventsListRoute,
  } as any)

const StaffAppIntegrationsIdIdRoute = StaffAppIntegrationsIdIdImport.update({
  id: '/_$id',
  getParentRoute: () => StaffAppIntegrationsIdRoute,
} as any)

const StacktraceValuesIdLayoutRoute = StacktraceValuesIdLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StacktraceValuesIdRoute,
} as any)

const StacktraceTestSuitesIdLayoutRoute =
  StacktraceTestSuitesIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StacktraceTestSuitesIdRoute,
  } as any)

const StacktraceTestSetsIdLayoutRoute = StacktraceTestSetsIdLayoutImport.update(
  {
    id: '/_layout',
    getParentRoute: () => StacktraceTestSetsIdRoute,
  } as any,
)

const StacktraceProductsIdLayoutRoute = StacktraceProductsIdLayoutImport.update(
  {
    id: '/_layout',
    getParentRoute: () => StacktraceProductsIdRoute,
  } as any,
)

const StacktraceProductionProductionIdLayoutRoute =
  StacktraceProductionProductionIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StacktraceProductionProductionIdRoute,
  } as any)

const StacktraceProductRoadmapRoadmapIdLayoutRoute =
  StacktraceProductRoadmapRoadmapIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StacktraceProductRoadmapRoadmapIdRoute,
  } as any)

const StacktraceIssuesIdLayoutRoute = StacktraceIssuesIdLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StacktraceIssuesIdRoute,
} as any)

const StacktraceDevelopmentTicketsTicketIdLayoutRoute =
  StacktraceDevelopmentTicketsTicketIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StacktraceDevelopmentTicketsTicketIdRoute,
  } as any)

const StaffSoftwareLayoutPeopleRouteRoute =
  StaffSoftwareLayoutPeopleRouteImport.update({
    id: '/people',
    path: '/people',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any)

const StaffSoftwareIdImportCsvRouteRoute =
  StaffSoftwareIdImportCsvRouteImport.update({
    id: '/$id/import-csv',
    path: '/$id/import-csv',
    getParentRoute: () => StaffSoftwareRoute,
  } as any).lazy(() =>
    import('./routes/_staff/software/$id/import-csv/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPublicIdsImportCsvPublicIdTypeRouteRoute =
  StaffPublicIdsImportCsvPublicIdTypeRouteImport.update({
    id: '/import-csv/$publicIdType',
    path: '/import-csv/$publicIdType',
    getParentRoute: () => StaffPublicIdsRoute,
  } as any)

const StaffPlacesLayoutSettingsRouteRoute =
  StaffPlacesLayoutSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => StaffPlacesLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/places/_layout/settings/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPersonImportCsvWorkerTypeRouteRoute =
  StaffPersonImportCsvWorkerTypeRouteImport.update({
    id: '/person/import-csv/$workerType',
    path: '/person/import-csv/$workerType',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffItOperationCoreRootPackagesRouteRoute =
  StaffItOperationCoreRootPackagesRouteImport.update({
    id: '/packages',
    path: '/packages',
    getParentRoute: () => StaffItOperationCoreRootRoute,
  } as any)

const StaffItOperationCoreRootInHousePackagesRouteRoute =
  StaffItOperationCoreRootInHousePackagesRouteImport.update({
    id: '/in-house-packages',
    path: '/in-house-packages',
    getParentRoute: () => StaffItOperationCoreRootRoute,
  } as any)

const StaffDevicesImportCsvDeviceTypeRouteRoute =
  StaffDevicesImportCsvDeviceTypeRouteImport.update({
    id: '/import-csv/$deviceType',
    path: '/import-csv/$deviceType',
    getParentRoute: () => StaffDevicesRoute,
  } as any)

const StaffBusinessPartnerImportCsvIndividualRouteRoute =
  StaffBusinessPartnerImportCsvIndividualRouteImport.update({
    id: '/import-csv/individual',
    path: '/import-csv/individual',
    getParentRoute: () => StaffBusinessPartnerRoute,
  } as any)

const StaffBusinessPartnerImportCsvCorporationRouteRoute =
  StaffBusinessPartnerImportCsvCorporationRouteImport.update({
    id: '/import-csv/corporation',
    path: '/import-csv/corporation',
    getParentRoute: () => StaffBusinessPartnerRoute,
  } as any)

const StaffAppIntegrationsImportCsvIdRouteRoute =
  StaffAppIntegrationsImportCsvIdRouteImport.update({
    id: '/app-integrations/import-csv/$id',
    path: '/app-integrations/import-csv/$id',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffLicensesListIndexRouteRoute =
  StaffLicensesListIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffLicensesListRoute,
  } as any)

const StaffCertificationListIndexRouteRoute =
  StaffCertificationListIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffCertificationListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/certification/_list/index/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffSoftwareIdIdContractAndCostRoute =
  StaffSoftwareIdIdContractAndCostImport.update({
    id: '/contract-and-cost',
    path: '/contract-and-cost',
    getParentRoute: () => StaffSoftwareIdIdRoute,
  } as any)

const StaffSettingsDataConnectorOutboundDataPipelineRoute =
  StaffSettingsDataConnectorOutboundDataPipelineImport.update({
    id: '/settings/data-connector/outbound/data-pipeline',
    path: '/settings/data-connector/outbound/data-pipeline',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffSettingsDataConnectorInboundDataPipelineRoute =
  StaffSettingsDataConnectorInboundDataPipelineImport.update({
    id: '/settings/data-connector/inbound/data-pipeline',
    path: '/settings/data-connector/inbound/data-pipeline',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffSettingsDataConnectorInboundAggregateDataPipelineRoute =
  StaffSettingsDataConnectorInboundAggregateDataPipelineImport.update({
    id: '/settings/data-connector/inbound/aggregate-data-pipeline',
    path: '/settings/data-connector/inbound/aggregate-data-pipeline',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffPayrollEngineLayoutPayrollStructuresStructureIdRoute =
  StaffPayrollEngineLayoutPayrollStructuresStructureIdImport.update({
    id: '/payroll-structures/$structureId',
    path: '/payroll-structures/$structureId',
    getParentRoute: () => StaffPayrollEngineLayoutRoute,
  } as any)

const StaffLicensesIdServicePlansLicenseServiceIdRoute =
  StaffLicensesIdServicePlansLicenseServiceIdImport.update({
    id: '/service-plans/$licenseServiceId',
    path: '/service-plans/$licenseServiceId',
    getParentRoute: () => StaffLicensesIdRoute,
  } as any)

const StaffItOperationCoreDetailOperationInstancesInstanceIdRoute =
  StaffItOperationCoreDetailOperationInstancesInstanceIdImport.update({
    id: '/operation-instances/$instanceId',
    path: '/operation-instances/$instanceId',
    getParentRoute: () => StaffItOperationCoreDetailRoute,
  } as any)

const StaffBusinessPartnerIdLayoutBpRoleInfoRoute =
  StaffBusinessPartnerIdLayoutBpRoleInfoImport.update({
    id: '/bp-role-info',
    path: '/bp-role-info',
    getParentRoute: () => StaffBusinessPartnerIdLayoutRoute,
  } as any)

const StaffAttendanceEngineLayoutAttendanceStructuresStructureIdRoute =
  StaffAttendanceEngineLayoutAttendanceStructuresStructureIdImport.update({
    id: '/attendance-structures/$structureId',
    path: '/attendance-structures/$structureId',
    getParentRoute: () => StaffAttendanceEngineLayoutRoute,
  } as any)

const StacktraceTestSuitesIdLayoutTestReviewRoute =
  StacktraceTestSuitesIdLayoutTestReviewImport.update({
    id: '/test-review',
    path: '/test-review',
    getParentRoute: () => StacktraceTestSuitesIdLayoutRoute,
  } as any)

const StacktraceTestSuitesIdLayoutTestPlanRoute =
  StacktraceTestSuitesIdLayoutTestPlanImport.update({
    id: '/test-plan',
    path: '/test-plan',
    getParentRoute: () => StacktraceTestSuitesIdLayoutRoute,
  } as any)

const StacktraceProductsIdScopeNodeIdRoute =
  StacktraceProductsIdScopeNodeIdImport.update({
    id: '/scope/$nodeId',
    path: '/scope/$nodeId',
    getParentRoute: () => StacktraceProductsIdRoute,
  } as any)

const StaffLicensesIdProfileIndexLazyRoute =
  StaffLicensesIdProfileIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffLicensesIdProfileRoute,
  } as any).lazy(() =>
    import('./routes/_staff/licenses/$id/_profile/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffEquipmentIdLayoutIndexLazyRoute =
  StaffEquipmentIdLayoutIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffEquipmentIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/equipment/$id/_layout/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffTimeAndAttendanceLayoutAttendanceLinksIndexRoute =
  StaffTimeAndAttendanceLayoutAttendanceLinksIndexImport.update({
    id: '/attendance-links/',
    path: '/attendance-links/',
    getParentRoute: () => StaffTimeAndAttendanceLayoutRoute,
  } as any)

const StaffSupplierListSettingsIndexRoute =
  StaffSupplierListSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffSupplierListSettingsRouteLazyRoute,
  } as any)

const StaffStorageFilesListSettingsIndexRoute =
  StaffStorageFilesListSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => StaffStorageFilesListRoute,
  } as any)

const StaffStorageFilesListFoldersIndexRoute =
  StaffStorageFilesListFoldersIndexImport.update({
    id: '/folders/',
    path: '/folders/',
    getParentRoute: () => StaffStorageFilesListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/storage-files/_list/folders/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffStorageFilesListFilesIndexRoute =
  StaffStorageFilesListFilesIndexImport.update({
    id: '/files/',
    path: '/files/',
    getParentRoute: () => StaffStorageFilesListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/storage-files/_list/files/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffStarlinksLayoutUserTerminalsIndexRoute =
  StaffStarlinksLayoutUserTerminalsIndexImport.update({
    id: '/user-terminals/',
    path: '/user-terminals/',
    getParentRoute: () => StaffStarlinksLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/starlinks/_layout/user-terminals/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffStarlinksLayoutAlertsIndexRoute =
  StaffStarlinksLayoutAlertsIndexImport.update({
    id: '/alerts/',
    path: '/alerts/',
    getParentRoute: () => StaffStarlinksLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/starlinks/_layout/alerts/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffSoftwareAddTypeIndexRoute = StaffSoftwareAddTypeIndexImport.update({
  id: '/add/$type/',
  path: '/add/$type/',
  getParentRoute: () => StaffSoftwareRoute,
} as any)

const StaffSoftwareLayoutSettingsIndexRoute =
  StaffSoftwareLayoutSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any)

const StaffSoftwareLayoutRuleAndPolicyIndexRoute =
  StaffSoftwareLayoutRuleAndPolicyIndexImport.update({
    id: '/rule-and-policy/',
    path: '/rule-and-policy/',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any)

const StaffSoftwareLayoutRegistryIndexRoute =
  StaffSoftwareLayoutRegistryIndexImport.update({
    id: '/registry/',
    path: '/registry/',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/software/_layout/registry/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffSoftwareLayoutPeopleIndexRoute =
  StaffSoftwareLayoutPeopleIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffSoftwareLayoutPeopleRouteRoute,
  } as any)

const StaffSoftwareLayoutOperationActivityIndexRoute =
  StaffSoftwareLayoutOperationActivityIndexImport.update({
    id: '/operation-activity/',
    path: '/operation-activity/',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/software/_layout/operation-activity/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSoftwareLayoutLibraryIndexRoute =
  StaffSoftwareLayoutLibraryIndexImport.update({
    id: '/library/',
    path: '/library/',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/software/_layout/library/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffSoftwareIdIdIndexRoute = StaffSoftwareIdIdIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffSoftwareIdIdRoute,
} as any)

const StaffSettingsPersonsInviteIndexRoute =
  StaffSettingsPersonsInviteIndexImport.update({
    id: '/invite/',
    path: '/invite/',
    getParentRoute: () => StaffSettingsPersonsRoute,
  } as any).lazy(() =>
    import('./routes/_staff/settings/persons/invite/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffSettingsDataConnectorOutboundIndexRoute =
  StaffSettingsDataConnectorOutboundIndexImport.update({
    id: '/settings/data-connector/outbound/',
    path: '/settings/data-connector/outbound/',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffSettingsDataConnectorInboundIndexRoute =
  StaffSettingsDataConnectorInboundIndexImport.update({
    id: '/settings/data-connector/inbound/',
    path: '/settings/data-connector/inbound/',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffPublicIdsListSettingsIndexRoute =
  StaffPublicIdsListSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => StaffPublicIdsListRoute,
  } as any)

const StaffPublicIdsListRulesAndPoliciesIndexRoute =
  StaffPublicIdsListRulesAndPoliciesIndexImport.update({
    id: '/rules-and-policies/',
    path: '/rules-and-policies/',
    getParentRoute: () => StaffPublicIdsListRoute,
  } as any)

const StaffPublicIdsListRegistryIndexRoute =
  StaffPublicIdsListRegistryIndexImport.update({
    id: '/registry/',
    path: '/registry/',
    getParentRoute: () => StaffPublicIdsListRoute,
  } as any)

const StaffPublicIdsListOperationActivityIndexRoute =
  StaffPublicIdsListOperationActivityIndexImport.update({
    id: '/operation-activity/',
    path: '/operation-activity/',
    getParentRoute: () => StaffPublicIdsListRoute,
  } as any)

const StaffPublicIdsListMembersIndexRoute =
  StaffPublicIdsListMembersIndexImport.update({
    id: '/members/',
    path: '/members/',
    getParentRoute: () => StaffPublicIdsListRoute,
  } as any)

const StaffPublicIdsListAlertsIndexRoute =
  StaffPublicIdsListAlertsIndexImport.update({
    id: '/alerts/',
    path: '/alerts/',
    getParentRoute: () => StaffPublicIdsListRoute,
  } as any)

const StaffPublicIdsIdFilesIndexRoute = StaffPublicIdsIdFilesIndexImport.update(
  {
    id: '/files/',
    path: '/files/',
    getParentRoute: () => StaffPublicIdsIdRoute,
  } as any,
)

const StaffPublicIdsIdDetailsIndexRoute =
  StaffPublicIdsIdDetailsIndexImport.update({
    id: '/details/',
    path: '/details/',
    getParentRoute: () => StaffPublicIdsIdRoute,
  } as any)

const StaffProfileDeviceIdIndexRoute = StaffProfileDeviceIdIndexImport.update({
  id: '/profile/device/$id/',
  path: '/profile/device/$id/',
  getParentRoute: () => StaffRoute,
} as any)

const StaffPlacesLayoutSettingsIndexRoute =
  StaffPlacesLayoutSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffPlacesLayoutSettingsRouteRoute,
  } as any)

const StaffPersonAutomapIngesterWorkerTypeIndexRoute =
  StaffPersonAutomapIngesterWorkerTypeIndexImport.update({
    id: '/person/automap-ingester/$workerType/',
    path: '/person/automap-ingester/$workerType/',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffPersonAddWorkerTypeIndexRoute =
  StaffPersonAddWorkerTypeIndexImport.update({
    id: '/person/add/$workerType/',
    path: '/person/add/$workerType/',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffPersonAddPersonCertificationCertificationKindIndexRoute =
  StaffPersonAddPersonCertificationCertificationKindIndexImport.update({
    id: '/person/add-person-certification/$certificationKind/',
    path: '/person/add-person-certification/$certificationKind/',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffPeopleListWorkforceIndexRoute =
  StaffPeopleListWorkforceIndexImport.update({
    id: '/workforce/',
    path: '/workforce/',
    getParentRoute: () => StaffPeopleListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/people/_list/workforce/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPeopleListSettingsIndexRoute =
  StaffPeopleListSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any)

const StaffPeopleListOperationActivityIndexRoute =
  StaffPeopleListOperationActivityIndexImport.update({
    id: '/operation-activity/',
    path: '/operation-activity/',
    getParentRoute: () => StaffPeopleListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/people/_list/operation-activity/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPeopleListAlumniIndexRoute = StaffPeopleListAlumniIndexImport.update(
  {
    id: '/alumni/',
    path: '/alumni/',
    getParentRoute: () => StaffPeopleListRoute,
  } as any,
).lazy(() =>
  import('./routes/_staff/people/_list/alumni/index.lazy').then((d) => d.Route),
)

const StaffPayrollLayoutSettingsIndexRoute =
  StaffPayrollLayoutSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => StaffPayrollLayoutRoute,
  } as any)

const StaffPayrollLayoutRuleAndPolicyIndexRoute =
  StaffPayrollLayoutRuleAndPolicyIndexImport.update({
    id: '/rule-and-policy/',
    path: '/rule-and-policy/',
    getParentRoute: () => StaffPayrollLayoutRoute,
  } as any)

const StaffPayrollLayoutPaySlipsIndexRoute =
  StaffPayrollLayoutPaySlipsIndexImport.update({
    id: '/pay-slips/',
    path: '/pay-slips/',
    getParentRoute: () => StaffPayrollLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/payroll/_layout/pay-slips/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPayrollLayoutOverviewIndexRoute =
  StaffPayrollLayoutOverviewIndexImport.update({
    id: '/overview/',
    path: '/overview/',
    getParentRoute: () => StaffPayrollLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/payroll/_layout/overview/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPayrollLayoutAlertsIndexRoute =
  StaffPayrollLayoutAlertsIndexImport.update({
    id: '/alerts/',
    path: '/alerts/',
    getParentRoute: () => StaffPayrollLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/payroll/_layout/alerts/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPayrollEngineLayoutPayrollUnitsIndexRoute =
  StaffPayrollEngineLayoutPayrollUnitsIndexImport.update({
    id: '/payroll-units/',
    path: '/payroll-units/',
    getParentRoute: () => StaffPayrollEngineLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/payroll-engine/_layout/payroll-units/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPayrollEngineLayoutPayrollStructuresIndexRoute =
  StaffPayrollEngineLayoutPayrollStructuresIndexImport.update({
    id: '/payroll-structures/',
    path: '/payroll-structures/',
    getParentRoute: () => StaffPayrollEngineLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/payroll-engine/_layout/payroll-structures/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPayrollEngineLayoutLogicComponentsIndexRoute =
  StaffPayrollEngineLayoutLogicComponentsIndexImport.update({
    id: '/logic-components/',
    path: '/logic-components/',
    getParentRoute: () => StaffPayrollEngineLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/payroll-engine/_layout/logic-components/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPayrollEngineLayoutItemsIndexRoute =
  StaffPayrollEngineLayoutItemsIndexImport.update({
    id: '/items/',
    path: '/items/',
    getParentRoute: () => StaffPayrollEngineLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/payroll-engine/_layout/items/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPayrollCoreLayoutPersonTargetsIndexRoute =
  StaffPayrollCoreLayoutPersonTargetsIndexImport.update({
    id: '/person-targets/',
    path: '/person-targets/',
    getParentRoute: () => StaffPayrollCoreLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/payroll-core/_layout/person-targets/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPayrollCoreLayoutOperationPackagesIndexRoute =
  StaffPayrollCoreLayoutOperationPackagesIndexImport.update({
    id: '/operation-packages/',
    path: '/operation-packages/',
    getParentRoute: () => StaffPayrollCoreLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/payroll-core/_layout/operation-packages/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPayrollCoreLayoutDashboardIndexRoute =
  StaffPayrollCoreLayoutDashboardIndexImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => StaffPayrollCoreLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/payroll-core/_layout/dashboard/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPayrollCoreLayoutConfigIndexRoute =
  StaffPayrollCoreLayoutConfigIndexImport.update({
    id: '/config/',
    path: '/config/',
    getParentRoute: () => StaffPayrollCoreLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/payroll-core/_layout/config/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPayrollCoreLayoutArchiveIndexRoute =
  StaffPayrollCoreLayoutArchiveIndexImport.update({
    id: '/archive/',
    path: '/archive/',
    getParentRoute: () => StaffPayrollCoreLayoutRoute,
  } as any)

const StaffOrganizationPlanCreateIndexRoute =
  StaffOrganizationPlanCreateIndexImport.update({
    id: '/plan/create/',
    path: '/plan/create/',
    getParentRoute: () => StaffOrganizationRoute,
  } as any)

const StaffOrganizationPlanIdIndexRoute =
  StaffOrganizationPlanIdIndexImport.update({
    id: '/plan/$id/',
    path: '/plan/$id/',
    getParentRoute: () => StaffOrganizationRoute,
  } as any)

const StaffOrganizationListSettingsIndexRoute =
  StaffOrganizationListSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => StaffOrganizationListRoute,
  } as any)

const StaffOrganizationListRulePolicyIndexRoute =
  StaffOrganizationListRulePolicyIndexImport.update({
    id: '/rule-policy/',
    path: '/rule-policy/',
    getParentRoute: () => StaffOrganizationListRoute,
  } as any)

const StaffOrganizationListHistoryIndexRoute =
  StaffOrganizationListHistoryIndexImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => StaffOrganizationListRoute,
  } as any)

const StaffOrganizationListCostIndexRoute =
  StaffOrganizationListCostIndexImport.update({
    id: '/cost/',
    path: '/cost/',
    getParentRoute: () => StaffOrganizationListRoute,
  } as any)

const StaffOrganizationListChartIndexRoute =
  StaffOrganizationListChartIndexImport.update({
    id: '/chart/',
    path: '/chart/',
    getParentRoute: () => StaffOrganizationListRoute,
  } as any)

const StaffOrganizationListAlertIndexRoute =
  StaffOrganizationListAlertIndexImport.update({
    id: '/alert/',
    path: '/alert/',
    getParentRoute: () => StaffOrganizationListRoute,
  } as any)

const StaffOrganizationIdLayoutIndexRoute =
  StaffOrganizationIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffOrganizationIdLayoutRoute,
  } as any)

const StaffMarketplaceSalesOrdersOrderIdIndexRoute =
  StaffMarketplaceSalesOrdersOrderIdIndexImport.update({
    id: '/sales-orders/$orderId/',
    path: '/sales-orders/$orderId/',
    getParentRoute: () => StaffMarketplaceRoute,
  } as any)

const StaffLicensesAddAllocationTypeIndexRoute =
  StaffLicensesAddAllocationTypeIndexImport.update({
    id: '/add/$allocationType/',
    path: '/add/$allocationType/',
    getParentRoute: () => StaffLicensesRoute,
  } as any)

const StaffLicensesListSettingsIndexRoute =
  StaffLicensesListSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => StaffLicensesListRoute,
  } as any)

const StaffLicensesListRuleAndPolicyIndexRoute =
  StaffLicensesListRuleAndPolicyIndexImport.update({
    id: '/rule-and-policy/',
    path: '/rule-and-policy/',
    getParentRoute: () => StaffLicensesListRoute,
  } as any)

const StaffLicensesListPeopleIndexRoute =
  StaffLicensesListPeopleIndexImport.update({
    id: '/people/',
    path: '/people/',
    getParentRoute: () => StaffLicensesListRoute,
  } as any)

const StaffLicensesListOperationActivityIndexRoute =
  StaffLicensesListOperationActivityIndexImport.update({
    id: '/operation-activity/',
    path: '/operation-activity/',
    getParentRoute: () => StaffLicensesListRoute,
  } as any)

const StaffLicensesListInventoryIndexRoute =
  StaffLicensesListInventoryIndexImport.update({
    id: '/inventory/',
    path: '/inventory/',
    getParentRoute: () => StaffLicensesListRoute,
  } as any)

const StaffLicensesListContractAndCostIndexRoute =
  StaffLicensesListContractAndCostIndexImport.update({
    id: '/contract-and-cost/',
    path: '/contract-and-cost/',
    getParentRoute: () => StaffLicensesListRoute,
  } as any)

const StaffLicensesListAlertsIndexRoute =
  StaffLicensesListAlertsIndexImport.update({
    id: '/alerts/',
    path: '/alerts/',
    getParentRoute: () => StaffLicensesListRoute,
  } as any)

const StaffLaborCoreConfigPatternIdIndexRoute =
  StaffLaborCoreConfigPatternIdIndexImport.update({
    id: '/config/$patternId/',
    path: '/config/$patternId/',
    getParentRoute: () => StaffLaborCoreRoute,
  } as any)

const StaffLaborCorePackagesSettingsIndexRoute =
  StaffLaborCorePackagesSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffLaborCorePackagesSettingsRoute,
  } as any)

const StaffLaborCorePackagesConfigsIndexRoute =
  StaffLaborCorePackagesConfigsIndexImport.update({
    id: '/configs/',
    path: '/configs/',
    getParentRoute: () => StaffLaborCorePackagesRoute,
  } as any)

const StaffLaborCorePackagesArchivesIndexRoute =
  StaffLaborCorePackagesArchivesIndexImport.update({
    id: '/archives/',
    path: '/archives/',
    getParentRoute: () => StaffLaborCorePackagesRoute,
  } as any)

const StaffItOperationCoreSelfReportPatternsPatternIdIndexRoute =
  StaffItOperationCoreSelfReportPatternsPatternIdIndexImport.update({
    id: '/self-report-patterns/$patternId/',
    path: '/self-report-patterns/$patternId/',
    getParentRoute: () => StaffItOperationCoreRoute,
  } as any)

const StaffItOperationCoreConfigPatternIdIndexRoute =
  StaffItOperationCoreConfigPatternIdIndexImport.update({
    id: '/config/$patternId/',
    path: '/config/$patternId/',
    getParentRoute: () => StaffItOperationCoreRoute,
  } as any)

const StaffItOperationCoreRootPackagesIndexRoute =
  StaffItOperationCoreRootPackagesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffItOperationCoreRootPackagesRouteRoute,
  } as any)

const StaffItOperationCoreRootInHousePackagesIndexRoute =
  StaffItOperationCoreRootInHousePackagesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffItOperationCoreRootInHousePackagesRouteRoute,
  } as any)

const StaffItOperationCoreRootConfigIndexRoute =
  StaffItOperationCoreRootConfigIndexImport.update({
    id: '/config/',
    path: '/config/',
    getParentRoute: () => StaffItOperationCoreRootRoute,
  } as any)

const StaffItOperationCoreRootArchivesIndexRoute =
  StaffItOperationCoreRootArchivesIndexImport.update({
    id: '/archives/',
    path: '/archives/',
    getParentRoute: () => StaffItOperationCoreRootRoute,
  } as any)

const StaffIdsGroupIdAddIndexRoute = StaffIdsGroupIdAddIndexImport.update({
  id: '/group-id/add/',
  path: '/group-id/add/',
  getParentRoute: () => StaffIdsRoute,
} as any).lazy(() =>
  import('./routes/_staff/ids/group-id/add/index.lazy').then((d) => d.Route),
)

const StaffIdsLayoutPeopleIndexRoute = StaffIdsLayoutPeopleIndexImport.update({
  id: '/people/',
  path: '/people/',
  getParentRoute: () => StaffIdsLayoutRoute,
} as any).lazy(() =>
  import('./routes/_staff/ids/_layout/people/index.lazy').then((d) => d.Route),
)

const StaffGaOperationCoreConfigPatternIdIndexRoute =
  StaffGaOperationCoreConfigPatternIdIndexImport.update({
    id: '/config/$patternId/',
    path: '/config/$patternId/',
    getParentRoute: () => StaffGaOperationCoreRoute,
  } as any)

const StaffGaOperationCorePackagesConfigsIndexRoute =
  StaffGaOperationCorePackagesConfigsIndexImport.update({
    id: '/configs/',
    path: '/configs/',
    getParentRoute: () => StaffGaOperationCorePackagesRoute,
  } as any)

const StaffGaOperationCorePackagesArchivesIndexRoute =
  StaffGaOperationCorePackagesArchivesIndexImport.update({
    id: '/archives/',
    path: '/archives/',
    getParentRoute: () => StaffGaOperationCorePackagesRoute,
  } as any)

const StaffFleetsLayoutListIndexRoute = StaffFleetsLayoutListIndexImport.update(
  {
    id: '/_list/',
    path: '/',
    getParentRoute: () => StaffFleetsLayoutRoute,
  } as any,
)

const StaffEquipmentLayoutSettingsIndexRoute =
  StaffEquipmentLayoutSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffEquipmentLayoutSettingsRouteLazyRoute,
  } as any)

const StaffEquipmentLayoutItemsIndexRoute =
  StaffEquipmentLayoutItemsIndexImport.update({
    id: '/items/',
    path: '/items/',
    getParentRoute: () => StaffEquipmentLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/equipment/_layout/items/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffEquipmentLayoutAlertsIndexRoute =
  StaffEquipmentLayoutAlertsIndexImport.update({
    id: '/alerts/',
    path: '/alerts/',
    getParentRoute: () => StaffEquipmentLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/equipment/_layout/alerts/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffDevicesAddCatalogIndexRoute =
  StaffDevicesAddCatalogIndexImport.update({
    id: '/add/catalog/',
    path: '/add/catalog/',
    getParentRoute: () => StaffDevicesRoute,
  } as any)

const StaffDevicesAddDeviceTypeIndexRoute =
  StaffDevicesAddDeviceTypeIndexImport.update({
    id: '/add/$deviceType/',
    path: '/add/$deviceType/',
    getParentRoute: () => StaffDevicesRoute,
  } as any)

const StaffDevicesListSettingsIndexRoute =
  StaffDevicesListSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffDevicesListSettingsRouteLazyRoute,
  } as any)

const StaffDevicesListPeopleIndexRoute =
  StaffDevicesListPeopleIndexImport.update({
    id: '/people/',
    path: '/people/',
    getParentRoute: () => StaffDevicesListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/devices/_list/people/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffDevicesListInventoryIndexRoute =
  StaffDevicesListInventoryIndexImport.update({
    id: '/inventory/',
    path: '/inventory/',
    getParentRoute: () => StaffDevicesListRoute,
  } as any)

const StaffDevicesListInventoriesIndexRoute =
  StaffDevicesListInventoriesIndexImport.update({
    id: '/inventories/',
    path: '/inventories/',
    getParentRoute: () => StaffDevicesListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/devices/_list/inventories/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffDevicesIdLayoutIndexRoute = StaffDevicesIdLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffDevicesIdLayoutRoute,
} as any)

const StaffDeviceCatalogAddDeviceTypeIndexRoute =
  StaffDeviceCatalogAddDeviceTypeIndexImport.update({
    id: '/device-catalog/add/$deviceType/',
    path: '/device-catalog/add/$deviceType/',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffDealAddDirectionIndexRoute = StaffDealAddDirectionIndexImport.update(
  {
    id: '/add/$direction/',
    path: '/add/$direction/',
    getParentRoute: () => StaffDealRoute,
  } as any,
).lazy(() =>
  import('./routes/_staff/deal/add/$direction/index.lazy').then((d) => d.Route),
)

const StaffContractorCoreConfigPatternIdIndexRoute =
  StaffContractorCoreConfigPatternIdIndexImport.update({
    id: '/config/$patternId/',
    path: '/config/$patternId/',
    getParentRoute: () => StaffContractorCoreRoute,
  } as any)

const StaffContractorCorePackagesConfigsIndexRoute =
  StaffContractorCorePackagesConfigsIndexImport.update({
    id: '/configs/',
    path: '/configs/',
    getParentRoute: () => StaffContractorCorePackagesRoute,
  } as any)

const StaffContractorCorePackagesArchivesIndexRoute =
  StaffContractorCorePackagesArchivesIndexImport.update({
    id: '/archives/',
    path: '/archives/',
    getParentRoute: () => StaffContractorCorePackagesRoute,
  } as any)

const StaffContractImportCsvContractTypeIndexRoute =
  StaffContractImportCsvContractTypeIndexImport.update({
    id: '/import-csv/$contractType/',
    path: '/import-csv/$contractType/',
    getParentRoute: () => StaffContractRoute,
  } as any)

const StaffContractAddSubscriptionIndexRoute =
  StaffContractAddSubscriptionIndexImport.update({
    id: '/add/subscription/',
    path: '/add/subscription/',
    getParentRoute: () => StaffContractRoute,
  } as any)

const StaffCockpitTaskTaskIdIndexRoute =
  StaffCockpitTaskTaskIdIndexImport.update({
    id: '/cockpit/task/$taskId/',
    path: '/cockpit/task/$taskId/',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffCockpitApprovalIdIndexRoute =
  StaffCockpitApprovalIdIndexImport.update({
    id: '/cockpit/approval/$id/',
    path: '/cockpit/approval/$id/',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffCertificationAddCertificationKindIndexRoute =
  StaffCertificationAddCertificationKindIndexImport.update({
    id: '/add/$certificationKind/',
    path: '/add/$certificationKind/',
    getParentRoute: () => StaffCertificationRoute,
  } as any)

const StaffCertificationListSettingsIndexRoute =
  StaffCertificationListSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffCertificationListSettingsRouteLazyRoute,
  } as any)

const StaffCertificationListPeopleIndexRoute =
  StaffCertificationListPeopleIndexImport.update({
    id: '/people/',
    path: '/people/',
    getParentRoute: () => StaffCertificationListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/certification/_list/people/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffBusinessPartnerAddBusinessPartnerTypeIndexRoute =
  StaffBusinessPartnerAddBusinessPartnerTypeIndexImport.update({
    id: '/add/$businessPartnerType/',
    path: '/add/$businessPartnerType/',
    getParentRoute: () => StaffBusinessPartnerRoute,
  } as any)

const StaffBusinessPartnerListTerminatedIndexRoute =
  StaffBusinessPartnerListTerminatedIndexImport.update({
    id: '/terminated/',
    path: '/terminated/',
    getParentRoute: () => StaffBusinessPartnerListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/business-partner/_list/terminated/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffAttendancesLayoutSettingsIndexRoute =
  StaffAttendancesLayoutSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => StaffAttendancesLayoutRoute,
  } as any)

const StaffAttendancesLayoutRuleAndPolicyIndexRoute =
  StaffAttendancesLayoutRuleAndPolicyIndexImport.update({
    id: '/rule-and-policy/',
    path: '/rule-and-policy/',
    getParentRoute: () => StaffAttendancesLayoutRoute,
  } as any)

const StaffAttendancesLayoutOverviewIndexRoute =
  StaffAttendancesLayoutOverviewIndexImport.update({
    id: '/overview/',
    path: '/overview/',
    getParentRoute: () => StaffAttendancesLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/attendances/_layout/overview/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffAttendancesLayoutOperationActivityIndexRoute =
  StaffAttendancesLayoutOperationActivityIndexImport.update({
    id: '/operation-activity/',
    path: '/operation-activity/',
    getParentRoute: () => StaffAttendancesLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/attendances/_layout/operation-activity/index.lazy'
    ).then((d) => d.Route),
  )

const StaffAttendancesLayoutEmployeesIndexRoute =
  StaffAttendancesLayoutEmployeesIndexImport.update({
    id: '/employees/',
    path: '/employees/',
    getParentRoute: () => StaffAttendancesLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/attendances/_layout/employees/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffAttendancesLayoutClockingRecordsIndexRoute =
  StaffAttendancesLayoutClockingRecordsIndexImport.update({
    id: '/clocking-records/',
    path: '/clocking-records/',
    getParentRoute: () => StaffAttendancesLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/attendances/_layout/clocking-records/index.lazy'
    ).then((d) => d.Route),
  )

const StaffAttendancesLayoutAlertsIndexRoute =
  StaffAttendancesLayoutAlertsIndexImport.update({
    id: '/alerts/',
    path: '/alerts/',
    getParentRoute: () => StaffAttendancesLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/attendances/_layout/alerts/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffAttendanceEngineLayoutLogicComponentsIndexRoute =
  StaffAttendanceEngineLayoutLogicComponentsIndexImport.update({
    id: '/logic-components/',
    path: '/logic-components/',
    getParentRoute: () => StaffAttendanceEngineLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/attendance-engine/_layout/logic-components/index.lazy'
    ).then((d) => d.Route),
  )

const StaffAttendanceEngineLayoutItemsIndexRoute =
  StaffAttendanceEngineLayoutItemsIndexImport.update({
    id: '/items/',
    path: '/items/',
    getParentRoute: () => StaffAttendanceEngineLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/attendance-engine/_layout/items/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffAttendanceEngineLayoutAttendanceUnitsIndexRoute =
  StaffAttendanceEngineLayoutAttendanceUnitsIndexImport.update({
    id: '/attendance-units/',
    path: '/attendance-units/',
    getParentRoute: () => StaffAttendanceEngineLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/attendance-engine/_layout/attendance-units/index.lazy'
    ).then((d) => d.Route),
  )

const StaffAttendanceEngineLayoutAttendanceStructuresIndexRoute =
  StaffAttendanceEngineLayoutAttendanceStructuresIndexImport.update({
    id: '/attendance-structures/',
    path: '/attendance-structures/',
    getParentRoute: () => StaffAttendanceEngineLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/attendance-engine/_layout/attendance-structures/index.lazy'
    ).then((d) => d.Route),
  )

const StaffAttendanceCoreLayoutOperationPackagesIndexRoute =
  StaffAttendanceCoreLayoutOperationPackagesIndexImport.update({
    id: '/operation-packages/',
    path: '/operation-packages/',
    getParentRoute: () => StaffAttendanceCoreLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/attendance-core/_layout/operation-packages/index.lazy'
    ).then((d) => d.Route),
  )

const StaffAttendanceCoreLayoutDashboardIndexRoute =
  StaffAttendanceCoreLayoutDashboardIndexImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => StaffAttendanceCoreLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/attendance-core/_layout/dashboard/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffAttendanceCoreLayoutConfigIndexRoute =
  StaffAttendanceCoreLayoutConfigIndexImport.update({
    id: '/config/',
    path: '/config/',
    getParentRoute: () => StaffAttendanceCoreLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/attendance-core/_layout/config/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffAttendanceCoreLayoutArchiveIndexRoute =
  StaffAttendanceCoreLayoutArchiveIndexImport.update({
    id: '/archive/',
    path: '/archive/',
    getParentRoute: () => StaffAttendanceCoreLayoutRoute,
  } as any)

const StaffAccessesLayoutSettingsIndexRoute =
  StaffAccessesLayoutSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => StaffAccessesLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/accesses/_layout/settings/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffAccessesLayoutListIndexRoute =
  StaffAccessesLayoutListIndexImport.update({
    id: '/list/',
    path: '/list/',
    getParentRoute: () => StaffAccessesLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/accesses/_layout/list/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffAccessesLayoutAlertsIndexRoute =
  StaffAccessesLayoutAlertsIndexImport.update({
    id: '/alerts/',
    path: '/alerts/',
    getParentRoute: () => StaffAccessesLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/accesses/_layout/alerts/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StacktraceValuesIdLayoutIndexRoute =
  StacktraceValuesIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StacktraceValuesIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_stacktrace/values/$id/_layout/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StacktraceTestSuitesIdLayoutIndexRoute =
  StacktraceTestSuitesIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StacktraceTestSuitesIdLayoutRoute,
  } as any)

const StacktraceTestSetsIdLayoutIndexRoute =
  StacktraceTestSetsIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StacktraceTestSetsIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_stacktrace/test-sets/$id/_layout/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StacktraceProductsIdLayoutIndexRoute =
  StacktraceProductsIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StacktraceProductsIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_stacktrace/products/$id/_layout/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StacktraceProductionProductionIdLayoutIndexRoute =
  StacktraceProductionProductionIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StacktraceProductionProductionIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_stacktrace/production/$productionId/_layout/index.lazy'
    ).then((d) => d.Route),
  )

const StacktraceProductRoadmapRoadmapIdLayoutIndexRoute =
  StacktraceProductRoadmapRoadmapIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StacktraceProductRoadmapRoadmapIdLayoutRoute,
  } as any)

const StacktraceIssuesLayoutOverviewIndexRoute =
  StacktraceIssuesLayoutOverviewIndexImport.update({
    id: '/overview/',
    path: '/overview/',
    getParentRoute: () => StacktraceIssuesLayoutRoute,
  } as any)

const StacktraceIssuesIdLayoutIndexRoute =
  StacktraceIssuesIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StacktraceIssuesIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_stacktrace/issues/$id/_layout/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StacktraceDevelopmentTicketsTicketIdLayoutIndexRoute =
  StacktraceDevelopmentTicketsTicketIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StacktraceDevelopmentTicketsTicketIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_stacktrace/development-tickets/$ticketId/_layout/index.lazy'
    ).then((d) => d.Route),
  )

const IndividualIndividualTaskIdIndexRoute =
  IndividualIndividualTaskIdIndexImport.update({
    id: '/task/$id/',
    path: '/task/$id/',
    getParentRoute: () => IndividualIndividualRoute,
  } as any)

const IndividualIndividualPortalRequestsIndexRoute =
  IndividualIndividualPortalRequestsIndexImport.update({
    id: '/requests/',
    path: '/requests/',
    getParentRoute: () => IndividualIndividualPortalRoute,
  } as any)

const IndividualIndividualPortalLookupIndexRoute =
  IndividualIndividualPortalLookupIndexImport.update({
    id: '/lookup/',
    path: '/lookup/',
    getParentRoute: () => IndividualIndividualPortalRoute,
  } as any)

const IndividualIndividualPortalApprovalsIndexRoute =
  IndividualIndividualPortalApprovalsIndexImport.update({
    id: '/approvals/',
    path: '/approvals/',
    getParentRoute: () => IndividualIndividualPortalRoute,
  } as any)

const IndividualIndividualOperationPackageIdIndexRoute =
  IndividualIndividualOperationPackageIdIndexImport.update({
    id: '/operation-package/$id/',
    path: '/operation-package/$id/',
    getParentRoute: () => IndividualIndividualRoute,
  } as any)

const IndividualIndividualTasksRequestTasksIndexRoute =
  IndividualIndividualTasksRequestTasksIndexImport.update({
    id: '/_tasks/request-tasks/',
    path: '/request-tasks/',
    getParentRoute: () => IndividualIndividualRoute,
  } as any)

const IndividualIndividualTasksOperationTasksIndexRoute =
  IndividualIndividualTasksOperationTasksIndexImport.update({
    id: '/_tasks/operation-tasks/',
    path: '/operation-tasks/',
    getParentRoute: () => IndividualIndividualRoute,
  } as any)

const IndividualIndividualTasksApprovalTasksIndexRoute =
  IndividualIndividualTasksApprovalTasksIndexImport.update({
    id: '/_tasks/approval-tasks/',
    path: '/approval-tasks/',
    getParentRoute: () => IndividualIndividualRoute,
  } as any)

const StaffSoftwareIdIdSettingsRouteLazyRoute =
  StaffSoftwareIdIdSettingsRouteLazyImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => StaffSoftwareIdIdRoute,
  } as any).lazy(() =>
    import('./routes/_staff/software/$id/_$id/settings/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffStorageFilesFoldersIdIdRoute =
  StaffStorageFilesFoldersIdIdImport.update({
    id: '/_$id',
    getParentRoute: () => StaffStorageFilesFoldersIdRoute,
  } as any)

const StaffStorageFilesFilesIdIdRoute = StaffStorageFilesFilesIdIdImport.update(
  {
    id: '/_$id',
    getParentRoute: () => StaffStorageFilesFilesIdRoute,
  } as any,
)

const StaffStarlinksLayoutPlaceholdersOperationActivityRoute =
  StaffStarlinksLayoutPlaceholdersOperationActivityImport.update({
    id: '/_placeholders/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffStarlinksLayoutRoute,
  } as any)

const StaffStarlinksLayoutPlaceholdersMarketplaceRoute =
  StaffStarlinksLayoutPlaceholdersMarketplaceImport.update({
    id: '/_placeholders/marketplace',
    path: '/marketplace',
    getParentRoute: () => StaffStarlinksLayoutRoute,
  } as any)

const StaffStarlinksLayoutPlaceholdersBillingAndCostRoute =
  StaffStarlinksLayoutPlaceholdersBillingAndCostImport.update({
    id: '/_placeholders/billing-and-cost',
    path: '/billing-and-cost',
    getParentRoute: () => StaffStarlinksLayoutRoute,
  } as any)

const StaffSoftwareLayoutContractAndCostContractAndCostRoute =
  StaffSoftwareLayoutContractAndCostContractAndCostImport.update({
    id: '/_contract-and-cost',
    getParentRoute: () => StaffSoftwareLayoutContractAndCostRoute,
  } as any)

const StaffSoftwareLayoutAlertsAlertsRoute =
  StaffSoftwareLayoutAlertsAlertsImport.update({
    id: '/_alerts',
    getParentRoute: () => StaffSoftwareLayoutAlertsRoute,
  } as any)

const StaffSoftwareIdIdProfilesRoute = StaffSoftwareIdIdProfilesImport.update({
  id: '/profiles',
  path: '/profiles',
  getParentRoute: () => StaffSoftwareIdIdRoute,
} as any).lazy(() =>
  import('./routes/_staff/software/$id/_$id/profiles.lazy').then(
    (d) => d.Route,
  ),
)

const StaffSoftwareIdIdGroupsRoute = StaffSoftwareIdIdGroupsImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => StaffSoftwareIdIdRoute,
} as any).lazy(() =>
  import('./routes/_staff/software/$id/_$id/groups.lazy').then((d) => d.Route),
)

const StaffSettingsPersonsListAccountRoute =
  StaffSettingsPersonsListAccountImport.update({
    id: '/_account',
    getParentRoute: () => StaffSettingsPersonsListRoute,
  } as any)

const StaffProfileDeviceIdSplatRoute = StaffProfileDeviceIdSplatImport.update({
  id: '/profile/device/$id/$',
  path: '/profile/device/$id/$',
  getParentRoute: () => StaffRoute,
} as any)

const StaffPlacesLayoutPlaceholdersStoreRoute =
  StaffPlacesLayoutPlaceholdersStoreImport.update({
    id: '/_placeholders/store',
    path: '/store',
    getParentRoute: () => StaffPlacesLayoutRoute,
  } as any)

const StaffPlacesLayoutPlaceholdersRuleAndPolicyRoute =
  StaffPlacesLayoutPlaceholdersRuleAndPolicyImport.update({
    id: '/_placeholders/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffPlacesLayoutRoute,
  } as any)

const StaffPlacesLayoutPlaceholdersPeopleRoute =
  StaffPlacesLayoutPlaceholdersPeopleImport.update({
    id: '/_placeholders/people',
    path: '/people',
    getParentRoute: () => StaffPlacesLayoutRoute,
  } as any)

const StaffPlacesLayoutPlaceholdersOperationActivityRoute =
  StaffPlacesLayoutPlaceholdersOperationActivityImport.update({
    id: '/_placeholders/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffPlacesLayoutRoute,
  } as any)

const StaffPlacesLayoutPlaceholdersContractAndCostRoute =
  StaffPlacesLayoutPlaceholdersContractAndCostImport.update({
    id: '/_placeholders/contract-and-cost',
    path: '/contract-and-cost',
    getParentRoute: () => StaffPlacesLayoutRoute,
  } as any)

const StaffPlacesLayoutPlaceholdersAlertsRoute =
  StaffPlacesLayoutPlaceholdersAlertsImport.update({
    id: '/_placeholders/alerts',
    path: '/alerts',
    getParentRoute: () => StaffPlacesLayoutRoute,
  } as any)

const StaffPersonAlumniIdProfileRoute = StaffPersonAlumniIdProfileImport.update(
  {
    id: '/_profile',
    getParentRoute: () => StaffPersonAlumniIdRoute,
  } as any,
)

const StaffPersonAddWorkerTypeCompletedRoute =
  StaffPersonAddWorkerTypeCompletedImport.update({
    id: '/person/add/$workerType/completed',
    path: '/person/add/$workerType/completed',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffPersonAddPersonCertificationCertificationKindCompletedRoute =
  StaffPersonAddPersonCertificationCertificationKindCompletedImport.update({
    id: '/person/add-person-certification/$certificationKind/completed',
    path: '/person/add-person-certification/$certificationKind/completed',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffPayrollLayoutContractAndCostContractAndCostRoute =
  StaffPayrollLayoutContractAndCostContractAndCostImport.update({
    id: '/_contract-and-cost',
    getParentRoute: () => StaffPayrollLayoutContractAndCostRoute,
  } as any)

const StaffNetworksLayoutPlaceholdersSettingsRoute =
  StaffNetworksLayoutPlaceholdersSettingsImport.update({
    id: '/_placeholders/settings',
    path: '/settings',
    getParentRoute: () => StaffNetworksLayoutRoute,
  } as any)

const StaffNetworksLayoutPlaceholdersRuleAndPolicyRoute =
  StaffNetworksLayoutPlaceholdersRuleAndPolicyImport.update({
    id: '/_placeholders/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffNetworksLayoutRoute,
  } as any)

const StaffNetworksLayoutPlaceholdersOverviewRoute =
  StaffNetworksLayoutPlaceholdersOverviewImport.update({
    id: '/_placeholders/overview',
    path: '/overview',
    getParentRoute: () => StaffNetworksLayoutRoute,
  } as any)

const StaffNetworksLayoutPlaceholdersOperationActivityRoute =
  StaffNetworksLayoutPlaceholdersOperationActivityImport.update({
    id: '/_placeholders/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffNetworksLayoutRoute,
  } as any)

const StaffNetworksLayoutPlaceholdersContractAndCostRoute =
  StaffNetworksLayoutPlaceholdersContractAndCostImport.update({
    id: '/_placeholders/contract-and-cost',
    path: '/contract-and-cost',
    getParentRoute: () => StaffNetworksLayoutRoute,
  } as any)

const StaffNetworksLayoutPlaceholdersAlertsRoute =
  StaffNetworksLayoutPlaceholdersAlertsImport.update({
    id: '/_placeholders/alerts',
    path: '/alerts',
    getParentRoute: () => StaffNetworksLayoutRoute,
  } as any)

const StaffMarketplaceSentOrdersOrderIdLayoutRoute =
  StaffMarketplaceSentOrdersOrderIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StaffMarketplaceSentOrdersOrderIdRoute,
  } as any)

const StaffLicensesAddAllocationTypeCompletedRoute =
  StaffLicensesAddAllocationTypeCompletedImport.update({
    id: '/add/$allocationType/completed',
    path: '/add/$allocationType/completed',
    getParentRoute: () => StaffLicensesRoute,
  } as any)

const StaffLaborCoreSettingsProfileProfileIdRoute =
  StaffLaborCoreSettingsProfileProfileIdImport.update({
    id: '/settings/profile/$profileId',
    path: '/settings/profile/$profileId',
    getParentRoute: () => StaffLaborCoreRoute,
  } as any)

const StaffItOperationCoreRootPackagesPackageIdRoute =
  StaffItOperationCoreRootPackagesPackageIdImport.update({
    id: '/$packageId',
    path: '/$packageId',
    getParentRoute: () => StaffItOperationCoreRootPackagesRouteRoute,
  } as any)

const StaffItOperationCoreRootInHousePackagesPackageIdRoute =
  StaffItOperationCoreRootInHousePackagesPackageIdImport.update({
    id: '/$packageId',
    path: '/$packageId',
    getParentRoute: () => StaffItOperationCoreRootInHousePackagesRouteRoute,
  } as any)

const StaffIdsGroupIdIdIdRoute = StaffIdsGroupIdIdIdImport.update({
  id: '/_$id',
  getParentRoute: () => StaffIdsGroupIdIdRoute,
} as any)

const StaffIdsLayoutPlaceholdersSettingsRoute =
  StaffIdsLayoutPlaceholdersSettingsImport.update({
    id: '/_placeholders/settings',
    path: '/settings',
    getParentRoute: () => StaffIdsLayoutRoute,
  } as any)

const StaffIdsLayoutPlaceholdersRuleAndPolicyRoute =
  StaffIdsLayoutPlaceholdersRuleAndPolicyImport.update({
    id: '/_placeholders/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffIdsLayoutRoute,
  } as any)

const StaffIdsLayoutPlaceholdersOverviewRoute =
  StaffIdsLayoutPlaceholdersOverviewImport.update({
    id: '/_placeholders/overview',
    path: '/overview',
    getParentRoute: () => StaffIdsLayoutRoute,
  } as any)

const StaffIdsLayoutPlaceholdersOperationActivityRoute =
  StaffIdsLayoutPlaceholdersOperationActivityImport.update({
    id: '/_placeholders/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffIdsLayoutRoute,
  } as any)

const StaffIdsLayoutPlaceholdersGroupIdRoute =
  StaffIdsLayoutPlaceholdersGroupIdImport.update({
    id: '/_placeholders/group-id',
    path: '/group-id',
    getParentRoute: () => StaffIdsLayoutRoute,
  } as any)

const StaffIdsLayoutPlaceholdersAlertsRoute =
  StaffIdsLayoutPlaceholdersAlertsImport.update({
    id: '/_placeholders/alerts',
    path: '/alerts',
    getParentRoute: () => StaffIdsLayoutRoute,
  } as any)

const StaffEquipmentItemsIdDetailRoute =
  StaffEquipmentItemsIdDetailImport.update({
    id: '/_detail',
    getParentRoute: () => StaffEquipmentItemsIdRoute,
  } as any)

const StaffEquipmentLayoutPlaceholdersSettingsRoute =
  StaffEquipmentLayoutPlaceholdersSettingsImport.update({
    id: '/_placeholders/settings',
    path: '/settings',
    getParentRoute: () => StaffEquipmentLayoutRoute,
  } as any)

const StaffEquipmentLayoutPlaceholdersRuleAndPolicyRoute =
  StaffEquipmentLayoutPlaceholdersRuleAndPolicyImport.update({
    id: '/_placeholders/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffEquipmentLayoutRoute,
  } as any)

const StaffEquipmentLayoutPlaceholdersOverviewRoute =
  StaffEquipmentLayoutPlaceholdersOverviewImport.update({
    id: '/_placeholders/overview',
    path: '/overview',
    getParentRoute: () => StaffEquipmentLayoutRoute,
  } as any)

const StaffDevicesAddDeviceTypeCompletedRoute =
  StaffDevicesAddDeviceTypeCompletedImport.update({
    id: '/add/$deviceType/completed',
    path: '/add/$deviceType/completed',
    getParentRoute: () => StaffDevicesRoute,
  } as any)

const StaffDevicesListContractAndCostContractAndCostRoute =
  StaffDevicesListContractAndCostContractAndCostImport.update({
    id: '/_contract-and-cost',
    getParentRoute: () => StaffDevicesListContractAndCostRoute,
  } as any)

const StaffDeviceCatalogDraftIdLayoutRoute =
  StaffDeviceCatalogDraftIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StaffDeviceCatalogDraftIdRoute,
  } as any)

const StaffDeviceCatalogAddDeviceTypeCompletedRoute =
  StaffDeviceCatalogAddDeviceTypeCompletedImport.update({
    id: '/device-catalog/add/$deviceType/completed',
    path: '/device-catalog/add/$deviceType/completed',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffDeviceCatalogActiveIdLayoutRoute =
  StaffDeviceCatalogActiveIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StaffDeviceCatalogActiveIdRoute,
  } as any)

const StaffDealAddDirectionCompletedRoute =
  StaffDealAddDirectionCompletedImport.update({
    id: '/add/$direction/completed',
    path: '/add/$direction/completed',
    getParentRoute: () => StaffDealRoute,
  } as any)

const StaffContractAddSubscriptionCompletedRoute =
  StaffContractAddSubscriptionCompletedImport.update({
    id: '/add/subscription/completed',
    path: '/add/subscription/completed',
    getParentRoute: () => StaffContractRoute,
  } as any)

const StaffCertificationSpecialtyCertificationIdLayoutRoute =
  StaffCertificationSpecialtyCertificationIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StaffCertificationSpecialtyCertificationIdRoute,
  } as any)

const StaffCertificationHandlingCertificationIdLayoutRoute =
  StaffCertificationHandlingCertificationIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StaffCertificationHandlingCertificationIdRoute,
  } as any)

const StaffCertificationAddCertificationKindCompletedRoute =
  StaffCertificationAddCertificationKindCompletedImport.update({
    id: '/add/$certificationKind/completed',
    path: '/add/$certificationKind/completed',
    getParentRoute: () => StaffCertificationRoute,
  } as any)

const StaffBusinessPartnerAddBusinessPartnerTypeCompletedRoute =
  StaffBusinessPartnerAddBusinessPartnerTypeCompletedImport.update({
    id: '/add/$businessPartnerType/completed',
    path: '/add/$businessPartnerType/completed',
    getParentRoute: () => StaffBusinessPartnerRoute,
  } as any)

const StaffAppIntegrationsIdIdSplatRoute =
  StaffAppIntegrationsIdIdSplatImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => StaffAppIntegrationsIdIdRoute,
  } as any)

const StaffAccessesLayoutPlaceholdersSoftwareRoute =
  StaffAccessesLayoutPlaceholdersSoftwareImport.update({
    id: '/_placeholders/software',
    path: '/software',
    getParentRoute: () => StaffAccessesLayoutRoute,
  } as any)

const StaffAccessesLayoutPlaceholdersOverviewRoute =
  StaffAccessesLayoutPlaceholdersOverviewImport.update({
    id: '/_placeholders/overview',
    path: '/overview',
    getParentRoute: () => StaffAccessesLayoutRoute,
  } as any)

const StaffAccessesLayoutPlaceholdersContractAndCostRoute =
  StaffAccessesLayoutPlaceholdersContractAndCostImport.update({
    id: '/_placeholders/contract-and-cost',
    path: '/contract-and-cost',
    getParentRoute: () => StaffAccessesLayoutRoute,
  } as any)

const IndividualIndividualTaskIdApprovalDialogRoute =
  IndividualIndividualTaskIdApprovalDialogImport.update({
    id: '/task/$id/approval-dialog',
    path: '/task/$id/approval-dialog',
    getParentRoute: () => IndividualIndividualRoute,
  } as any)

const IndividualIndividualProfileMyProfileLayoutRoute =
  IndividualIndividualProfileMyProfileLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => IndividualIndividualProfileMyProfileRoute,
  } as any)

const StaffSupplierListPlaceholdersRuleAndPolicyRouteRoute =
  StaffSupplierListPlaceholdersRuleAndPolicyRouteImport.update({
    id: '/_placeholders/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffSupplierListRoute,
  } as any)

const StaffSupplierListPlaceholdersOverviewRouteRoute =
  StaffSupplierListPlaceholdersOverviewRouteImport.update({
    id: '/_placeholders/overview',
    path: '/overview',
    getParentRoute: () => StaffSupplierListRoute,
  } as any)

const StaffSupplierListPlaceholdersOperationActivityRouteRoute =
  StaffSupplierListPlaceholdersOperationActivityRouteImport.update({
    id: '/_placeholders/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffSupplierListRoute,
  } as any)

const StaffSupplierListPlaceholdersContractAndCostRouteRoute =
  StaffSupplierListPlaceholdersContractAndCostRouteImport.update({
    id: '/_placeholders/contract-and-cost',
    path: '/contract-and-cost',
    getParentRoute: () => StaffSupplierListRoute,
  } as any)

const StaffSupplierListPlaceholdersAlertsRouteRoute =
  StaffSupplierListPlaceholdersAlertsRouteImport.update({
    id: '/_placeholders/alerts',
    path: '/alerts',
    getParentRoute: () => StaffSupplierListRoute,
  } as any)

const StaffSupplierSupplierIdLayoutSettingsRouteRoute =
  StaffSupplierSupplierIdLayoutSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => StaffSupplierSupplierIdLayoutRoute,
  } as any)

const StaffSupplierSupplierIdLayoutRulesAndPolicyRouteRoute =
  StaffSupplierSupplierIdLayoutRulesAndPolicyRouteImport.update({
    id: '/rules-and-policy',
    path: '/rules-and-policy',
    getParentRoute: () => StaffSupplierSupplierIdLayoutRoute,
  } as any)

const StaffSupplierSupplierIdLayoutFilesRouteRoute =
  StaffSupplierSupplierIdLayoutFilesRouteImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () => StaffSupplierSupplierIdLayoutRoute,
  } as any)

const StaffSoftwareLayoutMarketplaceIdRouteRoute =
  StaffSoftwareLayoutMarketplaceIdRouteImport.update({
    id: '/marketplace/$id',
    path: '/marketplace/$id',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any)

const StaffPayrollLayoutPaySlipsEmployeeIdRouteRoute =
  StaffPayrollLayoutPaySlipsEmployeeIdRouteImport.update({
    id: '/pay-slips/$employeeId',
    path: '/pay-slips/$employeeId',
    getParentRoute: () => StaffPayrollLayoutRoute,
  } as any)

const StaffDealDealIdLayoutStructureRouteRoute =
  StaffDealDealIdLayoutStructureRouteImport.update({
    id: '/structure',
    path: '/structure',
    getParentRoute: () => StaffDealDealIdLayoutRoute,
  } as any)

const StaffDealDealIdLayoutFlowRouteRoute =
  StaffDealDealIdLayoutFlowRouteImport.update({
    id: '/flow',
    path: '/flow',
    getParentRoute: () => StaffDealDealIdLayoutRoute,
  } as any)

const StaffContractListPlaceholdersPeopleRouteRoute =
  StaffContractListPlaceholdersPeopleRouteImport.update({
    id: '/_placeholders/people',
    path: '/people',
    getParentRoute: () => StaffContractListRoute,
  } as any)

const StaffContractListPlaceholdersOverviewRouteRoute =
  StaffContractListPlaceholdersOverviewRouteImport.update({
    id: '/_placeholders/overview',
    path: '/overview',
    getParentRoute: () => StaffContractListRoute,
  } as any)

const StaffContractListPlaceholdersOperationActivityRouteRoute =
  StaffContractListPlaceholdersOperationActivityRouteImport.update({
    id: '/_placeholders/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffContractListRoute,
  } as any)

const StaffContractListPlaceholdersContractAndCostRouteRoute =
  StaffContractListPlaceholdersContractAndCostRouteImport.update({
    id: '/_placeholders/contract-and-cost',
    path: '/contract-and-cost',
    getParentRoute: () => StaffContractListRoute,
  } as any)

const StaffContractListPlaceholdersAlertsRouteRoute =
  StaffContractListPlaceholdersAlertsRouteImport.update({
    id: '/_placeholders/alerts',
    path: '/alerts',
    getParentRoute: () => StaffContractListRoute,
  } as any)

const StaffCertificationListPlaceholdersRuleAndPolicyRouteRoute =
  StaffCertificationListPlaceholdersRuleAndPolicyRouteImport.update({
    id: '/_placeholders/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffCertificationListRoute,
  } as any)

const StaffCertificationListPlaceholdersOverviewRouteRoute =
  StaffCertificationListPlaceholdersOverviewRouteImport.update({
    id: '/_placeholders/overview',
    path: '/overview',
    getParentRoute: () => StaffCertificationListRoute,
  } as any)

const StaffCertificationListPlaceholdersOperationActivityRouteRoute =
  StaffCertificationListPlaceholdersOperationActivityRouteImport.update({
    id: '/_placeholders/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffCertificationListRoute,
  } as any)

const StaffCertificationListPlaceholdersAlertsRouteRoute =
  StaffCertificationListPlaceholdersAlertsRouteImport.update({
    id: '/_placeholders/alerts',
    path: '/alerts',
    getParentRoute: () => StaffCertificationListRoute,
  } as any)

const StaffBusinessPartnerListPlaceholdersSettingsRouteRoute =
  StaffBusinessPartnerListPlaceholdersSettingsRouteImport.update({
    id: '/_placeholders/settings',
    path: '/settings',
    getParentRoute: () => StaffBusinessPartnerListRoute,
  } as any)

const StaffBusinessPartnerListPlaceholdersRuleAndPolicyRouteRoute =
  StaffBusinessPartnerListPlaceholdersRuleAndPolicyRouteImport.update({
    id: '/_placeholders/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffBusinessPartnerListRoute,
  } as any)

const StaffBusinessPartnerListPlaceholdersOperationActivityRouteRoute =
  StaffBusinessPartnerListPlaceholdersOperationActivityRouteImport.update({
    id: '/_placeholders/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffBusinessPartnerListRoute,
  } as any)

const StaffBusinessPartnerListPlaceholdersContractAndCostRouteRoute =
  StaffBusinessPartnerListPlaceholdersContractAndCostRouteImport.update({
    id: '/_placeholders/contract-and-cost',
    path: '/contract-and-cost',
    getParentRoute: () => StaffBusinessPartnerListRoute,
  } as any)

const StaffBusinessPartnerListPlaceholdersAlertsRouteRoute =
  StaffBusinessPartnerListPlaceholdersAlertsRouteImport.update({
    id: '/_placeholders/alerts',
    path: '/alerts',
    getParentRoute: () => StaffBusinessPartnerListRoute,
  } as any)

const StaffAttendancesLayoutClockingRecordsEmployeeIdRouteRoute =
  StaffAttendancesLayoutClockingRecordsEmployeeIdRouteImport.update({
    id: '/clocking-records/$employeeId',
    path: '/clocking-records/$employeeId',
    getParentRoute: () => StaffAttendancesLayoutRoute,
  } as any)

const IndividualIndividualPortalLookupPaySlipRouteRoute =
  IndividualIndividualPortalLookupPaySlipRouteImport.update({
    id: '/lookup/pay-slip',
    path: '/lookup/pay-slip',
    getParentRoute: () => IndividualIndividualPortalRoute,
  } as any)

const IndividualIndividualPortalLookupClockingRecordRouteRoute =
  IndividualIndividualPortalLookupClockingRecordRouteImport.update({
    id: '/lookup/clocking-record',
    path: '/lookup/clocking-record',
    getParentRoute: () => IndividualIndividualPortalRoute,
  } as any)

const StaffPersonIdProfileIndexRouteRoute =
  StaffPersonIdProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any)

const StaffSoftwareLayoutContractAndCostContractAndCostDealRoute =
  StaffSoftwareLayoutContractAndCostContractAndCostDealImport.update({
    id: '/deal',
    path: '/deal',
    getParentRoute: () =>
      StaffSoftwareLayoutContractAndCostContractAndCostRoute,
  } as any)

const StaffSettingsDataConnectorOutboundDataPipelineIdRoute =
  StaffSettingsDataConnectorOutboundDataPipelineIdImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => StaffSettingsDataConnectorOutboundDataPipelineRoute,
  } as any)

const StaffSettingsDataConnectorInboundDataPipelineIdRoute =
  StaffSettingsDataConnectorInboundDataPipelineIdImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => StaffSettingsDataConnectorInboundDataPipelineRoute,
  } as any)

const StaffSettingsDataConnectorInboundAggregateDataPipelineIdRoute =
  StaffSettingsDataConnectorInboundAggregateDataPipelineIdImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () =>
      StaffSettingsDataConnectorInboundAggregateDataPipelineRoute,
  } as any)

const StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRoute =
  StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdImport.update(
    {
      id: '/certifications/specialty-certifications/$personCertificationInformationId',
      path: '/certifications/specialty-certifications/$personCertificationInformationId',
      getParentRoute: () => StaffPersonIdRoute,
    } as any,
  )

const StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRoute =
  StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdImport.update(
    {
      id: '/certifications/handling-certifications/$personCertificationInformationId',
      path: '/certifications/handling-certifications/$personCertificationInformationId',
      getParentRoute: () => StaffPersonIdRoute,
    } as any,
  )

const StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRoute =
  StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdImport.update(
    {
      id: '/certifications/base-certifications/$personCertificationInformationId',
      path: '/certifications/base-certifications/$personCertificationInformationId',
      getParentRoute: () => StaffPersonIdRoute,
    } as any,
  )

const StaffDevicesListContractAndCostContractAndCostDealRoute =
  StaffDevicesListContractAndCostContractAndCostDealImport.update({
    id: '/deal',
    path: '/deal',
    getParentRoute: () => StaffDevicesListContractAndCostContractAndCostRoute,
  } as any)

const StaffDeviceCatalogActiveIdLayoutContractAndCostRoute =
  StaffDeviceCatalogActiveIdLayoutContractAndCostImport.update({
    id: '/contract-and-cost',
    path: '/contract-and-cost',
    getParentRoute: () => StaffDeviceCatalogActiveIdLayoutRoute,
  } as any)

const IndividualIndividualProfileCertificationsSpecialtyCertificationsIdRoute =
  IndividualIndividualProfileCertificationsSpecialtyCertificationsIdImport.update(
    {
      id: '/certifications/specialty-certifications/$id',
      path: '/certifications/specialty-certifications/$id',
      getParentRoute: () => IndividualIndividualProfileRoute,
    } as any,
  )

const IndividualIndividualProfileCertificationsHandlingCertificationsIdRoute =
  IndividualIndividualProfileCertificationsHandlingCertificationsIdImport.update(
    {
      id: '/certifications/handling-certifications/$id',
      path: '/certifications/handling-certifications/$id',
      getParentRoute: () => IndividualIndividualProfileRoute,
    } as any,
  )

const IndividualIndividualProfileCertificationsBaseCertificationsIdRoute =
  IndividualIndividualProfileCertificationsBaseCertificationsIdImport.update({
    id: '/certifications/base-certifications/$id',
    path: '/certifications/base-certifications/$id',
    getParentRoute: () => IndividualIndividualProfileRoute,
  } as any)

const StaffStorageFilesFoldersIdIdIndexLazyRoute =
  StaffStorageFilesFoldersIdIdIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffStorageFilesFoldersIdIdRoute,
  } as any).lazy(() =>
    import('./routes/_staff/storage-files/folders/$id/_$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffStorageFilesFilesIdIdIndexLazyRoute =
  StaffStorageFilesFilesIdIdIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffStorageFilesFilesIdIdRoute,
  } as any).lazy(() =>
    import('./routes/_staff/storage-files/files/$id/_$id/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffStarlinksIdLayoutDetailIndexLazyRoute =
  StaffStarlinksIdLayoutDetailIndexLazyImport.update({
    id: '/detail/',
    path: '/detail/',
    getParentRoute: () => StaffStarlinksIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/starlinks/$id/_layout/detail/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffStarlinksIdLayoutOverviewIndexLazyRoute =
  StaffStarlinksIdLayoutOverviewIndexLazyImport.update({
    id: '/_overview/',
    path: '/',
    getParentRoute: () => StaffStarlinksIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/starlinks/$id/_layout/_overview/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPlacesIdLayoutProfileIndexLazyRoute =
  StaffPlacesIdLayoutProfileIndexLazyImport.update({
    id: '/_profile/',
    path: '/',
    getParentRoute: () => StaffPlacesIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/places/$id/_layout/_profile/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPayrollLayoutPaySlipsEmployeeIdIndexLazyRoute =
  StaffPayrollLayoutPaySlipsEmployeeIdIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffPayrollLayoutPaySlipsEmployeeIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/payroll/_layout/pay-slips/$employeeId/index.lazy'
    ).then((d) => d.Route),
  )

const StaffNetworksIdLayoutProfileIndexLazyRoute =
  StaffNetworksIdLayoutProfileIndexLazyImport.update({
    id: '/_profile/',
    path: '/',
    getParentRoute: () => StaffNetworksIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/networks/$id/_layout/_profile/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffFleetsIdLayoutProfileIndexLazyRoute =
  StaffFleetsIdLayoutProfileIndexLazyImport.update({
    id: '/_profile/',
    path: '/',
    getParentRoute: () => StaffFleetsIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/fleets/$id/_layout/_profile/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffEquipmentIdLayoutStatusIndexLazyRoute =
  StaffEquipmentIdLayoutStatusIndexLazyImport.update({
    id: '/status/',
    path: '/status/',
    getParentRoute: () => StaffEquipmentIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/equipment/$id/_layout/status/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffEquipmentIdLayoutLifecycleIndexLazyRoute =
  StaffEquipmentIdLayoutLifecycleIndexLazyImport.update({
    id: '/lifecycle/',
    path: '/lifecycle/',
    getParentRoute: () => StaffEquipmentIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/equipment/$id/_layout/lifecycle/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffContractIdLayoutStructureIndexLazyRoute =
  StaffContractIdLayoutStructureIndexLazyImport.update({
    id: '/structure/',
    path: '/structure/',
    getParentRoute: () => StaffContractIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/contract/$id/_layout/structure/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffContractIdLayoutIndexIndexLazyRoute =
  StaffContractIdLayoutIndexIndexLazyImport.update({
    id: '/_index/',
    path: '/',
    getParentRoute: () => StaffContractIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/contract/$id/_layout/_index/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffAttendancesLayoutClockingRecordsEmployeeIdIndexLazyRoute =
  StaffAttendancesLayoutClockingRecordsEmployeeIdIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      StaffAttendancesLayoutClockingRecordsEmployeeIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/attendances/_layout/clocking-records/$employeeId/index.lazy'
    ).then((d) => d.Route),
  )

const IndividualIndividualPortalLookupPaySlipIndexLazyRoute =
  IndividualIndividualPortalLookupPaySlipIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => IndividualIndividualPortalLookupPaySlipRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_individual/individual/portal/lookup/pay-slip/index.lazy'
    ).then((d) => d.Route),
  )

const IndividualIndividualPortalLookupClockingRecordIndexLazyRoute =
  IndividualIndividualPortalLookupClockingRecordIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      IndividualIndividualPortalLookupClockingRecordRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_individual/individual/portal/lookup/clocking-record/index.lazy'
    ).then((d) => d.Route),
  )

const StaffUsersUserIdLayoutSessionsIndexRoute =
  StaffUsersUserIdLayoutSessionsIndexImport.update({
    id: '/sessions/',
    path: '/sessions/',
    getParentRoute: () => StaffUsersUserIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/users/$userId/_layout/sessions/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffUsersUserIdLayoutIdentityIndexRoute =
  StaffUsersUserIdLayoutIdentityIndexImport.update({
    id: '/_identity/',
    path: '/',
    getParentRoute: () => StaffUsersUserIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/users/$userId/_layout/_identity/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffTimeAndAttendanceLayoutAttendanceLinksPlaceIdIndexRoute =
  StaffTimeAndAttendanceLayoutAttendanceLinksPlaceIdIndexImport.update({
    id: '/attendance-links/$placeId/',
    path: '/attendance-links/$placeId/',
    getParentRoute: () => StaffTimeAndAttendanceLayoutRoute,
  } as any)

const StaffTimeAndAttendanceLayoutListSummaryIndexRoute =
  StaffTimeAndAttendanceLayoutListSummaryIndexImport.update({
    id: '/_list/summary/',
    path: '/summary/',
    getParentRoute: () => StaffTimeAndAttendanceLayoutRoute,
  } as any)

const StaffSupplierListSettingsSupplierSubcategoriesIndexRoute =
  StaffSupplierListSettingsSupplierSubcategoriesIndexImport.update({
    id: '/supplier-subcategories/',
    path: '/supplier-subcategories/',
    getParentRoute: () => StaffSupplierListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/supplier/_list/settings/supplier-subcategories/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSupplierListSettingsSupplierCategoriesIndexRoute =
  StaffSupplierListSettingsSupplierCategoriesIndexImport.update({
    id: '/supplier-categories/',
    path: '/supplier-categories/',
    getParentRoute: () => StaffSupplierListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/supplier/_list/settings/supplier-categories/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSupplierListSettingsProcurementCategoriesIndexRoute =
  StaffSupplierListSettingsProcurementCategoriesIndexImport.update({
    id: '/procurement-categories/',
    path: '/procurement-categories/',
    getParentRoute: () => StaffSupplierListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/supplier/_list/settings/procurement-categories/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSupplierSupplierIdLayoutIndexIndexRoute =
  StaffSupplierSupplierIdLayoutIndexIndexImport.update({
    id: '/_index/',
    path: '/',
    getParentRoute: () => StaffSupplierSupplierIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/supplier/$supplierId/_layout/_index/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSoftwareCustomSaasAddCustomSaasTypeIndexRoute =
  StaffSoftwareCustomSaasAddCustomSaasTypeIndexImport.update({
    id: '/custom-saas/add/$customSaasType/',
    path: '/custom-saas/add/$customSaasType/',
    getParentRoute: () => StaffSoftwareRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/software/custom-saas/add/$customSaasType/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSoftwareLayoutLibrarySearchIndexRoute =
  StaffSoftwareLayoutLibrarySearchIndexImport.update({
    id: '/library/search/',
    path: '/library/search/',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/software/_layout/library/search/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffSoftwareLayoutContractAndCostContractAndCostIndexRoute =
  StaffSoftwareLayoutContractAndCostContractAndCostIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      StaffSoftwareLayoutContractAndCostContractAndCostRoute,
  } as any)

const StaffSoftwareLayoutAlertsAlertsIndexRoute =
  StaffSoftwareLayoutAlertsAlertsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffSoftwareLayoutAlertsAlertsRoute,
  } as any)

const StaffSoftwareIdIdSettingsIndexRoute =
  StaffSoftwareIdIdSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffSoftwareIdIdSettingsRouteLazyRoute,
  } as any)

const StaffSoftwareIdIdRuleAndPolicyIndexRoute =
  StaffSoftwareIdIdRuleAndPolicyIndexImport.update({
    id: '/rule-and-policy/',
    path: '/rule-and-policy/',
    getParentRoute: () => StaffSoftwareIdIdRoute,
  } as any)

const StaffSoftwareIdIdDetailIndexRoute =
  StaffSoftwareIdIdDetailIndexImport.update({
    id: '/detail/',
    path: '/detail/',
    getParentRoute: () => StaffSoftwareIdIdRoute,
  } as any)

const StaffSoftwareIdIdArchitectureIndexRoute =
  StaffSoftwareIdIdArchitectureIndexImport.update({
    id: '/architecture/',
    path: '/architecture/',
    getParentRoute: () => StaffSoftwareIdIdRoute,
  } as any)

const StaffSoftwareIdIdAlertsIndexRoute =
  StaffSoftwareIdIdAlertsIndexImport.update({
    id: '/alerts/',
    path: '/alerts/',
    getParentRoute: () => StaffSoftwareIdIdRoute,
  } as any).lazy(() =>
    import('./routes/_staff/software/$id/_$id/alerts/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffSoftwareIdIdActivityMonitoringIndexRoute =
  StaffSoftwareIdIdActivityMonitoringIndexImport.update({
    id: '/activity-monitoring/',
    path: '/activity-monitoring/',
    getParentRoute: () => StaffSoftwareIdIdRoute,
  } as any)

const StaffSoftwareIdIdAccountsIndexRoute =
  StaffSoftwareIdIdAccountsIndexImport.update({
    id: '/accounts/',
    path: '/accounts/',
    getParentRoute: () => StaffSoftwareIdIdRoute,
  } as any).lazy(() =>
    import('./routes/_staff/software/$id/_$id/accounts/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffSettingsPersonsListSettingsIndexRoute =
  StaffSettingsPersonsListSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => StaffSettingsPersonsListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/settings/persons/_list/settings/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffSettingsPermissionAndRolesListRolesIndexRoute =
  StaffSettingsPermissionAndRolesListRolesIndexImport.update({
    id: '/roles/',
    path: '/roles/',
    getParentRoute: () => StaffSettingsPermissionAndRolesListRoute,
  } as any)

const StaffSettingsPermissionAndRolesListProductPermissionsIndexRoute =
  StaffSettingsPermissionAndRolesListProductPermissionsIndexImport.update({
    id: '/product-permissions/',
    path: '/product-permissions/',
    getParentRoute: () => StaffSettingsPermissionAndRolesListRoute,
  } as any)

const StaffSettingsPermissionAndRolesListPeopleGroupsIndexRoute =
  StaffSettingsPermissionAndRolesListPeopleGroupsIndexImport.update({
    id: '/people-groups/',
    path: '/people-groups/',
    getParentRoute: () => StaffSettingsPermissionAndRolesListRoute,
  } as any)

const StaffSettingsPermissionAndRolesListCategoryPermissionsIndexRoute =
  StaffSettingsPermissionAndRolesListCategoryPermissionsIndexImport.update({
    id: '/category-permissions/',
    path: '/category-permissions/',
    getParentRoute: () => StaffSettingsPermissionAndRolesListRoute,
  } as any)

const StaffSettingsContractingCorporationProfileLayoutShareholdersIndexRoute =
  StaffSettingsContractingCorporationProfileLayoutShareholdersIndexImport.update(
    {
      id: '/shareholders/',
      path: '/shareholders/',
      getParentRoute: () =>
        StaffSettingsContractingCorporationProfileLayoutRoute,
    } as any,
  )

const StaffSettingsContractingCorporationProfileLayoutRegistrationIndexRoute =
  StaffSettingsContractingCorporationProfileLayoutRegistrationIndexImport.update(
    {
      id: '/registration/',
      path: '/registration/',
      getParentRoute: () =>
        StaffSettingsContractingCorporationProfileLayoutRoute,
    } as any,
  )

const StaffSettingsContractingCorporationProfileLayoutHistoryIndexRoute =
  StaffSettingsContractingCorporationProfileLayoutHistoryIndexImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => StaffSettingsContractingCorporationProfileLayoutRoute,
  } as any)

const StaffSettingsContractingCorporationProfileLayoutGroupCompaniesIndexRoute =
  StaffSettingsContractingCorporationProfileLayoutGroupCompaniesIndexImport.update(
    {
      id: '/group-companies/',
      path: '/group-companies/',
      getParentRoute: () =>
        StaffSettingsContractingCorporationProfileLayoutRoute,
    } as any,
  )

const StaffSettingsContractingCorporationProfileLayoutCorporateOverviewIndexRoute =
  StaffSettingsContractingCorporationProfileLayoutCorporateOverviewIndexImport.update(
    {
      id: '/corporate-overview/',
      path: '/corporate-overview/',
      getParentRoute: () =>
        StaffSettingsContractingCorporationProfileLayoutRoute,
    } as any,
  )

const StaffSettingsContractingCorporationProfileLayoutContactPointsIndexRoute =
  StaffSettingsContractingCorporationProfileLayoutContactPointsIndexImport.update(
    {
      id: '/contact-points/',
      path: '/contact-points/',
      getParentRoute: () =>
        StaffSettingsContractingCorporationProfileLayoutRoute,
    } as any,
  )

const StaffSettingsContractingCorporationProfileLayoutBoardMemberIndexRoute =
  StaffSettingsContractingCorporationProfileLayoutBoardMemberIndexImport.update(
    {
      id: '/board-member/',
      path: '/board-member/',
      getParentRoute: () =>
        StaffSettingsContractingCorporationProfileLayoutRoute,
    } as any,
  )

const StaffPlacesLayoutSettingsPlaceSubCodesIndexRoute =
  StaffPlacesLayoutSettingsPlaceSubCodesIndexImport.update({
    id: '/place-sub-codes/',
    path: '/place-sub-codes/',
    getParentRoute: () => StaffPlacesLayoutSettingsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/places/_layout/settings/place-sub-codes/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPlacesIdLayoutLaborCoreIndexRoute =
  StaffPlacesIdLayoutLaborCoreIndexImport.update({
    id: '/labor-core/',
    path: '/labor-core/',
    getParentRoute: () => StaffPlacesIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/places/$id/_layout/labor-core/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPlacesIdLayoutAdministratorsIndexRoute =
  StaffPlacesIdLayoutAdministratorsIndexImport.update({
    id: '/administrators/',
    path: '/administrators/',
    getParentRoute: () => StaffPlacesIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/places/$id/_layout/administrators/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPersonExternalHrSaasAppIntegrationIdPreviewIndexRoute =
  StaffPersonExternalHrSaasAppIntegrationIdPreviewIndexImport.update({
    id: '/person/external-hr-saas/$appIntegrationId/preview/',
    path: '/person/external-hr-saas/$appIntegrationId/preview/',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffPersonIdProfilePublicIdIndexRoute =
  StaffPersonIdProfilePublicIdIndexImport.update({
    id: '/public-id/',
    path: '/public-id/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any)

const StaffPersonIdProfilePersonalInformationIndexRoute =
  StaffPersonIdProfilePersonalInformationIndexImport.update({
    id: '/personal-information/',
    path: '/personal-information/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any)

const StaffPersonIdProfileOperationActivityIndexRoute =
  StaffPersonIdProfileOperationActivityIndexImport.update({
    id: '/operation-activity/',
    path: '/operation-activity/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/person/$id/_profile/operation-activity/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPersonIdProfileHistoryIndexRoute =
  StaffPersonIdProfileHistoryIndexImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any)

const StaffPersonIdProfileEquipmentIndexRoute =
  StaffPersonIdProfileEquipmentIndexImport.update({
    id: '/equipment/',
    path: '/equipment/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any)

const StaffPersonIdProfileEmployeeInformationIndexRoute =
  StaffPersonIdProfileEmployeeInformationIndexImport.update({
    id: '/employee-information/',
    path: '/employee-information/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any)

const StaffPersonIdProfileEducationAndQualificationIndexRoute =
  StaffPersonIdProfileEducationAndQualificationIndexImport.update({
    id: '/education-and-qualification/',
    path: '/education-and-qualification/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any)

const StaffPersonIdProfileDevicesIndexRoute =
  StaffPersonIdProfileDevicesIndexImport.update({
    id: '/devices/',
    path: '/devices/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any)

const StaffPersonIdProfileContractorInformationIndexRoute =
  StaffPersonIdProfileContractorInformationIndexImport.update({
    id: '/contractor-information/',
    path: '/contractor-information/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any)

const StaffPersonIdProfileAppsIndexRoute =
  StaffPersonIdProfileAppsIndexImport.update({
    id: '/apps/',
    path: '/apps/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any).lazy(() =>
    import('./routes/_staff/person/$id/_profile/apps/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPeopleListSettingsWorkModeIndexRoute =
  StaffPeopleListSettingsWorkModeIndexImport.update({
    id: '/work-mode/',
    path: '/work-mode/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_staff/people/_list/settings/work-mode/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPeopleListSettingsRetirementReasonsIndexRoute =
  StaffPeopleListSettingsRetirementReasonsIndexImport.update({
    id: '/retirement-reasons/',
    path: '/retirement-reasons/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/people/_list/settings/retirement-reasons/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPeopleListSettingsPositionsIndexRoute =
  StaffPeopleListSettingsPositionsIndexImport.update({
    id: '/positions/',
    path: '/positions/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_staff/people/_list/settings/positions/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPeopleListSettingsPlaceSocialInsurancesIndexRoute =
  StaffPeopleListSettingsPlaceSocialInsurancesIndexImport.update({
    id: '/place-social-insurances/',
    path: '/place-social-insurances/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/people/_list/settings/place-social-insurances/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPeopleListSettingsJobTypesIndexRoute =
  StaffPeopleListSettingsJobTypesIndexImport.update({
    id: '/job-types/',
    path: '/job-types/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_staff/people/_list/settings/job-types/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPeopleListSettingsJobTitlesIndexRoute =
  StaffPeopleListSettingsJobTitlesIndexImport.update({
    id: '/job-titles/',
    path: '/job-titles/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_staff/people/_list/settings/job-titles/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPeopleListSettingsJobLevelsIndexRoute =
  StaffPeopleListSettingsJobLevelsIndexImport.update({
    id: '/job-levels/',
    path: '/job-levels/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_staff/people/_list/settings/job-levels/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPeopleListSettingsJobGradesIndexRoute =
  StaffPeopleListSettingsJobGradesIndexImport.update({
    id: '/job-grades/',
    path: '/job-grades/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_staff/people/_list/settings/job-grades/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPeopleListSettingsJobFunctionsIndexRoute =
  StaffPeopleListSettingsJobFunctionsIndexImport.update({
    id: '/job-functions/',
    path: '/job-functions/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/people/_list/settings/job-functions/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPeopleListSettingsJobCompetenciesIndexRoute =
  StaffPeopleListSettingsJobCompetenciesIndexImport.update({
    id: '/job-competencies/',
    path: '/job-competencies/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/people/_list/settings/job-competencies/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPeopleListSettingsHealthInsuranceAssociationsIndexRoute =
  StaffPeopleListSettingsHealthInsuranceAssociationsIndexImport.update({
    id: '/health-insurance-associations/',
    path: '/health-insurance-associations/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/people/_list/settings/health-insurance-associations/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPeopleListSettingsGradesIndexRoute =
  StaffPeopleListSettingsGradesIndexImport.update({
    id: '/grades/',
    path: '/grades/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_staff/people/_list/settings/grades/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPeopleListSettingsEmploymentTypesIndexRoute =
  StaffPeopleListSettingsEmploymentTypesIndexImport.update({
    id: '/employment-types/',
    path: '/employment-types/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/people/_list/settings/employment-types/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPeopleListSettingsEmployeeSubIdNamesIndexRoute =
  StaffPeopleListSettingsEmployeeSubIdNamesIndexImport.update({
    id: '/employee-sub-id-names/',
    path: '/employee-sub-id-names/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/people/_list/settings/employee-sub-id-names/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPeopleListSettingsContractorTypesIndexRoute =
  StaffPeopleListSettingsContractorTypesIndexImport.update({
    id: '/contractor-types/',
    path: '/contractor-types/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/people/_list/settings/contractor-types/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPeopleListSettingsContractEndReasonsIndexRoute =
  StaffPeopleListSettingsContractEndReasonsIndexImport.update({
    id: '/contract-end-reasons/',
    path: '/contract-end-reasons/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/people/_list/settings/contract-end-reasons/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPeopleListSettingsCollaboratorTypesIndexRoute =
  StaffPeopleListSettingsCollaboratorTypesIndexImport.update({
    id: '/collaborator-types/',
    path: '/collaborator-types/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/people/_list/settings/collaborator-types/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPeopleListSettingsBoardMemberTypesIndexRoute =
  StaffPeopleListSettingsBoardMemberTypesIndexImport.update({
    id: '/board-member-types/',
    path: '/board-member-types/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/people/_list/settings/board-member-types/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPayrollLayoutContractAndCostContractAndCostIndexRoute =
  StaffPayrollLayoutContractAndCostContractAndCostIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffPayrollLayoutContractAndCostContractAndCostRoute,
  } as any)

const StaffPayrollEngineLayoutPayrollUnitsUnitIdIndexRoute =
  StaffPayrollEngineLayoutPayrollUnitsUnitIdIndexImport.update({
    id: '/payroll-units/$unitId/',
    path: '/payroll-units/$unitId/',
    getParentRoute: () => StaffPayrollEngineLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/payroll-engine/_layout/payroll-units/$unitId/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPayrollEngineLayoutLogicComponentsComponentIdIndexRoute =
  StaffPayrollEngineLayoutLogicComponentsComponentIdIndexImport.update({
    id: '/logic-components/$componentId/',
    path: '/logic-components/$componentId/',
    getParentRoute: () => StaffPayrollEngineLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/payroll-engine/_layout/logic-components/$componentId/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPayrollEngineLayoutItemsComponentIdIndexRoute =
  StaffPayrollEngineLayoutItemsComponentIdIndexImport.update({
    id: '/items/$componentId/',
    path: '/items/$componentId/',
    getParentRoute: () => StaffPayrollEngineLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/payroll-engine/_layout/items/$componentId/index.lazy'
    ).then((d) => d.Route),
  )

const StaffOrganizationPlanIdTransfersIndexRoute =
  StaffOrganizationPlanIdTransfersIndexImport.update({
    id: '/plan/$id/transfers/',
    path: '/plan/$id/transfers/',
    getParentRoute: () => StaffOrganizationRoute,
  } as any)

const StaffOrganizationPlanIdAddIndexRoute =
  StaffOrganizationPlanIdAddIndexImport.update({
    id: '/plan/$id/add/',
    path: '/plan/$id/add/',
    getParentRoute: () => StaffOrganizationRoute,
  } as any)

const StaffOrganizationIdLayoutHistoryIndexRoute =
  StaffOrganizationIdLayoutHistoryIndexImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => StaffOrganizationIdLayoutRoute,
  } as any)

const StaffMarketplaceSentOrdersOrderIdLayoutIndexRoute =
  StaffMarketplaceSentOrdersOrderIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffMarketplaceSentOrdersOrderIdLayoutRoute,
  } as any)

const StaffMarketplaceStoreStoreStarlinksIndexRoute =
  StaffMarketplaceStoreStoreStarlinksIndexImport.update({
    id: '/store/starlinks/',
    path: '/store/starlinks/',
    getParentRoute: () => StaffMarketplaceStoreRoute,
  } as any)

const StaffMarketplaceStoreStoreSentOrdersIndexRoute =
  StaffMarketplaceStoreStoreSentOrdersIndexImport.update({
    id: '/store/sent-orders/',
    path: '/store/sent-orders/',
    getParentRoute: () => StaffMarketplaceStoreRoute,
  } as any)

const StaffMarketplaceStoreStoreSalesOrdersIndexRoute =
  StaffMarketplaceStoreStoreSalesOrdersIndexImport.update({
    id: '/store/sales-orders/',
    path: '/store/sales-orders/',
    getParentRoute: () => StaffMarketplaceStoreRoute,
  } as any)

const StaffMarketplaceStoreStoreLicensesIndexRoute =
  StaffMarketplaceStoreStoreLicensesIndexImport.update({
    id: '/store/licenses/',
    path: '/store/licenses/',
    getParentRoute: () => StaffMarketplaceStoreRoute,
  } as any)

const StaffMarketplaceStoreStoreDevicesIndexRoute =
  StaffMarketplaceStoreStoreDevicesIndexImport.update({
    id: '/store/devices/',
    path: '/store/devices/',
    getParentRoute: () => StaffMarketplaceStoreRoute,
  } as any)

const StaffLicensesIdProfileServicePlansIndexRoute =
  StaffLicensesIdProfileServicePlansIndexImport.update({
    id: '/service-plans/',
    path: '/service-plans/',
    getParentRoute: () => StaffLicensesIdProfileRoute,
  } as any)

const StaffLicensesIdProfileRuleAndPolicyIndexRoute =
  StaffLicensesIdProfileRuleAndPolicyIndexImport.update({
    id: '/rule-and-policy/',
    path: '/rule-and-policy/',
    getParentRoute: () => StaffLicensesIdProfileRoute,
  } as any)

const StaffLicensesIdProfilePeopleIndexRoute =
  StaffLicensesIdProfilePeopleIndexImport.update({
    id: '/people/',
    path: '/people/',
    getParentRoute: () => StaffLicensesIdProfileRoute,
  } as any)

const StaffLicensesIdProfileAssignmentsIndexRoute =
  StaffLicensesIdProfileAssignmentsIndexImport.update({
    id: '/assignments/',
    path: '/assignments/',
    getParentRoute: () => StaffLicensesIdProfileRoute,
  } as any)

const StaffItOperationCoreDetailOperationInstancesInstanceIdIndexRoute =
  StaffItOperationCoreDetailOperationInstancesInstanceIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      StaffItOperationCoreDetailOperationInstancesInstanceIdRoute,
  } as any)

const StaffIdsGroupIdAddFromScratchIndexRoute =
  StaffIdsGroupIdAddFromScratchIndexImport.update({
    id: '/group-id/add/from-scratch/',
    path: '/group-id/add/from-scratch/',
    getParentRoute: () => StaffIdsRoute,
  } as any).lazy(() =>
    import('./routes/_staff/ids/group-id/add/from-scratch/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffIdsGroupIdIdIdIndexRoute = StaffIdsGroupIdIdIdIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffIdsGroupIdIdIdRoute,
} as any)

const StaffEquipmentItemsIdDetailIndexRoute =
  StaffEquipmentItemsIdDetailIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffEquipmentItemsIdDetailRoute,
  } as any)

const StaffEquipmentLayoutSettingsEquipmentTypesIndexRoute =
  StaffEquipmentLayoutSettingsEquipmentTypesIndexImport.update({
    id: '/equipment-types/',
    path: '/equipment-types/',
    getParentRoute: () => StaffEquipmentLayoutSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/equipment/_layout/settings/equipment-types/index.lazy'
    ).then((d) => d.Route),
  )

const StaffEquipmentLayoutSettingsEquipmentItemsIndexRoute =
  StaffEquipmentLayoutSettingsEquipmentItemsIndexImport.update({
    id: '/equipment-items/',
    path: '/equipment-items/',
    getParentRoute: () => StaffEquipmentLayoutSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/equipment/_layout/settings/equipment-items/index.lazy'
    ).then((d) => d.Route),
  )

const StaffDevicesExternalItSaasAppIntegrationIdPreviewIndexRoute =
  StaffDevicesExternalItSaasAppIntegrationIdPreviewIndexImport.update({
    id: '/external-it-saas/$appIntegrationId/preview/',
    path: '/external-it-saas/$appIntegrationId/preview/',
    getParentRoute: () => StaffDevicesRoute,
  } as any)

const StaffDevicesAddCatalogDeviceTypeIndexRoute =
  StaffDevicesAddCatalogDeviceTypeIndexImport.update({
    id: '/add/catalog/$deviceType/',
    path: '/add/catalog/$deviceType/',
    getParentRoute: () => StaffDevicesRoute,
  } as any)

const StaffDevicesListSettingsCatalogIndexRoute =
  StaffDevicesListSettingsCatalogIndexImport.update({
    id: '/catalog/',
    path: '/catalog/',
    getParentRoute: () => StaffDevicesListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_staff/devices/_list/settings/catalog/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffDevicesListContractAndCostContractAndCostIndexRoute =
  StaffDevicesListContractAndCostContractAndCostIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffDevicesListContractAndCostContractAndCostRoute,
  } as any)

const StaffDevicesIdLayoutStatusIndexRoute =
  StaffDevicesIdLayoutStatusIndexImport.update({
    id: '/status/',
    path: '/status/',
    getParentRoute: () => StaffDevicesIdLayoutRoute,
  } as any)

const StaffDevicesIdLayoutProfileIndexRoute =
  StaffDevicesIdLayoutProfileIndexImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => StaffDevicesIdLayoutRoute,
  } as any)

const StaffDevicesIdLayoutMdmIndexRoute =
  StaffDevicesIdLayoutMdmIndexImport.update({
    id: '/mdm/',
    path: '/mdm/',
    getParentRoute: () => StaffDevicesIdLayoutRoute,
  } as any)

const StaffDevicesIdLayoutLifecycleIndexRoute =
  StaffDevicesIdLayoutLifecycleIndexImport.update({
    id: '/lifecycle/',
    path: '/lifecycle/',
    getParentRoute: () => StaffDevicesIdLayoutRoute,
  } as any)

const StaffDevicesIdLayoutHistoryIndexRoute =
  StaffDevicesIdLayoutHistoryIndexImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => StaffDevicesIdLayoutRoute,
  } as any)

const StaffDevicesIdLayoutFilesIndexRoute =
  StaffDevicesIdLayoutFilesIndexImport.update({
    id: '/files/',
    path: '/files/',
    getParentRoute: () => StaffDevicesIdLayoutRoute,
  } as any)

const StaffDevicesIdLayoutControlIndexRoute =
  StaffDevicesIdLayoutControlIndexImport.update({
    id: '/control/',
    path: '/control/',
    getParentRoute: () => StaffDevicesIdLayoutRoute,
  } as any)

const StaffDealDealIdLayoutIndexIndexRoute =
  StaffDealDealIdLayoutIndexIndexImport.update({
    id: '/_index/',
    path: '/',
    getParentRoute: () => StaffDealDealIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/deal/$dealId/_layout/_index/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffCertificationListSettingsSpecialtyCategoryIndexRoute =
  StaffCertificationListSettingsSpecialtyCategoryIndexImport.update({
    id: '/specialty-category/',
    path: '/specialty-category/',
    getParentRoute: () => StaffCertificationListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/certification/_list/settings/specialty-category/index.lazy'
    ).then((d) => d.Route),
  )

const StaffCertificationListSettingsSpecialtyCategoryLevelIndexRoute =
  StaffCertificationListSettingsSpecialtyCategoryLevelIndexImport.update({
    id: '/specialty-category-level/',
    path: '/specialty-category-level/',
    getParentRoute: () => StaffCertificationListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/certification/_list/settings/specialty-category-level/index.lazy'
    ).then((d) => d.Route),
  )

const StaffCertificationListSettingsIssuingOrganizationIndexRoute =
  StaffCertificationListSettingsIssuingOrganizationIndexImport.update({
    id: '/issuing-organization/',
    path: '/issuing-organization/',
    getParentRoute: () => StaffCertificationListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/certification/_list/settings/issuing-organization/index.lazy'
    ).then((d) => d.Route),
  )

const StaffCertificationIdLayoutSpecialtyCertificationsIndexRoute =
  StaffCertificationIdLayoutSpecialtyCertificationsIndexImport.update({
    id: '/specialty-certifications/',
    path: '/specialty-certifications/',
    getParentRoute: () => StaffCertificationIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/certification/$id/_layout/specialty-certifications/index.lazy'
    ).then((d) => d.Route),
  )

const StaffCertificationIdLayoutHandlingCertificationsIndexRoute =
  StaffCertificationIdLayoutHandlingCertificationsIndexImport.update({
    id: '/handling-certifications/',
    path: '/handling-certifications/',
    getParentRoute: () => StaffCertificationIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/certification/$id/_layout/handling-certifications/index.lazy'
    ).then((d) => d.Route),
  )

const StaffCertificationIdLayoutCertificationHoldersIndexRoute =
  StaffCertificationIdLayoutCertificationHoldersIndexImport.update({
    id: '/certification-holders/',
    path: '/certification-holders/',
    getParentRoute: () => StaffCertificationIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/certification/$id/_layout/certification-holders/index.lazy'
    ).then((d) => d.Route),
  )

const StaffCertificationIdLayoutIndexIndexRoute =
  StaffCertificationIdLayoutIndexIndexImport.update({
    id: '/_index/',
    path: '/',
    getParentRoute: () => StaffCertificationIdLayoutRoute,
  } as any)

const StaffBusinessPartnerIdLayoutAddressAndContactIndexRoute =
  StaffBusinessPartnerIdLayoutAddressAndContactIndexImport.update({
    id: '/address-and-contact/',
    path: '/address-and-contact/',
    getParentRoute: () => StaffBusinessPartnerIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/business-partner/$id/_layout/address-and-contact/index.lazy'
    ).then((d) => d.Route),
  )

const StaffBusinessPartnerIdLayoutIndexIndexRoute =
  StaffBusinessPartnerIdLayoutIndexIndexImport.update({
    id: '/_index/',
    path: '/',
    getParentRoute: () => StaffBusinessPartnerIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/business-partner/$id/_layout/_index/index.lazy'
    ).then((d) => d.Route),
  )

const StaffAttendanceEngineLayoutLogicComponentsComponentIdIndexRoute =
  StaffAttendanceEngineLayoutLogicComponentsComponentIdIndexImport.update({
    id: '/logic-components/$componentId/',
    path: '/logic-components/$componentId/',
    getParentRoute: () => StaffAttendanceEngineLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/attendance-engine/_layout/logic-components/$componentId/index.lazy'
    ).then((d) => d.Route),
  )

const StaffAttendanceEngineLayoutItemsComponentIdIndexRoute =
  StaffAttendanceEngineLayoutItemsComponentIdIndexImport.update({
    id: '/items/$componentId/',
    path: '/items/$componentId/',
    getParentRoute: () => StaffAttendanceEngineLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/attendance-engine/_layout/items/$componentId/index.lazy'
    ).then((d) => d.Route),
  )

const StaffAttendanceEngineLayoutAttendanceUnitsUnitIdIndexRoute =
  StaffAttendanceEngineLayoutAttendanceUnitsUnitIdIndexImport.update({
    id: '/attendance-units/$unitId/',
    path: '/attendance-units/$unitId/',
    getParentRoute: () => StaffAttendanceEngineLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/attendance-engine/_layout/attendance-units/$unitId/index.lazy'
    ).then((d) => d.Route),
  )

const StaffAccessesLayoutListTraceableAppIdIndexRoute =
  StaffAccessesLayoutListTraceableAppIdIndexImport.update({
    id: '/list/$traceableAppId/',
    path: '/list/$traceableAppId/',
    getParentRoute: () => StaffAccessesLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/accesses/_layout/list/$traceableAppId/index.lazy'
    ).then((d) => d.Route),
  )

const StacktraceValuesIdLayoutProductScopeIndexRoute =
  StacktraceValuesIdLayoutProductScopeIndexImport.update({
    id: '/product-scope/',
    path: '/product-scope/',
    getParentRoute: () => StacktraceValuesIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_stacktrace/values/$id/_layout/product-scope/index.lazy'
    ).then((d) => d.Route),
  )

const StacktraceValuesIdLayoutHistoryIndexRoute =
  StacktraceValuesIdLayoutHistoryIndexImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => StacktraceValuesIdLayoutRoute,
  } as any)

const StacktraceTestSuitesIdLayoutTestSetIndexRoute =
  StacktraceTestSuitesIdLayoutTestSetIndexImport.update({
    id: '/test-set/',
    path: '/test-set/',
    getParentRoute: () => StacktraceTestSuitesIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_stacktrace/test-suites/$id/_layout/test-set/index.lazy'
    ).then((d) => d.Route),
  )

const StacktraceTestSuitesIdLayoutTargetFunctionsIndexRoute =
  StacktraceTestSuitesIdLayoutTargetFunctionsIndexImport.update({
    id: '/target-functions/',
    path: '/target-functions/',
    getParentRoute: () => StacktraceTestSuitesIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_stacktrace/test-suites/$id/_layout/target-functions/index.lazy'
    ).then((d) => d.Route),
  )

const StacktraceTestSuitesIdLayoutOverviewIndexRoute =
  StacktraceTestSuitesIdLayoutOverviewIndexImport.update({
    id: '/overview/',
    path: '/overview/',
    getParentRoute: () => StacktraceTestSuitesIdLayoutRoute,
  } as any)

const StacktraceTestSuitesIdLayoutIssuesIndexRoute =
  StacktraceTestSuitesIdLayoutIssuesIndexImport.update({
    id: '/issues/',
    path: '/issues/',
    getParentRoute: () => StacktraceTestSuitesIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_stacktrace/test-suites/$id/_layout/issues/index.lazy'
    ).then((d) => d.Route),
  )

const StacktraceTestSuitesIdLayoutDocumentIndexRoute =
  StacktraceTestSuitesIdLayoutDocumentIndexImport.update({
    id: '/document/',
    path: '/document/',
    getParentRoute: () => StacktraceTestSuitesIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_stacktrace/test-suites/$id/_layout/document/index.lazy'
    ).then((d) => d.Route),
  )

const StacktraceTestSetsIdLayoutTargetFunctionsIndexRoute =
  StacktraceTestSetsIdLayoutTargetFunctionsIndexImport.update({
    id: '/target-functions/',
    path: '/target-functions/',
    getParentRoute: () => StacktraceTestSetsIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_stacktrace/test-sets/$id/_layout/target-functions/index.lazy'
    ).then((d) => d.Route),
  )

const StacktraceTestSetsIdLayoutConditionsIndexRoute =
  StacktraceTestSetsIdLayoutConditionsIndexImport.update({
    id: '/conditions/',
    path: '/conditions/',
    getParentRoute: () => StacktraceTestSetsIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_stacktrace/test-sets/$id/_layout/conditions/index.lazy'
    ).then((d) => d.Route),
  )

const StacktraceProductsIdLayoutProductScopeIndexRoute =
  StacktraceProductsIdLayoutProductScopeIndexImport.update({
    id: '/product-scope/',
    path: '/product-scope/',
    getParentRoute: () => StacktraceProductsIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_stacktrace/products/$id/_layout/product-scope/index.lazy'
    ).then((d) => d.Route),
  )

const StacktraceProductionProductionIdLayoutValueIndexRoute =
  StacktraceProductionProductionIdLayoutValueIndexImport.update({
    id: '/value/',
    path: '/value/',
    getParentRoute: () => StacktraceProductionProductionIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_stacktrace/production/$productionId/_layout/value/index.lazy'
    ).then((d) => d.Route),
  )

const StacktraceProductionProductionIdLayoutQualityScopeIndexRoute =
  StacktraceProductionProductionIdLayoutQualityScopeIndexImport.update({
    id: '/quality-scope/',
    path: '/quality-scope/',
    getParentRoute: () => StacktraceProductionProductionIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_stacktrace/production/$productionId/_layout/quality-scope/index.lazy'
    ).then((d) => d.Route),
  )

const StacktraceProductionProductionIdLayoutProductScopeIndexRoute =
  StacktraceProductionProductionIdLayoutProductScopeIndexImport.update({
    id: '/product-scope/',
    path: '/product-scope/',
    getParentRoute: () => StacktraceProductionProductionIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_stacktrace/production/$productionId/_layout/product-scope/index.lazy'
    ).then((d) => d.Route),
  )

const StacktraceProductionProductionIdLayoutIssueScopeIndexRoute =
  StacktraceProductionProductionIdLayoutIssueScopeIndexImport.update({
    id: '/issue-scope/',
    path: '/issue-scope/',
    getParentRoute: () => StacktraceProductionProductionIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_stacktrace/production/$productionId/_layout/issue-scope/index.lazy'
    ).then((d) => d.Route),
  )

const StacktraceProductionProductionIdLayoutDevScopeIndexRoute =
  StacktraceProductionProductionIdLayoutDevScopeIndexImport.update({
    id: '/dev-scope/',
    path: '/dev-scope/',
    getParentRoute: () => StacktraceProductionProductionIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_stacktrace/production/$productionId/_layout/dev-scope/index.lazy'
    ).then((d) => d.Route),
  )

const StacktraceProductRoadmapRoadmapIdLayoutHistoryIndexRoute =
  StacktraceProductRoadmapRoadmapIdLayoutHistoryIndexImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => StacktraceProductRoadmapRoadmapIdLayoutRoute,
  } as any)

const StacktraceProductRoadmapRoadmapIdLayoutDetailIndexRoute =
  StacktraceProductRoadmapRoadmapIdLayoutDetailIndexImport.update({
    id: '/detail/',
    path: '/detail/',
    getParentRoute: () => StacktraceProductRoadmapRoadmapIdLayoutRoute,
  } as any)

const StacktraceIssuesIdLayoutHistoryIndexRoute =
  StacktraceIssuesIdLayoutHistoryIndexImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => StacktraceIssuesIdLayoutRoute,
  } as any)

const StacktraceDevelopmentTicketsTicketIdLayoutHistoryIndexRoute =
  StacktraceDevelopmentTicketsTicketIdLayoutHistoryIndexImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => StacktraceDevelopmentTicketsTicketIdLayoutRoute,
  } as any)

const IndividualIndividualTaskIdApprovalIndexRoute =
  IndividualIndividualTaskIdApprovalIndexImport.update({
    id: '/task/$id/approval/',
    path: '/task/$id/approval/',
    getParentRoute: () => IndividualIndividualRoute,
  } as any)

const StaffPayrollLayoutPaySlipsEmployeeIdSettingsLazyRoute =
  StaffPayrollLayoutPaySlipsEmployeeIdSettingsLazyImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => StaffPayrollLayoutPaySlipsEmployeeIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/payroll/_layout/pay-slips/$employeeId/settings.lazy'
    ).then((d) => d.Route),
  )

const StaffPayrollLayoutPaySlipsEmployeeIdOverviewLazyRoute =
  StaffPayrollLayoutPaySlipsEmployeeIdOverviewLazyImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => StaffPayrollLayoutPaySlipsEmployeeIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/payroll/_layout/pay-slips/$employeeId/overview.lazy'
    ).then((d) => d.Route),
  )

const StaffPayrollLayoutPaySlipsEmployeeIdHistoryLazyRoute =
  StaffPayrollLayoutPaySlipsEmployeeIdHistoryLazyImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => StaffPayrollLayoutPaySlipsEmployeeIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/payroll/_layout/pay-slips/$employeeId/history.lazy'
    ).then((d) => d.Route),
  )

const StaffPayrollLayoutPaySlipsEmployeeIdFilesLazyRoute =
  StaffPayrollLayoutPaySlipsEmployeeIdFilesLazyImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () => StaffPayrollLayoutPaySlipsEmployeeIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/payroll/_layout/pay-slips/$employeeId/files.lazy'
    ).then((d) => d.Route),
  )

const StaffPayrollLayoutPaySlipsEmployeeIdAlertsLazyRoute =
  StaffPayrollLayoutPaySlipsEmployeeIdAlertsLazyImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => StaffPayrollLayoutPaySlipsEmployeeIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/payroll/_layout/pay-slips/$employeeId/alerts.lazy'
    ).then((d) => d.Route),
  )

const StaffAttendancesLayoutClockingRecordsEmployeeIdSettingsLazyRoute =
  StaffAttendancesLayoutClockingRecordsEmployeeIdSettingsLazyImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () =>
      StaffAttendancesLayoutClockingRecordsEmployeeIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/attendances/_layout/clocking-records/$employeeId/settings.lazy'
    ).then((d) => d.Route),
  )

const StaffAttendancesLayoutClockingRecordsEmployeeIdScheduleLazyRoute =
  StaffAttendancesLayoutClockingRecordsEmployeeIdScheduleLazyImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () =>
      StaffAttendancesLayoutClockingRecordsEmployeeIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/attendances/_layout/clocking-records/$employeeId/schedule.lazy'
    ).then((d) => d.Route),
  )

const StaffAttendancesLayoutClockingRecordsEmployeeIdOverviewLazyRoute =
  StaffAttendancesLayoutClockingRecordsEmployeeIdOverviewLazyImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () =>
      StaffAttendancesLayoutClockingRecordsEmployeeIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/attendances/_layout/clocking-records/$employeeId/overview.lazy'
    ).then((d) => d.Route),
  )

const StaffAttendancesLayoutClockingRecordsEmployeeIdFilesLazyRoute =
  StaffAttendancesLayoutClockingRecordsEmployeeIdFilesLazyImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () =>
      StaffAttendancesLayoutClockingRecordsEmployeeIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/attendances/_layout/clocking-records/$employeeId/files.lazy'
    ).then((d) => d.Route),
  )

const StaffAttendancesLayoutClockingRecordsEmployeeIdAlertsLazyRoute =
  StaffAttendancesLayoutClockingRecordsEmployeeIdAlertsLazyImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () =>
      StaffAttendancesLayoutClockingRecordsEmployeeIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/attendances/_layout/clocking-records/$employeeId/alerts.lazy'
    ).then((d) => d.Route),
  )

const IndividualIndividualPortalLookupPaySlipOverviewLazyRoute =
  IndividualIndividualPortalLookupPaySlipOverviewLazyImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => IndividualIndividualPortalLookupPaySlipRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_individual/individual/portal/lookup/pay-slip/overview.lazy'
    ).then((d) => d.Route),
  )

const IndividualIndividualPortalLookupPaySlipHistoryLazyRoute =
  IndividualIndividualPortalLookupPaySlipHistoryLazyImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => IndividualIndividualPortalLookupPaySlipRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_individual/individual/portal/lookup/pay-slip/history.lazy'
    ).then((d) => d.Route),
  )

const IndividualIndividualPortalLookupPaySlipFilesLazyRoute =
  IndividualIndividualPortalLookupPaySlipFilesLazyImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () => IndividualIndividualPortalLookupPaySlipRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_individual/individual/portal/lookup/pay-slip/files.lazy'
    ).then((d) => d.Route),
  )

const IndividualIndividualPortalLookupPaySlipAlertsLazyRoute =
  IndividualIndividualPortalLookupPaySlipAlertsLazyImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => IndividualIndividualPortalLookupPaySlipRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_individual/individual/portal/lookup/pay-slip/alerts.lazy'
    ).then((d) => d.Route),
  )

const IndividualIndividualPortalLookupClockingRecordScheduleLazyRoute =
  IndividualIndividualPortalLookupClockingRecordScheduleLazyImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () =>
      IndividualIndividualPortalLookupClockingRecordRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_individual/individual/portal/lookup/clocking-record/schedule.lazy'
    ).then((d) => d.Route),
  )

const IndividualIndividualPortalLookupClockingRecordOverviewLazyRoute =
  IndividualIndividualPortalLookupClockingRecordOverviewLazyImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () =>
      IndividualIndividualPortalLookupClockingRecordRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_individual/individual/portal/lookup/clocking-record/overview.lazy'
    ).then((d) => d.Route),
  )

const IndividualIndividualPortalLookupClockingRecordFilesLazyRoute =
  IndividualIndividualPortalLookupClockingRecordFilesLazyImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () =>
      IndividualIndividualPortalLookupClockingRecordRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_individual/individual/portal/lookup/clocking-record/files.lazy'
    ).then((d) => d.Route),
  )

const IndividualIndividualPortalLookupClockingRecordAlertsLazyRoute =
  IndividualIndividualPortalLookupClockingRecordAlertsLazyImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () =>
      IndividualIndividualPortalLookupClockingRecordRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_individual/individual/portal/lookup/clocking-record/alerts.lazy'
    ).then((d) => d.Route),
  )

const StaffSoftwareIdIdContractAndCostContractAndCostRoute =
  StaffSoftwareIdIdContractAndCostContractAndCostImport.update({
    id: '/_contract-and-cost',
    getParentRoute: () => StaffSoftwareIdIdContractAndCostRoute,
  } as any)

const StaffSettingsDataConnectorOutboundDataPipelineListRoute =
  StaffSettingsDataConnectorOutboundDataPipelineListImport.update({
    id: '/_list',
    getParentRoute: () => StaffSettingsDataConnectorOutboundDataPipelineRoute,
  } as any)

const StaffSettingsDataConnectorInboundDataPipelineListRoute =
  StaffSettingsDataConnectorInboundDataPipelineListImport.update({
    id: '/_list',
    getParentRoute: () => StaffSettingsDataConnectorInboundDataPipelineRoute,
  } as any)

const StaffSettingsDataConnectorInboundAggregateDataPipelineListRoute =
  StaffSettingsDataConnectorInboundAggregateDataPipelineListImport.update({
    id: '/_list',
    getParentRoute: () =>
      StaffSettingsDataConnectorInboundAggregateDataPipelineRoute,
  } as any)

const StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutRoute =
  StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () =>
      StaffPayrollEngineLayoutPayrollStructuresStructureIdRoute,
  } as any)

const StaffMarketplaceSentOrdersOrderIdLayoutActivitiesRoute =
  StaffMarketplaceSentOrdersOrderIdLayoutActivitiesImport.update({
    id: '/activities',
    path: '/activities',
    getParentRoute: () => StaffMarketplaceSentOrdersOrderIdLayoutRoute,
  } as any)

const StaffLicensesIdServicePlansLicenseServiceIdDetailRoute =
  StaffLicensesIdServicePlansLicenseServiceIdDetailImport.update({
    id: '/_detail',
    getParentRoute: () => StaffLicensesIdServicePlansLicenseServiceIdRoute,
  } as any)

const StaffItOperationCoreRootInHousePackagesPackageIdStartTargetsRoute =
  StaffItOperationCoreRootInHousePackagesPackageIdStartTargetsImport.update({
    id: '/start-targets',
    path: '/start-targets',
    getParentRoute: () => StaffItOperationCoreRootInHousePackagesPackageIdRoute,
  } as any)

const StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRoute =
  StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () =>
      StaffItOperationCoreDetailOperationInstancesInstanceIdRoute,
  } as any)

const StaffIdsGroupIdAddFromScratchCompletedRoute =
  StaffIdsGroupIdAddFromScratchCompletedImport.update({
    id: '/group-id/add/from-scratch/completed',
    path: '/group-id/add/from-scratch/completed',
    getParentRoute: () => StaffIdsRoute,
  } as any)

const StaffDevicesAddCatalogDeviceTypeCompletedRoute =
  StaffDevicesAddCatalogDeviceTypeCompletedImport.update({
    id: '/add/catalog/$deviceType/completed',
    path: '/add/catalog/$deviceType/completed',
    getParentRoute: () => StaffDevicesRoute,
  } as any)

const StaffBusinessPartnerIdLayoutBpRoleInfoLayoutRoute =
  StaffBusinessPartnerIdLayoutBpRoleInfoLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StaffBusinessPartnerIdLayoutBpRoleInfoRoute,
  } as any)

const StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutRoute =
  StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        StaffAttendanceEngineLayoutAttendanceStructuresStructureIdRoute,
    } as any,
  )

const StacktraceTestSuitesIdLayoutTestReviewLayoutRoute =
  StacktraceTestSuitesIdLayoutTestReviewLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StacktraceTestSuitesIdLayoutTestReviewRoute,
  } as any)

const StacktraceTestSuitesIdLayoutTestPlanLayoutRoute =
  StacktraceTestSuitesIdLayoutTestPlanLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StacktraceTestSuitesIdLayoutTestPlanRoute,
  } as any)

const StacktraceProductsIdScopeNodeIdLayoutRoute =
  StacktraceProductsIdScopeNodeIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StacktraceProductsIdScopeNodeIdRoute,
  } as any)

const StaffContractIdLayoutPlaceholdersRuleAndPolicyRouteRoute =
  StaffContractIdLayoutPlaceholdersRuleAndPolicyRouteImport.update({
    id: '/_placeholders/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffContractIdLayoutRoute,
  } as any)

const StaffContractIdLayoutPlaceholdersRiskProvisionsRouteRoute =
  StaffContractIdLayoutPlaceholdersRiskProvisionsRouteImport.update({
    id: '/_placeholders/risk-provisions',
    path: '/risk-provisions',
    getParentRoute: () => StaffContractIdLayoutRoute,
  } as any)

const StaffContractIdLayoutPlaceholdersOperationActivityRouteRoute =
  StaffContractIdLayoutPlaceholdersOperationActivityRouteImport.update({
    id: '/_placeholders/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffContractIdLayoutRoute,
  } as any)

const StaffContractIdLayoutPlaceholdersHistoryRouteRoute =
  StaffContractIdLayoutPlaceholdersHistoryRouteImport.update({
    id: '/_placeholders/history',
    path: '/history',
    getParentRoute: () => StaffContractIdLayoutRoute,
  } as any)

const StaffContractIdLayoutPlaceholdersApprovalInfoRouteRoute =
  StaffContractIdLayoutPlaceholdersApprovalInfoRouteImport.update({
    id: '/_placeholders/approval-info',
    path: '/approval-info',
    getParentRoute: () => StaffContractIdLayoutRoute,
  } as any)

const StaffPersonAlumniIdProfileIndexRouteRoute =
  StaffPersonAlumniIdProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffPersonAlumniIdProfileRoute,
  } as any)

const IndividualIndividualProfileMyProfileLayoutIndexRouteRoute =
  IndividualIndividualProfileMyProfileLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => IndividualIndividualProfileMyProfileLayoutRoute,
  } as any)

const StaffSoftwareIdIdContractAndCostContractAndCostDealRoute =
  StaffSoftwareIdIdContractAndCostContractAndCostDealImport.update({
    id: '/deal',
    path: '/deal',
    getParentRoute: () => StaffSoftwareIdIdContractAndCostContractAndCostRoute,
  } as any)

const StaffEquipmentItemsIdDetailProfileIndexLazyRoute =
  StaffEquipmentItemsIdDetailProfileIndexLazyImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => StaffEquipmentItemsIdDetailRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/equipment/items/$id/_detail/profile/index.lazy'
    ).then((d) => d.Route),
  )

const StaffTimeAndAttendanceLayoutListSummaryMonthlyPlaceIndexRoute =
  StaffTimeAndAttendanceLayoutListSummaryMonthlyPlaceIndexImport.update({
    id: '/_list/summary/monthly-place/',
    path: '/summary/monthly-place/',
    getParentRoute: () => StaffTimeAndAttendanceLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/time-and-attendance/_layout/_list/summary/monthly-place/index.lazy'
    ).then((d) => d.Route),
  )

const StaffTimeAndAttendanceLayoutListSummaryMonthlyPersonIndexRoute =
  StaffTimeAndAttendanceLayoutListSummaryMonthlyPersonIndexImport.update({
    id: '/_list/summary/monthly-person/',
    path: '/summary/monthly-person/',
    getParentRoute: () => StaffTimeAndAttendanceLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/time-and-attendance/_layout/_list/summary/monthly-person/index.lazy'
    ).then((d) => d.Route),
  )

const StaffTimeAndAttendanceLayoutListSummaryDailyPlaceIndexRoute =
  StaffTimeAndAttendanceLayoutListSummaryDailyPlaceIndexImport.update({
    id: '/_list/summary/daily-place/',
    path: '/summary/daily-place/',
    getParentRoute: () => StaffTimeAndAttendanceLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/time-and-attendance/_layout/_list/summary/daily-place/index.lazy'
    ).then((d) => d.Route),
  )

const StaffStorageFilesFoldersIdIdUsersIndexRoute =
  StaffStorageFilesFoldersIdIdUsersIndexImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => StaffStorageFilesFoldersIdIdRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/storage-files/folders/$id/_$id/users/index.lazy'
    ).then((d) => d.Route),
  )

const StaffStorageFilesFoldersIdIdFilesIndexRoute =
  StaffStorageFilesFoldersIdIdFilesIndexImport.update({
    id: '/files/',
    path: '/files/',
    getParentRoute: () => StaffStorageFilesFoldersIdIdRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/storage-files/folders/$id/_$id/files/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSoftwareLayoutLibraryDetailSoftwareLibraryIdIndexRoute =
  StaffSoftwareLayoutLibraryDetailSoftwareLibraryIdIndexImport.update({
    id: '/library/detail/$softwareLibraryId/',
    path: '/library/detail/$softwareLibraryId/',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/software/_layout/library/detail/$softwareLibraryId/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSoftwareLayoutLibraryCategoryCategoryIndexRoute =
  StaffSoftwareLayoutLibraryCategoryCategoryIndexImport.update({
    id: '/library/category/$category/',
    path: '/library/category/$category/',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/software/_layout/library/category/$category/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSoftwareLayoutContractAndCostContractAndCostPaymentIndexRoute =
  StaffSoftwareLayoutContractAndCostContractAndCostPaymentIndexImport.update({
    id: '/payment/',
    path: '/payment/',
    getParentRoute: () =>
      StaffSoftwareLayoutContractAndCostContractAndCostRoute,
  } as any)

const StaffSoftwareLayoutContractAndCostContractAndCostCostIndexRoute =
  StaffSoftwareLayoutContractAndCostContractAndCostCostIndexImport.update({
    id: '/cost/',
    path: '/cost/',
    getParentRoute: () =>
      StaffSoftwareLayoutContractAndCostContractAndCostRoute,
  } as any)

const StaffSoftwareLayoutAlertsAlertsViolatedRoleIndexRoute =
  StaffSoftwareLayoutAlertsAlertsViolatedRoleIndexImport.update({
    id: '/violated-role/',
    path: '/violated-role/',
    getParentRoute: () => StaffSoftwareLayoutAlertsAlertsRoute,
  } as any)

const StaffSoftwareLayoutAlertsAlertsViolatedAssignmentIndexRoute =
  StaffSoftwareLayoutAlertsAlertsViolatedAssignmentIndexImport.update({
    id: '/violated-assignment/',
    path: '/violated-assignment/',
    getParentRoute: () => StaffSoftwareLayoutAlertsAlertsRoute,
  } as any)

const StaffSoftwareLayoutAlertsAlertsNoWorkerIndexRoute =
  StaffSoftwareLayoutAlertsAlertsNoWorkerIndexImport.update({
    id: '/no-worker/',
    path: '/no-worker/',
    getParentRoute: () => StaffSoftwareLayoutAlertsAlertsRoute,
  } as any)

const StaffSoftwareLayoutAlertsAlertsNoUserIndexRoute =
  StaffSoftwareLayoutAlertsAlertsNoUserIndexImport.update({
    id: '/no-user/',
    path: '/no-user/',
    getParentRoute: () => StaffSoftwareLayoutAlertsAlertsRoute,
  } as any)

const StaffSoftwareLayoutAlertsAlertsInactiveUserIndexRoute =
  StaffSoftwareLayoutAlertsAlertsInactiveUserIndexImport.update({
    id: '/inactive-user/',
    path: '/inactive-user/',
    getParentRoute: () => StaffSoftwareLayoutAlertsAlertsRoute,
  } as any)

const StaffSoftwareLayoutAlertsAlertsAlumniIndexRoute =
  StaffSoftwareLayoutAlertsAlertsAlumniIndexImport.update({
    id: '/alumni/',
    path: '/alumni/',
    getParentRoute: () => StaffSoftwareLayoutAlertsAlertsRoute,
  } as any)

const StaffSoftwareIdIdSettingsStatusIndexRoute =
  StaffSoftwareIdIdSettingsStatusIndexImport.update({
    id: '/status/',
    path: '/status/',
    getParentRoute: () => StaffSoftwareIdIdSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_staff/software/$id/_$id/settings/status/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffSoftwareIdIdSettingsRoleIndexRoute =
  StaffSoftwareIdIdSettingsRoleIndexImport.update({
    id: '/role/',
    path: '/role/',
    getParentRoute: () => StaffSoftwareIdIdSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_staff/software/$id/_$id/settings/role/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffSoftwareIdIdSettingsIntegrationIndexRoute =
  StaffSoftwareIdIdSettingsIntegrationIndexImport.update({
    id: '/integration/',
    path: '/integration/',
    getParentRoute: () => StaffSoftwareIdIdSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/software/$id/_$id/settings/integration/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSoftwareIdIdContractAndCostContractAndCostIndexRoute =
  StaffSoftwareIdIdContractAndCostContractAndCostIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffSoftwareIdIdContractAndCostContractAndCostRoute,
  } as any)

const StaffSettingsPersonsListAccountStaffIndexRoute =
  StaffSettingsPersonsListAccountStaffIndexImport.update({
    id: '/staff/',
    path: '/staff/',
    getParentRoute: () => StaffSettingsPersonsListAccountRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/settings/persons/_list/_account/staff/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSettingsPersonsListAccountIndividualIndexRoute =
  StaffSettingsPersonsListAccountIndividualIndexImport.update({
    id: '/individual/',
    path: '/individual/',
    getParentRoute: () => StaffSettingsPersonsListAccountRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/settings/persons/_list/_account/individual/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSettingsPermissionAndRolesFormRolesNewIndexRoute =
  StaffSettingsPermissionAndRolesFormRolesNewIndexImport.update({
    id: '/roles/new/',
    path: '/roles/new/',
    getParentRoute: () => StaffSettingsPermissionAndRolesFormRoute,
  } as any)

const StaffSettingsPermissionAndRolesFormProductPermissionsNewIndexRoute =
  StaffSettingsPermissionAndRolesFormProductPermissionsNewIndexImport.update({
    id: '/product-permissions/new/',
    path: '/product-permissions/new/',
    getParentRoute: () => StaffSettingsPermissionAndRolesFormRoute,
  } as any)

const StaffSettingsPermissionAndRolesFormPeopleGroupsNewIndexRoute =
  StaffSettingsPermissionAndRolesFormPeopleGroupsNewIndexImport.update({
    id: '/people-groups/new/',
    path: '/people-groups/new/',
    getParentRoute: () => StaffSettingsPermissionAndRolesFormRoute,
  } as any)

const StaffSettingsPermissionAndRolesFormCategoryPermissionsNewIndexRoute =
  StaffSettingsPermissionAndRolesFormCategoryPermissionsNewIndexImport.update({
    id: '/category-permissions/new/',
    path: '/category-permissions/new/',
    getParentRoute: () => StaffSettingsPermissionAndRolesFormRoute,
  } as any)

const StaffSettingsPermissionAndRolesDetailRolesIdIndexRoute =
  StaffSettingsPermissionAndRolesDetailRolesIdIndexImport.update({
    id: '/roles/$id/',
    path: '/roles/$id/',
    getParentRoute: () => StaffSettingsPermissionAndRolesDetailRoute,
  } as any)

const StaffSettingsPermissionAndRolesDetailProductPermissionsIdIndexRoute =
  StaffSettingsPermissionAndRolesDetailProductPermissionsIdIndexImport.update({
    id: '/product-permissions/$id/',
    path: '/product-permissions/$id/',
    getParentRoute: () => StaffSettingsPermissionAndRolesDetailRoute,
  } as any)

const StaffSettingsPermissionAndRolesDetailPeopleGroupsIdIndexRoute =
  StaffSettingsPermissionAndRolesDetailPeopleGroupsIdIndexImport.update({
    id: '/people-groups/$id/',
    path: '/people-groups/$id/',
    getParentRoute: () => StaffSettingsPermissionAndRolesDetailRoute,
  } as any)

const StaffSettingsPermissionAndRolesDetailCategoryPermissionsIdIndexRoute =
  StaffSettingsPermissionAndRolesDetailCategoryPermissionsIdIndexImport.update({
    id: '/category-permissions/$id/',
    path: '/category-permissions/$id/',
    getParentRoute: () => StaffSettingsPermissionAndRolesDetailRoute,
  } as any)

const StaffSettingsDataConnectorOutboundDataPipelineAddIndexRoute =
  StaffSettingsDataConnectorOutboundDataPipelineAddIndexImport.update({
    id: '/add/',
    path: '/add/',
    getParentRoute: () => StaffSettingsDataConnectorOutboundDataPipelineRoute,
  } as any)

const StaffSettingsDataConnectorOutboundDataPipelineListIndexRoute =
  StaffSettingsDataConnectorOutboundDataPipelineListIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      StaffSettingsDataConnectorOutboundDataPipelineListRoute,
  } as any)

const StaffSettingsDataConnectorInboundDataPipelineAddIndexRoute =
  StaffSettingsDataConnectorInboundDataPipelineAddIndexImport.update({
    id: '/add/',
    path: '/add/',
    getParentRoute: () => StaffSettingsDataConnectorInboundDataPipelineRoute,
  } as any)

const StaffSettingsDataConnectorInboundDataPipelineListIndexRoute =
  StaffSettingsDataConnectorInboundDataPipelineListIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      StaffSettingsDataConnectorInboundDataPipelineListRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/settings/data-connector/inbound/data-pipeline/_list/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSettingsDataConnectorInboundAggregateDataPipelineAddIndexRoute =
  StaffSettingsDataConnectorInboundAggregateDataPipelineAddIndexImport.update({
    id: '/add/',
    path: '/add/',
    getParentRoute: () =>
      StaffSettingsDataConnectorInboundAggregateDataPipelineRoute,
  } as any)

const StaffSettingsDataConnectorInboundAggregateDataPipelineListIndexRoute =
  StaffSettingsDataConnectorInboundAggregateDataPipelineListIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      StaffSettingsDataConnectorInboundAggregateDataPipelineListRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/settings/data-connector/inbound/aggregate-data-pipeline/_list/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPersonAlumniIdProfilePublicIdIndexRoute =
  StaffPersonAlumniIdProfilePublicIdIndexImport.update({
    id: '/public-id/',
    path: '/public-id/',
    getParentRoute: () => StaffPersonAlumniIdProfileRoute,
  } as any)

const StaffPersonAlumniIdProfilePersonalInformationIndexRoute =
  StaffPersonAlumniIdProfilePersonalInformationIndexImport.update({
    id: '/personal-information/',
    path: '/personal-information/',
    getParentRoute: () => StaffPersonAlumniIdProfileRoute,
  } as any)

const StaffPersonAlumniIdProfileOperationActivityIndexRoute =
  StaffPersonAlumniIdProfileOperationActivityIndexImport.update({
    id: '/operation-activity/',
    path: '/operation-activity/',
    getParentRoute: () => StaffPersonAlumniIdProfileRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/person/alumni/$id/_profile/operation-activity/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPersonAlumniIdProfileHistoryIndexRoute =
  StaffPersonAlumniIdProfileHistoryIndexImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => StaffPersonAlumniIdProfileRoute,
  } as any)

const StaffPersonAlumniIdProfileEquipmentIndexRoute =
  StaffPersonAlumniIdProfileEquipmentIndexImport.update({
    id: '/equipment/',
    path: '/equipment/',
    getParentRoute: () => StaffPersonAlumniIdProfileRoute,
  } as any)

const StaffPersonAlumniIdProfileEmployeeInformationIndexRoute =
  StaffPersonAlumniIdProfileEmployeeInformationIndexImport.update({
    id: '/employee-information/',
    path: '/employee-information/',
    getParentRoute: () => StaffPersonAlumniIdProfileRoute,
  } as any)

const StaffPersonAlumniIdProfileEducationAndQualificationIndexRoute =
  StaffPersonAlumniIdProfileEducationAndQualificationIndexImport.update({
    id: '/education-and-qualification/',
    path: '/education-and-qualification/',
    getParentRoute: () => StaffPersonAlumniIdProfileRoute,
  } as any)

const StaffPersonAlumniIdProfileDevicesIndexRoute =
  StaffPersonAlumniIdProfileDevicesIndexImport.update({
    id: '/devices/',
    path: '/devices/',
    getParentRoute: () => StaffPersonAlumniIdProfileRoute,
  } as any)

const StaffPersonAlumniIdProfileContractorInformationIndexRoute =
  StaffPersonAlumniIdProfileContractorInformationIndexImport.update({
    id: '/contractor-information/',
    path: '/contractor-information/',
    getParentRoute: () => StaffPersonAlumniIdProfileRoute,
  } as any)

const StaffPersonAlumniIdProfileAppsIndexRoute =
  StaffPersonAlumniIdProfileAppsIndexImport.update({
    id: '/apps/',
    path: '/apps/',
    getParentRoute: () => StaffPersonAlumniIdProfileRoute,
  } as any).lazy(() =>
    import('./routes/_staff/person/alumni/$id/_profile/apps/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPersonIdProfileFamilyFamilyPersonIdIndexRoute =
  StaffPersonIdProfileFamilyFamilyPersonIdIndexImport.update({
    id: '/family/$familyPersonId/',
    path: '/family/$familyPersonId/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any)

const StaffPayrollLayoutContractAndCostContractAndCostPaymentIndexRoute =
  StaffPayrollLayoutContractAndCostContractAndCostPaymentIndexImport.update({
    id: '/payment/',
    path: '/payment/',
    getParentRoute: () => StaffPayrollLayoutContractAndCostContractAndCostRoute,
  } as any)

const StaffPayrollLayoutContractAndCostContractAndCostDealIndexRoute =
  StaffPayrollLayoutContractAndCostContractAndCostDealIndexImport.update({
    id: '/deal/',
    path: '/deal/',
    getParentRoute: () => StaffPayrollLayoutContractAndCostContractAndCostRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/deal/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPayrollLayoutContractAndCostContractAndCostCostIndexRoute =
  StaffPayrollLayoutContractAndCostContractAndCostCostIndexImport.update({
    id: '/cost/',
    path: '/cost/',
    getParentRoute: () => StaffPayrollLayoutContractAndCostContractAndCostRoute,
  } as any)

const StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutIndexRoute =
  StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout/index.lazy'
    ).then((d) => d.Route),
  )

const StaffOrganizationPlanIdEditUnitIdIndexRoute =
  StaffOrganizationPlanIdEditUnitIdIndexImport.update({
    id: '/plan/$id/edit/$unitId/',
    path: '/plan/$id/edit/$unitId/',
    getParentRoute: () => StaffOrganizationRoute,
  } as any)

const StaffMarketplaceStoreStoreStarlinksProductIdIndexRoute =
  StaffMarketplaceStoreStoreStarlinksProductIdIndexImport.update({
    id: '/store/starlinks/$productId/',
    path: '/store/starlinks/$productId/',
    getParentRoute: () => StaffMarketplaceStoreRoute,
  } as any)

const StaffMarketplaceStoreStoreLicensesProductIdIndexRoute =
  StaffMarketplaceStoreStoreLicensesProductIdIndexImport.update({
    id: '/store/licenses/$productId/',
    path: '/store/licenses/$productId/',
    getParentRoute: () => StaffMarketplaceStoreRoute,
  } as any)

const StaffMarketplaceStoreStoreDevicesProductIdIndexRoute =
  StaffMarketplaceStoreStoreDevicesProductIdIndexImport.update({
    id: '/store/devices/$productId/',
    path: '/store/devices/$productId/',
    getParentRoute: () => StaffMarketplaceStoreRoute,
  } as any)

const StaffIdsGroupIdIdIdSoftwaresIndexRoute =
  StaffIdsGroupIdIdIdSoftwaresIndexImport.update({
    id: '/softwares/',
    path: '/softwares/',
    getParentRoute: () => StaffIdsGroupIdIdIdRoute,
  } as any)

const StaffIdsGroupIdIdIdSecurityAndAuthIndexRoute =
  StaffIdsGroupIdIdIdSecurityAndAuthIndexImport.update({
    id: '/security-and-auth/',
    path: '/security-and-auth/',
    getParentRoute: () => StaffIdsGroupIdIdIdRoute,
  } as any)

const StaffIdsGroupIdIdIdRuleAndPolicyIndexRoute =
  StaffIdsGroupIdIdIdRuleAndPolicyIndexImport.update({
    id: '/rule-and-policy/',
    path: '/rule-and-policy/',
    getParentRoute: () => StaffIdsGroupIdIdIdRoute,
  } as any)

const StaffIdsGroupIdIdIdMembersIndexRoute =
  StaffIdsGroupIdIdIdMembersIndexImport.update({
    id: '/members/',
    path: '/members/',
    getParentRoute: () => StaffIdsGroupIdIdIdRoute,
  } as any).lazy(() =>
    import('./routes/_staff/ids/group-id/$id/_$id/members/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffIdsGroupIdIdIdDevicesIndexRoute =
  StaffIdsGroupIdIdIdDevicesIndexImport.update({
    id: '/devices/',
    path: '/devices/',
    getParentRoute: () => StaffIdsGroupIdIdIdRoute,
  } as any)

const StaffIdsGroupIdIdIdDetailIndexRoute =
  StaffIdsGroupIdIdIdDetailIndexImport.update({
    id: '/detail/',
    path: '/detail/',
    getParentRoute: () => StaffIdsGroupIdIdIdRoute,
  } as any)

const StaffEquipmentItemsIdDetailRuleAndPolicyIndexRoute =
  StaffEquipmentItemsIdDetailRuleAndPolicyIndexImport.update({
    id: '/rule-and-policy/',
    path: '/rule-and-policy/',
    getParentRoute: () => StaffEquipmentItemsIdDetailRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/equipment/items/$id/_detail/rule-and-policy/index.lazy'
    ).then((d) => d.Route),
  )

const StaffEquipmentItemsIdDetailInventoryIndexRoute =
  StaffEquipmentItemsIdDetailInventoryIndexImport.update({
    id: '/inventory/',
    path: '/inventory/',
    getParentRoute: () => StaffEquipmentItemsIdDetailRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/equipment/items/$id/_detail/inventory/index.lazy'
    ).then((d) => d.Route),
  )

const StaffEquipmentItemsIdDetailAlertsIndexRoute =
  StaffEquipmentItemsIdDetailAlertsIndexImport.update({
    id: '/alerts/',
    path: '/alerts/',
    getParentRoute: () => StaffEquipmentItemsIdDetailRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/equipment/items/$id/_detail/alerts/index.lazy'
    ).then((d) => d.Route),
  )

const StaffDevicesListContractAndCostContractAndCostPaymentIndexRoute =
  StaffDevicesListContractAndCostContractAndCostPaymentIndexImport.update({
    id: '/payment/',
    path: '/payment/',
    getParentRoute: () => StaffDevicesListContractAndCostContractAndCostRoute,
  } as any)

const StaffDevicesListContractAndCostContractAndCostCostIndexRoute =
  StaffDevicesListContractAndCostContractAndCostCostIndexImport.update({
    id: '/cost/',
    path: '/cost/',
    getParentRoute: () => StaffDevicesListContractAndCostContractAndCostRoute,
  } as any)

const StaffDeviceCatalogDraftIdLayoutProfileIndexRoute =
  StaffDeviceCatalogDraftIdLayoutProfileIndexImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => StaffDeviceCatalogDraftIdLayoutRoute,
  } as any)

const StaffDeviceCatalogActiveIdLayoutProfileIndexRoute =
  StaffDeviceCatalogActiveIdLayoutProfileIndexImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => StaffDeviceCatalogActiveIdLayoutRoute,
  } as any)

const StaffCertificationSpecialtyCertificationIdLayoutHandlingCertificationsIndexRoute =
  StaffCertificationSpecialtyCertificationIdLayoutHandlingCertificationsIndexImport.update(
    {
      id: '/handling-certifications/',
      path: '/handling-certifications/',
      getParentRoute: () =>
        StaffCertificationSpecialtyCertificationIdLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_staff/certification/specialty-certification/$id/_layout/handling-certifications/index.lazy'
    ).then((d) => d.Route),
  )

const StaffCertificationSpecialtyCertificationIdLayoutCertificationHoldersIndexRoute =
  StaffCertificationSpecialtyCertificationIdLayoutCertificationHoldersIndexImport.update(
    {
      id: '/certification-holders/',
      path: '/certification-holders/',
      getParentRoute: () =>
        StaffCertificationSpecialtyCertificationIdLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_staff/certification/specialty-certification/$id/_layout/certification-holders/index.lazy'
    ).then((d) => d.Route),
  )

const StaffCertificationSpecialtyCertificationIdLayoutIndexIndexRoute =
  StaffCertificationSpecialtyCertificationIdLayoutIndexIndexImport.update({
    id: '/_index/',
    path: '/',
    getParentRoute: () => StaffCertificationSpecialtyCertificationIdLayoutRoute,
  } as any)

const StaffCertificationHandlingCertificationIdLayoutCertificationHoldersIndexRoute =
  StaffCertificationHandlingCertificationIdLayoutCertificationHoldersIndexImport.update(
    {
      id: '/certification-holders/',
      path: '/certification-holders/',
      getParentRoute: () =>
        StaffCertificationHandlingCertificationIdLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_staff/certification/handling-certification/$id/_layout/certification-holders/index.lazy'
    ).then((d) => d.Route),
  )

const StaffCertificationHandlingCertificationIdLayoutIndexIndexRoute =
  StaffCertificationHandlingCertificationIdLayoutIndexIndexImport.update({
    id: '/_index/',
    path: '/',
    getParentRoute: () => StaffCertificationHandlingCertificationIdLayoutRoute,
  } as any)

const StaffBusinessPartnerIdLayoutBpRoleInfoLayoutIndexRoute =
  StaffBusinessPartnerIdLayoutBpRoleInfoLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffBusinessPartnerIdLayoutBpRoleInfoLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/business-partner/$id/_layout/bp-role-info/_layout/index.lazy'
    ).then((d) => d.Route),
  )

const StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutIndexRoute =
  StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutRoute,
    } as any,
  )

const StaffAccessesLayoutAlertsDormancySoftwareIdIndexRoute =
  StaffAccessesLayoutAlertsDormancySoftwareIdIndexImport.update({
    id: '/alerts/dormancy/$softwareId/',
    path: '/alerts/dormancy/$softwareId/',
    getParentRoute: () => StaffAccessesLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/accesses/_layout/alerts/dormancy/$softwareId/index.lazy'
    ).then((d) => d.Route),
  )

const StaffAccessesLayoutAlertsDetailShadowItAppIdIndexRoute =
  StaffAccessesLayoutAlertsDetailShadowItAppIdIndexImport.update({
    id: '/alerts/detail/$shadowItAppId/',
    path: '/alerts/detail/$shadowItAppId/',
    getParentRoute: () => StaffAccessesLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/accesses/_layout/alerts/detail/$shadowItAppId/index.lazy'
    ).then((d) => d.Route),
  )

const StacktraceTestSuitesIdLayoutTestReviewLayoutIndexRoute =
  StacktraceTestSuitesIdLayoutTestReviewLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StacktraceTestSuitesIdLayoutTestReviewLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_stacktrace/test-suites/$id/_layout/test-review/_layout/index.lazy'
    ).then((d) => d.Route),
  )

const StacktraceTestSuitesIdLayoutTestPlanLayoutIndexRoute =
  StacktraceTestSuitesIdLayoutTestPlanLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StacktraceTestSuitesIdLayoutTestPlanLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_stacktrace/test-suites/$id/_layout/test-plan/_layout/index.lazy'
    ).then((d) => d.Route),
  )

const StacktraceProductsIdScopeNodeIdLayoutIndexRoute =
  StacktraceProductsIdScopeNodeIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StacktraceProductsIdScopeNodeIdLayoutRoute,
  } as any)

const StacktraceProductionProductionIdLayoutValueEditIndexRoute =
  StacktraceProductionProductionIdLayoutValueEditIndexImport.update({
    id: '/value/edit/',
    path: '/value/edit/',
    getParentRoute: () => StacktraceProductionProductionIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_stacktrace/production/$productionId/_layout/value/edit/index.lazy'
    ).then((d) => d.Route),
  )

const StacktraceProductionProductionIdLayoutIssueScopeEditIndexRoute =
  StacktraceProductionProductionIdLayoutIssueScopeEditIndexImport.update({
    id: '/issue-scope/edit/',
    path: '/issue-scope/edit/',
    getParentRoute: () => StacktraceProductionProductionIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_stacktrace/production/$productionId/_layout/issue-scope/edit/index.lazy'
    ).then((d) => d.Route),
  )

const StacktraceProductionProductionIdLayoutDevScopeEditIndexRoute =
  StacktraceProductionProductionIdLayoutDevScopeEditIndexImport.update({
    id: '/dev-scope/edit/',
    path: '/dev-scope/edit/',
    getParentRoute: () => StacktraceProductionProductionIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_stacktrace/production/$productionId/_layout/dev-scope/edit/index.lazy'
    ).then((d) => d.Route),
  )

const IndividualIndividualOperationPackageIdTargetTargetIdIndexRoute =
  IndividualIndividualOperationPackageIdTargetTargetIdIndexImport.update({
    id: '/operation-package/$id/target/$targetId/',
    path: '/operation-package/$id/target/$targetId/',
    getParentRoute: () => IndividualIndividualRoute,
  } as any)

const IndividualIndividualOperationPackageIdPatternPatternIdIndexRoute =
  IndividualIndividualOperationPackageIdPatternPatternIdIndexImport.update({
    id: '/operation-package/$id/pattern/$patternId/',
    path: '/operation-package/$id/pattern/$patternId/',
    getParentRoute: () => IndividualIndividualRoute,
  } as any)

const IndividualIndividualContractIdSignatureRequestSignatureRequestIdIndexRoute =
  IndividualIndividualContractIdSignatureRequestSignatureRequestIdIndexImport.update(
    {
      id: '/contract/$id/signature-request/$signatureRequestId/',
      path: '/contract/$id/signature-request/$signatureRequestId/',
      getParentRoute: () => IndividualIndividualRoute,
    } as any,
  )

const IndividualIndividualProfileMyProfileLayoutSoftwaresIndexRoute =
  IndividualIndividualProfileMyProfileLayoutSoftwaresIndexImport.update({
    id: '/softwares/',
    path: '/softwares/',
    getParentRoute: () => IndividualIndividualProfileMyProfileLayoutRoute,
  } as any)

const IndividualIndividualProfileMyProfileLayoutEducationAndQualificationIndexRoute =
  IndividualIndividualProfileMyProfileLayoutEducationAndQualificationIndexImport.update(
    {
      id: '/education-and-qualification/',
      path: '/education-and-qualification/',
      getParentRoute: () => IndividualIndividualProfileMyProfileLayoutRoute,
    } as any,
  )

const IndividualIndividualProfileMyProfileLayoutDevicesIndexRoute =
  IndividualIndividualProfileMyProfileLayoutDevicesIndexImport.update({
    id: '/devices/',
    path: '/devices/',
    getParentRoute: () => IndividualIndividualProfileMyProfileLayoutRoute,
  } as any)

const StaffSoftwareLayoutContractAndCostContractAndCostDealDealRoute =
  StaffSoftwareLayoutContractAndCostContractAndCostDealDealImport.update({
    id: '/_deal',
    getParentRoute: () =>
      StaffSoftwareLayoutContractAndCostContractAndCostDealRoute,
  } as any)

const StaffSettingsDataConnectorOutboundDataPipelineIdDetailRoute =
  StaffSettingsDataConnectorOutboundDataPipelineIdDetailImport.update({
    id: '/_detail',
    getParentRoute: () => StaffSettingsDataConnectorOutboundDataPipelineIdRoute,
  } as any)

const StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailRoute =
  StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailImport.update({
    id: '/_pipeline-detail',
    getParentRoute: () => StaffSettingsDataConnectorInboundDataPipelineIdRoute,
  } as any)

const StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailRoute =
  StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailImport.update(
    {
      id: '/_aggregate-detail',
      getParentRoute: () =>
        StaffSettingsDataConnectorInboundAggregateDataPipelineIdRoute,
    } as any,
  )

const StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRoute =
  StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRoute,
    } as any,
  )

const StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRoute =
  StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRoute,
    } as any,
  )

const StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRoute =
  StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRoute,
    } as any,
  )

const StaffDevicesListContractAndCostContractAndCostDealDealRoute =
  StaffDevicesListContractAndCostContractAndCostDealDealImport.update({
    id: '/_deal',
    getParentRoute: () =>
      StaffDevicesListContractAndCostContractAndCostDealRoute,
  } as any)

const StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostRoute =
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostImport.update({
    id: '/_contract-and-cost',
    getParentRoute: () => StaffDeviceCatalogActiveIdLayoutContractAndCostRoute,
  } as any)

const IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutRoute =
  IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        IndividualIndividualProfileCertificationsSpecialtyCertificationsIdRoute,
    } as any,
  )

const IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutRoute =
  IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        IndividualIndividualProfileCertificationsHandlingCertificationsIdRoute,
    } as any,
  )

const IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutRoute =
  IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        IndividualIndividualProfileCertificationsBaseCertificationsIdRoute,
    } as any,
  )

const StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdRoute =
  StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdImport.update(
    {
      id: '/execution-results/$taskId',
      path: '/execution-results/$taskId',
      getParentRoute: () =>
        StaffSettingsDataConnectorInboundDataPipelineIdRoute,
    } as any,
  )

const StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute =
  StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdImport.update(
    {
      id: '/operation-packages/$id/patterns/$patternId/instances/$instanceId',
      path: '/operation-packages/$id/patterns/$patternId/instances/$instanceId',
      getParentRoute: () => StaffLaborCoreRoute,
    } as any,
  )

const StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute =
  StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdImport.update(
    {
      id: '/operation-packages/$id/patterns/$patternId/instances/$instanceId',
      path: '/operation-packages/$id/patterns/$patternId/instances/$instanceId',
      getParentRoute: () => StaffGaOperationCoreRoute,
    } as any,
  )

const StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealRoute =
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealImport.update(
    {
      id: '/deal',
      path: '/deal',
      getParentRoute: () =>
        StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostRoute,
    } as any,
  )

const StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute =
  StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdImport.update(
    {
      id: '/operation-packages/$id/patterns/$patternId/instances/$instanceId',
      path: '/operation-packages/$id/patterns/$patternId/instances/$instanceId',
      getParentRoute: () => StaffContractorCoreRoute,
    } as any,
  )

const StaffSoftwareLayoutMarketplaceIdInstallFinishIndexRoute =
  StaffSoftwareLayoutMarketplaceIdInstallFinishIndexImport.update({
    id: '/install/finish/',
    path: '/install/finish/',
    getParentRoute: () => StaffSoftwareLayoutMarketplaceIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/software/_layout/marketplace/$id/install.finish/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSoftwareLayoutLibraryCategoryCategorySearchIndexRoute =
  StaffSoftwareLayoutLibraryCategoryCategorySearchIndexImport.update({
    id: '/library/category/$category/search/',
    path: '/library/category/$category/search/',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/software/_layout/library/category/$category/search/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSoftwareLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute =
  StaffSoftwareLayoutContractAndCostContractAndCostPaymentPeriodIndexImport.update(
    {
      id: '/payment/$period/',
      path: '/payment/$period/',
      getParentRoute: () =>
        StaffSoftwareLayoutContractAndCostContractAndCostRoute,
    } as any,
  )

const StaffSoftwareLayoutContractAndCostContractAndCostDealDealIndexRoute =
  StaffSoftwareLayoutContractAndCostContractAndCostDealDealIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      StaffSoftwareLayoutContractAndCostContractAndCostDealDealRoute,
  } as any)

const StaffSoftwareLayoutContractAndCostContractAndCostCostPeriodIndexRoute =
  StaffSoftwareLayoutContractAndCostContractAndCostCostPeriodIndexImport.update(
    {
      id: '/cost/$period/',
      path: '/cost/$period/',
      getParentRoute: () =>
        StaffSoftwareLayoutContractAndCostContractAndCostRoute,
    } as any,
  )

const StaffSoftwareIdIdContractAndCostContractAndCostPaymentIndexRoute =
  StaffSoftwareIdIdContractAndCostContractAndCostPaymentIndexImport.update({
    id: '/payment/',
    path: '/payment/',
    getParentRoute: () => StaffSoftwareIdIdContractAndCostContractAndCostRoute,
  } as any)

const StaffSoftwareIdIdContractAndCostContractAndCostCostIndexRoute =
  StaffSoftwareIdIdContractAndCostContractAndCostCostIndexImport.update({
    id: '/cost/',
    path: '/cost/',
    getParentRoute: () => StaffSoftwareIdIdContractAndCostContractAndCostRoute,
  } as any)

const StaffSettingsPermissionAndRolesFormRolesIdEditIndexRoute =
  StaffSettingsPermissionAndRolesFormRolesIdEditIndexImport.update({
    id: '/roles/$id/edit/',
    path: '/roles/$id/edit/',
    getParentRoute: () => StaffSettingsPermissionAndRolesFormRoute,
  } as any)

const StaffSettingsPermissionAndRolesFormProductPermissionsIdEditIndexRoute =
  StaffSettingsPermissionAndRolesFormProductPermissionsIdEditIndexImport.update(
    {
      id: '/product-permissions/$id/edit/',
      path: '/product-permissions/$id/edit/',
      getParentRoute: () => StaffSettingsPermissionAndRolesFormRoute,
    } as any,
  )

const StaffSettingsPermissionAndRolesFormPeopleGroupsIdEditIndexRoute =
  StaffSettingsPermissionAndRolesFormPeopleGroupsIdEditIndexImport.update({
    id: '/people-groups/$id/edit/',
    path: '/people-groups/$id/edit/',
    getParentRoute: () => StaffSettingsPermissionAndRolesFormRoute,
  } as any)

const StaffSettingsPermissionAndRolesFormCategoryPermissionsIdEditIndexRoute =
  StaffSettingsPermissionAndRolesFormCategoryPermissionsIdEditIndexImport.update(
    {
      id: '/category-permissions/$id/edit/',
      path: '/category-permissions/$id/edit/',
      getParentRoute: () => StaffSettingsPermissionAndRolesFormRoute,
    } as any,
  )

const StaffPayrollLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute =
  StaffPayrollLayoutContractAndCostContractAndCostPaymentPeriodIndexImport.update(
    {
      id: '/payment/$period/',
      path: '/payment/$period/',
      getParentRoute: () =>
        StaffPayrollLayoutContractAndCostContractAndCostRoute,
    } as any,
  )

const StaffPayrollLayoutContractAndCostContractAndCostCostPeriodIndexRoute =
  StaffPayrollLayoutContractAndCostContractAndCostCostPeriodIndexImport.update({
    id: '/cost/$period/',
    path: '/cost/$period/',
    getParentRoute: () => StaffPayrollLayoutContractAndCostContractAndCostRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/cost/$period/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutStructureIndexRoute =
  StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutStructureIndexImport.update(
    {
      id: '/structure/',
      path: '/structure/',
      getParentRoute: () =>
        StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout/structure/index.lazy'
    ).then((d) => d.Route),
  )

const StaffLicensesIdServicePlansLicenseServiceIdDetailAccountsIndexRoute =
  StaffLicensesIdServicePlansLicenseServiceIdDetailAccountsIndexImport.update({
    id: '/accounts/',
    path: '/accounts/',
    getParentRoute: () =>
      StaffLicensesIdServicePlansLicenseServiceIdDetailRoute,
  } as any)

const StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutOperationActivityIndexRoute =
  StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutOperationActivityIndexImport.update(
    {
      id: '/operation-activity/',
      path: '/operation-activity/',
      getParentRoute: () =>
        StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRoute,
    } as any,
  )

const StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDetailIndexRoute =
  StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDetailIndexImport.update(
    {
      id: '/detail/',
      path: '/detail/',
      getParentRoute: () =>
        StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRoute,
    } as any,
  )

const StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDataIndexRoute =
  StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDataIndexImport.update(
    {
      id: '/data/',
      path: '/data/',
      getParentRoute: () =>
        StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRoute,
    } as any,
  )

const StaffDevicesListContractAndCostContractAndCostPaymentPeriodIndexRoute =
  StaffDevicesListContractAndCostContractAndCostPaymentPeriodIndexImport.update(
    {
      id: '/payment/$period/',
      path: '/payment/$period/',
      getParentRoute: () => StaffDevicesListContractAndCostContractAndCostRoute,
    } as any,
  )

const StaffDevicesListContractAndCostContractAndCostDealDealIndexRoute =
  StaffDevicesListContractAndCostContractAndCostDealDealIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      StaffDevicesListContractAndCostContractAndCostDealDealRoute,
  } as any)

const StaffDevicesListContractAndCostContractAndCostCostPeriodIndexRoute =
  StaffDevicesListContractAndCostContractAndCostCostPeriodIndexImport.update({
    id: '/cost/$period/',
    path: '/cost/$period/',
    getParentRoute: () => StaffDevicesListContractAndCostContractAndCostRoute,
  } as any)

const StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostIndexRoute =
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostRoute,
    } as any,
  )

const StaffBusinessPartnerIdLayoutBpRoleInfoLayoutBpRoleIndexRoute =
  StaffBusinessPartnerIdLayoutBpRoleInfoLayoutBpRoleIndexImport.update({
    id: '/$bpRole/',
    path: '/$bpRole/',
    getParentRoute: () => StaffBusinessPartnerIdLayoutBpRoleInfoLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/business-partner/$id/_layout/bp-role-info/_layout/$bpRole/index.lazy'
    ).then((d) => d.Route),
  )

const StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutStructureIndexRoute =
  StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutStructureIndexImport.update(
    {
      id: '/structure/',
      path: '/structure/',
      getParentRoute: () =>
        StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout/structure/index.lazy'
    ).then((d) => d.Route),
  )

const StacktraceProductsIdScopeNodeIdLayoutValueIndexRoute =
  StacktraceProductsIdScopeNodeIdLayoutValueIndexImport.update({
    id: '/value/',
    path: '/value/',
    getParentRoute: () => StacktraceProductsIdScopeNodeIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_stacktrace/products/$id/scope/$nodeId/_layout/value/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSoftwareIdIdContractAndCostContractAndCostDealDealRoute =
  StaffSoftwareIdIdContractAndCostContractAndCostDealDealImport.update({
    id: '/_deal',
    getParentRoute: () =>
      StaffSoftwareIdIdContractAndCostContractAndCostDealRoute,
  } as any)

const StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute =
  StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdImport.update(
    {
      id: '/operation-packages/$id/patterns/$patternId/instances/$instanceId',
      path: '/operation-packages/$id/patterns/$patternId/instances/$instanceId',
      getParentRoute: () => StaffAttendanceCoreLayoutRoute,
    } as any,
  )

const StaffSoftwareLayoutContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute =
  StaffSoftwareLayoutContractAndCostContractAndCostDealDealVendorInvoiceIndexImport.update(
    {
      id: '/vendor-invoice/',
      path: '/vendor-invoice/',
      getParentRoute: () =>
        StaffSoftwareLayoutContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffSoftwareLayoutContractAndCostContractAndCostDealDealPaymentIndexRoute =
  StaffSoftwareLayoutContractAndCostContractAndCostDealDealPaymentIndexImport.update(
    {
      id: '/payment/',
      path: '/payment/',
      getParentRoute: () =>
        StaffSoftwareLayoutContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffSoftwareLayoutContractAndCostContractAndCostDealDealOrderIndexRoute =
  StaffSoftwareLayoutContractAndCostContractAndCostDealDealOrderIndexImport.update(
    {
      id: '/order/',
      path: '/order/',
      getParentRoute: () =>
        StaffSoftwareLayoutContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffSoftwareLayoutContractAndCostContractAndCostDealDealEstimateIndexRoute =
  StaffSoftwareLayoutContractAndCostContractAndCostDealDealEstimateIndexImport.update(
    {
      id: '/estimate/',
      path: '/estimate/',
      getParentRoute: () =>
        StaffSoftwareLayoutContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffSoftwareLayoutContractAndCostContractAndCostDealDealContractIndexRoute =
  StaffSoftwareLayoutContractAndCostContractAndCostDealDealContractIndexImport.update(
    {
      id: '/contract/',
      path: '/contract/',
      getParentRoute: () =>
        StaffSoftwareLayoutContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffSoftwareLayoutContractAndCostContractAndCostDealDealAllIndexRoute =
  StaffSoftwareLayoutContractAndCostContractAndCostDealDealAllIndexImport.update(
    {
      id: '/all/',
      path: '/all/',
      getParentRoute: () =>
        StaffSoftwareLayoutContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffSoftwareIdIdContractAndCostContractAndCostPaymentPeriodIndexRoute =
  StaffSoftwareIdIdContractAndCostContractAndCostPaymentPeriodIndexImport.update(
    {
      id: '/payment/$period/',
      path: '/payment/$period/',
      getParentRoute: () =>
        StaffSoftwareIdIdContractAndCostContractAndCostRoute,
    } as any,
  )

const StaffSoftwareIdIdContractAndCostContractAndCostDealDealIndexRoute =
  StaffSoftwareIdIdContractAndCostContractAndCostDealDealIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      StaffSoftwareIdIdContractAndCostContractAndCostDealDealRoute,
  } as any)

const StaffSoftwareIdIdContractAndCostContractAndCostCostPeriodIndexRoute =
  StaffSoftwareIdIdContractAndCostContractAndCostCostPeriodIndexImport.update({
    id: '/cost/$period/',
    path: '/cost/$period/',
    getParentRoute: () => StaffSoftwareIdIdContractAndCostContractAndCostRoute,
  } as any)

const StaffSettingsDataConnectorOutboundDataPipelineIdDetailExecutionResultsIndexRoute =
  StaffSettingsDataConnectorOutboundDataPipelineIdDetailExecutionResultsIndexImport.update(
    {
      id: '/execution-results/',
      path: '/execution-results/',
      getParentRoute: () =>
        StaffSettingsDataConnectorOutboundDataPipelineIdDetailRoute,
    } as any,
  )

const StaffSettingsDataConnectorOutboundDataPipelineIdDetailExecutionPlanIndexRoute =
  StaffSettingsDataConnectorOutboundDataPipelineIdDetailExecutionPlanIndexImport.update(
    {
      id: '/execution-plan/',
      path: '/execution-plan/',
      getParentRoute: () =>
        StaffSettingsDataConnectorOutboundDataPipelineIdDetailRoute,
    } as any,
  )

const StaffSettingsDataConnectorOutboundDataPipelineIdDetailDataLinkSettingsIndexRoute =
  StaffSettingsDataConnectorOutboundDataPipelineIdDetailDataLinkSettingsIndexImport.update(
    {
      id: '/data-link-settings/',
      path: '/data-link-settings/',
      getParentRoute: () =>
        StaffSettingsDataConnectorOutboundDataPipelineIdDetailRoute,
    } as any,
  )

const StaffSettingsDataConnectorOutboundDataPipelineIdDetailBasicSettingsIndexRoute =
  StaffSettingsDataConnectorOutboundDataPipelineIdDetailBasicSettingsIndexImport.update(
    {
      id: '/basic-settings/',
      path: '/basic-settings/',
      getParentRoute: () =>
        StaffSettingsDataConnectorOutboundDataPipelineIdDetailRoute,
    } as any,
  )

const StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailExecutionResultsIndexRoute =
  StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailExecutionResultsIndexImport.update(
    {
      id: '/execution-results/',
      path: '/execution-results/',
      getParentRoute: () =>
        StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/execution-results/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailExecutionPlanIndexRoute =
  StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailExecutionPlanIndexImport.update(
    {
      id: '/execution-plan/',
      path: '/execution-plan/',
      getParentRoute: () =>
        StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailRoute,
    } as any,
  )

const StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailDataLinkSettingsIndexRoute =
  StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailDataLinkSettingsIndexImport.update(
    {
      id: '/data-link-settings/',
      path: '/data-link-settings/',
      getParentRoute: () =>
        StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailRoute,
    } as any,
  )

const StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailBasicSettingsIndexRoute =
  StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailBasicSettingsIndexImport.update(
    {
      id: '/basic-settings/',
      path: '/basic-settings/',
      getParentRoute: () =>
        StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailRoute,
    } as any,
  )

const StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailTasksIndexRoute =
  StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailTasksIndexImport.update(
    {
      id: '/tasks/',
      path: '/tasks/',
      getParentRoute: () =>
        StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/tasks/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailPrioritySettingIndexRoute =
  StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailPrioritySettingIndexImport.update(
    {
      id: '/priority-setting/',
      path: '/priority-setting/',
      getParentRoute: () =>
        StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailRoute,
    } as any,
  )

const StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailExecutionPlanIndexRoute =
  StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailExecutionPlanIndexImport.update(
    {
      id: '/execution-plan/',
      path: '/execution-plan/',
      getParentRoute: () =>
        StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailRoute,
    } as any,
  )

const StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailBasicInfoIndexRoute =
  StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailBasicInfoIndexImport.update(
    {
      id: '/basic-info/',
      path: '/basic-info/',
      getParentRoute: () =>
        StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailRoute,
    } as any,
  )

const StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute =
  StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutIndexIndexImport.update(
    {
      id: '/_index/',
      path: '/',
      getParentRoute: () =>
        StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRoute,
    } as any,
  )

const StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute =
  StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutIndexIndexImport.update(
    {
      id: '/_index/',
      path: '/',
      getParentRoute: () =>
        StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRoute,
    } as any,
  )

const StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute =
  StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutIndexIndexImport.update(
    {
      id: '/_index/',
      path: '/',
      getParentRoute: () =>
        StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRoute,
    } as any,
  )

const StaffDevicesListContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute =
  StaffDevicesListContractAndCostContractAndCostDealDealVendorInvoiceIndexImport.update(
    {
      id: '/vendor-invoice/',
      path: '/vendor-invoice/',
      getParentRoute: () =>
        StaffDevicesListContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffDevicesListContractAndCostContractAndCostDealDealPaymentIndexRoute =
  StaffDevicesListContractAndCostContractAndCostDealDealPaymentIndexImport.update(
    {
      id: '/payment/',
      path: '/payment/',
      getParentRoute: () =>
        StaffDevicesListContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffDevicesListContractAndCostContractAndCostDealDealOrderIndexRoute =
  StaffDevicesListContractAndCostContractAndCostDealDealOrderIndexImport.update(
    {
      id: '/order/',
      path: '/order/',
      getParentRoute: () =>
        StaffDevicesListContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffDevicesListContractAndCostContractAndCostDealDealEstimateIndexRoute =
  StaffDevicesListContractAndCostContractAndCostDealDealEstimateIndexImport.update(
    {
      id: '/estimate/',
      path: '/estimate/',
      getParentRoute: () =>
        StaffDevicesListContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffDevicesListContractAndCostContractAndCostDealDealContractIndexRoute =
  StaffDevicesListContractAndCostContractAndCostDealDealContractIndexImport.update(
    {
      id: '/contract/',
      path: '/contract/',
      getParentRoute: () =>
        StaffDevicesListContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffDevicesListContractAndCostContractAndCostDealDealAllIndexRoute =
  StaffDevicesListContractAndCostContractAndCostDealDealAllIndexImport.update({
    id: '/all/',
    path: '/all/',
    getParentRoute: () =>
      StaffDevicesListContractAndCostContractAndCostDealDealRoute,
  } as any)

const StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostPaymentIndexRoute =
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostPaymentIndexImport.update(
    {
      id: '/payment/',
      path: '/payment/',
      getParentRoute: () =>
        StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostRoute,
    } as any,
  )

const StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostCostIndexRoute =
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostCostIndexImport.update(
    {
      id: '/cost/',
      path: '/cost/',
      getParentRoute: () =>
        StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostRoute,
    } as any,
  )

const IndividualIndividualTaskIdOperationPackageCommonFormFormIdIndexRoute =
  IndividualIndividualTaskIdOperationPackageCommonFormFormIdIndexImport.update({
    id: '/task/$id/_operation-package/_common/form/$formId/',
    path: '/task/$id/form/$formId/',
    getParentRoute: () => IndividualIndividualRoute,
  } as any)

const IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutIndexIndexRoute =
  IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutIndexIndexImport.update(
    {
      id: '/_index/',
      path: '/',
      getParentRoute: () =>
        IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutRoute,
    } as any,
  )

const IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutIndexIndexRoute =
  IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutIndexIndexImport.update(
    {
      id: '/_index/',
      path: '/',
      getParentRoute: () =>
        IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutRoute,
    } as any,
  )

const IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutIndexIndexRoute =
  IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutIndexIndexImport.update(
    {
      id: '/_index/',
      path: '/',
      getParentRoute: () =>
        IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutRoute,
    } as any,
  )

const StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailRoute =
  StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailImport.update(
    {
      id: '/_task-detail',
      getParentRoute: () =>
        StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdRoute,
    } as any,
  )

const StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute =
  StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport.update(
    {
      id: '/_profile',
      getParentRoute: () =>
        StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute,
    } as any,
  )

const StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute =
  StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport.update(
    {
      id: '/_profile',
      getParentRoute: () =>
        StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute,
    } as any,
  )

const StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealRoute =
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealImport.update(
    {
      id: '/_deal',
      getParentRoute: () =>
        StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealRoute,
    } as any,
  )

const StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute =
  StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport.update(
    {
      id: '/_profile',
      getParentRoute: () =>
        StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute,
    } as any,
  )

const StaffSoftwareIdIdContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute =
  StaffSoftwareIdIdContractAndCostContractAndCostDealDealVendorInvoiceIndexImport.update(
    {
      id: '/vendor-invoice/',
      path: '/vendor-invoice/',
      getParentRoute: () =>
        StaffSoftwareIdIdContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffSoftwareIdIdContractAndCostContractAndCostDealDealPaymentIndexRoute =
  StaffSoftwareIdIdContractAndCostContractAndCostDealDealPaymentIndexImport.update(
    {
      id: '/payment/',
      path: '/payment/',
      getParentRoute: () =>
        StaffSoftwareIdIdContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffSoftwareIdIdContractAndCostContractAndCostDealDealOrderIndexRoute =
  StaffSoftwareIdIdContractAndCostContractAndCostDealDealOrderIndexImport.update(
    {
      id: '/order/',
      path: '/order/',
      getParentRoute: () =>
        StaffSoftwareIdIdContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffSoftwareIdIdContractAndCostContractAndCostDealDealEstimateIndexRoute =
  StaffSoftwareIdIdContractAndCostContractAndCostDealDealEstimateIndexImport.update(
    {
      id: '/estimate/',
      path: '/estimate/',
      getParentRoute: () =>
        StaffSoftwareIdIdContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffSoftwareIdIdContractAndCostContractAndCostDealDealContractIndexRoute =
  StaffSoftwareIdIdContractAndCostContractAndCostDealDealContractIndexImport.update(
    {
      id: '/contract/',
      path: '/contract/',
      getParentRoute: () =>
        StaffSoftwareIdIdContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffSoftwareIdIdContractAndCostContractAndCostDealDealAllIndexRoute =
  StaffSoftwareIdIdContractAndCostContractAndCostDealDealAllIndexImport.update({
    id: '/all/',
    path: '/all/',
    getParentRoute: () =>
      StaffSoftwareIdIdContractAndCostContractAndCostDealDealRoute,
  } as any)

const StaffSettingsDataConnectorInboundAggregateDataPipelineIdTasksTaskIdChunksIndexRoute =
  StaffSettingsDataConnectorInboundAggregateDataPipelineIdTasksTaskIdChunksIndexImport.update(
    {
      id: '/tasks/$taskId/chunks/',
      path: '/tasks/$taskId/chunks/',
      getParentRoute: () =>
        StaffSettingsDataConnectorInboundAggregateDataPipelineIdRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/index.lazy'
    ).then((d) => d.Route),
  )

const StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute =
  StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute,
    } as any,
  )

const StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute =
  StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute,
    } as any,
  )

const StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute =
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostPaymentPeriodIndexImport.update(
    {
      id: '/payment/$period/',
      path: '/payment/$period/',
      getParentRoute: () =>
        StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostRoute,
    } as any,
  )

const StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealIndexRoute =
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostCostPeriodIndexRoute =
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostCostPeriodIndexImport.update(
    {
      id: '/cost/$period/',
      path: '/cost/$period/',
      getParentRoute: () =>
        StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostRoute,
    } as any,
  )

const StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute =
  StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute,
    } as any,
  )

const StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute =
  StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport.update(
    {
      id: '/_profile',
      getParentRoute: () =>
        StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute,
    } as any,
  )

const StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailChunksIndexRoute =
  StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailChunksIndexImport.update(
    {
      id: '/chunks/',
      path: '/chunks/',
      getParentRoute: () =>
        StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/_task-detail/chunks/index.lazy'
    ).then((d) => d.Route),
  )

const StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute =
  StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexImport.update(
    {
      id: '/data/',
      path: '/data/',
      getParentRoute: () =>
        StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute,
    } as any,
  )

const StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute =
  StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexImport.update(
    {
      id: '/data/',
      path: '/data/',
      getParentRoute: () =>
        StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute,
    } as any,
  )

const StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute =
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealVendorInvoiceIndexImport.update(
    {
      id: '/vendor-invoice/',
      path: '/vendor-invoice/',
      getParentRoute: () =>
        StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealPaymentIndexRoute =
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealPaymentIndexImport.update(
    {
      id: '/payment/',
      path: '/payment/',
      getParentRoute: () =>
        StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealOrderIndexRoute =
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealOrderIndexImport.update(
    {
      id: '/order/',
      path: '/order/',
      getParentRoute: () =>
        StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealEstimateIndexRoute =
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealEstimateIndexImport.update(
    {
      id: '/estimate/',
      path: '/estimate/',
      getParentRoute: () =>
        StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealContractIndexRoute =
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealContractIndexImport.update(
    {
      id: '/contract/',
      path: '/contract/',
      getParentRoute: () =>
        StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealAllIndexRoute =
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealAllIndexImport.update(
    {
      id: '/all/',
      path: '/all/',
      getParentRoute: () =>
        StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealRoute,
    } as any,
  )

const StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute =
  StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexImport.update(
    {
      id: '/data/',
      path: '/data/',
      getParentRoute: () =>
        StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute,
    } as any,
  )

const StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute =
  StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute,
    } as any,
  )

const StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdChunksChunkIdResultIndexRoute =
  StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdChunksChunkIdResultIndexImport.update(
    {
      id: '/chunks/$chunkId/result/',
      path: '/chunks/$chunkId/result/',
      getParentRoute: () =>
        StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/chunks/$chunkId/result/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSettingsDataConnectorInboundAggregateDataPipelineIdTasksTaskIdChunksChunkIdResultIndexRoute =
  StaffSettingsDataConnectorInboundAggregateDataPipelineIdTasksTaskIdChunksChunkIdResultIndexImport.update(
    {
      id: '/tasks/$taskId/chunks/$chunkId/result/',
      path: '/tasks/$taskId/chunks/$chunkId/result/',
      getParentRoute: () =>
        StaffSettingsDataConnectorInboundAggregateDataPipelineIdRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/$chunkId/result/index.lazy'
    ).then((d) => d.Route),
  )

const StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute =
  StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexImport.update(
    {
      id: '/data/',
      path: '/data/',
      getParentRoute: () =>
        StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_chat': {
      id: '/_chat'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ChatImport
      parentRoute: typeof rootRoute
    }
    '/_cockpit-mock': {
      id: '/_cockpit-mock'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof CockpitMockImport
      parentRoute: typeof rootRoute
    }
    '/_idp-sso-mock': {
      id: '/_idp-sso-mock'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof IdpSsoMockImport
      parentRoute: typeof rootRoute
    }
    '/_individual': {
      id: '/_individual'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof IndividualImport
      parentRoute: typeof rootRoute
    }
    '/_stacktrace': {
      id: '/_stacktrace'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof StacktraceImport
      parentRoute: typeof rootRoute
    }
    '/_staff': {
      id: '/_staff'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof StaffImport
      parentRoute: typeof rootRoute
    }
    '/_stacktrace/planning-operations-core': {
      id: '/_stacktrace/planning-operations-core'
      path: '/planning-operations-core'
      fullPath: '/planning-operations-core'
      preLoaderRoute: typeof StacktracePlanningOperationsCoreImport
      parentRoute: typeof StacktraceImport
    }
    '/_stacktrace/product-planning-core': {
      id: '/_stacktrace/product-planning-core'
      path: '/product-planning-core'
      fullPath: '/product-planning-core'
      preLoaderRoute: typeof StacktraceProductPlanningCoreImport
      parentRoute: typeof StacktraceImport
    }
    '/_stacktrace/qa-operations-core': {
      id: '/_stacktrace/qa-operations-core'
      path: '/qa-operations-core'
      fullPath: '/qa-operations-core'
      preLoaderRoute: typeof StacktraceQaOperationsCoreImport
      parentRoute: typeof StacktraceImport
    }
    '/_staff/apps': {
      id: '/_staff/apps'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof StaffAppsImport
      parentRoute: typeof StaffImport
    }
    '/_staff/id-managements': {
      id: '/_staff/id-managements'
      path: '/id-managements'
      fullPath: '/id-managements'
      preLoaderRoute: typeof StaffIdManagementsImport
      parentRoute: typeof StaffImport
    }
    '/me/': {
      id: '/me/'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof MeIndexImport
      parentRoute: typeof rootRoute
    }
    '/_stacktrace/development-tickets/import-csv': {
      id: '/_stacktrace/development-tickets/import-csv'
      path: '/development-tickets/import-csv'
      fullPath: '/development-tickets/import-csv'
      preLoaderRoute: typeof StacktraceDevelopmentTicketsImportCsvRouteImport
      parentRoute: typeof StacktraceImport
    }
    '/_stacktrace/issues/import-csv': {
      id: '/_stacktrace/issues/import-csv'
      path: '/issues/import-csv'
      fullPath: '/issues/import-csv'
      preLoaderRoute: typeof StacktraceIssuesImportCsvRouteImport
      parentRoute: typeof StacktraceImport
    }
    '/_stacktrace/values/import-csv': {
      id: '/_stacktrace/values/import-csv'
      path: '/values/import-csv'
      fullPath: '/values/import-csv'
      preLoaderRoute: typeof StacktraceValuesImportCsvRouteImport
      parentRoute: typeof StacktraceImport
    }
    '/_staff/it-operation-core/device-inventory': {
      id: '/_staff/it-operation-core/device-inventory'
      path: '/it-operation-core/device-inventory'
      fullPath: '/it-operation-core/device-inventory'
      preLoaderRoute: typeof StaffItOperationCoreDeviceInventoryRouteImport
      parentRoute: typeof StaffImport
    }
    '/_staff/places/import-csv': {
      id: '/_staff/places/import-csv'
      path: '/places/import-csv'
      fullPath: '/places/import-csv'
      preLoaderRoute: typeof StaffPlacesImportCsvRouteImport
      parentRoute: typeof StaffImport
    }
    '/_individual/individual': {
      id: '/_individual/individual'
      path: '/individual'
      fullPath: '/individual'
      preLoaderRoute: typeof IndividualIndividualImport
      parentRoute: typeof IndividualImport
    }
    '/_individual/individual/_profile': {
      id: '/_individual/individual/_profile'
      path: '/individual'
      fullPath: '/individual'
      preLoaderRoute: typeof IndividualIndividualProfileImport
      parentRoute: typeof IndividualIndividualRoute
    }
    '/_individual/individual/portal': {
      id: '/_individual/individual/portal'
      path: '/portal'
      fullPath: '/individual/portal'
      preLoaderRoute: typeof IndividualIndividualPortalImport
      parentRoute: typeof IndividualIndividualImport
    }
    '/_stacktrace/issues': {
      id: '/_stacktrace/issues'
      path: '/issues'
      fullPath: '/issues'
      preLoaderRoute: typeof StacktraceIssuesImport
      parentRoute: typeof StacktraceImport
    }
    '/_stacktrace/issues/_layout': {
      id: '/_stacktrace/issues/_layout'
      path: '/issues'
      fullPath: '/issues'
      preLoaderRoute: typeof StacktraceIssuesLayoutImport
      parentRoute: typeof StacktraceIssuesRoute
    }
    '/_stacktrace/product-roadmap': {
      id: '/_stacktrace/product-roadmap'
      path: '/product-roadmap'
      fullPath: '/product-roadmap'
      preLoaderRoute: typeof StacktraceProductRoadmapImport
      parentRoute: typeof StacktraceImport
    }
    '/_stacktrace/product-roadmap/_layout': {
      id: '/_stacktrace/product-roadmap/_layout'
      path: '/product-roadmap'
      fullPath: '/product-roadmap'
      preLoaderRoute: typeof StacktraceProductRoadmapLayoutImport
      parentRoute: typeof StacktraceProductRoadmapRoute
    }
    '/_stacktrace/test-sets': {
      id: '/_stacktrace/test-sets'
      path: '/test-sets'
      fullPath: '/test-sets'
      preLoaderRoute: typeof StacktraceTestSetsImport
      parentRoute: typeof StacktraceImport
    }
    '/_stacktrace/test-sets/_layout': {
      id: '/_stacktrace/test-sets/_layout'
      path: '/test-sets'
      fullPath: '/test-sets'
      preLoaderRoute: typeof StacktraceTestSetsLayoutImport
      parentRoute: typeof StacktraceTestSetsRoute
    }
    '/_stacktrace/test-suites': {
      id: '/_stacktrace/test-suites'
      path: '/test-suites'
      fullPath: '/test-suites'
      preLoaderRoute: typeof StacktraceTestSuitesImport
      parentRoute: typeof StacktraceImport
    }
    '/_stacktrace/test-suites/_layout': {
      id: '/_stacktrace/test-suites/_layout'
      path: '/test-suites'
      fullPath: '/test-suites'
      preLoaderRoute: typeof StacktraceTestSuitesLayoutImport
      parentRoute: typeof StacktraceTestSuitesRoute
    }
    '/_stacktrace/values': {
      id: '/_stacktrace/values'
      path: '/values'
      fullPath: '/values'
      preLoaderRoute: typeof StacktraceValuesImport
      parentRoute: typeof StacktraceImport
    }
    '/_stacktrace/values/_layout': {
      id: '/_stacktrace/values/_layout'
      path: '/values'
      fullPath: '/values'
      preLoaderRoute: typeof StacktraceValuesLayoutImport
      parentRoute: typeof StacktraceValuesRoute
    }
    '/_staff/accesses': {
      id: '/_staff/accesses'
      path: '/accesses'
      fullPath: '/accesses'
      preLoaderRoute: typeof StaffAccessesImport
      parentRoute: typeof StaffImport
    }
    '/_staff/accesses/_layout': {
      id: '/_staff/accesses/_layout'
      path: '/accesses'
      fullPath: '/accesses'
      preLoaderRoute: typeof StaffAccessesLayoutImport
      parentRoute: typeof StaffAccessesRoute
    }
    '/_staff/apps/$': {
      id: '/_staff/apps/$'
      path: '/$'
      fullPath: '/apps/$'
      preLoaderRoute: typeof StaffAppsSplatImport
      parentRoute: typeof StaffAppsImport
    }
    '/_staff/attendance-core': {
      id: '/_staff/attendance-core'
      path: '/attendance-core'
      fullPath: '/attendance-core'
      preLoaderRoute: typeof StaffAttendanceCoreImport
      parentRoute: typeof StaffImport
    }
    '/_staff/attendance-core/_layout': {
      id: '/_staff/attendance-core/_layout'
      path: '/attendance-core'
      fullPath: '/attendance-core'
      preLoaderRoute: typeof StaffAttendanceCoreLayoutImport
      parentRoute: typeof StaffAttendanceCoreRoute
    }
    '/_staff/attendance-engine': {
      id: '/_staff/attendance-engine'
      path: '/attendance-engine'
      fullPath: '/attendance-engine'
      preLoaderRoute: typeof StaffAttendanceEngineImport
      parentRoute: typeof StaffImport
    }
    '/_staff/attendance-engine/_layout': {
      id: '/_staff/attendance-engine/_layout'
      path: '/attendance-engine'
      fullPath: '/attendance-engine'
      preLoaderRoute: typeof StaffAttendanceEngineLayoutImport
      parentRoute: typeof StaffAttendanceEngineRoute
    }
    '/_staff/attendances': {
      id: '/_staff/attendances'
      path: '/attendances'
      fullPath: '/attendances'
      preLoaderRoute: typeof StaffAttendancesImport
      parentRoute: typeof StaffImport
    }
    '/_staff/attendances/_layout': {
      id: '/_staff/attendances/_layout'
      path: '/attendances'
      fullPath: '/attendances'
      preLoaderRoute: typeof StaffAttendancesLayoutImport
      parentRoute: typeof StaffAttendancesRoute
    }
    '/_staff/business-operation-events': {
      id: '/_staff/business-operation-events'
      path: '/business-operation-events'
      fullPath: '/business-operation-events'
      preLoaderRoute: typeof StaffBusinessOperationEventsImport
      parentRoute: typeof StaffImport
    }
    '/_staff/business-operation-events/_list': {
      id: '/_staff/business-operation-events/_list'
      path: '/business-operation-events'
      fullPath: '/business-operation-events'
      preLoaderRoute: typeof StaffBusinessOperationEventsListImport
      parentRoute: typeof StaffBusinessOperationEventsRoute
    }
    '/_staff/business-partner': {
      id: '/_staff/business-partner'
      path: '/business-partner'
      fullPath: '/business-partner'
      preLoaderRoute: typeof StaffBusinessPartnerImport
      parentRoute: typeof StaffImport
    }
    '/_staff/business-partner/_list': {
      id: '/_staff/business-partner/_list'
      path: '/business-partner'
      fullPath: '/business-partner'
      preLoaderRoute: typeof StaffBusinessPartnerListImport
      parentRoute: typeof StaffBusinessPartnerRoute
    }
    '/_staff/certification': {
      id: '/_staff/certification'
      path: '/certification'
      fullPath: '/certification'
      preLoaderRoute: typeof StaffCertificationImport
      parentRoute: typeof StaffImport
    }
    '/_staff/certification/_list': {
      id: '/_staff/certification/_list'
      path: '/certification'
      fullPath: '/certification'
      preLoaderRoute: typeof StaffCertificationListImport
      parentRoute: typeof StaffCertificationRoute
    }
    '/_staff/contract': {
      id: '/_staff/contract'
      path: '/contract'
      fullPath: '/contract'
      preLoaderRoute: typeof StaffContractImport
      parentRoute: typeof StaffImport
    }
    '/_staff/contract/_list': {
      id: '/_staff/contract/_list'
      path: '/contract'
      fullPath: '/contract'
      preLoaderRoute: typeof StaffContractListImport
      parentRoute: typeof StaffContractRoute
    }
    '/_staff/contractor-core': {
      id: '/_staff/contractor-core'
      path: '/contractor-core'
      fullPath: '/contractor-core'
      preLoaderRoute: typeof StaffContractorCoreImport
      parentRoute: typeof StaffImport
    }
    '/_staff/contractor-core/_packages': {
      id: '/_staff/contractor-core/_packages'
      path: '/contractor-core'
      fullPath: '/contractor-core'
      preLoaderRoute: typeof StaffContractorCorePackagesImport
      parentRoute: typeof StaffContractorCoreRoute
    }
    '/_staff/contractor-core/anchor-date': {
      id: '/_staff/contractor-core/anchor-date'
      path: '/anchor-date'
      fullPath: '/contractor-core/anchor-date'
      preLoaderRoute: typeof StaffContractorCoreAnchorDateImport
      parentRoute: typeof StaffContractorCoreImport
    }
    '/_staff/contractor-core/contract-targets': {
      id: '/_staff/contractor-core/contract-targets'
      path: '/contract-targets'
      fullPath: '/contractor-core/contract-targets'
      preLoaderRoute: typeof StaffContractorCoreContractTargetsImport
      parentRoute: typeof StaffContractorCoreImport
    }
    '/_staff/contractor-core/person-targets': {
      id: '/_staff/contractor-core/person-targets'
      path: '/person-targets'
      fullPath: '/contractor-core/person-targets'
      preLoaderRoute: typeof StaffContractorCorePersonTargetsImport
      parentRoute: typeof StaffContractorCoreImport
    }
    '/_staff/deal': {
      id: '/_staff/deal'
      path: '/deal'
      fullPath: '/deal'
      preLoaderRoute: typeof StaffDealImport
      parentRoute: typeof StaffImport
    }
    '/_staff/deal/_list': {
      id: '/_staff/deal/_list'
      path: '/deal'
      fullPath: '/deal'
      preLoaderRoute: typeof StaffDealListImport
      parentRoute: typeof StaffDealRoute
    }
    '/_staff/devices': {
      id: '/_staff/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof StaffDevicesImport
      parentRoute: typeof StaffImport
    }
    '/_staff/devices/_list': {
      id: '/_staff/devices/_list'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof StaffDevicesListImport
      parentRoute: typeof StaffDevicesRoute
    }
    '/_staff/equipment': {
      id: '/_staff/equipment'
      path: '/equipment'
      fullPath: '/equipment'
      preLoaderRoute: typeof StaffEquipmentImport
      parentRoute: typeof StaffImport
    }
    '/_staff/equipment/_layout': {
      id: '/_staff/equipment/_layout'
      path: '/equipment'
      fullPath: '/equipment'
      preLoaderRoute: typeof StaffEquipmentLayoutImport
      parentRoute: typeof StaffEquipmentRoute
    }
    '/_staff/fleets': {
      id: '/_staff/fleets'
      path: '/fleets'
      fullPath: '/fleets'
      preLoaderRoute: typeof StaffFleetsImport
      parentRoute: typeof StaffImport
    }
    '/_staff/fleets/_layout': {
      id: '/_staff/fleets/_layout'
      path: '/fleets'
      fullPath: '/fleets'
      preLoaderRoute: typeof StaffFleetsLayoutImport
      parentRoute: typeof StaffFleetsRoute
    }
    '/_staff/ga-operation-core': {
      id: '/_staff/ga-operation-core'
      path: '/ga-operation-core'
      fullPath: '/ga-operation-core'
      preLoaderRoute: typeof StaffGaOperationCoreImport
      parentRoute: typeof StaffImport
    }
    '/_staff/ga-operation-core/_packages': {
      id: '/_staff/ga-operation-core/_packages'
      path: '/ga-operation-core'
      fullPath: '/ga-operation-core'
      preLoaderRoute: typeof StaffGaOperationCorePackagesImport
      parentRoute: typeof StaffGaOperationCoreRoute
    }
    '/_staff/id-managements/$': {
      id: '/_staff/id-managements/$'
      path: '/$'
      fullPath: '/id-managements/$'
      preLoaderRoute: typeof StaffIdManagementsSplatImport
      parentRoute: typeof StaffIdManagementsImport
    }
    '/_staff/ids': {
      id: '/_staff/ids'
      path: '/ids'
      fullPath: '/ids'
      preLoaderRoute: typeof StaffIdsImport
      parentRoute: typeof StaffImport
    }
    '/_staff/ids/_layout': {
      id: '/_staff/ids/_layout'
      path: '/ids'
      fullPath: '/ids'
      preLoaderRoute: typeof StaffIdsLayoutImport
      parentRoute: typeof StaffIdsRoute
    }
    '/_staff/it-operation-core': {
      id: '/_staff/it-operation-core'
      path: '/it-operation-core'
      fullPath: '/it-operation-core'
      preLoaderRoute: typeof StaffItOperationCoreImport
      parentRoute: typeof StaffImport
    }
    '/_staff/it-operation-core/_detail': {
      id: '/_staff/it-operation-core/_detail'
      path: '/it-operation-core'
      fullPath: '/it-operation-core'
      preLoaderRoute: typeof StaffItOperationCoreDetailImport
      parentRoute: typeof StaffItOperationCoreRoute
    }
    '/_staff/it-operation-core/_root': {
      id: '/_staff/it-operation-core/_root'
      path: ''
      fullPath: '/it-operation-core'
      preLoaderRoute: typeof StaffItOperationCoreRootImport
      parentRoute: typeof StaffItOperationCoreImport
    }
    '/_staff/it-operation-core/anchor-date': {
      id: '/_staff/it-operation-core/anchor-date'
      path: '/anchor-date'
      fullPath: '/it-operation-core/anchor-date'
      preLoaderRoute: typeof StaffItOperationCoreAnchorDateImport
      parentRoute: typeof StaffItOperationCoreImport
    }
    '/_staff/it-operation-core/self-report-confirmation': {
      id: '/_staff/it-operation-core/self-report-confirmation'
      path: '/self-report-confirmation'
      fullPath: '/it-operation-core/self-report-confirmation'
      preLoaderRoute: typeof StaffItOperationCoreSelfReportConfirmationImport
      parentRoute: typeof StaffItOperationCoreImport
    }
    '/_staff/labor-core': {
      id: '/_staff/labor-core'
      path: '/labor-core'
      fullPath: '/labor-core'
      preLoaderRoute: typeof StaffLaborCoreImport
      parentRoute: typeof StaffImport
    }
    '/_staff/labor-core/_packages': {
      id: '/_staff/labor-core/_packages'
      path: '/labor-core'
      fullPath: '/labor-core'
      preLoaderRoute: typeof StaffLaborCorePackagesImport
      parentRoute: typeof StaffLaborCoreRoute
    }
    '/_staff/labor-core/anchor-date': {
      id: '/_staff/labor-core/anchor-date'
      path: '/anchor-date'
      fullPath: '/labor-core/anchor-date'
      preLoaderRoute: typeof StaffLaborCoreAnchorDateImport
      parentRoute: typeof StaffLaborCoreImport
    }
    '/_staff/labor-core/contract-targets': {
      id: '/_staff/labor-core/contract-targets'
      path: '/contract-targets'
      fullPath: '/labor-core/contract-targets'
      preLoaderRoute: typeof StaffLaborCoreContractTargetsImport
      parentRoute: typeof StaffLaborCoreImport
    }
    '/_staff/labor-core/government-application-confirmation': {
      id: '/_staff/labor-core/government-application-confirmation'
      path: '/government-application-confirmation'
      fullPath: '/labor-core/government-application-confirmation'
      preLoaderRoute: typeof StaffLaborCoreGovernmentApplicationConfirmationImport
      parentRoute: typeof StaffLaborCoreImport
    }
    '/_staff/labor-core/person-targets': {
      id: '/_staff/labor-core/person-targets'
      path: '/person-targets'
      fullPath: '/labor-core/person-targets'
      preLoaderRoute: typeof StaffLaborCorePersonTargetsImport
      parentRoute: typeof StaffLaborCoreImport
    }
    '/_staff/labor-core/year-end-adjustment-confirmation': {
      id: '/_staff/labor-core/year-end-adjustment-confirmation'
      path: '/year-end-adjustment-confirmation'
      fullPath: '/labor-core/year-end-adjustment-confirmation'
      preLoaderRoute: typeof StaffLaborCoreYearEndAdjustmentConfirmationImport
      parentRoute: typeof StaffLaborCoreImport
    }
    '/_staff/licenses': {
      id: '/_staff/licenses'
      path: '/licenses'
      fullPath: '/licenses'
      preLoaderRoute: typeof StaffLicensesImport
      parentRoute: typeof StaffImport
    }
    '/_staff/licenses/_list': {
      id: '/_staff/licenses/_list'
      path: '/licenses'
      fullPath: '/licenses'
      preLoaderRoute: typeof StaffLicensesListImport
      parentRoute: typeof StaffLicensesRoute
    }
    '/_staff/marketplace': {
      id: '/_staff/marketplace'
      path: '/marketplace'
      fullPath: '/marketplace'
      preLoaderRoute: typeof StaffMarketplaceImport
      parentRoute: typeof StaffImport
    }
    '/_staff/marketplace/_store': {
      id: '/_staff/marketplace/_store'
      path: '/marketplace'
      fullPath: '/marketplace'
      preLoaderRoute: typeof StaffMarketplaceStoreImport
      parentRoute: typeof StaffMarketplaceRoute
    }
    '/_staff/networks': {
      id: '/_staff/networks'
      path: '/networks'
      fullPath: '/networks'
      preLoaderRoute: typeof StaffNetworksImport
      parentRoute: typeof StaffImport
    }
    '/_staff/networks/_layout': {
      id: '/_staff/networks/_layout'
      path: '/networks'
      fullPath: '/networks'
      preLoaderRoute: typeof StaffNetworksLayoutImport
      parentRoute: typeof StaffNetworksRoute
    }
    '/_staff/organization': {
      id: '/_staff/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof StaffOrganizationImport
      parentRoute: typeof StaffImport
    }
    '/_staff/organization/_list': {
      id: '/_staff/organization/_list'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof StaffOrganizationListImport
      parentRoute: typeof StaffOrganizationRoute
    }
    '/_staff/payroll-core': {
      id: '/_staff/payroll-core'
      path: '/payroll-core'
      fullPath: '/payroll-core'
      preLoaderRoute: typeof StaffPayrollCoreImport
      parentRoute: typeof StaffImport
    }
    '/_staff/payroll-core/_layout': {
      id: '/_staff/payroll-core/_layout'
      path: '/payroll-core'
      fullPath: '/payroll-core'
      preLoaderRoute: typeof StaffPayrollCoreLayoutImport
      parentRoute: typeof StaffPayrollCoreRoute
    }
    '/_staff/payroll-engine': {
      id: '/_staff/payroll-engine'
      path: '/payroll-engine'
      fullPath: '/payroll-engine'
      preLoaderRoute: typeof StaffPayrollEngineImport
      parentRoute: typeof StaffImport
    }
    '/_staff/payroll-engine/_layout': {
      id: '/_staff/payroll-engine/_layout'
      path: '/payroll-engine'
      fullPath: '/payroll-engine'
      preLoaderRoute: typeof StaffPayrollEngineLayoutImport
      parentRoute: typeof StaffPayrollEngineRoute
    }
    '/_staff/payroll': {
      id: '/_staff/payroll'
      path: '/payroll'
      fullPath: '/payroll'
      preLoaderRoute: typeof StaffPayrollImport
      parentRoute: typeof StaffImport
    }
    '/_staff/payroll/_layout': {
      id: '/_staff/payroll/_layout'
      path: '/payroll'
      fullPath: '/payroll'
      preLoaderRoute: typeof StaffPayrollLayoutImport
      parentRoute: typeof StaffPayrollRoute
    }
    '/_staff/people': {
      id: '/_staff/people'
      path: '/people'
      fullPath: '/people'
      preLoaderRoute: typeof StaffPeopleImport
      parentRoute: typeof StaffImport
    }
    '/_staff/people/_list': {
      id: '/_staff/people/_list'
      path: '/people'
      fullPath: '/people'
      preLoaderRoute: typeof StaffPeopleListImport
      parentRoute: typeof StaffPeopleRoute
    }
    '/_staff/places': {
      id: '/_staff/places'
      path: '/places'
      fullPath: '/places'
      preLoaderRoute: typeof StaffPlacesImport
      parentRoute: typeof StaffImport
    }
    '/_staff/places/_layout': {
      id: '/_staff/places/_layout'
      path: '/places'
      fullPath: '/places'
      preLoaderRoute: typeof StaffPlacesLayoutImport
      parentRoute: typeof StaffPlacesRoute
    }
    '/_staff/public-ids/$id': {
      id: '/_staff/public-ids/$id'
      path: '/public-ids/$id'
      fullPath: '/public-ids/$id'
      preLoaderRoute: typeof StaffPublicIdsIdImport
      parentRoute: typeof StaffImport
    }
    '/_staff/public-ids': {
      id: '/_staff/public-ids'
      path: '/public-ids'
      fullPath: '/public-ids'
      preLoaderRoute: typeof StaffPublicIdsImport
      parentRoute: typeof StaffImport
    }
    '/_staff/public-ids/_list': {
      id: '/_staff/public-ids/_list'
      path: '/public-ids'
      fullPath: '/public-ids'
      preLoaderRoute: typeof StaffPublicIdsListImport
      parentRoute: typeof StaffPublicIdsRoute
    }
    '/_staff/software': {
      id: '/_staff/software'
      path: '/software'
      fullPath: '/software'
      preLoaderRoute: typeof StaffSoftwareImport
      parentRoute: typeof StaffImport
    }
    '/_staff/software/_layout': {
      id: '/_staff/software/_layout'
      path: '/software'
      fullPath: '/software'
      preLoaderRoute: typeof StaffSoftwareLayoutImport
      parentRoute: typeof StaffSoftwareRoute
    }
    '/_staff/starlinks': {
      id: '/_staff/starlinks'
      path: '/starlinks'
      fullPath: '/starlinks'
      preLoaderRoute: typeof StaffStarlinksImport
      parentRoute: typeof StaffImport
    }
    '/_staff/starlinks/_layout': {
      id: '/_staff/starlinks/_layout'
      path: '/starlinks'
      fullPath: '/starlinks'
      preLoaderRoute: typeof StaffStarlinksLayoutImport
      parentRoute: typeof StaffStarlinksRoute
    }
    '/_staff/storage-files': {
      id: '/_staff/storage-files'
      path: '/storage-files'
      fullPath: '/storage-files'
      preLoaderRoute: typeof StaffStorageFilesImport
      parentRoute: typeof StaffImport
    }
    '/_staff/storage-files/_list': {
      id: '/_staff/storage-files/_list'
      path: '/storage-files'
      fullPath: '/storage-files'
      preLoaderRoute: typeof StaffStorageFilesListImport
      parentRoute: typeof StaffStorageFilesRoute
    }
    '/_staff/supplier': {
      id: '/_staff/supplier'
      path: '/supplier'
      fullPath: '/supplier'
      preLoaderRoute: typeof StaffSupplierImport
      parentRoute: typeof StaffImport
    }
    '/_staff/supplier/_list': {
      id: '/_staff/supplier/_list'
      path: '/supplier'
      fullPath: '/supplier'
      preLoaderRoute: typeof StaffSupplierListImport
      parentRoute: typeof StaffSupplierRoute
    }
    '/_staff/time-and-attendance': {
      id: '/_staff/time-and-attendance'
      path: '/time-and-attendance'
      fullPath: '/time-and-attendance'
      preLoaderRoute: typeof StaffTimeAndAttendanceImport
      parentRoute: typeof StaffImport
    }
    '/_staff/time-and-attendance/_layout': {
      id: '/_staff/time-and-attendance/_layout'
      path: '/time-and-attendance'
      fullPath: '/time-and-attendance'
      preLoaderRoute: typeof StaffTimeAndAttendanceLayoutImport
      parentRoute: typeof StaffTimeAndAttendanceRoute
    }
    '/_staff/labor-core/group-name': {
      id: '/_staff/labor-core/group-name'
      path: '/group-name'
      fullPath: '/labor-core/group-name'
      preLoaderRoute: typeof StaffLaborCoreGroupNameLazyImport
      parentRoute: typeof StaffLaborCoreImport
    }
    '/_chat/chat/': {
      id: '/_chat/chat/'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatChatIndexImport
      parentRoute: typeof ChatImport
    }
    '/_cockpit-mock/cockpit-mock/': {
      id: '/_cockpit-mock/cockpit-mock/'
      path: '/cockpit-mock'
      fullPath: '/cockpit-mock'
      preLoaderRoute: typeof CockpitMockCockpitMockIndexImport
      parentRoute: typeof CockpitMockImport
    }
    '/_individual/individual/': {
      id: '/_individual/individual/'
      path: '/'
      fullPath: '/individual/'
      preLoaderRoute: typeof IndividualIndividualIndexImport
      parentRoute: typeof IndividualIndividualImport
    }
    '/_stacktrace/development-tickets/': {
      id: '/_stacktrace/development-tickets/'
      path: '/development-tickets'
      fullPath: '/development-tickets'
      preLoaderRoute: typeof StacktraceDevelopmentTicketsIndexImport
      parentRoute: typeof StacktraceImport
    }
    '/_stacktrace/production/': {
      id: '/_stacktrace/production/'
      path: '/production'
      fullPath: '/production'
      preLoaderRoute: typeof StacktraceProductionIndexImport
      parentRoute: typeof StacktraceImport
    }
    '/_stacktrace/products/': {
      id: '/_stacktrace/products/'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof StacktraceProductsIndexImport
      parentRoute: typeof StacktraceImport
    }
    '/_stacktrace/test-assets/': {
      id: '/_stacktrace/test-assets/'
      path: '/test-assets'
      fullPath: '/test-assets'
      preLoaderRoute: typeof StacktraceTestAssetsIndexImport
      parentRoute: typeof StacktraceImport
    }
    '/_staff/cockpit/': {
      id: '/_staff/cockpit/'
      path: '/cockpit'
      fullPath: '/cockpit'
      preLoaderRoute: typeof StaffCockpitIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/it-operation-core/': {
      id: '/_staff/it-operation-core/'
      path: '/'
      fullPath: '/it-operation-core/'
      preLoaderRoute: typeof StaffItOperationCoreIndexImport
      parentRoute: typeof StaffItOperationCoreImport
    }
    '/_staff/organization/': {
      id: '/_staff/organization/'
      path: '/'
      fullPath: '/organization/'
      preLoaderRoute: typeof StaffOrganizationIndexImport
      parentRoute: typeof StaffOrganizationImport
    }
    '/_staff/settings/': {
      id: '/_staff/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof StaffSettingsIndexImport
      parentRoute: typeof StaffImport
    }
    '/account/sso/': {
      id: '/account/sso/'
      path: '/account/sso'
      fullPath: '/account/sso'
      preLoaderRoute: typeof AccountSsoIndexImport
      parentRoute: typeof rootRoute
    }
    '/auth/password-reset/': {
      id: '/auth/password-reset/'
      path: '/auth/password-reset'
      fullPath: '/auth/password-reset'
      preLoaderRoute: typeof AuthPasswordResetIndexImport
      parentRoute: typeof rootRoute
    }
    '/auth/sign-in/': {
      id: '/auth/sign-in/'
      path: '/auth/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInIndexImport
      parentRoute: typeof rootRoute
    }
    '/oauth2/consent/': {
      id: '/oauth2/consent/'
      path: '/oauth2/consent'
      fullPath: '/oauth2/consent'
      preLoaderRoute: typeof Oauth2ConsentIndexImport
      parentRoute: typeof rootRoute
    }
    '/oauth2/error/': {
      id: '/oauth2/error/'
      path: '/oauth2/error'
      fullPath: '/oauth2/error'
      preLoaderRoute: typeof Oauth2ErrorIndexImport
      parentRoute: typeof rootRoute
    }
    '/oauth2/login/': {
      id: '/oauth2/login/'
      path: '/oauth2/login'
      fullPath: '/oauth2/login'
      preLoaderRoute: typeof Oauth2LoginIndexImport
      parentRoute: typeof rootRoute
    }
    '/oauth2/logout/': {
      id: '/oauth2/logout/'
      path: '/oauth2/logout'
      fullPath: '/oauth2/logout'
      preLoaderRoute: typeof Oauth2LogoutIndexImport
      parentRoute: typeof rootRoute
    }
    '/_staff/certification/_list/': {
      id: '/_staff/certification/_list/'
      path: '/'
      fullPath: '/certification/'
      preLoaderRoute: typeof StaffCertificationListIndexRouteImport
      parentRoute: typeof StaffCertificationListImport
    }
    '/_staff/licenses/_list/': {
      id: '/_staff/licenses/_list/'
      path: '/'
      fullPath: '/licenses/'
      preLoaderRoute: typeof StaffLicensesListIndexRouteImport
      parentRoute: typeof StaffLicensesListImport
    }
    '/_staff/app-integrations/import-csv/$id': {
      id: '/_staff/app-integrations/import-csv/$id'
      path: '/app-integrations/import-csv/$id'
      fullPath: '/app-integrations/import-csv/$id'
      preLoaderRoute: typeof StaffAppIntegrationsImportCsvIdRouteImport
      parentRoute: typeof StaffImport
    }
    '/_staff/business-partner/import-csv/corporation': {
      id: '/_staff/business-partner/import-csv/corporation'
      path: '/import-csv/corporation'
      fullPath: '/business-partner/import-csv/corporation'
      preLoaderRoute: typeof StaffBusinessPartnerImportCsvCorporationRouteImport
      parentRoute: typeof StaffBusinessPartnerImport
    }
    '/_staff/business-partner/import-csv/individual': {
      id: '/_staff/business-partner/import-csv/individual'
      path: '/import-csv/individual'
      fullPath: '/business-partner/import-csv/individual'
      preLoaderRoute: typeof StaffBusinessPartnerImportCsvIndividualRouteImport
      parentRoute: typeof StaffBusinessPartnerImport
    }
    '/_staff/devices/import-csv/$deviceType': {
      id: '/_staff/devices/import-csv/$deviceType'
      path: '/import-csv/$deviceType'
      fullPath: '/devices/import-csv/$deviceType'
      preLoaderRoute: typeof StaffDevicesImportCsvDeviceTypeRouteImport
      parentRoute: typeof StaffDevicesImport
    }
    '/_staff/it-operation-core/_root/in-house-packages': {
      id: '/_staff/it-operation-core/_root/in-house-packages'
      path: '/in-house-packages'
      fullPath: '/it-operation-core/in-house-packages'
      preLoaderRoute: typeof StaffItOperationCoreRootInHousePackagesRouteImport
      parentRoute: typeof StaffItOperationCoreRootImport
    }
    '/_staff/it-operation-core/_root/packages': {
      id: '/_staff/it-operation-core/_root/packages'
      path: '/packages'
      fullPath: '/it-operation-core/packages'
      preLoaderRoute: typeof StaffItOperationCoreRootPackagesRouteImport
      parentRoute: typeof StaffItOperationCoreRootImport
    }
    '/_staff/person/import-csv/$workerType': {
      id: '/_staff/person/import-csv/$workerType'
      path: '/person/import-csv/$workerType'
      fullPath: '/person/import-csv/$workerType'
      preLoaderRoute: typeof StaffPersonImportCsvWorkerTypeRouteImport
      parentRoute: typeof StaffImport
    }
    '/_staff/places/_layout/settings': {
      id: '/_staff/places/_layout/settings'
      path: '/settings'
      fullPath: '/places/settings'
      preLoaderRoute: typeof StaffPlacesLayoutSettingsRouteImport
      parentRoute: typeof StaffPlacesLayoutImport
    }
    '/_staff/public-ids/import-csv/$publicIdType': {
      id: '/_staff/public-ids/import-csv/$publicIdType'
      path: '/import-csv/$publicIdType'
      fullPath: '/public-ids/import-csv/$publicIdType'
      preLoaderRoute: typeof StaffPublicIdsImportCsvPublicIdTypeRouteImport
      parentRoute: typeof StaffPublicIdsImport
    }
    '/_staff/software/$id/import-csv': {
      id: '/_staff/software/$id/import-csv'
      path: '/$id/import-csv'
      fullPath: '/software/$id/import-csv'
      preLoaderRoute: typeof StaffSoftwareIdImportCsvRouteImport
      parentRoute: typeof StaffSoftwareImport
    }
    '/_staff/software/_layout/people': {
      id: '/_staff/software/_layout/people'
      path: '/people'
      fullPath: '/software/people'
      preLoaderRoute: typeof StaffSoftwareLayoutPeopleRouteImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_stacktrace/development-tickets/$ticketId': {
      id: '/_stacktrace/development-tickets/$ticketId'
      path: '/development-tickets/$ticketId'
      fullPath: '/development-tickets/$ticketId'
      preLoaderRoute: typeof StacktraceDevelopmentTicketsTicketIdImport
      parentRoute: typeof StacktraceImport
    }
    '/_stacktrace/development-tickets/$ticketId/_layout': {
      id: '/_stacktrace/development-tickets/$ticketId/_layout'
      path: '/development-tickets/$ticketId'
      fullPath: '/development-tickets/$ticketId'
      preLoaderRoute: typeof StacktraceDevelopmentTicketsTicketIdLayoutImport
      parentRoute: typeof StacktraceDevelopmentTicketsTicketIdRoute
    }
    '/_stacktrace/issues/$id': {
      id: '/_stacktrace/issues/$id'
      path: '/$id'
      fullPath: '/issues/$id'
      preLoaderRoute: typeof StacktraceIssuesIdImport
      parentRoute: typeof StacktraceIssuesImport
    }
    '/_stacktrace/issues/$id/_layout': {
      id: '/_stacktrace/issues/$id/_layout'
      path: '/$id'
      fullPath: '/issues/$id'
      preLoaderRoute: typeof StacktraceIssuesIdLayoutImport
      parentRoute: typeof StacktraceIssuesIdRoute
    }
    '/_stacktrace/product-roadmap/$roadmapId': {
      id: '/_stacktrace/product-roadmap/$roadmapId'
      path: '/$roadmapId'
      fullPath: '/product-roadmap/$roadmapId'
      preLoaderRoute: typeof StacktraceProductRoadmapRoadmapIdImport
      parentRoute: typeof StacktraceProductRoadmapImport
    }
    '/_stacktrace/product-roadmap/$roadmapId/_layout': {
      id: '/_stacktrace/product-roadmap/$roadmapId/_layout'
      path: '/$roadmapId'
      fullPath: '/product-roadmap/$roadmapId'
      preLoaderRoute: typeof StacktraceProductRoadmapRoadmapIdLayoutImport
      parentRoute: typeof StacktraceProductRoadmapRoadmapIdRoute
    }
    '/_stacktrace/production/$productionId': {
      id: '/_stacktrace/production/$productionId'
      path: '/production/$productionId'
      fullPath: '/production/$productionId'
      preLoaderRoute: typeof StacktraceProductionProductionIdImport
      parentRoute: typeof StacktraceImport
    }
    '/_stacktrace/production/$productionId/_layout': {
      id: '/_stacktrace/production/$productionId/_layout'
      path: '/production/$productionId'
      fullPath: '/production/$productionId'
      preLoaderRoute: typeof StacktraceProductionProductionIdLayoutImport
      parentRoute: typeof StacktraceProductionProductionIdRoute
    }
    '/_stacktrace/products/$id': {
      id: '/_stacktrace/products/$id'
      path: '/products/$id'
      fullPath: '/products/$id'
      preLoaderRoute: typeof StacktraceProductsIdImport
      parentRoute: typeof StacktraceImport
    }
    '/_stacktrace/products/$id/_layout': {
      id: '/_stacktrace/products/$id/_layout'
      path: '/products/$id'
      fullPath: '/products/$id'
      preLoaderRoute: typeof StacktraceProductsIdLayoutImport
      parentRoute: typeof StacktraceProductsIdRoute
    }
    '/_stacktrace/test-sets/$id': {
      id: '/_stacktrace/test-sets/$id'
      path: '/$id'
      fullPath: '/test-sets/$id'
      preLoaderRoute: typeof StacktraceTestSetsIdImport
      parentRoute: typeof StacktraceTestSetsImport
    }
    '/_stacktrace/test-sets/$id/_layout': {
      id: '/_stacktrace/test-sets/$id/_layout'
      path: '/$id'
      fullPath: '/test-sets/$id'
      preLoaderRoute: typeof StacktraceTestSetsIdLayoutImport
      parentRoute: typeof StacktraceTestSetsIdRoute
    }
    '/_stacktrace/test-suites/$id': {
      id: '/_stacktrace/test-suites/$id'
      path: '/$id'
      fullPath: '/test-suites/$id'
      preLoaderRoute: typeof StacktraceTestSuitesIdImport
      parentRoute: typeof StacktraceTestSuitesImport
    }
    '/_stacktrace/test-suites/$id/_layout': {
      id: '/_stacktrace/test-suites/$id/_layout'
      path: '/$id'
      fullPath: '/test-suites/$id'
      preLoaderRoute: typeof StacktraceTestSuitesIdLayoutImport
      parentRoute: typeof StacktraceTestSuitesIdRoute
    }
    '/_stacktrace/values/$id': {
      id: '/_stacktrace/values/$id'
      path: '/$id'
      fullPath: '/values/$id'
      preLoaderRoute: typeof StacktraceValuesIdImport
      parentRoute: typeof StacktraceValuesImport
    }
    '/_stacktrace/values/$id/_layout': {
      id: '/_stacktrace/values/$id/_layout'
      path: '/$id'
      fullPath: '/values/$id'
      preLoaderRoute: typeof StacktraceValuesIdLayoutImport
      parentRoute: typeof StacktraceValuesIdRoute
    }
    '/_staff/app-integrations/$id': {
      id: '/_staff/app-integrations/$id'
      path: '/app-integrations/$id'
      fullPath: '/app-integrations/$id'
      preLoaderRoute: typeof StaffAppIntegrationsIdImport
      parentRoute: typeof StaffImport
    }
    '/_staff/app-integrations/$id/_$id': {
      id: '/_staff/app-integrations/$id/_$id'
      path: '/app-integrations/$id'
      fullPath: '/app-integrations/$id'
      preLoaderRoute: typeof StaffAppIntegrationsIdIdImport
      parentRoute: typeof StaffAppIntegrationsIdRoute
    }
    '/_staff/business-operation-events/_list/archive': {
      id: '/_staff/business-operation-events/_list/archive'
      path: '/archive'
      fullPath: '/business-operation-events/archive'
      preLoaderRoute: typeof StaffBusinessOperationEventsListArchiveImport
      parentRoute: typeof StaffBusinessOperationEventsListImport
    }
    '/_staff/business-operation-events/_list/config': {
      id: '/_staff/business-operation-events/_list/config'
      path: '/config'
      fullPath: '/business-operation-events/config'
      preLoaderRoute: typeof StaffBusinessOperationEventsListConfigImport
      parentRoute: typeof StaffBusinessOperationEventsListImport
    }
    '/_staff/business-operation-events/_list/operation-activity': {
      id: '/_staff/business-operation-events/_list/operation-activity'
      path: '/operation-activity'
      fullPath: '/business-operation-events/operation-activity'
      preLoaderRoute: typeof StaffBusinessOperationEventsListOperationActivityImport
      parentRoute: typeof StaffBusinessOperationEventsListImport
    }
    '/_staff/business-operation-events/_list/overview': {
      id: '/_staff/business-operation-events/_list/overview'
      path: '/overview'
      fullPath: '/business-operation-events/overview'
      preLoaderRoute: typeof StaffBusinessOperationEventsListOverviewImport
      parentRoute: typeof StaffBusinessOperationEventsListImport
    }
    '/_staff/business-operation-events/_list/rule-and-policy': {
      id: '/_staff/business-operation-events/_list/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/business-operation-events/rule-and-policy'
      preLoaderRoute: typeof StaffBusinessOperationEventsListRuleAndPolicyImport
      parentRoute: typeof StaffBusinessOperationEventsListImport
    }
    '/_staff/business-operation-events/_list/settings': {
      id: '/_staff/business-operation-events/_list/settings'
      path: '/settings'
      fullPath: '/business-operation-events/settings'
      preLoaderRoute: typeof StaffBusinessOperationEventsListSettingsImport
      parentRoute: typeof StaffBusinessOperationEventsListImport
    }
    '/_staff/business-partner/$id': {
      id: '/_staff/business-partner/$id'
      path: '/$id'
      fullPath: '/business-partner/$id'
      preLoaderRoute: typeof StaffBusinessPartnerIdImport
      parentRoute: typeof StaffBusinessPartnerImport
    }
    '/_staff/business-partner/$id/_layout': {
      id: '/_staff/business-partner/$id/_layout'
      path: '/$id'
      fullPath: '/business-partner/$id'
      preLoaderRoute: typeof StaffBusinessPartnerIdLayoutImport
      parentRoute: typeof StaffBusinessPartnerIdRoute
    }
    '/_staff/certification/$id': {
      id: '/_staff/certification/$id'
      path: '/$id'
      fullPath: '/certification/$id'
      preLoaderRoute: typeof StaffCertificationIdImport
      parentRoute: typeof StaffCertificationImport
    }
    '/_staff/certification/$id/_layout': {
      id: '/_staff/certification/$id/_layout'
      path: '/$id'
      fullPath: '/certification/$id'
      preLoaderRoute: typeof StaffCertificationIdLayoutImport
      parentRoute: typeof StaffCertificationIdRoute
    }
    '/_staff/contract/$id': {
      id: '/_staff/contract/$id'
      path: '/$id'
      fullPath: '/contract/$id'
      preLoaderRoute: typeof StaffContractIdImport
      parentRoute: typeof StaffContractImport
    }
    '/_staff/contract/$id/_layout': {
      id: '/_staff/contract/$id/_layout'
      path: '/$id'
      fullPath: '/contract/$id'
      preLoaderRoute: typeof StaffContractIdLayoutImport
      parentRoute: typeof StaffContractIdRoute
    }
    '/_staff/deal/$dealId': {
      id: '/_staff/deal/$dealId'
      path: '/$dealId'
      fullPath: '/deal/$dealId'
      preLoaderRoute: typeof StaffDealDealIdImport
      parentRoute: typeof StaffDealImport
    }
    '/_staff/deal/$dealId/_layout': {
      id: '/_staff/deal/$dealId/_layout'
      path: '/$dealId'
      fullPath: '/deal/$dealId'
      preLoaderRoute: typeof StaffDealDealIdLayoutImport
      parentRoute: typeof StaffDealDealIdRoute
    }
    '/_staff/devices/$id': {
      id: '/_staff/devices/$id'
      path: '/$id'
      fullPath: '/devices/$id'
      preLoaderRoute: typeof StaffDevicesIdImport
      parentRoute: typeof StaffDevicesImport
    }
    '/_staff/devices/$id/_layout': {
      id: '/_staff/devices/$id/_layout'
      path: '/$id'
      fullPath: '/devices/$id'
      preLoaderRoute: typeof StaffDevicesIdLayoutImport
      parentRoute: typeof StaffDevicesIdRoute
    }
    '/_staff/devices/_list/alerts': {
      id: '/_staff/devices/_list/alerts'
      path: '/alerts'
      fullPath: '/devices/alerts'
      preLoaderRoute: typeof StaffDevicesListAlertsImport
      parentRoute: typeof StaffDevicesListImport
    }
    '/_staff/devices/_list/operation-activity': {
      id: '/_staff/devices/_list/operation-activity'
      path: '/operation-activity'
      fullPath: '/devices/operation-activity'
      preLoaderRoute: typeof StaffDevicesListOperationActivityImport
      parentRoute: typeof StaffDevicesListImport
    }
    '/_staff/devices/_list/rule-and-policy': {
      id: '/_staff/devices/_list/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/devices/rule-and-policy'
      preLoaderRoute: typeof StaffDevicesListRuleAndPolicyImport
      parentRoute: typeof StaffDevicesListImport
    }
    '/_staff/equipment/$id': {
      id: '/_staff/equipment/$id'
      path: '/$id'
      fullPath: '/equipment/$id'
      preLoaderRoute: typeof StaffEquipmentIdImport
      parentRoute: typeof StaffEquipmentImport
    }
    '/_staff/equipment/$id/_layout': {
      id: '/_staff/equipment/$id/_layout'
      path: '/$id'
      fullPath: '/equipment/$id'
      preLoaderRoute: typeof StaffEquipmentIdLayoutImport
      parentRoute: typeof StaffEquipmentIdRoute
    }
    '/_staff/fleets/$id': {
      id: '/_staff/fleets/$id'
      path: '/$id'
      fullPath: '/fleets/$id'
      preLoaderRoute: typeof StaffFleetsIdImport
      parentRoute: typeof StaffFleetsImport
    }
    '/_staff/fleets/$id/_layout': {
      id: '/_staff/fleets/$id/_layout'
      path: '/$id'
      fullPath: '/fleets/$id'
      preLoaderRoute: typeof StaffFleetsIdLayoutImport
      parentRoute: typeof StaffFleetsIdRoute
    }
    '/_staff/fleets/_layout/alerts': {
      id: '/_staff/fleets/_layout/alerts'
      path: '/alerts'
      fullPath: '/fleets/alerts'
      preLoaderRoute: typeof StaffFleetsLayoutAlertsImport
      parentRoute: typeof StaffFleetsLayoutImport
    }
    '/_staff/fleets/_layout/overview': {
      id: '/_staff/fleets/_layout/overview'
      path: '/overview'
      fullPath: '/fleets/overview'
      preLoaderRoute: typeof StaffFleetsLayoutOverviewImport
      parentRoute: typeof StaffFleetsLayoutImport
    }
    '/_staff/fleets/_layout/rule-and-policy': {
      id: '/_staff/fleets/_layout/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/fleets/rule-and-policy'
      preLoaderRoute: typeof StaffFleetsLayoutRuleAndPolicyImport
      parentRoute: typeof StaffFleetsLayoutImport
    }
    '/_staff/fleets/_layout/settings': {
      id: '/_staff/fleets/_layout/settings'
      path: '/settings'
      fullPath: '/fleets/settings'
      preLoaderRoute: typeof StaffFleetsLayoutSettingsImport
      parentRoute: typeof StaffFleetsLayoutImport
    }
    '/_staff/it-operation-core/device-inventory/data': {
      id: '/_staff/it-operation-core/device-inventory/data'
      path: '/data'
      fullPath: '/it-operation-core/device-inventory/data'
      preLoaderRoute: typeof StaffItOperationCoreDeviceInventoryDataImport
      parentRoute: typeof StaffItOperationCoreDeviceInventoryRouteImport
    }
    '/_staff/it-operation-core/device-inventory/detail': {
      id: '/_staff/it-operation-core/device-inventory/detail'
      path: '/detail'
      fullPath: '/it-operation-core/device-inventory/detail'
      preLoaderRoute: typeof StaffItOperationCoreDeviceInventoryDetailImport
      parentRoute: typeof StaffItOperationCoreDeviceInventoryRouteImport
    }
    '/_staff/labor-core/_packages/settings': {
      id: '/_staff/labor-core/_packages/settings'
      path: '/settings'
      fullPath: '/labor-core/settings'
      preLoaderRoute: typeof StaffLaborCorePackagesSettingsImport
      parentRoute: typeof StaffLaborCorePackagesImport
    }
    '/_staff/labor-core/settings/egov-callback': {
      id: '/_staff/labor-core/settings/egov-callback'
      path: '/settings/egov-callback'
      fullPath: '/labor-core/settings/egov-callback'
      preLoaderRoute: typeof StaffLaborCoreSettingsEgovCallbackImport
      parentRoute: typeof StaffLaborCoreImport
    }
    '/_staff/licenses/$id': {
      id: '/_staff/licenses/$id'
      path: '/$id'
      fullPath: '/licenses/$id'
      preLoaderRoute: typeof StaffLicensesIdImport
      parentRoute: typeof StaffLicensesImport
    }
    '/_staff/licenses/$id/_profile': {
      id: '/_staff/licenses/$id/_profile'
      path: '/$id'
      fullPath: '/licenses/$id'
      preLoaderRoute: typeof StaffLicensesIdProfileImport
      parentRoute: typeof StaffLicensesIdRoute
    }
    '/_staff/networks/$id': {
      id: '/_staff/networks/$id'
      path: '/$id'
      fullPath: '/networks/$id'
      preLoaderRoute: typeof StaffNetworksIdImport
      parentRoute: typeof StaffNetworksImport
    }
    '/_staff/networks/$id/_layout': {
      id: '/_staff/networks/$id/_layout'
      path: '/$id'
      fullPath: '/networks/$id'
      preLoaderRoute: typeof StaffNetworksIdLayoutImport
      parentRoute: typeof StaffNetworksIdRoute
    }
    '/_staff/organization/$id': {
      id: '/_staff/organization/$id'
      path: '/$id'
      fullPath: '/organization/$id'
      preLoaderRoute: typeof StaffOrganizationIdImport
      parentRoute: typeof StaffOrganizationImport
    }
    '/_staff/organization/$id/_layout': {
      id: '/_staff/organization/$id/_layout'
      path: '/$id'
      fullPath: '/organization/$id'
      preLoaderRoute: typeof StaffOrganizationIdLayoutImport
      parentRoute: typeof StaffOrganizationIdRoute
    }
    '/_staff/people/_list/alerts': {
      id: '/_staff/people/_list/alerts'
      path: '/alerts'
      fullPath: '/people/alerts'
      preLoaderRoute: typeof StaffPeopleListAlertsImport
      parentRoute: typeof StaffPeopleListImport
    }
    '/_staff/people/_list/community': {
      id: '/_staff/people/_list/community'
      path: '/community'
      fullPath: '/people/community'
      preLoaderRoute: typeof StaffPeopleListCommunityImport
      parentRoute: typeof StaffPeopleListImport
    }
    '/_staff/people/_list/people-graph': {
      id: '/_staff/people/_list/people-graph'
      path: '/people-graph'
      fullPath: '/people/people-graph'
      preLoaderRoute: typeof StaffPeopleListPeopleGraphImport
      parentRoute: typeof StaffPeopleListImport
    }
    '/_staff/people/_list/rule-and-policy': {
      id: '/_staff/people/_list/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/people/rule-and-policy'
      preLoaderRoute: typeof StaffPeopleListRuleAndPolicyImport
      parentRoute: typeof StaffPeopleListImport
    }
    '/_staff/people/_list/salary-and-payment': {
      id: '/_staff/people/_list/salary-and-payment'
      path: '/salary-and-payment'
      fullPath: '/people/salary-and-payment'
      preLoaderRoute: typeof StaffPeopleListSalaryAndPaymentImport
      parentRoute: typeof StaffPeopleListImport
    }
    '/_staff/person/$id': {
      id: '/_staff/person/$id'
      path: '/person/$id'
      fullPath: '/person/$id'
      preLoaderRoute: typeof StaffPersonIdImport
      parentRoute: typeof StaffImport
    }
    '/_staff/person/$id/_profile': {
      id: '/_staff/person/$id/_profile'
      path: '/person/$id'
      fullPath: '/person/$id'
      preLoaderRoute: typeof StaffPersonIdProfileImport
      parentRoute: typeof StaffPersonIdRoute
    }
    '/_staff/places/$id': {
      id: '/_staff/places/$id'
      path: '/$id'
      fullPath: '/places/$id'
      preLoaderRoute: typeof StaffPlacesIdImport
      parentRoute: typeof StaffPlacesImport
    }
    '/_staff/places/$id/_layout': {
      id: '/_staff/places/$id/_layout'
      path: '/$id'
      fullPath: '/places/$id'
      preLoaderRoute: typeof StaffPlacesIdLayoutImport
      parentRoute: typeof StaffPlacesIdRoute
    }
    '/_staff/places/_layout/overview': {
      id: '/_staff/places/_layout/overview'
      path: '/overview'
      fullPath: '/places/overview'
      preLoaderRoute: typeof StaffPlacesLayoutOverviewImport
      parentRoute: typeof StaffPlacesLayoutImport
    }
    '/_staff/settings/contracting-corporation-profile': {
      id: '/_staff/settings/contracting-corporation-profile'
      path: '/settings/contracting-corporation-profile'
      fullPath: '/settings/contracting-corporation-profile'
      preLoaderRoute: typeof StaffSettingsContractingCorporationProfileImport
      parentRoute: typeof StaffImport
    }
    '/_staff/settings/contracting-corporation-profile/_layout': {
      id: '/_staff/settings/contracting-corporation-profile/_layout'
      path: '/settings/contracting-corporation-profile'
      fullPath: '/settings/contracting-corporation-profile'
      preLoaderRoute: typeof StaffSettingsContractingCorporationProfileLayoutImport
      parentRoute: typeof StaffSettingsContractingCorporationProfileRoute
    }
    '/_staff/settings/permission-and-roles': {
      id: '/_staff/settings/permission-and-roles'
      path: '/settings/permission-and-roles'
      fullPath: '/settings/permission-and-roles'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesImport
      parentRoute: typeof StaffImport
    }
    '/_staff/settings/permission-and-roles/_detail': {
      id: '/_staff/settings/permission-and-roles/_detail'
      path: '/settings/permission-and-roles'
      fullPath: '/settings/permission-and-roles'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesDetailImport
      parentRoute: typeof StaffSettingsPermissionAndRolesRoute
    }
    '/_staff/settings/permission-and-roles/_form': {
      id: '/_staff/settings/permission-and-roles/_form'
      path: ''
      fullPath: '/settings/permission-and-roles'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesFormImport
      parentRoute: typeof StaffSettingsPermissionAndRolesImport
    }
    '/_staff/settings/permission-and-roles/_list': {
      id: '/_staff/settings/permission-and-roles/_list'
      path: ''
      fullPath: '/settings/permission-and-roles'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesListImport
      parentRoute: typeof StaffSettingsPermissionAndRolesImport
    }
    '/_staff/settings/persons': {
      id: '/_staff/settings/persons'
      path: '/settings/persons'
      fullPath: '/settings/persons'
      preLoaderRoute: typeof StaffSettingsPersonsImport
      parentRoute: typeof StaffImport
    }
    '/_staff/settings/persons/_list': {
      id: '/_staff/settings/persons/_list'
      path: '/settings/persons'
      fullPath: '/settings/persons'
      preLoaderRoute: typeof StaffSettingsPersonsListImport
      parentRoute: typeof StaffSettingsPersonsRoute
    }
    '/_staff/software/$id': {
      id: '/_staff/software/$id'
      path: '/$id'
      fullPath: '/software/$id'
      preLoaderRoute: typeof StaffSoftwareIdImport
      parentRoute: typeof StaffSoftwareImport
    }
    '/_staff/software/$id/_$id': {
      id: '/_staff/software/$id/_$id'
      path: '/$id'
      fullPath: '/software/$id'
      preLoaderRoute: typeof StaffSoftwareIdIdImport
      parentRoute: typeof StaffSoftwareIdRoute
    }
    '/_staff/software/_layout/integrations': {
      id: '/_staff/software/_layout/integrations'
      path: '/integrations'
      fullPath: '/software/integrations'
      preLoaderRoute: typeof StaffSoftwareLayoutIntegrationsImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/starlinks/$id': {
      id: '/_staff/starlinks/$id'
      path: '/$id'
      fullPath: '/starlinks/$id'
      preLoaderRoute: typeof StaffStarlinksIdImport
      parentRoute: typeof StaffStarlinksImport
    }
    '/_staff/starlinks/$id/_layout': {
      id: '/_staff/starlinks/$id/_layout'
      path: '/$id'
      fullPath: '/starlinks/$id'
      preLoaderRoute: typeof StaffStarlinksIdLayoutImport
      parentRoute: typeof StaffStarlinksIdRoute
    }
    '/_staff/supplier/$supplierId': {
      id: '/_staff/supplier/$supplierId'
      path: '/$supplierId'
      fullPath: '/supplier/$supplierId'
      preLoaderRoute: typeof StaffSupplierSupplierIdImport
      parentRoute: typeof StaffSupplierImport
    }
    '/_staff/supplier/$supplierId/_layout': {
      id: '/_staff/supplier/$supplierId/_layout'
      path: '/$supplierId'
      fullPath: '/supplier/$supplierId'
      preLoaderRoute: typeof StaffSupplierSupplierIdLayoutImport
      parentRoute: typeof StaffSupplierSupplierIdRoute
    }
    '/_staff/users/$userId': {
      id: '/_staff/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof StaffUsersUserIdImport
      parentRoute: typeof StaffImport
    }
    '/_staff/users/$userId/_layout': {
      id: '/_staff/users/$userId/_layout'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof StaffUsersUserIdLayoutImport
      parentRoute: typeof StaffUsersUserIdRoute
    }
    '/_staff/devices/_list/': {
      id: '/_staff/devices/_list/'
      path: '/'
      fullPath: '/devices/'
      preLoaderRoute: typeof StaffDevicesListIndexRouteLazyImport
      parentRoute: typeof StaffDevicesListImport
    }
    '/_staff/people/_list/': {
      id: '/_staff/people/_list/'
      path: '/'
      fullPath: '/people/'
      preLoaderRoute: typeof StaffPeopleListIndexRouteLazyImport
      parentRoute: typeof StaffPeopleListImport
    }
    '/_staff/software/_layout/': {
      id: '/_staff/software/_layout/'
      path: '/'
      fullPath: '/software/'
      preLoaderRoute: typeof StaffSoftwareLayoutIndexRouteLazyImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/certification/_list/settings': {
      id: '/_staff/certification/_list/settings'
      path: '/settings'
      fullPath: '/certification/settings'
      preLoaderRoute: typeof StaffCertificationListSettingsRouteLazyImport
      parentRoute: typeof StaffCertificationListImport
    }
    '/_staff/devices/_list/settings': {
      id: '/_staff/devices/_list/settings'
      path: '/settings'
      fullPath: '/devices/settings'
      preLoaderRoute: typeof StaffDevicesListSettingsRouteLazyImport
      parentRoute: typeof StaffDevicesListImport
    }
    '/_staff/equipment/_layout/settings': {
      id: '/_staff/equipment/_layout/settings'
      path: '/settings'
      fullPath: '/equipment/settings'
      preLoaderRoute: typeof StaffEquipmentLayoutSettingsRouteLazyImport
      parentRoute: typeof StaffEquipmentLayoutImport
    }
    '/_staff/people/_list/settings': {
      id: '/_staff/people/_list/settings'
      path: '/settings'
      fullPath: '/people/settings'
      preLoaderRoute: typeof StaffPeopleListSettingsRouteLazyImport
      parentRoute: typeof StaffPeopleListImport
    }
    '/_staff/supplier/_list/settings': {
      id: '/_staff/supplier/_list/settings'
      path: '/settings'
      fullPath: '/supplier/settings'
      preLoaderRoute: typeof StaffSupplierListSettingsRouteLazyImport
      parentRoute: typeof StaffSupplierListImport
    }
    '/_chat/chat/$sessionId/': {
      id: '/_chat/chat/$sessionId/'
      path: '/chat/$sessionId'
      fullPath: '/chat/$sessionId'
      preLoaderRoute: typeof ChatChatSessionIdIndexImport
      parentRoute: typeof ChatImport
    }
    '/_chat/chat/new/': {
      id: '/_chat/chat/new/'
      path: '/chat/new'
      fullPath: '/chat/new'
      preLoaderRoute: typeof ChatChatNewIndexImport
      parentRoute: typeof ChatImport
    }
    '/_idp-sso-mock/idp-sso/google-workspace/': {
      id: '/_idp-sso-mock/idp-sso/google-workspace/'
      path: '/idp-sso/google-workspace'
      fullPath: '/idp-sso/google-workspace'
      preLoaderRoute: typeof IdpSsoMockIdpSsoGoogleWorkspaceIndexImport
      parentRoute: typeof IdpSsoMockImport
    }
    '/_individual/individual/portal/': {
      id: '/_individual/individual/portal/'
      path: '/'
      fullPath: '/individual/portal/'
      preLoaderRoute: typeof IndividualIndividualPortalIndexImport
      parentRoute: typeof IndividualIndividualPortalImport
    }
    '/_stacktrace/development-tickets/add-select/': {
      id: '/_stacktrace/development-tickets/add-select/'
      path: '/development-tickets/add-select'
      fullPath: '/development-tickets/add-select'
      preLoaderRoute: typeof StacktraceDevelopmentTicketsAddSelectIndexImport
      parentRoute: typeof StacktraceImport
    }
    '/_stacktrace/development-tickets/add/': {
      id: '/_stacktrace/development-tickets/add/'
      path: '/development-tickets/add'
      fullPath: '/development-tickets/add'
      preLoaderRoute: typeof StacktraceDevelopmentTicketsAddIndexImport
      parentRoute: typeof StacktraceImport
    }
    '/_stacktrace/development-tickets/external-integrations/': {
      id: '/_stacktrace/development-tickets/external-integrations/'
      path: '/development-tickets/external-integrations'
      fullPath: '/development-tickets/external-integrations'
      preLoaderRoute: typeof StacktraceDevelopmentTicketsExternalIntegrationsIndexImport
      parentRoute: typeof StacktraceImport
    }
    '/_stacktrace/issues/_layout/': {
      id: '/_stacktrace/issues/_layout/'
      path: '/'
      fullPath: '/issues/'
      preLoaderRoute: typeof StacktraceIssuesLayoutIndexImport
      parentRoute: typeof StacktraceIssuesLayoutImport
    }
    '/_stacktrace/issues/add-select/': {
      id: '/_stacktrace/issues/add-select/'
      path: '/add-select'
      fullPath: '/issues/add-select'
      preLoaderRoute: typeof StacktraceIssuesAddSelectIndexImport
      parentRoute: typeof StacktraceIssuesImport
    }
    '/_stacktrace/issues/add/': {
      id: '/_stacktrace/issues/add/'
      path: '/add'
      fullPath: '/issues/add'
      preLoaderRoute: typeof StacktraceIssuesAddIndexImport
      parentRoute: typeof StacktraceIssuesImport
    }
    '/_stacktrace/issues/external-integrations/': {
      id: '/_stacktrace/issues/external-integrations/'
      path: '/external-integrations'
      fullPath: '/issues/external-integrations'
      preLoaderRoute: typeof StacktraceIssuesExternalIntegrationsIndexImport
      parentRoute: typeof StacktraceIssuesImport
    }
    '/_stacktrace/product-roadmap/_layout/': {
      id: '/_stacktrace/product-roadmap/_layout/'
      path: '/'
      fullPath: '/product-roadmap/'
      preLoaderRoute: typeof StacktraceProductRoadmapLayoutIndexImport
      parentRoute: typeof StacktraceProductRoadmapLayoutImport
    }
    '/_stacktrace/products/add-select/': {
      id: '/_stacktrace/products/add-select/'
      path: '/products/add-select'
      fullPath: '/products/add-select'
      preLoaderRoute: typeof StacktraceProductsAddSelectIndexImport
      parentRoute: typeof StacktraceImport
    }
    '/_stacktrace/products/add/': {
      id: '/_stacktrace/products/add/'
      path: '/products/add'
      fullPath: '/products/add'
      preLoaderRoute: typeof StacktraceProductsAddIndexImport
      parentRoute: typeof StacktraceImport
    }
    '/_stacktrace/test-sets/_layout/': {
      id: '/_stacktrace/test-sets/_layout/'
      path: '/'
      fullPath: '/test-sets/'
      preLoaderRoute: typeof StacktraceTestSetsLayoutIndexImport
      parentRoute: typeof StacktraceTestSetsLayoutImport
    }
    '/_stacktrace/test-suites/_layout/': {
      id: '/_stacktrace/test-suites/_layout/'
      path: '/'
      fullPath: '/test-suites/'
      preLoaderRoute: typeof StacktraceTestSuitesLayoutIndexImport
      parentRoute: typeof StacktraceTestSuitesLayoutImport
    }
    '/_stacktrace/values/_layout/': {
      id: '/_stacktrace/values/_layout/'
      path: '/'
      fullPath: '/values/'
      preLoaderRoute: typeof StacktraceValuesLayoutIndexImport
      parentRoute: typeof StacktraceValuesLayoutImport
    }
    '/_stacktrace/values/add-select/': {
      id: '/_stacktrace/values/add-select/'
      path: '/add-select'
      fullPath: '/values/add-select'
      preLoaderRoute: typeof StacktraceValuesAddSelectIndexImport
      parentRoute: typeof StacktraceValuesImport
    }
    '/_stacktrace/values/add/': {
      id: '/_stacktrace/values/add/'
      path: '/add'
      fullPath: '/values/add'
      preLoaderRoute: typeof StacktraceValuesAddIndexImport
      parentRoute: typeof StacktraceValuesImport
    }
    '/_staff/accesses/_layout/': {
      id: '/_staff/accesses/_layout/'
      path: '/'
      fullPath: '/accesses/'
      preLoaderRoute: typeof StaffAccessesLayoutIndexImport
      parentRoute: typeof StaffAccessesLayoutImport
    }
    '/_staff/attendance-core/_layout/': {
      id: '/_staff/attendance-core/_layout/'
      path: '/'
      fullPath: '/attendance-core/'
      preLoaderRoute: typeof StaffAttendanceCoreLayoutIndexImport
      parentRoute: typeof StaffAttendanceCoreLayoutImport
    }
    '/_staff/attendance-engine/_layout/': {
      id: '/_staff/attendance-engine/_layout/'
      path: '/'
      fullPath: '/attendance-engine/'
      preLoaderRoute: typeof StaffAttendanceEngineLayoutIndexImport
      parentRoute: typeof StaffAttendanceEngineLayoutImport
    }
    '/_staff/attendances/_layout/': {
      id: '/_staff/attendances/_layout/'
      path: '/'
      fullPath: '/attendances/'
      preLoaderRoute: typeof StaffAttendancesLayoutIndexImport
      parentRoute: typeof StaffAttendancesLayoutImport
    }
    '/_staff/business-operation-events/$eventInstanceId/': {
      id: '/_staff/business-operation-events/$eventInstanceId/'
      path: '/$eventInstanceId'
      fullPath: '/business-operation-events/$eventInstanceId'
      preLoaderRoute: typeof StaffBusinessOperationEventsEventInstanceIdIndexImport
      parentRoute: typeof StaffBusinessOperationEventsImport
    }
    '/_staff/business-operation-events/_list/': {
      id: '/_staff/business-operation-events/_list/'
      path: '/'
      fullPath: '/business-operation-events/'
      preLoaderRoute: typeof StaffBusinessOperationEventsListIndexImport
      parentRoute: typeof StaffBusinessOperationEventsListImport
    }
    '/_staff/business-partner/_list/': {
      id: '/_staff/business-partner/_list/'
      path: '/'
      fullPath: '/business-partner/'
      preLoaderRoute: typeof StaffBusinessPartnerListIndexImport
      parentRoute: typeof StaffBusinessPartnerListImport
    }
    '/_staff/business-partner/add/': {
      id: '/_staff/business-partner/add/'
      path: '/add'
      fullPath: '/business-partner/add'
      preLoaderRoute: typeof StaffBusinessPartnerAddIndexImport
      parentRoute: typeof StaffBusinessPartnerImport
    }
    '/_staff/certification/add/': {
      id: '/_staff/certification/add/'
      path: '/add'
      fullPath: '/certification/add'
      preLoaderRoute: typeof StaffCertificationAddIndexImport
      parentRoute: typeof StaffCertificationImport
    }
    '/_staff/contract/_list/': {
      id: '/_staff/contract/_list/'
      path: '/'
      fullPath: '/contract/'
      preLoaderRoute: typeof StaffContractListIndexImport
      parentRoute: typeof StaffContractListImport
    }
    '/_staff/contract/add/': {
      id: '/_staff/contract/add/'
      path: '/add'
      fullPath: '/contract/add'
      preLoaderRoute: typeof StaffContractAddIndexImport
      parentRoute: typeof StaffContractImport
    }
    '/_staff/contractor-core/_packages/': {
      id: '/_staff/contractor-core/_packages/'
      path: '/'
      fullPath: '/contractor-core/'
      preLoaderRoute: typeof StaffContractorCorePackagesIndexImport
      parentRoute: typeof StaffContractorCorePackagesImport
    }
    '/_staff/deal/_list/': {
      id: '/_staff/deal/_list/'
      path: '/'
      fullPath: '/deal/'
      preLoaderRoute: typeof StaffDealListIndexImport
      parentRoute: typeof StaffDealListImport
    }
    '/_staff/deal/add/': {
      id: '/_staff/deal/add/'
      path: '/add'
      fullPath: '/deal/add'
      preLoaderRoute: typeof StaffDealAddIndexImport
      parentRoute: typeof StaffDealImport
    }
    '/_staff/device-catalog/add/': {
      id: '/_staff/device-catalog/add/'
      path: '/device-catalog/add'
      fullPath: '/device-catalog/add'
      preLoaderRoute: typeof StaffDeviceCatalogAddIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/devices/add/': {
      id: '/_staff/devices/add/'
      path: '/add'
      fullPath: '/devices/add'
      preLoaderRoute: typeof StaffDevicesAddIndexImport
      parentRoute: typeof StaffDevicesImport
    }
    '/_staff/devices/external-it-saas/': {
      id: '/_staff/devices/external-it-saas/'
      path: '/external-it-saas'
      fullPath: '/devices/external-it-saas'
      preLoaderRoute: typeof StaffDevicesExternalItSaasIndexImport
      parentRoute: typeof StaffDevicesImport
    }
    '/_staff/equipment/_layout/': {
      id: '/_staff/equipment/_layout/'
      path: '/'
      fullPath: '/equipment/'
      preLoaderRoute: typeof StaffEquipmentLayoutIndexImport
      parentRoute: typeof StaffEquipmentLayoutImport
    }
    '/_staff/equipment/add-select/': {
      id: '/_staff/equipment/add-select/'
      path: '/add-select'
      fullPath: '/equipment/add-select'
      preLoaderRoute: typeof StaffEquipmentAddSelectIndexImport
      parentRoute: typeof StaffEquipmentImport
    }
    '/_staff/equipment/add/': {
      id: '/_staff/equipment/add/'
      path: '/add'
      fullPath: '/equipment/add'
      preLoaderRoute: typeof StaffEquipmentAddIndexImport
      parentRoute: typeof StaffEquipmentImport
    }
    '/_staff/equipment/import-csv/': {
      id: '/_staff/equipment/import-csv/'
      path: '/import-csv'
      fullPath: '/equipment/import-csv'
      preLoaderRoute: typeof StaffEquipmentImportCsvIndexImport
      parentRoute: typeof StaffEquipmentImport
    }
    '/_staff/fleets/add-select/': {
      id: '/_staff/fleets/add-select/'
      path: '/add-select'
      fullPath: '/fleets/add-select'
      preLoaderRoute: typeof StaffFleetsAddSelectIndexImport
      parentRoute: typeof StaffFleetsImport
    }
    '/_staff/fleets/add/': {
      id: '/_staff/fleets/add/'
      path: '/add'
      fullPath: '/fleets/add'
      preLoaderRoute: typeof StaffFleetsAddIndexImport
      parentRoute: typeof StaffFleetsImport
    }
    '/_staff/ga-operation-core/_packages/': {
      id: '/_staff/ga-operation-core/_packages/'
      path: '/'
      fullPath: '/ga-operation-core/'
      preLoaderRoute: typeof StaffGaOperationCorePackagesIndexImport
      parentRoute: typeof StaffGaOperationCorePackagesImport
    }
    '/_staff/ids/_layout/': {
      id: '/_staff/ids/_layout/'
      path: '/'
      fullPath: '/ids/'
      preLoaderRoute: typeof StaffIdsLayoutIndexImport
      parentRoute: typeof StaffIdsLayoutImport
    }
    '/_staff/it-operation-core/device-targets/': {
      id: '/_staff/it-operation-core/device-targets/'
      path: '/device-targets'
      fullPath: '/it-operation-core/device-targets'
      preLoaderRoute: typeof StaffItOperationCoreDeviceTargetsIndexImport
      parentRoute: typeof StaffItOperationCoreImport
    }
    '/_staff/it-operation-core/person-targets/': {
      id: '/_staff/it-operation-core/person-targets/'
      path: '/person-targets'
      fullPath: '/it-operation-core/person-targets'
      preLoaderRoute: typeof StaffItOperationCorePersonTargetsIndexImport
      parentRoute: typeof StaffItOperationCoreImport
    }
    '/_staff/labor-core/_packages/': {
      id: '/_staff/labor-core/_packages/'
      path: '/'
      fullPath: '/labor-core/'
      preLoaderRoute: typeof StaffLaborCorePackagesIndexImport
      parentRoute: typeof StaffLaborCorePackagesImport
    }
    '/_staff/licenses/add/': {
      id: '/_staff/licenses/add/'
      path: '/add'
      fullPath: '/licenses/add'
      preLoaderRoute: typeof StaffLicensesAddIndexImport
      parentRoute: typeof StaffLicensesImport
    }
    '/_staff/marketplace/cart/': {
      id: '/_staff/marketplace/cart/'
      path: '/cart'
      fullPath: '/marketplace/cart'
      preLoaderRoute: typeof StaffMarketplaceCartIndexImport
      parentRoute: typeof StaffMarketplaceImport
    }
    '/_staff/marketplace/unavailable/': {
      id: '/_staff/marketplace/unavailable/'
      path: '/unavailable'
      fullPath: '/marketplace/unavailable'
      preLoaderRoute: typeof StaffMarketplaceUnavailableIndexImport
      parentRoute: typeof StaffMarketplaceImport
    }
    '/_staff/networks/_layout/': {
      id: '/_staff/networks/_layout/'
      path: '/'
      fullPath: '/networks/'
      preLoaderRoute: typeof StaffNetworksLayoutIndexImport
      parentRoute: typeof StaffNetworksLayoutImport
    }
    '/_staff/networks/add/': {
      id: '/_staff/networks/add/'
      path: '/add'
      fullPath: '/networks/add'
      preLoaderRoute: typeof StaffNetworksAddIndexImport
      parentRoute: typeof StaffNetworksImport
    }
    '/_staff/organization/plan/': {
      id: '/_staff/organization/plan/'
      path: '/plan'
      fullPath: '/organization/plan'
      preLoaderRoute: typeof StaffOrganizationPlanIndexImport
      parentRoute: typeof StaffOrganizationImport
    }
    '/_staff/payroll-core/_layout/': {
      id: '/_staff/payroll-core/_layout/'
      path: '/'
      fullPath: '/payroll-core/'
      preLoaderRoute: typeof StaffPayrollCoreLayoutIndexImport
      parentRoute: typeof StaffPayrollCoreLayoutImport
    }
    '/_staff/payroll-engine/_layout/': {
      id: '/_staff/payroll-engine/_layout/'
      path: '/'
      fullPath: '/payroll-engine/'
      preLoaderRoute: typeof StaffPayrollEngineLayoutIndexImport
      parentRoute: typeof StaffPayrollEngineLayoutImport
    }
    '/_staff/payroll/_layout/': {
      id: '/_staff/payroll/_layout/'
      path: '/'
      fullPath: '/payroll/'
      preLoaderRoute: typeof StaffPayrollLayoutIndexImport
      parentRoute: typeof StaffPayrollLayoutImport
    }
    '/_staff/person/add-person-certification/': {
      id: '/_staff/person/add-person-certification/'
      path: '/person/add-person-certification'
      fullPath: '/person/add-person-certification'
      preLoaderRoute: typeof StaffPersonAddPersonCertificationIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/person/add/': {
      id: '/_staff/person/add/'
      path: '/person/add'
      fullPath: '/person/add'
      preLoaderRoute: typeof StaffPersonAddIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/person/external-hr-saas/': {
      id: '/_staff/person/external-hr-saas/'
      path: '/person/external-hr-saas'
      fullPath: '/person/external-hr-saas'
      preLoaderRoute: typeof StaffPersonExternalHrSaasIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/places/_layout/': {
      id: '/_staff/places/_layout/'
      path: '/'
      fullPath: '/places/'
      preLoaderRoute: typeof StaffPlacesLayoutIndexImport
      parentRoute: typeof StaffPlacesLayoutImport
    }
    '/_staff/places/add-select/': {
      id: '/_staff/places/add-select/'
      path: '/add-select'
      fullPath: '/places/add-select'
      preLoaderRoute: typeof StaffPlacesAddSelectIndexImport
      parentRoute: typeof StaffPlacesImport
    }
    '/_staff/places/add/': {
      id: '/_staff/places/add/'
      path: '/add'
      fullPath: '/places/add'
      preLoaderRoute: typeof StaffPlacesAddIndexImport
      parentRoute: typeof StaffPlacesImport
    }
    '/_staff/public-ids/$id/': {
      id: '/_staff/public-ids/$id/'
      path: '/'
      fullPath: '/public-ids/$id/'
      preLoaderRoute: typeof StaffPublicIdsIdIndexImport
      parentRoute: typeof StaffPublicIdsIdImport
    }
    '/_staff/public-ids/_list/': {
      id: '/_staff/public-ids/_list/'
      path: '/'
      fullPath: '/public-ids/'
      preLoaderRoute: typeof StaffPublicIdsListIndexImport
      parentRoute: typeof StaffPublicIdsListImport
    }
    '/_staff/public-ids/add/': {
      id: '/_staff/public-ids/add/'
      path: '/add'
      fullPath: '/public-ids/add'
      preLoaderRoute: typeof StaffPublicIdsAddIndexImport
      parentRoute: typeof StaffPublicIdsImport
    }
    '/_staff/settings/contracting-corporation-profile/': {
      id: '/_staff/settings/contracting-corporation-profile/'
      path: '/'
      fullPath: '/settings/contracting-corporation-profile/'
      preLoaderRoute: typeof StaffSettingsContractingCorporationProfileIndexImport
      parentRoute: typeof StaffSettingsContractingCorporationProfileImport
    }
    '/_staff/settings/permission-and-roles/': {
      id: '/_staff/settings/permission-and-roles/'
      path: '/'
      fullPath: '/settings/permission-and-roles/'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesImport
    }
    '/_staff/settings/persons/': {
      id: '/_staff/settings/persons/'
      path: '/'
      fullPath: '/settings/persons/'
      preLoaderRoute: typeof StaffSettingsPersonsIndexImport
      parentRoute: typeof StaffSettingsPersonsImport
    }
    '/_staff/software/add/': {
      id: '/_staff/software/add/'
      path: '/add'
      fullPath: '/software/add'
      preLoaderRoute: typeof StaffSoftwareAddIndexImport
      parentRoute: typeof StaffSoftwareImport
    }
    '/_staff/starlinks/_layout/': {
      id: '/_staff/starlinks/_layout/'
      path: '/'
      fullPath: '/starlinks/'
      preLoaderRoute: typeof StaffStarlinksLayoutIndexImport
      parentRoute: typeof StaffStarlinksLayoutImport
    }
    '/_staff/storage-files/_list/': {
      id: '/_staff/storage-files/_list/'
      path: '/'
      fullPath: '/storage-files/'
      preLoaderRoute: typeof StaffStorageFilesListIndexImport
      parentRoute: typeof StaffStorageFilesListImport
    }
    '/_staff/supplier/_list/': {
      id: '/_staff/supplier/_list/'
      path: '/'
      fullPath: '/supplier/'
      preLoaderRoute: typeof StaffSupplierListIndexImport
      parentRoute: typeof StaffSupplierListImport
    }
    '/_staff/time-and-attendance/_layout/': {
      id: '/_staff/time-and-attendance/_layout/'
      path: '/'
      fullPath: '/time-and-attendance/'
      preLoaderRoute: typeof StaffTimeAndAttendanceLayoutIndexImport
      parentRoute: typeof StaffTimeAndAttendanceLayoutImport
    }
    '/auth/invitation/$invitationCode/': {
      id: '/auth/invitation/$invitationCode/'
      path: '/auth/invitation/$invitationCode'
      fullPath: '/auth/invitation/$invitationCode'
      preLoaderRoute: typeof AuthInvitationInvitationCodeIndexImport
      parentRoute: typeof rootRoute
    }
    '/auth/sign-in/error/': {
      id: '/auth/sign-in/error/'
      path: '/auth/sign-in/error'
      fullPath: '/auth/sign-in/error'
      preLoaderRoute: typeof AuthSignInErrorIndexImport
      parentRoute: typeof rootRoute
    }
    '/_staff/person/$id/_profile/': {
      id: '/_staff/person/$id/_profile/'
      path: '/'
      fullPath: '/person/$id/'
      preLoaderRoute: typeof StaffPersonIdProfileIndexRouteImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_individual/individual/portal/lookup/clocking-record': {
      id: '/_individual/individual/portal/lookup/clocking-record'
      path: '/lookup/clocking-record'
      fullPath: '/individual/portal/lookup/clocking-record'
      preLoaderRoute: typeof IndividualIndividualPortalLookupClockingRecordRouteImport
      parentRoute: typeof IndividualIndividualPortalImport
    }
    '/_individual/individual/portal/lookup/pay-slip': {
      id: '/_individual/individual/portal/lookup/pay-slip'
      path: '/lookup/pay-slip'
      fullPath: '/individual/portal/lookup/pay-slip'
      preLoaderRoute: typeof IndividualIndividualPortalLookupPaySlipRouteImport
      parentRoute: typeof IndividualIndividualPortalImport
    }
    '/_staff/attendances/_layout/clocking-records/$employeeId': {
      id: '/_staff/attendances/_layout/clocking-records/$employeeId'
      path: '/clocking-records/$employeeId'
      fullPath: '/attendances/clocking-records/$employeeId'
      preLoaderRoute: typeof StaffAttendancesLayoutClockingRecordsEmployeeIdRouteImport
      parentRoute: typeof StaffAttendancesLayoutImport
    }
    '/_staff/business-partner/_list/_placeholders/alerts': {
      id: '/_staff/business-partner/_list/_placeholders/alerts'
      path: '/alerts'
      fullPath: '/business-partner/alerts'
      preLoaderRoute: typeof StaffBusinessPartnerListPlaceholdersAlertsRouteImport
      parentRoute: typeof StaffBusinessPartnerListImport
    }
    '/_staff/business-partner/_list/_placeholders/contract-and-cost': {
      id: '/_staff/business-partner/_list/_placeholders/contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/business-partner/contract-and-cost'
      preLoaderRoute: typeof StaffBusinessPartnerListPlaceholdersContractAndCostRouteImport
      parentRoute: typeof StaffBusinessPartnerListImport
    }
    '/_staff/business-partner/_list/_placeholders/operation-activity': {
      id: '/_staff/business-partner/_list/_placeholders/operation-activity'
      path: '/operation-activity'
      fullPath: '/business-partner/operation-activity'
      preLoaderRoute: typeof StaffBusinessPartnerListPlaceholdersOperationActivityRouteImport
      parentRoute: typeof StaffBusinessPartnerListImport
    }
    '/_staff/business-partner/_list/_placeholders/rule-and-policy': {
      id: '/_staff/business-partner/_list/_placeholders/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/business-partner/rule-and-policy'
      preLoaderRoute: typeof StaffBusinessPartnerListPlaceholdersRuleAndPolicyRouteImport
      parentRoute: typeof StaffBusinessPartnerListImport
    }
    '/_staff/business-partner/_list/_placeholders/settings': {
      id: '/_staff/business-partner/_list/_placeholders/settings'
      path: '/settings'
      fullPath: '/business-partner/settings'
      preLoaderRoute: typeof StaffBusinessPartnerListPlaceholdersSettingsRouteImport
      parentRoute: typeof StaffBusinessPartnerListImport
    }
    '/_staff/certification/_list/_placeholders/alerts': {
      id: '/_staff/certification/_list/_placeholders/alerts'
      path: '/alerts'
      fullPath: '/certification/alerts'
      preLoaderRoute: typeof StaffCertificationListPlaceholdersAlertsRouteImport
      parentRoute: typeof StaffCertificationListImport
    }
    '/_staff/certification/_list/_placeholders/operation-activity': {
      id: '/_staff/certification/_list/_placeholders/operation-activity'
      path: '/operation-activity'
      fullPath: '/certification/operation-activity'
      preLoaderRoute: typeof StaffCertificationListPlaceholdersOperationActivityRouteImport
      parentRoute: typeof StaffCertificationListImport
    }
    '/_staff/certification/_list/_placeholders/overview': {
      id: '/_staff/certification/_list/_placeholders/overview'
      path: '/overview'
      fullPath: '/certification/overview'
      preLoaderRoute: typeof StaffCertificationListPlaceholdersOverviewRouteImport
      parentRoute: typeof StaffCertificationListImport
    }
    '/_staff/certification/_list/_placeholders/rule-and-policy': {
      id: '/_staff/certification/_list/_placeholders/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/certification/rule-and-policy'
      preLoaderRoute: typeof StaffCertificationListPlaceholdersRuleAndPolicyRouteImport
      parentRoute: typeof StaffCertificationListImport
    }
    '/_staff/contract/_list/_placeholders/alerts': {
      id: '/_staff/contract/_list/_placeholders/alerts'
      path: '/alerts'
      fullPath: '/contract/alerts'
      preLoaderRoute: typeof StaffContractListPlaceholdersAlertsRouteImport
      parentRoute: typeof StaffContractListImport
    }
    '/_staff/contract/_list/_placeholders/contract-and-cost': {
      id: '/_staff/contract/_list/_placeholders/contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/contract/contract-and-cost'
      preLoaderRoute: typeof StaffContractListPlaceholdersContractAndCostRouteImport
      parentRoute: typeof StaffContractListImport
    }
    '/_staff/contract/_list/_placeholders/operation-activity': {
      id: '/_staff/contract/_list/_placeholders/operation-activity'
      path: '/operation-activity'
      fullPath: '/contract/operation-activity'
      preLoaderRoute: typeof StaffContractListPlaceholdersOperationActivityRouteImport
      parentRoute: typeof StaffContractListImport
    }
    '/_staff/contract/_list/_placeholders/overview': {
      id: '/_staff/contract/_list/_placeholders/overview'
      path: '/overview'
      fullPath: '/contract/overview'
      preLoaderRoute: typeof StaffContractListPlaceholdersOverviewRouteImport
      parentRoute: typeof StaffContractListImport
    }
    '/_staff/contract/_list/_placeholders/people': {
      id: '/_staff/contract/_list/_placeholders/people'
      path: '/people'
      fullPath: '/contract/people'
      preLoaderRoute: typeof StaffContractListPlaceholdersPeopleRouteImport
      parentRoute: typeof StaffContractListImport
    }
    '/_staff/deal/$dealId/_layout/flow': {
      id: '/_staff/deal/$dealId/_layout/flow'
      path: '/flow'
      fullPath: '/deal/$dealId/flow'
      preLoaderRoute: typeof StaffDealDealIdLayoutFlowRouteImport
      parentRoute: typeof StaffDealDealIdLayoutImport
    }
    '/_staff/deal/$dealId/_layout/structure': {
      id: '/_staff/deal/$dealId/_layout/structure'
      path: '/structure'
      fullPath: '/deal/$dealId/structure'
      preLoaderRoute: typeof StaffDealDealIdLayoutStructureRouteImport
      parentRoute: typeof StaffDealDealIdLayoutImport
    }
    '/_staff/payroll/_layout/pay-slips/$employeeId': {
      id: '/_staff/payroll/_layout/pay-slips/$employeeId'
      path: '/pay-slips/$employeeId'
      fullPath: '/payroll/pay-slips/$employeeId'
      preLoaderRoute: typeof StaffPayrollLayoutPaySlipsEmployeeIdRouteImport
      parentRoute: typeof StaffPayrollLayoutImport
    }
    '/_staff/software/_layout/marketplace/$id': {
      id: '/_staff/software/_layout/marketplace/$id'
      path: '/marketplace/$id'
      fullPath: '/software/marketplace/$id'
      preLoaderRoute: typeof StaffSoftwareLayoutMarketplaceIdRouteImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/supplier/$supplierId/_layout/files': {
      id: '/_staff/supplier/$supplierId/_layout/files'
      path: '/files'
      fullPath: '/supplier/$supplierId/files'
      preLoaderRoute: typeof StaffSupplierSupplierIdLayoutFilesRouteImport
      parentRoute: typeof StaffSupplierSupplierIdLayoutImport
    }
    '/_staff/supplier/$supplierId/_layout/rules-and-policy': {
      id: '/_staff/supplier/$supplierId/_layout/rules-and-policy'
      path: '/rules-and-policy'
      fullPath: '/supplier/$supplierId/rules-and-policy'
      preLoaderRoute: typeof StaffSupplierSupplierIdLayoutRulesAndPolicyRouteImport
      parentRoute: typeof StaffSupplierSupplierIdLayoutImport
    }
    '/_staff/supplier/$supplierId/_layout/settings': {
      id: '/_staff/supplier/$supplierId/_layout/settings'
      path: '/settings'
      fullPath: '/supplier/$supplierId/settings'
      preLoaderRoute: typeof StaffSupplierSupplierIdLayoutSettingsRouteImport
      parentRoute: typeof StaffSupplierSupplierIdLayoutImport
    }
    '/_staff/supplier/_list/_placeholders/alerts': {
      id: '/_staff/supplier/_list/_placeholders/alerts'
      path: '/alerts'
      fullPath: '/supplier/alerts'
      preLoaderRoute: typeof StaffSupplierListPlaceholdersAlertsRouteImport
      parentRoute: typeof StaffSupplierListImport
    }
    '/_staff/supplier/_list/_placeholders/contract-and-cost': {
      id: '/_staff/supplier/_list/_placeholders/contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/supplier/contract-and-cost'
      preLoaderRoute: typeof StaffSupplierListPlaceholdersContractAndCostRouteImport
      parentRoute: typeof StaffSupplierListImport
    }
    '/_staff/supplier/_list/_placeholders/operation-activity': {
      id: '/_staff/supplier/_list/_placeholders/operation-activity'
      path: '/operation-activity'
      fullPath: '/supplier/operation-activity'
      preLoaderRoute: typeof StaffSupplierListPlaceholdersOperationActivityRouteImport
      parentRoute: typeof StaffSupplierListImport
    }
    '/_staff/supplier/_list/_placeholders/overview': {
      id: '/_staff/supplier/_list/_placeholders/overview'
      path: '/overview'
      fullPath: '/supplier/overview'
      preLoaderRoute: typeof StaffSupplierListPlaceholdersOverviewRouteImport
      parentRoute: typeof StaffSupplierListImport
    }
    '/_staff/supplier/_list/_placeholders/rule-and-policy': {
      id: '/_staff/supplier/_list/_placeholders/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/supplier/rule-and-policy'
      preLoaderRoute: typeof StaffSupplierListPlaceholdersRuleAndPolicyRouteImport
      parentRoute: typeof StaffSupplierListImport
    }
    '/_individual/individual/_profile/my-profile': {
      id: '/_individual/individual/_profile/my-profile'
      path: '/my-profile'
      fullPath: '/individual/my-profile'
      preLoaderRoute: typeof IndividualIndividualProfileMyProfileImport
      parentRoute: typeof IndividualIndividualProfileImport
    }
    '/_individual/individual/_profile/my-profile/_layout': {
      id: '/_individual/individual/_profile/my-profile/_layout'
      path: '/my-profile'
      fullPath: '/individual/my-profile'
      preLoaderRoute: typeof IndividualIndividualProfileMyProfileLayoutImport
      parentRoute: typeof IndividualIndividualProfileMyProfileRoute
    }
    '/_individual/individual/task/$id/approval-dialog': {
      id: '/_individual/individual/task/$id/approval-dialog'
      path: '/task/$id/approval-dialog'
      fullPath: '/individual/task/$id/approval-dialog'
      preLoaderRoute: typeof IndividualIndividualTaskIdApprovalDialogImport
      parentRoute: typeof IndividualIndividualImport
    }
    '/_staff/accesses/_layout/_placeholders/contract-and-cost': {
      id: '/_staff/accesses/_layout/_placeholders/contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/accesses/contract-and-cost'
      preLoaderRoute: typeof StaffAccessesLayoutPlaceholdersContractAndCostImport
      parentRoute: typeof StaffAccessesLayoutImport
    }
    '/_staff/accesses/_layout/_placeholders/overview': {
      id: '/_staff/accesses/_layout/_placeholders/overview'
      path: '/overview'
      fullPath: '/accesses/overview'
      preLoaderRoute: typeof StaffAccessesLayoutPlaceholdersOverviewImport
      parentRoute: typeof StaffAccessesLayoutImport
    }
    '/_staff/accesses/_layout/_placeholders/software': {
      id: '/_staff/accesses/_layout/_placeholders/software'
      path: '/software'
      fullPath: '/accesses/software'
      preLoaderRoute: typeof StaffAccessesLayoutPlaceholdersSoftwareImport
      parentRoute: typeof StaffAccessesLayoutImport
    }
    '/_staff/app-integrations/$id/_$id/$': {
      id: '/_staff/app-integrations/$id/_$id/$'
      path: '/$'
      fullPath: '/app-integrations/$id/$'
      preLoaderRoute: typeof StaffAppIntegrationsIdIdSplatImport
      parentRoute: typeof StaffAppIntegrationsIdIdImport
    }
    '/_staff/business-partner/add/$businessPartnerType/completed': {
      id: '/_staff/business-partner/add/$businessPartnerType/completed'
      path: '/add/$businessPartnerType/completed'
      fullPath: '/business-partner/add/$businessPartnerType/completed'
      preLoaderRoute: typeof StaffBusinessPartnerAddBusinessPartnerTypeCompletedImport
      parentRoute: typeof StaffBusinessPartnerImport
    }
    '/_staff/certification/add/$certificationKind/completed': {
      id: '/_staff/certification/add/$certificationKind/completed'
      path: '/add/$certificationKind/completed'
      fullPath: '/certification/add/$certificationKind/completed'
      preLoaderRoute: typeof StaffCertificationAddCertificationKindCompletedImport
      parentRoute: typeof StaffCertificationImport
    }
    '/_staff/certification/handling-certification/$id': {
      id: '/_staff/certification/handling-certification/$id'
      path: '/handling-certification/$id'
      fullPath: '/certification/handling-certification/$id'
      preLoaderRoute: typeof StaffCertificationHandlingCertificationIdImport
      parentRoute: typeof StaffCertificationImport
    }
    '/_staff/certification/handling-certification/$id/_layout': {
      id: '/_staff/certification/handling-certification/$id/_layout'
      path: '/handling-certification/$id'
      fullPath: '/certification/handling-certification/$id'
      preLoaderRoute: typeof StaffCertificationHandlingCertificationIdLayoutImport
      parentRoute: typeof StaffCertificationHandlingCertificationIdRoute
    }
    '/_staff/certification/specialty-certification/$id': {
      id: '/_staff/certification/specialty-certification/$id'
      path: '/specialty-certification/$id'
      fullPath: '/certification/specialty-certification/$id'
      preLoaderRoute: typeof StaffCertificationSpecialtyCertificationIdImport
      parentRoute: typeof StaffCertificationImport
    }
    '/_staff/certification/specialty-certification/$id/_layout': {
      id: '/_staff/certification/specialty-certification/$id/_layout'
      path: '/specialty-certification/$id'
      fullPath: '/certification/specialty-certification/$id'
      preLoaderRoute: typeof StaffCertificationSpecialtyCertificationIdLayoutImport
      parentRoute: typeof StaffCertificationSpecialtyCertificationIdRoute
    }
    '/_staff/contract/add/subscription/completed': {
      id: '/_staff/contract/add/subscription/completed'
      path: '/add/subscription/completed'
      fullPath: '/contract/add/subscription/completed'
      preLoaderRoute: typeof StaffContractAddSubscriptionCompletedImport
      parentRoute: typeof StaffContractImport
    }
    '/_staff/deal/add/$direction/completed': {
      id: '/_staff/deal/add/$direction/completed'
      path: '/add/$direction/completed'
      fullPath: '/deal/add/$direction/completed'
      preLoaderRoute: typeof StaffDealAddDirectionCompletedImport
      parentRoute: typeof StaffDealImport
    }
    '/_staff/device-catalog/active/$id': {
      id: '/_staff/device-catalog/active/$id'
      path: '/device-catalog/active/$id'
      fullPath: '/device-catalog/active/$id'
      preLoaderRoute: typeof StaffDeviceCatalogActiveIdImport
      parentRoute: typeof StaffImport
    }
    '/_staff/device-catalog/active/$id/_layout': {
      id: '/_staff/device-catalog/active/$id/_layout'
      path: '/device-catalog/active/$id'
      fullPath: '/device-catalog/active/$id'
      preLoaderRoute: typeof StaffDeviceCatalogActiveIdLayoutImport
      parentRoute: typeof StaffDeviceCatalogActiveIdRoute
    }
    '/_staff/device-catalog/add/$deviceType/completed': {
      id: '/_staff/device-catalog/add/$deviceType/completed'
      path: '/device-catalog/add/$deviceType/completed'
      fullPath: '/device-catalog/add/$deviceType/completed'
      preLoaderRoute: typeof StaffDeviceCatalogAddDeviceTypeCompletedImport
      parentRoute: typeof StaffImport
    }
    '/_staff/device-catalog/draft/$id': {
      id: '/_staff/device-catalog/draft/$id'
      path: '/device-catalog/draft/$id'
      fullPath: '/device-catalog/draft/$id'
      preLoaderRoute: typeof StaffDeviceCatalogDraftIdImport
      parentRoute: typeof StaffImport
    }
    '/_staff/device-catalog/draft/$id/_layout': {
      id: '/_staff/device-catalog/draft/$id/_layout'
      path: '/device-catalog/draft/$id'
      fullPath: '/device-catalog/draft/$id'
      preLoaderRoute: typeof StaffDeviceCatalogDraftIdLayoutImport
      parentRoute: typeof StaffDeviceCatalogDraftIdRoute
    }
    '/_staff/devices/_list/contract-and-cost': {
      id: '/_staff/devices/_list/contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/devices/contract-and-cost'
      preLoaderRoute: typeof StaffDevicesListContractAndCostImport
      parentRoute: typeof StaffDevicesListImport
    }
    '/_staff/devices/_list/contract-and-cost/_contract-and-cost': {
      id: '/_staff/devices/_list/contract-and-cost/_contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/devices/contract-and-cost'
      preLoaderRoute: typeof StaffDevicesListContractAndCostContractAndCostImport
      parentRoute: typeof StaffDevicesListContractAndCostRoute
    }
    '/_staff/devices/add/$deviceType/completed': {
      id: '/_staff/devices/add/$deviceType/completed'
      path: '/add/$deviceType/completed'
      fullPath: '/devices/add/$deviceType/completed'
      preLoaderRoute: typeof StaffDevicesAddDeviceTypeCompletedImport
      parentRoute: typeof StaffDevicesImport
    }
    '/_staff/equipment/_layout/_placeholders/overview': {
      id: '/_staff/equipment/_layout/_placeholders/overview'
      path: '/overview'
      fullPath: '/equipment/overview'
      preLoaderRoute: typeof StaffEquipmentLayoutPlaceholdersOverviewImport
      parentRoute: typeof StaffEquipmentLayoutImport
    }
    '/_staff/equipment/_layout/_placeholders/rule-and-policy': {
      id: '/_staff/equipment/_layout/_placeholders/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/equipment/rule-and-policy'
      preLoaderRoute: typeof StaffEquipmentLayoutPlaceholdersRuleAndPolicyImport
      parentRoute: typeof StaffEquipmentLayoutImport
    }
    '/_staff/equipment/_layout/_placeholders/settings': {
      id: '/_staff/equipment/_layout/_placeholders/settings'
      path: '/settings'
      fullPath: '/equipment/settings'
      preLoaderRoute: typeof StaffEquipmentLayoutPlaceholdersSettingsImport
      parentRoute: typeof StaffEquipmentLayoutImport
    }
    '/_staff/equipment/items/$id': {
      id: '/_staff/equipment/items/$id'
      path: '/items/$id'
      fullPath: '/equipment/items/$id'
      preLoaderRoute: typeof StaffEquipmentItemsIdImport
      parentRoute: typeof StaffEquipmentImport
    }
    '/_staff/equipment/items/$id/_detail': {
      id: '/_staff/equipment/items/$id/_detail'
      path: '/items/$id'
      fullPath: '/equipment/items/$id'
      preLoaderRoute: typeof StaffEquipmentItemsIdDetailImport
      parentRoute: typeof StaffEquipmentItemsIdRoute
    }
    '/_staff/ids/_layout/_placeholders/alerts': {
      id: '/_staff/ids/_layout/_placeholders/alerts'
      path: '/alerts'
      fullPath: '/ids/alerts'
      preLoaderRoute: typeof StaffIdsLayoutPlaceholdersAlertsImport
      parentRoute: typeof StaffIdsLayoutImport
    }
    '/_staff/ids/_layout/_placeholders/group-id': {
      id: '/_staff/ids/_layout/_placeholders/group-id'
      path: '/group-id'
      fullPath: '/ids/group-id'
      preLoaderRoute: typeof StaffIdsLayoutPlaceholdersGroupIdImport
      parentRoute: typeof StaffIdsLayoutImport
    }
    '/_staff/ids/_layout/_placeholders/operation-activity': {
      id: '/_staff/ids/_layout/_placeholders/operation-activity'
      path: '/operation-activity'
      fullPath: '/ids/operation-activity'
      preLoaderRoute: typeof StaffIdsLayoutPlaceholdersOperationActivityImport
      parentRoute: typeof StaffIdsLayoutImport
    }
    '/_staff/ids/_layout/_placeholders/overview': {
      id: '/_staff/ids/_layout/_placeholders/overview'
      path: '/overview'
      fullPath: '/ids/overview'
      preLoaderRoute: typeof StaffIdsLayoutPlaceholdersOverviewImport
      parentRoute: typeof StaffIdsLayoutImport
    }
    '/_staff/ids/_layout/_placeholders/rule-and-policy': {
      id: '/_staff/ids/_layout/_placeholders/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/ids/rule-and-policy'
      preLoaderRoute: typeof StaffIdsLayoutPlaceholdersRuleAndPolicyImport
      parentRoute: typeof StaffIdsLayoutImport
    }
    '/_staff/ids/_layout/_placeholders/settings': {
      id: '/_staff/ids/_layout/_placeholders/settings'
      path: '/settings'
      fullPath: '/ids/settings'
      preLoaderRoute: typeof StaffIdsLayoutPlaceholdersSettingsImport
      parentRoute: typeof StaffIdsLayoutImport
    }
    '/_staff/ids/group-id/$id': {
      id: '/_staff/ids/group-id/$id'
      path: '/group-id/$id'
      fullPath: '/ids/group-id/$id'
      preLoaderRoute: typeof StaffIdsGroupIdIdImport
      parentRoute: typeof StaffIdsImport
    }
    '/_staff/ids/group-id/$id/_$id': {
      id: '/_staff/ids/group-id/$id/_$id'
      path: '/group-id/$id'
      fullPath: '/ids/group-id/$id'
      preLoaderRoute: typeof StaffIdsGroupIdIdIdImport
      parentRoute: typeof StaffIdsGroupIdIdRoute
    }
    '/_staff/it-operation-core/_root/in-house-packages/$packageId': {
      id: '/_staff/it-operation-core/_root/in-house-packages/$packageId'
      path: '/$packageId'
      fullPath: '/it-operation-core/in-house-packages/$packageId'
      preLoaderRoute: typeof StaffItOperationCoreRootInHousePackagesPackageIdImport
      parentRoute: typeof StaffItOperationCoreRootInHousePackagesRouteImport
    }
    '/_staff/it-operation-core/_root/packages/$packageId': {
      id: '/_staff/it-operation-core/_root/packages/$packageId'
      path: '/$packageId'
      fullPath: '/it-operation-core/packages/$packageId'
      preLoaderRoute: typeof StaffItOperationCoreRootPackagesPackageIdImport
      parentRoute: typeof StaffItOperationCoreRootPackagesRouteImport
    }
    '/_staff/labor-core/settings/profile/$profileId': {
      id: '/_staff/labor-core/settings/profile/$profileId'
      path: '/settings/profile/$profileId'
      fullPath: '/labor-core/settings/profile/$profileId'
      preLoaderRoute: typeof StaffLaborCoreSettingsProfileProfileIdImport
      parentRoute: typeof StaffLaborCoreImport
    }
    '/_staff/licenses/add/$allocationType/completed': {
      id: '/_staff/licenses/add/$allocationType/completed'
      path: '/add/$allocationType/completed'
      fullPath: '/licenses/add/$allocationType/completed'
      preLoaderRoute: typeof StaffLicensesAddAllocationTypeCompletedImport
      parentRoute: typeof StaffLicensesImport
    }
    '/_staff/marketplace/sent-orders/$orderId': {
      id: '/_staff/marketplace/sent-orders/$orderId'
      path: '/sent-orders/$orderId'
      fullPath: '/marketplace/sent-orders/$orderId'
      preLoaderRoute: typeof StaffMarketplaceSentOrdersOrderIdImport
      parentRoute: typeof StaffMarketplaceImport
    }
    '/_staff/marketplace/sent-orders/$orderId/_layout': {
      id: '/_staff/marketplace/sent-orders/$orderId/_layout'
      path: '/sent-orders/$orderId'
      fullPath: '/marketplace/sent-orders/$orderId'
      preLoaderRoute: typeof StaffMarketplaceSentOrdersOrderIdLayoutImport
      parentRoute: typeof StaffMarketplaceSentOrdersOrderIdRoute
    }
    '/_staff/networks/_layout/_placeholders/alerts': {
      id: '/_staff/networks/_layout/_placeholders/alerts'
      path: '/alerts'
      fullPath: '/networks/alerts'
      preLoaderRoute: typeof StaffNetworksLayoutPlaceholdersAlertsImport
      parentRoute: typeof StaffNetworksLayoutImport
    }
    '/_staff/networks/_layout/_placeholders/contract-and-cost': {
      id: '/_staff/networks/_layout/_placeholders/contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/networks/contract-and-cost'
      preLoaderRoute: typeof StaffNetworksLayoutPlaceholdersContractAndCostImport
      parentRoute: typeof StaffNetworksLayoutImport
    }
    '/_staff/networks/_layout/_placeholders/operation-activity': {
      id: '/_staff/networks/_layout/_placeholders/operation-activity'
      path: '/operation-activity'
      fullPath: '/networks/operation-activity'
      preLoaderRoute: typeof StaffNetworksLayoutPlaceholdersOperationActivityImport
      parentRoute: typeof StaffNetworksLayoutImport
    }
    '/_staff/networks/_layout/_placeholders/overview': {
      id: '/_staff/networks/_layout/_placeholders/overview'
      path: '/overview'
      fullPath: '/networks/overview'
      preLoaderRoute: typeof StaffNetworksLayoutPlaceholdersOverviewImport
      parentRoute: typeof StaffNetworksLayoutImport
    }
    '/_staff/networks/_layout/_placeholders/rule-and-policy': {
      id: '/_staff/networks/_layout/_placeholders/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/networks/rule-and-policy'
      preLoaderRoute: typeof StaffNetworksLayoutPlaceholdersRuleAndPolicyImport
      parentRoute: typeof StaffNetworksLayoutImport
    }
    '/_staff/networks/_layout/_placeholders/settings': {
      id: '/_staff/networks/_layout/_placeholders/settings'
      path: '/settings'
      fullPath: '/networks/settings'
      preLoaderRoute: typeof StaffNetworksLayoutPlaceholdersSettingsImport
      parentRoute: typeof StaffNetworksLayoutImport
    }
    '/_staff/payroll/_layout/contract-and-cost': {
      id: '/_staff/payroll/_layout/contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/payroll/contract-and-cost'
      preLoaderRoute: typeof StaffPayrollLayoutContractAndCostImport
      parentRoute: typeof StaffPayrollLayoutImport
    }
    '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost': {
      id: '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/payroll/contract-and-cost'
      preLoaderRoute: typeof StaffPayrollLayoutContractAndCostContractAndCostImport
      parentRoute: typeof StaffPayrollLayoutContractAndCostRoute
    }
    '/_staff/person/add-person-certification/$certificationKind/completed': {
      id: '/_staff/person/add-person-certification/$certificationKind/completed'
      path: '/person/add-person-certification/$certificationKind/completed'
      fullPath: '/person/add-person-certification/$certificationKind/completed'
      preLoaderRoute: typeof StaffPersonAddPersonCertificationCertificationKindCompletedImport
      parentRoute: typeof StaffImport
    }
    '/_staff/person/add/$workerType/completed': {
      id: '/_staff/person/add/$workerType/completed'
      path: '/person/add/$workerType/completed'
      fullPath: '/person/add/$workerType/completed'
      preLoaderRoute: typeof StaffPersonAddWorkerTypeCompletedImport
      parentRoute: typeof StaffImport
    }
    '/_staff/person/alumni/$id': {
      id: '/_staff/person/alumni/$id'
      path: '/person/alumni/$id'
      fullPath: '/person/alumni/$id'
      preLoaderRoute: typeof StaffPersonAlumniIdImport
      parentRoute: typeof StaffImport
    }
    '/_staff/person/alumni/$id/_profile': {
      id: '/_staff/person/alumni/$id/_profile'
      path: '/person/alumni/$id'
      fullPath: '/person/alumni/$id'
      preLoaderRoute: typeof StaffPersonAlumniIdProfileImport
      parentRoute: typeof StaffPersonAlumniIdRoute
    }
    '/_staff/places/_layout/_placeholders/alerts': {
      id: '/_staff/places/_layout/_placeholders/alerts'
      path: '/alerts'
      fullPath: '/places/alerts'
      preLoaderRoute: typeof StaffPlacesLayoutPlaceholdersAlertsImport
      parentRoute: typeof StaffPlacesLayoutImport
    }
    '/_staff/places/_layout/_placeholders/contract-and-cost': {
      id: '/_staff/places/_layout/_placeholders/contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/places/contract-and-cost'
      preLoaderRoute: typeof StaffPlacesLayoutPlaceholdersContractAndCostImport
      parentRoute: typeof StaffPlacesLayoutImport
    }
    '/_staff/places/_layout/_placeholders/operation-activity': {
      id: '/_staff/places/_layout/_placeholders/operation-activity'
      path: '/operation-activity'
      fullPath: '/places/operation-activity'
      preLoaderRoute: typeof StaffPlacesLayoutPlaceholdersOperationActivityImport
      parentRoute: typeof StaffPlacesLayoutImport
    }
    '/_staff/places/_layout/_placeholders/people': {
      id: '/_staff/places/_layout/_placeholders/people'
      path: '/people'
      fullPath: '/places/people'
      preLoaderRoute: typeof StaffPlacesLayoutPlaceholdersPeopleImport
      parentRoute: typeof StaffPlacesLayoutImport
    }
    '/_staff/places/_layout/_placeholders/rule-and-policy': {
      id: '/_staff/places/_layout/_placeholders/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/places/rule-and-policy'
      preLoaderRoute: typeof StaffPlacesLayoutPlaceholdersRuleAndPolicyImport
      parentRoute: typeof StaffPlacesLayoutImport
    }
    '/_staff/places/_layout/_placeholders/store': {
      id: '/_staff/places/_layout/_placeholders/store'
      path: '/store'
      fullPath: '/places/store'
      preLoaderRoute: typeof StaffPlacesLayoutPlaceholdersStoreImport
      parentRoute: typeof StaffPlacesLayoutImport
    }
    '/_staff/profile/device/$id/$': {
      id: '/_staff/profile/device/$id/$'
      path: '/profile/device/$id/$'
      fullPath: '/profile/device/$id/$'
      preLoaderRoute: typeof StaffProfileDeviceIdSplatImport
      parentRoute: typeof StaffImport
    }
    '/_staff/settings/persons/_list/_account': {
      id: '/_staff/settings/persons/_list/_account'
      path: ''
      fullPath: '/settings/persons'
      preLoaderRoute: typeof StaffSettingsPersonsListAccountImport
      parentRoute: typeof StaffSettingsPersonsListImport
    }
    '/_staff/software/$id/_$id/groups': {
      id: '/_staff/software/$id/_$id/groups'
      path: '/groups'
      fullPath: '/software/$id/groups'
      preLoaderRoute: typeof StaffSoftwareIdIdGroupsImport
      parentRoute: typeof StaffSoftwareIdIdImport
    }
    '/_staff/software/$id/_$id/profiles': {
      id: '/_staff/software/$id/_$id/profiles'
      path: '/profiles'
      fullPath: '/software/$id/profiles'
      preLoaderRoute: typeof StaffSoftwareIdIdProfilesImport
      parentRoute: typeof StaffSoftwareIdIdImport
    }
    '/_staff/software/_layout/alerts': {
      id: '/_staff/software/_layout/alerts'
      path: '/alerts'
      fullPath: '/software/alerts'
      preLoaderRoute: typeof StaffSoftwareLayoutAlertsImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/software/_layout/alerts/_alerts': {
      id: '/_staff/software/_layout/alerts/_alerts'
      path: '/alerts'
      fullPath: '/software/alerts'
      preLoaderRoute: typeof StaffSoftwareLayoutAlertsAlertsImport
      parentRoute: typeof StaffSoftwareLayoutAlertsRoute
    }
    '/_staff/software/_layout/contract-and-cost': {
      id: '/_staff/software/_layout/contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/software/contract-and-cost'
      preLoaderRoute: typeof StaffSoftwareLayoutContractAndCostImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/software/_layout/contract-and-cost/_contract-and-cost': {
      id: '/_staff/software/_layout/contract-and-cost/_contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/software/contract-and-cost'
      preLoaderRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostImport
      parentRoute: typeof StaffSoftwareLayoutContractAndCostRoute
    }
    '/_staff/starlinks/_layout/_placeholders/billing-and-cost': {
      id: '/_staff/starlinks/_layout/_placeholders/billing-and-cost'
      path: '/billing-and-cost'
      fullPath: '/starlinks/billing-and-cost'
      preLoaderRoute: typeof StaffStarlinksLayoutPlaceholdersBillingAndCostImport
      parentRoute: typeof StaffStarlinksLayoutImport
    }
    '/_staff/starlinks/_layout/_placeholders/marketplace': {
      id: '/_staff/starlinks/_layout/_placeholders/marketplace'
      path: '/marketplace'
      fullPath: '/starlinks/marketplace'
      preLoaderRoute: typeof StaffStarlinksLayoutPlaceholdersMarketplaceImport
      parentRoute: typeof StaffStarlinksLayoutImport
    }
    '/_staff/starlinks/_layout/_placeholders/operation-activity': {
      id: '/_staff/starlinks/_layout/_placeholders/operation-activity'
      path: '/operation-activity'
      fullPath: '/starlinks/operation-activity'
      preLoaderRoute: typeof StaffStarlinksLayoutPlaceholdersOperationActivityImport
      parentRoute: typeof StaffStarlinksLayoutImport
    }
    '/_staff/storage-files/files/$id': {
      id: '/_staff/storage-files/files/$id'
      path: '/files/$id'
      fullPath: '/storage-files/files/$id'
      preLoaderRoute: typeof StaffStorageFilesFilesIdImport
      parentRoute: typeof StaffStorageFilesImport
    }
    '/_staff/storage-files/files/$id/_$id': {
      id: '/_staff/storage-files/files/$id/_$id'
      path: '/files/$id'
      fullPath: '/storage-files/files/$id'
      preLoaderRoute: typeof StaffStorageFilesFilesIdIdImport
      parentRoute: typeof StaffStorageFilesFilesIdRoute
    }
    '/_staff/storage-files/folders/$id': {
      id: '/_staff/storage-files/folders/$id'
      path: '/folders/$id'
      fullPath: '/storage-files/folders/$id'
      preLoaderRoute: typeof StaffStorageFilesFoldersIdImport
      parentRoute: typeof StaffStorageFilesImport
    }
    '/_staff/storage-files/folders/$id/_$id': {
      id: '/_staff/storage-files/folders/$id/_$id'
      path: '/folders/$id'
      fullPath: '/storage-files/folders/$id'
      preLoaderRoute: typeof StaffStorageFilesFoldersIdIdImport
      parentRoute: typeof StaffStorageFilesFoldersIdRoute
    }
    '/_staff/software/$id/_$id/settings': {
      id: '/_staff/software/$id/_$id/settings'
      path: '/settings'
      fullPath: '/software/$id/settings'
      preLoaderRoute: typeof StaffSoftwareIdIdSettingsRouteLazyImport
      parentRoute: typeof StaffSoftwareIdIdImport
    }
    '/_individual/individual/_tasks/approval-tasks/': {
      id: '/_individual/individual/_tasks/approval-tasks/'
      path: '/approval-tasks'
      fullPath: '/individual/approval-tasks'
      preLoaderRoute: typeof IndividualIndividualTasksApprovalTasksIndexImport
      parentRoute: typeof IndividualIndividualImport
    }
    '/_individual/individual/_tasks/operation-tasks/': {
      id: '/_individual/individual/_tasks/operation-tasks/'
      path: '/operation-tasks'
      fullPath: '/individual/operation-tasks'
      preLoaderRoute: typeof IndividualIndividualTasksOperationTasksIndexImport
      parentRoute: typeof IndividualIndividualImport
    }
    '/_individual/individual/_tasks/request-tasks/': {
      id: '/_individual/individual/_tasks/request-tasks/'
      path: '/request-tasks'
      fullPath: '/individual/request-tasks'
      preLoaderRoute: typeof IndividualIndividualTasksRequestTasksIndexImport
      parentRoute: typeof IndividualIndividualImport
    }
    '/_individual/individual/operation-package/$id/': {
      id: '/_individual/individual/operation-package/$id/'
      path: '/operation-package/$id'
      fullPath: '/individual/operation-package/$id'
      preLoaderRoute: typeof IndividualIndividualOperationPackageIdIndexImport
      parentRoute: typeof IndividualIndividualImport
    }
    '/_individual/individual/portal/approvals/': {
      id: '/_individual/individual/portal/approvals/'
      path: '/approvals'
      fullPath: '/individual/portal/approvals'
      preLoaderRoute: typeof IndividualIndividualPortalApprovalsIndexImport
      parentRoute: typeof IndividualIndividualPortalImport
    }
    '/_individual/individual/portal/lookup/': {
      id: '/_individual/individual/portal/lookup/'
      path: '/lookup'
      fullPath: '/individual/portal/lookup'
      preLoaderRoute: typeof IndividualIndividualPortalLookupIndexImport
      parentRoute: typeof IndividualIndividualPortalImport
    }
    '/_individual/individual/portal/requests/': {
      id: '/_individual/individual/portal/requests/'
      path: '/requests'
      fullPath: '/individual/portal/requests'
      preLoaderRoute: typeof IndividualIndividualPortalRequestsIndexImport
      parentRoute: typeof IndividualIndividualPortalImport
    }
    '/_individual/individual/task/$id/': {
      id: '/_individual/individual/task/$id/'
      path: '/task/$id'
      fullPath: '/individual/task/$id'
      preLoaderRoute: typeof IndividualIndividualTaskIdIndexImport
      parentRoute: typeof IndividualIndividualImport
    }
    '/_stacktrace/development-tickets/$ticketId/_layout/': {
      id: '/_stacktrace/development-tickets/$ticketId/_layout/'
      path: '/'
      fullPath: '/development-tickets/$ticketId/'
      preLoaderRoute: typeof StacktraceDevelopmentTicketsTicketIdLayoutIndexImport
      parentRoute: typeof StacktraceDevelopmentTicketsTicketIdLayoutImport
    }
    '/_stacktrace/issues/$id/_layout/': {
      id: '/_stacktrace/issues/$id/_layout/'
      path: '/'
      fullPath: '/issues/$id/'
      preLoaderRoute: typeof StacktraceIssuesIdLayoutIndexImport
      parentRoute: typeof StacktraceIssuesIdLayoutImport
    }
    '/_stacktrace/issues/_layout/overview/': {
      id: '/_stacktrace/issues/_layout/overview/'
      path: '/overview'
      fullPath: '/issues/overview'
      preLoaderRoute: typeof StacktraceIssuesLayoutOverviewIndexImport
      parentRoute: typeof StacktraceIssuesLayoutImport
    }
    '/_stacktrace/product-roadmap/$roadmapId/_layout/': {
      id: '/_stacktrace/product-roadmap/$roadmapId/_layout/'
      path: '/'
      fullPath: '/product-roadmap/$roadmapId/'
      preLoaderRoute: typeof StacktraceProductRoadmapRoadmapIdLayoutIndexImport
      parentRoute: typeof StacktraceProductRoadmapRoadmapIdLayoutImport
    }
    '/_stacktrace/production/$productionId/_layout/': {
      id: '/_stacktrace/production/$productionId/_layout/'
      path: '/'
      fullPath: '/production/$productionId/'
      preLoaderRoute: typeof StacktraceProductionProductionIdLayoutIndexImport
      parentRoute: typeof StacktraceProductionProductionIdLayoutImport
    }
    '/_stacktrace/products/$id/_layout/': {
      id: '/_stacktrace/products/$id/_layout/'
      path: '/'
      fullPath: '/products/$id/'
      preLoaderRoute: typeof StacktraceProductsIdLayoutIndexImport
      parentRoute: typeof StacktraceProductsIdLayoutImport
    }
    '/_stacktrace/test-sets/$id/_layout/': {
      id: '/_stacktrace/test-sets/$id/_layout/'
      path: '/'
      fullPath: '/test-sets/$id/'
      preLoaderRoute: typeof StacktraceTestSetsIdLayoutIndexImport
      parentRoute: typeof StacktraceTestSetsIdLayoutImport
    }
    '/_stacktrace/test-suites/$id/_layout/': {
      id: '/_stacktrace/test-suites/$id/_layout/'
      path: '/'
      fullPath: '/test-suites/$id/'
      preLoaderRoute: typeof StacktraceTestSuitesIdLayoutIndexImport
      parentRoute: typeof StacktraceTestSuitesIdLayoutImport
    }
    '/_stacktrace/values/$id/_layout/': {
      id: '/_stacktrace/values/$id/_layout/'
      path: '/'
      fullPath: '/values/$id/'
      preLoaderRoute: typeof StacktraceValuesIdLayoutIndexImport
      parentRoute: typeof StacktraceValuesIdLayoutImport
    }
    '/_staff/accesses/_layout/alerts/': {
      id: '/_staff/accesses/_layout/alerts/'
      path: '/alerts'
      fullPath: '/accesses/alerts'
      preLoaderRoute: typeof StaffAccessesLayoutAlertsIndexImport
      parentRoute: typeof StaffAccessesLayoutImport
    }
    '/_staff/accesses/_layout/list/': {
      id: '/_staff/accesses/_layout/list/'
      path: '/list'
      fullPath: '/accesses/list'
      preLoaderRoute: typeof StaffAccessesLayoutListIndexImport
      parentRoute: typeof StaffAccessesLayoutImport
    }
    '/_staff/accesses/_layout/settings/': {
      id: '/_staff/accesses/_layout/settings/'
      path: '/settings'
      fullPath: '/accesses/settings'
      preLoaderRoute: typeof StaffAccessesLayoutSettingsIndexImport
      parentRoute: typeof StaffAccessesLayoutImport
    }
    '/_staff/attendance-core/_layout/archive/': {
      id: '/_staff/attendance-core/_layout/archive/'
      path: '/archive'
      fullPath: '/attendance-core/archive'
      preLoaderRoute: typeof StaffAttendanceCoreLayoutArchiveIndexImport
      parentRoute: typeof StaffAttendanceCoreLayoutImport
    }
    '/_staff/attendance-core/_layout/config/': {
      id: '/_staff/attendance-core/_layout/config/'
      path: '/config'
      fullPath: '/attendance-core/config'
      preLoaderRoute: typeof StaffAttendanceCoreLayoutConfigIndexImport
      parentRoute: typeof StaffAttendanceCoreLayoutImport
    }
    '/_staff/attendance-core/_layout/dashboard/': {
      id: '/_staff/attendance-core/_layout/dashboard/'
      path: '/dashboard'
      fullPath: '/attendance-core/dashboard'
      preLoaderRoute: typeof StaffAttendanceCoreLayoutDashboardIndexImport
      parentRoute: typeof StaffAttendanceCoreLayoutImport
    }
    '/_staff/attendance-core/_layout/operation-packages/': {
      id: '/_staff/attendance-core/_layout/operation-packages/'
      path: '/operation-packages'
      fullPath: '/attendance-core/operation-packages'
      preLoaderRoute: typeof StaffAttendanceCoreLayoutOperationPackagesIndexImport
      parentRoute: typeof StaffAttendanceCoreLayoutImport
    }
    '/_staff/attendance-engine/_layout/attendance-structures/': {
      id: '/_staff/attendance-engine/_layout/attendance-structures/'
      path: '/attendance-structures'
      fullPath: '/attendance-engine/attendance-structures'
      preLoaderRoute: typeof StaffAttendanceEngineLayoutAttendanceStructuresIndexImport
      parentRoute: typeof StaffAttendanceEngineLayoutImport
    }
    '/_staff/attendance-engine/_layout/attendance-units/': {
      id: '/_staff/attendance-engine/_layout/attendance-units/'
      path: '/attendance-units'
      fullPath: '/attendance-engine/attendance-units'
      preLoaderRoute: typeof StaffAttendanceEngineLayoutAttendanceUnitsIndexImport
      parentRoute: typeof StaffAttendanceEngineLayoutImport
    }
    '/_staff/attendance-engine/_layout/items/': {
      id: '/_staff/attendance-engine/_layout/items/'
      path: '/items'
      fullPath: '/attendance-engine/items'
      preLoaderRoute: typeof StaffAttendanceEngineLayoutItemsIndexImport
      parentRoute: typeof StaffAttendanceEngineLayoutImport
    }
    '/_staff/attendance-engine/_layout/logic-components/': {
      id: '/_staff/attendance-engine/_layout/logic-components/'
      path: '/logic-components'
      fullPath: '/attendance-engine/logic-components'
      preLoaderRoute: typeof StaffAttendanceEngineLayoutLogicComponentsIndexImport
      parentRoute: typeof StaffAttendanceEngineLayoutImport
    }
    '/_staff/attendances/_layout/alerts/': {
      id: '/_staff/attendances/_layout/alerts/'
      path: '/alerts'
      fullPath: '/attendances/alerts'
      preLoaderRoute: typeof StaffAttendancesLayoutAlertsIndexImport
      parentRoute: typeof StaffAttendancesLayoutImport
    }
    '/_staff/attendances/_layout/clocking-records/': {
      id: '/_staff/attendances/_layout/clocking-records/'
      path: '/clocking-records'
      fullPath: '/attendances/clocking-records'
      preLoaderRoute: typeof StaffAttendancesLayoutClockingRecordsIndexImport
      parentRoute: typeof StaffAttendancesLayoutImport
    }
    '/_staff/attendances/_layout/employees/': {
      id: '/_staff/attendances/_layout/employees/'
      path: '/employees'
      fullPath: '/attendances/employees'
      preLoaderRoute: typeof StaffAttendancesLayoutEmployeesIndexImport
      parentRoute: typeof StaffAttendancesLayoutImport
    }
    '/_staff/attendances/_layout/operation-activity/': {
      id: '/_staff/attendances/_layout/operation-activity/'
      path: '/operation-activity'
      fullPath: '/attendances/operation-activity'
      preLoaderRoute: typeof StaffAttendancesLayoutOperationActivityIndexImport
      parentRoute: typeof StaffAttendancesLayoutImport
    }
    '/_staff/attendances/_layout/overview/': {
      id: '/_staff/attendances/_layout/overview/'
      path: '/overview'
      fullPath: '/attendances/overview'
      preLoaderRoute: typeof StaffAttendancesLayoutOverviewIndexImport
      parentRoute: typeof StaffAttendancesLayoutImport
    }
    '/_staff/attendances/_layout/rule-and-policy/': {
      id: '/_staff/attendances/_layout/rule-and-policy/'
      path: '/rule-and-policy'
      fullPath: '/attendances/rule-and-policy'
      preLoaderRoute: typeof StaffAttendancesLayoutRuleAndPolicyIndexImport
      parentRoute: typeof StaffAttendancesLayoutImport
    }
    '/_staff/attendances/_layout/settings/': {
      id: '/_staff/attendances/_layout/settings/'
      path: '/settings'
      fullPath: '/attendances/settings'
      preLoaderRoute: typeof StaffAttendancesLayoutSettingsIndexImport
      parentRoute: typeof StaffAttendancesLayoutImport
    }
    '/_staff/business-partner/_list/terminated/': {
      id: '/_staff/business-partner/_list/terminated/'
      path: '/terminated'
      fullPath: '/business-partner/terminated'
      preLoaderRoute: typeof StaffBusinessPartnerListTerminatedIndexImport
      parentRoute: typeof StaffBusinessPartnerListImport
    }
    '/_staff/business-partner/add/$businessPartnerType/': {
      id: '/_staff/business-partner/add/$businessPartnerType/'
      path: '/add/$businessPartnerType'
      fullPath: '/business-partner/add/$businessPartnerType'
      preLoaderRoute: typeof StaffBusinessPartnerAddBusinessPartnerTypeIndexImport
      parentRoute: typeof StaffBusinessPartnerImport
    }
    '/_staff/certification/_list/people/': {
      id: '/_staff/certification/_list/people/'
      path: '/people'
      fullPath: '/certification/people'
      preLoaderRoute: typeof StaffCertificationListPeopleIndexImport
      parentRoute: typeof StaffCertificationListImport
    }
    '/_staff/certification/_list/settings/': {
      id: '/_staff/certification/_list/settings/'
      path: '/'
      fullPath: '/certification/settings/'
      preLoaderRoute: typeof StaffCertificationListSettingsIndexImport
      parentRoute: typeof StaffCertificationListSettingsRouteLazyImport
    }
    '/_staff/certification/add/$certificationKind/': {
      id: '/_staff/certification/add/$certificationKind/'
      path: '/add/$certificationKind'
      fullPath: '/certification/add/$certificationKind'
      preLoaderRoute: typeof StaffCertificationAddCertificationKindIndexImport
      parentRoute: typeof StaffCertificationImport
    }
    '/_staff/cockpit/approval/$id/': {
      id: '/_staff/cockpit/approval/$id/'
      path: '/cockpit/approval/$id'
      fullPath: '/cockpit/approval/$id'
      preLoaderRoute: typeof StaffCockpitApprovalIdIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/cockpit/task/$taskId/': {
      id: '/_staff/cockpit/task/$taskId/'
      path: '/cockpit/task/$taskId'
      fullPath: '/cockpit/task/$taskId'
      preLoaderRoute: typeof StaffCockpitTaskTaskIdIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/contract/add/subscription/': {
      id: '/_staff/contract/add/subscription/'
      path: '/add/subscription'
      fullPath: '/contract/add/subscription'
      preLoaderRoute: typeof StaffContractAddSubscriptionIndexImport
      parentRoute: typeof StaffContractImport
    }
    '/_staff/contract/import-csv/$contractType/': {
      id: '/_staff/contract/import-csv/$contractType/'
      path: '/import-csv/$contractType'
      fullPath: '/contract/import-csv/$contractType'
      preLoaderRoute: typeof StaffContractImportCsvContractTypeIndexImport
      parentRoute: typeof StaffContractImport
    }
    '/_staff/contractor-core/_packages/archives/': {
      id: '/_staff/contractor-core/_packages/archives/'
      path: '/archives'
      fullPath: '/contractor-core/archives'
      preLoaderRoute: typeof StaffContractorCorePackagesArchivesIndexImport
      parentRoute: typeof StaffContractorCorePackagesImport
    }
    '/_staff/contractor-core/_packages/configs/': {
      id: '/_staff/contractor-core/_packages/configs/'
      path: '/configs'
      fullPath: '/contractor-core/configs'
      preLoaderRoute: typeof StaffContractorCorePackagesConfigsIndexImport
      parentRoute: typeof StaffContractorCorePackagesImport
    }
    '/_staff/contractor-core/config/$patternId/': {
      id: '/_staff/contractor-core/config/$patternId/'
      path: '/config/$patternId'
      fullPath: '/contractor-core/config/$patternId'
      preLoaderRoute: typeof StaffContractorCoreConfigPatternIdIndexImport
      parentRoute: typeof StaffContractorCoreImport
    }
    '/_staff/deal/add/$direction/': {
      id: '/_staff/deal/add/$direction/'
      path: '/add/$direction'
      fullPath: '/deal/add/$direction'
      preLoaderRoute: typeof StaffDealAddDirectionIndexImport
      parentRoute: typeof StaffDealImport
    }
    '/_staff/device-catalog/add/$deviceType/': {
      id: '/_staff/device-catalog/add/$deviceType/'
      path: '/device-catalog/add/$deviceType'
      fullPath: '/device-catalog/add/$deviceType'
      preLoaderRoute: typeof StaffDeviceCatalogAddDeviceTypeIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/devices/$id/_layout/': {
      id: '/_staff/devices/$id/_layout/'
      path: '/'
      fullPath: '/devices/$id/'
      preLoaderRoute: typeof StaffDevicesIdLayoutIndexImport
      parentRoute: typeof StaffDevicesIdLayoutImport
    }
    '/_staff/devices/_list/inventories/': {
      id: '/_staff/devices/_list/inventories/'
      path: '/inventories'
      fullPath: '/devices/inventories'
      preLoaderRoute: typeof StaffDevicesListInventoriesIndexImport
      parentRoute: typeof StaffDevicesListImport
    }
    '/_staff/devices/_list/inventory/': {
      id: '/_staff/devices/_list/inventory/'
      path: '/inventory'
      fullPath: '/devices/inventory'
      preLoaderRoute: typeof StaffDevicesListInventoryIndexImport
      parentRoute: typeof StaffDevicesListImport
    }
    '/_staff/devices/_list/people/': {
      id: '/_staff/devices/_list/people/'
      path: '/people'
      fullPath: '/devices/people'
      preLoaderRoute: typeof StaffDevicesListPeopleIndexImport
      parentRoute: typeof StaffDevicesListImport
    }
    '/_staff/devices/_list/settings/': {
      id: '/_staff/devices/_list/settings/'
      path: '/'
      fullPath: '/devices/settings/'
      preLoaderRoute: typeof StaffDevicesListSettingsIndexImport
      parentRoute: typeof StaffDevicesListSettingsRouteLazyImport
    }
    '/_staff/devices/add/$deviceType/': {
      id: '/_staff/devices/add/$deviceType/'
      path: '/add/$deviceType'
      fullPath: '/devices/add/$deviceType'
      preLoaderRoute: typeof StaffDevicesAddDeviceTypeIndexImport
      parentRoute: typeof StaffDevicesImport
    }
    '/_staff/devices/add/catalog/': {
      id: '/_staff/devices/add/catalog/'
      path: '/add/catalog'
      fullPath: '/devices/add/catalog'
      preLoaderRoute: typeof StaffDevicesAddCatalogIndexImport
      parentRoute: typeof StaffDevicesImport
    }
    '/_staff/equipment/_layout/alerts/': {
      id: '/_staff/equipment/_layout/alerts/'
      path: '/alerts'
      fullPath: '/equipment/alerts'
      preLoaderRoute: typeof StaffEquipmentLayoutAlertsIndexImport
      parentRoute: typeof StaffEquipmentLayoutImport
    }
    '/_staff/equipment/_layout/items/': {
      id: '/_staff/equipment/_layout/items/'
      path: '/items'
      fullPath: '/equipment/items'
      preLoaderRoute: typeof StaffEquipmentLayoutItemsIndexImport
      parentRoute: typeof StaffEquipmentLayoutImport
    }
    '/_staff/equipment/_layout/settings/': {
      id: '/_staff/equipment/_layout/settings/'
      path: '/'
      fullPath: '/equipment/settings/'
      preLoaderRoute: typeof StaffEquipmentLayoutSettingsIndexImport
      parentRoute: typeof StaffEquipmentLayoutSettingsRouteLazyImport
    }
    '/_staff/fleets/_layout/_list/': {
      id: '/_staff/fleets/_layout/_list/'
      path: '/'
      fullPath: '/fleets/'
      preLoaderRoute: typeof StaffFleetsLayoutListIndexImport
      parentRoute: typeof StaffFleetsLayoutImport
    }
    '/_staff/ga-operation-core/_packages/archives/': {
      id: '/_staff/ga-operation-core/_packages/archives/'
      path: '/archives'
      fullPath: '/ga-operation-core/archives'
      preLoaderRoute: typeof StaffGaOperationCorePackagesArchivesIndexImport
      parentRoute: typeof StaffGaOperationCorePackagesImport
    }
    '/_staff/ga-operation-core/_packages/configs/': {
      id: '/_staff/ga-operation-core/_packages/configs/'
      path: '/configs'
      fullPath: '/ga-operation-core/configs'
      preLoaderRoute: typeof StaffGaOperationCorePackagesConfigsIndexImport
      parentRoute: typeof StaffGaOperationCorePackagesImport
    }
    '/_staff/ga-operation-core/config/$patternId/': {
      id: '/_staff/ga-operation-core/config/$patternId/'
      path: '/config/$patternId'
      fullPath: '/ga-operation-core/config/$patternId'
      preLoaderRoute: typeof StaffGaOperationCoreConfigPatternIdIndexImport
      parentRoute: typeof StaffGaOperationCoreImport
    }
    '/_staff/ids/_layout/people/': {
      id: '/_staff/ids/_layout/people/'
      path: '/people'
      fullPath: '/ids/people'
      preLoaderRoute: typeof StaffIdsLayoutPeopleIndexImport
      parentRoute: typeof StaffIdsLayoutImport
    }
    '/_staff/ids/group-id/add/': {
      id: '/_staff/ids/group-id/add/'
      path: '/group-id/add'
      fullPath: '/ids/group-id/add'
      preLoaderRoute: typeof StaffIdsGroupIdAddIndexImport
      parentRoute: typeof StaffIdsImport
    }
    '/_staff/it-operation-core/_root/archives/': {
      id: '/_staff/it-operation-core/_root/archives/'
      path: '/archives'
      fullPath: '/it-operation-core/archives'
      preLoaderRoute: typeof StaffItOperationCoreRootArchivesIndexImport
      parentRoute: typeof StaffItOperationCoreRootImport
    }
    '/_staff/it-operation-core/_root/config/': {
      id: '/_staff/it-operation-core/_root/config/'
      path: '/config'
      fullPath: '/it-operation-core/config'
      preLoaderRoute: typeof StaffItOperationCoreRootConfigIndexImport
      parentRoute: typeof StaffItOperationCoreRootImport
    }
    '/_staff/it-operation-core/_root/in-house-packages/': {
      id: '/_staff/it-operation-core/_root/in-house-packages/'
      path: '/'
      fullPath: '/it-operation-core/in-house-packages/'
      preLoaderRoute: typeof StaffItOperationCoreRootInHousePackagesIndexImport
      parentRoute: typeof StaffItOperationCoreRootInHousePackagesRouteImport
    }
    '/_staff/it-operation-core/_root/packages/': {
      id: '/_staff/it-operation-core/_root/packages/'
      path: '/'
      fullPath: '/it-operation-core/packages/'
      preLoaderRoute: typeof StaffItOperationCoreRootPackagesIndexImport
      parentRoute: typeof StaffItOperationCoreRootPackagesRouteImport
    }
    '/_staff/it-operation-core/config/$patternId/': {
      id: '/_staff/it-operation-core/config/$patternId/'
      path: '/config/$patternId'
      fullPath: '/it-operation-core/config/$patternId'
      preLoaderRoute: typeof StaffItOperationCoreConfigPatternIdIndexImport
      parentRoute: typeof StaffItOperationCoreImport
    }
    '/_staff/it-operation-core/self-report-patterns/$patternId/': {
      id: '/_staff/it-operation-core/self-report-patterns/$patternId/'
      path: '/self-report-patterns/$patternId'
      fullPath: '/it-operation-core/self-report-patterns/$patternId'
      preLoaderRoute: typeof StaffItOperationCoreSelfReportPatternsPatternIdIndexImport
      parentRoute: typeof StaffItOperationCoreImport
    }
    '/_staff/labor-core/_packages/archives/': {
      id: '/_staff/labor-core/_packages/archives/'
      path: '/archives'
      fullPath: '/labor-core/archives'
      preLoaderRoute: typeof StaffLaborCorePackagesArchivesIndexImport
      parentRoute: typeof StaffLaborCorePackagesImport
    }
    '/_staff/labor-core/_packages/configs/': {
      id: '/_staff/labor-core/_packages/configs/'
      path: '/configs'
      fullPath: '/labor-core/configs'
      preLoaderRoute: typeof StaffLaborCorePackagesConfigsIndexImport
      parentRoute: typeof StaffLaborCorePackagesImport
    }
    '/_staff/labor-core/_packages/settings/': {
      id: '/_staff/labor-core/_packages/settings/'
      path: '/'
      fullPath: '/labor-core/settings/'
      preLoaderRoute: typeof StaffLaborCorePackagesSettingsIndexImport
      parentRoute: typeof StaffLaborCorePackagesSettingsImport
    }
    '/_staff/labor-core/config/$patternId/': {
      id: '/_staff/labor-core/config/$patternId/'
      path: '/config/$patternId'
      fullPath: '/labor-core/config/$patternId'
      preLoaderRoute: typeof StaffLaborCoreConfigPatternIdIndexImport
      parentRoute: typeof StaffLaborCoreImport
    }
    '/_staff/licenses/_list/alerts/': {
      id: '/_staff/licenses/_list/alerts/'
      path: '/alerts'
      fullPath: '/licenses/alerts'
      preLoaderRoute: typeof StaffLicensesListAlertsIndexImport
      parentRoute: typeof StaffLicensesListImport
    }
    '/_staff/licenses/_list/contract-and-cost/': {
      id: '/_staff/licenses/_list/contract-and-cost/'
      path: '/contract-and-cost'
      fullPath: '/licenses/contract-and-cost'
      preLoaderRoute: typeof StaffLicensesListContractAndCostIndexImport
      parentRoute: typeof StaffLicensesListImport
    }
    '/_staff/licenses/_list/inventory/': {
      id: '/_staff/licenses/_list/inventory/'
      path: '/inventory'
      fullPath: '/licenses/inventory'
      preLoaderRoute: typeof StaffLicensesListInventoryIndexImport
      parentRoute: typeof StaffLicensesListImport
    }
    '/_staff/licenses/_list/operation-activity/': {
      id: '/_staff/licenses/_list/operation-activity/'
      path: '/operation-activity'
      fullPath: '/licenses/operation-activity'
      preLoaderRoute: typeof StaffLicensesListOperationActivityIndexImport
      parentRoute: typeof StaffLicensesListImport
    }
    '/_staff/licenses/_list/people/': {
      id: '/_staff/licenses/_list/people/'
      path: '/people'
      fullPath: '/licenses/people'
      preLoaderRoute: typeof StaffLicensesListPeopleIndexImport
      parentRoute: typeof StaffLicensesListImport
    }
    '/_staff/licenses/_list/rule-and-policy/': {
      id: '/_staff/licenses/_list/rule-and-policy/'
      path: '/rule-and-policy'
      fullPath: '/licenses/rule-and-policy'
      preLoaderRoute: typeof StaffLicensesListRuleAndPolicyIndexImport
      parentRoute: typeof StaffLicensesListImport
    }
    '/_staff/licenses/_list/settings/': {
      id: '/_staff/licenses/_list/settings/'
      path: '/settings'
      fullPath: '/licenses/settings'
      preLoaderRoute: typeof StaffLicensesListSettingsIndexImport
      parentRoute: typeof StaffLicensesListImport
    }
    '/_staff/licenses/add/$allocationType/': {
      id: '/_staff/licenses/add/$allocationType/'
      path: '/add/$allocationType'
      fullPath: '/licenses/add/$allocationType'
      preLoaderRoute: typeof StaffLicensesAddAllocationTypeIndexImport
      parentRoute: typeof StaffLicensesImport
    }
    '/_staff/marketplace/sales-orders/$orderId/': {
      id: '/_staff/marketplace/sales-orders/$orderId/'
      path: '/sales-orders/$orderId'
      fullPath: '/marketplace/sales-orders/$orderId'
      preLoaderRoute: typeof StaffMarketplaceSalesOrdersOrderIdIndexImport
      parentRoute: typeof StaffMarketplaceImport
    }
    '/_staff/organization/$id/_layout/': {
      id: '/_staff/organization/$id/_layout/'
      path: '/'
      fullPath: '/organization/$id/'
      preLoaderRoute: typeof StaffOrganizationIdLayoutIndexImport
      parentRoute: typeof StaffOrganizationIdLayoutImport
    }
    '/_staff/organization/_list/alert/': {
      id: '/_staff/organization/_list/alert/'
      path: '/alert'
      fullPath: '/organization/alert'
      preLoaderRoute: typeof StaffOrganizationListAlertIndexImport
      parentRoute: typeof StaffOrganizationListImport
    }
    '/_staff/organization/_list/chart/': {
      id: '/_staff/organization/_list/chart/'
      path: '/chart'
      fullPath: '/organization/chart'
      preLoaderRoute: typeof StaffOrganizationListChartIndexImport
      parentRoute: typeof StaffOrganizationListImport
    }
    '/_staff/organization/_list/cost/': {
      id: '/_staff/organization/_list/cost/'
      path: '/cost'
      fullPath: '/organization/cost'
      preLoaderRoute: typeof StaffOrganizationListCostIndexImport
      parentRoute: typeof StaffOrganizationListImport
    }
    '/_staff/organization/_list/history/': {
      id: '/_staff/organization/_list/history/'
      path: '/history'
      fullPath: '/organization/history'
      preLoaderRoute: typeof StaffOrganizationListHistoryIndexImport
      parentRoute: typeof StaffOrganizationListImport
    }
    '/_staff/organization/_list/rule-policy/': {
      id: '/_staff/organization/_list/rule-policy/'
      path: '/rule-policy'
      fullPath: '/organization/rule-policy'
      preLoaderRoute: typeof StaffOrganizationListRulePolicyIndexImport
      parentRoute: typeof StaffOrganizationListImport
    }
    '/_staff/organization/_list/settings/': {
      id: '/_staff/organization/_list/settings/'
      path: '/settings'
      fullPath: '/organization/settings'
      preLoaderRoute: typeof StaffOrganizationListSettingsIndexImport
      parentRoute: typeof StaffOrganizationListImport
    }
    '/_staff/organization/plan/$id/': {
      id: '/_staff/organization/plan/$id/'
      path: '/plan/$id'
      fullPath: '/organization/plan/$id'
      preLoaderRoute: typeof StaffOrganizationPlanIdIndexImport
      parentRoute: typeof StaffOrganizationImport
    }
    '/_staff/organization/plan/create/': {
      id: '/_staff/organization/plan/create/'
      path: '/plan/create'
      fullPath: '/organization/plan/create'
      preLoaderRoute: typeof StaffOrganizationPlanCreateIndexImport
      parentRoute: typeof StaffOrganizationImport
    }
    '/_staff/payroll-core/_layout/archive/': {
      id: '/_staff/payroll-core/_layout/archive/'
      path: '/archive'
      fullPath: '/payroll-core/archive'
      preLoaderRoute: typeof StaffPayrollCoreLayoutArchiveIndexImport
      parentRoute: typeof StaffPayrollCoreLayoutImport
    }
    '/_staff/payroll-core/_layout/config/': {
      id: '/_staff/payroll-core/_layout/config/'
      path: '/config'
      fullPath: '/payroll-core/config'
      preLoaderRoute: typeof StaffPayrollCoreLayoutConfigIndexImport
      parentRoute: typeof StaffPayrollCoreLayoutImport
    }
    '/_staff/payroll-core/_layout/dashboard/': {
      id: '/_staff/payroll-core/_layout/dashboard/'
      path: '/dashboard'
      fullPath: '/payroll-core/dashboard'
      preLoaderRoute: typeof StaffPayrollCoreLayoutDashboardIndexImport
      parentRoute: typeof StaffPayrollCoreLayoutImport
    }
    '/_staff/payroll-core/_layout/operation-packages/': {
      id: '/_staff/payroll-core/_layout/operation-packages/'
      path: '/operation-packages'
      fullPath: '/payroll-core/operation-packages'
      preLoaderRoute: typeof StaffPayrollCoreLayoutOperationPackagesIndexImport
      parentRoute: typeof StaffPayrollCoreLayoutImport
    }
    '/_staff/payroll-core/_layout/person-targets/': {
      id: '/_staff/payroll-core/_layout/person-targets/'
      path: '/person-targets'
      fullPath: '/payroll-core/person-targets'
      preLoaderRoute: typeof StaffPayrollCoreLayoutPersonTargetsIndexImport
      parentRoute: typeof StaffPayrollCoreLayoutImport
    }
    '/_staff/payroll-engine/_layout/items/': {
      id: '/_staff/payroll-engine/_layout/items/'
      path: '/items'
      fullPath: '/payroll-engine/items'
      preLoaderRoute: typeof StaffPayrollEngineLayoutItemsIndexImport
      parentRoute: typeof StaffPayrollEngineLayoutImport
    }
    '/_staff/payroll-engine/_layout/logic-components/': {
      id: '/_staff/payroll-engine/_layout/logic-components/'
      path: '/logic-components'
      fullPath: '/payroll-engine/logic-components'
      preLoaderRoute: typeof StaffPayrollEngineLayoutLogicComponentsIndexImport
      parentRoute: typeof StaffPayrollEngineLayoutImport
    }
    '/_staff/payroll-engine/_layout/payroll-structures/': {
      id: '/_staff/payroll-engine/_layout/payroll-structures/'
      path: '/payroll-structures'
      fullPath: '/payroll-engine/payroll-structures'
      preLoaderRoute: typeof StaffPayrollEngineLayoutPayrollStructuresIndexImport
      parentRoute: typeof StaffPayrollEngineLayoutImport
    }
    '/_staff/payroll-engine/_layout/payroll-units/': {
      id: '/_staff/payroll-engine/_layout/payroll-units/'
      path: '/payroll-units'
      fullPath: '/payroll-engine/payroll-units'
      preLoaderRoute: typeof StaffPayrollEngineLayoutPayrollUnitsIndexImport
      parentRoute: typeof StaffPayrollEngineLayoutImport
    }
    '/_staff/payroll/_layout/alerts/': {
      id: '/_staff/payroll/_layout/alerts/'
      path: '/alerts'
      fullPath: '/payroll/alerts'
      preLoaderRoute: typeof StaffPayrollLayoutAlertsIndexImport
      parentRoute: typeof StaffPayrollLayoutImport
    }
    '/_staff/payroll/_layout/overview/': {
      id: '/_staff/payroll/_layout/overview/'
      path: '/overview'
      fullPath: '/payroll/overview'
      preLoaderRoute: typeof StaffPayrollLayoutOverviewIndexImport
      parentRoute: typeof StaffPayrollLayoutImport
    }
    '/_staff/payroll/_layout/pay-slips/': {
      id: '/_staff/payroll/_layout/pay-slips/'
      path: '/pay-slips'
      fullPath: '/payroll/pay-slips'
      preLoaderRoute: typeof StaffPayrollLayoutPaySlipsIndexImport
      parentRoute: typeof StaffPayrollLayoutImport
    }
    '/_staff/payroll/_layout/rule-and-policy/': {
      id: '/_staff/payroll/_layout/rule-and-policy/'
      path: '/rule-and-policy'
      fullPath: '/payroll/rule-and-policy'
      preLoaderRoute: typeof StaffPayrollLayoutRuleAndPolicyIndexImport
      parentRoute: typeof StaffPayrollLayoutImport
    }
    '/_staff/payroll/_layout/settings/': {
      id: '/_staff/payroll/_layout/settings/'
      path: '/settings'
      fullPath: '/payroll/settings'
      preLoaderRoute: typeof StaffPayrollLayoutSettingsIndexImport
      parentRoute: typeof StaffPayrollLayoutImport
    }
    '/_staff/people/_list/alumni/': {
      id: '/_staff/people/_list/alumni/'
      path: '/alumni'
      fullPath: '/people/alumni'
      preLoaderRoute: typeof StaffPeopleListAlumniIndexImport
      parentRoute: typeof StaffPeopleListImport
    }
    '/_staff/people/_list/operation-activity/': {
      id: '/_staff/people/_list/operation-activity/'
      path: '/operation-activity'
      fullPath: '/people/operation-activity'
      preLoaderRoute: typeof StaffPeopleListOperationActivityIndexImport
      parentRoute: typeof StaffPeopleListImport
    }
    '/_staff/people/_list/settings/': {
      id: '/_staff/people/_list/settings/'
      path: '/'
      fullPath: '/people/settings/'
      preLoaderRoute: typeof StaffPeopleListSettingsIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/workforce/': {
      id: '/_staff/people/_list/workforce/'
      path: '/workforce'
      fullPath: '/people/workforce'
      preLoaderRoute: typeof StaffPeopleListWorkforceIndexImport
      parentRoute: typeof StaffPeopleListImport
    }
    '/_staff/person/add-person-certification/$certificationKind/': {
      id: '/_staff/person/add-person-certification/$certificationKind/'
      path: '/person/add-person-certification/$certificationKind'
      fullPath: '/person/add-person-certification/$certificationKind'
      preLoaderRoute: typeof StaffPersonAddPersonCertificationCertificationKindIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/person/add/$workerType/': {
      id: '/_staff/person/add/$workerType/'
      path: '/person/add/$workerType'
      fullPath: '/person/add/$workerType'
      preLoaderRoute: typeof StaffPersonAddWorkerTypeIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/person/automap-ingester/$workerType/': {
      id: '/_staff/person/automap-ingester/$workerType/'
      path: '/person/automap-ingester/$workerType'
      fullPath: '/person/automap-ingester/$workerType'
      preLoaderRoute: typeof StaffPersonAutomapIngesterWorkerTypeIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/places/_layout/settings/': {
      id: '/_staff/places/_layout/settings/'
      path: '/'
      fullPath: '/places/settings/'
      preLoaderRoute: typeof StaffPlacesLayoutSettingsIndexImport
      parentRoute: typeof StaffPlacesLayoutSettingsRouteImport
    }
    '/_staff/profile/device/$id/': {
      id: '/_staff/profile/device/$id/'
      path: '/profile/device/$id'
      fullPath: '/profile/device/$id'
      preLoaderRoute: typeof StaffProfileDeviceIdIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/public-ids/$id/details/': {
      id: '/_staff/public-ids/$id/details/'
      path: '/details'
      fullPath: '/public-ids/$id/details'
      preLoaderRoute: typeof StaffPublicIdsIdDetailsIndexImport
      parentRoute: typeof StaffPublicIdsIdImport
    }
    '/_staff/public-ids/$id/files/': {
      id: '/_staff/public-ids/$id/files/'
      path: '/files'
      fullPath: '/public-ids/$id/files'
      preLoaderRoute: typeof StaffPublicIdsIdFilesIndexImport
      parentRoute: typeof StaffPublicIdsIdImport
    }
    '/_staff/public-ids/_list/alerts/': {
      id: '/_staff/public-ids/_list/alerts/'
      path: '/alerts'
      fullPath: '/public-ids/alerts'
      preLoaderRoute: typeof StaffPublicIdsListAlertsIndexImport
      parentRoute: typeof StaffPublicIdsListImport
    }
    '/_staff/public-ids/_list/members/': {
      id: '/_staff/public-ids/_list/members/'
      path: '/members'
      fullPath: '/public-ids/members'
      preLoaderRoute: typeof StaffPublicIdsListMembersIndexImport
      parentRoute: typeof StaffPublicIdsListImport
    }
    '/_staff/public-ids/_list/operation-activity/': {
      id: '/_staff/public-ids/_list/operation-activity/'
      path: '/operation-activity'
      fullPath: '/public-ids/operation-activity'
      preLoaderRoute: typeof StaffPublicIdsListOperationActivityIndexImport
      parentRoute: typeof StaffPublicIdsListImport
    }
    '/_staff/public-ids/_list/registry/': {
      id: '/_staff/public-ids/_list/registry/'
      path: '/registry'
      fullPath: '/public-ids/registry'
      preLoaderRoute: typeof StaffPublicIdsListRegistryIndexImport
      parentRoute: typeof StaffPublicIdsListImport
    }
    '/_staff/public-ids/_list/rules-and-policies/': {
      id: '/_staff/public-ids/_list/rules-and-policies/'
      path: '/rules-and-policies'
      fullPath: '/public-ids/rules-and-policies'
      preLoaderRoute: typeof StaffPublicIdsListRulesAndPoliciesIndexImport
      parentRoute: typeof StaffPublicIdsListImport
    }
    '/_staff/public-ids/_list/settings/': {
      id: '/_staff/public-ids/_list/settings/'
      path: '/settings'
      fullPath: '/public-ids/settings'
      preLoaderRoute: typeof StaffPublicIdsListSettingsIndexImport
      parentRoute: typeof StaffPublicIdsListImport
    }
    '/_staff/settings/data-connector/inbound/': {
      id: '/_staff/settings/data-connector/inbound/'
      path: '/settings/data-connector/inbound'
      fullPath: '/settings/data-connector/inbound'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/settings/data-connector/outbound/': {
      id: '/_staff/settings/data-connector/outbound/'
      path: '/settings/data-connector/outbound'
      fullPath: '/settings/data-connector/outbound'
      preLoaderRoute: typeof StaffSettingsDataConnectorOutboundIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/settings/persons/invite/': {
      id: '/_staff/settings/persons/invite/'
      path: '/invite'
      fullPath: '/settings/persons/invite'
      preLoaderRoute: typeof StaffSettingsPersonsInviteIndexImport
      parentRoute: typeof StaffSettingsPersonsImport
    }
    '/_staff/software/$id/_$id/': {
      id: '/_staff/software/$id/_$id/'
      path: '/'
      fullPath: '/software/$id/'
      preLoaderRoute: typeof StaffSoftwareIdIdIndexImport
      parentRoute: typeof StaffSoftwareIdIdImport
    }
    '/_staff/software/_layout/library/': {
      id: '/_staff/software/_layout/library/'
      path: '/library'
      fullPath: '/software/library'
      preLoaderRoute: typeof StaffSoftwareLayoutLibraryIndexImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/software/_layout/operation-activity/': {
      id: '/_staff/software/_layout/operation-activity/'
      path: '/operation-activity'
      fullPath: '/software/operation-activity'
      preLoaderRoute: typeof StaffSoftwareLayoutOperationActivityIndexImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/software/_layout/people/': {
      id: '/_staff/software/_layout/people/'
      path: '/'
      fullPath: '/software/people/'
      preLoaderRoute: typeof StaffSoftwareLayoutPeopleIndexImport
      parentRoute: typeof StaffSoftwareLayoutPeopleRouteImport
    }
    '/_staff/software/_layout/registry/': {
      id: '/_staff/software/_layout/registry/'
      path: '/registry'
      fullPath: '/software/registry'
      preLoaderRoute: typeof StaffSoftwareLayoutRegistryIndexImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/software/_layout/rule-and-policy/': {
      id: '/_staff/software/_layout/rule-and-policy/'
      path: '/rule-and-policy'
      fullPath: '/software/rule-and-policy'
      preLoaderRoute: typeof StaffSoftwareLayoutRuleAndPolicyIndexImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/software/_layout/settings/': {
      id: '/_staff/software/_layout/settings/'
      path: '/settings'
      fullPath: '/software/settings'
      preLoaderRoute: typeof StaffSoftwareLayoutSettingsIndexImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/software/add/$type/': {
      id: '/_staff/software/add/$type/'
      path: '/add/$type'
      fullPath: '/software/add/$type'
      preLoaderRoute: typeof StaffSoftwareAddTypeIndexImport
      parentRoute: typeof StaffSoftwareImport
    }
    '/_staff/starlinks/_layout/alerts/': {
      id: '/_staff/starlinks/_layout/alerts/'
      path: '/alerts'
      fullPath: '/starlinks/alerts'
      preLoaderRoute: typeof StaffStarlinksLayoutAlertsIndexImport
      parentRoute: typeof StaffStarlinksLayoutImport
    }
    '/_staff/starlinks/_layout/user-terminals/': {
      id: '/_staff/starlinks/_layout/user-terminals/'
      path: '/user-terminals'
      fullPath: '/starlinks/user-terminals'
      preLoaderRoute: typeof StaffStarlinksLayoutUserTerminalsIndexImport
      parentRoute: typeof StaffStarlinksLayoutImport
    }
    '/_staff/storage-files/_list/files/': {
      id: '/_staff/storage-files/_list/files/'
      path: '/files'
      fullPath: '/storage-files/files'
      preLoaderRoute: typeof StaffStorageFilesListFilesIndexImport
      parentRoute: typeof StaffStorageFilesListImport
    }
    '/_staff/storage-files/_list/folders/': {
      id: '/_staff/storage-files/_list/folders/'
      path: '/folders'
      fullPath: '/storage-files/folders'
      preLoaderRoute: typeof StaffStorageFilesListFoldersIndexImport
      parentRoute: typeof StaffStorageFilesListImport
    }
    '/_staff/storage-files/_list/settings/': {
      id: '/_staff/storage-files/_list/settings/'
      path: '/settings'
      fullPath: '/storage-files/settings'
      preLoaderRoute: typeof StaffStorageFilesListSettingsIndexImport
      parentRoute: typeof StaffStorageFilesListImport
    }
    '/_staff/supplier/_list/settings/': {
      id: '/_staff/supplier/_list/settings/'
      path: '/'
      fullPath: '/supplier/settings/'
      preLoaderRoute: typeof StaffSupplierListSettingsIndexImport
      parentRoute: typeof StaffSupplierListSettingsRouteLazyImport
    }
    '/_staff/time-and-attendance/_layout/attendance-links/': {
      id: '/_staff/time-and-attendance/_layout/attendance-links/'
      path: '/attendance-links'
      fullPath: '/time-and-attendance/attendance-links'
      preLoaderRoute: typeof StaffTimeAndAttendanceLayoutAttendanceLinksIndexImport
      parentRoute: typeof StaffTimeAndAttendanceLayoutImport
    }
    '/_staff/equipment/$id/_layout/': {
      id: '/_staff/equipment/$id/_layout/'
      path: '/'
      fullPath: '/equipment/$id/'
      preLoaderRoute: typeof StaffEquipmentIdLayoutIndexLazyImport
      parentRoute: typeof StaffEquipmentIdLayoutImport
    }
    '/_staff/licenses/$id/_profile/': {
      id: '/_staff/licenses/$id/_profile/'
      path: '/'
      fullPath: '/licenses/$id/'
      preLoaderRoute: typeof StaffLicensesIdProfileIndexLazyImport
      parentRoute: typeof StaffLicensesIdProfileImport
    }
    '/_individual/individual/_profile/my-profile/_layout/': {
      id: '/_individual/individual/_profile/my-profile/_layout/'
      path: '/'
      fullPath: '/individual/my-profile/'
      preLoaderRoute: typeof IndividualIndividualProfileMyProfileLayoutIndexRouteImport
      parentRoute: typeof IndividualIndividualProfileMyProfileLayoutImport
    }
    '/_staff/person/alumni/$id/_profile/': {
      id: '/_staff/person/alumni/$id/_profile/'
      path: '/'
      fullPath: '/person/alumni/$id/'
      preLoaderRoute: typeof StaffPersonAlumniIdProfileIndexRouteImport
      parentRoute: typeof StaffPersonAlumniIdProfileImport
    }
    '/_staff/contract/$id/_layout/_placeholders/approval-info': {
      id: '/_staff/contract/$id/_layout/_placeholders/approval-info'
      path: '/approval-info'
      fullPath: '/contract/$id/approval-info'
      preLoaderRoute: typeof StaffContractIdLayoutPlaceholdersApprovalInfoRouteImport
      parentRoute: typeof StaffContractIdLayoutImport
    }
    '/_staff/contract/$id/_layout/_placeholders/history': {
      id: '/_staff/contract/$id/_layout/_placeholders/history'
      path: '/history'
      fullPath: '/contract/$id/history'
      preLoaderRoute: typeof StaffContractIdLayoutPlaceholdersHistoryRouteImport
      parentRoute: typeof StaffContractIdLayoutImport
    }
    '/_staff/contract/$id/_layout/_placeholders/operation-activity': {
      id: '/_staff/contract/$id/_layout/_placeholders/operation-activity'
      path: '/operation-activity'
      fullPath: '/contract/$id/operation-activity'
      preLoaderRoute: typeof StaffContractIdLayoutPlaceholdersOperationActivityRouteImport
      parentRoute: typeof StaffContractIdLayoutImport
    }
    '/_staff/contract/$id/_layout/_placeholders/risk-provisions': {
      id: '/_staff/contract/$id/_layout/_placeholders/risk-provisions'
      path: '/risk-provisions'
      fullPath: '/contract/$id/risk-provisions'
      preLoaderRoute: typeof StaffContractIdLayoutPlaceholdersRiskProvisionsRouteImport
      parentRoute: typeof StaffContractIdLayoutImport
    }
    '/_staff/contract/$id/_layout/_placeholders/rule-and-policy': {
      id: '/_staff/contract/$id/_layout/_placeholders/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/contract/$id/rule-and-policy'
      preLoaderRoute: typeof StaffContractIdLayoutPlaceholdersRuleAndPolicyRouteImport
      parentRoute: typeof StaffContractIdLayoutImport
    }
    '/_stacktrace/products/$id/scope/$nodeId': {
      id: '/_stacktrace/products/$id/scope/$nodeId'
      path: '/scope/$nodeId'
      fullPath: '/products/$id/scope/$nodeId'
      preLoaderRoute: typeof StacktraceProductsIdScopeNodeIdImport
      parentRoute: typeof StacktraceProductsIdImport
    }
    '/_stacktrace/products/$id/scope/$nodeId/_layout': {
      id: '/_stacktrace/products/$id/scope/$nodeId/_layout'
      path: '/scope/$nodeId'
      fullPath: '/products/$id/scope/$nodeId'
      preLoaderRoute: typeof StacktraceProductsIdScopeNodeIdLayoutImport
      parentRoute: typeof StacktraceProductsIdScopeNodeIdRoute
    }
    '/_stacktrace/test-suites/$id/_layout/test-plan': {
      id: '/_stacktrace/test-suites/$id/_layout/test-plan'
      path: '/test-plan'
      fullPath: '/test-suites/$id/test-plan'
      preLoaderRoute: typeof StacktraceTestSuitesIdLayoutTestPlanImport
      parentRoute: typeof StacktraceTestSuitesIdLayoutImport
    }
    '/_stacktrace/test-suites/$id/_layout/test-plan/_layout': {
      id: '/_stacktrace/test-suites/$id/_layout/test-plan/_layout'
      path: '/test-plan'
      fullPath: '/test-suites/$id/test-plan'
      preLoaderRoute: typeof StacktraceTestSuitesIdLayoutTestPlanLayoutImport
      parentRoute: typeof StacktraceTestSuitesIdLayoutTestPlanRoute
    }
    '/_stacktrace/test-suites/$id/_layout/test-review': {
      id: '/_stacktrace/test-suites/$id/_layout/test-review'
      path: '/test-review'
      fullPath: '/test-suites/$id/test-review'
      preLoaderRoute: typeof StacktraceTestSuitesIdLayoutTestReviewImport
      parentRoute: typeof StacktraceTestSuitesIdLayoutImport
    }
    '/_stacktrace/test-suites/$id/_layout/test-review/_layout': {
      id: '/_stacktrace/test-suites/$id/_layout/test-review/_layout'
      path: '/test-review'
      fullPath: '/test-suites/$id/test-review'
      preLoaderRoute: typeof StacktraceTestSuitesIdLayoutTestReviewLayoutImport
      parentRoute: typeof StacktraceTestSuitesIdLayoutTestReviewRoute
    }
    '/_staff/attendance-engine/_layout/attendance-structures/$structureId': {
      id: '/_staff/attendance-engine/_layout/attendance-structures/$structureId'
      path: '/attendance-structures/$structureId'
      fullPath: '/attendance-engine/attendance-structures/$structureId'
      preLoaderRoute: typeof StaffAttendanceEngineLayoutAttendanceStructuresStructureIdImport
      parentRoute: typeof StaffAttendanceEngineLayoutImport
    }
    '/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout': {
      id: '/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout'
      path: '/attendance-structures/$structureId'
      fullPath: '/attendance-engine/attendance-structures/$structureId'
      preLoaderRoute: typeof StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutImport
      parentRoute: typeof StaffAttendanceEngineLayoutAttendanceStructuresStructureIdRoute
    }
    '/_staff/business-partner/$id/_layout/bp-role-info': {
      id: '/_staff/business-partner/$id/_layout/bp-role-info'
      path: '/bp-role-info'
      fullPath: '/business-partner/$id/bp-role-info'
      preLoaderRoute: typeof StaffBusinessPartnerIdLayoutBpRoleInfoImport
      parentRoute: typeof StaffBusinessPartnerIdLayoutImport
    }
    '/_staff/business-partner/$id/_layout/bp-role-info/_layout': {
      id: '/_staff/business-partner/$id/_layout/bp-role-info/_layout'
      path: '/bp-role-info'
      fullPath: '/business-partner/$id/bp-role-info'
      preLoaderRoute: typeof StaffBusinessPartnerIdLayoutBpRoleInfoLayoutImport
      parentRoute: typeof StaffBusinessPartnerIdLayoutBpRoleInfoRoute
    }
    '/_staff/devices/add/catalog/$deviceType/completed': {
      id: '/_staff/devices/add/catalog/$deviceType/completed'
      path: '/add/catalog/$deviceType/completed'
      fullPath: '/devices/add/catalog/$deviceType/completed'
      preLoaderRoute: typeof StaffDevicesAddCatalogDeviceTypeCompletedImport
      parentRoute: typeof StaffDevicesImport
    }
    '/_staff/ids/group-id/add/from-scratch/completed': {
      id: '/_staff/ids/group-id/add/from-scratch/completed'
      path: '/group-id/add/from-scratch/completed'
      fullPath: '/ids/group-id/add/from-scratch/completed'
      preLoaderRoute: typeof StaffIdsGroupIdAddFromScratchCompletedImport
      parentRoute: typeof StaffIdsImport
    }
    '/_staff/it-operation-core/_detail/operation-instances/$instanceId': {
      id: '/_staff/it-operation-core/_detail/operation-instances/$instanceId'
      path: '/operation-instances/$instanceId'
      fullPath: '/it-operation-core/operation-instances/$instanceId'
      preLoaderRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdImport
      parentRoute: typeof StaffItOperationCoreDetailImport
    }
    '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout': {
      id: '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout'
      path: '/operation-instances/$instanceId'
      fullPath: '/it-operation-core/operation-instances/$instanceId'
      preLoaderRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutImport
      parentRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdRoute
    }
    '/_staff/it-operation-core/_root/in-house-packages/$packageId/start-targets': {
      id: '/_staff/it-operation-core/_root/in-house-packages/$packageId/start-targets'
      path: '/start-targets'
      fullPath: '/it-operation-core/in-house-packages/$packageId/start-targets'
      preLoaderRoute: typeof StaffItOperationCoreRootInHousePackagesPackageIdStartTargetsImport
      parentRoute: typeof StaffItOperationCoreRootInHousePackagesPackageIdImport
    }
    '/_staff/licenses/$id/service-plans/$licenseServiceId': {
      id: '/_staff/licenses/$id/service-plans/$licenseServiceId'
      path: '/service-plans/$licenseServiceId'
      fullPath: '/licenses/$id/service-plans/$licenseServiceId'
      preLoaderRoute: typeof StaffLicensesIdServicePlansLicenseServiceIdImport
      parentRoute: typeof StaffLicensesIdImport
    }
    '/_staff/licenses/$id/service-plans/$licenseServiceId/_detail': {
      id: '/_staff/licenses/$id/service-plans/$licenseServiceId/_detail'
      path: '/service-plans/$licenseServiceId'
      fullPath: '/licenses/$id/service-plans/$licenseServiceId'
      preLoaderRoute: typeof StaffLicensesIdServicePlansLicenseServiceIdDetailImport
      parentRoute: typeof StaffLicensesIdServicePlansLicenseServiceIdRoute
    }
    '/_staff/marketplace/sent-orders/$orderId/_layout/activities': {
      id: '/_staff/marketplace/sent-orders/$orderId/_layout/activities'
      path: '/activities'
      fullPath: '/marketplace/sent-orders/$orderId/activities'
      preLoaderRoute: typeof StaffMarketplaceSentOrdersOrderIdLayoutActivitiesImport
      parentRoute: typeof StaffMarketplaceSentOrdersOrderIdLayoutImport
    }
    '/_staff/payroll-engine/_layout/payroll-structures/$structureId': {
      id: '/_staff/payroll-engine/_layout/payroll-structures/$structureId'
      path: '/payroll-structures/$structureId'
      fullPath: '/payroll-engine/payroll-structures/$structureId'
      preLoaderRoute: typeof StaffPayrollEngineLayoutPayrollStructuresStructureIdImport
      parentRoute: typeof StaffPayrollEngineLayoutImport
    }
    '/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout': {
      id: '/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout'
      path: '/payroll-structures/$structureId'
      fullPath: '/payroll-engine/payroll-structures/$structureId'
      preLoaderRoute: typeof StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutImport
      parentRoute: typeof StaffPayrollEngineLayoutPayrollStructuresStructureIdRoute
    }
    '/_staff/settings/data-connector/inbound/aggregate-data-pipeline': {
      id: '/_staff/settings/data-connector/inbound/aggregate-data-pipeline'
      path: '/settings/data-connector/inbound/aggregate-data-pipeline'
      fullPath: '/settings/data-connector/inbound/aggregate-data-pipeline'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineImport
      parentRoute: typeof StaffImport
    }
    '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/_list': {
      id: '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/_list'
      path: '/settings/data-connector/inbound/aggregate-data-pipeline'
      fullPath: '/settings/data-connector/inbound/aggregate-data-pipeline'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineListImport
      parentRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineRoute
    }
    '/_staff/settings/data-connector/inbound/data-pipeline': {
      id: '/_staff/settings/data-connector/inbound/data-pipeline'
      path: '/settings/data-connector/inbound/data-pipeline'
      fullPath: '/settings/data-connector/inbound/data-pipeline'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundDataPipelineImport
      parentRoute: typeof StaffImport
    }
    '/_staff/settings/data-connector/inbound/data-pipeline/_list': {
      id: '/_staff/settings/data-connector/inbound/data-pipeline/_list'
      path: '/settings/data-connector/inbound/data-pipeline'
      fullPath: '/settings/data-connector/inbound/data-pipeline'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundDataPipelineListImport
      parentRoute: typeof StaffSettingsDataConnectorInboundDataPipelineRoute
    }
    '/_staff/settings/data-connector/outbound/data-pipeline': {
      id: '/_staff/settings/data-connector/outbound/data-pipeline'
      path: '/settings/data-connector/outbound/data-pipeline'
      fullPath: '/settings/data-connector/outbound/data-pipeline'
      preLoaderRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineImport
      parentRoute: typeof StaffImport
    }
    '/_staff/settings/data-connector/outbound/data-pipeline/_list': {
      id: '/_staff/settings/data-connector/outbound/data-pipeline/_list'
      path: '/settings/data-connector/outbound/data-pipeline'
      fullPath: '/settings/data-connector/outbound/data-pipeline'
      preLoaderRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineListImport
      parentRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineRoute
    }
    '/_staff/software/$id/_$id/contract-and-cost': {
      id: '/_staff/software/$id/_$id/contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/software/$id/contract-and-cost'
      preLoaderRoute: typeof StaffSoftwareIdIdContractAndCostImport
      parentRoute: typeof StaffSoftwareIdIdImport
    }
    '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost': {
      id: '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/software/$id/contract-and-cost'
      preLoaderRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostImport
      parentRoute: typeof StaffSoftwareIdIdContractAndCostRoute
    }
    '/_individual/individual/portal/lookup/clocking-record/alerts': {
      id: '/_individual/individual/portal/lookup/clocking-record/alerts'
      path: '/alerts'
      fullPath: '/individual/portal/lookup/clocking-record/alerts'
      preLoaderRoute: typeof IndividualIndividualPortalLookupClockingRecordAlertsLazyImport
      parentRoute: typeof IndividualIndividualPortalLookupClockingRecordRouteImport
    }
    '/_individual/individual/portal/lookup/clocking-record/files': {
      id: '/_individual/individual/portal/lookup/clocking-record/files'
      path: '/files'
      fullPath: '/individual/portal/lookup/clocking-record/files'
      preLoaderRoute: typeof IndividualIndividualPortalLookupClockingRecordFilesLazyImport
      parentRoute: typeof IndividualIndividualPortalLookupClockingRecordRouteImport
    }
    '/_individual/individual/portal/lookup/clocking-record/overview': {
      id: '/_individual/individual/portal/lookup/clocking-record/overview'
      path: '/overview'
      fullPath: '/individual/portal/lookup/clocking-record/overview'
      preLoaderRoute: typeof IndividualIndividualPortalLookupClockingRecordOverviewLazyImport
      parentRoute: typeof IndividualIndividualPortalLookupClockingRecordRouteImport
    }
    '/_individual/individual/portal/lookup/clocking-record/schedule': {
      id: '/_individual/individual/portal/lookup/clocking-record/schedule'
      path: '/schedule'
      fullPath: '/individual/portal/lookup/clocking-record/schedule'
      preLoaderRoute: typeof IndividualIndividualPortalLookupClockingRecordScheduleLazyImport
      parentRoute: typeof IndividualIndividualPortalLookupClockingRecordRouteImport
    }
    '/_individual/individual/portal/lookup/pay-slip/alerts': {
      id: '/_individual/individual/portal/lookup/pay-slip/alerts'
      path: '/alerts'
      fullPath: '/individual/portal/lookup/pay-slip/alerts'
      preLoaderRoute: typeof IndividualIndividualPortalLookupPaySlipAlertsLazyImport
      parentRoute: typeof IndividualIndividualPortalLookupPaySlipRouteImport
    }
    '/_individual/individual/portal/lookup/pay-slip/files': {
      id: '/_individual/individual/portal/lookup/pay-slip/files'
      path: '/files'
      fullPath: '/individual/portal/lookup/pay-slip/files'
      preLoaderRoute: typeof IndividualIndividualPortalLookupPaySlipFilesLazyImport
      parentRoute: typeof IndividualIndividualPortalLookupPaySlipRouteImport
    }
    '/_individual/individual/portal/lookup/pay-slip/history': {
      id: '/_individual/individual/portal/lookup/pay-slip/history'
      path: '/history'
      fullPath: '/individual/portal/lookup/pay-slip/history'
      preLoaderRoute: typeof IndividualIndividualPortalLookupPaySlipHistoryLazyImport
      parentRoute: typeof IndividualIndividualPortalLookupPaySlipRouteImport
    }
    '/_individual/individual/portal/lookup/pay-slip/overview': {
      id: '/_individual/individual/portal/lookup/pay-slip/overview'
      path: '/overview'
      fullPath: '/individual/portal/lookup/pay-slip/overview'
      preLoaderRoute: typeof IndividualIndividualPortalLookupPaySlipOverviewLazyImport
      parentRoute: typeof IndividualIndividualPortalLookupPaySlipRouteImport
    }
    '/_staff/attendances/_layout/clocking-records/$employeeId/alerts': {
      id: '/_staff/attendances/_layout/clocking-records/$employeeId/alerts'
      path: '/alerts'
      fullPath: '/attendances/clocking-records/$employeeId/alerts'
      preLoaderRoute: typeof StaffAttendancesLayoutClockingRecordsEmployeeIdAlertsLazyImport
      parentRoute: typeof StaffAttendancesLayoutClockingRecordsEmployeeIdRouteImport
    }
    '/_staff/attendances/_layout/clocking-records/$employeeId/files': {
      id: '/_staff/attendances/_layout/clocking-records/$employeeId/files'
      path: '/files'
      fullPath: '/attendances/clocking-records/$employeeId/files'
      preLoaderRoute: typeof StaffAttendancesLayoutClockingRecordsEmployeeIdFilesLazyImport
      parentRoute: typeof StaffAttendancesLayoutClockingRecordsEmployeeIdRouteImport
    }
    '/_staff/attendances/_layout/clocking-records/$employeeId/overview': {
      id: '/_staff/attendances/_layout/clocking-records/$employeeId/overview'
      path: '/overview'
      fullPath: '/attendances/clocking-records/$employeeId/overview'
      preLoaderRoute: typeof StaffAttendancesLayoutClockingRecordsEmployeeIdOverviewLazyImport
      parentRoute: typeof StaffAttendancesLayoutClockingRecordsEmployeeIdRouteImport
    }
    '/_staff/attendances/_layout/clocking-records/$employeeId/schedule': {
      id: '/_staff/attendances/_layout/clocking-records/$employeeId/schedule'
      path: '/schedule'
      fullPath: '/attendances/clocking-records/$employeeId/schedule'
      preLoaderRoute: typeof StaffAttendancesLayoutClockingRecordsEmployeeIdScheduleLazyImport
      parentRoute: typeof StaffAttendancesLayoutClockingRecordsEmployeeIdRouteImport
    }
    '/_staff/attendances/_layout/clocking-records/$employeeId/settings': {
      id: '/_staff/attendances/_layout/clocking-records/$employeeId/settings'
      path: '/settings'
      fullPath: '/attendances/clocking-records/$employeeId/settings'
      preLoaderRoute: typeof StaffAttendancesLayoutClockingRecordsEmployeeIdSettingsLazyImport
      parentRoute: typeof StaffAttendancesLayoutClockingRecordsEmployeeIdRouteImport
    }
    '/_staff/payroll/_layout/pay-slips/$employeeId/alerts': {
      id: '/_staff/payroll/_layout/pay-slips/$employeeId/alerts'
      path: '/alerts'
      fullPath: '/payroll/pay-slips/$employeeId/alerts'
      preLoaderRoute: typeof StaffPayrollLayoutPaySlipsEmployeeIdAlertsLazyImport
      parentRoute: typeof StaffPayrollLayoutPaySlipsEmployeeIdRouteImport
    }
    '/_staff/payroll/_layout/pay-slips/$employeeId/files': {
      id: '/_staff/payroll/_layout/pay-slips/$employeeId/files'
      path: '/files'
      fullPath: '/payroll/pay-slips/$employeeId/files'
      preLoaderRoute: typeof StaffPayrollLayoutPaySlipsEmployeeIdFilesLazyImport
      parentRoute: typeof StaffPayrollLayoutPaySlipsEmployeeIdRouteImport
    }
    '/_staff/payroll/_layout/pay-slips/$employeeId/history': {
      id: '/_staff/payroll/_layout/pay-slips/$employeeId/history'
      path: '/history'
      fullPath: '/payroll/pay-slips/$employeeId/history'
      preLoaderRoute: typeof StaffPayrollLayoutPaySlipsEmployeeIdHistoryLazyImport
      parentRoute: typeof StaffPayrollLayoutPaySlipsEmployeeIdRouteImport
    }
    '/_staff/payroll/_layout/pay-slips/$employeeId/overview': {
      id: '/_staff/payroll/_layout/pay-slips/$employeeId/overview'
      path: '/overview'
      fullPath: '/payroll/pay-slips/$employeeId/overview'
      preLoaderRoute: typeof StaffPayrollLayoutPaySlipsEmployeeIdOverviewLazyImport
      parentRoute: typeof StaffPayrollLayoutPaySlipsEmployeeIdRouteImport
    }
    '/_staff/payroll/_layout/pay-slips/$employeeId/settings': {
      id: '/_staff/payroll/_layout/pay-slips/$employeeId/settings'
      path: '/settings'
      fullPath: '/payroll/pay-slips/$employeeId/settings'
      preLoaderRoute: typeof StaffPayrollLayoutPaySlipsEmployeeIdSettingsLazyImport
      parentRoute: typeof StaffPayrollLayoutPaySlipsEmployeeIdRouteImport
    }
    '/_individual/individual/task/$id/approval/': {
      id: '/_individual/individual/task/$id/approval/'
      path: '/task/$id/approval'
      fullPath: '/individual/task/$id/approval'
      preLoaderRoute: typeof IndividualIndividualTaskIdApprovalIndexImport
      parentRoute: typeof IndividualIndividualImport
    }
    '/_stacktrace/development-tickets/$ticketId/_layout/history/': {
      id: '/_stacktrace/development-tickets/$ticketId/_layout/history/'
      path: '/history'
      fullPath: '/development-tickets/$ticketId/history'
      preLoaderRoute: typeof StacktraceDevelopmentTicketsTicketIdLayoutHistoryIndexImport
      parentRoute: typeof StacktraceDevelopmentTicketsTicketIdLayoutImport
    }
    '/_stacktrace/issues/$id/_layout/history/': {
      id: '/_stacktrace/issues/$id/_layout/history/'
      path: '/history'
      fullPath: '/issues/$id/history'
      preLoaderRoute: typeof StacktraceIssuesIdLayoutHistoryIndexImport
      parentRoute: typeof StacktraceIssuesIdLayoutImport
    }
    '/_stacktrace/product-roadmap/$roadmapId/_layout/detail/': {
      id: '/_stacktrace/product-roadmap/$roadmapId/_layout/detail/'
      path: '/detail'
      fullPath: '/product-roadmap/$roadmapId/detail'
      preLoaderRoute: typeof StacktraceProductRoadmapRoadmapIdLayoutDetailIndexImport
      parentRoute: typeof StacktraceProductRoadmapRoadmapIdLayoutImport
    }
    '/_stacktrace/product-roadmap/$roadmapId/_layout/history/': {
      id: '/_stacktrace/product-roadmap/$roadmapId/_layout/history/'
      path: '/history'
      fullPath: '/product-roadmap/$roadmapId/history'
      preLoaderRoute: typeof StacktraceProductRoadmapRoadmapIdLayoutHistoryIndexImport
      parentRoute: typeof StacktraceProductRoadmapRoadmapIdLayoutImport
    }
    '/_stacktrace/production/$productionId/_layout/dev-scope/': {
      id: '/_stacktrace/production/$productionId/_layout/dev-scope/'
      path: '/dev-scope'
      fullPath: '/production/$productionId/dev-scope'
      preLoaderRoute: typeof StacktraceProductionProductionIdLayoutDevScopeIndexImport
      parentRoute: typeof StacktraceProductionProductionIdLayoutImport
    }
    '/_stacktrace/production/$productionId/_layout/issue-scope/': {
      id: '/_stacktrace/production/$productionId/_layout/issue-scope/'
      path: '/issue-scope'
      fullPath: '/production/$productionId/issue-scope'
      preLoaderRoute: typeof StacktraceProductionProductionIdLayoutIssueScopeIndexImport
      parentRoute: typeof StacktraceProductionProductionIdLayoutImport
    }
    '/_stacktrace/production/$productionId/_layout/product-scope/': {
      id: '/_stacktrace/production/$productionId/_layout/product-scope/'
      path: '/product-scope'
      fullPath: '/production/$productionId/product-scope'
      preLoaderRoute: typeof StacktraceProductionProductionIdLayoutProductScopeIndexImport
      parentRoute: typeof StacktraceProductionProductionIdLayoutImport
    }
    '/_stacktrace/production/$productionId/_layout/quality-scope/': {
      id: '/_stacktrace/production/$productionId/_layout/quality-scope/'
      path: '/quality-scope'
      fullPath: '/production/$productionId/quality-scope'
      preLoaderRoute: typeof StacktraceProductionProductionIdLayoutQualityScopeIndexImport
      parentRoute: typeof StacktraceProductionProductionIdLayoutImport
    }
    '/_stacktrace/production/$productionId/_layout/value/': {
      id: '/_stacktrace/production/$productionId/_layout/value/'
      path: '/value'
      fullPath: '/production/$productionId/value'
      preLoaderRoute: typeof StacktraceProductionProductionIdLayoutValueIndexImport
      parentRoute: typeof StacktraceProductionProductionIdLayoutImport
    }
    '/_stacktrace/products/$id/_layout/product-scope/': {
      id: '/_stacktrace/products/$id/_layout/product-scope/'
      path: '/product-scope'
      fullPath: '/products/$id/product-scope'
      preLoaderRoute: typeof StacktraceProductsIdLayoutProductScopeIndexImport
      parentRoute: typeof StacktraceProductsIdLayoutImport
    }
    '/_stacktrace/test-sets/$id/_layout/conditions/': {
      id: '/_stacktrace/test-sets/$id/_layout/conditions/'
      path: '/conditions'
      fullPath: '/test-sets/$id/conditions'
      preLoaderRoute: typeof StacktraceTestSetsIdLayoutConditionsIndexImport
      parentRoute: typeof StacktraceTestSetsIdLayoutImport
    }
    '/_stacktrace/test-sets/$id/_layout/target-functions/': {
      id: '/_stacktrace/test-sets/$id/_layout/target-functions/'
      path: '/target-functions'
      fullPath: '/test-sets/$id/target-functions'
      preLoaderRoute: typeof StacktraceTestSetsIdLayoutTargetFunctionsIndexImport
      parentRoute: typeof StacktraceTestSetsIdLayoutImport
    }
    '/_stacktrace/test-suites/$id/_layout/document/': {
      id: '/_stacktrace/test-suites/$id/_layout/document/'
      path: '/document'
      fullPath: '/test-suites/$id/document'
      preLoaderRoute: typeof StacktraceTestSuitesIdLayoutDocumentIndexImport
      parentRoute: typeof StacktraceTestSuitesIdLayoutImport
    }
    '/_stacktrace/test-suites/$id/_layout/issues/': {
      id: '/_stacktrace/test-suites/$id/_layout/issues/'
      path: '/issues'
      fullPath: '/test-suites/$id/issues'
      preLoaderRoute: typeof StacktraceTestSuitesIdLayoutIssuesIndexImport
      parentRoute: typeof StacktraceTestSuitesIdLayoutImport
    }
    '/_stacktrace/test-suites/$id/_layout/overview/': {
      id: '/_stacktrace/test-suites/$id/_layout/overview/'
      path: '/overview'
      fullPath: '/test-suites/$id/overview'
      preLoaderRoute: typeof StacktraceTestSuitesIdLayoutOverviewIndexImport
      parentRoute: typeof StacktraceTestSuitesIdLayoutImport
    }
    '/_stacktrace/test-suites/$id/_layout/target-functions/': {
      id: '/_stacktrace/test-suites/$id/_layout/target-functions/'
      path: '/target-functions'
      fullPath: '/test-suites/$id/target-functions'
      preLoaderRoute: typeof StacktraceTestSuitesIdLayoutTargetFunctionsIndexImport
      parentRoute: typeof StacktraceTestSuitesIdLayoutImport
    }
    '/_stacktrace/test-suites/$id/_layout/test-set/': {
      id: '/_stacktrace/test-suites/$id/_layout/test-set/'
      path: '/test-set'
      fullPath: '/test-suites/$id/test-set'
      preLoaderRoute: typeof StacktraceTestSuitesIdLayoutTestSetIndexImport
      parentRoute: typeof StacktraceTestSuitesIdLayoutImport
    }
    '/_stacktrace/values/$id/_layout/history/': {
      id: '/_stacktrace/values/$id/_layout/history/'
      path: '/history'
      fullPath: '/values/$id/history'
      preLoaderRoute: typeof StacktraceValuesIdLayoutHistoryIndexImport
      parentRoute: typeof StacktraceValuesIdLayoutImport
    }
    '/_stacktrace/values/$id/_layout/product-scope/': {
      id: '/_stacktrace/values/$id/_layout/product-scope/'
      path: '/product-scope'
      fullPath: '/values/$id/product-scope'
      preLoaderRoute: typeof StacktraceValuesIdLayoutProductScopeIndexImport
      parentRoute: typeof StacktraceValuesIdLayoutImport
    }
    '/_staff/accesses/_layout/list/$traceableAppId/': {
      id: '/_staff/accesses/_layout/list/$traceableAppId/'
      path: '/list/$traceableAppId'
      fullPath: '/accesses/list/$traceableAppId'
      preLoaderRoute: typeof StaffAccessesLayoutListTraceableAppIdIndexImport
      parentRoute: typeof StaffAccessesLayoutImport
    }
    '/_staff/attendance-engine/_layout/attendance-units/$unitId/': {
      id: '/_staff/attendance-engine/_layout/attendance-units/$unitId/'
      path: '/attendance-units/$unitId'
      fullPath: '/attendance-engine/attendance-units/$unitId'
      preLoaderRoute: typeof StaffAttendanceEngineLayoutAttendanceUnitsUnitIdIndexImport
      parentRoute: typeof StaffAttendanceEngineLayoutImport
    }
    '/_staff/attendance-engine/_layout/items/$componentId/': {
      id: '/_staff/attendance-engine/_layout/items/$componentId/'
      path: '/items/$componentId'
      fullPath: '/attendance-engine/items/$componentId'
      preLoaderRoute: typeof StaffAttendanceEngineLayoutItemsComponentIdIndexImport
      parentRoute: typeof StaffAttendanceEngineLayoutImport
    }
    '/_staff/attendance-engine/_layout/logic-components/$componentId/': {
      id: '/_staff/attendance-engine/_layout/logic-components/$componentId/'
      path: '/logic-components/$componentId'
      fullPath: '/attendance-engine/logic-components/$componentId'
      preLoaderRoute: typeof StaffAttendanceEngineLayoutLogicComponentsComponentIdIndexImport
      parentRoute: typeof StaffAttendanceEngineLayoutImport
    }
    '/_staff/business-partner/$id/_layout/_index/': {
      id: '/_staff/business-partner/$id/_layout/_index/'
      path: '/'
      fullPath: '/business-partner/$id/'
      preLoaderRoute: typeof StaffBusinessPartnerIdLayoutIndexIndexImport
      parentRoute: typeof StaffBusinessPartnerIdLayoutImport
    }
    '/_staff/business-partner/$id/_layout/address-and-contact/': {
      id: '/_staff/business-partner/$id/_layout/address-and-contact/'
      path: '/address-and-contact'
      fullPath: '/business-partner/$id/address-and-contact'
      preLoaderRoute: typeof StaffBusinessPartnerIdLayoutAddressAndContactIndexImport
      parentRoute: typeof StaffBusinessPartnerIdLayoutImport
    }
    '/_staff/certification/$id/_layout/_index/': {
      id: '/_staff/certification/$id/_layout/_index/'
      path: '/'
      fullPath: '/certification/$id/'
      preLoaderRoute: typeof StaffCertificationIdLayoutIndexIndexImport
      parentRoute: typeof StaffCertificationIdLayoutImport
    }
    '/_staff/certification/$id/_layout/certification-holders/': {
      id: '/_staff/certification/$id/_layout/certification-holders/'
      path: '/certification-holders'
      fullPath: '/certification/$id/certification-holders'
      preLoaderRoute: typeof StaffCertificationIdLayoutCertificationHoldersIndexImport
      parentRoute: typeof StaffCertificationIdLayoutImport
    }
    '/_staff/certification/$id/_layout/handling-certifications/': {
      id: '/_staff/certification/$id/_layout/handling-certifications/'
      path: '/handling-certifications'
      fullPath: '/certification/$id/handling-certifications'
      preLoaderRoute: typeof StaffCertificationIdLayoutHandlingCertificationsIndexImport
      parentRoute: typeof StaffCertificationIdLayoutImport
    }
    '/_staff/certification/$id/_layout/specialty-certifications/': {
      id: '/_staff/certification/$id/_layout/specialty-certifications/'
      path: '/specialty-certifications'
      fullPath: '/certification/$id/specialty-certifications'
      preLoaderRoute: typeof StaffCertificationIdLayoutSpecialtyCertificationsIndexImport
      parentRoute: typeof StaffCertificationIdLayoutImport
    }
    '/_staff/certification/_list/settings/issuing-organization/': {
      id: '/_staff/certification/_list/settings/issuing-organization/'
      path: '/issuing-organization'
      fullPath: '/certification/settings/issuing-organization'
      preLoaderRoute: typeof StaffCertificationListSettingsIssuingOrganizationIndexImport
      parentRoute: typeof StaffCertificationListSettingsRouteLazyImport
    }
    '/_staff/certification/_list/settings/specialty-category-level/': {
      id: '/_staff/certification/_list/settings/specialty-category-level/'
      path: '/specialty-category-level'
      fullPath: '/certification/settings/specialty-category-level'
      preLoaderRoute: typeof StaffCertificationListSettingsSpecialtyCategoryLevelIndexImport
      parentRoute: typeof StaffCertificationListSettingsRouteLazyImport
    }
    '/_staff/certification/_list/settings/specialty-category/': {
      id: '/_staff/certification/_list/settings/specialty-category/'
      path: '/specialty-category'
      fullPath: '/certification/settings/specialty-category'
      preLoaderRoute: typeof StaffCertificationListSettingsSpecialtyCategoryIndexImport
      parentRoute: typeof StaffCertificationListSettingsRouteLazyImport
    }
    '/_staff/deal/$dealId/_layout/_index/': {
      id: '/_staff/deal/$dealId/_layout/_index/'
      path: '/'
      fullPath: '/deal/$dealId/'
      preLoaderRoute: typeof StaffDealDealIdLayoutIndexIndexImport
      parentRoute: typeof StaffDealDealIdLayoutImport
    }
    '/_staff/devices/$id/_layout/control/': {
      id: '/_staff/devices/$id/_layout/control/'
      path: '/control'
      fullPath: '/devices/$id/control'
      preLoaderRoute: typeof StaffDevicesIdLayoutControlIndexImport
      parentRoute: typeof StaffDevicesIdLayoutImport
    }
    '/_staff/devices/$id/_layout/files/': {
      id: '/_staff/devices/$id/_layout/files/'
      path: '/files'
      fullPath: '/devices/$id/files'
      preLoaderRoute: typeof StaffDevicesIdLayoutFilesIndexImport
      parentRoute: typeof StaffDevicesIdLayoutImport
    }
    '/_staff/devices/$id/_layout/history/': {
      id: '/_staff/devices/$id/_layout/history/'
      path: '/history'
      fullPath: '/devices/$id/history'
      preLoaderRoute: typeof StaffDevicesIdLayoutHistoryIndexImport
      parentRoute: typeof StaffDevicesIdLayoutImport
    }
    '/_staff/devices/$id/_layout/lifecycle/': {
      id: '/_staff/devices/$id/_layout/lifecycle/'
      path: '/lifecycle'
      fullPath: '/devices/$id/lifecycle'
      preLoaderRoute: typeof StaffDevicesIdLayoutLifecycleIndexImport
      parentRoute: typeof StaffDevicesIdLayoutImport
    }
    '/_staff/devices/$id/_layout/mdm/': {
      id: '/_staff/devices/$id/_layout/mdm/'
      path: '/mdm'
      fullPath: '/devices/$id/mdm'
      preLoaderRoute: typeof StaffDevicesIdLayoutMdmIndexImport
      parentRoute: typeof StaffDevicesIdLayoutImport
    }
    '/_staff/devices/$id/_layout/profile/': {
      id: '/_staff/devices/$id/_layout/profile/'
      path: '/profile'
      fullPath: '/devices/$id/profile'
      preLoaderRoute: typeof StaffDevicesIdLayoutProfileIndexImport
      parentRoute: typeof StaffDevicesIdLayoutImport
    }
    '/_staff/devices/$id/_layout/status/': {
      id: '/_staff/devices/$id/_layout/status/'
      path: '/status'
      fullPath: '/devices/$id/status'
      preLoaderRoute: typeof StaffDevicesIdLayoutStatusIndexImport
      parentRoute: typeof StaffDevicesIdLayoutImport
    }
    '/_staff/devices/_list/contract-and-cost/_contract-and-cost/': {
      id: '/_staff/devices/_list/contract-and-cost/_contract-and-cost/'
      path: '/'
      fullPath: '/devices/contract-and-cost/'
      preLoaderRoute: typeof StaffDevicesListContractAndCostContractAndCostIndexImport
      parentRoute: typeof StaffDevicesListContractAndCostContractAndCostImport
    }
    '/_staff/devices/_list/settings/catalog/': {
      id: '/_staff/devices/_list/settings/catalog/'
      path: '/catalog'
      fullPath: '/devices/settings/catalog'
      preLoaderRoute: typeof StaffDevicesListSettingsCatalogIndexImport
      parentRoute: typeof StaffDevicesListSettingsRouteLazyImport
    }
    '/_staff/devices/add/catalog/$deviceType/': {
      id: '/_staff/devices/add/catalog/$deviceType/'
      path: '/add/catalog/$deviceType'
      fullPath: '/devices/add/catalog/$deviceType'
      preLoaderRoute: typeof StaffDevicesAddCatalogDeviceTypeIndexImport
      parentRoute: typeof StaffDevicesImport
    }
    '/_staff/devices/external-it-saas/$appIntegrationId/preview/': {
      id: '/_staff/devices/external-it-saas/$appIntegrationId/preview/'
      path: '/external-it-saas/$appIntegrationId/preview'
      fullPath: '/devices/external-it-saas/$appIntegrationId/preview'
      preLoaderRoute: typeof StaffDevicesExternalItSaasAppIntegrationIdPreviewIndexImport
      parentRoute: typeof StaffDevicesImport
    }
    '/_staff/equipment/_layout/settings/equipment-items/': {
      id: '/_staff/equipment/_layout/settings/equipment-items/'
      path: '/equipment-items'
      fullPath: '/equipment/settings/equipment-items'
      preLoaderRoute: typeof StaffEquipmentLayoutSettingsEquipmentItemsIndexImport
      parentRoute: typeof StaffEquipmentLayoutSettingsRouteLazyImport
    }
    '/_staff/equipment/_layout/settings/equipment-types/': {
      id: '/_staff/equipment/_layout/settings/equipment-types/'
      path: '/equipment-types'
      fullPath: '/equipment/settings/equipment-types'
      preLoaderRoute: typeof StaffEquipmentLayoutSettingsEquipmentTypesIndexImport
      parentRoute: typeof StaffEquipmentLayoutSettingsRouteLazyImport
    }
    '/_staff/equipment/items/$id/_detail/': {
      id: '/_staff/equipment/items/$id/_detail/'
      path: '/'
      fullPath: '/equipment/items/$id/'
      preLoaderRoute: typeof StaffEquipmentItemsIdDetailIndexImport
      parentRoute: typeof StaffEquipmentItemsIdDetailImport
    }
    '/_staff/ids/group-id/$id/_$id/': {
      id: '/_staff/ids/group-id/$id/_$id/'
      path: '/'
      fullPath: '/ids/group-id/$id/'
      preLoaderRoute: typeof StaffIdsGroupIdIdIdIndexImport
      parentRoute: typeof StaffIdsGroupIdIdIdImport
    }
    '/_staff/ids/group-id/add/from-scratch/': {
      id: '/_staff/ids/group-id/add/from-scratch/'
      path: '/group-id/add/from-scratch'
      fullPath: '/ids/group-id/add/from-scratch'
      preLoaderRoute: typeof StaffIdsGroupIdAddFromScratchIndexImport
      parentRoute: typeof StaffIdsImport
    }
    '/_staff/it-operation-core/_detail/operation-instances/$instanceId/': {
      id: '/_staff/it-operation-core/_detail/operation-instances/$instanceId/'
      path: '/'
      fullPath: '/it-operation-core/operation-instances/$instanceId/'
      preLoaderRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdIndexImport
      parentRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdImport
    }
    '/_staff/licenses/$id/_profile/assignments/': {
      id: '/_staff/licenses/$id/_profile/assignments/'
      path: '/assignments'
      fullPath: '/licenses/$id/assignments'
      preLoaderRoute: typeof StaffLicensesIdProfileAssignmentsIndexImport
      parentRoute: typeof StaffLicensesIdProfileImport
    }
    '/_staff/licenses/$id/_profile/people/': {
      id: '/_staff/licenses/$id/_profile/people/'
      path: '/people'
      fullPath: '/licenses/$id/people'
      preLoaderRoute: typeof StaffLicensesIdProfilePeopleIndexImport
      parentRoute: typeof StaffLicensesIdProfileImport
    }
    '/_staff/licenses/$id/_profile/rule-and-policy/': {
      id: '/_staff/licenses/$id/_profile/rule-and-policy/'
      path: '/rule-and-policy'
      fullPath: '/licenses/$id/rule-and-policy'
      preLoaderRoute: typeof StaffLicensesIdProfileRuleAndPolicyIndexImport
      parentRoute: typeof StaffLicensesIdProfileImport
    }
    '/_staff/licenses/$id/_profile/service-plans/': {
      id: '/_staff/licenses/$id/_profile/service-plans/'
      path: '/service-plans'
      fullPath: '/licenses/$id/service-plans'
      preLoaderRoute: typeof StaffLicensesIdProfileServicePlansIndexImport
      parentRoute: typeof StaffLicensesIdProfileImport
    }
    '/_staff/marketplace/_store/store/devices/': {
      id: '/_staff/marketplace/_store/store/devices/'
      path: '/store/devices'
      fullPath: '/marketplace/store/devices'
      preLoaderRoute: typeof StaffMarketplaceStoreStoreDevicesIndexImport
      parentRoute: typeof StaffMarketplaceStoreImport
    }
    '/_staff/marketplace/_store/store/licenses/': {
      id: '/_staff/marketplace/_store/store/licenses/'
      path: '/store/licenses'
      fullPath: '/marketplace/store/licenses'
      preLoaderRoute: typeof StaffMarketplaceStoreStoreLicensesIndexImport
      parentRoute: typeof StaffMarketplaceStoreImport
    }
    '/_staff/marketplace/_store/store/sales-orders/': {
      id: '/_staff/marketplace/_store/store/sales-orders/'
      path: '/store/sales-orders'
      fullPath: '/marketplace/store/sales-orders'
      preLoaderRoute: typeof StaffMarketplaceStoreStoreSalesOrdersIndexImport
      parentRoute: typeof StaffMarketplaceStoreImport
    }
    '/_staff/marketplace/_store/store/sent-orders/': {
      id: '/_staff/marketplace/_store/store/sent-orders/'
      path: '/store/sent-orders'
      fullPath: '/marketplace/store/sent-orders'
      preLoaderRoute: typeof StaffMarketplaceStoreStoreSentOrdersIndexImport
      parentRoute: typeof StaffMarketplaceStoreImport
    }
    '/_staff/marketplace/_store/store/starlinks/': {
      id: '/_staff/marketplace/_store/store/starlinks/'
      path: '/store/starlinks'
      fullPath: '/marketplace/store/starlinks'
      preLoaderRoute: typeof StaffMarketplaceStoreStoreStarlinksIndexImport
      parentRoute: typeof StaffMarketplaceStoreImport
    }
    '/_staff/marketplace/sent-orders/$orderId/_layout/': {
      id: '/_staff/marketplace/sent-orders/$orderId/_layout/'
      path: '/'
      fullPath: '/marketplace/sent-orders/$orderId/'
      preLoaderRoute: typeof StaffMarketplaceSentOrdersOrderIdLayoutIndexImport
      parentRoute: typeof StaffMarketplaceSentOrdersOrderIdLayoutImport
    }
    '/_staff/organization/$id/_layout/history/': {
      id: '/_staff/organization/$id/_layout/history/'
      path: '/history'
      fullPath: '/organization/$id/history'
      preLoaderRoute: typeof StaffOrganizationIdLayoutHistoryIndexImport
      parentRoute: typeof StaffOrganizationIdLayoutImport
    }
    '/_staff/organization/plan/$id/add/': {
      id: '/_staff/organization/plan/$id/add/'
      path: '/plan/$id/add'
      fullPath: '/organization/plan/$id/add'
      preLoaderRoute: typeof StaffOrganizationPlanIdAddIndexImport
      parentRoute: typeof StaffOrganizationImport
    }
    '/_staff/organization/plan/$id/transfers/': {
      id: '/_staff/organization/plan/$id/transfers/'
      path: '/plan/$id/transfers'
      fullPath: '/organization/plan/$id/transfers'
      preLoaderRoute: typeof StaffOrganizationPlanIdTransfersIndexImport
      parentRoute: typeof StaffOrganizationImport
    }
    '/_staff/payroll-engine/_layout/items/$componentId/': {
      id: '/_staff/payroll-engine/_layout/items/$componentId/'
      path: '/items/$componentId'
      fullPath: '/payroll-engine/items/$componentId'
      preLoaderRoute: typeof StaffPayrollEngineLayoutItemsComponentIdIndexImport
      parentRoute: typeof StaffPayrollEngineLayoutImport
    }
    '/_staff/payroll-engine/_layout/logic-components/$componentId/': {
      id: '/_staff/payroll-engine/_layout/logic-components/$componentId/'
      path: '/logic-components/$componentId'
      fullPath: '/payroll-engine/logic-components/$componentId'
      preLoaderRoute: typeof StaffPayrollEngineLayoutLogicComponentsComponentIdIndexImport
      parentRoute: typeof StaffPayrollEngineLayoutImport
    }
    '/_staff/payroll-engine/_layout/payroll-units/$unitId/': {
      id: '/_staff/payroll-engine/_layout/payroll-units/$unitId/'
      path: '/payroll-units/$unitId'
      fullPath: '/payroll-engine/payroll-units/$unitId'
      preLoaderRoute: typeof StaffPayrollEngineLayoutPayrollUnitsUnitIdIndexImport
      parentRoute: typeof StaffPayrollEngineLayoutImport
    }
    '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/': {
      id: '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/'
      path: '/'
      fullPath: '/payroll/contract-and-cost/'
      preLoaderRoute: typeof StaffPayrollLayoutContractAndCostContractAndCostIndexImport
      parentRoute: typeof StaffPayrollLayoutContractAndCostContractAndCostImport
    }
    '/_staff/people/_list/settings/board-member-types/': {
      id: '/_staff/people/_list/settings/board-member-types/'
      path: '/board-member-types'
      fullPath: '/people/settings/board-member-types'
      preLoaderRoute: typeof StaffPeopleListSettingsBoardMemberTypesIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/collaborator-types/': {
      id: '/_staff/people/_list/settings/collaborator-types/'
      path: '/collaborator-types'
      fullPath: '/people/settings/collaborator-types'
      preLoaderRoute: typeof StaffPeopleListSettingsCollaboratorTypesIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/contract-end-reasons/': {
      id: '/_staff/people/_list/settings/contract-end-reasons/'
      path: '/contract-end-reasons'
      fullPath: '/people/settings/contract-end-reasons'
      preLoaderRoute: typeof StaffPeopleListSettingsContractEndReasonsIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/contractor-types/': {
      id: '/_staff/people/_list/settings/contractor-types/'
      path: '/contractor-types'
      fullPath: '/people/settings/contractor-types'
      preLoaderRoute: typeof StaffPeopleListSettingsContractorTypesIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/employee-sub-id-names/': {
      id: '/_staff/people/_list/settings/employee-sub-id-names/'
      path: '/employee-sub-id-names'
      fullPath: '/people/settings/employee-sub-id-names'
      preLoaderRoute: typeof StaffPeopleListSettingsEmployeeSubIdNamesIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/employment-types/': {
      id: '/_staff/people/_list/settings/employment-types/'
      path: '/employment-types'
      fullPath: '/people/settings/employment-types'
      preLoaderRoute: typeof StaffPeopleListSettingsEmploymentTypesIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/grades/': {
      id: '/_staff/people/_list/settings/grades/'
      path: '/grades'
      fullPath: '/people/settings/grades'
      preLoaderRoute: typeof StaffPeopleListSettingsGradesIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/health-insurance-associations/': {
      id: '/_staff/people/_list/settings/health-insurance-associations/'
      path: '/health-insurance-associations'
      fullPath: '/people/settings/health-insurance-associations'
      preLoaderRoute: typeof StaffPeopleListSettingsHealthInsuranceAssociationsIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/job-competencies/': {
      id: '/_staff/people/_list/settings/job-competencies/'
      path: '/job-competencies'
      fullPath: '/people/settings/job-competencies'
      preLoaderRoute: typeof StaffPeopleListSettingsJobCompetenciesIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/job-functions/': {
      id: '/_staff/people/_list/settings/job-functions/'
      path: '/job-functions'
      fullPath: '/people/settings/job-functions'
      preLoaderRoute: typeof StaffPeopleListSettingsJobFunctionsIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/job-grades/': {
      id: '/_staff/people/_list/settings/job-grades/'
      path: '/job-grades'
      fullPath: '/people/settings/job-grades'
      preLoaderRoute: typeof StaffPeopleListSettingsJobGradesIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/job-levels/': {
      id: '/_staff/people/_list/settings/job-levels/'
      path: '/job-levels'
      fullPath: '/people/settings/job-levels'
      preLoaderRoute: typeof StaffPeopleListSettingsJobLevelsIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/job-titles/': {
      id: '/_staff/people/_list/settings/job-titles/'
      path: '/job-titles'
      fullPath: '/people/settings/job-titles'
      preLoaderRoute: typeof StaffPeopleListSettingsJobTitlesIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/job-types/': {
      id: '/_staff/people/_list/settings/job-types/'
      path: '/job-types'
      fullPath: '/people/settings/job-types'
      preLoaderRoute: typeof StaffPeopleListSettingsJobTypesIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/place-social-insurances/': {
      id: '/_staff/people/_list/settings/place-social-insurances/'
      path: '/place-social-insurances'
      fullPath: '/people/settings/place-social-insurances'
      preLoaderRoute: typeof StaffPeopleListSettingsPlaceSocialInsurancesIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/positions/': {
      id: '/_staff/people/_list/settings/positions/'
      path: '/positions'
      fullPath: '/people/settings/positions'
      preLoaderRoute: typeof StaffPeopleListSettingsPositionsIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/retirement-reasons/': {
      id: '/_staff/people/_list/settings/retirement-reasons/'
      path: '/retirement-reasons'
      fullPath: '/people/settings/retirement-reasons'
      preLoaderRoute: typeof StaffPeopleListSettingsRetirementReasonsIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/work-mode/': {
      id: '/_staff/people/_list/settings/work-mode/'
      path: '/work-mode'
      fullPath: '/people/settings/work-mode'
      preLoaderRoute: typeof StaffPeopleListSettingsWorkModeIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/person/$id/_profile/apps/': {
      id: '/_staff/person/$id/_profile/apps/'
      path: '/apps'
      fullPath: '/person/$id/apps'
      preLoaderRoute: typeof StaffPersonIdProfileAppsIndexImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_staff/person/$id/_profile/contractor-information/': {
      id: '/_staff/person/$id/_profile/contractor-information/'
      path: '/contractor-information'
      fullPath: '/person/$id/contractor-information'
      preLoaderRoute: typeof StaffPersonIdProfileContractorInformationIndexImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_staff/person/$id/_profile/devices/': {
      id: '/_staff/person/$id/_profile/devices/'
      path: '/devices'
      fullPath: '/person/$id/devices'
      preLoaderRoute: typeof StaffPersonIdProfileDevicesIndexImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_staff/person/$id/_profile/education-and-qualification/': {
      id: '/_staff/person/$id/_profile/education-and-qualification/'
      path: '/education-and-qualification'
      fullPath: '/person/$id/education-and-qualification'
      preLoaderRoute: typeof StaffPersonIdProfileEducationAndQualificationIndexImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_staff/person/$id/_profile/employee-information/': {
      id: '/_staff/person/$id/_profile/employee-information/'
      path: '/employee-information'
      fullPath: '/person/$id/employee-information'
      preLoaderRoute: typeof StaffPersonIdProfileEmployeeInformationIndexImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_staff/person/$id/_profile/equipment/': {
      id: '/_staff/person/$id/_profile/equipment/'
      path: '/equipment'
      fullPath: '/person/$id/equipment'
      preLoaderRoute: typeof StaffPersonIdProfileEquipmentIndexImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_staff/person/$id/_profile/history/': {
      id: '/_staff/person/$id/_profile/history/'
      path: '/history'
      fullPath: '/person/$id/history'
      preLoaderRoute: typeof StaffPersonIdProfileHistoryIndexImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_staff/person/$id/_profile/operation-activity/': {
      id: '/_staff/person/$id/_profile/operation-activity/'
      path: '/operation-activity'
      fullPath: '/person/$id/operation-activity'
      preLoaderRoute: typeof StaffPersonIdProfileOperationActivityIndexImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_staff/person/$id/_profile/personal-information/': {
      id: '/_staff/person/$id/_profile/personal-information/'
      path: '/personal-information'
      fullPath: '/person/$id/personal-information'
      preLoaderRoute: typeof StaffPersonIdProfilePersonalInformationIndexImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_staff/person/$id/_profile/public-id/': {
      id: '/_staff/person/$id/_profile/public-id/'
      path: '/public-id'
      fullPath: '/person/$id/public-id'
      preLoaderRoute: typeof StaffPersonIdProfilePublicIdIndexImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_staff/person/external-hr-saas/$appIntegrationId/preview/': {
      id: '/_staff/person/external-hr-saas/$appIntegrationId/preview/'
      path: '/person/external-hr-saas/$appIntegrationId/preview'
      fullPath: '/person/external-hr-saas/$appIntegrationId/preview'
      preLoaderRoute: typeof StaffPersonExternalHrSaasAppIntegrationIdPreviewIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/places/$id/_layout/administrators/': {
      id: '/_staff/places/$id/_layout/administrators/'
      path: '/administrators'
      fullPath: '/places/$id/administrators'
      preLoaderRoute: typeof StaffPlacesIdLayoutAdministratorsIndexImport
      parentRoute: typeof StaffPlacesIdLayoutImport
    }
    '/_staff/places/$id/_layout/labor-core/': {
      id: '/_staff/places/$id/_layout/labor-core/'
      path: '/labor-core'
      fullPath: '/places/$id/labor-core'
      preLoaderRoute: typeof StaffPlacesIdLayoutLaborCoreIndexImport
      parentRoute: typeof StaffPlacesIdLayoutImport
    }
    '/_staff/places/_layout/settings/place-sub-codes/': {
      id: '/_staff/places/_layout/settings/place-sub-codes/'
      path: '/place-sub-codes'
      fullPath: '/places/settings/place-sub-codes'
      preLoaderRoute: typeof StaffPlacesLayoutSettingsPlaceSubCodesIndexImport
      parentRoute: typeof StaffPlacesLayoutSettingsRouteImport
    }
    '/_staff/settings/contracting-corporation-profile/_layout/board-member/': {
      id: '/_staff/settings/contracting-corporation-profile/_layout/board-member/'
      path: '/board-member'
      fullPath: '/settings/contracting-corporation-profile/board-member'
      preLoaderRoute: typeof StaffSettingsContractingCorporationProfileLayoutBoardMemberIndexImport
      parentRoute: typeof StaffSettingsContractingCorporationProfileLayoutImport
    }
    '/_staff/settings/contracting-corporation-profile/_layout/contact-points/': {
      id: '/_staff/settings/contracting-corporation-profile/_layout/contact-points/'
      path: '/contact-points'
      fullPath: '/settings/contracting-corporation-profile/contact-points'
      preLoaderRoute: typeof StaffSettingsContractingCorporationProfileLayoutContactPointsIndexImport
      parentRoute: typeof StaffSettingsContractingCorporationProfileLayoutImport
    }
    '/_staff/settings/contracting-corporation-profile/_layout/corporate-overview/': {
      id: '/_staff/settings/contracting-corporation-profile/_layout/corporate-overview/'
      path: '/corporate-overview'
      fullPath: '/settings/contracting-corporation-profile/corporate-overview'
      preLoaderRoute: typeof StaffSettingsContractingCorporationProfileLayoutCorporateOverviewIndexImport
      parentRoute: typeof StaffSettingsContractingCorporationProfileLayoutImport
    }
    '/_staff/settings/contracting-corporation-profile/_layout/group-companies/': {
      id: '/_staff/settings/contracting-corporation-profile/_layout/group-companies/'
      path: '/group-companies'
      fullPath: '/settings/contracting-corporation-profile/group-companies'
      preLoaderRoute: typeof StaffSettingsContractingCorporationProfileLayoutGroupCompaniesIndexImport
      parentRoute: typeof StaffSettingsContractingCorporationProfileLayoutImport
    }
    '/_staff/settings/contracting-corporation-profile/_layout/history/': {
      id: '/_staff/settings/contracting-corporation-profile/_layout/history/'
      path: '/history'
      fullPath: '/settings/contracting-corporation-profile/history'
      preLoaderRoute: typeof StaffSettingsContractingCorporationProfileLayoutHistoryIndexImport
      parentRoute: typeof StaffSettingsContractingCorporationProfileLayoutImport
    }
    '/_staff/settings/contracting-corporation-profile/_layout/registration/': {
      id: '/_staff/settings/contracting-corporation-profile/_layout/registration/'
      path: '/registration'
      fullPath: '/settings/contracting-corporation-profile/registration'
      preLoaderRoute: typeof StaffSettingsContractingCorporationProfileLayoutRegistrationIndexImport
      parentRoute: typeof StaffSettingsContractingCorporationProfileLayoutImport
    }
    '/_staff/settings/contracting-corporation-profile/_layout/shareholders/': {
      id: '/_staff/settings/contracting-corporation-profile/_layout/shareholders/'
      path: '/shareholders'
      fullPath: '/settings/contracting-corporation-profile/shareholders'
      preLoaderRoute: typeof StaffSettingsContractingCorporationProfileLayoutShareholdersIndexImport
      parentRoute: typeof StaffSettingsContractingCorporationProfileLayoutImport
    }
    '/_staff/settings/permission-and-roles/_list/category-permissions/': {
      id: '/_staff/settings/permission-and-roles/_list/category-permissions/'
      path: '/category-permissions'
      fullPath: '/settings/permission-and-roles/category-permissions'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesListCategoryPermissionsIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesListImport
    }
    '/_staff/settings/permission-and-roles/_list/people-groups/': {
      id: '/_staff/settings/permission-and-roles/_list/people-groups/'
      path: '/people-groups'
      fullPath: '/settings/permission-and-roles/people-groups'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesListPeopleGroupsIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesListImport
    }
    '/_staff/settings/permission-and-roles/_list/product-permissions/': {
      id: '/_staff/settings/permission-and-roles/_list/product-permissions/'
      path: '/product-permissions'
      fullPath: '/settings/permission-and-roles/product-permissions'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesListProductPermissionsIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesListImport
    }
    '/_staff/settings/permission-and-roles/_list/roles/': {
      id: '/_staff/settings/permission-and-roles/_list/roles/'
      path: '/roles'
      fullPath: '/settings/permission-and-roles/roles'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesListRolesIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesListImport
    }
    '/_staff/settings/persons/_list/settings/': {
      id: '/_staff/settings/persons/_list/settings/'
      path: '/settings'
      fullPath: '/settings/persons/settings'
      preLoaderRoute: typeof StaffSettingsPersonsListSettingsIndexImport
      parentRoute: typeof StaffSettingsPersonsListImport
    }
    '/_staff/software/$id/_$id/accounts/': {
      id: '/_staff/software/$id/_$id/accounts/'
      path: '/accounts'
      fullPath: '/software/$id/accounts'
      preLoaderRoute: typeof StaffSoftwareIdIdAccountsIndexImport
      parentRoute: typeof StaffSoftwareIdIdImport
    }
    '/_staff/software/$id/_$id/activity-monitoring/': {
      id: '/_staff/software/$id/_$id/activity-monitoring/'
      path: '/activity-monitoring'
      fullPath: '/software/$id/activity-monitoring'
      preLoaderRoute: typeof StaffSoftwareIdIdActivityMonitoringIndexImport
      parentRoute: typeof StaffSoftwareIdIdImport
    }
    '/_staff/software/$id/_$id/alerts/': {
      id: '/_staff/software/$id/_$id/alerts/'
      path: '/alerts'
      fullPath: '/software/$id/alerts'
      preLoaderRoute: typeof StaffSoftwareIdIdAlertsIndexImport
      parentRoute: typeof StaffSoftwareIdIdImport
    }
    '/_staff/software/$id/_$id/architecture/': {
      id: '/_staff/software/$id/_$id/architecture/'
      path: '/architecture'
      fullPath: '/software/$id/architecture'
      preLoaderRoute: typeof StaffSoftwareIdIdArchitectureIndexImport
      parentRoute: typeof StaffSoftwareIdIdImport
    }
    '/_staff/software/$id/_$id/detail/': {
      id: '/_staff/software/$id/_$id/detail/'
      path: '/detail'
      fullPath: '/software/$id/detail'
      preLoaderRoute: typeof StaffSoftwareIdIdDetailIndexImport
      parentRoute: typeof StaffSoftwareIdIdImport
    }
    '/_staff/software/$id/_$id/rule-and-policy/': {
      id: '/_staff/software/$id/_$id/rule-and-policy/'
      path: '/rule-and-policy'
      fullPath: '/software/$id/rule-and-policy'
      preLoaderRoute: typeof StaffSoftwareIdIdRuleAndPolicyIndexImport
      parentRoute: typeof StaffSoftwareIdIdImport
    }
    '/_staff/software/$id/_$id/settings/': {
      id: '/_staff/software/$id/_$id/settings/'
      path: '/'
      fullPath: '/software/$id/settings/'
      preLoaderRoute: typeof StaffSoftwareIdIdSettingsIndexImport
      parentRoute: typeof StaffSoftwareIdIdSettingsRouteLazyImport
    }
    '/_staff/software/_layout/alerts/_alerts/': {
      id: '/_staff/software/_layout/alerts/_alerts/'
      path: '/'
      fullPath: '/software/alerts/'
      preLoaderRoute: typeof StaffSoftwareLayoutAlertsAlertsIndexImport
      parentRoute: typeof StaffSoftwareLayoutAlertsAlertsImport
    }
    '/_staff/software/_layout/contract-and-cost/_contract-and-cost/': {
      id: '/_staff/software/_layout/contract-and-cost/_contract-and-cost/'
      path: '/'
      fullPath: '/software/contract-and-cost/'
      preLoaderRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostIndexImport
      parentRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostImport
    }
    '/_staff/software/_layout/library/search/': {
      id: '/_staff/software/_layout/library/search/'
      path: '/library/search'
      fullPath: '/software/library/search'
      preLoaderRoute: typeof StaffSoftwareLayoutLibrarySearchIndexImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/software/custom-saas/add/$customSaasType/': {
      id: '/_staff/software/custom-saas/add/$customSaasType/'
      path: '/custom-saas/add/$customSaasType'
      fullPath: '/software/custom-saas/add/$customSaasType'
      preLoaderRoute: typeof StaffSoftwareCustomSaasAddCustomSaasTypeIndexImport
      parentRoute: typeof StaffSoftwareImport
    }
    '/_staff/supplier/$supplierId/_layout/_index/': {
      id: '/_staff/supplier/$supplierId/_layout/_index/'
      path: '/'
      fullPath: '/supplier/$supplierId/'
      preLoaderRoute: typeof StaffSupplierSupplierIdLayoutIndexIndexImport
      parentRoute: typeof StaffSupplierSupplierIdLayoutImport
    }
    '/_staff/supplier/_list/settings/procurement-categories/': {
      id: '/_staff/supplier/_list/settings/procurement-categories/'
      path: '/procurement-categories'
      fullPath: '/supplier/settings/procurement-categories'
      preLoaderRoute: typeof StaffSupplierListSettingsProcurementCategoriesIndexImport
      parentRoute: typeof StaffSupplierListSettingsRouteLazyImport
    }
    '/_staff/supplier/_list/settings/supplier-categories/': {
      id: '/_staff/supplier/_list/settings/supplier-categories/'
      path: '/supplier-categories'
      fullPath: '/supplier/settings/supplier-categories'
      preLoaderRoute: typeof StaffSupplierListSettingsSupplierCategoriesIndexImport
      parentRoute: typeof StaffSupplierListSettingsRouteLazyImport
    }
    '/_staff/supplier/_list/settings/supplier-subcategories/': {
      id: '/_staff/supplier/_list/settings/supplier-subcategories/'
      path: '/supplier-subcategories'
      fullPath: '/supplier/settings/supplier-subcategories'
      preLoaderRoute: typeof StaffSupplierListSettingsSupplierSubcategoriesIndexImport
      parentRoute: typeof StaffSupplierListSettingsRouteLazyImport
    }
    '/_staff/time-and-attendance/_layout/_list/summary/': {
      id: '/_staff/time-and-attendance/_layout/_list/summary/'
      path: '/summary'
      fullPath: '/time-and-attendance/summary'
      preLoaderRoute: typeof StaffTimeAndAttendanceLayoutListSummaryIndexImport
      parentRoute: typeof StaffTimeAndAttendanceLayoutImport
    }
    '/_staff/time-and-attendance/_layout/attendance-links/$placeId/': {
      id: '/_staff/time-and-attendance/_layout/attendance-links/$placeId/'
      path: '/attendance-links/$placeId'
      fullPath: '/time-and-attendance/attendance-links/$placeId'
      preLoaderRoute: typeof StaffTimeAndAttendanceLayoutAttendanceLinksPlaceIdIndexImport
      parentRoute: typeof StaffTimeAndAttendanceLayoutImport
    }
    '/_staff/users/$userId/_layout/_identity/': {
      id: '/_staff/users/$userId/_layout/_identity/'
      path: '/'
      fullPath: '/users/$userId/'
      preLoaderRoute: typeof StaffUsersUserIdLayoutIdentityIndexImport
      parentRoute: typeof StaffUsersUserIdLayoutImport
    }
    '/_staff/users/$userId/_layout/sessions/': {
      id: '/_staff/users/$userId/_layout/sessions/'
      path: '/sessions'
      fullPath: '/users/$userId/sessions'
      preLoaderRoute: typeof StaffUsersUserIdLayoutSessionsIndexImport
      parentRoute: typeof StaffUsersUserIdLayoutImport
    }
    '/_individual/individual/portal/lookup/clocking-record/': {
      id: '/_individual/individual/portal/lookup/clocking-record/'
      path: '/'
      fullPath: '/individual/portal/lookup/clocking-record/'
      preLoaderRoute: typeof IndividualIndividualPortalLookupClockingRecordIndexLazyImport
      parentRoute: typeof IndividualIndividualPortalLookupClockingRecordRouteImport
    }
    '/_individual/individual/portal/lookup/pay-slip/': {
      id: '/_individual/individual/portal/lookup/pay-slip/'
      path: '/'
      fullPath: '/individual/portal/lookup/pay-slip/'
      preLoaderRoute: typeof IndividualIndividualPortalLookupPaySlipIndexLazyImport
      parentRoute: typeof IndividualIndividualPortalLookupPaySlipRouteImport
    }
    '/_staff/attendances/_layout/clocking-records/$employeeId/': {
      id: '/_staff/attendances/_layout/clocking-records/$employeeId/'
      path: '/'
      fullPath: '/attendances/clocking-records/$employeeId/'
      preLoaderRoute: typeof StaffAttendancesLayoutClockingRecordsEmployeeIdIndexLazyImport
      parentRoute: typeof StaffAttendancesLayoutClockingRecordsEmployeeIdRouteImport
    }
    '/_staff/contract/$id/_layout/_index/': {
      id: '/_staff/contract/$id/_layout/_index/'
      path: '/'
      fullPath: '/contract/$id/'
      preLoaderRoute: typeof StaffContractIdLayoutIndexIndexLazyImport
      parentRoute: typeof StaffContractIdLayoutImport
    }
    '/_staff/contract/$id/_layout/structure/': {
      id: '/_staff/contract/$id/_layout/structure/'
      path: '/structure'
      fullPath: '/contract/$id/structure'
      preLoaderRoute: typeof StaffContractIdLayoutStructureIndexLazyImport
      parentRoute: typeof StaffContractIdLayoutImport
    }
    '/_staff/equipment/$id/_layout/lifecycle/': {
      id: '/_staff/equipment/$id/_layout/lifecycle/'
      path: '/lifecycle'
      fullPath: '/equipment/$id/lifecycle'
      preLoaderRoute: typeof StaffEquipmentIdLayoutLifecycleIndexLazyImport
      parentRoute: typeof StaffEquipmentIdLayoutImport
    }
    '/_staff/equipment/$id/_layout/status/': {
      id: '/_staff/equipment/$id/_layout/status/'
      path: '/status'
      fullPath: '/equipment/$id/status'
      preLoaderRoute: typeof StaffEquipmentIdLayoutStatusIndexLazyImport
      parentRoute: typeof StaffEquipmentIdLayoutImport
    }
    '/_staff/fleets/$id/_layout/_profile/': {
      id: '/_staff/fleets/$id/_layout/_profile/'
      path: '/'
      fullPath: '/fleets/$id/'
      preLoaderRoute: typeof StaffFleetsIdLayoutProfileIndexLazyImport
      parentRoute: typeof StaffFleetsIdLayoutImport
    }
    '/_staff/networks/$id/_layout/_profile/': {
      id: '/_staff/networks/$id/_layout/_profile/'
      path: '/'
      fullPath: '/networks/$id/'
      preLoaderRoute: typeof StaffNetworksIdLayoutProfileIndexLazyImport
      parentRoute: typeof StaffNetworksIdLayoutImport
    }
    '/_staff/payroll/_layout/pay-slips/$employeeId/': {
      id: '/_staff/payroll/_layout/pay-slips/$employeeId/'
      path: '/'
      fullPath: '/payroll/pay-slips/$employeeId/'
      preLoaderRoute: typeof StaffPayrollLayoutPaySlipsEmployeeIdIndexLazyImport
      parentRoute: typeof StaffPayrollLayoutPaySlipsEmployeeIdRouteImport
    }
    '/_staff/places/$id/_layout/_profile/': {
      id: '/_staff/places/$id/_layout/_profile/'
      path: '/'
      fullPath: '/places/$id/'
      preLoaderRoute: typeof StaffPlacesIdLayoutProfileIndexLazyImport
      parentRoute: typeof StaffPlacesIdLayoutImport
    }
    '/_staff/starlinks/$id/_layout/_overview/': {
      id: '/_staff/starlinks/$id/_layout/_overview/'
      path: '/'
      fullPath: '/starlinks/$id/'
      preLoaderRoute: typeof StaffStarlinksIdLayoutOverviewIndexLazyImport
      parentRoute: typeof StaffStarlinksIdLayoutImport
    }
    '/_staff/starlinks/$id/_layout/detail/': {
      id: '/_staff/starlinks/$id/_layout/detail/'
      path: '/detail'
      fullPath: '/starlinks/$id/detail'
      preLoaderRoute: typeof StaffStarlinksIdLayoutDetailIndexLazyImport
      parentRoute: typeof StaffStarlinksIdLayoutImport
    }
    '/_staff/storage-files/files/$id/_$id/': {
      id: '/_staff/storage-files/files/$id/_$id/'
      path: '/'
      fullPath: '/storage-files/files/$id/'
      preLoaderRoute: typeof StaffStorageFilesFilesIdIdIndexLazyImport
      parentRoute: typeof StaffStorageFilesFilesIdIdImport
    }
    '/_staff/storage-files/folders/$id/_$id/': {
      id: '/_staff/storage-files/folders/$id/_$id/'
      path: '/'
      fullPath: '/storage-files/folders/$id/'
      preLoaderRoute: typeof StaffStorageFilesFoldersIdIdIndexLazyImport
      parentRoute: typeof StaffStorageFilesFoldersIdIdImport
    }
    '/_individual/individual/_profile/certifications/base-certifications/$id': {
      id: '/_individual/individual/_profile/certifications/base-certifications/$id'
      path: '/certifications/base-certifications/$id'
      fullPath: '/individual/certifications/base-certifications/$id'
      preLoaderRoute: typeof IndividualIndividualProfileCertificationsBaseCertificationsIdImport
      parentRoute: typeof IndividualIndividualProfileImport
    }
    '/_individual/individual/_profile/certifications/base-certifications/$id/_layout': {
      id: '/_individual/individual/_profile/certifications/base-certifications/$id/_layout'
      path: '/certifications/base-certifications/$id'
      fullPath: '/individual/certifications/base-certifications/$id'
      preLoaderRoute: typeof IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutImport
      parentRoute: typeof IndividualIndividualProfileCertificationsBaseCertificationsIdRoute
    }
    '/_individual/individual/_profile/certifications/handling-certifications/$id': {
      id: '/_individual/individual/_profile/certifications/handling-certifications/$id'
      path: '/certifications/handling-certifications/$id'
      fullPath: '/individual/certifications/handling-certifications/$id'
      preLoaderRoute: typeof IndividualIndividualProfileCertificationsHandlingCertificationsIdImport
      parentRoute: typeof IndividualIndividualProfileImport
    }
    '/_individual/individual/_profile/certifications/handling-certifications/$id/_layout': {
      id: '/_individual/individual/_profile/certifications/handling-certifications/$id/_layout'
      path: '/certifications/handling-certifications/$id'
      fullPath: '/individual/certifications/handling-certifications/$id'
      preLoaderRoute: typeof IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutImport
      parentRoute: typeof IndividualIndividualProfileCertificationsHandlingCertificationsIdRoute
    }
    '/_individual/individual/_profile/certifications/specialty-certifications/$id': {
      id: '/_individual/individual/_profile/certifications/specialty-certifications/$id'
      path: '/certifications/specialty-certifications/$id'
      fullPath: '/individual/certifications/specialty-certifications/$id'
      preLoaderRoute: typeof IndividualIndividualProfileCertificationsSpecialtyCertificationsIdImport
      parentRoute: typeof IndividualIndividualProfileImport
    }
    '/_individual/individual/_profile/certifications/specialty-certifications/$id/_layout': {
      id: '/_individual/individual/_profile/certifications/specialty-certifications/$id/_layout'
      path: '/certifications/specialty-certifications/$id'
      fullPath: '/individual/certifications/specialty-certifications/$id'
      preLoaderRoute: typeof IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutImport
      parentRoute: typeof IndividualIndividualProfileCertificationsSpecialtyCertificationsIdRoute
    }
    '/_staff/device-catalog/active/$id/_layout/contract-and-cost': {
      id: '/_staff/device-catalog/active/$id/_layout/contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/device-catalog/active/$id/contract-and-cost'
      preLoaderRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostImport
      parentRoute: typeof StaffDeviceCatalogActiveIdLayoutImport
    }
    '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost': {
      id: '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/device-catalog/active/$id/contract-and-cost'
      preLoaderRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostImport
      parentRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostRoute
    }
    '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal': {
      id: '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal'
      path: '/deal'
      fullPath: '/devices/contract-and-cost/deal'
      preLoaderRoute: typeof StaffDevicesListContractAndCostContractAndCostDealImport
      parentRoute: typeof StaffDevicesListContractAndCostContractAndCostImport
    }
    '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal': {
      id: '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal'
      path: '/deal'
      fullPath: '/devices/contract-and-cost/deal'
      preLoaderRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealImport
      parentRoute: typeof StaffDevicesListContractAndCostContractAndCostDealRoute
    }
    '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId': {
      id: '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId'
      path: '/certifications/base-certifications/$personCertificationInformationId'
      fullPath: '/person/$id/certifications/base-certifications/$personCertificationInformationId'
      preLoaderRoute: typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdImport
      parentRoute: typeof StaffPersonIdImport
    }
    '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout': {
      id: '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout'
      path: '/certifications/base-certifications/$personCertificationInformationId'
      fullPath: '/person/$id/certifications/base-certifications/$personCertificationInformationId'
      preLoaderRoute: typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutImport
      parentRoute: typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRoute
    }
    '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId': {
      id: '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId'
      path: '/certifications/handling-certifications/$personCertificationInformationId'
      fullPath: '/person/$id/certifications/handling-certifications/$personCertificationInformationId'
      preLoaderRoute: typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdImport
      parentRoute: typeof StaffPersonIdImport
    }
    '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout': {
      id: '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout'
      path: '/certifications/handling-certifications/$personCertificationInformationId'
      fullPath: '/person/$id/certifications/handling-certifications/$personCertificationInformationId'
      preLoaderRoute: typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutImport
      parentRoute: typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRoute
    }
    '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId': {
      id: '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId'
      path: '/certifications/specialty-certifications/$personCertificationInformationId'
      fullPath: '/person/$id/certifications/specialty-certifications/$personCertificationInformationId'
      preLoaderRoute: typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdImport
      parentRoute: typeof StaffPersonIdImport
    }
    '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout': {
      id: '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout'
      path: '/certifications/specialty-certifications/$personCertificationInformationId'
      fullPath: '/person/$id/certifications/specialty-certifications/$personCertificationInformationId'
      preLoaderRoute: typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutImport
      parentRoute: typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRoute
    }
    '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id': {
      id: '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id'
      path: '/$id'
      fullPath: '/settings/data-connector/inbound/aggregate-data-pipeline/$id'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdImport
      parentRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineImport
    }
    '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail': {
      id: '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail'
      path: '/$id'
      fullPath: '/settings/data-connector/inbound/aggregate-data-pipeline/$id'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailImport
      parentRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdRoute
    }
    '/_staff/settings/data-connector/inbound/data-pipeline/$id': {
      id: '/_staff/settings/data-connector/inbound/data-pipeline/$id'
      path: '/$id'
      fullPath: '/settings/data-connector/inbound/data-pipeline/$id'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdImport
      parentRoute: typeof StaffSettingsDataConnectorInboundDataPipelineImport
    }
    '/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail': {
      id: '/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail'
      path: '/$id'
      fullPath: '/settings/data-connector/inbound/data-pipeline/$id'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailImport
      parentRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdRoute
    }
    '/_staff/settings/data-connector/outbound/data-pipeline/$id': {
      id: '/_staff/settings/data-connector/outbound/data-pipeline/$id'
      path: '/$id'
      fullPath: '/settings/data-connector/outbound/data-pipeline/$id'
      preLoaderRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineIdImport
      parentRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineImport
    }
    '/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail': {
      id: '/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail'
      path: '/$id'
      fullPath: '/settings/data-connector/outbound/data-pipeline/$id'
      preLoaderRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailImport
      parentRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineIdRoute
    }
    '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal': {
      id: '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal'
      path: '/deal'
      fullPath: '/software/contract-and-cost/deal'
      preLoaderRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealImport
      parentRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostImport
    }
    '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal': {
      id: '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal'
      path: '/deal'
      fullPath: '/software/contract-and-cost/deal'
      preLoaderRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealImport
      parentRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealRoute
    }
    '/_individual/individual/_profile/my-profile/_layout/devices/': {
      id: '/_individual/individual/_profile/my-profile/_layout/devices/'
      path: '/devices'
      fullPath: '/individual/my-profile/devices'
      preLoaderRoute: typeof IndividualIndividualProfileMyProfileLayoutDevicesIndexImport
      parentRoute: typeof IndividualIndividualProfileMyProfileLayoutImport
    }
    '/_individual/individual/_profile/my-profile/_layout/education-and-qualification/': {
      id: '/_individual/individual/_profile/my-profile/_layout/education-and-qualification/'
      path: '/education-and-qualification'
      fullPath: '/individual/my-profile/education-and-qualification'
      preLoaderRoute: typeof IndividualIndividualProfileMyProfileLayoutEducationAndQualificationIndexImport
      parentRoute: typeof IndividualIndividualProfileMyProfileLayoutImport
    }
    '/_individual/individual/_profile/my-profile/_layout/softwares/': {
      id: '/_individual/individual/_profile/my-profile/_layout/softwares/'
      path: '/softwares'
      fullPath: '/individual/my-profile/softwares'
      preLoaderRoute: typeof IndividualIndividualProfileMyProfileLayoutSoftwaresIndexImport
      parentRoute: typeof IndividualIndividualProfileMyProfileLayoutImport
    }
    '/_individual/individual/contract/$id/signature-request/$signatureRequestId/': {
      id: '/_individual/individual/contract/$id/signature-request/$signatureRequestId/'
      path: '/contract/$id/signature-request/$signatureRequestId'
      fullPath: '/individual/contract/$id/signature-request/$signatureRequestId'
      preLoaderRoute: typeof IndividualIndividualContractIdSignatureRequestSignatureRequestIdIndexImport
      parentRoute: typeof IndividualIndividualImport
    }
    '/_individual/individual/operation-package/$id/pattern/$patternId/': {
      id: '/_individual/individual/operation-package/$id/pattern/$patternId/'
      path: '/operation-package/$id/pattern/$patternId'
      fullPath: '/individual/operation-package/$id/pattern/$patternId'
      preLoaderRoute: typeof IndividualIndividualOperationPackageIdPatternPatternIdIndexImport
      parentRoute: typeof IndividualIndividualImport
    }
    '/_individual/individual/operation-package/$id/target/$targetId/': {
      id: '/_individual/individual/operation-package/$id/target/$targetId/'
      path: '/operation-package/$id/target/$targetId'
      fullPath: '/individual/operation-package/$id/target/$targetId'
      preLoaderRoute: typeof IndividualIndividualOperationPackageIdTargetTargetIdIndexImport
      parentRoute: typeof IndividualIndividualImport
    }
    '/_stacktrace/production/$productionId/_layout/dev-scope/edit/': {
      id: '/_stacktrace/production/$productionId/_layout/dev-scope/edit/'
      path: '/dev-scope/edit'
      fullPath: '/production/$productionId/dev-scope/edit'
      preLoaderRoute: typeof StacktraceProductionProductionIdLayoutDevScopeEditIndexImport
      parentRoute: typeof StacktraceProductionProductionIdLayoutImport
    }
    '/_stacktrace/production/$productionId/_layout/issue-scope/edit/': {
      id: '/_stacktrace/production/$productionId/_layout/issue-scope/edit/'
      path: '/issue-scope/edit'
      fullPath: '/production/$productionId/issue-scope/edit'
      preLoaderRoute: typeof StacktraceProductionProductionIdLayoutIssueScopeEditIndexImport
      parentRoute: typeof StacktraceProductionProductionIdLayoutImport
    }
    '/_stacktrace/production/$productionId/_layout/value/edit/': {
      id: '/_stacktrace/production/$productionId/_layout/value/edit/'
      path: '/value/edit'
      fullPath: '/production/$productionId/value/edit'
      preLoaderRoute: typeof StacktraceProductionProductionIdLayoutValueEditIndexImport
      parentRoute: typeof StacktraceProductionProductionIdLayoutImport
    }
    '/_stacktrace/products/$id/scope/$nodeId/_layout/': {
      id: '/_stacktrace/products/$id/scope/$nodeId/_layout/'
      path: '/'
      fullPath: '/products/$id/scope/$nodeId/'
      preLoaderRoute: typeof StacktraceProductsIdScopeNodeIdLayoutIndexImport
      parentRoute: typeof StacktraceProductsIdScopeNodeIdLayoutImport
    }
    '/_stacktrace/test-suites/$id/_layout/test-plan/_layout/': {
      id: '/_stacktrace/test-suites/$id/_layout/test-plan/_layout/'
      path: '/'
      fullPath: '/test-suites/$id/test-plan/'
      preLoaderRoute: typeof StacktraceTestSuitesIdLayoutTestPlanLayoutIndexImport
      parentRoute: typeof StacktraceTestSuitesIdLayoutTestPlanLayoutImport
    }
    '/_stacktrace/test-suites/$id/_layout/test-review/_layout/': {
      id: '/_stacktrace/test-suites/$id/_layout/test-review/_layout/'
      path: '/'
      fullPath: '/test-suites/$id/test-review/'
      preLoaderRoute: typeof StacktraceTestSuitesIdLayoutTestReviewLayoutIndexImport
      parentRoute: typeof StacktraceTestSuitesIdLayoutTestReviewLayoutImport
    }
    '/_staff/accesses/_layout/alerts/detail/$shadowItAppId/': {
      id: '/_staff/accesses/_layout/alerts/detail/$shadowItAppId/'
      path: '/alerts/detail/$shadowItAppId'
      fullPath: '/accesses/alerts/detail/$shadowItAppId'
      preLoaderRoute: typeof StaffAccessesLayoutAlertsDetailShadowItAppIdIndexImport
      parentRoute: typeof StaffAccessesLayoutImport
    }
    '/_staff/accesses/_layout/alerts/dormancy/$softwareId/': {
      id: '/_staff/accesses/_layout/alerts/dormancy/$softwareId/'
      path: '/alerts/dormancy/$softwareId'
      fullPath: '/accesses/alerts/dormancy/$softwareId'
      preLoaderRoute: typeof StaffAccessesLayoutAlertsDormancySoftwareIdIndexImport
      parentRoute: typeof StaffAccessesLayoutImport
    }
    '/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout/': {
      id: '/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout/'
      path: '/'
      fullPath: '/attendance-engine/attendance-structures/$structureId/'
      preLoaderRoute: typeof StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutIndexImport
      parentRoute: typeof StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutImport
    }
    '/_staff/business-partner/$id/_layout/bp-role-info/_layout/': {
      id: '/_staff/business-partner/$id/_layout/bp-role-info/_layout/'
      path: '/'
      fullPath: '/business-partner/$id/bp-role-info/'
      preLoaderRoute: typeof StaffBusinessPartnerIdLayoutBpRoleInfoLayoutIndexImport
      parentRoute: typeof StaffBusinessPartnerIdLayoutBpRoleInfoLayoutImport
    }
    '/_staff/certification/handling-certification/$id/_layout/_index/': {
      id: '/_staff/certification/handling-certification/$id/_layout/_index/'
      path: '/'
      fullPath: '/certification/handling-certification/$id/'
      preLoaderRoute: typeof StaffCertificationHandlingCertificationIdLayoutIndexIndexImport
      parentRoute: typeof StaffCertificationHandlingCertificationIdLayoutImport
    }
    '/_staff/certification/handling-certification/$id/_layout/certification-holders/': {
      id: '/_staff/certification/handling-certification/$id/_layout/certification-holders/'
      path: '/certification-holders'
      fullPath: '/certification/handling-certification/$id/certification-holders'
      preLoaderRoute: typeof StaffCertificationHandlingCertificationIdLayoutCertificationHoldersIndexImport
      parentRoute: typeof StaffCertificationHandlingCertificationIdLayoutImport
    }
    '/_staff/certification/specialty-certification/$id/_layout/_index/': {
      id: '/_staff/certification/specialty-certification/$id/_layout/_index/'
      path: '/'
      fullPath: '/certification/specialty-certification/$id/'
      preLoaderRoute: typeof StaffCertificationSpecialtyCertificationIdLayoutIndexIndexImport
      parentRoute: typeof StaffCertificationSpecialtyCertificationIdLayoutImport
    }
    '/_staff/certification/specialty-certification/$id/_layout/certification-holders/': {
      id: '/_staff/certification/specialty-certification/$id/_layout/certification-holders/'
      path: '/certification-holders'
      fullPath: '/certification/specialty-certification/$id/certification-holders'
      preLoaderRoute: typeof StaffCertificationSpecialtyCertificationIdLayoutCertificationHoldersIndexImport
      parentRoute: typeof StaffCertificationSpecialtyCertificationIdLayoutImport
    }
    '/_staff/certification/specialty-certification/$id/_layout/handling-certifications/': {
      id: '/_staff/certification/specialty-certification/$id/_layout/handling-certifications/'
      path: '/handling-certifications'
      fullPath: '/certification/specialty-certification/$id/handling-certifications'
      preLoaderRoute: typeof StaffCertificationSpecialtyCertificationIdLayoutHandlingCertificationsIndexImport
      parentRoute: typeof StaffCertificationSpecialtyCertificationIdLayoutImport
    }
    '/_staff/device-catalog/active/$id/_layout/profile/': {
      id: '/_staff/device-catalog/active/$id/_layout/profile/'
      path: '/profile'
      fullPath: '/device-catalog/active/$id/profile'
      preLoaderRoute: typeof StaffDeviceCatalogActiveIdLayoutProfileIndexImport
      parentRoute: typeof StaffDeviceCatalogActiveIdLayoutImport
    }
    '/_staff/device-catalog/draft/$id/_layout/profile/': {
      id: '/_staff/device-catalog/draft/$id/_layout/profile/'
      path: '/profile'
      fullPath: '/device-catalog/draft/$id/profile'
      preLoaderRoute: typeof StaffDeviceCatalogDraftIdLayoutProfileIndexImport
      parentRoute: typeof StaffDeviceCatalogDraftIdLayoutImport
    }
    '/_staff/devices/_list/contract-and-cost/_contract-and-cost/cost/': {
      id: '/_staff/devices/_list/contract-and-cost/_contract-and-cost/cost/'
      path: '/cost'
      fullPath: '/devices/contract-and-cost/cost'
      preLoaderRoute: typeof StaffDevicesListContractAndCostContractAndCostCostIndexImport
      parentRoute: typeof StaffDevicesListContractAndCostContractAndCostImport
    }
    '/_staff/devices/_list/contract-and-cost/_contract-and-cost/payment/': {
      id: '/_staff/devices/_list/contract-and-cost/_contract-and-cost/payment/'
      path: '/payment'
      fullPath: '/devices/contract-and-cost/payment'
      preLoaderRoute: typeof StaffDevicesListContractAndCostContractAndCostPaymentIndexImport
      parentRoute: typeof StaffDevicesListContractAndCostContractAndCostImport
    }
    '/_staff/equipment/items/$id/_detail/alerts/': {
      id: '/_staff/equipment/items/$id/_detail/alerts/'
      path: '/alerts'
      fullPath: '/equipment/items/$id/alerts'
      preLoaderRoute: typeof StaffEquipmentItemsIdDetailAlertsIndexImport
      parentRoute: typeof StaffEquipmentItemsIdDetailImport
    }
    '/_staff/equipment/items/$id/_detail/inventory/': {
      id: '/_staff/equipment/items/$id/_detail/inventory/'
      path: '/inventory'
      fullPath: '/equipment/items/$id/inventory'
      preLoaderRoute: typeof StaffEquipmentItemsIdDetailInventoryIndexImport
      parentRoute: typeof StaffEquipmentItemsIdDetailImport
    }
    '/_staff/equipment/items/$id/_detail/rule-and-policy/': {
      id: '/_staff/equipment/items/$id/_detail/rule-and-policy/'
      path: '/rule-and-policy'
      fullPath: '/equipment/items/$id/rule-and-policy'
      preLoaderRoute: typeof StaffEquipmentItemsIdDetailRuleAndPolicyIndexImport
      parentRoute: typeof StaffEquipmentItemsIdDetailImport
    }
    '/_staff/ids/group-id/$id/_$id/detail/': {
      id: '/_staff/ids/group-id/$id/_$id/detail/'
      path: '/detail'
      fullPath: '/ids/group-id/$id/detail'
      preLoaderRoute: typeof StaffIdsGroupIdIdIdDetailIndexImport
      parentRoute: typeof StaffIdsGroupIdIdIdImport
    }
    '/_staff/ids/group-id/$id/_$id/devices/': {
      id: '/_staff/ids/group-id/$id/_$id/devices/'
      path: '/devices'
      fullPath: '/ids/group-id/$id/devices'
      preLoaderRoute: typeof StaffIdsGroupIdIdIdDevicesIndexImport
      parentRoute: typeof StaffIdsGroupIdIdIdImport
    }
    '/_staff/ids/group-id/$id/_$id/members/': {
      id: '/_staff/ids/group-id/$id/_$id/members/'
      path: '/members'
      fullPath: '/ids/group-id/$id/members'
      preLoaderRoute: typeof StaffIdsGroupIdIdIdMembersIndexImport
      parentRoute: typeof StaffIdsGroupIdIdIdImport
    }
    '/_staff/ids/group-id/$id/_$id/rule-and-policy/': {
      id: '/_staff/ids/group-id/$id/_$id/rule-and-policy/'
      path: '/rule-and-policy'
      fullPath: '/ids/group-id/$id/rule-and-policy'
      preLoaderRoute: typeof StaffIdsGroupIdIdIdRuleAndPolicyIndexImport
      parentRoute: typeof StaffIdsGroupIdIdIdImport
    }
    '/_staff/ids/group-id/$id/_$id/security-and-auth/': {
      id: '/_staff/ids/group-id/$id/_$id/security-and-auth/'
      path: '/security-and-auth'
      fullPath: '/ids/group-id/$id/security-and-auth'
      preLoaderRoute: typeof StaffIdsGroupIdIdIdSecurityAndAuthIndexImport
      parentRoute: typeof StaffIdsGroupIdIdIdImport
    }
    '/_staff/ids/group-id/$id/_$id/softwares/': {
      id: '/_staff/ids/group-id/$id/_$id/softwares/'
      path: '/softwares'
      fullPath: '/ids/group-id/$id/softwares'
      preLoaderRoute: typeof StaffIdsGroupIdIdIdSoftwaresIndexImport
      parentRoute: typeof StaffIdsGroupIdIdIdImport
    }
    '/_staff/marketplace/_store/store/devices/$productId/': {
      id: '/_staff/marketplace/_store/store/devices/$productId/'
      path: '/store/devices/$productId'
      fullPath: '/marketplace/store/devices/$productId'
      preLoaderRoute: typeof StaffMarketplaceStoreStoreDevicesProductIdIndexImport
      parentRoute: typeof StaffMarketplaceStoreImport
    }
    '/_staff/marketplace/_store/store/licenses/$productId/': {
      id: '/_staff/marketplace/_store/store/licenses/$productId/'
      path: '/store/licenses/$productId'
      fullPath: '/marketplace/store/licenses/$productId'
      preLoaderRoute: typeof StaffMarketplaceStoreStoreLicensesProductIdIndexImport
      parentRoute: typeof StaffMarketplaceStoreImport
    }
    '/_staff/marketplace/_store/store/starlinks/$productId/': {
      id: '/_staff/marketplace/_store/store/starlinks/$productId/'
      path: '/store/starlinks/$productId'
      fullPath: '/marketplace/store/starlinks/$productId'
      preLoaderRoute: typeof StaffMarketplaceStoreStoreStarlinksProductIdIndexImport
      parentRoute: typeof StaffMarketplaceStoreImport
    }
    '/_staff/organization/plan/$id/edit/$unitId/': {
      id: '/_staff/organization/plan/$id/edit/$unitId/'
      path: '/plan/$id/edit/$unitId'
      fullPath: '/organization/plan/$id/edit/$unitId'
      preLoaderRoute: typeof StaffOrganizationPlanIdEditUnitIdIndexImport
      parentRoute: typeof StaffOrganizationImport
    }
    '/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout/': {
      id: '/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout/'
      path: '/'
      fullPath: '/payroll-engine/payroll-structures/$structureId/'
      preLoaderRoute: typeof StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutIndexImport
      parentRoute: typeof StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutImport
    }
    '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/cost/': {
      id: '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/cost/'
      path: '/cost'
      fullPath: '/payroll/contract-and-cost/cost'
      preLoaderRoute: typeof StaffPayrollLayoutContractAndCostContractAndCostCostIndexImport
      parentRoute: typeof StaffPayrollLayoutContractAndCostContractAndCostImport
    }
    '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/deal/': {
      id: '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/deal/'
      path: '/deal'
      fullPath: '/payroll/contract-and-cost/deal'
      preLoaderRoute: typeof StaffPayrollLayoutContractAndCostContractAndCostDealIndexImport
      parentRoute: typeof StaffPayrollLayoutContractAndCostContractAndCostImport
    }
    '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/payment/': {
      id: '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/payment/'
      path: '/payment'
      fullPath: '/payroll/contract-and-cost/payment'
      preLoaderRoute: typeof StaffPayrollLayoutContractAndCostContractAndCostPaymentIndexImport
      parentRoute: typeof StaffPayrollLayoutContractAndCostContractAndCostImport
    }
    '/_staff/person/$id/_profile/family/$familyPersonId/': {
      id: '/_staff/person/$id/_profile/family/$familyPersonId/'
      path: '/family/$familyPersonId'
      fullPath: '/person/$id/family/$familyPersonId'
      preLoaderRoute: typeof StaffPersonIdProfileFamilyFamilyPersonIdIndexImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_staff/person/alumni/$id/_profile/apps/': {
      id: '/_staff/person/alumni/$id/_profile/apps/'
      path: '/apps'
      fullPath: '/person/alumni/$id/apps'
      preLoaderRoute: typeof StaffPersonAlumniIdProfileAppsIndexImport
      parentRoute: typeof StaffPersonAlumniIdProfileImport
    }
    '/_staff/person/alumni/$id/_profile/contractor-information/': {
      id: '/_staff/person/alumni/$id/_profile/contractor-information/'
      path: '/contractor-information'
      fullPath: '/person/alumni/$id/contractor-information'
      preLoaderRoute: typeof StaffPersonAlumniIdProfileContractorInformationIndexImport
      parentRoute: typeof StaffPersonAlumniIdProfileImport
    }
    '/_staff/person/alumni/$id/_profile/devices/': {
      id: '/_staff/person/alumni/$id/_profile/devices/'
      path: '/devices'
      fullPath: '/person/alumni/$id/devices'
      preLoaderRoute: typeof StaffPersonAlumniIdProfileDevicesIndexImport
      parentRoute: typeof StaffPersonAlumniIdProfileImport
    }
    '/_staff/person/alumni/$id/_profile/education-and-qualification/': {
      id: '/_staff/person/alumni/$id/_profile/education-and-qualification/'
      path: '/education-and-qualification'
      fullPath: '/person/alumni/$id/education-and-qualification'
      preLoaderRoute: typeof StaffPersonAlumniIdProfileEducationAndQualificationIndexImport
      parentRoute: typeof StaffPersonAlumniIdProfileImport
    }
    '/_staff/person/alumni/$id/_profile/employee-information/': {
      id: '/_staff/person/alumni/$id/_profile/employee-information/'
      path: '/employee-information'
      fullPath: '/person/alumni/$id/employee-information'
      preLoaderRoute: typeof StaffPersonAlumniIdProfileEmployeeInformationIndexImport
      parentRoute: typeof StaffPersonAlumniIdProfileImport
    }
    '/_staff/person/alumni/$id/_profile/equipment/': {
      id: '/_staff/person/alumni/$id/_profile/equipment/'
      path: '/equipment'
      fullPath: '/person/alumni/$id/equipment'
      preLoaderRoute: typeof StaffPersonAlumniIdProfileEquipmentIndexImport
      parentRoute: typeof StaffPersonAlumniIdProfileImport
    }
    '/_staff/person/alumni/$id/_profile/history/': {
      id: '/_staff/person/alumni/$id/_profile/history/'
      path: '/history'
      fullPath: '/person/alumni/$id/history'
      preLoaderRoute: typeof StaffPersonAlumniIdProfileHistoryIndexImport
      parentRoute: typeof StaffPersonAlumniIdProfileImport
    }
    '/_staff/person/alumni/$id/_profile/operation-activity/': {
      id: '/_staff/person/alumni/$id/_profile/operation-activity/'
      path: '/operation-activity'
      fullPath: '/person/alumni/$id/operation-activity'
      preLoaderRoute: typeof StaffPersonAlumniIdProfileOperationActivityIndexImport
      parentRoute: typeof StaffPersonAlumniIdProfileImport
    }
    '/_staff/person/alumni/$id/_profile/personal-information/': {
      id: '/_staff/person/alumni/$id/_profile/personal-information/'
      path: '/personal-information'
      fullPath: '/person/alumni/$id/personal-information'
      preLoaderRoute: typeof StaffPersonAlumniIdProfilePersonalInformationIndexImport
      parentRoute: typeof StaffPersonAlumniIdProfileImport
    }
    '/_staff/person/alumni/$id/_profile/public-id/': {
      id: '/_staff/person/alumni/$id/_profile/public-id/'
      path: '/public-id'
      fullPath: '/person/alumni/$id/public-id'
      preLoaderRoute: typeof StaffPersonAlumniIdProfilePublicIdIndexImport
      parentRoute: typeof StaffPersonAlumniIdProfileImport
    }
    '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/_list/': {
      id: '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/_list/'
      path: '/'
      fullPath: '/settings/data-connector/inbound/aggregate-data-pipeline/'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineListIndexImport
      parentRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineListImport
    }
    '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/add/': {
      id: '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/add/'
      path: '/add'
      fullPath: '/settings/data-connector/inbound/aggregate-data-pipeline/add'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineAddIndexImport
      parentRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineImport
    }
    '/_staff/settings/data-connector/inbound/data-pipeline/_list/': {
      id: '/_staff/settings/data-connector/inbound/data-pipeline/_list/'
      path: '/'
      fullPath: '/settings/data-connector/inbound/data-pipeline/'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundDataPipelineListIndexImport
      parentRoute: typeof StaffSettingsDataConnectorInboundDataPipelineListImport
    }
    '/_staff/settings/data-connector/inbound/data-pipeline/add/': {
      id: '/_staff/settings/data-connector/inbound/data-pipeline/add/'
      path: '/add'
      fullPath: '/settings/data-connector/inbound/data-pipeline/add'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundDataPipelineAddIndexImport
      parentRoute: typeof StaffSettingsDataConnectorInboundDataPipelineImport
    }
    '/_staff/settings/data-connector/outbound/data-pipeline/_list/': {
      id: '/_staff/settings/data-connector/outbound/data-pipeline/_list/'
      path: '/'
      fullPath: '/settings/data-connector/outbound/data-pipeline/'
      preLoaderRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineListIndexImport
      parentRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineListImport
    }
    '/_staff/settings/data-connector/outbound/data-pipeline/add/': {
      id: '/_staff/settings/data-connector/outbound/data-pipeline/add/'
      path: '/add'
      fullPath: '/settings/data-connector/outbound/data-pipeline/add'
      preLoaderRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineAddIndexImport
      parentRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineImport
    }
    '/_staff/settings/permission-and-roles/_detail/category-permissions/$id/': {
      id: '/_staff/settings/permission-and-roles/_detail/category-permissions/$id/'
      path: '/category-permissions/$id'
      fullPath: '/settings/permission-and-roles/category-permissions/$id'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesDetailCategoryPermissionsIdIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesDetailImport
    }
    '/_staff/settings/permission-and-roles/_detail/people-groups/$id/': {
      id: '/_staff/settings/permission-and-roles/_detail/people-groups/$id/'
      path: '/people-groups/$id'
      fullPath: '/settings/permission-and-roles/people-groups/$id'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesDetailPeopleGroupsIdIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesDetailImport
    }
    '/_staff/settings/permission-and-roles/_detail/product-permissions/$id/': {
      id: '/_staff/settings/permission-and-roles/_detail/product-permissions/$id/'
      path: '/product-permissions/$id'
      fullPath: '/settings/permission-and-roles/product-permissions/$id'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesDetailProductPermissionsIdIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesDetailImport
    }
    '/_staff/settings/permission-and-roles/_detail/roles/$id/': {
      id: '/_staff/settings/permission-and-roles/_detail/roles/$id/'
      path: '/roles/$id'
      fullPath: '/settings/permission-and-roles/roles/$id'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesDetailRolesIdIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesDetailImport
    }
    '/_staff/settings/permission-and-roles/_form/category-permissions/new/': {
      id: '/_staff/settings/permission-and-roles/_form/category-permissions/new/'
      path: '/category-permissions/new'
      fullPath: '/settings/permission-and-roles/category-permissions/new'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesFormCategoryPermissionsNewIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesFormImport
    }
    '/_staff/settings/permission-and-roles/_form/people-groups/new/': {
      id: '/_staff/settings/permission-and-roles/_form/people-groups/new/'
      path: '/people-groups/new'
      fullPath: '/settings/permission-and-roles/people-groups/new'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesFormPeopleGroupsNewIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesFormImport
    }
    '/_staff/settings/permission-and-roles/_form/product-permissions/new/': {
      id: '/_staff/settings/permission-and-roles/_form/product-permissions/new/'
      path: '/product-permissions/new'
      fullPath: '/settings/permission-and-roles/product-permissions/new'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesFormProductPermissionsNewIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesFormImport
    }
    '/_staff/settings/permission-and-roles/_form/roles/new/': {
      id: '/_staff/settings/permission-and-roles/_form/roles/new/'
      path: '/roles/new'
      fullPath: '/settings/permission-and-roles/roles/new'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesFormRolesNewIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesFormImport
    }
    '/_staff/settings/persons/_list/_account/individual/': {
      id: '/_staff/settings/persons/_list/_account/individual/'
      path: '/individual'
      fullPath: '/settings/persons/individual'
      preLoaderRoute: typeof StaffSettingsPersonsListAccountIndividualIndexImport
      parentRoute: typeof StaffSettingsPersonsListAccountImport
    }
    '/_staff/settings/persons/_list/_account/staff/': {
      id: '/_staff/settings/persons/_list/_account/staff/'
      path: '/staff'
      fullPath: '/settings/persons/staff'
      preLoaderRoute: typeof StaffSettingsPersonsListAccountStaffIndexImport
      parentRoute: typeof StaffSettingsPersonsListAccountImport
    }
    '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/': {
      id: '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/'
      path: '/'
      fullPath: '/software/$id/contract-and-cost/'
      preLoaderRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostIndexImport
      parentRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostImport
    }
    '/_staff/software/$id/_$id/settings/integration/': {
      id: '/_staff/software/$id/_$id/settings/integration/'
      path: '/integration'
      fullPath: '/software/$id/settings/integration'
      preLoaderRoute: typeof StaffSoftwareIdIdSettingsIntegrationIndexImport
      parentRoute: typeof StaffSoftwareIdIdSettingsRouteLazyImport
    }
    '/_staff/software/$id/_$id/settings/role/': {
      id: '/_staff/software/$id/_$id/settings/role/'
      path: '/role'
      fullPath: '/software/$id/settings/role'
      preLoaderRoute: typeof StaffSoftwareIdIdSettingsRoleIndexImport
      parentRoute: typeof StaffSoftwareIdIdSettingsRouteLazyImport
    }
    '/_staff/software/$id/_$id/settings/status/': {
      id: '/_staff/software/$id/_$id/settings/status/'
      path: '/status'
      fullPath: '/software/$id/settings/status'
      preLoaderRoute: typeof StaffSoftwareIdIdSettingsStatusIndexImport
      parentRoute: typeof StaffSoftwareIdIdSettingsRouteLazyImport
    }
    '/_staff/software/_layout/alerts/_alerts/alumni/': {
      id: '/_staff/software/_layout/alerts/_alerts/alumni/'
      path: '/alumni'
      fullPath: '/software/alerts/alumni'
      preLoaderRoute: typeof StaffSoftwareLayoutAlertsAlertsAlumniIndexImport
      parentRoute: typeof StaffSoftwareLayoutAlertsAlertsImport
    }
    '/_staff/software/_layout/alerts/_alerts/inactive-user/': {
      id: '/_staff/software/_layout/alerts/_alerts/inactive-user/'
      path: '/inactive-user'
      fullPath: '/software/alerts/inactive-user'
      preLoaderRoute: typeof StaffSoftwareLayoutAlertsAlertsInactiveUserIndexImport
      parentRoute: typeof StaffSoftwareLayoutAlertsAlertsImport
    }
    '/_staff/software/_layout/alerts/_alerts/no-user/': {
      id: '/_staff/software/_layout/alerts/_alerts/no-user/'
      path: '/no-user'
      fullPath: '/software/alerts/no-user'
      preLoaderRoute: typeof StaffSoftwareLayoutAlertsAlertsNoUserIndexImport
      parentRoute: typeof StaffSoftwareLayoutAlertsAlertsImport
    }
    '/_staff/software/_layout/alerts/_alerts/no-worker/': {
      id: '/_staff/software/_layout/alerts/_alerts/no-worker/'
      path: '/no-worker'
      fullPath: '/software/alerts/no-worker'
      preLoaderRoute: typeof StaffSoftwareLayoutAlertsAlertsNoWorkerIndexImport
      parentRoute: typeof StaffSoftwareLayoutAlertsAlertsImport
    }
    '/_staff/software/_layout/alerts/_alerts/violated-assignment/': {
      id: '/_staff/software/_layout/alerts/_alerts/violated-assignment/'
      path: '/violated-assignment'
      fullPath: '/software/alerts/violated-assignment'
      preLoaderRoute: typeof StaffSoftwareLayoutAlertsAlertsViolatedAssignmentIndexImport
      parentRoute: typeof StaffSoftwareLayoutAlertsAlertsImport
    }
    '/_staff/software/_layout/alerts/_alerts/violated-role/': {
      id: '/_staff/software/_layout/alerts/_alerts/violated-role/'
      path: '/violated-role'
      fullPath: '/software/alerts/violated-role'
      preLoaderRoute: typeof StaffSoftwareLayoutAlertsAlertsViolatedRoleIndexImport
      parentRoute: typeof StaffSoftwareLayoutAlertsAlertsImport
    }
    '/_staff/software/_layout/contract-and-cost/_contract-and-cost/cost/': {
      id: '/_staff/software/_layout/contract-and-cost/_contract-and-cost/cost/'
      path: '/cost'
      fullPath: '/software/contract-and-cost/cost'
      preLoaderRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostCostIndexImport
      parentRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostImport
    }
    '/_staff/software/_layout/contract-and-cost/_contract-and-cost/payment/': {
      id: '/_staff/software/_layout/contract-and-cost/_contract-and-cost/payment/'
      path: '/payment'
      fullPath: '/software/contract-and-cost/payment'
      preLoaderRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostPaymentIndexImport
      parentRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostImport
    }
    '/_staff/software/_layout/library/category/$category/': {
      id: '/_staff/software/_layout/library/category/$category/'
      path: '/library/category/$category'
      fullPath: '/software/library/category/$category'
      preLoaderRoute: typeof StaffSoftwareLayoutLibraryCategoryCategoryIndexImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/software/_layout/library/detail/$softwareLibraryId/': {
      id: '/_staff/software/_layout/library/detail/$softwareLibraryId/'
      path: '/library/detail/$softwareLibraryId'
      fullPath: '/software/library/detail/$softwareLibraryId'
      preLoaderRoute: typeof StaffSoftwareLayoutLibraryDetailSoftwareLibraryIdIndexImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/storage-files/folders/$id/_$id/files/': {
      id: '/_staff/storage-files/folders/$id/_$id/files/'
      path: '/files'
      fullPath: '/storage-files/folders/$id/files'
      preLoaderRoute: typeof StaffStorageFilesFoldersIdIdFilesIndexImport
      parentRoute: typeof StaffStorageFilesFoldersIdIdImport
    }
    '/_staff/storage-files/folders/$id/_$id/users/': {
      id: '/_staff/storage-files/folders/$id/_$id/users/'
      path: '/users'
      fullPath: '/storage-files/folders/$id/users'
      preLoaderRoute: typeof StaffStorageFilesFoldersIdIdUsersIndexImport
      parentRoute: typeof StaffStorageFilesFoldersIdIdImport
    }
    '/_staff/time-and-attendance/_layout/_list/summary/daily-place/': {
      id: '/_staff/time-and-attendance/_layout/_list/summary/daily-place/'
      path: '/summary/daily-place'
      fullPath: '/time-and-attendance/summary/daily-place'
      preLoaderRoute: typeof StaffTimeAndAttendanceLayoutListSummaryDailyPlaceIndexImport
      parentRoute: typeof StaffTimeAndAttendanceLayoutImport
    }
    '/_staff/time-and-attendance/_layout/_list/summary/monthly-person/': {
      id: '/_staff/time-and-attendance/_layout/_list/summary/monthly-person/'
      path: '/summary/monthly-person'
      fullPath: '/time-and-attendance/summary/monthly-person'
      preLoaderRoute: typeof StaffTimeAndAttendanceLayoutListSummaryMonthlyPersonIndexImport
      parentRoute: typeof StaffTimeAndAttendanceLayoutImport
    }
    '/_staff/time-and-attendance/_layout/_list/summary/monthly-place/': {
      id: '/_staff/time-and-attendance/_layout/_list/summary/monthly-place/'
      path: '/summary/monthly-place'
      fullPath: '/time-and-attendance/summary/monthly-place'
      preLoaderRoute: typeof StaffTimeAndAttendanceLayoutListSummaryMonthlyPlaceIndexImport
      parentRoute: typeof StaffTimeAndAttendanceLayoutImport
    }
    '/_staff/equipment/items/$id/_detail/profile/': {
      id: '/_staff/equipment/items/$id/_detail/profile/'
      path: '/profile'
      fullPath: '/equipment/items/$id/profile'
      preLoaderRoute: typeof StaffEquipmentItemsIdDetailProfileIndexLazyImport
      parentRoute: typeof StaffEquipmentItemsIdDetailImport
    }
    '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal': {
      id: '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal'
      path: '/deal'
      fullPath: '/software/$id/contract-and-cost/deal'
      preLoaderRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealImport
      parentRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostImport
    }
    '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal': {
      id: '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal'
      path: '/deal'
      fullPath: '/software/$id/contract-and-cost/deal'
      preLoaderRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealImport
      parentRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealRoute
    }
    '/_stacktrace/products/$id/scope/$nodeId/_layout/value/': {
      id: '/_stacktrace/products/$id/scope/$nodeId/_layout/value/'
      path: '/value'
      fullPath: '/products/$id/scope/$nodeId/value'
      preLoaderRoute: typeof StacktraceProductsIdScopeNodeIdLayoutValueIndexImport
      parentRoute: typeof StacktraceProductsIdScopeNodeIdLayoutImport
    }
    '/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout/structure/': {
      id: '/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout/structure/'
      path: '/structure'
      fullPath: '/attendance-engine/attendance-structures/$structureId/structure'
      preLoaderRoute: typeof StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutStructureIndexImport
      parentRoute: typeof StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutImport
    }
    '/_staff/business-partner/$id/_layout/bp-role-info/_layout/$bpRole/': {
      id: '/_staff/business-partner/$id/_layout/bp-role-info/_layout/$bpRole/'
      path: '/$bpRole'
      fullPath: '/business-partner/$id/bp-role-info/$bpRole'
      preLoaderRoute: typeof StaffBusinessPartnerIdLayoutBpRoleInfoLayoutBpRoleIndexImport
      parentRoute: typeof StaffBusinessPartnerIdLayoutBpRoleInfoLayoutImport
    }
    '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/': {
      id: '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/'
      path: '/'
      fullPath: '/device-catalog/active/$id/contract-and-cost/'
      preLoaderRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostIndexImport
      parentRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostImport
    }
    '/_staff/devices/_list/contract-and-cost/_contract-and-cost/cost/$period/': {
      id: '/_staff/devices/_list/contract-and-cost/_contract-and-cost/cost/$period/'
      path: '/cost/$period'
      fullPath: '/devices/contract-and-cost/cost/$period'
      preLoaderRoute: typeof StaffDevicesListContractAndCostContractAndCostCostPeriodIndexImport
      parentRoute: typeof StaffDevicesListContractAndCostContractAndCostImport
    }
    '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/': {
      id: '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/'
      path: '/'
      fullPath: '/devices/contract-and-cost/deal/'
      preLoaderRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealIndexImport
      parentRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealImport
    }
    '/_staff/devices/_list/contract-and-cost/_contract-and-cost/payment/$period/': {
      id: '/_staff/devices/_list/contract-and-cost/_contract-and-cost/payment/$period/'
      path: '/payment/$period'
      fullPath: '/devices/contract-and-cost/payment/$period'
      preLoaderRoute: typeof StaffDevicesListContractAndCostContractAndCostPaymentPeriodIndexImport
      parentRoute: typeof StaffDevicesListContractAndCostContractAndCostImport
    }
    '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/data/': {
      id: '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/data/'
      path: '/data'
      fullPath: '/it-operation-core/operation-instances/$instanceId/data'
      preLoaderRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDataIndexImport
      parentRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutImport
    }
    '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/detail/': {
      id: '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/detail/'
      path: '/detail'
      fullPath: '/it-operation-core/operation-instances/$instanceId/detail'
      preLoaderRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDetailIndexImport
      parentRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutImport
    }
    '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/operation-activity/': {
      id: '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/operation-activity/'
      path: '/operation-activity'
      fullPath: '/it-operation-core/operation-instances/$instanceId/operation-activity'
      preLoaderRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutOperationActivityIndexImport
      parentRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutImport
    }
    '/_staff/licenses/$id/service-plans/$licenseServiceId/_detail/accounts/': {
      id: '/_staff/licenses/$id/service-plans/$licenseServiceId/_detail/accounts/'
      path: '/accounts'
      fullPath: '/licenses/$id/service-plans/$licenseServiceId/accounts'
      preLoaderRoute: typeof StaffLicensesIdServicePlansLicenseServiceIdDetailAccountsIndexImport
      parentRoute: typeof StaffLicensesIdServicePlansLicenseServiceIdDetailImport
    }
    '/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout/structure/': {
      id: '/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout/structure/'
      path: '/structure'
      fullPath: '/payroll-engine/payroll-structures/$structureId/structure'
      preLoaderRoute: typeof StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutStructureIndexImport
      parentRoute: typeof StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutImport
    }
    '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/cost/$period/': {
      id: '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/cost/$period/'
      path: '/cost/$period'
      fullPath: '/payroll/contract-and-cost/cost/$period'
      preLoaderRoute: typeof StaffPayrollLayoutContractAndCostContractAndCostCostPeriodIndexImport
      parentRoute: typeof StaffPayrollLayoutContractAndCostContractAndCostImport
    }
    '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/payment/$period/': {
      id: '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/payment/$period/'
      path: '/payment/$period'
      fullPath: '/payroll/contract-and-cost/payment/$period'
      preLoaderRoute: typeof StaffPayrollLayoutContractAndCostContractAndCostPaymentPeriodIndexImport
      parentRoute: typeof StaffPayrollLayoutContractAndCostContractAndCostImport
    }
    '/_staff/settings/permission-and-roles/_form/category-permissions/$id/edit/': {
      id: '/_staff/settings/permission-and-roles/_form/category-permissions/$id/edit/'
      path: '/category-permissions/$id/edit'
      fullPath: '/settings/permission-and-roles/category-permissions/$id/edit'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesFormCategoryPermissionsIdEditIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesFormImport
    }
    '/_staff/settings/permission-and-roles/_form/people-groups/$id/edit/': {
      id: '/_staff/settings/permission-and-roles/_form/people-groups/$id/edit/'
      path: '/people-groups/$id/edit'
      fullPath: '/settings/permission-and-roles/people-groups/$id/edit'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesFormPeopleGroupsIdEditIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesFormImport
    }
    '/_staff/settings/permission-and-roles/_form/product-permissions/$id/edit/': {
      id: '/_staff/settings/permission-and-roles/_form/product-permissions/$id/edit/'
      path: '/product-permissions/$id/edit'
      fullPath: '/settings/permission-and-roles/product-permissions/$id/edit'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesFormProductPermissionsIdEditIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesFormImport
    }
    '/_staff/settings/permission-and-roles/_form/roles/$id/edit/': {
      id: '/_staff/settings/permission-and-roles/_form/roles/$id/edit/'
      path: '/roles/$id/edit'
      fullPath: '/settings/permission-and-roles/roles/$id/edit'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesFormRolesIdEditIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesFormImport
    }
    '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/cost/': {
      id: '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/cost/'
      path: '/cost'
      fullPath: '/software/$id/contract-and-cost/cost'
      preLoaderRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostCostIndexImport
      parentRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostImport
    }
    '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/payment/': {
      id: '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/payment/'
      path: '/payment'
      fullPath: '/software/$id/contract-and-cost/payment'
      preLoaderRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostPaymentIndexImport
      parentRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostImport
    }
    '/_staff/software/_layout/contract-and-cost/_contract-and-cost/cost/$period/': {
      id: '/_staff/software/_layout/contract-and-cost/_contract-and-cost/cost/$period/'
      path: '/cost/$period'
      fullPath: '/software/contract-and-cost/cost/$period'
      preLoaderRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostCostPeriodIndexImport
      parentRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostImport
    }
    '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/': {
      id: '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/'
      path: '/'
      fullPath: '/software/contract-and-cost/deal/'
      preLoaderRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealIndexImport
      parentRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealImport
    }
    '/_staff/software/_layout/contract-and-cost/_contract-and-cost/payment/$period/': {
      id: '/_staff/software/_layout/contract-and-cost/_contract-and-cost/payment/$period/'
      path: '/payment/$period'
      fullPath: '/software/contract-and-cost/payment/$period'
      preLoaderRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostPaymentPeriodIndexImport
      parentRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostImport
    }
    '/_staff/software/_layout/library/category/$category/search/': {
      id: '/_staff/software/_layout/library/category/$category/search/'
      path: '/library/category/$category/search'
      fullPath: '/software/library/category/$category/search'
      preLoaderRoute: typeof StaffSoftwareLayoutLibraryCategoryCategorySearchIndexImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/software/_layout/marketplace/$id/install/finish/': {
      id: '/_staff/software/_layout/marketplace/$id/install/finish/'
      path: '/install/finish'
      fullPath: '/software/marketplace/$id/install/finish'
      preLoaderRoute: typeof StaffSoftwareLayoutMarketplaceIdInstallFinishIndexImport
      parentRoute: typeof StaffSoftwareLayoutMarketplaceIdRouteImport
    }
    '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': {
      id: '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      path: '/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      fullPath: '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      preLoaderRoute: typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdImport
      parentRoute: typeof StaffContractorCoreImport
    }
    '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile': {
      id: '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile'
      path: '/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      fullPath: '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      preLoaderRoute: typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport
      parentRoute: typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute
    }
    '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal': {
      id: '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal'
      path: '/deal'
      fullPath: '/device-catalog/active/$id/contract-and-cost/deal'
      preLoaderRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealImport
      parentRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostImport
    }
    '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal': {
      id: '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal'
      path: '/deal'
      fullPath: '/device-catalog/active/$id/contract-and-cost/deal'
      preLoaderRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealImport
      parentRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealRoute
    }
    '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': {
      id: '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      path: '/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      fullPath: '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      preLoaderRoute: typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdImport
      parentRoute: typeof StaffGaOperationCoreImport
    }
    '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile': {
      id: '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile'
      path: '/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      fullPath: '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      preLoaderRoute: typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport
      parentRoute: typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute
    }
    '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': {
      id: '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      path: '/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      fullPath: '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      preLoaderRoute: typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdImport
      parentRoute: typeof StaffLaborCoreImport
    }
    '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile': {
      id: '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile'
      path: '/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      fullPath: '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      preLoaderRoute: typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport
      parentRoute: typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute
    }
    '/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId': {
      id: '/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId'
      path: '/execution-results/$taskId'
      fullPath: '/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdImport
      parentRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdImport
    }
    '/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/_task-detail': {
      id: '/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/_task-detail'
      path: '/execution-results/$taskId'
      fullPath: '/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailImport
      parentRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdRoute
    }
    '/_individual/individual/_profile/certifications/base-certifications/$id/_layout/_index/': {
      id: '/_individual/individual/_profile/certifications/base-certifications/$id/_layout/_index/'
      path: '/'
      fullPath: '/individual/certifications/base-certifications/$id/'
      preLoaderRoute: typeof IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutIndexIndexImport
      parentRoute: typeof IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutImport
    }
    '/_individual/individual/_profile/certifications/handling-certifications/$id/_layout/_index/': {
      id: '/_individual/individual/_profile/certifications/handling-certifications/$id/_layout/_index/'
      path: '/'
      fullPath: '/individual/certifications/handling-certifications/$id/'
      preLoaderRoute: typeof IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutIndexIndexImport
      parentRoute: typeof IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutImport
    }
    '/_individual/individual/_profile/certifications/specialty-certifications/$id/_layout/_index/': {
      id: '/_individual/individual/_profile/certifications/specialty-certifications/$id/_layout/_index/'
      path: '/'
      fullPath: '/individual/certifications/specialty-certifications/$id/'
      preLoaderRoute: typeof IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutIndexIndexImport
      parentRoute: typeof IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutImport
    }
    '/_individual/individual/task/$id/_operation-package/_common/form/$formId/': {
      id: '/_individual/individual/task/$id/_operation-package/_common/form/$formId/'
      path: '/task/$id/form/$formId'
      fullPath: '/individual/task/$id/form/$formId'
      preLoaderRoute: typeof IndividualIndividualTaskIdOperationPackageCommonFormFormIdIndexImport
      parentRoute: typeof IndividualIndividualImport
    }
    '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/cost/': {
      id: '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/cost/'
      path: '/cost'
      fullPath: '/device-catalog/active/$id/contract-and-cost/cost'
      preLoaderRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostCostIndexImport
      parentRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostImport
    }
    '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/payment/': {
      id: '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/payment/'
      path: '/payment'
      fullPath: '/device-catalog/active/$id/contract-and-cost/payment'
      preLoaderRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostPaymentIndexImport
      parentRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostImport
    }
    '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/all/': {
      id: '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/all/'
      path: '/all'
      fullPath: '/devices/contract-and-cost/deal/all'
      preLoaderRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealAllIndexImport
      parentRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealImport
    }
    '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/contract/': {
      id: '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/contract/'
      path: '/contract'
      fullPath: '/devices/contract-and-cost/deal/contract'
      preLoaderRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealContractIndexImport
      parentRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealImport
    }
    '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/estimate/': {
      id: '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/estimate/'
      path: '/estimate'
      fullPath: '/devices/contract-and-cost/deal/estimate'
      preLoaderRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealEstimateIndexImport
      parentRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealImport
    }
    '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/order/': {
      id: '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/order/'
      path: '/order'
      fullPath: '/devices/contract-and-cost/deal/order'
      preLoaderRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealOrderIndexImport
      parentRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealImport
    }
    '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/payment/': {
      id: '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/payment/'
      path: '/payment'
      fullPath: '/devices/contract-and-cost/deal/payment'
      preLoaderRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealPaymentIndexImport
      parentRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealImport
    }
    '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/': {
      id: '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/'
      path: '/vendor-invoice'
      fullPath: '/devices/contract-and-cost/deal/vendor-invoice'
      preLoaderRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealVendorInvoiceIndexImport
      parentRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealImport
    }
    '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout/_index/': {
      id: '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout/_index/'
      path: '/'
      fullPath: '/person/$id/certifications/base-certifications/$personCertificationInformationId/'
      preLoaderRoute: typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutIndexIndexImport
      parentRoute: typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutImport
    }
    '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout/_index/': {
      id: '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout/_index/'
      path: '/'
      fullPath: '/person/$id/certifications/handling-certifications/$personCertificationInformationId/'
      preLoaderRoute: typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutIndexIndexImport
      parentRoute: typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutImport
    }
    '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout/_index/': {
      id: '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout/_index/'
      path: '/'
      fullPath: '/person/$id/certifications/specialty-certifications/$personCertificationInformationId/'
      preLoaderRoute: typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutIndexIndexImport
      parentRoute: typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutImport
    }
    '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/basic-info/': {
      id: '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/basic-info/'
      path: '/basic-info'
      fullPath: '/settings/data-connector/inbound/aggregate-data-pipeline/$id/basic-info'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailBasicInfoIndexImport
      parentRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailImport
    }
    '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/execution-plan/': {
      id: '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/execution-plan/'
      path: '/execution-plan'
      fullPath: '/settings/data-connector/inbound/aggregate-data-pipeline/$id/execution-plan'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailExecutionPlanIndexImport
      parentRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailImport
    }
    '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/priority-setting/': {
      id: '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/priority-setting/'
      path: '/priority-setting'
      fullPath: '/settings/data-connector/inbound/aggregate-data-pipeline/$id/priority-setting'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailPrioritySettingIndexImport
      parentRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailImport
    }
    '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/tasks/': {
      id: '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/tasks/'
      path: '/tasks'
      fullPath: '/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailTasksIndexImport
      parentRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailImport
    }
    '/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/basic-settings/': {
      id: '/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/basic-settings/'
      path: '/basic-settings'
      fullPath: '/settings/data-connector/inbound/data-pipeline/$id/basic-settings'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailBasicSettingsIndexImport
      parentRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailImport
    }
    '/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/data-link-settings/': {
      id: '/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/data-link-settings/'
      path: '/data-link-settings'
      fullPath: '/settings/data-connector/inbound/data-pipeline/$id/data-link-settings'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailDataLinkSettingsIndexImport
      parentRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailImport
    }
    '/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/execution-plan/': {
      id: '/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/execution-plan/'
      path: '/execution-plan'
      fullPath: '/settings/data-connector/inbound/data-pipeline/$id/execution-plan'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailExecutionPlanIndexImport
      parentRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailImport
    }
    '/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/execution-results/': {
      id: '/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/execution-results/'
      path: '/execution-results'
      fullPath: '/settings/data-connector/inbound/data-pipeline/$id/execution-results'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailExecutionResultsIndexImport
      parentRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailImport
    }
    '/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/basic-settings/': {
      id: '/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/basic-settings/'
      path: '/basic-settings'
      fullPath: '/settings/data-connector/outbound/data-pipeline/$id/basic-settings'
      preLoaderRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailBasicSettingsIndexImport
      parentRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailImport
    }
    '/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/data-link-settings/': {
      id: '/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/data-link-settings/'
      path: '/data-link-settings'
      fullPath: '/settings/data-connector/outbound/data-pipeline/$id/data-link-settings'
      preLoaderRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailDataLinkSettingsIndexImport
      parentRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailImport
    }
    '/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/execution-plan/': {
      id: '/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/execution-plan/'
      path: '/execution-plan'
      fullPath: '/settings/data-connector/outbound/data-pipeline/$id/execution-plan'
      preLoaderRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailExecutionPlanIndexImport
      parentRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailImport
    }
    '/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/execution-results/': {
      id: '/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/execution-results/'
      path: '/execution-results'
      fullPath: '/settings/data-connector/outbound/data-pipeline/$id/execution-results'
      preLoaderRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailExecutionResultsIndexImport
      parentRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailImport
    }
    '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/cost/$period/': {
      id: '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/cost/$period/'
      path: '/cost/$period'
      fullPath: '/software/$id/contract-and-cost/cost/$period'
      preLoaderRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostCostPeriodIndexImport
      parentRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostImport
    }
    '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/': {
      id: '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/'
      path: '/'
      fullPath: '/software/$id/contract-and-cost/deal/'
      preLoaderRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealIndexImport
      parentRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealImport
    }
    '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/payment/$period/': {
      id: '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/payment/$period/'
      path: '/payment/$period'
      fullPath: '/software/$id/contract-and-cost/payment/$period'
      preLoaderRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostPaymentPeriodIndexImport
      parentRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostImport
    }
    '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/all/': {
      id: '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/all/'
      path: '/all'
      fullPath: '/software/contract-and-cost/deal/all'
      preLoaderRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealAllIndexImport
      parentRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealImport
    }
    '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/contract/': {
      id: '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/contract/'
      path: '/contract'
      fullPath: '/software/contract-and-cost/deal/contract'
      preLoaderRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealContractIndexImport
      parentRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealImport
    }
    '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/estimate/': {
      id: '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/estimate/'
      path: '/estimate'
      fullPath: '/software/contract-and-cost/deal/estimate'
      preLoaderRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealEstimateIndexImport
      parentRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealImport
    }
    '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/order/': {
      id: '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/order/'
      path: '/order'
      fullPath: '/software/contract-and-cost/deal/order'
      preLoaderRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealOrderIndexImport
      parentRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealImport
    }
    '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/payment/': {
      id: '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/payment/'
      path: '/payment'
      fullPath: '/software/contract-and-cost/deal/payment'
      preLoaderRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealPaymentIndexImport
      parentRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealImport
    }
    '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/': {
      id: '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/'
      path: '/vendor-invoice'
      fullPath: '/software/contract-and-cost/deal/vendor-invoice'
      preLoaderRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealVendorInvoiceIndexImport
      parentRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealImport
    }
    '/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId': {
      id: '/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      path: '/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      fullPath: '/attendance-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      preLoaderRoute: typeof StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdImport
      parentRoute: typeof StaffAttendanceCoreLayoutImport
    }
    '/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile': {
      id: '/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile'
      path: '/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      fullPath: '/attendance-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      preLoaderRoute: typeof StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport
      parentRoute: typeof StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute
    }
    '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/': {
      id: '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/'
      path: '/'
      fullPath: '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/'
      preLoaderRoute: typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexImport
      parentRoute: typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport
    }
    '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/cost/$period/': {
      id: '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/cost/$period/'
      path: '/cost/$period'
      fullPath: '/device-catalog/active/$id/contract-and-cost/cost/$period'
      preLoaderRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostCostPeriodIndexImport
      parentRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostImport
    }
    '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/': {
      id: '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/'
      path: '/'
      fullPath: '/device-catalog/active/$id/contract-and-cost/deal/'
      preLoaderRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealIndexImport
      parentRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealImport
    }
    '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/payment/$period/': {
      id: '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/payment/$period/'
      path: '/payment/$period'
      fullPath: '/device-catalog/active/$id/contract-and-cost/payment/$period'
      preLoaderRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostPaymentPeriodIndexImport
      parentRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostImport
    }
    '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/': {
      id: '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/'
      path: '/'
      fullPath: '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/'
      preLoaderRoute: typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexImport
      parentRoute: typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport
    }
    '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/': {
      id: '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/'
      path: '/'
      fullPath: '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/'
      preLoaderRoute: typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexImport
      parentRoute: typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport
    }
    '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/': {
      id: '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/'
      path: '/tasks/$taskId/chunks'
      fullPath: '/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdTasksTaskIdChunksIndexImport
      parentRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdImport
    }
    '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/all/': {
      id: '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/all/'
      path: '/all'
      fullPath: '/software/$id/contract-and-cost/deal/all'
      preLoaderRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealAllIndexImport
      parentRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealImport
    }
    '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/contract/': {
      id: '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/contract/'
      path: '/contract'
      fullPath: '/software/$id/contract-and-cost/deal/contract'
      preLoaderRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealContractIndexImport
      parentRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealImport
    }
    '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/estimate/': {
      id: '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/estimate/'
      path: '/estimate'
      fullPath: '/software/$id/contract-and-cost/deal/estimate'
      preLoaderRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealEstimateIndexImport
      parentRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealImport
    }
    '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/order/': {
      id: '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/order/'
      path: '/order'
      fullPath: '/software/$id/contract-and-cost/deal/order'
      preLoaderRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealOrderIndexImport
      parentRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealImport
    }
    '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/payment/': {
      id: '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/payment/'
      path: '/payment'
      fullPath: '/software/$id/contract-and-cost/deal/payment'
      preLoaderRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealPaymentIndexImport
      parentRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealImport
    }
    '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/': {
      id: '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/'
      path: '/vendor-invoice'
      fullPath: '/software/$id/contract-and-cost/deal/vendor-invoice'
      preLoaderRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealVendorInvoiceIndexImport
      parentRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealImport
    }
    '/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/': {
      id: '/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/'
      path: '/'
      fullPath: '/attendance-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/'
      preLoaderRoute: typeof StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexImport
      parentRoute: typeof StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport
    }
    '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/': {
      id: '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/'
      path: '/data'
      fullPath: '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data'
      preLoaderRoute: typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexImport
      parentRoute: typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport
    }
    '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/all/': {
      id: '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/all/'
      path: '/all'
      fullPath: '/device-catalog/active/$id/contract-and-cost/deal/all'
      preLoaderRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealAllIndexImport
      parentRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealImport
    }
    '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/contract/': {
      id: '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/contract/'
      path: '/contract'
      fullPath: '/device-catalog/active/$id/contract-and-cost/deal/contract'
      preLoaderRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealContractIndexImport
      parentRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealImport
    }
    '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/estimate/': {
      id: '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/estimate/'
      path: '/estimate'
      fullPath: '/device-catalog/active/$id/contract-and-cost/deal/estimate'
      preLoaderRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealEstimateIndexImport
      parentRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealImport
    }
    '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/order/': {
      id: '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/order/'
      path: '/order'
      fullPath: '/device-catalog/active/$id/contract-and-cost/deal/order'
      preLoaderRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealOrderIndexImport
      parentRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealImport
    }
    '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/payment/': {
      id: '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/payment/'
      path: '/payment'
      fullPath: '/device-catalog/active/$id/contract-and-cost/deal/payment'
      preLoaderRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealPaymentIndexImport
      parentRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealImport
    }
    '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/': {
      id: '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/'
      path: '/vendor-invoice'
      fullPath: '/device-catalog/active/$id/contract-and-cost/deal/vendor-invoice'
      preLoaderRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealVendorInvoiceIndexImport
      parentRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealImport
    }
    '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/': {
      id: '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/'
      path: '/data'
      fullPath: '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data'
      preLoaderRoute: typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexImport
      parentRoute: typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport
    }
    '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/': {
      id: '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/'
      path: '/data'
      fullPath: '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data'
      preLoaderRoute: typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexImport
      parentRoute: typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport
    }
    '/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/_task-detail/chunks/': {
      id: '/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/_task-detail/chunks/'
      path: '/chunks'
      fullPath: '/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/chunks'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailChunksIndexImport
      parentRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailImport
    }
    '/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/': {
      id: '/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/'
      path: '/data'
      fullPath: '/attendance-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data'
      preLoaderRoute: typeof StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexImport
      parentRoute: typeof StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport
    }
    '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/$chunkId/result/': {
      id: '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/$chunkId/result/'
      path: '/tasks/$taskId/chunks/$chunkId/result'
      fullPath: '/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/$chunkId/result'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdTasksTaskIdChunksChunkIdResultIndexImport
      parentRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdImport
    }
    '/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/chunks/$chunkId/result/': {
      id: '/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/chunks/$chunkId/result/'
      path: '/chunks/$chunkId/result'
      fullPath: '/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/chunks/$chunkId/result'
      preLoaderRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdChunksChunkIdResultIndexImport
      parentRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdImport
    }
  }
}

// Create and export the route tree

interface ChatRouteChildren {
  ChatChatIndexRoute: typeof ChatChatIndexRoute
  ChatChatSessionIdIndexRoute: typeof ChatChatSessionIdIndexRoute
  ChatChatNewIndexRoute: typeof ChatChatNewIndexRoute
}

const ChatRouteChildren: ChatRouteChildren = {
  ChatChatIndexRoute: ChatChatIndexRoute,
  ChatChatSessionIdIndexRoute: ChatChatSessionIdIndexRoute,
  ChatChatNewIndexRoute: ChatChatNewIndexRoute,
}

const ChatRouteWithChildren = ChatRoute._addFileChildren(ChatRouteChildren)

interface CockpitMockRouteChildren {
  CockpitMockCockpitMockIndexRoute: typeof CockpitMockCockpitMockIndexRoute
}

const CockpitMockRouteChildren: CockpitMockRouteChildren = {
  CockpitMockCockpitMockIndexRoute: CockpitMockCockpitMockIndexRoute,
}

const CockpitMockRouteWithChildren = CockpitMockRoute._addFileChildren(
  CockpitMockRouteChildren,
)

interface IdpSsoMockRouteChildren {
  IdpSsoMockIdpSsoGoogleWorkspaceIndexRoute: typeof IdpSsoMockIdpSsoGoogleWorkspaceIndexRoute
}

const IdpSsoMockRouteChildren: IdpSsoMockRouteChildren = {
  IdpSsoMockIdpSsoGoogleWorkspaceIndexRoute:
    IdpSsoMockIdpSsoGoogleWorkspaceIndexRoute,
}

const IdpSsoMockRouteWithChildren = IdpSsoMockRoute._addFileChildren(
  IdpSsoMockRouteChildren,
)

interface IndividualIndividualProfileMyProfileLayoutRouteChildren {
  IndividualIndividualProfileMyProfileLayoutIndexRouteRoute: typeof IndividualIndividualProfileMyProfileLayoutIndexRouteRoute
  IndividualIndividualProfileMyProfileLayoutDevicesIndexRoute: typeof IndividualIndividualProfileMyProfileLayoutDevicesIndexRoute
  IndividualIndividualProfileMyProfileLayoutEducationAndQualificationIndexRoute: typeof IndividualIndividualProfileMyProfileLayoutEducationAndQualificationIndexRoute
  IndividualIndividualProfileMyProfileLayoutSoftwaresIndexRoute: typeof IndividualIndividualProfileMyProfileLayoutSoftwaresIndexRoute
}

const IndividualIndividualProfileMyProfileLayoutRouteChildren: IndividualIndividualProfileMyProfileLayoutRouteChildren =
  {
    IndividualIndividualProfileMyProfileLayoutIndexRouteRoute:
      IndividualIndividualProfileMyProfileLayoutIndexRouteRoute,
    IndividualIndividualProfileMyProfileLayoutDevicesIndexRoute:
      IndividualIndividualProfileMyProfileLayoutDevicesIndexRoute,
    IndividualIndividualProfileMyProfileLayoutEducationAndQualificationIndexRoute:
      IndividualIndividualProfileMyProfileLayoutEducationAndQualificationIndexRoute,
    IndividualIndividualProfileMyProfileLayoutSoftwaresIndexRoute:
      IndividualIndividualProfileMyProfileLayoutSoftwaresIndexRoute,
  }

const IndividualIndividualProfileMyProfileLayoutRouteWithChildren =
  IndividualIndividualProfileMyProfileLayoutRoute._addFileChildren(
    IndividualIndividualProfileMyProfileLayoutRouteChildren,
  )

interface IndividualIndividualProfileMyProfileRouteChildren {
  IndividualIndividualProfileMyProfileLayoutRoute: typeof IndividualIndividualProfileMyProfileLayoutRouteWithChildren
}

const IndividualIndividualProfileMyProfileRouteChildren: IndividualIndividualProfileMyProfileRouteChildren =
  {
    IndividualIndividualProfileMyProfileLayoutRoute:
      IndividualIndividualProfileMyProfileLayoutRouteWithChildren,
  }

const IndividualIndividualProfileMyProfileRouteWithChildren =
  IndividualIndividualProfileMyProfileRoute._addFileChildren(
    IndividualIndividualProfileMyProfileRouteChildren,
  )

interface IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutRouteChildren {
  IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutIndexIndexRoute: typeof IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutIndexIndexRoute
}

const IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutRouteChildren: IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutRouteChildren =
  {
    IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutIndexIndexRoute:
      IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutIndexIndexRoute,
  }

const IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutRouteWithChildren =
  IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutRoute._addFileChildren(
    IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutRouteChildren,
  )

interface IndividualIndividualProfileCertificationsBaseCertificationsIdRouteChildren {
  IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutRoute: typeof IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutRouteWithChildren
}

const IndividualIndividualProfileCertificationsBaseCertificationsIdRouteChildren: IndividualIndividualProfileCertificationsBaseCertificationsIdRouteChildren =
  {
    IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutRoute:
      IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutRouteWithChildren,
  }

const IndividualIndividualProfileCertificationsBaseCertificationsIdRouteWithChildren =
  IndividualIndividualProfileCertificationsBaseCertificationsIdRoute._addFileChildren(
    IndividualIndividualProfileCertificationsBaseCertificationsIdRouteChildren,
  )

interface IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutRouteChildren {
  IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutIndexIndexRoute: typeof IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutIndexIndexRoute
}

const IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutRouteChildren: IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutRouteChildren =
  {
    IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutIndexIndexRoute:
      IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutIndexIndexRoute,
  }

const IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutRouteWithChildren =
  IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutRoute._addFileChildren(
    IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutRouteChildren,
  )

interface IndividualIndividualProfileCertificationsHandlingCertificationsIdRouteChildren {
  IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutRoute: typeof IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutRouteWithChildren
}

const IndividualIndividualProfileCertificationsHandlingCertificationsIdRouteChildren: IndividualIndividualProfileCertificationsHandlingCertificationsIdRouteChildren =
  {
    IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutRoute:
      IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutRouteWithChildren,
  }

const IndividualIndividualProfileCertificationsHandlingCertificationsIdRouteWithChildren =
  IndividualIndividualProfileCertificationsHandlingCertificationsIdRoute._addFileChildren(
    IndividualIndividualProfileCertificationsHandlingCertificationsIdRouteChildren,
  )

interface IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutRouteChildren {
  IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutIndexIndexRoute: typeof IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutIndexIndexRoute
}

const IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutRouteChildren: IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutRouteChildren =
  {
    IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutIndexIndexRoute:
      IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutIndexIndexRoute,
  }

const IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutRouteWithChildren =
  IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutRoute._addFileChildren(
    IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutRouteChildren,
  )

interface IndividualIndividualProfileCertificationsSpecialtyCertificationsIdRouteChildren {
  IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutRoute: typeof IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutRouteWithChildren
}

const IndividualIndividualProfileCertificationsSpecialtyCertificationsIdRouteChildren: IndividualIndividualProfileCertificationsSpecialtyCertificationsIdRouteChildren =
  {
    IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutRoute:
      IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutRouteWithChildren,
  }

const IndividualIndividualProfileCertificationsSpecialtyCertificationsIdRouteWithChildren =
  IndividualIndividualProfileCertificationsSpecialtyCertificationsIdRoute._addFileChildren(
    IndividualIndividualProfileCertificationsSpecialtyCertificationsIdRouteChildren,
  )

interface IndividualIndividualProfileRouteChildren {
  IndividualIndividualProfileMyProfileRoute: typeof IndividualIndividualProfileMyProfileRouteWithChildren
  IndividualIndividualProfileCertificationsBaseCertificationsIdRoute: typeof IndividualIndividualProfileCertificationsBaseCertificationsIdRouteWithChildren
  IndividualIndividualProfileCertificationsHandlingCertificationsIdRoute: typeof IndividualIndividualProfileCertificationsHandlingCertificationsIdRouteWithChildren
  IndividualIndividualProfileCertificationsSpecialtyCertificationsIdRoute: typeof IndividualIndividualProfileCertificationsSpecialtyCertificationsIdRouteWithChildren
}

const IndividualIndividualProfileRouteChildren: IndividualIndividualProfileRouteChildren =
  {
    IndividualIndividualProfileMyProfileRoute:
      IndividualIndividualProfileMyProfileRouteWithChildren,
    IndividualIndividualProfileCertificationsBaseCertificationsIdRoute:
      IndividualIndividualProfileCertificationsBaseCertificationsIdRouteWithChildren,
    IndividualIndividualProfileCertificationsHandlingCertificationsIdRoute:
      IndividualIndividualProfileCertificationsHandlingCertificationsIdRouteWithChildren,
    IndividualIndividualProfileCertificationsSpecialtyCertificationsIdRoute:
      IndividualIndividualProfileCertificationsSpecialtyCertificationsIdRouteWithChildren,
  }

const IndividualIndividualProfileRouteWithChildren =
  IndividualIndividualProfileRoute._addFileChildren(
    IndividualIndividualProfileRouteChildren,
  )

interface IndividualIndividualPortalLookupClockingRecordRouteRouteChildren {
  IndividualIndividualPortalLookupClockingRecordAlertsLazyRoute: typeof IndividualIndividualPortalLookupClockingRecordAlertsLazyRoute
  IndividualIndividualPortalLookupClockingRecordFilesLazyRoute: typeof IndividualIndividualPortalLookupClockingRecordFilesLazyRoute
  IndividualIndividualPortalLookupClockingRecordOverviewLazyRoute: typeof IndividualIndividualPortalLookupClockingRecordOverviewLazyRoute
  IndividualIndividualPortalLookupClockingRecordScheduleLazyRoute: typeof IndividualIndividualPortalLookupClockingRecordScheduleLazyRoute
  IndividualIndividualPortalLookupClockingRecordIndexLazyRoute: typeof IndividualIndividualPortalLookupClockingRecordIndexLazyRoute
}

const IndividualIndividualPortalLookupClockingRecordRouteRouteChildren: IndividualIndividualPortalLookupClockingRecordRouteRouteChildren =
  {
    IndividualIndividualPortalLookupClockingRecordAlertsLazyRoute:
      IndividualIndividualPortalLookupClockingRecordAlertsLazyRoute,
    IndividualIndividualPortalLookupClockingRecordFilesLazyRoute:
      IndividualIndividualPortalLookupClockingRecordFilesLazyRoute,
    IndividualIndividualPortalLookupClockingRecordOverviewLazyRoute:
      IndividualIndividualPortalLookupClockingRecordOverviewLazyRoute,
    IndividualIndividualPortalLookupClockingRecordScheduleLazyRoute:
      IndividualIndividualPortalLookupClockingRecordScheduleLazyRoute,
    IndividualIndividualPortalLookupClockingRecordIndexLazyRoute:
      IndividualIndividualPortalLookupClockingRecordIndexLazyRoute,
  }

const IndividualIndividualPortalLookupClockingRecordRouteRouteWithChildren =
  IndividualIndividualPortalLookupClockingRecordRouteRoute._addFileChildren(
    IndividualIndividualPortalLookupClockingRecordRouteRouteChildren,
  )

interface IndividualIndividualPortalLookupPaySlipRouteRouteChildren {
  IndividualIndividualPortalLookupPaySlipAlertsLazyRoute: typeof IndividualIndividualPortalLookupPaySlipAlertsLazyRoute
  IndividualIndividualPortalLookupPaySlipFilesLazyRoute: typeof IndividualIndividualPortalLookupPaySlipFilesLazyRoute
  IndividualIndividualPortalLookupPaySlipHistoryLazyRoute: typeof IndividualIndividualPortalLookupPaySlipHistoryLazyRoute
  IndividualIndividualPortalLookupPaySlipOverviewLazyRoute: typeof IndividualIndividualPortalLookupPaySlipOverviewLazyRoute
  IndividualIndividualPortalLookupPaySlipIndexLazyRoute: typeof IndividualIndividualPortalLookupPaySlipIndexLazyRoute
}

const IndividualIndividualPortalLookupPaySlipRouteRouteChildren: IndividualIndividualPortalLookupPaySlipRouteRouteChildren =
  {
    IndividualIndividualPortalLookupPaySlipAlertsLazyRoute:
      IndividualIndividualPortalLookupPaySlipAlertsLazyRoute,
    IndividualIndividualPortalLookupPaySlipFilesLazyRoute:
      IndividualIndividualPortalLookupPaySlipFilesLazyRoute,
    IndividualIndividualPortalLookupPaySlipHistoryLazyRoute:
      IndividualIndividualPortalLookupPaySlipHistoryLazyRoute,
    IndividualIndividualPortalLookupPaySlipOverviewLazyRoute:
      IndividualIndividualPortalLookupPaySlipOverviewLazyRoute,
    IndividualIndividualPortalLookupPaySlipIndexLazyRoute:
      IndividualIndividualPortalLookupPaySlipIndexLazyRoute,
  }

const IndividualIndividualPortalLookupPaySlipRouteRouteWithChildren =
  IndividualIndividualPortalLookupPaySlipRouteRoute._addFileChildren(
    IndividualIndividualPortalLookupPaySlipRouteRouteChildren,
  )

interface IndividualIndividualPortalRouteChildren {
  IndividualIndividualPortalIndexRoute: typeof IndividualIndividualPortalIndexRoute
  IndividualIndividualPortalLookupClockingRecordRouteRoute: typeof IndividualIndividualPortalLookupClockingRecordRouteRouteWithChildren
  IndividualIndividualPortalLookupPaySlipRouteRoute: typeof IndividualIndividualPortalLookupPaySlipRouteRouteWithChildren
  IndividualIndividualPortalApprovalsIndexRoute: typeof IndividualIndividualPortalApprovalsIndexRoute
  IndividualIndividualPortalLookupIndexRoute: typeof IndividualIndividualPortalLookupIndexRoute
  IndividualIndividualPortalRequestsIndexRoute: typeof IndividualIndividualPortalRequestsIndexRoute
}

const IndividualIndividualPortalRouteChildren: IndividualIndividualPortalRouteChildren =
  {
    IndividualIndividualPortalIndexRoute: IndividualIndividualPortalIndexRoute,
    IndividualIndividualPortalLookupClockingRecordRouteRoute:
      IndividualIndividualPortalLookupClockingRecordRouteRouteWithChildren,
    IndividualIndividualPortalLookupPaySlipRouteRoute:
      IndividualIndividualPortalLookupPaySlipRouteRouteWithChildren,
    IndividualIndividualPortalApprovalsIndexRoute:
      IndividualIndividualPortalApprovalsIndexRoute,
    IndividualIndividualPortalLookupIndexRoute:
      IndividualIndividualPortalLookupIndexRoute,
    IndividualIndividualPortalRequestsIndexRoute:
      IndividualIndividualPortalRequestsIndexRoute,
  }

const IndividualIndividualPortalRouteWithChildren =
  IndividualIndividualPortalRoute._addFileChildren(
    IndividualIndividualPortalRouteChildren,
  )

interface IndividualIndividualRouteChildren {
  IndividualIndividualProfileRoute: typeof IndividualIndividualProfileRouteWithChildren
  IndividualIndividualPortalRoute: typeof IndividualIndividualPortalRouteWithChildren
  IndividualIndividualIndexRoute: typeof IndividualIndividualIndexRoute
  IndividualIndividualTaskIdApprovalDialogRoute: typeof IndividualIndividualTaskIdApprovalDialogRoute
  IndividualIndividualTasksApprovalTasksIndexRoute: typeof IndividualIndividualTasksApprovalTasksIndexRoute
  IndividualIndividualTasksOperationTasksIndexRoute: typeof IndividualIndividualTasksOperationTasksIndexRoute
  IndividualIndividualTasksRequestTasksIndexRoute: typeof IndividualIndividualTasksRequestTasksIndexRoute
  IndividualIndividualOperationPackageIdIndexRoute: typeof IndividualIndividualOperationPackageIdIndexRoute
  IndividualIndividualTaskIdIndexRoute: typeof IndividualIndividualTaskIdIndexRoute
  IndividualIndividualTaskIdApprovalIndexRoute: typeof IndividualIndividualTaskIdApprovalIndexRoute
  IndividualIndividualContractIdSignatureRequestSignatureRequestIdIndexRoute: typeof IndividualIndividualContractIdSignatureRequestSignatureRequestIdIndexRoute
  IndividualIndividualOperationPackageIdPatternPatternIdIndexRoute: typeof IndividualIndividualOperationPackageIdPatternPatternIdIndexRoute
  IndividualIndividualOperationPackageIdTargetTargetIdIndexRoute: typeof IndividualIndividualOperationPackageIdTargetTargetIdIndexRoute
  IndividualIndividualTaskIdOperationPackageCommonFormFormIdIndexRoute: typeof IndividualIndividualTaskIdOperationPackageCommonFormFormIdIndexRoute
}

const IndividualIndividualRouteChildren: IndividualIndividualRouteChildren = {
  IndividualIndividualProfileRoute:
    IndividualIndividualProfileRouteWithChildren,
  IndividualIndividualPortalRoute: IndividualIndividualPortalRouteWithChildren,
  IndividualIndividualIndexRoute: IndividualIndividualIndexRoute,
  IndividualIndividualTaskIdApprovalDialogRoute:
    IndividualIndividualTaskIdApprovalDialogRoute,
  IndividualIndividualTasksApprovalTasksIndexRoute:
    IndividualIndividualTasksApprovalTasksIndexRoute,
  IndividualIndividualTasksOperationTasksIndexRoute:
    IndividualIndividualTasksOperationTasksIndexRoute,
  IndividualIndividualTasksRequestTasksIndexRoute:
    IndividualIndividualTasksRequestTasksIndexRoute,
  IndividualIndividualOperationPackageIdIndexRoute:
    IndividualIndividualOperationPackageIdIndexRoute,
  IndividualIndividualTaskIdIndexRoute: IndividualIndividualTaskIdIndexRoute,
  IndividualIndividualTaskIdApprovalIndexRoute:
    IndividualIndividualTaskIdApprovalIndexRoute,
  IndividualIndividualContractIdSignatureRequestSignatureRequestIdIndexRoute:
    IndividualIndividualContractIdSignatureRequestSignatureRequestIdIndexRoute,
  IndividualIndividualOperationPackageIdPatternPatternIdIndexRoute:
    IndividualIndividualOperationPackageIdPatternPatternIdIndexRoute,
  IndividualIndividualOperationPackageIdTargetTargetIdIndexRoute:
    IndividualIndividualOperationPackageIdTargetTargetIdIndexRoute,
  IndividualIndividualTaskIdOperationPackageCommonFormFormIdIndexRoute:
    IndividualIndividualTaskIdOperationPackageCommonFormFormIdIndexRoute,
}

const IndividualIndividualRouteWithChildren =
  IndividualIndividualRoute._addFileChildren(IndividualIndividualRouteChildren)

interface IndividualRouteChildren {
  IndividualIndividualRoute: typeof IndividualIndividualRouteWithChildren
}

const IndividualRouteChildren: IndividualRouteChildren = {
  IndividualIndividualRoute: IndividualIndividualRouteWithChildren,
}

const IndividualRouteWithChildren = IndividualRoute._addFileChildren(
  IndividualRouteChildren,
)

interface StacktraceIssuesLayoutRouteChildren {
  StacktraceIssuesLayoutIndexRoute: typeof StacktraceIssuesLayoutIndexRoute
  StacktraceIssuesLayoutOverviewIndexRoute: typeof StacktraceIssuesLayoutOverviewIndexRoute
}

const StacktraceIssuesLayoutRouteChildren: StacktraceIssuesLayoutRouteChildren =
  {
    StacktraceIssuesLayoutIndexRoute: StacktraceIssuesLayoutIndexRoute,
    StacktraceIssuesLayoutOverviewIndexRoute:
      StacktraceIssuesLayoutOverviewIndexRoute,
  }

const StacktraceIssuesLayoutRouteWithChildren =
  StacktraceIssuesLayoutRoute._addFileChildren(
    StacktraceIssuesLayoutRouteChildren,
  )

interface StacktraceIssuesIdLayoutRouteChildren {
  StacktraceIssuesIdLayoutIndexRoute: typeof StacktraceIssuesIdLayoutIndexRoute
  StacktraceIssuesIdLayoutHistoryIndexRoute: typeof StacktraceIssuesIdLayoutHistoryIndexRoute
}

const StacktraceIssuesIdLayoutRouteChildren: StacktraceIssuesIdLayoutRouteChildren =
  {
    StacktraceIssuesIdLayoutIndexRoute: StacktraceIssuesIdLayoutIndexRoute,
    StacktraceIssuesIdLayoutHistoryIndexRoute:
      StacktraceIssuesIdLayoutHistoryIndexRoute,
  }

const StacktraceIssuesIdLayoutRouteWithChildren =
  StacktraceIssuesIdLayoutRoute._addFileChildren(
    StacktraceIssuesIdLayoutRouteChildren,
  )

interface StacktraceIssuesIdRouteChildren {
  StacktraceIssuesIdLayoutRoute: typeof StacktraceIssuesIdLayoutRouteWithChildren
}

const StacktraceIssuesIdRouteChildren: StacktraceIssuesIdRouteChildren = {
  StacktraceIssuesIdLayoutRoute: StacktraceIssuesIdLayoutRouteWithChildren,
}

const StacktraceIssuesIdRouteWithChildren =
  StacktraceIssuesIdRoute._addFileChildren(StacktraceIssuesIdRouteChildren)

interface StacktraceIssuesRouteChildren {
  StacktraceIssuesLayoutRoute: typeof StacktraceIssuesLayoutRouteWithChildren
  StacktraceIssuesIdRoute: typeof StacktraceIssuesIdRouteWithChildren
  StacktraceIssuesAddSelectIndexRoute: typeof StacktraceIssuesAddSelectIndexRoute
  StacktraceIssuesAddIndexRoute: typeof StacktraceIssuesAddIndexRoute
  StacktraceIssuesExternalIntegrationsIndexRoute: typeof StacktraceIssuesExternalIntegrationsIndexRoute
}

const StacktraceIssuesRouteChildren: StacktraceIssuesRouteChildren = {
  StacktraceIssuesLayoutRoute: StacktraceIssuesLayoutRouteWithChildren,
  StacktraceIssuesIdRoute: StacktraceIssuesIdRouteWithChildren,
  StacktraceIssuesAddSelectIndexRoute: StacktraceIssuesAddSelectIndexRoute,
  StacktraceIssuesAddIndexRoute: StacktraceIssuesAddIndexRoute,
  StacktraceIssuesExternalIntegrationsIndexRoute:
    StacktraceIssuesExternalIntegrationsIndexRoute,
}

const StacktraceIssuesRouteWithChildren =
  StacktraceIssuesRoute._addFileChildren(StacktraceIssuesRouteChildren)

interface StacktraceProductRoadmapLayoutRouteChildren {
  StacktraceProductRoadmapLayoutIndexRoute: typeof StacktraceProductRoadmapLayoutIndexRoute
}

const StacktraceProductRoadmapLayoutRouteChildren: StacktraceProductRoadmapLayoutRouteChildren =
  {
    StacktraceProductRoadmapLayoutIndexRoute:
      StacktraceProductRoadmapLayoutIndexRoute,
  }

const StacktraceProductRoadmapLayoutRouteWithChildren =
  StacktraceProductRoadmapLayoutRoute._addFileChildren(
    StacktraceProductRoadmapLayoutRouteChildren,
  )

interface StacktraceProductRoadmapRoadmapIdLayoutRouteChildren {
  StacktraceProductRoadmapRoadmapIdLayoutIndexRoute: typeof StacktraceProductRoadmapRoadmapIdLayoutIndexRoute
  StacktraceProductRoadmapRoadmapIdLayoutDetailIndexRoute: typeof StacktraceProductRoadmapRoadmapIdLayoutDetailIndexRoute
  StacktraceProductRoadmapRoadmapIdLayoutHistoryIndexRoute: typeof StacktraceProductRoadmapRoadmapIdLayoutHistoryIndexRoute
}

const StacktraceProductRoadmapRoadmapIdLayoutRouteChildren: StacktraceProductRoadmapRoadmapIdLayoutRouteChildren =
  {
    StacktraceProductRoadmapRoadmapIdLayoutIndexRoute:
      StacktraceProductRoadmapRoadmapIdLayoutIndexRoute,
    StacktraceProductRoadmapRoadmapIdLayoutDetailIndexRoute:
      StacktraceProductRoadmapRoadmapIdLayoutDetailIndexRoute,
    StacktraceProductRoadmapRoadmapIdLayoutHistoryIndexRoute:
      StacktraceProductRoadmapRoadmapIdLayoutHistoryIndexRoute,
  }

const StacktraceProductRoadmapRoadmapIdLayoutRouteWithChildren =
  StacktraceProductRoadmapRoadmapIdLayoutRoute._addFileChildren(
    StacktraceProductRoadmapRoadmapIdLayoutRouteChildren,
  )

interface StacktraceProductRoadmapRoadmapIdRouteChildren {
  StacktraceProductRoadmapRoadmapIdLayoutRoute: typeof StacktraceProductRoadmapRoadmapIdLayoutRouteWithChildren
}

const StacktraceProductRoadmapRoadmapIdRouteChildren: StacktraceProductRoadmapRoadmapIdRouteChildren =
  {
    StacktraceProductRoadmapRoadmapIdLayoutRoute:
      StacktraceProductRoadmapRoadmapIdLayoutRouteWithChildren,
  }

const StacktraceProductRoadmapRoadmapIdRouteWithChildren =
  StacktraceProductRoadmapRoadmapIdRoute._addFileChildren(
    StacktraceProductRoadmapRoadmapIdRouteChildren,
  )

interface StacktraceProductRoadmapRouteChildren {
  StacktraceProductRoadmapLayoutRoute: typeof StacktraceProductRoadmapLayoutRouteWithChildren
  StacktraceProductRoadmapRoadmapIdRoute: typeof StacktraceProductRoadmapRoadmapIdRouteWithChildren
}

const StacktraceProductRoadmapRouteChildren: StacktraceProductRoadmapRouteChildren =
  {
    StacktraceProductRoadmapLayoutRoute:
      StacktraceProductRoadmapLayoutRouteWithChildren,
    StacktraceProductRoadmapRoadmapIdRoute:
      StacktraceProductRoadmapRoadmapIdRouteWithChildren,
  }

const StacktraceProductRoadmapRouteWithChildren =
  StacktraceProductRoadmapRoute._addFileChildren(
    StacktraceProductRoadmapRouteChildren,
  )

interface StacktraceTestSetsLayoutRouteChildren {
  StacktraceTestSetsLayoutIndexRoute: typeof StacktraceTestSetsLayoutIndexRoute
}

const StacktraceTestSetsLayoutRouteChildren: StacktraceTestSetsLayoutRouteChildren =
  {
    StacktraceTestSetsLayoutIndexRoute: StacktraceTestSetsLayoutIndexRoute,
  }

const StacktraceTestSetsLayoutRouteWithChildren =
  StacktraceTestSetsLayoutRoute._addFileChildren(
    StacktraceTestSetsLayoutRouteChildren,
  )

interface StacktraceTestSetsIdLayoutRouteChildren {
  StacktraceTestSetsIdLayoutIndexRoute: typeof StacktraceTestSetsIdLayoutIndexRoute
  StacktraceTestSetsIdLayoutConditionsIndexRoute: typeof StacktraceTestSetsIdLayoutConditionsIndexRoute
  StacktraceTestSetsIdLayoutTargetFunctionsIndexRoute: typeof StacktraceTestSetsIdLayoutTargetFunctionsIndexRoute
}

const StacktraceTestSetsIdLayoutRouteChildren: StacktraceTestSetsIdLayoutRouteChildren =
  {
    StacktraceTestSetsIdLayoutIndexRoute: StacktraceTestSetsIdLayoutIndexRoute,
    StacktraceTestSetsIdLayoutConditionsIndexRoute:
      StacktraceTestSetsIdLayoutConditionsIndexRoute,
    StacktraceTestSetsIdLayoutTargetFunctionsIndexRoute:
      StacktraceTestSetsIdLayoutTargetFunctionsIndexRoute,
  }

const StacktraceTestSetsIdLayoutRouteWithChildren =
  StacktraceTestSetsIdLayoutRoute._addFileChildren(
    StacktraceTestSetsIdLayoutRouteChildren,
  )

interface StacktraceTestSetsIdRouteChildren {
  StacktraceTestSetsIdLayoutRoute: typeof StacktraceTestSetsIdLayoutRouteWithChildren
}

const StacktraceTestSetsIdRouteChildren: StacktraceTestSetsIdRouteChildren = {
  StacktraceTestSetsIdLayoutRoute: StacktraceTestSetsIdLayoutRouteWithChildren,
}

const StacktraceTestSetsIdRouteWithChildren =
  StacktraceTestSetsIdRoute._addFileChildren(StacktraceTestSetsIdRouteChildren)

interface StacktraceTestSetsRouteChildren {
  StacktraceTestSetsLayoutRoute: typeof StacktraceTestSetsLayoutRouteWithChildren
  StacktraceTestSetsIdRoute: typeof StacktraceTestSetsIdRouteWithChildren
}

const StacktraceTestSetsRouteChildren: StacktraceTestSetsRouteChildren = {
  StacktraceTestSetsLayoutRoute: StacktraceTestSetsLayoutRouteWithChildren,
  StacktraceTestSetsIdRoute: StacktraceTestSetsIdRouteWithChildren,
}

const StacktraceTestSetsRouteWithChildren =
  StacktraceTestSetsRoute._addFileChildren(StacktraceTestSetsRouteChildren)

interface StacktraceTestSuitesLayoutRouteChildren {
  StacktraceTestSuitesLayoutIndexRoute: typeof StacktraceTestSuitesLayoutIndexRoute
}

const StacktraceTestSuitesLayoutRouteChildren: StacktraceTestSuitesLayoutRouteChildren =
  {
    StacktraceTestSuitesLayoutIndexRoute: StacktraceTestSuitesLayoutIndexRoute,
  }

const StacktraceTestSuitesLayoutRouteWithChildren =
  StacktraceTestSuitesLayoutRoute._addFileChildren(
    StacktraceTestSuitesLayoutRouteChildren,
  )

interface StacktraceTestSuitesIdLayoutTestPlanLayoutRouteChildren {
  StacktraceTestSuitesIdLayoutTestPlanLayoutIndexRoute: typeof StacktraceTestSuitesIdLayoutTestPlanLayoutIndexRoute
}

const StacktraceTestSuitesIdLayoutTestPlanLayoutRouteChildren: StacktraceTestSuitesIdLayoutTestPlanLayoutRouteChildren =
  {
    StacktraceTestSuitesIdLayoutTestPlanLayoutIndexRoute:
      StacktraceTestSuitesIdLayoutTestPlanLayoutIndexRoute,
  }

const StacktraceTestSuitesIdLayoutTestPlanLayoutRouteWithChildren =
  StacktraceTestSuitesIdLayoutTestPlanLayoutRoute._addFileChildren(
    StacktraceTestSuitesIdLayoutTestPlanLayoutRouteChildren,
  )

interface StacktraceTestSuitesIdLayoutTestPlanRouteChildren {
  StacktraceTestSuitesIdLayoutTestPlanLayoutRoute: typeof StacktraceTestSuitesIdLayoutTestPlanLayoutRouteWithChildren
}

const StacktraceTestSuitesIdLayoutTestPlanRouteChildren: StacktraceTestSuitesIdLayoutTestPlanRouteChildren =
  {
    StacktraceTestSuitesIdLayoutTestPlanLayoutRoute:
      StacktraceTestSuitesIdLayoutTestPlanLayoutRouteWithChildren,
  }

const StacktraceTestSuitesIdLayoutTestPlanRouteWithChildren =
  StacktraceTestSuitesIdLayoutTestPlanRoute._addFileChildren(
    StacktraceTestSuitesIdLayoutTestPlanRouteChildren,
  )

interface StacktraceTestSuitesIdLayoutTestReviewLayoutRouteChildren {
  StacktraceTestSuitesIdLayoutTestReviewLayoutIndexRoute: typeof StacktraceTestSuitesIdLayoutTestReviewLayoutIndexRoute
}

const StacktraceTestSuitesIdLayoutTestReviewLayoutRouteChildren: StacktraceTestSuitesIdLayoutTestReviewLayoutRouteChildren =
  {
    StacktraceTestSuitesIdLayoutTestReviewLayoutIndexRoute:
      StacktraceTestSuitesIdLayoutTestReviewLayoutIndexRoute,
  }

const StacktraceTestSuitesIdLayoutTestReviewLayoutRouteWithChildren =
  StacktraceTestSuitesIdLayoutTestReviewLayoutRoute._addFileChildren(
    StacktraceTestSuitesIdLayoutTestReviewLayoutRouteChildren,
  )

interface StacktraceTestSuitesIdLayoutTestReviewRouteChildren {
  StacktraceTestSuitesIdLayoutTestReviewLayoutRoute: typeof StacktraceTestSuitesIdLayoutTestReviewLayoutRouteWithChildren
}

const StacktraceTestSuitesIdLayoutTestReviewRouteChildren: StacktraceTestSuitesIdLayoutTestReviewRouteChildren =
  {
    StacktraceTestSuitesIdLayoutTestReviewLayoutRoute:
      StacktraceTestSuitesIdLayoutTestReviewLayoutRouteWithChildren,
  }

const StacktraceTestSuitesIdLayoutTestReviewRouteWithChildren =
  StacktraceTestSuitesIdLayoutTestReviewRoute._addFileChildren(
    StacktraceTestSuitesIdLayoutTestReviewRouteChildren,
  )

interface StacktraceTestSuitesIdLayoutRouteChildren {
  StacktraceTestSuitesIdLayoutIndexRoute: typeof StacktraceTestSuitesIdLayoutIndexRoute
  StacktraceTestSuitesIdLayoutTestPlanRoute: typeof StacktraceTestSuitesIdLayoutTestPlanRouteWithChildren
  StacktraceTestSuitesIdLayoutTestReviewRoute: typeof StacktraceTestSuitesIdLayoutTestReviewRouteWithChildren
  StacktraceTestSuitesIdLayoutDocumentIndexRoute: typeof StacktraceTestSuitesIdLayoutDocumentIndexRoute
  StacktraceTestSuitesIdLayoutIssuesIndexRoute: typeof StacktraceTestSuitesIdLayoutIssuesIndexRoute
  StacktraceTestSuitesIdLayoutOverviewIndexRoute: typeof StacktraceTestSuitesIdLayoutOverviewIndexRoute
  StacktraceTestSuitesIdLayoutTargetFunctionsIndexRoute: typeof StacktraceTestSuitesIdLayoutTargetFunctionsIndexRoute
  StacktraceTestSuitesIdLayoutTestSetIndexRoute: typeof StacktraceTestSuitesIdLayoutTestSetIndexRoute
}

const StacktraceTestSuitesIdLayoutRouteChildren: StacktraceTestSuitesIdLayoutRouteChildren =
  {
    StacktraceTestSuitesIdLayoutIndexRoute:
      StacktraceTestSuitesIdLayoutIndexRoute,
    StacktraceTestSuitesIdLayoutTestPlanRoute:
      StacktraceTestSuitesIdLayoutTestPlanRouteWithChildren,
    StacktraceTestSuitesIdLayoutTestReviewRoute:
      StacktraceTestSuitesIdLayoutTestReviewRouteWithChildren,
    StacktraceTestSuitesIdLayoutDocumentIndexRoute:
      StacktraceTestSuitesIdLayoutDocumentIndexRoute,
    StacktraceTestSuitesIdLayoutIssuesIndexRoute:
      StacktraceTestSuitesIdLayoutIssuesIndexRoute,
    StacktraceTestSuitesIdLayoutOverviewIndexRoute:
      StacktraceTestSuitesIdLayoutOverviewIndexRoute,
    StacktraceTestSuitesIdLayoutTargetFunctionsIndexRoute:
      StacktraceTestSuitesIdLayoutTargetFunctionsIndexRoute,
    StacktraceTestSuitesIdLayoutTestSetIndexRoute:
      StacktraceTestSuitesIdLayoutTestSetIndexRoute,
  }

const StacktraceTestSuitesIdLayoutRouteWithChildren =
  StacktraceTestSuitesIdLayoutRoute._addFileChildren(
    StacktraceTestSuitesIdLayoutRouteChildren,
  )

interface StacktraceTestSuitesIdRouteChildren {
  StacktraceTestSuitesIdLayoutRoute: typeof StacktraceTestSuitesIdLayoutRouteWithChildren
}

const StacktraceTestSuitesIdRouteChildren: StacktraceTestSuitesIdRouteChildren =
  {
    StacktraceTestSuitesIdLayoutRoute:
      StacktraceTestSuitesIdLayoutRouteWithChildren,
  }

const StacktraceTestSuitesIdRouteWithChildren =
  StacktraceTestSuitesIdRoute._addFileChildren(
    StacktraceTestSuitesIdRouteChildren,
  )

interface StacktraceTestSuitesRouteChildren {
  StacktraceTestSuitesLayoutRoute: typeof StacktraceTestSuitesLayoutRouteWithChildren
  StacktraceTestSuitesIdRoute: typeof StacktraceTestSuitesIdRouteWithChildren
}

const StacktraceTestSuitesRouteChildren: StacktraceTestSuitesRouteChildren = {
  StacktraceTestSuitesLayoutRoute: StacktraceTestSuitesLayoutRouteWithChildren,
  StacktraceTestSuitesIdRoute: StacktraceTestSuitesIdRouteWithChildren,
}

const StacktraceTestSuitesRouteWithChildren =
  StacktraceTestSuitesRoute._addFileChildren(StacktraceTestSuitesRouteChildren)

interface StacktraceValuesLayoutRouteChildren {
  StacktraceValuesLayoutIndexRoute: typeof StacktraceValuesLayoutIndexRoute
}

const StacktraceValuesLayoutRouteChildren: StacktraceValuesLayoutRouteChildren =
  {
    StacktraceValuesLayoutIndexRoute: StacktraceValuesLayoutIndexRoute,
  }

const StacktraceValuesLayoutRouteWithChildren =
  StacktraceValuesLayoutRoute._addFileChildren(
    StacktraceValuesLayoutRouteChildren,
  )

interface StacktraceValuesIdLayoutRouteChildren {
  StacktraceValuesIdLayoutIndexRoute: typeof StacktraceValuesIdLayoutIndexRoute
  StacktraceValuesIdLayoutHistoryIndexRoute: typeof StacktraceValuesIdLayoutHistoryIndexRoute
  StacktraceValuesIdLayoutProductScopeIndexRoute: typeof StacktraceValuesIdLayoutProductScopeIndexRoute
}

const StacktraceValuesIdLayoutRouteChildren: StacktraceValuesIdLayoutRouteChildren =
  {
    StacktraceValuesIdLayoutIndexRoute: StacktraceValuesIdLayoutIndexRoute,
    StacktraceValuesIdLayoutHistoryIndexRoute:
      StacktraceValuesIdLayoutHistoryIndexRoute,
    StacktraceValuesIdLayoutProductScopeIndexRoute:
      StacktraceValuesIdLayoutProductScopeIndexRoute,
  }

const StacktraceValuesIdLayoutRouteWithChildren =
  StacktraceValuesIdLayoutRoute._addFileChildren(
    StacktraceValuesIdLayoutRouteChildren,
  )

interface StacktraceValuesIdRouteChildren {
  StacktraceValuesIdLayoutRoute: typeof StacktraceValuesIdLayoutRouteWithChildren
}

const StacktraceValuesIdRouteChildren: StacktraceValuesIdRouteChildren = {
  StacktraceValuesIdLayoutRoute: StacktraceValuesIdLayoutRouteWithChildren,
}

const StacktraceValuesIdRouteWithChildren =
  StacktraceValuesIdRoute._addFileChildren(StacktraceValuesIdRouteChildren)

interface StacktraceValuesRouteChildren {
  StacktraceValuesLayoutRoute: typeof StacktraceValuesLayoutRouteWithChildren
  StacktraceValuesIdRoute: typeof StacktraceValuesIdRouteWithChildren
  StacktraceValuesAddSelectIndexRoute: typeof StacktraceValuesAddSelectIndexRoute
  StacktraceValuesAddIndexRoute: typeof StacktraceValuesAddIndexRoute
}

const StacktraceValuesRouteChildren: StacktraceValuesRouteChildren = {
  StacktraceValuesLayoutRoute: StacktraceValuesLayoutRouteWithChildren,
  StacktraceValuesIdRoute: StacktraceValuesIdRouteWithChildren,
  StacktraceValuesAddSelectIndexRoute: StacktraceValuesAddSelectIndexRoute,
  StacktraceValuesAddIndexRoute: StacktraceValuesAddIndexRoute,
}

const StacktraceValuesRouteWithChildren =
  StacktraceValuesRoute._addFileChildren(StacktraceValuesRouteChildren)

interface StacktraceDevelopmentTicketsTicketIdLayoutRouteChildren {
  StacktraceDevelopmentTicketsTicketIdLayoutIndexRoute: typeof StacktraceDevelopmentTicketsTicketIdLayoutIndexRoute
  StacktraceDevelopmentTicketsTicketIdLayoutHistoryIndexRoute: typeof StacktraceDevelopmentTicketsTicketIdLayoutHistoryIndexRoute
}

const StacktraceDevelopmentTicketsTicketIdLayoutRouteChildren: StacktraceDevelopmentTicketsTicketIdLayoutRouteChildren =
  {
    StacktraceDevelopmentTicketsTicketIdLayoutIndexRoute:
      StacktraceDevelopmentTicketsTicketIdLayoutIndexRoute,
    StacktraceDevelopmentTicketsTicketIdLayoutHistoryIndexRoute:
      StacktraceDevelopmentTicketsTicketIdLayoutHistoryIndexRoute,
  }

const StacktraceDevelopmentTicketsTicketIdLayoutRouteWithChildren =
  StacktraceDevelopmentTicketsTicketIdLayoutRoute._addFileChildren(
    StacktraceDevelopmentTicketsTicketIdLayoutRouteChildren,
  )

interface StacktraceDevelopmentTicketsTicketIdRouteChildren {
  StacktraceDevelopmentTicketsTicketIdLayoutRoute: typeof StacktraceDevelopmentTicketsTicketIdLayoutRouteWithChildren
}

const StacktraceDevelopmentTicketsTicketIdRouteChildren: StacktraceDevelopmentTicketsTicketIdRouteChildren =
  {
    StacktraceDevelopmentTicketsTicketIdLayoutRoute:
      StacktraceDevelopmentTicketsTicketIdLayoutRouteWithChildren,
  }

const StacktraceDevelopmentTicketsTicketIdRouteWithChildren =
  StacktraceDevelopmentTicketsTicketIdRoute._addFileChildren(
    StacktraceDevelopmentTicketsTicketIdRouteChildren,
  )

interface StacktraceProductionProductionIdLayoutRouteChildren {
  StacktraceProductionProductionIdLayoutIndexRoute: typeof StacktraceProductionProductionIdLayoutIndexRoute
  StacktraceProductionProductionIdLayoutDevScopeIndexRoute: typeof StacktraceProductionProductionIdLayoutDevScopeIndexRoute
  StacktraceProductionProductionIdLayoutIssueScopeIndexRoute: typeof StacktraceProductionProductionIdLayoutIssueScopeIndexRoute
  StacktraceProductionProductionIdLayoutProductScopeIndexRoute: typeof StacktraceProductionProductionIdLayoutProductScopeIndexRoute
  StacktraceProductionProductionIdLayoutQualityScopeIndexRoute: typeof StacktraceProductionProductionIdLayoutQualityScopeIndexRoute
  StacktraceProductionProductionIdLayoutValueIndexRoute: typeof StacktraceProductionProductionIdLayoutValueIndexRoute
  StacktraceProductionProductionIdLayoutDevScopeEditIndexRoute: typeof StacktraceProductionProductionIdLayoutDevScopeEditIndexRoute
  StacktraceProductionProductionIdLayoutIssueScopeEditIndexRoute: typeof StacktraceProductionProductionIdLayoutIssueScopeEditIndexRoute
  StacktraceProductionProductionIdLayoutValueEditIndexRoute: typeof StacktraceProductionProductionIdLayoutValueEditIndexRoute
}

const StacktraceProductionProductionIdLayoutRouteChildren: StacktraceProductionProductionIdLayoutRouteChildren =
  {
    StacktraceProductionProductionIdLayoutIndexRoute:
      StacktraceProductionProductionIdLayoutIndexRoute,
    StacktraceProductionProductionIdLayoutDevScopeIndexRoute:
      StacktraceProductionProductionIdLayoutDevScopeIndexRoute,
    StacktraceProductionProductionIdLayoutIssueScopeIndexRoute:
      StacktraceProductionProductionIdLayoutIssueScopeIndexRoute,
    StacktraceProductionProductionIdLayoutProductScopeIndexRoute:
      StacktraceProductionProductionIdLayoutProductScopeIndexRoute,
    StacktraceProductionProductionIdLayoutQualityScopeIndexRoute:
      StacktraceProductionProductionIdLayoutQualityScopeIndexRoute,
    StacktraceProductionProductionIdLayoutValueIndexRoute:
      StacktraceProductionProductionIdLayoutValueIndexRoute,
    StacktraceProductionProductionIdLayoutDevScopeEditIndexRoute:
      StacktraceProductionProductionIdLayoutDevScopeEditIndexRoute,
    StacktraceProductionProductionIdLayoutIssueScopeEditIndexRoute:
      StacktraceProductionProductionIdLayoutIssueScopeEditIndexRoute,
    StacktraceProductionProductionIdLayoutValueEditIndexRoute:
      StacktraceProductionProductionIdLayoutValueEditIndexRoute,
  }

const StacktraceProductionProductionIdLayoutRouteWithChildren =
  StacktraceProductionProductionIdLayoutRoute._addFileChildren(
    StacktraceProductionProductionIdLayoutRouteChildren,
  )

interface StacktraceProductionProductionIdRouteChildren {
  StacktraceProductionProductionIdLayoutRoute: typeof StacktraceProductionProductionIdLayoutRouteWithChildren
}

const StacktraceProductionProductionIdRouteChildren: StacktraceProductionProductionIdRouteChildren =
  {
    StacktraceProductionProductionIdLayoutRoute:
      StacktraceProductionProductionIdLayoutRouteWithChildren,
  }

const StacktraceProductionProductionIdRouteWithChildren =
  StacktraceProductionProductionIdRoute._addFileChildren(
    StacktraceProductionProductionIdRouteChildren,
  )

interface StacktraceProductsIdLayoutRouteChildren {
  StacktraceProductsIdLayoutIndexRoute: typeof StacktraceProductsIdLayoutIndexRoute
  StacktraceProductsIdLayoutProductScopeIndexRoute: typeof StacktraceProductsIdLayoutProductScopeIndexRoute
}

const StacktraceProductsIdLayoutRouteChildren: StacktraceProductsIdLayoutRouteChildren =
  {
    StacktraceProductsIdLayoutIndexRoute: StacktraceProductsIdLayoutIndexRoute,
    StacktraceProductsIdLayoutProductScopeIndexRoute:
      StacktraceProductsIdLayoutProductScopeIndexRoute,
  }

const StacktraceProductsIdLayoutRouteWithChildren =
  StacktraceProductsIdLayoutRoute._addFileChildren(
    StacktraceProductsIdLayoutRouteChildren,
  )

interface StacktraceProductsIdScopeNodeIdLayoutRouteChildren {
  StacktraceProductsIdScopeNodeIdLayoutIndexRoute: typeof StacktraceProductsIdScopeNodeIdLayoutIndexRoute
  StacktraceProductsIdScopeNodeIdLayoutValueIndexRoute: typeof StacktraceProductsIdScopeNodeIdLayoutValueIndexRoute
}

const StacktraceProductsIdScopeNodeIdLayoutRouteChildren: StacktraceProductsIdScopeNodeIdLayoutRouteChildren =
  {
    StacktraceProductsIdScopeNodeIdLayoutIndexRoute:
      StacktraceProductsIdScopeNodeIdLayoutIndexRoute,
    StacktraceProductsIdScopeNodeIdLayoutValueIndexRoute:
      StacktraceProductsIdScopeNodeIdLayoutValueIndexRoute,
  }

const StacktraceProductsIdScopeNodeIdLayoutRouteWithChildren =
  StacktraceProductsIdScopeNodeIdLayoutRoute._addFileChildren(
    StacktraceProductsIdScopeNodeIdLayoutRouteChildren,
  )

interface StacktraceProductsIdScopeNodeIdRouteChildren {
  StacktraceProductsIdScopeNodeIdLayoutRoute: typeof StacktraceProductsIdScopeNodeIdLayoutRouteWithChildren
}

const StacktraceProductsIdScopeNodeIdRouteChildren: StacktraceProductsIdScopeNodeIdRouteChildren =
  {
    StacktraceProductsIdScopeNodeIdLayoutRoute:
      StacktraceProductsIdScopeNodeIdLayoutRouteWithChildren,
  }

const StacktraceProductsIdScopeNodeIdRouteWithChildren =
  StacktraceProductsIdScopeNodeIdRoute._addFileChildren(
    StacktraceProductsIdScopeNodeIdRouteChildren,
  )

interface StacktraceProductsIdRouteChildren {
  StacktraceProductsIdLayoutRoute: typeof StacktraceProductsIdLayoutRouteWithChildren
  StacktraceProductsIdScopeNodeIdRoute: typeof StacktraceProductsIdScopeNodeIdRouteWithChildren
}

const StacktraceProductsIdRouteChildren: StacktraceProductsIdRouteChildren = {
  StacktraceProductsIdLayoutRoute: StacktraceProductsIdLayoutRouteWithChildren,
  StacktraceProductsIdScopeNodeIdRoute:
    StacktraceProductsIdScopeNodeIdRouteWithChildren,
}

const StacktraceProductsIdRouteWithChildren =
  StacktraceProductsIdRoute._addFileChildren(StacktraceProductsIdRouteChildren)

interface StacktraceRouteChildren {
  StacktracePlanningOperationsCoreRoute: typeof StacktracePlanningOperationsCoreRoute
  StacktraceProductPlanningCoreRoute: typeof StacktraceProductPlanningCoreRoute
  StacktraceQaOperationsCoreRoute: typeof StacktraceQaOperationsCoreRoute
  StacktraceDevelopmentTicketsImportCsvRouteRoute: typeof StacktraceDevelopmentTicketsImportCsvRouteRoute
  StacktraceIssuesImportCsvRouteRoute: typeof StacktraceIssuesImportCsvRouteRoute
  StacktraceValuesImportCsvRouteRoute: typeof StacktraceValuesImportCsvRouteRoute
  StacktraceIssuesRoute: typeof StacktraceIssuesRouteWithChildren
  StacktraceProductRoadmapRoute: typeof StacktraceProductRoadmapRouteWithChildren
  StacktraceTestSetsRoute: typeof StacktraceTestSetsRouteWithChildren
  StacktraceTestSuitesRoute: typeof StacktraceTestSuitesRouteWithChildren
  StacktraceValuesRoute: typeof StacktraceValuesRouteWithChildren
  StacktraceDevelopmentTicketsIndexRoute: typeof StacktraceDevelopmentTicketsIndexRoute
  StacktraceProductionIndexRoute: typeof StacktraceProductionIndexRoute
  StacktraceProductsIndexRoute: typeof StacktraceProductsIndexRoute
  StacktraceTestAssetsIndexRoute: typeof StacktraceTestAssetsIndexRoute
  StacktraceDevelopmentTicketsTicketIdRoute: typeof StacktraceDevelopmentTicketsTicketIdRouteWithChildren
  StacktraceProductionProductionIdRoute: typeof StacktraceProductionProductionIdRouteWithChildren
  StacktraceProductsIdRoute: typeof StacktraceProductsIdRouteWithChildren
  StacktraceDevelopmentTicketsAddSelectIndexRoute: typeof StacktraceDevelopmentTicketsAddSelectIndexRoute
  StacktraceDevelopmentTicketsAddIndexRoute: typeof StacktraceDevelopmentTicketsAddIndexRoute
  StacktraceDevelopmentTicketsExternalIntegrationsIndexRoute: typeof StacktraceDevelopmentTicketsExternalIntegrationsIndexRoute
  StacktraceProductsAddSelectIndexRoute: typeof StacktraceProductsAddSelectIndexRoute
  StacktraceProductsAddIndexRoute: typeof StacktraceProductsAddIndexRoute
}

const StacktraceRouteChildren: StacktraceRouteChildren = {
  StacktracePlanningOperationsCoreRoute: StacktracePlanningOperationsCoreRoute,
  StacktraceProductPlanningCoreRoute: StacktraceProductPlanningCoreRoute,
  StacktraceQaOperationsCoreRoute: StacktraceQaOperationsCoreRoute,
  StacktraceDevelopmentTicketsImportCsvRouteRoute:
    StacktraceDevelopmentTicketsImportCsvRouteRoute,
  StacktraceIssuesImportCsvRouteRoute: StacktraceIssuesImportCsvRouteRoute,
  StacktraceValuesImportCsvRouteRoute: StacktraceValuesImportCsvRouteRoute,
  StacktraceIssuesRoute: StacktraceIssuesRouteWithChildren,
  StacktraceProductRoadmapRoute: StacktraceProductRoadmapRouteWithChildren,
  StacktraceTestSetsRoute: StacktraceTestSetsRouteWithChildren,
  StacktraceTestSuitesRoute: StacktraceTestSuitesRouteWithChildren,
  StacktraceValuesRoute: StacktraceValuesRouteWithChildren,
  StacktraceDevelopmentTicketsIndexRoute:
    StacktraceDevelopmentTicketsIndexRoute,
  StacktraceProductionIndexRoute: StacktraceProductionIndexRoute,
  StacktraceProductsIndexRoute: StacktraceProductsIndexRoute,
  StacktraceTestAssetsIndexRoute: StacktraceTestAssetsIndexRoute,
  StacktraceDevelopmentTicketsTicketIdRoute:
    StacktraceDevelopmentTicketsTicketIdRouteWithChildren,
  StacktraceProductionProductionIdRoute:
    StacktraceProductionProductionIdRouteWithChildren,
  StacktraceProductsIdRoute: StacktraceProductsIdRouteWithChildren,
  StacktraceDevelopmentTicketsAddSelectIndexRoute:
    StacktraceDevelopmentTicketsAddSelectIndexRoute,
  StacktraceDevelopmentTicketsAddIndexRoute:
    StacktraceDevelopmentTicketsAddIndexRoute,
  StacktraceDevelopmentTicketsExternalIntegrationsIndexRoute:
    StacktraceDevelopmentTicketsExternalIntegrationsIndexRoute,
  StacktraceProductsAddSelectIndexRoute: StacktraceProductsAddSelectIndexRoute,
  StacktraceProductsAddIndexRoute: StacktraceProductsAddIndexRoute,
}

const StacktraceRouteWithChildren = StacktraceRoute._addFileChildren(
  StacktraceRouteChildren,
)

interface StaffAppsRouteChildren {
  StaffAppsSplatRoute: typeof StaffAppsSplatRoute
}

const StaffAppsRouteChildren: StaffAppsRouteChildren = {
  StaffAppsSplatRoute: StaffAppsSplatRoute,
}

const StaffAppsRouteWithChildren = StaffAppsRoute._addFileChildren(
  StaffAppsRouteChildren,
)

interface StaffIdManagementsRouteChildren {
  StaffIdManagementsSplatRoute: typeof StaffIdManagementsSplatRoute
}

const StaffIdManagementsRouteChildren: StaffIdManagementsRouteChildren = {
  StaffIdManagementsSplatRoute: StaffIdManagementsSplatRoute,
}

const StaffIdManagementsRouteWithChildren =
  StaffIdManagementsRoute._addFileChildren(StaffIdManagementsRouteChildren)

interface StaffItOperationCoreDeviceInventoryRouteRouteChildren {
  StaffItOperationCoreDeviceInventoryDataRoute: typeof StaffItOperationCoreDeviceInventoryDataRoute
  StaffItOperationCoreDeviceInventoryDetailRoute: typeof StaffItOperationCoreDeviceInventoryDetailRoute
}

const StaffItOperationCoreDeviceInventoryRouteRouteChildren: StaffItOperationCoreDeviceInventoryRouteRouteChildren =
  {
    StaffItOperationCoreDeviceInventoryDataRoute:
      StaffItOperationCoreDeviceInventoryDataRoute,
    StaffItOperationCoreDeviceInventoryDetailRoute:
      StaffItOperationCoreDeviceInventoryDetailRoute,
  }

const StaffItOperationCoreDeviceInventoryRouteRouteWithChildren =
  StaffItOperationCoreDeviceInventoryRouteRoute._addFileChildren(
    StaffItOperationCoreDeviceInventoryRouteRouteChildren,
  )

interface StaffAccessesLayoutRouteChildren {
  StaffAccessesLayoutIndexRoute: typeof StaffAccessesLayoutIndexRoute
  StaffAccessesLayoutPlaceholdersContractAndCostRoute: typeof StaffAccessesLayoutPlaceholdersContractAndCostRoute
  StaffAccessesLayoutPlaceholdersOverviewRoute: typeof StaffAccessesLayoutPlaceholdersOverviewRoute
  StaffAccessesLayoutPlaceholdersSoftwareRoute: typeof StaffAccessesLayoutPlaceholdersSoftwareRoute
  StaffAccessesLayoutAlertsIndexRoute: typeof StaffAccessesLayoutAlertsIndexRoute
  StaffAccessesLayoutListIndexRoute: typeof StaffAccessesLayoutListIndexRoute
  StaffAccessesLayoutSettingsIndexRoute: typeof StaffAccessesLayoutSettingsIndexRoute
  StaffAccessesLayoutListTraceableAppIdIndexRoute: typeof StaffAccessesLayoutListTraceableAppIdIndexRoute
  StaffAccessesLayoutAlertsDetailShadowItAppIdIndexRoute: typeof StaffAccessesLayoutAlertsDetailShadowItAppIdIndexRoute
  StaffAccessesLayoutAlertsDormancySoftwareIdIndexRoute: typeof StaffAccessesLayoutAlertsDormancySoftwareIdIndexRoute
}

const StaffAccessesLayoutRouteChildren: StaffAccessesLayoutRouteChildren = {
  StaffAccessesLayoutIndexRoute: StaffAccessesLayoutIndexRoute,
  StaffAccessesLayoutPlaceholdersContractAndCostRoute:
    StaffAccessesLayoutPlaceholdersContractAndCostRoute,
  StaffAccessesLayoutPlaceholdersOverviewRoute:
    StaffAccessesLayoutPlaceholdersOverviewRoute,
  StaffAccessesLayoutPlaceholdersSoftwareRoute:
    StaffAccessesLayoutPlaceholdersSoftwareRoute,
  StaffAccessesLayoutAlertsIndexRoute: StaffAccessesLayoutAlertsIndexRoute,
  StaffAccessesLayoutListIndexRoute: StaffAccessesLayoutListIndexRoute,
  StaffAccessesLayoutSettingsIndexRoute: StaffAccessesLayoutSettingsIndexRoute,
  StaffAccessesLayoutListTraceableAppIdIndexRoute:
    StaffAccessesLayoutListTraceableAppIdIndexRoute,
  StaffAccessesLayoutAlertsDetailShadowItAppIdIndexRoute:
    StaffAccessesLayoutAlertsDetailShadowItAppIdIndexRoute,
  StaffAccessesLayoutAlertsDormancySoftwareIdIndexRoute:
    StaffAccessesLayoutAlertsDormancySoftwareIdIndexRoute,
}

const StaffAccessesLayoutRouteWithChildren =
  StaffAccessesLayoutRoute._addFileChildren(StaffAccessesLayoutRouteChildren)

interface StaffAccessesRouteChildren {
  StaffAccessesLayoutRoute: typeof StaffAccessesLayoutRouteWithChildren
}

const StaffAccessesRouteChildren: StaffAccessesRouteChildren = {
  StaffAccessesLayoutRoute: StaffAccessesLayoutRouteWithChildren,
}

const StaffAccessesRouteWithChildren = StaffAccessesRoute._addFileChildren(
  StaffAccessesRouteChildren,
)

interface StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren {
  StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute: typeof StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute: typeof StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
}

const StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren: StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren =
  {
    StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute:
      StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute,
    StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute:
      StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute,
  }

const StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren =
  StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute._addFileChildren(
    StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren,
  )

interface StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren {
  StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute: typeof StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren
}

const StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren: StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren =
  {
    StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute:
      StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren,
  }

const StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren =
  StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute._addFileChildren(
    StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren,
  )

interface StaffAttendanceCoreLayoutRouteChildren {
  StaffAttendanceCoreLayoutIndexRoute: typeof StaffAttendanceCoreLayoutIndexRoute
  StaffAttendanceCoreLayoutArchiveIndexRoute: typeof StaffAttendanceCoreLayoutArchiveIndexRoute
  StaffAttendanceCoreLayoutConfigIndexRoute: typeof StaffAttendanceCoreLayoutConfigIndexRoute
  StaffAttendanceCoreLayoutDashboardIndexRoute: typeof StaffAttendanceCoreLayoutDashboardIndexRoute
  StaffAttendanceCoreLayoutOperationPackagesIndexRoute: typeof StaffAttendanceCoreLayoutOperationPackagesIndexRoute
  StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute: typeof StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren
}

const StaffAttendanceCoreLayoutRouteChildren: StaffAttendanceCoreLayoutRouteChildren =
  {
    StaffAttendanceCoreLayoutIndexRoute: StaffAttendanceCoreLayoutIndexRoute,
    StaffAttendanceCoreLayoutArchiveIndexRoute:
      StaffAttendanceCoreLayoutArchiveIndexRoute,
    StaffAttendanceCoreLayoutConfigIndexRoute:
      StaffAttendanceCoreLayoutConfigIndexRoute,
    StaffAttendanceCoreLayoutDashboardIndexRoute:
      StaffAttendanceCoreLayoutDashboardIndexRoute,
    StaffAttendanceCoreLayoutOperationPackagesIndexRoute:
      StaffAttendanceCoreLayoutOperationPackagesIndexRoute,
    StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute:
      StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren,
  }

const StaffAttendanceCoreLayoutRouteWithChildren =
  StaffAttendanceCoreLayoutRoute._addFileChildren(
    StaffAttendanceCoreLayoutRouteChildren,
  )

interface StaffAttendanceCoreRouteChildren {
  StaffAttendanceCoreLayoutRoute: typeof StaffAttendanceCoreLayoutRouteWithChildren
}

const StaffAttendanceCoreRouteChildren: StaffAttendanceCoreRouteChildren = {
  StaffAttendanceCoreLayoutRoute: StaffAttendanceCoreLayoutRouteWithChildren,
}

const StaffAttendanceCoreRouteWithChildren =
  StaffAttendanceCoreRoute._addFileChildren(StaffAttendanceCoreRouteChildren)

interface StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutRouteChildren {
  StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutIndexRoute: typeof StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutIndexRoute
  StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutStructureIndexRoute: typeof StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutStructureIndexRoute
}

const StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutRouteChildren: StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutRouteChildren =
  {
    StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutIndexRoute:
      StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutIndexRoute,
    StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutStructureIndexRoute:
      StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutStructureIndexRoute,
  }

const StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutRouteWithChildren =
  StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutRoute._addFileChildren(
    StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutRouteChildren,
  )

interface StaffAttendanceEngineLayoutAttendanceStructuresStructureIdRouteChildren {
  StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutRoute: typeof StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutRouteWithChildren
}

const StaffAttendanceEngineLayoutAttendanceStructuresStructureIdRouteChildren: StaffAttendanceEngineLayoutAttendanceStructuresStructureIdRouteChildren =
  {
    StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutRoute:
      StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutRouteWithChildren,
  }

const StaffAttendanceEngineLayoutAttendanceStructuresStructureIdRouteWithChildren =
  StaffAttendanceEngineLayoutAttendanceStructuresStructureIdRoute._addFileChildren(
    StaffAttendanceEngineLayoutAttendanceStructuresStructureIdRouteChildren,
  )

interface StaffAttendanceEngineLayoutRouteChildren {
  StaffAttendanceEngineLayoutIndexRoute: typeof StaffAttendanceEngineLayoutIndexRoute
  StaffAttendanceEngineLayoutAttendanceStructuresIndexRoute: typeof StaffAttendanceEngineLayoutAttendanceStructuresIndexRoute
  StaffAttendanceEngineLayoutAttendanceUnitsIndexRoute: typeof StaffAttendanceEngineLayoutAttendanceUnitsIndexRoute
  StaffAttendanceEngineLayoutItemsIndexRoute: typeof StaffAttendanceEngineLayoutItemsIndexRoute
  StaffAttendanceEngineLayoutLogicComponentsIndexRoute: typeof StaffAttendanceEngineLayoutLogicComponentsIndexRoute
  StaffAttendanceEngineLayoutAttendanceStructuresStructureIdRoute: typeof StaffAttendanceEngineLayoutAttendanceStructuresStructureIdRouteWithChildren
  StaffAttendanceEngineLayoutAttendanceUnitsUnitIdIndexRoute: typeof StaffAttendanceEngineLayoutAttendanceUnitsUnitIdIndexRoute
  StaffAttendanceEngineLayoutItemsComponentIdIndexRoute: typeof StaffAttendanceEngineLayoutItemsComponentIdIndexRoute
  StaffAttendanceEngineLayoutLogicComponentsComponentIdIndexRoute: typeof StaffAttendanceEngineLayoutLogicComponentsComponentIdIndexRoute
}

const StaffAttendanceEngineLayoutRouteChildren: StaffAttendanceEngineLayoutRouteChildren =
  {
    StaffAttendanceEngineLayoutIndexRoute:
      StaffAttendanceEngineLayoutIndexRoute,
    StaffAttendanceEngineLayoutAttendanceStructuresIndexRoute:
      StaffAttendanceEngineLayoutAttendanceStructuresIndexRoute,
    StaffAttendanceEngineLayoutAttendanceUnitsIndexRoute:
      StaffAttendanceEngineLayoutAttendanceUnitsIndexRoute,
    StaffAttendanceEngineLayoutItemsIndexRoute:
      StaffAttendanceEngineLayoutItemsIndexRoute,
    StaffAttendanceEngineLayoutLogicComponentsIndexRoute:
      StaffAttendanceEngineLayoutLogicComponentsIndexRoute,
    StaffAttendanceEngineLayoutAttendanceStructuresStructureIdRoute:
      StaffAttendanceEngineLayoutAttendanceStructuresStructureIdRouteWithChildren,
    StaffAttendanceEngineLayoutAttendanceUnitsUnitIdIndexRoute:
      StaffAttendanceEngineLayoutAttendanceUnitsUnitIdIndexRoute,
    StaffAttendanceEngineLayoutItemsComponentIdIndexRoute:
      StaffAttendanceEngineLayoutItemsComponentIdIndexRoute,
    StaffAttendanceEngineLayoutLogicComponentsComponentIdIndexRoute:
      StaffAttendanceEngineLayoutLogicComponentsComponentIdIndexRoute,
  }

const StaffAttendanceEngineLayoutRouteWithChildren =
  StaffAttendanceEngineLayoutRoute._addFileChildren(
    StaffAttendanceEngineLayoutRouteChildren,
  )

interface StaffAttendanceEngineRouteChildren {
  StaffAttendanceEngineLayoutRoute: typeof StaffAttendanceEngineLayoutRouteWithChildren
}

const StaffAttendanceEngineRouteChildren: StaffAttendanceEngineRouteChildren = {
  StaffAttendanceEngineLayoutRoute:
    StaffAttendanceEngineLayoutRouteWithChildren,
}

const StaffAttendanceEngineRouteWithChildren =
  StaffAttendanceEngineRoute._addFileChildren(
    StaffAttendanceEngineRouteChildren,
  )

interface StaffAttendancesLayoutClockingRecordsEmployeeIdRouteRouteChildren {
  StaffAttendancesLayoutClockingRecordsEmployeeIdAlertsLazyRoute: typeof StaffAttendancesLayoutClockingRecordsEmployeeIdAlertsLazyRoute
  StaffAttendancesLayoutClockingRecordsEmployeeIdFilesLazyRoute: typeof StaffAttendancesLayoutClockingRecordsEmployeeIdFilesLazyRoute
  StaffAttendancesLayoutClockingRecordsEmployeeIdOverviewLazyRoute: typeof StaffAttendancesLayoutClockingRecordsEmployeeIdOverviewLazyRoute
  StaffAttendancesLayoutClockingRecordsEmployeeIdScheduleLazyRoute: typeof StaffAttendancesLayoutClockingRecordsEmployeeIdScheduleLazyRoute
  StaffAttendancesLayoutClockingRecordsEmployeeIdSettingsLazyRoute: typeof StaffAttendancesLayoutClockingRecordsEmployeeIdSettingsLazyRoute
  StaffAttendancesLayoutClockingRecordsEmployeeIdIndexLazyRoute: typeof StaffAttendancesLayoutClockingRecordsEmployeeIdIndexLazyRoute
}

const StaffAttendancesLayoutClockingRecordsEmployeeIdRouteRouteChildren: StaffAttendancesLayoutClockingRecordsEmployeeIdRouteRouteChildren =
  {
    StaffAttendancesLayoutClockingRecordsEmployeeIdAlertsLazyRoute:
      StaffAttendancesLayoutClockingRecordsEmployeeIdAlertsLazyRoute,
    StaffAttendancesLayoutClockingRecordsEmployeeIdFilesLazyRoute:
      StaffAttendancesLayoutClockingRecordsEmployeeIdFilesLazyRoute,
    StaffAttendancesLayoutClockingRecordsEmployeeIdOverviewLazyRoute:
      StaffAttendancesLayoutClockingRecordsEmployeeIdOverviewLazyRoute,
    StaffAttendancesLayoutClockingRecordsEmployeeIdScheduleLazyRoute:
      StaffAttendancesLayoutClockingRecordsEmployeeIdScheduleLazyRoute,
    StaffAttendancesLayoutClockingRecordsEmployeeIdSettingsLazyRoute:
      StaffAttendancesLayoutClockingRecordsEmployeeIdSettingsLazyRoute,
    StaffAttendancesLayoutClockingRecordsEmployeeIdIndexLazyRoute:
      StaffAttendancesLayoutClockingRecordsEmployeeIdIndexLazyRoute,
  }

const StaffAttendancesLayoutClockingRecordsEmployeeIdRouteRouteWithChildren =
  StaffAttendancesLayoutClockingRecordsEmployeeIdRouteRoute._addFileChildren(
    StaffAttendancesLayoutClockingRecordsEmployeeIdRouteRouteChildren,
  )

interface StaffAttendancesLayoutRouteChildren {
  StaffAttendancesLayoutIndexRoute: typeof StaffAttendancesLayoutIndexRoute
  StaffAttendancesLayoutClockingRecordsEmployeeIdRouteRoute: typeof StaffAttendancesLayoutClockingRecordsEmployeeIdRouteRouteWithChildren
  StaffAttendancesLayoutAlertsIndexRoute: typeof StaffAttendancesLayoutAlertsIndexRoute
  StaffAttendancesLayoutClockingRecordsIndexRoute: typeof StaffAttendancesLayoutClockingRecordsIndexRoute
  StaffAttendancesLayoutEmployeesIndexRoute: typeof StaffAttendancesLayoutEmployeesIndexRoute
  StaffAttendancesLayoutOperationActivityIndexRoute: typeof StaffAttendancesLayoutOperationActivityIndexRoute
  StaffAttendancesLayoutOverviewIndexRoute: typeof StaffAttendancesLayoutOverviewIndexRoute
  StaffAttendancesLayoutRuleAndPolicyIndexRoute: typeof StaffAttendancesLayoutRuleAndPolicyIndexRoute
  StaffAttendancesLayoutSettingsIndexRoute: typeof StaffAttendancesLayoutSettingsIndexRoute
}

const StaffAttendancesLayoutRouteChildren: StaffAttendancesLayoutRouteChildren =
  {
    StaffAttendancesLayoutIndexRoute: StaffAttendancesLayoutIndexRoute,
    StaffAttendancesLayoutClockingRecordsEmployeeIdRouteRoute:
      StaffAttendancesLayoutClockingRecordsEmployeeIdRouteRouteWithChildren,
    StaffAttendancesLayoutAlertsIndexRoute:
      StaffAttendancesLayoutAlertsIndexRoute,
    StaffAttendancesLayoutClockingRecordsIndexRoute:
      StaffAttendancesLayoutClockingRecordsIndexRoute,
    StaffAttendancesLayoutEmployeesIndexRoute:
      StaffAttendancesLayoutEmployeesIndexRoute,
    StaffAttendancesLayoutOperationActivityIndexRoute:
      StaffAttendancesLayoutOperationActivityIndexRoute,
    StaffAttendancesLayoutOverviewIndexRoute:
      StaffAttendancesLayoutOverviewIndexRoute,
    StaffAttendancesLayoutRuleAndPolicyIndexRoute:
      StaffAttendancesLayoutRuleAndPolicyIndexRoute,
    StaffAttendancesLayoutSettingsIndexRoute:
      StaffAttendancesLayoutSettingsIndexRoute,
  }

const StaffAttendancesLayoutRouteWithChildren =
  StaffAttendancesLayoutRoute._addFileChildren(
    StaffAttendancesLayoutRouteChildren,
  )

interface StaffAttendancesRouteChildren {
  StaffAttendancesLayoutRoute: typeof StaffAttendancesLayoutRouteWithChildren
}

const StaffAttendancesRouteChildren: StaffAttendancesRouteChildren = {
  StaffAttendancesLayoutRoute: StaffAttendancesLayoutRouteWithChildren,
}

const StaffAttendancesRouteWithChildren =
  StaffAttendancesRoute._addFileChildren(StaffAttendancesRouteChildren)

interface StaffBusinessOperationEventsListRouteChildren {
  StaffBusinessOperationEventsListArchiveRoute: typeof StaffBusinessOperationEventsListArchiveRoute
  StaffBusinessOperationEventsListConfigRoute: typeof StaffBusinessOperationEventsListConfigRoute
  StaffBusinessOperationEventsListOperationActivityRoute: typeof StaffBusinessOperationEventsListOperationActivityRoute
  StaffBusinessOperationEventsListOverviewRoute: typeof StaffBusinessOperationEventsListOverviewRoute
  StaffBusinessOperationEventsListRuleAndPolicyRoute: typeof StaffBusinessOperationEventsListRuleAndPolicyRoute
  StaffBusinessOperationEventsListSettingsRoute: typeof StaffBusinessOperationEventsListSettingsRoute
  StaffBusinessOperationEventsListIndexRoute: typeof StaffBusinessOperationEventsListIndexRoute
}

const StaffBusinessOperationEventsListRouteChildren: StaffBusinessOperationEventsListRouteChildren =
  {
    StaffBusinessOperationEventsListArchiveRoute:
      StaffBusinessOperationEventsListArchiveRoute,
    StaffBusinessOperationEventsListConfigRoute:
      StaffBusinessOperationEventsListConfigRoute,
    StaffBusinessOperationEventsListOperationActivityRoute:
      StaffBusinessOperationEventsListOperationActivityRoute,
    StaffBusinessOperationEventsListOverviewRoute:
      StaffBusinessOperationEventsListOverviewRoute,
    StaffBusinessOperationEventsListRuleAndPolicyRoute:
      StaffBusinessOperationEventsListRuleAndPolicyRoute,
    StaffBusinessOperationEventsListSettingsRoute:
      StaffBusinessOperationEventsListSettingsRoute,
    StaffBusinessOperationEventsListIndexRoute:
      StaffBusinessOperationEventsListIndexRoute,
  }

const StaffBusinessOperationEventsListRouteWithChildren =
  StaffBusinessOperationEventsListRoute._addFileChildren(
    StaffBusinessOperationEventsListRouteChildren,
  )

interface StaffBusinessOperationEventsRouteChildren {
  StaffBusinessOperationEventsListRoute: typeof StaffBusinessOperationEventsListRouteWithChildren
  StaffBusinessOperationEventsEventInstanceIdIndexRoute: typeof StaffBusinessOperationEventsEventInstanceIdIndexRoute
}

const StaffBusinessOperationEventsRouteChildren: StaffBusinessOperationEventsRouteChildren =
  {
    StaffBusinessOperationEventsListRoute:
      StaffBusinessOperationEventsListRouteWithChildren,
    StaffBusinessOperationEventsEventInstanceIdIndexRoute:
      StaffBusinessOperationEventsEventInstanceIdIndexRoute,
  }

const StaffBusinessOperationEventsRouteWithChildren =
  StaffBusinessOperationEventsRoute._addFileChildren(
    StaffBusinessOperationEventsRouteChildren,
  )

interface StaffBusinessPartnerListRouteChildren {
  StaffBusinessPartnerListIndexRoute: typeof StaffBusinessPartnerListIndexRoute
  StaffBusinessPartnerListPlaceholdersAlertsRouteRoute: typeof StaffBusinessPartnerListPlaceholdersAlertsRouteRoute
  StaffBusinessPartnerListPlaceholdersContractAndCostRouteRoute: typeof StaffBusinessPartnerListPlaceholdersContractAndCostRouteRoute
  StaffBusinessPartnerListPlaceholdersOperationActivityRouteRoute: typeof StaffBusinessPartnerListPlaceholdersOperationActivityRouteRoute
  StaffBusinessPartnerListPlaceholdersRuleAndPolicyRouteRoute: typeof StaffBusinessPartnerListPlaceholdersRuleAndPolicyRouteRoute
  StaffBusinessPartnerListPlaceholdersSettingsRouteRoute: typeof StaffBusinessPartnerListPlaceholdersSettingsRouteRoute
  StaffBusinessPartnerListTerminatedIndexRoute: typeof StaffBusinessPartnerListTerminatedIndexRoute
}

const StaffBusinessPartnerListRouteChildren: StaffBusinessPartnerListRouteChildren =
  {
    StaffBusinessPartnerListIndexRoute: StaffBusinessPartnerListIndexRoute,
    StaffBusinessPartnerListPlaceholdersAlertsRouteRoute:
      StaffBusinessPartnerListPlaceholdersAlertsRouteRoute,
    StaffBusinessPartnerListPlaceholdersContractAndCostRouteRoute:
      StaffBusinessPartnerListPlaceholdersContractAndCostRouteRoute,
    StaffBusinessPartnerListPlaceholdersOperationActivityRouteRoute:
      StaffBusinessPartnerListPlaceholdersOperationActivityRouteRoute,
    StaffBusinessPartnerListPlaceholdersRuleAndPolicyRouteRoute:
      StaffBusinessPartnerListPlaceholdersRuleAndPolicyRouteRoute,
    StaffBusinessPartnerListPlaceholdersSettingsRouteRoute:
      StaffBusinessPartnerListPlaceholdersSettingsRouteRoute,
    StaffBusinessPartnerListTerminatedIndexRoute:
      StaffBusinessPartnerListTerminatedIndexRoute,
  }

const StaffBusinessPartnerListRouteWithChildren =
  StaffBusinessPartnerListRoute._addFileChildren(
    StaffBusinessPartnerListRouteChildren,
  )

interface StaffBusinessPartnerIdLayoutBpRoleInfoLayoutRouteChildren {
  StaffBusinessPartnerIdLayoutBpRoleInfoLayoutIndexRoute: typeof StaffBusinessPartnerIdLayoutBpRoleInfoLayoutIndexRoute
  StaffBusinessPartnerIdLayoutBpRoleInfoLayoutBpRoleIndexRoute: typeof StaffBusinessPartnerIdLayoutBpRoleInfoLayoutBpRoleIndexRoute
}

const StaffBusinessPartnerIdLayoutBpRoleInfoLayoutRouteChildren: StaffBusinessPartnerIdLayoutBpRoleInfoLayoutRouteChildren =
  {
    StaffBusinessPartnerIdLayoutBpRoleInfoLayoutIndexRoute:
      StaffBusinessPartnerIdLayoutBpRoleInfoLayoutIndexRoute,
    StaffBusinessPartnerIdLayoutBpRoleInfoLayoutBpRoleIndexRoute:
      StaffBusinessPartnerIdLayoutBpRoleInfoLayoutBpRoleIndexRoute,
  }

const StaffBusinessPartnerIdLayoutBpRoleInfoLayoutRouteWithChildren =
  StaffBusinessPartnerIdLayoutBpRoleInfoLayoutRoute._addFileChildren(
    StaffBusinessPartnerIdLayoutBpRoleInfoLayoutRouteChildren,
  )

interface StaffBusinessPartnerIdLayoutBpRoleInfoRouteChildren {
  StaffBusinessPartnerIdLayoutBpRoleInfoLayoutRoute: typeof StaffBusinessPartnerIdLayoutBpRoleInfoLayoutRouteWithChildren
}

const StaffBusinessPartnerIdLayoutBpRoleInfoRouteChildren: StaffBusinessPartnerIdLayoutBpRoleInfoRouteChildren =
  {
    StaffBusinessPartnerIdLayoutBpRoleInfoLayoutRoute:
      StaffBusinessPartnerIdLayoutBpRoleInfoLayoutRouteWithChildren,
  }

const StaffBusinessPartnerIdLayoutBpRoleInfoRouteWithChildren =
  StaffBusinessPartnerIdLayoutBpRoleInfoRoute._addFileChildren(
    StaffBusinessPartnerIdLayoutBpRoleInfoRouteChildren,
  )

interface StaffBusinessPartnerIdLayoutRouteChildren {
  StaffBusinessPartnerIdLayoutBpRoleInfoRoute: typeof StaffBusinessPartnerIdLayoutBpRoleInfoRouteWithChildren
  StaffBusinessPartnerIdLayoutIndexIndexRoute: typeof StaffBusinessPartnerIdLayoutIndexIndexRoute
  StaffBusinessPartnerIdLayoutAddressAndContactIndexRoute: typeof StaffBusinessPartnerIdLayoutAddressAndContactIndexRoute
}

const StaffBusinessPartnerIdLayoutRouteChildren: StaffBusinessPartnerIdLayoutRouteChildren =
  {
    StaffBusinessPartnerIdLayoutBpRoleInfoRoute:
      StaffBusinessPartnerIdLayoutBpRoleInfoRouteWithChildren,
    StaffBusinessPartnerIdLayoutIndexIndexRoute:
      StaffBusinessPartnerIdLayoutIndexIndexRoute,
    StaffBusinessPartnerIdLayoutAddressAndContactIndexRoute:
      StaffBusinessPartnerIdLayoutAddressAndContactIndexRoute,
  }

const StaffBusinessPartnerIdLayoutRouteWithChildren =
  StaffBusinessPartnerIdLayoutRoute._addFileChildren(
    StaffBusinessPartnerIdLayoutRouteChildren,
  )

interface StaffBusinessPartnerIdRouteChildren {
  StaffBusinessPartnerIdLayoutRoute: typeof StaffBusinessPartnerIdLayoutRouteWithChildren
}

const StaffBusinessPartnerIdRouteChildren: StaffBusinessPartnerIdRouteChildren =
  {
    StaffBusinessPartnerIdLayoutRoute:
      StaffBusinessPartnerIdLayoutRouteWithChildren,
  }

const StaffBusinessPartnerIdRouteWithChildren =
  StaffBusinessPartnerIdRoute._addFileChildren(
    StaffBusinessPartnerIdRouteChildren,
  )

interface StaffBusinessPartnerRouteChildren {
  StaffBusinessPartnerListRoute: typeof StaffBusinessPartnerListRouteWithChildren
  StaffBusinessPartnerImportCsvCorporationRouteRoute: typeof StaffBusinessPartnerImportCsvCorporationRouteRoute
  StaffBusinessPartnerImportCsvIndividualRouteRoute: typeof StaffBusinessPartnerImportCsvIndividualRouteRoute
  StaffBusinessPartnerIdRoute: typeof StaffBusinessPartnerIdRouteWithChildren
  StaffBusinessPartnerAddIndexRoute: typeof StaffBusinessPartnerAddIndexRoute
  StaffBusinessPartnerAddBusinessPartnerTypeCompletedRoute: typeof StaffBusinessPartnerAddBusinessPartnerTypeCompletedRoute
  StaffBusinessPartnerAddBusinessPartnerTypeIndexRoute: typeof StaffBusinessPartnerAddBusinessPartnerTypeIndexRoute
}

const StaffBusinessPartnerRouteChildren: StaffBusinessPartnerRouteChildren = {
  StaffBusinessPartnerListRoute: StaffBusinessPartnerListRouteWithChildren,
  StaffBusinessPartnerImportCsvCorporationRouteRoute:
    StaffBusinessPartnerImportCsvCorporationRouteRoute,
  StaffBusinessPartnerImportCsvIndividualRouteRoute:
    StaffBusinessPartnerImportCsvIndividualRouteRoute,
  StaffBusinessPartnerIdRoute: StaffBusinessPartnerIdRouteWithChildren,
  StaffBusinessPartnerAddIndexRoute: StaffBusinessPartnerAddIndexRoute,
  StaffBusinessPartnerAddBusinessPartnerTypeCompletedRoute:
    StaffBusinessPartnerAddBusinessPartnerTypeCompletedRoute,
  StaffBusinessPartnerAddBusinessPartnerTypeIndexRoute:
    StaffBusinessPartnerAddBusinessPartnerTypeIndexRoute,
}

const StaffBusinessPartnerRouteWithChildren =
  StaffBusinessPartnerRoute._addFileChildren(StaffBusinessPartnerRouteChildren)

interface StaffCertificationListSettingsRouteLazyRouteChildren {
  StaffCertificationListSettingsIndexRoute: typeof StaffCertificationListSettingsIndexRoute
  StaffCertificationListSettingsIssuingOrganizationIndexRoute: typeof StaffCertificationListSettingsIssuingOrganizationIndexRoute
  StaffCertificationListSettingsSpecialtyCategoryLevelIndexRoute: typeof StaffCertificationListSettingsSpecialtyCategoryLevelIndexRoute
  StaffCertificationListSettingsSpecialtyCategoryIndexRoute: typeof StaffCertificationListSettingsSpecialtyCategoryIndexRoute
}

const StaffCertificationListSettingsRouteLazyRouteChildren: StaffCertificationListSettingsRouteLazyRouteChildren =
  {
    StaffCertificationListSettingsIndexRoute:
      StaffCertificationListSettingsIndexRoute,
    StaffCertificationListSettingsIssuingOrganizationIndexRoute:
      StaffCertificationListSettingsIssuingOrganizationIndexRoute,
    StaffCertificationListSettingsSpecialtyCategoryLevelIndexRoute:
      StaffCertificationListSettingsSpecialtyCategoryLevelIndexRoute,
    StaffCertificationListSettingsSpecialtyCategoryIndexRoute:
      StaffCertificationListSettingsSpecialtyCategoryIndexRoute,
  }

const StaffCertificationListSettingsRouteLazyRouteWithChildren =
  StaffCertificationListSettingsRouteLazyRoute._addFileChildren(
    StaffCertificationListSettingsRouteLazyRouteChildren,
  )

interface StaffCertificationListRouteChildren {
  StaffCertificationListIndexRouteRoute: typeof StaffCertificationListIndexRouteRoute
  StaffCertificationListSettingsRouteLazyRoute: typeof StaffCertificationListSettingsRouteLazyRouteWithChildren
  StaffCertificationListPlaceholdersAlertsRouteRoute: typeof StaffCertificationListPlaceholdersAlertsRouteRoute
  StaffCertificationListPlaceholdersOperationActivityRouteRoute: typeof StaffCertificationListPlaceholdersOperationActivityRouteRoute
  StaffCertificationListPlaceholdersOverviewRouteRoute: typeof StaffCertificationListPlaceholdersOverviewRouteRoute
  StaffCertificationListPlaceholdersRuleAndPolicyRouteRoute: typeof StaffCertificationListPlaceholdersRuleAndPolicyRouteRoute
  StaffCertificationListPeopleIndexRoute: typeof StaffCertificationListPeopleIndexRoute
}

const StaffCertificationListRouteChildren: StaffCertificationListRouteChildren =
  {
    StaffCertificationListIndexRouteRoute:
      StaffCertificationListIndexRouteRoute,
    StaffCertificationListSettingsRouteLazyRoute:
      StaffCertificationListSettingsRouteLazyRouteWithChildren,
    StaffCertificationListPlaceholdersAlertsRouteRoute:
      StaffCertificationListPlaceholdersAlertsRouteRoute,
    StaffCertificationListPlaceholdersOperationActivityRouteRoute:
      StaffCertificationListPlaceholdersOperationActivityRouteRoute,
    StaffCertificationListPlaceholdersOverviewRouteRoute:
      StaffCertificationListPlaceholdersOverviewRouteRoute,
    StaffCertificationListPlaceholdersRuleAndPolicyRouteRoute:
      StaffCertificationListPlaceholdersRuleAndPolicyRouteRoute,
    StaffCertificationListPeopleIndexRoute:
      StaffCertificationListPeopleIndexRoute,
  }

const StaffCertificationListRouteWithChildren =
  StaffCertificationListRoute._addFileChildren(
    StaffCertificationListRouteChildren,
  )

interface StaffCertificationIdLayoutRouteChildren {
  StaffCertificationIdLayoutIndexIndexRoute: typeof StaffCertificationIdLayoutIndexIndexRoute
  StaffCertificationIdLayoutCertificationHoldersIndexRoute: typeof StaffCertificationIdLayoutCertificationHoldersIndexRoute
  StaffCertificationIdLayoutHandlingCertificationsIndexRoute: typeof StaffCertificationIdLayoutHandlingCertificationsIndexRoute
  StaffCertificationIdLayoutSpecialtyCertificationsIndexRoute: typeof StaffCertificationIdLayoutSpecialtyCertificationsIndexRoute
}

const StaffCertificationIdLayoutRouteChildren: StaffCertificationIdLayoutRouteChildren =
  {
    StaffCertificationIdLayoutIndexIndexRoute:
      StaffCertificationIdLayoutIndexIndexRoute,
    StaffCertificationIdLayoutCertificationHoldersIndexRoute:
      StaffCertificationIdLayoutCertificationHoldersIndexRoute,
    StaffCertificationIdLayoutHandlingCertificationsIndexRoute:
      StaffCertificationIdLayoutHandlingCertificationsIndexRoute,
    StaffCertificationIdLayoutSpecialtyCertificationsIndexRoute:
      StaffCertificationIdLayoutSpecialtyCertificationsIndexRoute,
  }

const StaffCertificationIdLayoutRouteWithChildren =
  StaffCertificationIdLayoutRoute._addFileChildren(
    StaffCertificationIdLayoutRouteChildren,
  )

interface StaffCertificationIdRouteChildren {
  StaffCertificationIdLayoutRoute: typeof StaffCertificationIdLayoutRouteWithChildren
}

const StaffCertificationIdRouteChildren: StaffCertificationIdRouteChildren = {
  StaffCertificationIdLayoutRoute: StaffCertificationIdLayoutRouteWithChildren,
}

const StaffCertificationIdRouteWithChildren =
  StaffCertificationIdRoute._addFileChildren(StaffCertificationIdRouteChildren)

interface StaffCertificationHandlingCertificationIdLayoutRouteChildren {
  StaffCertificationHandlingCertificationIdLayoutIndexIndexRoute: typeof StaffCertificationHandlingCertificationIdLayoutIndexIndexRoute
  StaffCertificationHandlingCertificationIdLayoutCertificationHoldersIndexRoute: typeof StaffCertificationHandlingCertificationIdLayoutCertificationHoldersIndexRoute
}

const StaffCertificationHandlingCertificationIdLayoutRouteChildren: StaffCertificationHandlingCertificationIdLayoutRouteChildren =
  {
    StaffCertificationHandlingCertificationIdLayoutIndexIndexRoute:
      StaffCertificationHandlingCertificationIdLayoutIndexIndexRoute,
    StaffCertificationHandlingCertificationIdLayoutCertificationHoldersIndexRoute:
      StaffCertificationHandlingCertificationIdLayoutCertificationHoldersIndexRoute,
  }

const StaffCertificationHandlingCertificationIdLayoutRouteWithChildren =
  StaffCertificationHandlingCertificationIdLayoutRoute._addFileChildren(
    StaffCertificationHandlingCertificationIdLayoutRouteChildren,
  )

interface StaffCertificationHandlingCertificationIdRouteChildren {
  StaffCertificationHandlingCertificationIdLayoutRoute: typeof StaffCertificationHandlingCertificationIdLayoutRouteWithChildren
}

const StaffCertificationHandlingCertificationIdRouteChildren: StaffCertificationHandlingCertificationIdRouteChildren =
  {
    StaffCertificationHandlingCertificationIdLayoutRoute:
      StaffCertificationHandlingCertificationIdLayoutRouteWithChildren,
  }

const StaffCertificationHandlingCertificationIdRouteWithChildren =
  StaffCertificationHandlingCertificationIdRoute._addFileChildren(
    StaffCertificationHandlingCertificationIdRouteChildren,
  )

interface StaffCertificationSpecialtyCertificationIdLayoutRouteChildren {
  StaffCertificationSpecialtyCertificationIdLayoutIndexIndexRoute: typeof StaffCertificationSpecialtyCertificationIdLayoutIndexIndexRoute
  StaffCertificationSpecialtyCertificationIdLayoutCertificationHoldersIndexRoute: typeof StaffCertificationSpecialtyCertificationIdLayoutCertificationHoldersIndexRoute
  StaffCertificationSpecialtyCertificationIdLayoutHandlingCertificationsIndexRoute: typeof StaffCertificationSpecialtyCertificationIdLayoutHandlingCertificationsIndexRoute
}

const StaffCertificationSpecialtyCertificationIdLayoutRouteChildren: StaffCertificationSpecialtyCertificationIdLayoutRouteChildren =
  {
    StaffCertificationSpecialtyCertificationIdLayoutIndexIndexRoute:
      StaffCertificationSpecialtyCertificationIdLayoutIndexIndexRoute,
    StaffCertificationSpecialtyCertificationIdLayoutCertificationHoldersIndexRoute:
      StaffCertificationSpecialtyCertificationIdLayoutCertificationHoldersIndexRoute,
    StaffCertificationSpecialtyCertificationIdLayoutHandlingCertificationsIndexRoute:
      StaffCertificationSpecialtyCertificationIdLayoutHandlingCertificationsIndexRoute,
  }

const StaffCertificationSpecialtyCertificationIdLayoutRouteWithChildren =
  StaffCertificationSpecialtyCertificationIdLayoutRoute._addFileChildren(
    StaffCertificationSpecialtyCertificationIdLayoutRouteChildren,
  )

interface StaffCertificationSpecialtyCertificationIdRouteChildren {
  StaffCertificationSpecialtyCertificationIdLayoutRoute: typeof StaffCertificationSpecialtyCertificationIdLayoutRouteWithChildren
}

const StaffCertificationSpecialtyCertificationIdRouteChildren: StaffCertificationSpecialtyCertificationIdRouteChildren =
  {
    StaffCertificationSpecialtyCertificationIdLayoutRoute:
      StaffCertificationSpecialtyCertificationIdLayoutRouteWithChildren,
  }

const StaffCertificationSpecialtyCertificationIdRouteWithChildren =
  StaffCertificationSpecialtyCertificationIdRoute._addFileChildren(
    StaffCertificationSpecialtyCertificationIdRouteChildren,
  )

interface StaffCertificationRouteChildren {
  StaffCertificationListRoute: typeof StaffCertificationListRouteWithChildren
  StaffCertificationIdRoute: typeof StaffCertificationIdRouteWithChildren
  StaffCertificationAddIndexRoute: typeof StaffCertificationAddIndexRoute
  StaffCertificationAddCertificationKindCompletedRoute: typeof StaffCertificationAddCertificationKindCompletedRoute
  StaffCertificationHandlingCertificationIdRoute: typeof StaffCertificationHandlingCertificationIdRouteWithChildren
  StaffCertificationSpecialtyCertificationIdRoute: typeof StaffCertificationSpecialtyCertificationIdRouteWithChildren
  StaffCertificationAddCertificationKindIndexRoute: typeof StaffCertificationAddCertificationKindIndexRoute
}

const StaffCertificationRouteChildren: StaffCertificationRouteChildren = {
  StaffCertificationListRoute: StaffCertificationListRouteWithChildren,
  StaffCertificationIdRoute: StaffCertificationIdRouteWithChildren,
  StaffCertificationAddIndexRoute: StaffCertificationAddIndexRoute,
  StaffCertificationAddCertificationKindCompletedRoute:
    StaffCertificationAddCertificationKindCompletedRoute,
  StaffCertificationHandlingCertificationIdRoute:
    StaffCertificationHandlingCertificationIdRouteWithChildren,
  StaffCertificationSpecialtyCertificationIdRoute:
    StaffCertificationSpecialtyCertificationIdRouteWithChildren,
  StaffCertificationAddCertificationKindIndexRoute:
    StaffCertificationAddCertificationKindIndexRoute,
}

const StaffCertificationRouteWithChildren =
  StaffCertificationRoute._addFileChildren(StaffCertificationRouteChildren)

interface StaffContractListRouteChildren {
  StaffContractListIndexRoute: typeof StaffContractListIndexRoute
  StaffContractListPlaceholdersAlertsRouteRoute: typeof StaffContractListPlaceholdersAlertsRouteRoute
  StaffContractListPlaceholdersContractAndCostRouteRoute: typeof StaffContractListPlaceholdersContractAndCostRouteRoute
  StaffContractListPlaceholdersOperationActivityRouteRoute: typeof StaffContractListPlaceholdersOperationActivityRouteRoute
  StaffContractListPlaceholdersOverviewRouteRoute: typeof StaffContractListPlaceholdersOverviewRouteRoute
  StaffContractListPlaceholdersPeopleRouteRoute: typeof StaffContractListPlaceholdersPeopleRouteRoute
}

const StaffContractListRouteChildren: StaffContractListRouteChildren = {
  StaffContractListIndexRoute: StaffContractListIndexRoute,
  StaffContractListPlaceholdersAlertsRouteRoute:
    StaffContractListPlaceholdersAlertsRouteRoute,
  StaffContractListPlaceholdersContractAndCostRouteRoute:
    StaffContractListPlaceholdersContractAndCostRouteRoute,
  StaffContractListPlaceholdersOperationActivityRouteRoute:
    StaffContractListPlaceholdersOperationActivityRouteRoute,
  StaffContractListPlaceholdersOverviewRouteRoute:
    StaffContractListPlaceholdersOverviewRouteRoute,
  StaffContractListPlaceholdersPeopleRouteRoute:
    StaffContractListPlaceholdersPeopleRouteRoute,
}

const StaffContractListRouteWithChildren =
  StaffContractListRoute._addFileChildren(StaffContractListRouteChildren)

interface StaffContractIdLayoutRouteChildren {
  StaffContractIdLayoutPlaceholdersApprovalInfoRouteRoute: typeof StaffContractIdLayoutPlaceholdersApprovalInfoRouteRoute
  StaffContractIdLayoutPlaceholdersHistoryRouteRoute: typeof StaffContractIdLayoutPlaceholdersHistoryRouteRoute
  StaffContractIdLayoutPlaceholdersOperationActivityRouteRoute: typeof StaffContractIdLayoutPlaceholdersOperationActivityRouteRoute
  StaffContractIdLayoutPlaceholdersRiskProvisionsRouteRoute: typeof StaffContractIdLayoutPlaceholdersRiskProvisionsRouteRoute
  StaffContractIdLayoutPlaceholdersRuleAndPolicyRouteRoute: typeof StaffContractIdLayoutPlaceholdersRuleAndPolicyRouteRoute
  StaffContractIdLayoutIndexIndexLazyRoute: typeof StaffContractIdLayoutIndexIndexLazyRoute
  StaffContractIdLayoutStructureIndexLazyRoute: typeof StaffContractIdLayoutStructureIndexLazyRoute
}

const StaffContractIdLayoutRouteChildren: StaffContractIdLayoutRouteChildren = {
  StaffContractIdLayoutPlaceholdersApprovalInfoRouteRoute:
    StaffContractIdLayoutPlaceholdersApprovalInfoRouteRoute,
  StaffContractIdLayoutPlaceholdersHistoryRouteRoute:
    StaffContractIdLayoutPlaceholdersHistoryRouteRoute,
  StaffContractIdLayoutPlaceholdersOperationActivityRouteRoute:
    StaffContractIdLayoutPlaceholdersOperationActivityRouteRoute,
  StaffContractIdLayoutPlaceholdersRiskProvisionsRouteRoute:
    StaffContractIdLayoutPlaceholdersRiskProvisionsRouteRoute,
  StaffContractIdLayoutPlaceholdersRuleAndPolicyRouteRoute:
    StaffContractIdLayoutPlaceholdersRuleAndPolicyRouteRoute,
  StaffContractIdLayoutIndexIndexLazyRoute:
    StaffContractIdLayoutIndexIndexLazyRoute,
  StaffContractIdLayoutStructureIndexLazyRoute:
    StaffContractIdLayoutStructureIndexLazyRoute,
}

const StaffContractIdLayoutRouteWithChildren =
  StaffContractIdLayoutRoute._addFileChildren(
    StaffContractIdLayoutRouteChildren,
  )

interface StaffContractIdRouteChildren {
  StaffContractIdLayoutRoute: typeof StaffContractIdLayoutRouteWithChildren
}

const StaffContractIdRouteChildren: StaffContractIdRouteChildren = {
  StaffContractIdLayoutRoute: StaffContractIdLayoutRouteWithChildren,
}

const StaffContractIdRouteWithChildren = StaffContractIdRoute._addFileChildren(
  StaffContractIdRouteChildren,
)

interface StaffContractRouteChildren {
  StaffContractListRoute: typeof StaffContractListRouteWithChildren
  StaffContractIdRoute: typeof StaffContractIdRouteWithChildren
  StaffContractAddIndexRoute: typeof StaffContractAddIndexRoute
  StaffContractAddSubscriptionCompletedRoute: typeof StaffContractAddSubscriptionCompletedRoute
  StaffContractAddSubscriptionIndexRoute: typeof StaffContractAddSubscriptionIndexRoute
  StaffContractImportCsvContractTypeIndexRoute: typeof StaffContractImportCsvContractTypeIndexRoute
}

const StaffContractRouteChildren: StaffContractRouteChildren = {
  StaffContractListRoute: StaffContractListRouteWithChildren,
  StaffContractIdRoute: StaffContractIdRouteWithChildren,
  StaffContractAddIndexRoute: StaffContractAddIndexRoute,
  StaffContractAddSubscriptionCompletedRoute:
    StaffContractAddSubscriptionCompletedRoute,
  StaffContractAddSubscriptionIndexRoute:
    StaffContractAddSubscriptionIndexRoute,
  StaffContractImportCsvContractTypeIndexRoute:
    StaffContractImportCsvContractTypeIndexRoute,
}

const StaffContractRouteWithChildren = StaffContractRoute._addFileChildren(
  StaffContractRouteChildren,
)

interface StaffContractorCorePackagesRouteChildren {
  StaffContractorCorePackagesIndexRoute: typeof StaffContractorCorePackagesIndexRoute
  StaffContractorCorePackagesArchivesIndexRoute: typeof StaffContractorCorePackagesArchivesIndexRoute
  StaffContractorCorePackagesConfigsIndexRoute: typeof StaffContractorCorePackagesConfigsIndexRoute
}

const StaffContractorCorePackagesRouteChildren: StaffContractorCorePackagesRouteChildren =
  {
    StaffContractorCorePackagesIndexRoute:
      StaffContractorCorePackagesIndexRoute,
    StaffContractorCorePackagesArchivesIndexRoute:
      StaffContractorCorePackagesArchivesIndexRoute,
    StaffContractorCorePackagesConfigsIndexRoute:
      StaffContractorCorePackagesConfigsIndexRoute,
  }

const StaffContractorCorePackagesRouteWithChildren =
  StaffContractorCorePackagesRoute._addFileChildren(
    StaffContractorCorePackagesRouteChildren,
  )

interface StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren {
  StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute: typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute: typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
}

const StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren: StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren =
  {
    StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute:
      StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute,
    StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute:
      StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute,
  }

const StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren =
  StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute._addFileChildren(
    StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren,
  )

interface StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren {
  StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute: typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren
}

const StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren: StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren =
  {
    StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute:
      StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren,
  }

const StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren =
  StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute._addFileChildren(
    StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren,
  )

interface StaffContractorCoreRouteChildren {
  StaffContractorCorePackagesRoute: typeof StaffContractorCorePackagesRouteWithChildren
  StaffContractorCoreAnchorDateRoute: typeof StaffContractorCoreAnchorDateRoute
  StaffContractorCoreContractTargetsRoute: typeof StaffContractorCoreContractTargetsRoute
  StaffContractorCorePersonTargetsRoute: typeof StaffContractorCorePersonTargetsRoute
  StaffContractorCoreConfigPatternIdIndexRoute: typeof StaffContractorCoreConfigPatternIdIndexRoute
  StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute: typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren
}

const StaffContractorCoreRouteChildren: StaffContractorCoreRouteChildren = {
  StaffContractorCorePackagesRoute:
    StaffContractorCorePackagesRouteWithChildren,
  StaffContractorCoreAnchorDateRoute: StaffContractorCoreAnchorDateRoute,
  StaffContractorCoreContractTargetsRoute:
    StaffContractorCoreContractTargetsRoute,
  StaffContractorCorePersonTargetsRoute: StaffContractorCorePersonTargetsRoute,
  StaffContractorCoreConfigPatternIdIndexRoute:
    StaffContractorCoreConfigPatternIdIndexRoute,
  StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute:
    StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren,
}

const StaffContractorCoreRouteWithChildren =
  StaffContractorCoreRoute._addFileChildren(StaffContractorCoreRouteChildren)

interface StaffDealListRouteChildren {
  StaffDealListIndexRoute: typeof StaffDealListIndexRoute
}

const StaffDealListRouteChildren: StaffDealListRouteChildren = {
  StaffDealListIndexRoute: StaffDealListIndexRoute,
}

const StaffDealListRouteWithChildren = StaffDealListRoute._addFileChildren(
  StaffDealListRouteChildren,
)

interface StaffDealDealIdLayoutRouteChildren {
  StaffDealDealIdLayoutFlowRouteRoute: typeof StaffDealDealIdLayoutFlowRouteRoute
  StaffDealDealIdLayoutStructureRouteRoute: typeof StaffDealDealIdLayoutStructureRouteRoute
  StaffDealDealIdLayoutIndexIndexRoute: typeof StaffDealDealIdLayoutIndexIndexRoute
}

const StaffDealDealIdLayoutRouteChildren: StaffDealDealIdLayoutRouteChildren = {
  StaffDealDealIdLayoutFlowRouteRoute: StaffDealDealIdLayoutFlowRouteRoute,
  StaffDealDealIdLayoutStructureRouteRoute:
    StaffDealDealIdLayoutStructureRouteRoute,
  StaffDealDealIdLayoutIndexIndexRoute: StaffDealDealIdLayoutIndexIndexRoute,
}

const StaffDealDealIdLayoutRouteWithChildren =
  StaffDealDealIdLayoutRoute._addFileChildren(
    StaffDealDealIdLayoutRouteChildren,
  )

interface StaffDealDealIdRouteChildren {
  StaffDealDealIdLayoutRoute: typeof StaffDealDealIdLayoutRouteWithChildren
}

const StaffDealDealIdRouteChildren: StaffDealDealIdRouteChildren = {
  StaffDealDealIdLayoutRoute: StaffDealDealIdLayoutRouteWithChildren,
}

const StaffDealDealIdRouteWithChildren = StaffDealDealIdRoute._addFileChildren(
  StaffDealDealIdRouteChildren,
)

interface StaffDealRouteChildren {
  StaffDealListRoute: typeof StaffDealListRouteWithChildren
  StaffDealDealIdRoute: typeof StaffDealDealIdRouteWithChildren
  StaffDealAddIndexRoute: typeof StaffDealAddIndexRoute
  StaffDealAddDirectionCompletedRoute: typeof StaffDealAddDirectionCompletedRoute
  StaffDealAddDirectionIndexRoute: typeof StaffDealAddDirectionIndexRoute
}

const StaffDealRouteChildren: StaffDealRouteChildren = {
  StaffDealListRoute: StaffDealListRouteWithChildren,
  StaffDealDealIdRoute: StaffDealDealIdRouteWithChildren,
  StaffDealAddIndexRoute: StaffDealAddIndexRoute,
  StaffDealAddDirectionCompletedRoute: StaffDealAddDirectionCompletedRoute,
  StaffDealAddDirectionIndexRoute: StaffDealAddDirectionIndexRoute,
}

const StaffDealRouteWithChildren = StaffDealRoute._addFileChildren(
  StaffDealRouteChildren,
)

interface StaffDevicesListSettingsRouteLazyRouteChildren {
  StaffDevicesListSettingsIndexRoute: typeof StaffDevicesListSettingsIndexRoute
  StaffDevicesListSettingsCatalogIndexRoute: typeof StaffDevicesListSettingsCatalogIndexRoute
}

const StaffDevicesListSettingsRouteLazyRouteChildren: StaffDevicesListSettingsRouteLazyRouteChildren =
  {
    StaffDevicesListSettingsIndexRoute: StaffDevicesListSettingsIndexRoute,
    StaffDevicesListSettingsCatalogIndexRoute:
      StaffDevicesListSettingsCatalogIndexRoute,
  }

const StaffDevicesListSettingsRouteLazyRouteWithChildren =
  StaffDevicesListSettingsRouteLazyRoute._addFileChildren(
    StaffDevicesListSettingsRouteLazyRouteChildren,
  )

interface StaffDevicesListContractAndCostContractAndCostDealDealRouteChildren {
  StaffDevicesListContractAndCostContractAndCostDealDealIndexRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealIndexRoute
  StaffDevicesListContractAndCostContractAndCostDealDealAllIndexRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealAllIndexRoute
  StaffDevicesListContractAndCostContractAndCostDealDealContractIndexRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealContractIndexRoute
  StaffDevicesListContractAndCostContractAndCostDealDealEstimateIndexRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealEstimateIndexRoute
  StaffDevicesListContractAndCostContractAndCostDealDealOrderIndexRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealOrderIndexRoute
  StaffDevicesListContractAndCostContractAndCostDealDealPaymentIndexRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealPaymentIndexRoute
  StaffDevicesListContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute
}

const StaffDevicesListContractAndCostContractAndCostDealDealRouteChildren: StaffDevicesListContractAndCostContractAndCostDealDealRouteChildren =
  {
    StaffDevicesListContractAndCostContractAndCostDealDealIndexRoute:
      StaffDevicesListContractAndCostContractAndCostDealDealIndexRoute,
    StaffDevicesListContractAndCostContractAndCostDealDealAllIndexRoute:
      StaffDevicesListContractAndCostContractAndCostDealDealAllIndexRoute,
    StaffDevicesListContractAndCostContractAndCostDealDealContractIndexRoute:
      StaffDevicesListContractAndCostContractAndCostDealDealContractIndexRoute,
    StaffDevicesListContractAndCostContractAndCostDealDealEstimateIndexRoute:
      StaffDevicesListContractAndCostContractAndCostDealDealEstimateIndexRoute,
    StaffDevicesListContractAndCostContractAndCostDealDealOrderIndexRoute:
      StaffDevicesListContractAndCostContractAndCostDealDealOrderIndexRoute,
    StaffDevicesListContractAndCostContractAndCostDealDealPaymentIndexRoute:
      StaffDevicesListContractAndCostContractAndCostDealDealPaymentIndexRoute,
    StaffDevicesListContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute:
      StaffDevicesListContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute,
  }

const StaffDevicesListContractAndCostContractAndCostDealDealRouteWithChildren =
  StaffDevicesListContractAndCostContractAndCostDealDealRoute._addFileChildren(
    StaffDevicesListContractAndCostContractAndCostDealDealRouteChildren,
  )

interface StaffDevicesListContractAndCostContractAndCostDealRouteChildren {
  StaffDevicesListContractAndCostContractAndCostDealDealRoute: typeof StaffDevicesListContractAndCostContractAndCostDealDealRouteWithChildren
}

const StaffDevicesListContractAndCostContractAndCostDealRouteChildren: StaffDevicesListContractAndCostContractAndCostDealRouteChildren =
  {
    StaffDevicesListContractAndCostContractAndCostDealDealRoute:
      StaffDevicesListContractAndCostContractAndCostDealDealRouteWithChildren,
  }

const StaffDevicesListContractAndCostContractAndCostDealRouteWithChildren =
  StaffDevicesListContractAndCostContractAndCostDealRoute._addFileChildren(
    StaffDevicesListContractAndCostContractAndCostDealRouteChildren,
  )

interface StaffDevicesListContractAndCostContractAndCostRouteChildren {
  StaffDevicesListContractAndCostContractAndCostIndexRoute: typeof StaffDevicesListContractAndCostContractAndCostIndexRoute
  StaffDevicesListContractAndCostContractAndCostDealRoute: typeof StaffDevicesListContractAndCostContractAndCostDealRouteWithChildren
  StaffDevicesListContractAndCostContractAndCostCostIndexRoute: typeof StaffDevicesListContractAndCostContractAndCostCostIndexRoute
  StaffDevicesListContractAndCostContractAndCostPaymentIndexRoute: typeof StaffDevicesListContractAndCostContractAndCostPaymentIndexRoute
  StaffDevicesListContractAndCostContractAndCostCostPeriodIndexRoute: typeof StaffDevicesListContractAndCostContractAndCostCostPeriodIndexRoute
  StaffDevicesListContractAndCostContractAndCostPaymentPeriodIndexRoute: typeof StaffDevicesListContractAndCostContractAndCostPaymentPeriodIndexRoute
}

const StaffDevicesListContractAndCostContractAndCostRouteChildren: StaffDevicesListContractAndCostContractAndCostRouteChildren =
  {
    StaffDevicesListContractAndCostContractAndCostIndexRoute:
      StaffDevicesListContractAndCostContractAndCostIndexRoute,
    StaffDevicesListContractAndCostContractAndCostDealRoute:
      StaffDevicesListContractAndCostContractAndCostDealRouteWithChildren,
    StaffDevicesListContractAndCostContractAndCostCostIndexRoute:
      StaffDevicesListContractAndCostContractAndCostCostIndexRoute,
    StaffDevicesListContractAndCostContractAndCostPaymentIndexRoute:
      StaffDevicesListContractAndCostContractAndCostPaymentIndexRoute,
    StaffDevicesListContractAndCostContractAndCostCostPeriodIndexRoute:
      StaffDevicesListContractAndCostContractAndCostCostPeriodIndexRoute,
    StaffDevicesListContractAndCostContractAndCostPaymentPeriodIndexRoute:
      StaffDevicesListContractAndCostContractAndCostPaymentPeriodIndexRoute,
  }

const StaffDevicesListContractAndCostContractAndCostRouteWithChildren =
  StaffDevicesListContractAndCostContractAndCostRoute._addFileChildren(
    StaffDevicesListContractAndCostContractAndCostRouteChildren,
  )

interface StaffDevicesListContractAndCostRouteChildren {
  StaffDevicesListContractAndCostContractAndCostRoute: typeof StaffDevicesListContractAndCostContractAndCostRouteWithChildren
}

const StaffDevicesListContractAndCostRouteChildren: StaffDevicesListContractAndCostRouteChildren =
  {
    StaffDevicesListContractAndCostContractAndCostRoute:
      StaffDevicesListContractAndCostContractAndCostRouteWithChildren,
  }

const StaffDevicesListContractAndCostRouteWithChildren =
  StaffDevicesListContractAndCostRoute._addFileChildren(
    StaffDevicesListContractAndCostRouteChildren,
  )

interface StaffDevicesListRouteChildren {
  StaffDevicesListAlertsRoute: typeof StaffDevicesListAlertsRoute
  StaffDevicesListOperationActivityRoute: typeof StaffDevicesListOperationActivityRoute
  StaffDevicesListRuleAndPolicyRoute: typeof StaffDevicesListRuleAndPolicyRoute
  StaffDevicesListIndexRouteLazyRoute: typeof StaffDevicesListIndexRouteLazyRoute
  StaffDevicesListSettingsRouteLazyRoute: typeof StaffDevicesListSettingsRouteLazyRouteWithChildren
  StaffDevicesListContractAndCostRoute: typeof StaffDevicesListContractAndCostRouteWithChildren
  StaffDevicesListInventoriesIndexRoute: typeof StaffDevicesListInventoriesIndexRoute
  StaffDevicesListInventoryIndexRoute: typeof StaffDevicesListInventoryIndexRoute
  StaffDevicesListPeopleIndexRoute: typeof StaffDevicesListPeopleIndexRoute
}

const StaffDevicesListRouteChildren: StaffDevicesListRouteChildren = {
  StaffDevicesListAlertsRoute: StaffDevicesListAlertsRoute,
  StaffDevicesListOperationActivityRoute:
    StaffDevicesListOperationActivityRoute,
  StaffDevicesListRuleAndPolicyRoute: StaffDevicesListRuleAndPolicyRoute,
  StaffDevicesListIndexRouteLazyRoute: StaffDevicesListIndexRouteLazyRoute,
  StaffDevicesListSettingsRouteLazyRoute:
    StaffDevicesListSettingsRouteLazyRouteWithChildren,
  StaffDevicesListContractAndCostRoute:
    StaffDevicesListContractAndCostRouteWithChildren,
  StaffDevicesListInventoriesIndexRoute: StaffDevicesListInventoriesIndexRoute,
  StaffDevicesListInventoryIndexRoute: StaffDevicesListInventoryIndexRoute,
  StaffDevicesListPeopleIndexRoute: StaffDevicesListPeopleIndexRoute,
}

const StaffDevicesListRouteWithChildren =
  StaffDevicesListRoute._addFileChildren(StaffDevicesListRouteChildren)

interface StaffDevicesIdLayoutRouteChildren {
  StaffDevicesIdLayoutIndexRoute: typeof StaffDevicesIdLayoutIndexRoute
  StaffDevicesIdLayoutControlIndexRoute: typeof StaffDevicesIdLayoutControlIndexRoute
  StaffDevicesIdLayoutFilesIndexRoute: typeof StaffDevicesIdLayoutFilesIndexRoute
  StaffDevicesIdLayoutHistoryIndexRoute: typeof StaffDevicesIdLayoutHistoryIndexRoute
  StaffDevicesIdLayoutLifecycleIndexRoute: typeof StaffDevicesIdLayoutLifecycleIndexRoute
  StaffDevicesIdLayoutMdmIndexRoute: typeof StaffDevicesIdLayoutMdmIndexRoute
  StaffDevicesIdLayoutProfileIndexRoute: typeof StaffDevicesIdLayoutProfileIndexRoute
  StaffDevicesIdLayoutStatusIndexRoute: typeof StaffDevicesIdLayoutStatusIndexRoute
}

const StaffDevicesIdLayoutRouteChildren: StaffDevicesIdLayoutRouteChildren = {
  StaffDevicesIdLayoutIndexRoute: StaffDevicesIdLayoutIndexRoute,
  StaffDevicesIdLayoutControlIndexRoute: StaffDevicesIdLayoutControlIndexRoute,
  StaffDevicesIdLayoutFilesIndexRoute: StaffDevicesIdLayoutFilesIndexRoute,
  StaffDevicesIdLayoutHistoryIndexRoute: StaffDevicesIdLayoutHistoryIndexRoute,
  StaffDevicesIdLayoutLifecycleIndexRoute:
    StaffDevicesIdLayoutLifecycleIndexRoute,
  StaffDevicesIdLayoutMdmIndexRoute: StaffDevicesIdLayoutMdmIndexRoute,
  StaffDevicesIdLayoutProfileIndexRoute: StaffDevicesIdLayoutProfileIndexRoute,
  StaffDevicesIdLayoutStatusIndexRoute: StaffDevicesIdLayoutStatusIndexRoute,
}

const StaffDevicesIdLayoutRouteWithChildren =
  StaffDevicesIdLayoutRoute._addFileChildren(StaffDevicesIdLayoutRouteChildren)

interface StaffDevicesIdRouteChildren {
  StaffDevicesIdLayoutRoute: typeof StaffDevicesIdLayoutRouteWithChildren
}

const StaffDevicesIdRouteChildren: StaffDevicesIdRouteChildren = {
  StaffDevicesIdLayoutRoute: StaffDevicesIdLayoutRouteWithChildren,
}

const StaffDevicesIdRouteWithChildren = StaffDevicesIdRoute._addFileChildren(
  StaffDevicesIdRouteChildren,
)

interface StaffDevicesRouteChildren {
  StaffDevicesListRoute: typeof StaffDevicesListRouteWithChildren
  StaffDevicesImportCsvDeviceTypeRouteRoute: typeof StaffDevicesImportCsvDeviceTypeRouteRoute
  StaffDevicesIdRoute: typeof StaffDevicesIdRouteWithChildren
  StaffDevicesAddIndexRoute: typeof StaffDevicesAddIndexRoute
  StaffDevicesExternalItSaasIndexRoute: typeof StaffDevicesExternalItSaasIndexRoute
  StaffDevicesAddDeviceTypeCompletedRoute: typeof StaffDevicesAddDeviceTypeCompletedRoute
  StaffDevicesAddDeviceTypeIndexRoute: typeof StaffDevicesAddDeviceTypeIndexRoute
  StaffDevicesAddCatalogIndexRoute: typeof StaffDevicesAddCatalogIndexRoute
  StaffDevicesAddCatalogDeviceTypeCompletedRoute: typeof StaffDevicesAddCatalogDeviceTypeCompletedRoute
  StaffDevicesAddCatalogDeviceTypeIndexRoute: typeof StaffDevicesAddCatalogDeviceTypeIndexRoute
  StaffDevicesExternalItSaasAppIntegrationIdPreviewIndexRoute: typeof StaffDevicesExternalItSaasAppIntegrationIdPreviewIndexRoute
}

const StaffDevicesRouteChildren: StaffDevicesRouteChildren = {
  StaffDevicesListRoute: StaffDevicesListRouteWithChildren,
  StaffDevicesImportCsvDeviceTypeRouteRoute:
    StaffDevicesImportCsvDeviceTypeRouteRoute,
  StaffDevicesIdRoute: StaffDevicesIdRouteWithChildren,
  StaffDevicesAddIndexRoute: StaffDevicesAddIndexRoute,
  StaffDevicesExternalItSaasIndexRoute: StaffDevicesExternalItSaasIndexRoute,
  StaffDevicesAddDeviceTypeCompletedRoute:
    StaffDevicesAddDeviceTypeCompletedRoute,
  StaffDevicesAddDeviceTypeIndexRoute: StaffDevicesAddDeviceTypeIndexRoute,
  StaffDevicesAddCatalogIndexRoute: StaffDevicesAddCatalogIndexRoute,
  StaffDevicesAddCatalogDeviceTypeCompletedRoute:
    StaffDevicesAddCatalogDeviceTypeCompletedRoute,
  StaffDevicesAddCatalogDeviceTypeIndexRoute:
    StaffDevicesAddCatalogDeviceTypeIndexRoute,
  StaffDevicesExternalItSaasAppIntegrationIdPreviewIndexRoute:
    StaffDevicesExternalItSaasAppIntegrationIdPreviewIndexRoute,
}

const StaffDevicesRouteWithChildren = StaffDevicesRoute._addFileChildren(
  StaffDevicesRouteChildren,
)

interface StaffEquipmentLayoutSettingsRouteLazyRouteChildren {
  StaffEquipmentLayoutSettingsIndexRoute: typeof StaffEquipmentLayoutSettingsIndexRoute
  StaffEquipmentLayoutSettingsEquipmentItemsIndexRoute: typeof StaffEquipmentLayoutSettingsEquipmentItemsIndexRoute
  StaffEquipmentLayoutSettingsEquipmentTypesIndexRoute: typeof StaffEquipmentLayoutSettingsEquipmentTypesIndexRoute
}

const StaffEquipmentLayoutSettingsRouteLazyRouteChildren: StaffEquipmentLayoutSettingsRouteLazyRouteChildren =
  {
    StaffEquipmentLayoutSettingsIndexRoute:
      StaffEquipmentLayoutSettingsIndexRoute,
    StaffEquipmentLayoutSettingsEquipmentItemsIndexRoute:
      StaffEquipmentLayoutSettingsEquipmentItemsIndexRoute,
    StaffEquipmentLayoutSettingsEquipmentTypesIndexRoute:
      StaffEquipmentLayoutSettingsEquipmentTypesIndexRoute,
  }

const StaffEquipmentLayoutSettingsRouteLazyRouteWithChildren =
  StaffEquipmentLayoutSettingsRouteLazyRoute._addFileChildren(
    StaffEquipmentLayoutSettingsRouteLazyRouteChildren,
  )

interface StaffEquipmentLayoutRouteChildren {
  StaffEquipmentLayoutSettingsRouteLazyRoute: typeof StaffEquipmentLayoutSettingsRouteLazyRouteWithChildren
  StaffEquipmentLayoutIndexRoute: typeof StaffEquipmentLayoutIndexRoute
  StaffEquipmentLayoutPlaceholdersOverviewRoute: typeof StaffEquipmentLayoutPlaceholdersOverviewRoute
  StaffEquipmentLayoutPlaceholdersRuleAndPolicyRoute: typeof StaffEquipmentLayoutPlaceholdersRuleAndPolicyRoute
  StaffEquipmentLayoutPlaceholdersSettingsRoute: typeof StaffEquipmentLayoutPlaceholdersSettingsRoute
  StaffEquipmentLayoutAlertsIndexRoute: typeof StaffEquipmentLayoutAlertsIndexRoute
  StaffEquipmentLayoutItemsIndexRoute: typeof StaffEquipmentLayoutItemsIndexRoute
}

const StaffEquipmentLayoutRouteChildren: StaffEquipmentLayoutRouteChildren = {
  StaffEquipmentLayoutSettingsRouteLazyRoute:
    StaffEquipmentLayoutSettingsRouteLazyRouteWithChildren,
  StaffEquipmentLayoutIndexRoute: StaffEquipmentLayoutIndexRoute,
  StaffEquipmentLayoutPlaceholdersOverviewRoute:
    StaffEquipmentLayoutPlaceholdersOverviewRoute,
  StaffEquipmentLayoutPlaceholdersRuleAndPolicyRoute:
    StaffEquipmentLayoutPlaceholdersRuleAndPolicyRoute,
  StaffEquipmentLayoutPlaceholdersSettingsRoute:
    StaffEquipmentLayoutPlaceholdersSettingsRoute,
  StaffEquipmentLayoutAlertsIndexRoute: StaffEquipmentLayoutAlertsIndexRoute,
  StaffEquipmentLayoutItemsIndexRoute: StaffEquipmentLayoutItemsIndexRoute,
}

const StaffEquipmentLayoutRouteWithChildren =
  StaffEquipmentLayoutRoute._addFileChildren(StaffEquipmentLayoutRouteChildren)

interface StaffEquipmentIdLayoutRouteChildren {
  StaffEquipmentIdLayoutIndexLazyRoute: typeof StaffEquipmentIdLayoutIndexLazyRoute
  StaffEquipmentIdLayoutLifecycleIndexLazyRoute: typeof StaffEquipmentIdLayoutLifecycleIndexLazyRoute
  StaffEquipmentIdLayoutStatusIndexLazyRoute: typeof StaffEquipmentIdLayoutStatusIndexLazyRoute
}

const StaffEquipmentIdLayoutRouteChildren: StaffEquipmentIdLayoutRouteChildren =
  {
    StaffEquipmentIdLayoutIndexLazyRoute: StaffEquipmentIdLayoutIndexLazyRoute,
    StaffEquipmentIdLayoutLifecycleIndexLazyRoute:
      StaffEquipmentIdLayoutLifecycleIndexLazyRoute,
    StaffEquipmentIdLayoutStatusIndexLazyRoute:
      StaffEquipmentIdLayoutStatusIndexLazyRoute,
  }

const StaffEquipmentIdLayoutRouteWithChildren =
  StaffEquipmentIdLayoutRoute._addFileChildren(
    StaffEquipmentIdLayoutRouteChildren,
  )

interface StaffEquipmentIdRouteChildren {
  StaffEquipmentIdLayoutRoute: typeof StaffEquipmentIdLayoutRouteWithChildren
}

const StaffEquipmentIdRouteChildren: StaffEquipmentIdRouteChildren = {
  StaffEquipmentIdLayoutRoute: StaffEquipmentIdLayoutRouteWithChildren,
}

const StaffEquipmentIdRouteWithChildren =
  StaffEquipmentIdRoute._addFileChildren(StaffEquipmentIdRouteChildren)

interface StaffEquipmentItemsIdDetailRouteChildren {
  StaffEquipmentItemsIdDetailIndexRoute: typeof StaffEquipmentItemsIdDetailIndexRoute
  StaffEquipmentItemsIdDetailAlertsIndexRoute: typeof StaffEquipmentItemsIdDetailAlertsIndexRoute
  StaffEquipmentItemsIdDetailInventoryIndexRoute: typeof StaffEquipmentItemsIdDetailInventoryIndexRoute
  StaffEquipmentItemsIdDetailRuleAndPolicyIndexRoute: typeof StaffEquipmentItemsIdDetailRuleAndPolicyIndexRoute
  StaffEquipmentItemsIdDetailProfileIndexLazyRoute: typeof StaffEquipmentItemsIdDetailProfileIndexLazyRoute
}

const StaffEquipmentItemsIdDetailRouteChildren: StaffEquipmentItemsIdDetailRouteChildren =
  {
    StaffEquipmentItemsIdDetailIndexRoute:
      StaffEquipmentItemsIdDetailIndexRoute,
    StaffEquipmentItemsIdDetailAlertsIndexRoute:
      StaffEquipmentItemsIdDetailAlertsIndexRoute,
    StaffEquipmentItemsIdDetailInventoryIndexRoute:
      StaffEquipmentItemsIdDetailInventoryIndexRoute,
    StaffEquipmentItemsIdDetailRuleAndPolicyIndexRoute:
      StaffEquipmentItemsIdDetailRuleAndPolicyIndexRoute,
    StaffEquipmentItemsIdDetailProfileIndexLazyRoute:
      StaffEquipmentItemsIdDetailProfileIndexLazyRoute,
  }

const StaffEquipmentItemsIdDetailRouteWithChildren =
  StaffEquipmentItemsIdDetailRoute._addFileChildren(
    StaffEquipmentItemsIdDetailRouteChildren,
  )

interface StaffEquipmentItemsIdRouteChildren {
  StaffEquipmentItemsIdDetailRoute: typeof StaffEquipmentItemsIdDetailRouteWithChildren
}

const StaffEquipmentItemsIdRouteChildren: StaffEquipmentItemsIdRouteChildren = {
  StaffEquipmentItemsIdDetailRoute:
    StaffEquipmentItemsIdDetailRouteWithChildren,
}

const StaffEquipmentItemsIdRouteWithChildren =
  StaffEquipmentItemsIdRoute._addFileChildren(
    StaffEquipmentItemsIdRouteChildren,
  )

interface StaffEquipmentRouteChildren {
  StaffEquipmentLayoutRoute: typeof StaffEquipmentLayoutRouteWithChildren
  StaffEquipmentIdRoute: typeof StaffEquipmentIdRouteWithChildren
  StaffEquipmentAddSelectIndexRoute: typeof StaffEquipmentAddSelectIndexRoute
  StaffEquipmentAddIndexRoute: typeof StaffEquipmentAddIndexRoute
  StaffEquipmentImportCsvIndexRoute: typeof StaffEquipmentImportCsvIndexRoute
  StaffEquipmentItemsIdRoute: typeof StaffEquipmentItemsIdRouteWithChildren
}

const StaffEquipmentRouteChildren: StaffEquipmentRouteChildren = {
  StaffEquipmentLayoutRoute: StaffEquipmentLayoutRouteWithChildren,
  StaffEquipmentIdRoute: StaffEquipmentIdRouteWithChildren,
  StaffEquipmentAddSelectIndexRoute: StaffEquipmentAddSelectIndexRoute,
  StaffEquipmentAddIndexRoute: StaffEquipmentAddIndexRoute,
  StaffEquipmentImportCsvIndexRoute: StaffEquipmentImportCsvIndexRoute,
  StaffEquipmentItemsIdRoute: StaffEquipmentItemsIdRouteWithChildren,
}

const StaffEquipmentRouteWithChildren = StaffEquipmentRoute._addFileChildren(
  StaffEquipmentRouteChildren,
)

interface StaffFleetsLayoutRouteChildren {
  StaffFleetsLayoutAlertsRoute: typeof StaffFleetsLayoutAlertsRoute
  StaffFleetsLayoutOverviewRoute: typeof StaffFleetsLayoutOverviewRoute
  StaffFleetsLayoutRuleAndPolicyRoute: typeof StaffFleetsLayoutRuleAndPolicyRoute
  StaffFleetsLayoutSettingsRoute: typeof StaffFleetsLayoutSettingsRoute
  StaffFleetsLayoutListIndexRoute: typeof StaffFleetsLayoutListIndexRoute
}

const StaffFleetsLayoutRouteChildren: StaffFleetsLayoutRouteChildren = {
  StaffFleetsLayoutAlertsRoute: StaffFleetsLayoutAlertsRoute,
  StaffFleetsLayoutOverviewRoute: StaffFleetsLayoutOverviewRoute,
  StaffFleetsLayoutRuleAndPolicyRoute: StaffFleetsLayoutRuleAndPolicyRoute,
  StaffFleetsLayoutSettingsRoute: StaffFleetsLayoutSettingsRoute,
  StaffFleetsLayoutListIndexRoute: StaffFleetsLayoutListIndexRoute,
}

const StaffFleetsLayoutRouteWithChildren =
  StaffFleetsLayoutRoute._addFileChildren(StaffFleetsLayoutRouteChildren)

interface StaffFleetsIdLayoutRouteChildren {
  StaffFleetsIdLayoutProfileIndexLazyRoute: typeof StaffFleetsIdLayoutProfileIndexLazyRoute
}

const StaffFleetsIdLayoutRouteChildren: StaffFleetsIdLayoutRouteChildren = {
  StaffFleetsIdLayoutProfileIndexLazyRoute:
    StaffFleetsIdLayoutProfileIndexLazyRoute,
}

const StaffFleetsIdLayoutRouteWithChildren =
  StaffFleetsIdLayoutRoute._addFileChildren(StaffFleetsIdLayoutRouteChildren)

interface StaffFleetsIdRouteChildren {
  StaffFleetsIdLayoutRoute: typeof StaffFleetsIdLayoutRouteWithChildren
}

const StaffFleetsIdRouteChildren: StaffFleetsIdRouteChildren = {
  StaffFleetsIdLayoutRoute: StaffFleetsIdLayoutRouteWithChildren,
}

const StaffFleetsIdRouteWithChildren = StaffFleetsIdRoute._addFileChildren(
  StaffFleetsIdRouteChildren,
)

interface StaffFleetsRouteChildren {
  StaffFleetsLayoutRoute: typeof StaffFleetsLayoutRouteWithChildren
  StaffFleetsIdRoute: typeof StaffFleetsIdRouteWithChildren
  StaffFleetsAddSelectIndexRoute: typeof StaffFleetsAddSelectIndexRoute
  StaffFleetsAddIndexRoute: typeof StaffFleetsAddIndexRoute
}

const StaffFleetsRouteChildren: StaffFleetsRouteChildren = {
  StaffFleetsLayoutRoute: StaffFleetsLayoutRouteWithChildren,
  StaffFleetsIdRoute: StaffFleetsIdRouteWithChildren,
  StaffFleetsAddSelectIndexRoute: StaffFleetsAddSelectIndexRoute,
  StaffFleetsAddIndexRoute: StaffFleetsAddIndexRoute,
}

const StaffFleetsRouteWithChildren = StaffFleetsRoute._addFileChildren(
  StaffFleetsRouteChildren,
)

interface StaffGaOperationCorePackagesRouteChildren {
  StaffGaOperationCorePackagesIndexRoute: typeof StaffGaOperationCorePackagesIndexRoute
  StaffGaOperationCorePackagesArchivesIndexRoute: typeof StaffGaOperationCorePackagesArchivesIndexRoute
  StaffGaOperationCorePackagesConfigsIndexRoute: typeof StaffGaOperationCorePackagesConfigsIndexRoute
}

const StaffGaOperationCorePackagesRouteChildren: StaffGaOperationCorePackagesRouteChildren =
  {
    StaffGaOperationCorePackagesIndexRoute:
      StaffGaOperationCorePackagesIndexRoute,
    StaffGaOperationCorePackagesArchivesIndexRoute:
      StaffGaOperationCorePackagesArchivesIndexRoute,
    StaffGaOperationCorePackagesConfigsIndexRoute:
      StaffGaOperationCorePackagesConfigsIndexRoute,
  }

const StaffGaOperationCorePackagesRouteWithChildren =
  StaffGaOperationCorePackagesRoute._addFileChildren(
    StaffGaOperationCorePackagesRouteChildren,
  )

interface StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren {
  StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute: typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute: typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
}

const StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren: StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren =
  {
    StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute:
      StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute,
    StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute:
      StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute,
  }

const StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren =
  StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute._addFileChildren(
    StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren,
  )

interface StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren {
  StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute: typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren
}

const StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren: StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren =
  {
    StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute:
      StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren,
  }

const StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren =
  StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute._addFileChildren(
    StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren,
  )

interface StaffGaOperationCoreRouteChildren {
  StaffGaOperationCorePackagesRoute: typeof StaffGaOperationCorePackagesRouteWithChildren
  StaffGaOperationCoreConfigPatternIdIndexRoute: typeof StaffGaOperationCoreConfigPatternIdIndexRoute
  StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute: typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren
}

const StaffGaOperationCoreRouteChildren: StaffGaOperationCoreRouteChildren = {
  StaffGaOperationCorePackagesRoute:
    StaffGaOperationCorePackagesRouteWithChildren,
  StaffGaOperationCoreConfigPatternIdIndexRoute:
    StaffGaOperationCoreConfigPatternIdIndexRoute,
  StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute:
    StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren,
}

const StaffGaOperationCoreRouteWithChildren =
  StaffGaOperationCoreRoute._addFileChildren(StaffGaOperationCoreRouteChildren)

interface StaffIdsLayoutRouteChildren {
  StaffIdsLayoutIndexRoute: typeof StaffIdsLayoutIndexRoute
  StaffIdsLayoutPlaceholdersAlertsRoute: typeof StaffIdsLayoutPlaceholdersAlertsRoute
  StaffIdsLayoutPlaceholdersGroupIdRoute: typeof StaffIdsLayoutPlaceholdersGroupIdRoute
  StaffIdsLayoutPlaceholdersOperationActivityRoute: typeof StaffIdsLayoutPlaceholdersOperationActivityRoute
  StaffIdsLayoutPlaceholdersOverviewRoute: typeof StaffIdsLayoutPlaceholdersOverviewRoute
  StaffIdsLayoutPlaceholdersRuleAndPolicyRoute: typeof StaffIdsLayoutPlaceholdersRuleAndPolicyRoute
  StaffIdsLayoutPlaceholdersSettingsRoute: typeof StaffIdsLayoutPlaceholdersSettingsRoute
  StaffIdsLayoutPeopleIndexRoute: typeof StaffIdsLayoutPeopleIndexRoute
}

const StaffIdsLayoutRouteChildren: StaffIdsLayoutRouteChildren = {
  StaffIdsLayoutIndexRoute: StaffIdsLayoutIndexRoute,
  StaffIdsLayoutPlaceholdersAlertsRoute: StaffIdsLayoutPlaceholdersAlertsRoute,
  StaffIdsLayoutPlaceholdersGroupIdRoute:
    StaffIdsLayoutPlaceholdersGroupIdRoute,
  StaffIdsLayoutPlaceholdersOperationActivityRoute:
    StaffIdsLayoutPlaceholdersOperationActivityRoute,
  StaffIdsLayoutPlaceholdersOverviewRoute:
    StaffIdsLayoutPlaceholdersOverviewRoute,
  StaffIdsLayoutPlaceholdersRuleAndPolicyRoute:
    StaffIdsLayoutPlaceholdersRuleAndPolicyRoute,
  StaffIdsLayoutPlaceholdersSettingsRoute:
    StaffIdsLayoutPlaceholdersSettingsRoute,
  StaffIdsLayoutPeopleIndexRoute: StaffIdsLayoutPeopleIndexRoute,
}

const StaffIdsLayoutRouteWithChildren = StaffIdsLayoutRoute._addFileChildren(
  StaffIdsLayoutRouteChildren,
)

interface StaffIdsGroupIdIdIdRouteChildren {
  StaffIdsGroupIdIdIdIndexRoute: typeof StaffIdsGroupIdIdIdIndexRoute
  StaffIdsGroupIdIdIdDetailIndexRoute: typeof StaffIdsGroupIdIdIdDetailIndexRoute
  StaffIdsGroupIdIdIdDevicesIndexRoute: typeof StaffIdsGroupIdIdIdDevicesIndexRoute
  StaffIdsGroupIdIdIdMembersIndexRoute: typeof StaffIdsGroupIdIdIdMembersIndexRoute
  StaffIdsGroupIdIdIdRuleAndPolicyIndexRoute: typeof StaffIdsGroupIdIdIdRuleAndPolicyIndexRoute
  StaffIdsGroupIdIdIdSecurityAndAuthIndexRoute: typeof StaffIdsGroupIdIdIdSecurityAndAuthIndexRoute
  StaffIdsGroupIdIdIdSoftwaresIndexRoute: typeof StaffIdsGroupIdIdIdSoftwaresIndexRoute
}

const StaffIdsGroupIdIdIdRouteChildren: StaffIdsGroupIdIdIdRouteChildren = {
  StaffIdsGroupIdIdIdIndexRoute: StaffIdsGroupIdIdIdIndexRoute,
  StaffIdsGroupIdIdIdDetailIndexRoute: StaffIdsGroupIdIdIdDetailIndexRoute,
  StaffIdsGroupIdIdIdDevicesIndexRoute: StaffIdsGroupIdIdIdDevicesIndexRoute,
  StaffIdsGroupIdIdIdMembersIndexRoute: StaffIdsGroupIdIdIdMembersIndexRoute,
  StaffIdsGroupIdIdIdRuleAndPolicyIndexRoute:
    StaffIdsGroupIdIdIdRuleAndPolicyIndexRoute,
  StaffIdsGroupIdIdIdSecurityAndAuthIndexRoute:
    StaffIdsGroupIdIdIdSecurityAndAuthIndexRoute,
  StaffIdsGroupIdIdIdSoftwaresIndexRoute:
    StaffIdsGroupIdIdIdSoftwaresIndexRoute,
}

const StaffIdsGroupIdIdIdRouteWithChildren =
  StaffIdsGroupIdIdIdRoute._addFileChildren(StaffIdsGroupIdIdIdRouteChildren)

interface StaffIdsGroupIdIdRouteChildren {
  StaffIdsGroupIdIdIdRoute: typeof StaffIdsGroupIdIdIdRouteWithChildren
}

const StaffIdsGroupIdIdRouteChildren: StaffIdsGroupIdIdRouteChildren = {
  StaffIdsGroupIdIdIdRoute: StaffIdsGroupIdIdIdRouteWithChildren,
}

const StaffIdsGroupIdIdRouteWithChildren =
  StaffIdsGroupIdIdRoute._addFileChildren(StaffIdsGroupIdIdRouteChildren)

interface StaffIdsRouteChildren {
  StaffIdsLayoutRoute: typeof StaffIdsLayoutRouteWithChildren
  StaffIdsGroupIdIdRoute: typeof StaffIdsGroupIdIdRouteWithChildren
  StaffIdsGroupIdAddIndexRoute: typeof StaffIdsGroupIdAddIndexRoute
  StaffIdsGroupIdAddFromScratchCompletedRoute: typeof StaffIdsGroupIdAddFromScratchCompletedRoute
  StaffIdsGroupIdAddFromScratchIndexRoute: typeof StaffIdsGroupIdAddFromScratchIndexRoute
}

const StaffIdsRouteChildren: StaffIdsRouteChildren = {
  StaffIdsLayoutRoute: StaffIdsLayoutRouteWithChildren,
  StaffIdsGroupIdIdRoute: StaffIdsGroupIdIdRouteWithChildren,
  StaffIdsGroupIdAddIndexRoute: StaffIdsGroupIdAddIndexRoute,
  StaffIdsGroupIdAddFromScratchCompletedRoute:
    StaffIdsGroupIdAddFromScratchCompletedRoute,
  StaffIdsGroupIdAddFromScratchIndexRoute:
    StaffIdsGroupIdAddFromScratchIndexRoute,
}

const StaffIdsRouteWithChildren = StaffIdsRoute._addFileChildren(
  StaffIdsRouteChildren,
)

interface StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRouteChildren {
  StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDataIndexRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDataIndexRoute
  StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDetailIndexRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDetailIndexRoute
  StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutOperationActivityIndexRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutOperationActivityIndexRoute
}

const StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRouteChildren: StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRouteChildren =
  {
    StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDataIndexRoute:
      StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDataIndexRoute,
    StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDetailIndexRoute:
      StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDetailIndexRoute,
    StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutOperationActivityIndexRoute:
      StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutOperationActivityIndexRoute,
  }

const StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRouteWithChildren =
  StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRoute._addFileChildren(
    StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRouteChildren,
  )

interface StaffItOperationCoreDetailOperationInstancesInstanceIdRouteChildren {
  StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRouteWithChildren
  StaffItOperationCoreDetailOperationInstancesInstanceIdIndexRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdIndexRoute
}

const StaffItOperationCoreDetailOperationInstancesInstanceIdRouteChildren: StaffItOperationCoreDetailOperationInstancesInstanceIdRouteChildren =
  {
    StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRoute:
      StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRouteWithChildren,
    StaffItOperationCoreDetailOperationInstancesInstanceIdIndexRoute:
      StaffItOperationCoreDetailOperationInstancesInstanceIdIndexRoute,
  }

const StaffItOperationCoreDetailOperationInstancesInstanceIdRouteWithChildren =
  StaffItOperationCoreDetailOperationInstancesInstanceIdRoute._addFileChildren(
    StaffItOperationCoreDetailOperationInstancesInstanceIdRouteChildren,
  )

interface StaffItOperationCoreDetailRouteChildren {
  StaffItOperationCoreDetailOperationInstancesInstanceIdRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdRouteWithChildren
}

const StaffItOperationCoreDetailRouteChildren: StaffItOperationCoreDetailRouteChildren =
  {
    StaffItOperationCoreDetailOperationInstancesInstanceIdRoute:
      StaffItOperationCoreDetailOperationInstancesInstanceIdRouteWithChildren,
  }

const StaffItOperationCoreDetailRouteWithChildren =
  StaffItOperationCoreDetailRoute._addFileChildren(
    StaffItOperationCoreDetailRouteChildren,
  )

interface StaffItOperationCoreRootInHousePackagesPackageIdRouteChildren {
  StaffItOperationCoreRootInHousePackagesPackageIdStartTargetsRoute: typeof StaffItOperationCoreRootInHousePackagesPackageIdStartTargetsRoute
}

const StaffItOperationCoreRootInHousePackagesPackageIdRouteChildren: StaffItOperationCoreRootInHousePackagesPackageIdRouteChildren =
  {
    StaffItOperationCoreRootInHousePackagesPackageIdStartTargetsRoute:
      StaffItOperationCoreRootInHousePackagesPackageIdStartTargetsRoute,
  }

const StaffItOperationCoreRootInHousePackagesPackageIdRouteWithChildren =
  StaffItOperationCoreRootInHousePackagesPackageIdRoute._addFileChildren(
    StaffItOperationCoreRootInHousePackagesPackageIdRouteChildren,
  )

interface StaffItOperationCoreRootInHousePackagesRouteRouteChildren {
  StaffItOperationCoreRootInHousePackagesPackageIdRoute: typeof StaffItOperationCoreRootInHousePackagesPackageIdRouteWithChildren
  StaffItOperationCoreRootInHousePackagesIndexRoute: typeof StaffItOperationCoreRootInHousePackagesIndexRoute
}

const StaffItOperationCoreRootInHousePackagesRouteRouteChildren: StaffItOperationCoreRootInHousePackagesRouteRouteChildren =
  {
    StaffItOperationCoreRootInHousePackagesPackageIdRoute:
      StaffItOperationCoreRootInHousePackagesPackageIdRouteWithChildren,
    StaffItOperationCoreRootInHousePackagesIndexRoute:
      StaffItOperationCoreRootInHousePackagesIndexRoute,
  }

const StaffItOperationCoreRootInHousePackagesRouteRouteWithChildren =
  StaffItOperationCoreRootInHousePackagesRouteRoute._addFileChildren(
    StaffItOperationCoreRootInHousePackagesRouteRouteChildren,
  )

interface StaffItOperationCoreRootPackagesRouteRouteChildren {
  StaffItOperationCoreRootPackagesPackageIdRoute: typeof StaffItOperationCoreRootPackagesPackageIdRoute
  StaffItOperationCoreRootPackagesIndexRoute: typeof StaffItOperationCoreRootPackagesIndexRoute
}

const StaffItOperationCoreRootPackagesRouteRouteChildren: StaffItOperationCoreRootPackagesRouteRouteChildren =
  {
    StaffItOperationCoreRootPackagesPackageIdRoute:
      StaffItOperationCoreRootPackagesPackageIdRoute,
    StaffItOperationCoreRootPackagesIndexRoute:
      StaffItOperationCoreRootPackagesIndexRoute,
  }

const StaffItOperationCoreRootPackagesRouteRouteWithChildren =
  StaffItOperationCoreRootPackagesRouteRoute._addFileChildren(
    StaffItOperationCoreRootPackagesRouteRouteChildren,
  )

interface StaffItOperationCoreRootRouteChildren {
  StaffItOperationCoreRootInHousePackagesRouteRoute: typeof StaffItOperationCoreRootInHousePackagesRouteRouteWithChildren
  StaffItOperationCoreRootPackagesRouteRoute: typeof StaffItOperationCoreRootPackagesRouteRouteWithChildren
  StaffItOperationCoreRootArchivesIndexRoute: typeof StaffItOperationCoreRootArchivesIndexRoute
  StaffItOperationCoreRootConfigIndexRoute: typeof StaffItOperationCoreRootConfigIndexRoute
}

const StaffItOperationCoreRootRouteChildren: StaffItOperationCoreRootRouteChildren =
  {
    StaffItOperationCoreRootInHousePackagesRouteRoute:
      StaffItOperationCoreRootInHousePackagesRouteRouteWithChildren,
    StaffItOperationCoreRootPackagesRouteRoute:
      StaffItOperationCoreRootPackagesRouteRouteWithChildren,
    StaffItOperationCoreRootArchivesIndexRoute:
      StaffItOperationCoreRootArchivesIndexRoute,
    StaffItOperationCoreRootConfigIndexRoute:
      StaffItOperationCoreRootConfigIndexRoute,
  }

const StaffItOperationCoreRootRouteWithChildren =
  StaffItOperationCoreRootRoute._addFileChildren(
    StaffItOperationCoreRootRouteChildren,
  )

interface StaffItOperationCoreRouteChildren {
  StaffItOperationCoreDetailRoute: typeof StaffItOperationCoreDetailRouteWithChildren
  StaffItOperationCoreRootRoute: typeof StaffItOperationCoreRootRouteWithChildren
  StaffItOperationCoreAnchorDateRoute: typeof StaffItOperationCoreAnchorDateRoute
  StaffItOperationCoreSelfReportConfirmationRoute: typeof StaffItOperationCoreSelfReportConfirmationRoute
  StaffItOperationCoreIndexRoute: typeof StaffItOperationCoreIndexRoute
  StaffItOperationCoreDeviceTargetsIndexRoute: typeof StaffItOperationCoreDeviceTargetsIndexRoute
  StaffItOperationCorePersonTargetsIndexRoute: typeof StaffItOperationCorePersonTargetsIndexRoute
  StaffItOperationCoreConfigPatternIdIndexRoute: typeof StaffItOperationCoreConfigPatternIdIndexRoute
  StaffItOperationCoreSelfReportPatternsPatternIdIndexRoute: typeof StaffItOperationCoreSelfReportPatternsPatternIdIndexRoute
}

const StaffItOperationCoreRouteChildren: StaffItOperationCoreRouteChildren = {
  StaffItOperationCoreDetailRoute: StaffItOperationCoreDetailRouteWithChildren,
  StaffItOperationCoreRootRoute: StaffItOperationCoreRootRouteWithChildren,
  StaffItOperationCoreAnchorDateRoute: StaffItOperationCoreAnchorDateRoute,
  StaffItOperationCoreSelfReportConfirmationRoute:
    StaffItOperationCoreSelfReportConfirmationRoute,
  StaffItOperationCoreIndexRoute: StaffItOperationCoreIndexRoute,
  StaffItOperationCoreDeviceTargetsIndexRoute:
    StaffItOperationCoreDeviceTargetsIndexRoute,
  StaffItOperationCorePersonTargetsIndexRoute:
    StaffItOperationCorePersonTargetsIndexRoute,
  StaffItOperationCoreConfigPatternIdIndexRoute:
    StaffItOperationCoreConfigPatternIdIndexRoute,
  StaffItOperationCoreSelfReportPatternsPatternIdIndexRoute:
    StaffItOperationCoreSelfReportPatternsPatternIdIndexRoute,
}

const StaffItOperationCoreRouteWithChildren =
  StaffItOperationCoreRoute._addFileChildren(StaffItOperationCoreRouteChildren)

interface StaffLaborCorePackagesSettingsRouteChildren {
  StaffLaborCorePackagesSettingsIndexRoute: typeof StaffLaborCorePackagesSettingsIndexRoute
}

const StaffLaborCorePackagesSettingsRouteChildren: StaffLaborCorePackagesSettingsRouteChildren =
  {
    StaffLaborCorePackagesSettingsIndexRoute:
      StaffLaborCorePackagesSettingsIndexRoute,
  }

const StaffLaborCorePackagesSettingsRouteWithChildren =
  StaffLaborCorePackagesSettingsRoute._addFileChildren(
    StaffLaborCorePackagesSettingsRouteChildren,
  )

interface StaffLaborCorePackagesRouteChildren {
  StaffLaborCorePackagesSettingsRoute: typeof StaffLaborCorePackagesSettingsRouteWithChildren
  StaffLaborCorePackagesIndexRoute: typeof StaffLaborCorePackagesIndexRoute
  StaffLaborCorePackagesArchivesIndexRoute: typeof StaffLaborCorePackagesArchivesIndexRoute
  StaffLaborCorePackagesConfigsIndexRoute: typeof StaffLaborCorePackagesConfigsIndexRoute
}

const StaffLaborCorePackagesRouteChildren: StaffLaborCorePackagesRouteChildren =
  {
    StaffLaborCorePackagesSettingsRoute:
      StaffLaborCorePackagesSettingsRouteWithChildren,
    StaffLaborCorePackagesIndexRoute: StaffLaborCorePackagesIndexRoute,
    StaffLaborCorePackagesArchivesIndexRoute:
      StaffLaborCorePackagesArchivesIndexRoute,
    StaffLaborCorePackagesConfigsIndexRoute:
      StaffLaborCorePackagesConfigsIndexRoute,
  }

const StaffLaborCorePackagesRouteWithChildren =
  StaffLaborCorePackagesRoute._addFileChildren(
    StaffLaborCorePackagesRouteChildren,
  )

interface StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren {
  StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute: typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute: typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
}

const StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren: StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren =
  {
    StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute:
      StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute,
    StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute:
      StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute,
  }

const StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren =
  StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute._addFileChildren(
    StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren,
  )

interface StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren {
  StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute: typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren
}

const StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren: StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren =
  {
    StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute:
      StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren,
  }

const StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren =
  StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute._addFileChildren(
    StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren,
  )

interface StaffLaborCoreRouteChildren {
  StaffLaborCorePackagesRoute: typeof StaffLaborCorePackagesRouteWithChildren
  StaffLaborCoreAnchorDateRoute: typeof StaffLaborCoreAnchorDateRoute
  StaffLaborCoreContractTargetsRoute: typeof StaffLaborCoreContractTargetsRoute
  StaffLaborCoreGovernmentApplicationConfirmationRoute: typeof StaffLaborCoreGovernmentApplicationConfirmationRoute
  StaffLaborCorePersonTargetsRoute: typeof StaffLaborCorePersonTargetsRoute
  StaffLaborCoreYearEndAdjustmentConfirmationRoute: typeof StaffLaborCoreYearEndAdjustmentConfirmationRoute
  StaffLaborCoreGroupNameLazyRoute: typeof StaffLaborCoreGroupNameLazyRoute
  StaffLaborCoreSettingsEgovCallbackRoute: typeof StaffLaborCoreSettingsEgovCallbackRoute
  StaffLaborCoreSettingsProfileProfileIdRoute: typeof StaffLaborCoreSettingsProfileProfileIdRoute
  StaffLaborCoreConfigPatternIdIndexRoute: typeof StaffLaborCoreConfigPatternIdIndexRoute
  StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute: typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren
}

const StaffLaborCoreRouteChildren: StaffLaborCoreRouteChildren = {
  StaffLaborCorePackagesRoute: StaffLaborCorePackagesRouteWithChildren,
  StaffLaborCoreAnchorDateRoute: StaffLaborCoreAnchorDateRoute,
  StaffLaborCoreContractTargetsRoute: StaffLaborCoreContractTargetsRoute,
  StaffLaborCoreGovernmentApplicationConfirmationRoute:
    StaffLaborCoreGovernmentApplicationConfirmationRoute,
  StaffLaborCorePersonTargetsRoute: StaffLaborCorePersonTargetsRoute,
  StaffLaborCoreYearEndAdjustmentConfirmationRoute:
    StaffLaborCoreYearEndAdjustmentConfirmationRoute,
  StaffLaborCoreGroupNameLazyRoute: StaffLaborCoreGroupNameLazyRoute,
  StaffLaborCoreSettingsEgovCallbackRoute:
    StaffLaborCoreSettingsEgovCallbackRoute,
  StaffLaborCoreSettingsProfileProfileIdRoute:
    StaffLaborCoreSettingsProfileProfileIdRoute,
  StaffLaborCoreConfigPatternIdIndexRoute:
    StaffLaborCoreConfigPatternIdIndexRoute,
  StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute:
    StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren,
}

const StaffLaborCoreRouteWithChildren = StaffLaborCoreRoute._addFileChildren(
  StaffLaborCoreRouteChildren,
)

interface StaffLicensesListRouteChildren {
  StaffLicensesListIndexRouteRoute: typeof StaffLicensesListIndexRouteRoute
  StaffLicensesListAlertsIndexRoute: typeof StaffLicensesListAlertsIndexRoute
  StaffLicensesListContractAndCostIndexRoute: typeof StaffLicensesListContractAndCostIndexRoute
  StaffLicensesListInventoryIndexRoute: typeof StaffLicensesListInventoryIndexRoute
  StaffLicensesListOperationActivityIndexRoute: typeof StaffLicensesListOperationActivityIndexRoute
  StaffLicensesListPeopleIndexRoute: typeof StaffLicensesListPeopleIndexRoute
  StaffLicensesListRuleAndPolicyIndexRoute: typeof StaffLicensesListRuleAndPolicyIndexRoute
  StaffLicensesListSettingsIndexRoute: typeof StaffLicensesListSettingsIndexRoute
}

const StaffLicensesListRouteChildren: StaffLicensesListRouteChildren = {
  StaffLicensesListIndexRouteRoute: StaffLicensesListIndexRouteRoute,
  StaffLicensesListAlertsIndexRoute: StaffLicensesListAlertsIndexRoute,
  StaffLicensesListContractAndCostIndexRoute:
    StaffLicensesListContractAndCostIndexRoute,
  StaffLicensesListInventoryIndexRoute: StaffLicensesListInventoryIndexRoute,
  StaffLicensesListOperationActivityIndexRoute:
    StaffLicensesListOperationActivityIndexRoute,
  StaffLicensesListPeopleIndexRoute: StaffLicensesListPeopleIndexRoute,
  StaffLicensesListRuleAndPolicyIndexRoute:
    StaffLicensesListRuleAndPolicyIndexRoute,
  StaffLicensesListSettingsIndexRoute: StaffLicensesListSettingsIndexRoute,
}

const StaffLicensesListRouteWithChildren =
  StaffLicensesListRoute._addFileChildren(StaffLicensesListRouteChildren)

interface StaffLicensesIdProfileRouteChildren {
  StaffLicensesIdProfileIndexLazyRoute: typeof StaffLicensesIdProfileIndexLazyRoute
  StaffLicensesIdProfileAssignmentsIndexRoute: typeof StaffLicensesIdProfileAssignmentsIndexRoute
  StaffLicensesIdProfilePeopleIndexRoute: typeof StaffLicensesIdProfilePeopleIndexRoute
  StaffLicensesIdProfileRuleAndPolicyIndexRoute: typeof StaffLicensesIdProfileRuleAndPolicyIndexRoute
  StaffLicensesIdProfileServicePlansIndexRoute: typeof StaffLicensesIdProfileServicePlansIndexRoute
}

const StaffLicensesIdProfileRouteChildren: StaffLicensesIdProfileRouteChildren =
  {
    StaffLicensesIdProfileIndexLazyRoute: StaffLicensesIdProfileIndexLazyRoute,
    StaffLicensesIdProfileAssignmentsIndexRoute:
      StaffLicensesIdProfileAssignmentsIndexRoute,
    StaffLicensesIdProfilePeopleIndexRoute:
      StaffLicensesIdProfilePeopleIndexRoute,
    StaffLicensesIdProfileRuleAndPolicyIndexRoute:
      StaffLicensesIdProfileRuleAndPolicyIndexRoute,
    StaffLicensesIdProfileServicePlansIndexRoute:
      StaffLicensesIdProfileServicePlansIndexRoute,
  }

const StaffLicensesIdProfileRouteWithChildren =
  StaffLicensesIdProfileRoute._addFileChildren(
    StaffLicensesIdProfileRouteChildren,
  )

interface StaffLicensesIdServicePlansLicenseServiceIdDetailRouteChildren {
  StaffLicensesIdServicePlansLicenseServiceIdDetailAccountsIndexRoute: typeof StaffLicensesIdServicePlansLicenseServiceIdDetailAccountsIndexRoute
}

const StaffLicensesIdServicePlansLicenseServiceIdDetailRouteChildren: StaffLicensesIdServicePlansLicenseServiceIdDetailRouteChildren =
  {
    StaffLicensesIdServicePlansLicenseServiceIdDetailAccountsIndexRoute:
      StaffLicensesIdServicePlansLicenseServiceIdDetailAccountsIndexRoute,
  }

const StaffLicensesIdServicePlansLicenseServiceIdDetailRouteWithChildren =
  StaffLicensesIdServicePlansLicenseServiceIdDetailRoute._addFileChildren(
    StaffLicensesIdServicePlansLicenseServiceIdDetailRouteChildren,
  )

interface StaffLicensesIdServicePlansLicenseServiceIdRouteChildren {
  StaffLicensesIdServicePlansLicenseServiceIdDetailRoute: typeof StaffLicensesIdServicePlansLicenseServiceIdDetailRouteWithChildren
}

const StaffLicensesIdServicePlansLicenseServiceIdRouteChildren: StaffLicensesIdServicePlansLicenseServiceIdRouteChildren =
  {
    StaffLicensesIdServicePlansLicenseServiceIdDetailRoute:
      StaffLicensesIdServicePlansLicenseServiceIdDetailRouteWithChildren,
  }

const StaffLicensesIdServicePlansLicenseServiceIdRouteWithChildren =
  StaffLicensesIdServicePlansLicenseServiceIdRoute._addFileChildren(
    StaffLicensesIdServicePlansLicenseServiceIdRouteChildren,
  )

interface StaffLicensesIdRouteChildren {
  StaffLicensesIdProfileRoute: typeof StaffLicensesIdProfileRouteWithChildren
  StaffLicensesIdServicePlansLicenseServiceIdRoute: typeof StaffLicensesIdServicePlansLicenseServiceIdRouteWithChildren
}

const StaffLicensesIdRouteChildren: StaffLicensesIdRouteChildren = {
  StaffLicensesIdProfileRoute: StaffLicensesIdProfileRouteWithChildren,
  StaffLicensesIdServicePlansLicenseServiceIdRoute:
    StaffLicensesIdServicePlansLicenseServiceIdRouteWithChildren,
}

const StaffLicensesIdRouteWithChildren = StaffLicensesIdRoute._addFileChildren(
  StaffLicensesIdRouteChildren,
)

interface StaffLicensesRouteChildren {
  StaffLicensesListRoute: typeof StaffLicensesListRouteWithChildren
  StaffLicensesIdRoute: typeof StaffLicensesIdRouteWithChildren
  StaffLicensesAddIndexRoute: typeof StaffLicensesAddIndexRoute
  StaffLicensesAddAllocationTypeCompletedRoute: typeof StaffLicensesAddAllocationTypeCompletedRoute
  StaffLicensesAddAllocationTypeIndexRoute: typeof StaffLicensesAddAllocationTypeIndexRoute
}

const StaffLicensesRouteChildren: StaffLicensesRouteChildren = {
  StaffLicensesListRoute: StaffLicensesListRouteWithChildren,
  StaffLicensesIdRoute: StaffLicensesIdRouteWithChildren,
  StaffLicensesAddIndexRoute: StaffLicensesAddIndexRoute,
  StaffLicensesAddAllocationTypeCompletedRoute:
    StaffLicensesAddAllocationTypeCompletedRoute,
  StaffLicensesAddAllocationTypeIndexRoute:
    StaffLicensesAddAllocationTypeIndexRoute,
}

const StaffLicensesRouteWithChildren = StaffLicensesRoute._addFileChildren(
  StaffLicensesRouteChildren,
)

interface StaffMarketplaceStoreRouteChildren {
  StaffMarketplaceStoreStoreDevicesIndexRoute: typeof StaffMarketplaceStoreStoreDevicesIndexRoute
  StaffMarketplaceStoreStoreLicensesIndexRoute: typeof StaffMarketplaceStoreStoreLicensesIndexRoute
  StaffMarketplaceStoreStoreSalesOrdersIndexRoute: typeof StaffMarketplaceStoreStoreSalesOrdersIndexRoute
  StaffMarketplaceStoreStoreSentOrdersIndexRoute: typeof StaffMarketplaceStoreStoreSentOrdersIndexRoute
  StaffMarketplaceStoreStoreStarlinksIndexRoute: typeof StaffMarketplaceStoreStoreStarlinksIndexRoute
  StaffMarketplaceStoreStoreDevicesProductIdIndexRoute: typeof StaffMarketplaceStoreStoreDevicesProductIdIndexRoute
  StaffMarketplaceStoreStoreLicensesProductIdIndexRoute: typeof StaffMarketplaceStoreStoreLicensesProductIdIndexRoute
  StaffMarketplaceStoreStoreStarlinksProductIdIndexRoute: typeof StaffMarketplaceStoreStoreStarlinksProductIdIndexRoute
}

const StaffMarketplaceStoreRouteChildren: StaffMarketplaceStoreRouteChildren = {
  StaffMarketplaceStoreStoreDevicesIndexRoute:
    StaffMarketplaceStoreStoreDevicesIndexRoute,
  StaffMarketplaceStoreStoreLicensesIndexRoute:
    StaffMarketplaceStoreStoreLicensesIndexRoute,
  StaffMarketplaceStoreStoreSalesOrdersIndexRoute:
    StaffMarketplaceStoreStoreSalesOrdersIndexRoute,
  StaffMarketplaceStoreStoreSentOrdersIndexRoute:
    StaffMarketplaceStoreStoreSentOrdersIndexRoute,
  StaffMarketplaceStoreStoreStarlinksIndexRoute:
    StaffMarketplaceStoreStoreStarlinksIndexRoute,
  StaffMarketplaceStoreStoreDevicesProductIdIndexRoute:
    StaffMarketplaceStoreStoreDevicesProductIdIndexRoute,
  StaffMarketplaceStoreStoreLicensesProductIdIndexRoute:
    StaffMarketplaceStoreStoreLicensesProductIdIndexRoute,
  StaffMarketplaceStoreStoreStarlinksProductIdIndexRoute:
    StaffMarketplaceStoreStoreStarlinksProductIdIndexRoute,
}

const StaffMarketplaceStoreRouteWithChildren =
  StaffMarketplaceStoreRoute._addFileChildren(
    StaffMarketplaceStoreRouteChildren,
  )

interface StaffMarketplaceSentOrdersOrderIdLayoutRouteChildren {
  StaffMarketplaceSentOrdersOrderIdLayoutActivitiesRoute: typeof StaffMarketplaceSentOrdersOrderIdLayoutActivitiesRoute
  StaffMarketplaceSentOrdersOrderIdLayoutIndexRoute: typeof StaffMarketplaceSentOrdersOrderIdLayoutIndexRoute
}

const StaffMarketplaceSentOrdersOrderIdLayoutRouteChildren: StaffMarketplaceSentOrdersOrderIdLayoutRouteChildren =
  {
    StaffMarketplaceSentOrdersOrderIdLayoutActivitiesRoute:
      StaffMarketplaceSentOrdersOrderIdLayoutActivitiesRoute,
    StaffMarketplaceSentOrdersOrderIdLayoutIndexRoute:
      StaffMarketplaceSentOrdersOrderIdLayoutIndexRoute,
  }

const StaffMarketplaceSentOrdersOrderIdLayoutRouteWithChildren =
  StaffMarketplaceSentOrdersOrderIdLayoutRoute._addFileChildren(
    StaffMarketplaceSentOrdersOrderIdLayoutRouteChildren,
  )

interface StaffMarketplaceSentOrdersOrderIdRouteChildren {
  StaffMarketplaceSentOrdersOrderIdLayoutRoute: typeof StaffMarketplaceSentOrdersOrderIdLayoutRouteWithChildren
}

const StaffMarketplaceSentOrdersOrderIdRouteChildren: StaffMarketplaceSentOrdersOrderIdRouteChildren =
  {
    StaffMarketplaceSentOrdersOrderIdLayoutRoute:
      StaffMarketplaceSentOrdersOrderIdLayoutRouteWithChildren,
  }

const StaffMarketplaceSentOrdersOrderIdRouteWithChildren =
  StaffMarketplaceSentOrdersOrderIdRoute._addFileChildren(
    StaffMarketplaceSentOrdersOrderIdRouteChildren,
  )

interface StaffMarketplaceRouteChildren {
  StaffMarketplaceStoreRoute: typeof StaffMarketplaceStoreRouteWithChildren
  StaffMarketplaceCartIndexRoute: typeof StaffMarketplaceCartIndexRoute
  StaffMarketplaceUnavailableIndexRoute: typeof StaffMarketplaceUnavailableIndexRoute
  StaffMarketplaceSentOrdersOrderIdRoute: typeof StaffMarketplaceSentOrdersOrderIdRouteWithChildren
  StaffMarketplaceSalesOrdersOrderIdIndexRoute: typeof StaffMarketplaceSalesOrdersOrderIdIndexRoute
}

const StaffMarketplaceRouteChildren: StaffMarketplaceRouteChildren = {
  StaffMarketplaceStoreRoute: StaffMarketplaceStoreRouteWithChildren,
  StaffMarketplaceCartIndexRoute: StaffMarketplaceCartIndexRoute,
  StaffMarketplaceUnavailableIndexRoute: StaffMarketplaceUnavailableIndexRoute,
  StaffMarketplaceSentOrdersOrderIdRoute:
    StaffMarketplaceSentOrdersOrderIdRouteWithChildren,
  StaffMarketplaceSalesOrdersOrderIdIndexRoute:
    StaffMarketplaceSalesOrdersOrderIdIndexRoute,
}

const StaffMarketplaceRouteWithChildren =
  StaffMarketplaceRoute._addFileChildren(StaffMarketplaceRouteChildren)

interface StaffNetworksLayoutRouteChildren {
  StaffNetworksLayoutIndexRoute: typeof StaffNetworksLayoutIndexRoute
  StaffNetworksLayoutPlaceholdersAlertsRoute: typeof StaffNetworksLayoutPlaceholdersAlertsRoute
  StaffNetworksLayoutPlaceholdersContractAndCostRoute: typeof StaffNetworksLayoutPlaceholdersContractAndCostRoute
  StaffNetworksLayoutPlaceholdersOperationActivityRoute: typeof StaffNetworksLayoutPlaceholdersOperationActivityRoute
  StaffNetworksLayoutPlaceholdersOverviewRoute: typeof StaffNetworksLayoutPlaceholdersOverviewRoute
  StaffNetworksLayoutPlaceholdersRuleAndPolicyRoute: typeof StaffNetworksLayoutPlaceholdersRuleAndPolicyRoute
  StaffNetworksLayoutPlaceholdersSettingsRoute: typeof StaffNetworksLayoutPlaceholdersSettingsRoute
}

const StaffNetworksLayoutRouteChildren: StaffNetworksLayoutRouteChildren = {
  StaffNetworksLayoutIndexRoute: StaffNetworksLayoutIndexRoute,
  StaffNetworksLayoutPlaceholdersAlertsRoute:
    StaffNetworksLayoutPlaceholdersAlertsRoute,
  StaffNetworksLayoutPlaceholdersContractAndCostRoute:
    StaffNetworksLayoutPlaceholdersContractAndCostRoute,
  StaffNetworksLayoutPlaceholdersOperationActivityRoute:
    StaffNetworksLayoutPlaceholdersOperationActivityRoute,
  StaffNetworksLayoutPlaceholdersOverviewRoute:
    StaffNetworksLayoutPlaceholdersOverviewRoute,
  StaffNetworksLayoutPlaceholdersRuleAndPolicyRoute:
    StaffNetworksLayoutPlaceholdersRuleAndPolicyRoute,
  StaffNetworksLayoutPlaceholdersSettingsRoute:
    StaffNetworksLayoutPlaceholdersSettingsRoute,
}

const StaffNetworksLayoutRouteWithChildren =
  StaffNetworksLayoutRoute._addFileChildren(StaffNetworksLayoutRouteChildren)

interface StaffNetworksIdLayoutRouteChildren {
  StaffNetworksIdLayoutProfileIndexLazyRoute: typeof StaffNetworksIdLayoutProfileIndexLazyRoute
}

const StaffNetworksIdLayoutRouteChildren: StaffNetworksIdLayoutRouteChildren = {
  StaffNetworksIdLayoutProfileIndexLazyRoute:
    StaffNetworksIdLayoutProfileIndexLazyRoute,
}

const StaffNetworksIdLayoutRouteWithChildren =
  StaffNetworksIdLayoutRoute._addFileChildren(
    StaffNetworksIdLayoutRouteChildren,
  )

interface StaffNetworksIdRouteChildren {
  StaffNetworksIdLayoutRoute: typeof StaffNetworksIdLayoutRouteWithChildren
}

const StaffNetworksIdRouteChildren: StaffNetworksIdRouteChildren = {
  StaffNetworksIdLayoutRoute: StaffNetworksIdLayoutRouteWithChildren,
}

const StaffNetworksIdRouteWithChildren = StaffNetworksIdRoute._addFileChildren(
  StaffNetworksIdRouteChildren,
)

interface StaffNetworksRouteChildren {
  StaffNetworksLayoutRoute: typeof StaffNetworksLayoutRouteWithChildren
  StaffNetworksIdRoute: typeof StaffNetworksIdRouteWithChildren
  StaffNetworksAddIndexRoute: typeof StaffNetworksAddIndexRoute
}

const StaffNetworksRouteChildren: StaffNetworksRouteChildren = {
  StaffNetworksLayoutRoute: StaffNetworksLayoutRouteWithChildren,
  StaffNetworksIdRoute: StaffNetworksIdRouteWithChildren,
  StaffNetworksAddIndexRoute: StaffNetworksAddIndexRoute,
}

const StaffNetworksRouteWithChildren = StaffNetworksRoute._addFileChildren(
  StaffNetworksRouteChildren,
)

interface StaffOrganizationListRouteChildren {
  StaffOrganizationListAlertIndexRoute: typeof StaffOrganizationListAlertIndexRoute
  StaffOrganizationListChartIndexRoute: typeof StaffOrganizationListChartIndexRoute
  StaffOrganizationListCostIndexRoute: typeof StaffOrganizationListCostIndexRoute
  StaffOrganizationListHistoryIndexRoute: typeof StaffOrganizationListHistoryIndexRoute
  StaffOrganizationListRulePolicyIndexRoute: typeof StaffOrganizationListRulePolicyIndexRoute
  StaffOrganizationListSettingsIndexRoute: typeof StaffOrganizationListSettingsIndexRoute
}

const StaffOrganizationListRouteChildren: StaffOrganizationListRouteChildren = {
  StaffOrganizationListAlertIndexRoute: StaffOrganizationListAlertIndexRoute,
  StaffOrganizationListChartIndexRoute: StaffOrganizationListChartIndexRoute,
  StaffOrganizationListCostIndexRoute: StaffOrganizationListCostIndexRoute,
  StaffOrganizationListHistoryIndexRoute:
    StaffOrganizationListHistoryIndexRoute,
  StaffOrganizationListRulePolicyIndexRoute:
    StaffOrganizationListRulePolicyIndexRoute,
  StaffOrganizationListSettingsIndexRoute:
    StaffOrganizationListSettingsIndexRoute,
}

const StaffOrganizationListRouteWithChildren =
  StaffOrganizationListRoute._addFileChildren(
    StaffOrganizationListRouteChildren,
  )

interface StaffOrganizationIdLayoutRouteChildren {
  StaffOrganizationIdLayoutIndexRoute: typeof StaffOrganizationIdLayoutIndexRoute
  StaffOrganizationIdLayoutHistoryIndexRoute: typeof StaffOrganizationIdLayoutHistoryIndexRoute
}

const StaffOrganizationIdLayoutRouteChildren: StaffOrganizationIdLayoutRouteChildren =
  {
    StaffOrganizationIdLayoutIndexRoute: StaffOrganizationIdLayoutIndexRoute,
    StaffOrganizationIdLayoutHistoryIndexRoute:
      StaffOrganizationIdLayoutHistoryIndexRoute,
  }

const StaffOrganizationIdLayoutRouteWithChildren =
  StaffOrganizationIdLayoutRoute._addFileChildren(
    StaffOrganizationIdLayoutRouteChildren,
  )

interface StaffOrganizationIdRouteChildren {
  StaffOrganizationIdLayoutRoute: typeof StaffOrganizationIdLayoutRouteWithChildren
}

const StaffOrganizationIdRouteChildren: StaffOrganizationIdRouteChildren = {
  StaffOrganizationIdLayoutRoute: StaffOrganizationIdLayoutRouteWithChildren,
}

const StaffOrganizationIdRouteWithChildren =
  StaffOrganizationIdRoute._addFileChildren(StaffOrganizationIdRouteChildren)

interface StaffOrganizationRouteChildren {
  StaffOrganizationListRoute: typeof StaffOrganizationListRouteWithChildren
  StaffOrganizationIndexRoute: typeof StaffOrganizationIndexRoute
  StaffOrganizationIdRoute: typeof StaffOrganizationIdRouteWithChildren
  StaffOrganizationPlanIndexRoute: typeof StaffOrganizationPlanIndexRoute
  StaffOrganizationPlanIdIndexRoute: typeof StaffOrganizationPlanIdIndexRoute
  StaffOrganizationPlanCreateIndexRoute: typeof StaffOrganizationPlanCreateIndexRoute
  StaffOrganizationPlanIdAddIndexRoute: typeof StaffOrganizationPlanIdAddIndexRoute
  StaffOrganizationPlanIdTransfersIndexRoute: typeof StaffOrganizationPlanIdTransfersIndexRoute
  StaffOrganizationPlanIdEditUnitIdIndexRoute: typeof StaffOrganizationPlanIdEditUnitIdIndexRoute
}

const StaffOrganizationRouteChildren: StaffOrganizationRouteChildren = {
  StaffOrganizationListRoute: StaffOrganizationListRouteWithChildren,
  StaffOrganizationIndexRoute: StaffOrganizationIndexRoute,
  StaffOrganizationIdRoute: StaffOrganizationIdRouteWithChildren,
  StaffOrganizationPlanIndexRoute: StaffOrganizationPlanIndexRoute,
  StaffOrganizationPlanIdIndexRoute: StaffOrganizationPlanIdIndexRoute,
  StaffOrganizationPlanCreateIndexRoute: StaffOrganizationPlanCreateIndexRoute,
  StaffOrganizationPlanIdAddIndexRoute: StaffOrganizationPlanIdAddIndexRoute,
  StaffOrganizationPlanIdTransfersIndexRoute:
    StaffOrganizationPlanIdTransfersIndexRoute,
  StaffOrganizationPlanIdEditUnitIdIndexRoute:
    StaffOrganizationPlanIdEditUnitIdIndexRoute,
}

const StaffOrganizationRouteWithChildren =
  StaffOrganizationRoute._addFileChildren(StaffOrganizationRouteChildren)

interface StaffPayrollCoreLayoutRouteChildren {
  StaffPayrollCoreLayoutIndexRoute: typeof StaffPayrollCoreLayoutIndexRoute
  StaffPayrollCoreLayoutArchiveIndexRoute: typeof StaffPayrollCoreLayoutArchiveIndexRoute
  StaffPayrollCoreLayoutConfigIndexRoute: typeof StaffPayrollCoreLayoutConfigIndexRoute
  StaffPayrollCoreLayoutDashboardIndexRoute: typeof StaffPayrollCoreLayoutDashboardIndexRoute
  StaffPayrollCoreLayoutOperationPackagesIndexRoute: typeof StaffPayrollCoreLayoutOperationPackagesIndexRoute
  StaffPayrollCoreLayoutPersonTargetsIndexRoute: typeof StaffPayrollCoreLayoutPersonTargetsIndexRoute
}

const StaffPayrollCoreLayoutRouteChildren: StaffPayrollCoreLayoutRouteChildren =
  {
    StaffPayrollCoreLayoutIndexRoute: StaffPayrollCoreLayoutIndexRoute,
    StaffPayrollCoreLayoutArchiveIndexRoute:
      StaffPayrollCoreLayoutArchiveIndexRoute,
    StaffPayrollCoreLayoutConfigIndexRoute:
      StaffPayrollCoreLayoutConfigIndexRoute,
    StaffPayrollCoreLayoutDashboardIndexRoute:
      StaffPayrollCoreLayoutDashboardIndexRoute,
    StaffPayrollCoreLayoutOperationPackagesIndexRoute:
      StaffPayrollCoreLayoutOperationPackagesIndexRoute,
    StaffPayrollCoreLayoutPersonTargetsIndexRoute:
      StaffPayrollCoreLayoutPersonTargetsIndexRoute,
  }

const StaffPayrollCoreLayoutRouteWithChildren =
  StaffPayrollCoreLayoutRoute._addFileChildren(
    StaffPayrollCoreLayoutRouteChildren,
  )

interface StaffPayrollCoreRouteChildren {
  StaffPayrollCoreLayoutRoute: typeof StaffPayrollCoreLayoutRouteWithChildren
}

const StaffPayrollCoreRouteChildren: StaffPayrollCoreRouteChildren = {
  StaffPayrollCoreLayoutRoute: StaffPayrollCoreLayoutRouteWithChildren,
}

const StaffPayrollCoreRouteWithChildren =
  StaffPayrollCoreRoute._addFileChildren(StaffPayrollCoreRouteChildren)

interface StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutRouteChildren {
  StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutIndexRoute: typeof StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutIndexRoute
  StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutStructureIndexRoute: typeof StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutStructureIndexRoute
}

const StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutRouteChildren: StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutRouteChildren =
  {
    StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutIndexRoute:
      StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutIndexRoute,
    StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutStructureIndexRoute:
      StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutStructureIndexRoute,
  }

const StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutRouteWithChildren =
  StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutRoute._addFileChildren(
    StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutRouteChildren,
  )

interface StaffPayrollEngineLayoutPayrollStructuresStructureIdRouteChildren {
  StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutRoute: typeof StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutRouteWithChildren
}

const StaffPayrollEngineLayoutPayrollStructuresStructureIdRouteChildren: StaffPayrollEngineLayoutPayrollStructuresStructureIdRouteChildren =
  {
    StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutRoute:
      StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutRouteWithChildren,
  }

const StaffPayrollEngineLayoutPayrollStructuresStructureIdRouteWithChildren =
  StaffPayrollEngineLayoutPayrollStructuresStructureIdRoute._addFileChildren(
    StaffPayrollEngineLayoutPayrollStructuresStructureIdRouteChildren,
  )

interface StaffPayrollEngineLayoutRouteChildren {
  StaffPayrollEngineLayoutIndexRoute: typeof StaffPayrollEngineLayoutIndexRoute
  StaffPayrollEngineLayoutItemsIndexRoute: typeof StaffPayrollEngineLayoutItemsIndexRoute
  StaffPayrollEngineLayoutLogicComponentsIndexRoute: typeof StaffPayrollEngineLayoutLogicComponentsIndexRoute
  StaffPayrollEngineLayoutPayrollStructuresIndexRoute: typeof StaffPayrollEngineLayoutPayrollStructuresIndexRoute
  StaffPayrollEngineLayoutPayrollUnitsIndexRoute: typeof StaffPayrollEngineLayoutPayrollUnitsIndexRoute
  StaffPayrollEngineLayoutPayrollStructuresStructureIdRoute: typeof StaffPayrollEngineLayoutPayrollStructuresStructureIdRouteWithChildren
  StaffPayrollEngineLayoutItemsComponentIdIndexRoute: typeof StaffPayrollEngineLayoutItemsComponentIdIndexRoute
  StaffPayrollEngineLayoutLogicComponentsComponentIdIndexRoute: typeof StaffPayrollEngineLayoutLogicComponentsComponentIdIndexRoute
  StaffPayrollEngineLayoutPayrollUnitsUnitIdIndexRoute: typeof StaffPayrollEngineLayoutPayrollUnitsUnitIdIndexRoute
}

const StaffPayrollEngineLayoutRouteChildren: StaffPayrollEngineLayoutRouteChildren =
  {
    StaffPayrollEngineLayoutIndexRoute: StaffPayrollEngineLayoutIndexRoute,
    StaffPayrollEngineLayoutItemsIndexRoute:
      StaffPayrollEngineLayoutItemsIndexRoute,
    StaffPayrollEngineLayoutLogicComponentsIndexRoute:
      StaffPayrollEngineLayoutLogicComponentsIndexRoute,
    StaffPayrollEngineLayoutPayrollStructuresIndexRoute:
      StaffPayrollEngineLayoutPayrollStructuresIndexRoute,
    StaffPayrollEngineLayoutPayrollUnitsIndexRoute:
      StaffPayrollEngineLayoutPayrollUnitsIndexRoute,
    StaffPayrollEngineLayoutPayrollStructuresStructureIdRoute:
      StaffPayrollEngineLayoutPayrollStructuresStructureIdRouteWithChildren,
    StaffPayrollEngineLayoutItemsComponentIdIndexRoute:
      StaffPayrollEngineLayoutItemsComponentIdIndexRoute,
    StaffPayrollEngineLayoutLogicComponentsComponentIdIndexRoute:
      StaffPayrollEngineLayoutLogicComponentsComponentIdIndexRoute,
    StaffPayrollEngineLayoutPayrollUnitsUnitIdIndexRoute:
      StaffPayrollEngineLayoutPayrollUnitsUnitIdIndexRoute,
  }

const StaffPayrollEngineLayoutRouteWithChildren =
  StaffPayrollEngineLayoutRoute._addFileChildren(
    StaffPayrollEngineLayoutRouteChildren,
  )

interface StaffPayrollEngineRouteChildren {
  StaffPayrollEngineLayoutRoute: typeof StaffPayrollEngineLayoutRouteWithChildren
}

const StaffPayrollEngineRouteChildren: StaffPayrollEngineRouteChildren = {
  StaffPayrollEngineLayoutRoute: StaffPayrollEngineLayoutRouteWithChildren,
}

const StaffPayrollEngineRouteWithChildren =
  StaffPayrollEngineRoute._addFileChildren(StaffPayrollEngineRouteChildren)

interface StaffPayrollLayoutPaySlipsEmployeeIdRouteRouteChildren {
  StaffPayrollLayoutPaySlipsEmployeeIdAlertsLazyRoute: typeof StaffPayrollLayoutPaySlipsEmployeeIdAlertsLazyRoute
  StaffPayrollLayoutPaySlipsEmployeeIdFilesLazyRoute: typeof StaffPayrollLayoutPaySlipsEmployeeIdFilesLazyRoute
  StaffPayrollLayoutPaySlipsEmployeeIdHistoryLazyRoute: typeof StaffPayrollLayoutPaySlipsEmployeeIdHistoryLazyRoute
  StaffPayrollLayoutPaySlipsEmployeeIdOverviewLazyRoute: typeof StaffPayrollLayoutPaySlipsEmployeeIdOverviewLazyRoute
  StaffPayrollLayoutPaySlipsEmployeeIdSettingsLazyRoute: typeof StaffPayrollLayoutPaySlipsEmployeeIdSettingsLazyRoute
  StaffPayrollLayoutPaySlipsEmployeeIdIndexLazyRoute: typeof StaffPayrollLayoutPaySlipsEmployeeIdIndexLazyRoute
}

const StaffPayrollLayoutPaySlipsEmployeeIdRouteRouteChildren: StaffPayrollLayoutPaySlipsEmployeeIdRouteRouteChildren =
  {
    StaffPayrollLayoutPaySlipsEmployeeIdAlertsLazyRoute:
      StaffPayrollLayoutPaySlipsEmployeeIdAlertsLazyRoute,
    StaffPayrollLayoutPaySlipsEmployeeIdFilesLazyRoute:
      StaffPayrollLayoutPaySlipsEmployeeIdFilesLazyRoute,
    StaffPayrollLayoutPaySlipsEmployeeIdHistoryLazyRoute:
      StaffPayrollLayoutPaySlipsEmployeeIdHistoryLazyRoute,
    StaffPayrollLayoutPaySlipsEmployeeIdOverviewLazyRoute:
      StaffPayrollLayoutPaySlipsEmployeeIdOverviewLazyRoute,
    StaffPayrollLayoutPaySlipsEmployeeIdSettingsLazyRoute:
      StaffPayrollLayoutPaySlipsEmployeeIdSettingsLazyRoute,
    StaffPayrollLayoutPaySlipsEmployeeIdIndexLazyRoute:
      StaffPayrollLayoutPaySlipsEmployeeIdIndexLazyRoute,
  }

const StaffPayrollLayoutPaySlipsEmployeeIdRouteRouteWithChildren =
  StaffPayrollLayoutPaySlipsEmployeeIdRouteRoute._addFileChildren(
    StaffPayrollLayoutPaySlipsEmployeeIdRouteRouteChildren,
  )

interface StaffPayrollLayoutContractAndCostContractAndCostRouteChildren {
  StaffPayrollLayoutContractAndCostContractAndCostIndexRoute: typeof StaffPayrollLayoutContractAndCostContractAndCostIndexRoute
  StaffPayrollLayoutContractAndCostContractAndCostCostIndexRoute: typeof StaffPayrollLayoutContractAndCostContractAndCostCostIndexRoute
  StaffPayrollLayoutContractAndCostContractAndCostDealIndexRoute: typeof StaffPayrollLayoutContractAndCostContractAndCostDealIndexRoute
  StaffPayrollLayoutContractAndCostContractAndCostPaymentIndexRoute: typeof StaffPayrollLayoutContractAndCostContractAndCostPaymentIndexRoute
  StaffPayrollLayoutContractAndCostContractAndCostCostPeriodIndexRoute: typeof StaffPayrollLayoutContractAndCostContractAndCostCostPeriodIndexRoute
  StaffPayrollLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute: typeof StaffPayrollLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute
}

const StaffPayrollLayoutContractAndCostContractAndCostRouteChildren: StaffPayrollLayoutContractAndCostContractAndCostRouteChildren =
  {
    StaffPayrollLayoutContractAndCostContractAndCostIndexRoute:
      StaffPayrollLayoutContractAndCostContractAndCostIndexRoute,
    StaffPayrollLayoutContractAndCostContractAndCostCostIndexRoute:
      StaffPayrollLayoutContractAndCostContractAndCostCostIndexRoute,
    StaffPayrollLayoutContractAndCostContractAndCostDealIndexRoute:
      StaffPayrollLayoutContractAndCostContractAndCostDealIndexRoute,
    StaffPayrollLayoutContractAndCostContractAndCostPaymentIndexRoute:
      StaffPayrollLayoutContractAndCostContractAndCostPaymentIndexRoute,
    StaffPayrollLayoutContractAndCostContractAndCostCostPeriodIndexRoute:
      StaffPayrollLayoutContractAndCostContractAndCostCostPeriodIndexRoute,
    StaffPayrollLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute:
      StaffPayrollLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute,
  }

const StaffPayrollLayoutContractAndCostContractAndCostRouteWithChildren =
  StaffPayrollLayoutContractAndCostContractAndCostRoute._addFileChildren(
    StaffPayrollLayoutContractAndCostContractAndCostRouteChildren,
  )

interface StaffPayrollLayoutContractAndCostRouteChildren {
  StaffPayrollLayoutContractAndCostContractAndCostRoute: typeof StaffPayrollLayoutContractAndCostContractAndCostRouteWithChildren
}

const StaffPayrollLayoutContractAndCostRouteChildren: StaffPayrollLayoutContractAndCostRouteChildren =
  {
    StaffPayrollLayoutContractAndCostContractAndCostRoute:
      StaffPayrollLayoutContractAndCostContractAndCostRouteWithChildren,
  }

const StaffPayrollLayoutContractAndCostRouteWithChildren =
  StaffPayrollLayoutContractAndCostRoute._addFileChildren(
    StaffPayrollLayoutContractAndCostRouteChildren,
  )

interface StaffPayrollLayoutRouteChildren {
  StaffPayrollLayoutIndexRoute: typeof StaffPayrollLayoutIndexRoute
  StaffPayrollLayoutPaySlipsEmployeeIdRouteRoute: typeof StaffPayrollLayoutPaySlipsEmployeeIdRouteRouteWithChildren
  StaffPayrollLayoutContractAndCostRoute: typeof StaffPayrollLayoutContractAndCostRouteWithChildren
  StaffPayrollLayoutAlertsIndexRoute: typeof StaffPayrollLayoutAlertsIndexRoute
  StaffPayrollLayoutOverviewIndexRoute: typeof StaffPayrollLayoutOverviewIndexRoute
  StaffPayrollLayoutPaySlipsIndexRoute: typeof StaffPayrollLayoutPaySlipsIndexRoute
  StaffPayrollLayoutRuleAndPolicyIndexRoute: typeof StaffPayrollLayoutRuleAndPolicyIndexRoute
  StaffPayrollLayoutSettingsIndexRoute: typeof StaffPayrollLayoutSettingsIndexRoute
}

const StaffPayrollLayoutRouteChildren: StaffPayrollLayoutRouteChildren = {
  StaffPayrollLayoutIndexRoute: StaffPayrollLayoutIndexRoute,
  StaffPayrollLayoutPaySlipsEmployeeIdRouteRoute:
    StaffPayrollLayoutPaySlipsEmployeeIdRouteRouteWithChildren,
  StaffPayrollLayoutContractAndCostRoute:
    StaffPayrollLayoutContractAndCostRouteWithChildren,
  StaffPayrollLayoutAlertsIndexRoute: StaffPayrollLayoutAlertsIndexRoute,
  StaffPayrollLayoutOverviewIndexRoute: StaffPayrollLayoutOverviewIndexRoute,
  StaffPayrollLayoutPaySlipsIndexRoute: StaffPayrollLayoutPaySlipsIndexRoute,
  StaffPayrollLayoutRuleAndPolicyIndexRoute:
    StaffPayrollLayoutRuleAndPolicyIndexRoute,
  StaffPayrollLayoutSettingsIndexRoute: StaffPayrollLayoutSettingsIndexRoute,
}

const StaffPayrollLayoutRouteWithChildren =
  StaffPayrollLayoutRoute._addFileChildren(StaffPayrollLayoutRouteChildren)

interface StaffPayrollRouteChildren {
  StaffPayrollLayoutRoute: typeof StaffPayrollLayoutRouteWithChildren
}

const StaffPayrollRouteChildren: StaffPayrollRouteChildren = {
  StaffPayrollLayoutRoute: StaffPayrollLayoutRouteWithChildren,
}

const StaffPayrollRouteWithChildren = StaffPayrollRoute._addFileChildren(
  StaffPayrollRouteChildren,
)

interface StaffPeopleListSettingsRouteLazyRouteChildren {
  StaffPeopleListSettingsIndexRoute: typeof StaffPeopleListSettingsIndexRoute
  StaffPeopleListSettingsBoardMemberTypesIndexRoute: typeof StaffPeopleListSettingsBoardMemberTypesIndexRoute
  StaffPeopleListSettingsCollaboratorTypesIndexRoute: typeof StaffPeopleListSettingsCollaboratorTypesIndexRoute
  StaffPeopleListSettingsContractEndReasonsIndexRoute: typeof StaffPeopleListSettingsContractEndReasonsIndexRoute
  StaffPeopleListSettingsContractorTypesIndexRoute: typeof StaffPeopleListSettingsContractorTypesIndexRoute
  StaffPeopleListSettingsEmployeeSubIdNamesIndexRoute: typeof StaffPeopleListSettingsEmployeeSubIdNamesIndexRoute
  StaffPeopleListSettingsEmploymentTypesIndexRoute: typeof StaffPeopleListSettingsEmploymentTypesIndexRoute
  StaffPeopleListSettingsGradesIndexRoute: typeof StaffPeopleListSettingsGradesIndexRoute
  StaffPeopleListSettingsHealthInsuranceAssociationsIndexRoute: typeof StaffPeopleListSettingsHealthInsuranceAssociationsIndexRoute
  StaffPeopleListSettingsJobCompetenciesIndexRoute: typeof StaffPeopleListSettingsJobCompetenciesIndexRoute
  StaffPeopleListSettingsJobFunctionsIndexRoute: typeof StaffPeopleListSettingsJobFunctionsIndexRoute
  StaffPeopleListSettingsJobGradesIndexRoute: typeof StaffPeopleListSettingsJobGradesIndexRoute
  StaffPeopleListSettingsJobLevelsIndexRoute: typeof StaffPeopleListSettingsJobLevelsIndexRoute
  StaffPeopleListSettingsJobTitlesIndexRoute: typeof StaffPeopleListSettingsJobTitlesIndexRoute
  StaffPeopleListSettingsJobTypesIndexRoute: typeof StaffPeopleListSettingsJobTypesIndexRoute
  StaffPeopleListSettingsPlaceSocialInsurancesIndexRoute: typeof StaffPeopleListSettingsPlaceSocialInsurancesIndexRoute
  StaffPeopleListSettingsPositionsIndexRoute: typeof StaffPeopleListSettingsPositionsIndexRoute
  StaffPeopleListSettingsRetirementReasonsIndexRoute: typeof StaffPeopleListSettingsRetirementReasonsIndexRoute
  StaffPeopleListSettingsWorkModeIndexRoute: typeof StaffPeopleListSettingsWorkModeIndexRoute
}

const StaffPeopleListSettingsRouteLazyRouteChildren: StaffPeopleListSettingsRouteLazyRouteChildren =
  {
    StaffPeopleListSettingsIndexRoute: StaffPeopleListSettingsIndexRoute,
    StaffPeopleListSettingsBoardMemberTypesIndexRoute:
      StaffPeopleListSettingsBoardMemberTypesIndexRoute,
    StaffPeopleListSettingsCollaboratorTypesIndexRoute:
      StaffPeopleListSettingsCollaboratorTypesIndexRoute,
    StaffPeopleListSettingsContractEndReasonsIndexRoute:
      StaffPeopleListSettingsContractEndReasonsIndexRoute,
    StaffPeopleListSettingsContractorTypesIndexRoute:
      StaffPeopleListSettingsContractorTypesIndexRoute,
    StaffPeopleListSettingsEmployeeSubIdNamesIndexRoute:
      StaffPeopleListSettingsEmployeeSubIdNamesIndexRoute,
    StaffPeopleListSettingsEmploymentTypesIndexRoute:
      StaffPeopleListSettingsEmploymentTypesIndexRoute,
    StaffPeopleListSettingsGradesIndexRoute:
      StaffPeopleListSettingsGradesIndexRoute,
    StaffPeopleListSettingsHealthInsuranceAssociationsIndexRoute:
      StaffPeopleListSettingsHealthInsuranceAssociationsIndexRoute,
    StaffPeopleListSettingsJobCompetenciesIndexRoute:
      StaffPeopleListSettingsJobCompetenciesIndexRoute,
    StaffPeopleListSettingsJobFunctionsIndexRoute:
      StaffPeopleListSettingsJobFunctionsIndexRoute,
    StaffPeopleListSettingsJobGradesIndexRoute:
      StaffPeopleListSettingsJobGradesIndexRoute,
    StaffPeopleListSettingsJobLevelsIndexRoute:
      StaffPeopleListSettingsJobLevelsIndexRoute,
    StaffPeopleListSettingsJobTitlesIndexRoute:
      StaffPeopleListSettingsJobTitlesIndexRoute,
    StaffPeopleListSettingsJobTypesIndexRoute:
      StaffPeopleListSettingsJobTypesIndexRoute,
    StaffPeopleListSettingsPlaceSocialInsurancesIndexRoute:
      StaffPeopleListSettingsPlaceSocialInsurancesIndexRoute,
    StaffPeopleListSettingsPositionsIndexRoute:
      StaffPeopleListSettingsPositionsIndexRoute,
    StaffPeopleListSettingsRetirementReasonsIndexRoute:
      StaffPeopleListSettingsRetirementReasonsIndexRoute,
    StaffPeopleListSettingsWorkModeIndexRoute:
      StaffPeopleListSettingsWorkModeIndexRoute,
  }

const StaffPeopleListSettingsRouteLazyRouteWithChildren =
  StaffPeopleListSettingsRouteLazyRoute._addFileChildren(
    StaffPeopleListSettingsRouteLazyRouteChildren,
  )

interface StaffPeopleListRouteChildren {
  StaffPeopleListAlertsRoute: typeof StaffPeopleListAlertsRoute
  StaffPeopleListCommunityRoute: typeof StaffPeopleListCommunityRoute
  StaffPeopleListPeopleGraphRoute: typeof StaffPeopleListPeopleGraphRoute
  StaffPeopleListRuleAndPolicyRoute: typeof StaffPeopleListRuleAndPolicyRoute
  StaffPeopleListSalaryAndPaymentRoute: typeof StaffPeopleListSalaryAndPaymentRoute
  StaffPeopleListIndexRouteLazyRoute: typeof StaffPeopleListIndexRouteLazyRoute
  StaffPeopleListSettingsRouteLazyRoute: typeof StaffPeopleListSettingsRouteLazyRouteWithChildren
  StaffPeopleListAlumniIndexRoute: typeof StaffPeopleListAlumniIndexRoute
  StaffPeopleListOperationActivityIndexRoute: typeof StaffPeopleListOperationActivityIndexRoute
  StaffPeopleListWorkforceIndexRoute: typeof StaffPeopleListWorkforceIndexRoute
}

const StaffPeopleListRouteChildren: StaffPeopleListRouteChildren = {
  StaffPeopleListAlertsRoute: StaffPeopleListAlertsRoute,
  StaffPeopleListCommunityRoute: StaffPeopleListCommunityRoute,
  StaffPeopleListPeopleGraphRoute: StaffPeopleListPeopleGraphRoute,
  StaffPeopleListRuleAndPolicyRoute: StaffPeopleListRuleAndPolicyRoute,
  StaffPeopleListSalaryAndPaymentRoute: StaffPeopleListSalaryAndPaymentRoute,
  StaffPeopleListIndexRouteLazyRoute: StaffPeopleListIndexRouteLazyRoute,
  StaffPeopleListSettingsRouteLazyRoute:
    StaffPeopleListSettingsRouteLazyRouteWithChildren,
  StaffPeopleListAlumniIndexRoute: StaffPeopleListAlumniIndexRoute,
  StaffPeopleListOperationActivityIndexRoute:
    StaffPeopleListOperationActivityIndexRoute,
  StaffPeopleListWorkforceIndexRoute: StaffPeopleListWorkforceIndexRoute,
}

const StaffPeopleListRouteWithChildren = StaffPeopleListRoute._addFileChildren(
  StaffPeopleListRouteChildren,
)

interface StaffPeopleRouteChildren {
  StaffPeopleListRoute: typeof StaffPeopleListRouteWithChildren
}

const StaffPeopleRouteChildren: StaffPeopleRouteChildren = {
  StaffPeopleListRoute: StaffPeopleListRouteWithChildren,
}

const StaffPeopleRouteWithChildren = StaffPeopleRoute._addFileChildren(
  StaffPeopleRouteChildren,
)

interface StaffPlacesLayoutSettingsRouteRouteChildren {
  StaffPlacesLayoutSettingsIndexRoute: typeof StaffPlacesLayoutSettingsIndexRoute
  StaffPlacesLayoutSettingsPlaceSubCodesIndexRoute: typeof StaffPlacesLayoutSettingsPlaceSubCodesIndexRoute
}

const StaffPlacesLayoutSettingsRouteRouteChildren: StaffPlacesLayoutSettingsRouteRouteChildren =
  {
    StaffPlacesLayoutSettingsIndexRoute: StaffPlacesLayoutSettingsIndexRoute,
    StaffPlacesLayoutSettingsPlaceSubCodesIndexRoute:
      StaffPlacesLayoutSettingsPlaceSubCodesIndexRoute,
  }

const StaffPlacesLayoutSettingsRouteRouteWithChildren =
  StaffPlacesLayoutSettingsRouteRoute._addFileChildren(
    StaffPlacesLayoutSettingsRouteRouteChildren,
  )

interface StaffPlacesLayoutRouteChildren {
  StaffPlacesLayoutSettingsRouteRoute: typeof StaffPlacesLayoutSettingsRouteRouteWithChildren
  StaffPlacesLayoutOverviewRoute: typeof StaffPlacesLayoutOverviewRoute
  StaffPlacesLayoutIndexRoute: typeof StaffPlacesLayoutIndexRoute
  StaffPlacesLayoutPlaceholdersAlertsRoute: typeof StaffPlacesLayoutPlaceholdersAlertsRoute
  StaffPlacesLayoutPlaceholdersContractAndCostRoute: typeof StaffPlacesLayoutPlaceholdersContractAndCostRoute
  StaffPlacesLayoutPlaceholdersOperationActivityRoute: typeof StaffPlacesLayoutPlaceholdersOperationActivityRoute
  StaffPlacesLayoutPlaceholdersPeopleRoute: typeof StaffPlacesLayoutPlaceholdersPeopleRoute
  StaffPlacesLayoutPlaceholdersRuleAndPolicyRoute: typeof StaffPlacesLayoutPlaceholdersRuleAndPolicyRoute
  StaffPlacesLayoutPlaceholdersStoreRoute: typeof StaffPlacesLayoutPlaceholdersStoreRoute
}

const StaffPlacesLayoutRouteChildren: StaffPlacesLayoutRouteChildren = {
  StaffPlacesLayoutSettingsRouteRoute:
    StaffPlacesLayoutSettingsRouteRouteWithChildren,
  StaffPlacesLayoutOverviewRoute: StaffPlacesLayoutOverviewRoute,
  StaffPlacesLayoutIndexRoute: StaffPlacesLayoutIndexRoute,
  StaffPlacesLayoutPlaceholdersAlertsRoute:
    StaffPlacesLayoutPlaceholdersAlertsRoute,
  StaffPlacesLayoutPlaceholdersContractAndCostRoute:
    StaffPlacesLayoutPlaceholdersContractAndCostRoute,
  StaffPlacesLayoutPlaceholdersOperationActivityRoute:
    StaffPlacesLayoutPlaceholdersOperationActivityRoute,
  StaffPlacesLayoutPlaceholdersPeopleRoute:
    StaffPlacesLayoutPlaceholdersPeopleRoute,
  StaffPlacesLayoutPlaceholdersRuleAndPolicyRoute:
    StaffPlacesLayoutPlaceholdersRuleAndPolicyRoute,
  StaffPlacesLayoutPlaceholdersStoreRoute:
    StaffPlacesLayoutPlaceholdersStoreRoute,
}

const StaffPlacesLayoutRouteWithChildren =
  StaffPlacesLayoutRoute._addFileChildren(StaffPlacesLayoutRouteChildren)

interface StaffPlacesIdLayoutRouteChildren {
  StaffPlacesIdLayoutAdministratorsIndexRoute: typeof StaffPlacesIdLayoutAdministratorsIndexRoute
  StaffPlacesIdLayoutLaborCoreIndexRoute: typeof StaffPlacesIdLayoutLaborCoreIndexRoute
  StaffPlacesIdLayoutProfileIndexLazyRoute: typeof StaffPlacesIdLayoutProfileIndexLazyRoute
}

const StaffPlacesIdLayoutRouteChildren: StaffPlacesIdLayoutRouteChildren = {
  StaffPlacesIdLayoutAdministratorsIndexRoute:
    StaffPlacesIdLayoutAdministratorsIndexRoute,
  StaffPlacesIdLayoutLaborCoreIndexRoute:
    StaffPlacesIdLayoutLaborCoreIndexRoute,
  StaffPlacesIdLayoutProfileIndexLazyRoute:
    StaffPlacesIdLayoutProfileIndexLazyRoute,
}

const StaffPlacesIdLayoutRouteWithChildren =
  StaffPlacesIdLayoutRoute._addFileChildren(StaffPlacesIdLayoutRouteChildren)

interface StaffPlacesIdRouteChildren {
  StaffPlacesIdLayoutRoute: typeof StaffPlacesIdLayoutRouteWithChildren
}

const StaffPlacesIdRouteChildren: StaffPlacesIdRouteChildren = {
  StaffPlacesIdLayoutRoute: StaffPlacesIdLayoutRouteWithChildren,
}

const StaffPlacesIdRouteWithChildren = StaffPlacesIdRoute._addFileChildren(
  StaffPlacesIdRouteChildren,
)

interface StaffPlacesRouteChildren {
  StaffPlacesLayoutRoute: typeof StaffPlacesLayoutRouteWithChildren
  StaffPlacesIdRoute: typeof StaffPlacesIdRouteWithChildren
  StaffPlacesAddSelectIndexRoute: typeof StaffPlacesAddSelectIndexRoute
  StaffPlacesAddIndexRoute: typeof StaffPlacesAddIndexRoute
}

const StaffPlacesRouteChildren: StaffPlacesRouteChildren = {
  StaffPlacesLayoutRoute: StaffPlacesLayoutRouteWithChildren,
  StaffPlacesIdRoute: StaffPlacesIdRouteWithChildren,
  StaffPlacesAddSelectIndexRoute: StaffPlacesAddSelectIndexRoute,
  StaffPlacesAddIndexRoute: StaffPlacesAddIndexRoute,
}

const StaffPlacesRouteWithChildren = StaffPlacesRoute._addFileChildren(
  StaffPlacesRouteChildren,
)

interface StaffPublicIdsIdRouteChildren {
  StaffPublicIdsIdIndexRoute: typeof StaffPublicIdsIdIndexRoute
  StaffPublicIdsIdDetailsIndexRoute: typeof StaffPublicIdsIdDetailsIndexRoute
  StaffPublicIdsIdFilesIndexRoute: typeof StaffPublicIdsIdFilesIndexRoute
}

const StaffPublicIdsIdRouteChildren: StaffPublicIdsIdRouteChildren = {
  StaffPublicIdsIdIndexRoute: StaffPublicIdsIdIndexRoute,
  StaffPublicIdsIdDetailsIndexRoute: StaffPublicIdsIdDetailsIndexRoute,
  StaffPublicIdsIdFilesIndexRoute: StaffPublicIdsIdFilesIndexRoute,
}

const StaffPublicIdsIdRouteWithChildren =
  StaffPublicIdsIdRoute._addFileChildren(StaffPublicIdsIdRouteChildren)

interface StaffPublicIdsListRouteChildren {
  StaffPublicIdsListIndexRoute: typeof StaffPublicIdsListIndexRoute
  StaffPublicIdsListAlertsIndexRoute: typeof StaffPublicIdsListAlertsIndexRoute
  StaffPublicIdsListMembersIndexRoute: typeof StaffPublicIdsListMembersIndexRoute
  StaffPublicIdsListOperationActivityIndexRoute: typeof StaffPublicIdsListOperationActivityIndexRoute
  StaffPublicIdsListRegistryIndexRoute: typeof StaffPublicIdsListRegistryIndexRoute
  StaffPublicIdsListRulesAndPoliciesIndexRoute: typeof StaffPublicIdsListRulesAndPoliciesIndexRoute
  StaffPublicIdsListSettingsIndexRoute: typeof StaffPublicIdsListSettingsIndexRoute
}

const StaffPublicIdsListRouteChildren: StaffPublicIdsListRouteChildren = {
  StaffPublicIdsListIndexRoute: StaffPublicIdsListIndexRoute,
  StaffPublicIdsListAlertsIndexRoute: StaffPublicIdsListAlertsIndexRoute,
  StaffPublicIdsListMembersIndexRoute: StaffPublicIdsListMembersIndexRoute,
  StaffPublicIdsListOperationActivityIndexRoute:
    StaffPublicIdsListOperationActivityIndexRoute,
  StaffPublicIdsListRegistryIndexRoute: StaffPublicIdsListRegistryIndexRoute,
  StaffPublicIdsListRulesAndPoliciesIndexRoute:
    StaffPublicIdsListRulesAndPoliciesIndexRoute,
  StaffPublicIdsListSettingsIndexRoute: StaffPublicIdsListSettingsIndexRoute,
}

const StaffPublicIdsListRouteWithChildren =
  StaffPublicIdsListRoute._addFileChildren(StaffPublicIdsListRouteChildren)

interface StaffPublicIdsRouteChildren {
  StaffPublicIdsListRoute: typeof StaffPublicIdsListRouteWithChildren
  StaffPublicIdsImportCsvPublicIdTypeRouteRoute: typeof StaffPublicIdsImportCsvPublicIdTypeRouteRoute
  StaffPublicIdsAddIndexRoute: typeof StaffPublicIdsAddIndexRoute
}

const StaffPublicIdsRouteChildren: StaffPublicIdsRouteChildren = {
  StaffPublicIdsListRoute: StaffPublicIdsListRouteWithChildren,
  StaffPublicIdsImportCsvPublicIdTypeRouteRoute:
    StaffPublicIdsImportCsvPublicIdTypeRouteRoute,
  StaffPublicIdsAddIndexRoute: StaffPublicIdsAddIndexRoute,
}

const StaffPublicIdsRouteWithChildren = StaffPublicIdsRoute._addFileChildren(
  StaffPublicIdsRouteChildren,
)

interface StaffSoftwareLayoutPeopleRouteRouteChildren {
  StaffSoftwareLayoutPeopleIndexRoute: typeof StaffSoftwareLayoutPeopleIndexRoute
}

const StaffSoftwareLayoutPeopleRouteRouteChildren: StaffSoftwareLayoutPeopleRouteRouteChildren =
  {
    StaffSoftwareLayoutPeopleIndexRoute: StaffSoftwareLayoutPeopleIndexRoute,
  }

const StaffSoftwareLayoutPeopleRouteRouteWithChildren =
  StaffSoftwareLayoutPeopleRouteRoute._addFileChildren(
    StaffSoftwareLayoutPeopleRouteRouteChildren,
  )

interface StaffSoftwareLayoutMarketplaceIdRouteRouteChildren {
  StaffSoftwareLayoutMarketplaceIdInstallFinishIndexRoute: typeof StaffSoftwareLayoutMarketplaceIdInstallFinishIndexRoute
}

const StaffSoftwareLayoutMarketplaceIdRouteRouteChildren: StaffSoftwareLayoutMarketplaceIdRouteRouteChildren =
  {
    StaffSoftwareLayoutMarketplaceIdInstallFinishIndexRoute:
      StaffSoftwareLayoutMarketplaceIdInstallFinishIndexRoute,
  }

const StaffSoftwareLayoutMarketplaceIdRouteRouteWithChildren =
  StaffSoftwareLayoutMarketplaceIdRouteRoute._addFileChildren(
    StaffSoftwareLayoutMarketplaceIdRouteRouteChildren,
  )

interface StaffSoftwareLayoutAlertsAlertsRouteChildren {
  StaffSoftwareLayoutAlertsAlertsIndexRoute: typeof StaffSoftwareLayoutAlertsAlertsIndexRoute
  StaffSoftwareLayoutAlertsAlertsAlumniIndexRoute: typeof StaffSoftwareLayoutAlertsAlertsAlumniIndexRoute
  StaffSoftwareLayoutAlertsAlertsInactiveUserIndexRoute: typeof StaffSoftwareLayoutAlertsAlertsInactiveUserIndexRoute
  StaffSoftwareLayoutAlertsAlertsNoUserIndexRoute: typeof StaffSoftwareLayoutAlertsAlertsNoUserIndexRoute
  StaffSoftwareLayoutAlertsAlertsNoWorkerIndexRoute: typeof StaffSoftwareLayoutAlertsAlertsNoWorkerIndexRoute
  StaffSoftwareLayoutAlertsAlertsViolatedAssignmentIndexRoute: typeof StaffSoftwareLayoutAlertsAlertsViolatedAssignmentIndexRoute
  StaffSoftwareLayoutAlertsAlertsViolatedRoleIndexRoute: typeof StaffSoftwareLayoutAlertsAlertsViolatedRoleIndexRoute
}

const StaffSoftwareLayoutAlertsAlertsRouteChildren: StaffSoftwareLayoutAlertsAlertsRouteChildren =
  {
    StaffSoftwareLayoutAlertsAlertsIndexRoute:
      StaffSoftwareLayoutAlertsAlertsIndexRoute,
    StaffSoftwareLayoutAlertsAlertsAlumniIndexRoute:
      StaffSoftwareLayoutAlertsAlertsAlumniIndexRoute,
    StaffSoftwareLayoutAlertsAlertsInactiveUserIndexRoute:
      StaffSoftwareLayoutAlertsAlertsInactiveUserIndexRoute,
    StaffSoftwareLayoutAlertsAlertsNoUserIndexRoute:
      StaffSoftwareLayoutAlertsAlertsNoUserIndexRoute,
    StaffSoftwareLayoutAlertsAlertsNoWorkerIndexRoute:
      StaffSoftwareLayoutAlertsAlertsNoWorkerIndexRoute,
    StaffSoftwareLayoutAlertsAlertsViolatedAssignmentIndexRoute:
      StaffSoftwareLayoutAlertsAlertsViolatedAssignmentIndexRoute,
    StaffSoftwareLayoutAlertsAlertsViolatedRoleIndexRoute:
      StaffSoftwareLayoutAlertsAlertsViolatedRoleIndexRoute,
  }

const StaffSoftwareLayoutAlertsAlertsRouteWithChildren =
  StaffSoftwareLayoutAlertsAlertsRoute._addFileChildren(
    StaffSoftwareLayoutAlertsAlertsRouteChildren,
  )

interface StaffSoftwareLayoutAlertsRouteChildren {
  StaffSoftwareLayoutAlertsAlertsRoute: typeof StaffSoftwareLayoutAlertsAlertsRouteWithChildren
}

const StaffSoftwareLayoutAlertsRouteChildren: StaffSoftwareLayoutAlertsRouteChildren =
  {
    StaffSoftwareLayoutAlertsAlertsRoute:
      StaffSoftwareLayoutAlertsAlertsRouteWithChildren,
  }

const StaffSoftwareLayoutAlertsRouteWithChildren =
  StaffSoftwareLayoutAlertsRoute._addFileChildren(
    StaffSoftwareLayoutAlertsRouteChildren,
  )

interface StaffSoftwareLayoutContractAndCostContractAndCostDealDealRouteChildren {
  StaffSoftwareLayoutContractAndCostContractAndCostDealDealIndexRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealIndexRoute
  StaffSoftwareLayoutContractAndCostContractAndCostDealDealAllIndexRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealAllIndexRoute
  StaffSoftwareLayoutContractAndCostContractAndCostDealDealContractIndexRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealContractIndexRoute
  StaffSoftwareLayoutContractAndCostContractAndCostDealDealEstimateIndexRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealEstimateIndexRoute
  StaffSoftwareLayoutContractAndCostContractAndCostDealDealOrderIndexRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealOrderIndexRoute
  StaffSoftwareLayoutContractAndCostContractAndCostDealDealPaymentIndexRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealPaymentIndexRoute
  StaffSoftwareLayoutContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute
}

const StaffSoftwareLayoutContractAndCostContractAndCostDealDealRouteChildren: StaffSoftwareLayoutContractAndCostContractAndCostDealDealRouteChildren =
  {
    StaffSoftwareLayoutContractAndCostContractAndCostDealDealIndexRoute:
      StaffSoftwareLayoutContractAndCostContractAndCostDealDealIndexRoute,
    StaffSoftwareLayoutContractAndCostContractAndCostDealDealAllIndexRoute:
      StaffSoftwareLayoutContractAndCostContractAndCostDealDealAllIndexRoute,
    StaffSoftwareLayoutContractAndCostContractAndCostDealDealContractIndexRoute:
      StaffSoftwareLayoutContractAndCostContractAndCostDealDealContractIndexRoute,
    StaffSoftwareLayoutContractAndCostContractAndCostDealDealEstimateIndexRoute:
      StaffSoftwareLayoutContractAndCostContractAndCostDealDealEstimateIndexRoute,
    StaffSoftwareLayoutContractAndCostContractAndCostDealDealOrderIndexRoute:
      StaffSoftwareLayoutContractAndCostContractAndCostDealDealOrderIndexRoute,
    StaffSoftwareLayoutContractAndCostContractAndCostDealDealPaymentIndexRoute:
      StaffSoftwareLayoutContractAndCostContractAndCostDealDealPaymentIndexRoute,
    StaffSoftwareLayoutContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute:
      StaffSoftwareLayoutContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute,
  }

const StaffSoftwareLayoutContractAndCostContractAndCostDealDealRouteWithChildren =
  StaffSoftwareLayoutContractAndCostContractAndCostDealDealRoute._addFileChildren(
    StaffSoftwareLayoutContractAndCostContractAndCostDealDealRouteChildren,
  )

interface StaffSoftwareLayoutContractAndCostContractAndCostDealRouteChildren {
  StaffSoftwareLayoutContractAndCostContractAndCostDealDealRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealRouteWithChildren
}

const StaffSoftwareLayoutContractAndCostContractAndCostDealRouteChildren: StaffSoftwareLayoutContractAndCostContractAndCostDealRouteChildren =
  {
    StaffSoftwareLayoutContractAndCostContractAndCostDealDealRoute:
      StaffSoftwareLayoutContractAndCostContractAndCostDealDealRouteWithChildren,
  }

const StaffSoftwareLayoutContractAndCostContractAndCostDealRouteWithChildren =
  StaffSoftwareLayoutContractAndCostContractAndCostDealRoute._addFileChildren(
    StaffSoftwareLayoutContractAndCostContractAndCostDealRouteChildren,
  )

interface StaffSoftwareLayoutContractAndCostContractAndCostRouteChildren {
  StaffSoftwareLayoutContractAndCostContractAndCostIndexRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostIndexRoute
  StaffSoftwareLayoutContractAndCostContractAndCostDealRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostDealRouteWithChildren
  StaffSoftwareLayoutContractAndCostContractAndCostCostIndexRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostCostIndexRoute
  StaffSoftwareLayoutContractAndCostContractAndCostPaymentIndexRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostPaymentIndexRoute
  StaffSoftwareLayoutContractAndCostContractAndCostCostPeriodIndexRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostCostPeriodIndexRoute
  StaffSoftwareLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute
}

const StaffSoftwareLayoutContractAndCostContractAndCostRouteChildren: StaffSoftwareLayoutContractAndCostContractAndCostRouteChildren =
  {
    StaffSoftwareLayoutContractAndCostContractAndCostIndexRoute:
      StaffSoftwareLayoutContractAndCostContractAndCostIndexRoute,
    StaffSoftwareLayoutContractAndCostContractAndCostDealRoute:
      StaffSoftwareLayoutContractAndCostContractAndCostDealRouteWithChildren,
    StaffSoftwareLayoutContractAndCostContractAndCostCostIndexRoute:
      StaffSoftwareLayoutContractAndCostContractAndCostCostIndexRoute,
    StaffSoftwareLayoutContractAndCostContractAndCostPaymentIndexRoute:
      StaffSoftwareLayoutContractAndCostContractAndCostPaymentIndexRoute,
    StaffSoftwareLayoutContractAndCostContractAndCostCostPeriodIndexRoute:
      StaffSoftwareLayoutContractAndCostContractAndCostCostPeriodIndexRoute,
    StaffSoftwareLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute:
      StaffSoftwareLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute,
  }

const StaffSoftwareLayoutContractAndCostContractAndCostRouteWithChildren =
  StaffSoftwareLayoutContractAndCostContractAndCostRoute._addFileChildren(
    StaffSoftwareLayoutContractAndCostContractAndCostRouteChildren,
  )

interface StaffSoftwareLayoutContractAndCostRouteChildren {
  StaffSoftwareLayoutContractAndCostContractAndCostRoute: typeof StaffSoftwareLayoutContractAndCostContractAndCostRouteWithChildren
}

const StaffSoftwareLayoutContractAndCostRouteChildren: StaffSoftwareLayoutContractAndCostRouteChildren =
  {
    StaffSoftwareLayoutContractAndCostContractAndCostRoute:
      StaffSoftwareLayoutContractAndCostContractAndCostRouteWithChildren,
  }

const StaffSoftwareLayoutContractAndCostRouteWithChildren =
  StaffSoftwareLayoutContractAndCostRoute._addFileChildren(
    StaffSoftwareLayoutContractAndCostRouteChildren,
  )

interface StaffSoftwareLayoutRouteChildren {
  StaffSoftwareLayoutPeopleRouteRoute: typeof StaffSoftwareLayoutPeopleRouteRouteWithChildren
  StaffSoftwareLayoutIntegrationsRoute: typeof StaffSoftwareLayoutIntegrationsRoute
  StaffSoftwareLayoutIndexRouteLazyRoute: typeof StaffSoftwareLayoutIndexRouteLazyRoute
  StaffSoftwareLayoutMarketplaceIdRouteRoute: typeof StaffSoftwareLayoutMarketplaceIdRouteRouteWithChildren
  StaffSoftwareLayoutAlertsRoute: typeof StaffSoftwareLayoutAlertsRouteWithChildren
  StaffSoftwareLayoutContractAndCostRoute: typeof StaffSoftwareLayoutContractAndCostRouteWithChildren
  StaffSoftwareLayoutLibraryIndexRoute: typeof StaffSoftwareLayoutLibraryIndexRoute
  StaffSoftwareLayoutOperationActivityIndexRoute: typeof StaffSoftwareLayoutOperationActivityIndexRoute
  StaffSoftwareLayoutRegistryIndexRoute: typeof StaffSoftwareLayoutRegistryIndexRoute
  StaffSoftwareLayoutRuleAndPolicyIndexRoute: typeof StaffSoftwareLayoutRuleAndPolicyIndexRoute
  StaffSoftwareLayoutSettingsIndexRoute: typeof StaffSoftwareLayoutSettingsIndexRoute
  StaffSoftwareLayoutLibrarySearchIndexRoute: typeof StaffSoftwareLayoutLibrarySearchIndexRoute
  StaffSoftwareLayoutLibraryCategoryCategoryIndexRoute: typeof StaffSoftwareLayoutLibraryCategoryCategoryIndexRoute
  StaffSoftwareLayoutLibraryDetailSoftwareLibraryIdIndexRoute: typeof StaffSoftwareLayoutLibraryDetailSoftwareLibraryIdIndexRoute
  StaffSoftwareLayoutLibraryCategoryCategorySearchIndexRoute: typeof StaffSoftwareLayoutLibraryCategoryCategorySearchIndexRoute
}

const StaffSoftwareLayoutRouteChildren: StaffSoftwareLayoutRouteChildren = {
  StaffSoftwareLayoutPeopleRouteRoute:
    StaffSoftwareLayoutPeopleRouteRouteWithChildren,
  StaffSoftwareLayoutIntegrationsRoute: StaffSoftwareLayoutIntegrationsRoute,
  StaffSoftwareLayoutIndexRouteLazyRoute:
    StaffSoftwareLayoutIndexRouteLazyRoute,
  StaffSoftwareLayoutMarketplaceIdRouteRoute:
    StaffSoftwareLayoutMarketplaceIdRouteRouteWithChildren,
  StaffSoftwareLayoutAlertsRoute: StaffSoftwareLayoutAlertsRouteWithChildren,
  StaffSoftwareLayoutContractAndCostRoute:
    StaffSoftwareLayoutContractAndCostRouteWithChildren,
  StaffSoftwareLayoutLibraryIndexRoute: StaffSoftwareLayoutLibraryIndexRoute,
  StaffSoftwareLayoutOperationActivityIndexRoute:
    StaffSoftwareLayoutOperationActivityIndexRoute,
  StaffSoftwareLayoutRegistryIndexRoute: StaffSoftwareLayoutRegistryIndexRoute,
  StaffSoftwareLayoutRuleAndPolicyIndexRoute:
    StaffSoftwareLayoutRuleAndPolicyIndexRoute,
  StaffSoftwareLayoutSettingsIndexRoute: StaffSoftwareLayoutSettingsIndexRoute,
  StaffSoftwareLayoutLibrarySearchIndexRoute:
    StaffSoftwareLayoutLibrarySearchIndexRoute,
  StaffSoftwareLayoutLibraryCategoryCategoryIndexRoute:
    StaffSoftwareLayoutLibraryCategoryCategoryIndexRoute,
  StaffSoftwareLayoutLibraryDetailSoftwareLibraryIdIndexRoute:
    StaffSoftwareLayoutLibraryDetailSoftwareLibraryIdIndexRoute,
  StaffSoftwareLayoutLibraryCategoryCategorySearchIndexRoute:
    StaffSoftwareLayoutLibraryCategoryCategorySearchIndexRoute,
}

const StaffSoftwareLayoutRouteWithChildren =
  StaffSoftwareLayoutRoute._addFileChildren(StaffSoftwareLayoutRouteChildren)

interface StaffSoftwareIdIdSettingsRouteLazyRouteChildren {
  StaffSoftwareIdIdSettingsIndexRoute: typeof StaffSoftwareIdIdSettingsIndexRoute
  StaffSoftwareIdIdSettingsIntegrationIndexRoute: typeof StaffSoftwareIdIdSettingsIntegrationIndexRoute
  StaffSoftwareIdIdSettingsRoleIndexRoute: typeof StaffSoftwareIdIdSettingsRoleIndexRoute
  StaffSoftwareIdIdSettingsStatusIndexRoute: typeof StaffSoftwareIdIdSettingsStatusIndexRoute
}

const StaffSoftwareIdIdSettingsRouteLazyRouteChildren: StaffSoftwareIdIdSettingsRouteLazyRouteChildren =
  {
    StaffSoftwareIdIdSettingsIndexRoute: StaffSoftwareIdIdSettingsIndexRoute,
    StaffSoftwareIdIdSettingsIntegrationIndexRoute:
      StaffSoftwareIdIdSettingsIntegrationIndexRoute,
    StaffSoftwareIdIdSettingsRoleIndexRoute:
      StaffSoftwareIdIdSettingsRoleIndexRoute,
    StaffSoftwareIdIdSettingsStatusIndexRoute:
      StaffSoftwareIdIdSettingsStatusIndexRoute,
  }

const StaffSoftwareIdIdSettingsRouteLazyRouteWithChildren =
  StaffSoftwareIdIdSettingsRouteLazyRoute._addFileChildren(
    StaffSoftwareIdIdSettingsRouteLazyRouteChildren,
  )

interface StaffSoftwareIdIdContractAndCostContractAndCostDealDealRouteChildren {
  StaffSoftwareIdIdContractAndCostContractAndCostDealDealIndexRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealIndexRoute
  StaffSoftwareIdIdContractAndCostContractAndCostDealDealAllIndexRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealAllIndexRoute
  StaffSoftwareIdIdContractAndCostContractAndCostDealDealContractIndexRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealContractIndexRoute
  StaffSoftwareIdIdContractAndCostContractAndCostDealDealEstimateIndexRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealEstimateIndexRoute
  StaffSoftwareIdIdContractAndCostContractAndCostDealDealOrderIndexRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealOrderIndexRoute
  StaffSoftwareIdIdContractAndCostContractAndCostDealDealPaymentIndexRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealPaymentIndexRoute
  StaffSoftwareIdIdContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute
}

const StaffSoftwareIdIdContractAndCostContractAndCostDealDealRouteChildren: StaffSoftwareIdIdContractAndCostContractAndCostDealDealRouteChildren =
  {
    StaffSoftwareIdIdContractAndCostContractAndCostDealDealIndexRoute:
      StaffSoftwareIdIdContractAndCostContractAndCostDealDealIndexRoute,
    StaffSoftwareIdIdContractAndCostContractAndCostDealDealAllIndexRoute:
      StaffSoftwareIdIdContractAndCostContractAndCostDealDealAllIndexRoute,
    StaffSoftwareIdIdContractAndCostContractAndCostDealDealContractIndexRoute:
      StaffSoftwareIdIdContractAndCostContractAndCostDealDealContractIndexRoute,
    StaffSoftwareIdIdContractAndCostContractAndCostDealDealEstimateIndexRoute:
      StaffSoftwareIdIdContractAndCostContractAndCostDealDealEstimateIndexRoute,
    StaffSoftwareIdIdContractAndCostContractAndCostDealDealOrderIndexRoute:
      StaffSoftwareIdIdContractAndCostContractAndCostDealDealOrderIndexRoute,
    StaffSoftwareIdIdContractAndCostContractAndCostDealDealPaymentIndexRoute:
      StaffSoftwareIdIdContractAndCostContractAndCostDealDealPaymentIndexRoute,
    StaffSoftwareIdIdContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute:
      StaffSoftwareIdIdContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute,
  }

const StaffSoftwareIdIdContractAndCostContractAndCostDealDealRouteWithChildren =
  StaffSoftwareIdIdContractAndCostContractAndCostDealDealRoute._addFileChildren(
    StaffSoftwareIdIdContractAndCostContractAndCostDealDealRouteChildren,
  )

interface StaffSoftwareIdIdContractAndCostContractAndCostDealRouteChildren {
  StaffSoftwareIdIdContractAndCostContractAndCostDealDealRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealRouteWithChildren
}

const StaffSoftwareIdIdContractAndCostContractAndCostDealRouteChildren: StaffSoftwareIdIdContractAndCostContractAndCostDealRouteChildren =
  {
    StaffSoftwareIdIdContractAndCostContractAndCostDealDealRoute:
      StaffSoftwareIdIdContractAndCostContractAndCostDealDealRouteWithChildren,
  }

const StaffSoftwareIdIdContractAndCostContractAndCostDealRouteWithChildren =
  StaffSoftwareIdIdContractAndCostContractAndCostDealRoute._addFileChildren(
    StaffSoftwareIdIdContractAndCostContractAndCostDealRouteChildren,
  )

interface StaffSoftwareIdIdContractAndCostContractAndCostRouteChildren {
  StaffSoftwareIdIdContractAndCostContractAndCostIndexRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostIndexRoute
  StaffSoftwareIdIdContractAndCostContractAndCostDealRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostDealRouteWithChildren
  StaffSoftwareIdIdContractAndCostContractAndCostCostIndexRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostCostIndexRoute
  StaffSoftwareIdIdContractAndCostContractAndCostPaymentIndexRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostPaymentIndexRoute
  StaffSoftwareIdIdContractAndCostContractAndCostCostPeriodIndexRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostCostPeriodIndexRoute
  StaffSoftwareIdIdContractAndCostContractAndCostPaymentPeriodIndexRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostPaymentPeriodIndexRoute
}

const StaffSoftwareIdIdContractAndCostContractAndCostRouteChildren: StaffSoftwareIdIdContractAndCostContractAndCostRouteChildren =
  {
    StaffSoftwareIdIdContractAndCostContractAndCostIndexRoute:
      StaffSoftwareIdIdContractAndCostContractAndCostIndexRoute,
    StaffSoftwareIdIdContractAndCostContractAndCostDealRoute:
      StaffSoftwareIdIdContractAndCostContractAndCostDealRouteWithChildren,
    StaffSoftwareIdIdContractAndCostContractAndCostCostIndexRoute:
      StaffSoftwareIdIdContractAndCostContractAndCostCostIndexRoute,
    StaffSoftwareIdIdContractAndCostContractAndCostPaymentIndexRoute:
      StaffSoftwareIdIdContractAndCostContractAndCostPaymentIndexRoute,
    StaffSoftwareIdIdContractAndCostContractAndCostCostPeriodIndexRoute:
      StaffSoftwareIdIdContractAndCostContractAndCostCostPeriodIndexRoute,
    StaffSoftwareIdIdContractAndCostContractAndCostPaymentPeriodIndexRoute:
      StaffSoftwareIdIdContractAndCostContractAndCostPaymentPeriodIndexRoute,
  }

const StaffSoftwareIdIdContractAndCostContractAndCostRouteWithChildren =
  StaffSoftwareIdIdContractAndCostContractAndCostRoute._addFileChildren(
    StaffSoftwareIdIdContractAndCostContractAndCostRouteChildren,
  )

interface StaffSoftwareIdIdContractAndCostRouteChildren {
  StaffSoftwareIdIdContractAndCostContractAndCostRoute: typeof StaffSoftwareIdIdContractAndCostContractAndCostRouteWithChildren
}

const StaffSoftwareIdIdContractAndCostRouteChildren: StaffSoftwareIdIdContractAndCostRouteChildren =
  {
    StaffSoftwareIdIdContractAndCostContractAndCostRoute:
      StaffSoftwareIdIdContractAndCostContractAndCostRouteWithChildren,
  }

const StaffSoftwareIdIdContractAndCostRouteWithChildren =
  StaffSoftwareIdIdContractAndCostRoute._addFileChildren(
    StaffSoftwareIdIdContractAndCostRouteChildren,
  )

interface StaffSoftwareIdIdRouteChildren {
  StaffSoftwareIdIdGroupsRoute: typeof StaffSoftwareIdIdGroupsRoute
  StaffSoftwareIdIdProfilesRoute: typeof StaffSoftwareIdIdProfilesRoute
  StaffSoftwareIdIdSettingsRouteLazyRoute: typeof StaffSoftwareIdIdSettingsRouteLazyRouteWithChildren
  StaffSoftwareIdIdIndexRoute: typeof StaffSoftwareIdIdIndexRoute
  StaffSoftwareIdIdContractAndCostRoute: typeof StaffSoftwareIdIdContractAndCostRouteWithChildren
  StaffSoftwareIdIdAccountsIndexRoute: typeof StaffSoftwareIdIdAccountsIndexRoute
  StaffSoftwareIdIdActivityMonitoringIndexRoute: typeof StaffSoftwareIdIdActivityMonitoringIndexRoute
  StaffSoftwareIdIdAlertsIndexRoute: typeof StaffSoftwareIdIdAlertsIndexRoute
  StaffSoftwareIdIdArchitectureIndexRoute: typeof StaffSoftwareIdIdArchitectureIndexRoute
  StaffSoftwareIdIdDetailIndexRoute: typeof StaffSoftwareIdIdDetailIndexRoute
  StaffSoftwareIdIdRuleAndPolicyIndexRoute: typeof StaffSoftwareIdIdRuleAndPolicyIndexRoute
}

const StaffSoftwareIdIdRouteChildren: StaffSoftwareIdIdRouteChildren = {
  StaffSoftwareIdIdGroupsRoute: StaffSoftwareIdIdGroupsRoute,
  StaffSoftwareIdIdProfilesRoute: StaffSoftwareIdIdProfilesRoute,
  StaffSoftwareIdIdSettingsRouteLazyRoute:
    StaffSoftwareIdIdSettingsRouteLazyRouteWithChildren,
  StaffSoftwareIdIdIndexRoute: StaffSoftwareIdIdIndexRoute,
  StaffSoftwareIdIdContractAndCostRoute:
    StaffSoftwareIdIdContractAndCostRouteWithChildren,
  StaffSoftwareIdIdAccountsIndexRoute: StaffSoftwareIdIdAccountsIndexRoute,
  StaffSoftwareIdIdActivityMonitoringIndexRoute:
    StaffSoftwareIdIdActivityMonitoringIndexRoute,
  StaffSoftwareIdIdAlertsIndexRoute: StaffSoftwareIdIdAlertsIndexRoute,
  StaffSoftwareIdIdArchitectureIndexRoute:
    StaffSoftwareIdIdArchitectureIndexRoute,
  StaffSoftwareIdIdDetailIndexRoute: StaffSoftwareIdIdDetailIndexRoute,
  StaffSoftwareIdIdRuleAndPolicyIndexRoute:
    StaffSoftwareIdIdRuleAndPolicyIndexRoute,
}

const StaffSoftwareIdIdRouteWithChildren =
  StaffSoftwareIdIdRoute._addFileChildren(StaffSoftwareIdIdRouteChildren)

interface StaffSoftwareIdRouteChildren {
  StaffSoftwareIdIdRoute: typeof StaffSoftwareIdIdRouteWithChildren
}

const StaffSoftwareIdRouteChildren: StaffSoftwareIdRouteChildren = {
  StaffSoftwareIdIdRoute: StaffSoftwareIdIdRouteWithChildren,
}

const StaffSoftwareIdRouteWithChildren = StaffSoftwareIdRoute._addFileChildren(
  StaffSoftwareIdRouteChildren,
)

interface StaffSoftwareRouteChildren {
  StaffSoftwareLayoutRoute: typeof StaffSoftwareLayoutRouteWithChildren
  StaffSoftwareIdImportCsvRouteRoute: typeof StaffSoftwareIdImportCsvRouteRoute
  StaffSoftwareIdRoute: typeof StaffSoftwareIdRouteWithChildren
  StaffSoftwareAddIndexRoute: typeof StaffSoftwareAddIndexRoute
  StaffSoftwareAddTypeIndexRoute: typeof StaffSoftwareAddTypeIndexRoute
  StaffSoftwareCustomSaasAddCustomSaasTypeIndexRoute: typeof StaffSoftwareCustomSaasAddCustomSaasTypeIndexRoute
}

const StaffSoftwareRouteChildren: StaffSoftwareRouteChildren = {
  StaffSoftwareLayoutRoute: StaffSoftwareLayoutRouteWithChildren,
  StaffSoftwareIdImportCsvRouteRoute: StaffSoftwareIdImportCsvRouteRoute,
  StaffSoftwareIdRoute: StaffSoftwareIdRouteWithChildren,
  StaffSoftwareAddIndexRoute: StaffSoftwareAddIndexRoute,
  StaffSoftwareAddTypeIndexRoute: StaffSoftwareAddTypeIndexRoute,
  StaffSoftwareCustomSaasAddCustomSaasTypeIndexRoute:
    StaffSoftwareCustomSaasAddCustomSaasTypeIndexRoute,
}

const StaffSoftwareRouteWithChildren = StaffSoftwareRoute._addFileChildren(
  StaffSoftwareRouteChildren,
)

interface StaffStarlinksLayoutRouteChildren {
  StaffStarlinksLayoutIndexRoute: typeof StaffStarlinksLayoutIndexRoute
  StaffStarlinksLayoutPlaceholdersBillingAndCostRoute: typeof StaffStarlinksLayoutPlaceholdersBillingAndCostRoute
  StaffStarlinksLayoutPlaceholdersMarketplaceRoute: typeof StaffStarlinksLayoutPlaceholdersMarketplaceRoute
  StaffStarlinksLayoutPlaceholdersOperationActivityRoute: typeof StaffStarlinksLayoutPlaceholdersOperationActivityRoute
  StaffStarlinksLayoutAlertsIndexRoute: typeof StaffStarlinksLayoutAlertsIndexRoute
  StaffStarlinksLayoutUserTerminalsIndexRoute: typeof StaffStarlinksLayoutUserTerminalsIndexRoute
}

const StaffStarlinksLayoutRouteChildren: StaffStarlinksLayoutRouteChildren = {
  StaffStarlinksLayoutIndexRoute: StaffStarlinksLayoutIndexRoute,
  StaffStarlinksLayoutPlaceholdersBillingAndCostRoute:
    StaffStarlinksLayoutPlaceholdersBillingAndCostRoute,
  StaffStarlinksLayoutPlaceholdersMarketplaceRoute:
    StaffStarlinksLayoutPlaceholdersMarketplaceRoute,
  StaffStarlinksLayoutPlaceholdersOperationActivityRoute:
    StaffStarlinksLayoutPlaceholdersOperationActivityRoute,
  StaffStarlinksLayoutAlertsIndexRoute: StaffStarlinksLayoutAlertsIndexRoute,
  StaffStarlinksLayoutUserTerminalsIndexRoute:
    StaffStarlinksLayoutUserTerminalsIndexRoute,
}

const StaffStarlinksLayoutRouteWithChildren =
  StaffStarlinksLayoutRoute._addFileChildren(StaffStarlinksLayoutRouteChildren)

interface StaffStarlinksIdLayoutRouteChildren {
  StaffStarlinksIdLayoutOverviewIndexLazyRoute: typeof StaffStarlinksIdLayoutOverviewIndexLazyRoute
  StaffStarlinksIdLayoutDetailIndexLazyRoute: typeof StaffStarlinksIdLayoutDetailIndexLazyRoute
}

const StaffStarlinksIdLayoutRouteChildren: StaffStarlinksIdLayoutRouteChildren =
  {
    StaffStarlinksIdLayoutOverviewIndexLazyRoute:
      StaffStarlinksIdLayoutOverviewIndexLazyRoute,
    StaffStarlinksIdLayoutDetailIndexLazyRoute:
      StaffStarlinksIdLayoutDetailIndexLazyRoute,
  }

const StaffStarlinksIdLayoutRouteWithChildren =
  StaffStarlinksIdLayoutRoute._addFileChildren(
    StaffStarlinksIdLayoutRouteChildren,
  )

interface StaffStarlinksIdRouteChildren {
  StaffStarlinksIdLayoutRoute: typeof StaffStarlinksIdLayoutRouteWithChildren
}

const StaffStarlinksIdRouteChildren: StaffStarlinksIdRouteChildren = {
  StaffStarlinksIdLayoutRoute: StaffStarlinksIdLayoutRouteWithChildren,
}

const StaffStarlinksIdRouteWithChildren =
  StaffStarlinksIdRoute._addFileChildren(StaffStarlinksIdRouteChildren)

interface StaffStarlinksRouteChildren {
  StaffStarlinksLayoutRoute: typeof StaffStarlinksLayoutRouteWithChildren
  StaffStarlinksIdRoute: typeof StaffStarlinksIdRouteWithChildren
}

const StaffStarlinksRouteChildren: StaffStarlinksRouteChildren = {
  StaffStarlinksLayoutRoute: StaffStarlinksLayoutRouteWithChildren,
  StaffStarlinksIdRoute: StaffStarlinksIdRouteWithChildren,
}

const StaffStarlinksRouteWithChildren = StaffStarlinksRoute._addFileChildren(
  StaffStarlinksRouteChildren,
)

interface StaffStorageFilesListRouteChildren {
  StaffStorageFilesListIndexRoute: typeof StaffStorageFilesListIndexRoute
  StaffStorageFilesListFilesIndexRoute: typeof StaffStorageFilesListFilesIndexRoute
  StaffStorageFilesListFoldersIndexRoute: typeof StaffStorageFilesListFoldersIndexRoute
  StaffStorageFilesListSettingsIndexRoute: typeof StaffStorageFilesListSettingsIndexRoute
}

const StaffStorageFilesListRouteChildren: StaffStorageFilesListRouteChildren = {
  StaffStorageFilesListIndexRoute: StaffStorageFilesListIndexRoute,
  StaffStorageFilesListFilesIndexRoute: StaffStorageFilesListFilesIndexRoute,
  StaffStorageFilesListFoldersIndexRoute:
    StaffStorageFilesListFoldersIndexRoute,
  StaffStorageFilesListSettingsIndexRoute:
    StaffStorageFilesListSettingsIndexRoute,
}

const StaffStorageFilesListRouteWithChildren =
  StaffStorageFilesListRoute._addFileChildren(
    StaffStorageFilesListRouteChildren,
  )

interface StaffStorageFilesFilesIdIdRouteChildren {
  StaffStorageFilesFilesIdIdIndexLazyRoute: typeof StaffStorageFilesFilesIdIdIndexLazyRoute
}

const StaffStorageFilesFilesIdIdRouteChildren: StaffStorageFilesFilesIdIdRouteChildren =
  {
    StaffStorageFilesFilesIdIdIndexLazyRoute:
      StaffStorageFilesFilesIdIdIndexLazyRoute,
  }

const StaffStorageFilesFilesIdIdRouteWithChildren =
  StaffStorageFilesFilesIdIdRoute._addFileChildren(
    StaffStorageFilesFilesIdIdRouteChildren,
  )

interface StaffStorageFilesFilesIdRouteChildren {
  StaffStorageFilesFilesIdIdRoute: typeof StaffStorageFilesFilesIdIdRouteWithChildren
}

const StaffStorageFilesFilesIdRouteChildren: StaffStorageFilesFilesIdRouteChildren =
  {
    StaffStorageFilesFilesIdIdRoute:
      StaffStorageFilesFilesIdIdRouteWithChildren,
  }

const StaffStorageFilesFilesIdRouteWithChildren =
  StaffStorageFilesFilesIdRoute._addFileChildren(
    StaffStorageFilesFilesIdRouteChildren,
  )

interface StaffStorageFilesFoldersIdIdRouteChildren {
  StaffStorageFilesFoldersIdIdIndexLazyRoute: typeof StaffStorageFilesFoldersIdIdIndexLazyRoute
  StaffStorageFilesFoldersIdIdFilesIndexRoute: typeof StaffStorageFilesFoldersIdIdFilesIndexRoute
  StaffStorageFilesFoldersIdIdUsersIndexRoute: typeof StaffStorageFilesFoldersIdIdUsersIndexRoute
}

const StaffStorageFilesFoldersIdIdRouteChildren: StaffStorageFilesFoldersIdIdRouteChildren =
  {
    StaffStorageFilesFoldersIdIdIndexLazyRoute:
      StaffStorageFilesFoldersIdIdIndexLazyRoute,
    StaffStorageFilesFoldersIdIdFilesIndexRoute:
      StaffStorageFilesFoldersIdIdFilesIndexRoute,
    StaffStorageFilesFoldersIdIdUsersIndexRoute:
      StaffStorageFilesFoldersIdIdUsersIndexRoute,
  }

const StaffStorageFilesFoldersIdIdRouteWithChildren =
  StaffStorageFilesFoldersIdIdRoute._addFileChildren(
    StaffStorageFilesFoldersIdIdRouteChildren,
  )

interface StaffStorageFilesFoldersIdRouteChildren {
  StaffStorageFilesFoldersIdIdRoute: typeof StaffStorageFilesFoldersIdIdRouteWithChildren
}

const StaffStorageFilesFoldersIdRouteChildren: StaffStorageFilesFoldersIdRouteChildren =
  {
    StaffStorageFilesFoldersIdIdRoute:
      StaffStorageFilesFoldersIdIdRouteWithChildren,
  }

const StaffStorageFilesFoldersIdRouteWithChildren =
  StaffStorageFilesFoldersIdRoute._addFileChildren(
    StaffStorageFilesFoldersIdRouteChildren,
  )

interface StaffStorageFilesRouteChildren {
  StaffStorageFilesListRoute: typeof StaffStorageFilesListRouteWithChildren
  StaffStorageFilesFilesIdRoute: typeof StaffStorageFilesFilesIdRouteWithChildren
  StaffStorageFilesFoldersIdRoute: typeof StaffStorageFilesFoldersIdRouteWithChildren
}

const StaffStorageFilesRouteChildren: StaffStorageFilesRouteChildren = {
  StaffStorageFilesListRoute: StaffStorageFilesListRouteWithChildren,
  StaffStorageFilesFilesIdRoute: StaffStorageFilesFilesIdRouteWithChildren,
  StaffStorageFilesFoldersIdRoute: StaffStorageFilesFoldersIdRouteWithChildren,
}

const StaffStorageFilesRouteWithChildren =
  StaffStorageFilesRoute._addFileChildren(StaffStorageFilesRouteChildren)

interface StaffSupplierListSettingsRouteLazyRouteChildren {
  StaffSupplierListSettingsIndexRoute: typeof StaffSupplierListSettingsIndexRoute
  StaffSupplierListSettingsProcurementCategoriesIndexRoute: typeof StaffSupplierListSettingsProcurementCategoriesIndexRoute
  StaffSupplierListSettingsSupplierCategoriesIndexRoute: typeof StaffSupplierListSettingsSupplierCategoriesIndexRoute
  StaffSupplierListSettingsSupplierSubcategoriesIndexRoute: typeof StaffSupplierListSettingsSupplierSubcategoriesIndexRoute
}

const StaffSupplierListSettingsRouteLazyRouteChildren: StaffSupplierListSettingsRouteLazyRouteChildren =
  {
    StaffSupplierListSettingsIndexRoute: StaffSupplierListSettingsIndexRoute,
    StaffSupplierListSettingsProcurementCategoriesIndexRoute:
      StaffSupplierListSettingsProcurementCategoriesIndexRoute,
    StaffSupplierListSettingsSupplierCategoriesIndexRoute:
      StaffSupplierListSettingsSupplierCategoriesIndexRoute,
    StaffSupplierListSettingsSupplierSubcategoriesIndexRoute:
      StaffSupplierListSettingsSupplierSubcategoriesIndexRoute,
  }

const StaffSupplierListSettingsRouteLazyRouteWithChildren =
  StaffSupplierListSettingsRouteLazyRoute._addFileChildren(
    StaffSupplierListSettingsRouteLazyRouteChildren,
  )

interface StaffSupplierListRouteChildren {
  StaffSupplierListSettingsRouteLazyRoute: typeof StaffSupplierListSettingsRouteLazyRouteWithChildren
  StaffSupplierListIndexRoute: typeof StaffSupplierListIndexRoute
  StaffSupplierListPlaceholdersAlertsRouteRoute: typeof StaffSupplierListPlaceholdersAlertsRouteRoute
  StaffSupplierListPlaceholdersContractAndCostRouteRoute: typeof StaffSupplierListPlaceholdersContractAndCostRouteRoute
  StaffSupplierListPlaceholdersOperationActivityRouteRoute: typeof StaffSupplierListPlaceholdersOperationActivityRouteRoute
  StaffSupplierListPlaceholdersOverviewRouteRoute: typeof StaffSupplierListPlaceholdersOverviewRouteRoute
  StaffSupplierListPlaceholdersRuleAndPolicyRouteRoute: typeof StaffSupplierListPlaceholdersRuleAndPolicyRouteRoute
}

const StaffSupplierListRouteChildren: StaffSupplierListRouteChildren = {
  StaffSupplierListSettingsRouteLazyRoute:
    StaffSupplierListSettingsRouteLazyRouteWithChildren,
  StaffSupplierListIndexRoute: StaffSupplierListIndexRoute,
  StaffSupplierListPlaceholdersAlertsRouteRoute:
    StaffSupplierListPlaceholdersAlertsRouteRoute,
  StaffSupplierListPlaceholdersContractAndCostRouteRoute:
    StaffSupplierListPlaceholdersContractAndCostRouteRoute,
  StaffSupplierListPlaceholdersOperationActivityRouteRoute:
    StaffSupplierListPlaceholdersOperationActivityRouteRoute,
  StaffSupplierListPlaceholdersOverviewRouteRoute:
    StaffSupplierListPlaceholdersOverviewRouteRoute,
  StaffSupplierListPlaceholdersRuleAndPolicyRouteRoute:
    StaffSupplierListPlaceholdersRuleAndPolicyRouteRoute,
}

const StaffSupplierListRouteWithChildren =
  StaffSupplierListRoute._addFileChildren(StaffSupplierListRouteChildren)

interface StaffSupplierSupplierIdLayoutRouteChildren {
  StaffSupplierSupplierIdLayoutFilesRouteRoute: typeof StaffSupplierSupplierIdLayoutFilesRouteRoute
  StaffSupplierSupplierIdLayoutRulesAndPolicyRouteRoute: typeof StaffSupplierSupplierIdLayoutRulesAndPolicyRouteRoute
  StaffSupplierSupplierIdLayoutSettingsRouteRoute: typeof StaffSupplierSupplierIdLayoutSettingsRouteRoute
  StaffSupplierSupplierIdLayoutIndexIndexRoute: typeof StaffSupplierSupplierIdLayoutIndexIndexRoute
}

const StaffSupplierSupplierIdLayoutRouteChildren: StaffSupplierSupplierIdLayoutRouteChildren =
  {
    StaffSupplierSupplierIdLayoutFilesRouteRoute:
      StaffSupplierSupplierIdLayoutFilesRouteRoute,
    StaffSupplierSupplierIdLayoutRulesAndPolicyRouteRoute:
      StaffSupplierSupplierIdLayoutRulesAndPolicyRouteRoute,
    StaffSupplierSupplierIdLayoutSettingsRouteRoute:
      StaffSupplierSupplierIdLayoutSettingsRouteRoute,
    StaffSupplierSupplierIdLayoutIndexIndexRoute:
      StaffSupplierSupplierIdLayoutIndexIndexRoute,
  }

const StaffSupplierSupplierIdLayoutRouteWithChildren =
  StaffSupplierSupplierIdLayoutRoute._addFileChildren(
    StaffSupplierSupplierIdLayoutRouteChildren,
  )

interface StaffSupplierSupplierIdRouteChildren {
  StaffSupplierSupplierIdLayoutRoute: typeof StaffSupplierSupplierIdLayoutRouteWithChildren
}

const StaffSupplierSupplierIdRouteChildren: StaffSupplierSupplierIdRouteChildren =
  {
    StaffSupplierSupplierIdLayoutRoute:
      StaffSupplierSupplierIdLayoutRouteWithChildren,
  }

const StaffSupplierSupplierIdRouteWithChildren =
  StaffSupplierSupplierIdRoute._addFileChildren(
    StaffSupplierSupplierIdRouteChildren,
  )

interface StaffSupplierRouteChildren {
  StaffSupplierListRoute: typeof StaffSupplierListRouteWithChildren
  StaffSupplierSupplierIdRoute: typeof StaffSupplierSupplierIdRouteWithChildren
}

const StaffSupplierRouteChildren: StaffSupplierRouteChildren = {
  StaffSupplierListRoute: StaffSupplierListRouteWithChildren,
  StaffSupplierSupplierIdRoute: StaffSupplierSupplierIdRouteWithChildren,
}

const StaffSupplierRouteWithChildren = StaffSupplierRoute._addFileChildren(
  StaffSupplierRouteChildren,
)

interface StaffTimeAndAttendanceLayoutRouteChildren {
  StaffTimeAndAttendanceLayoutIndexRoute: typeof StaffTimeAndAttendanceLayoutIndexRoute
  StaffTimeAndAttendanceLayoutAttendanceLinksIndexRoute: typeof StaffTimeAndAttendanceLayoutAttendanceLinksIndexRoute
  StaffTimeAndAttendanceLayoutListSummaryIndexRoute: typeof StaffTimeAndAttendanceLayoutListSummaryIndexRoute
  StaffTimeAndAttendanceLayoutAttendanceLinksPlaceIdIndexRoute: typeof StaffTimeAndAttendanceLayoutAttendanceLinksPlaceIdIndexRoute
  StaffTimeAndAttendanceLayoutListSummaryDailyPlaceIndexRoute: typeof StaffTimeAndAttendanceLayoutListSummaryDailyPlaceIndexRoute
  StaffTimeAndAttendanceLayoutListSummaryMonthlyPersonIndexRoute: typeof StaffTimeAndAttendanceLayoutListSummaryMonthlyPersonIndexRoute
  StaffTimeAndAttendanceLayoutListSummaryMonthlyPlaceIndexRoute: typeof StaffTimeAndAttendanceLayoutListSummaryMonthlyPlaceIndexRoute
}

const StaffTimeAndAttendanceLayoutRouteChildren: StaffTimeAndAttendanceLayoutRouteChildren =
  {
    StaffTimeAndAttendanceLayoutIndexRoute:
      StaffTimeAndAttendanceLayoutIndexRoute,
    StaffTimeAndAttendanceLayoutAttendanceLinksIndexRoute:
      StaffTimeAndAttendanceLayoutAttendanceLinksIndexRoute,
    StaffTimeAndAttendanceLayoutListSummaryIndexRoute:
      StaffTimeAndAttendanceLayoutListSummaryIndexRoute,
    StaffTimeAndAttendanceLayoutAttendanceLinksPlaceIdIndexRoute:
      StaffTimeAndAttendanceLayoutAttendanceLinksPlaceIdIndexRoute,
    StaffTimeAndAttendanceLayoutListSummaryDailyPlaceIndexRoute:
      StaffTimeAndAttendanceLayoutListSummaryDailyPlaceIndexRoute,
    StaffTimeAndAttendanceLayoutListSummaryMonthlyPersonIndexRoute:
      StaffTimeAndAttendanceLayoutListSummaryMonthlyPersonIndexRoute,
    StaffTimeAndAttendanceLayoutListSummaryMonthlyPlaceIndexRoute:
      StaffTimeAndAttendanceLayoutListSummaryMonthlyPlaceIndexRoute,
  }

const StaffTimeAndAttendanceLayoutRouteWithChildren =
  StaffTimeAndAttendanceLayoutRoute._addFileChildren(
    StaffTimeAndAttendanceLayoutRouteChildren,
  )

interface StaffTimeAndAttendanceRouteChildren {
  StaffTimeAndAttendanceLayoutRoute: typeof StaffTimeAndAttendanceLayoutRouteWithChildren
}

const StaffTimeAndAttendanceRouteChildren: StaffTimeAndAttendanceRouteChildren =
  {
    StaffTimeAndAttendanceLayoutRoute:
      StaffTimeAndAttendanceLayoutRouteWithChildren,
  }

const StaffTimeAndAttendanceRouteWithChildren =
  StaffTimeAndAttendanceRoute._addFileChildren(
    StaffTimeAndAttendanceRouteChildren,
  )

interface StaffAppIntegrationsIdIdRouteChildren {
  StaffAppIntegrationsIdIdSplatRoute: typeof StaffAppIntegrationsIdIdSplatRoute
}

const StaffAppIntegrationsIdIdRouteChildren: StaffAppIntegrationsIdIdRouteChildren =
  {
    StaffAppIntegrationsIdIdSplatRoute: StaffAppIntegrationsIdIdSplatRoute,
  }

const StaffAppIntegrationsIdIdRouteWithChildren =
  StaffAppIntegrationsIdIdRoute._addFileChildren(
    StaffAppIntegrationsIdIdRouteChildren,
  )

interface StaffAppIntegrationsIdRouteChildren {
  StaffAppIntegrationsIdIdRoute: typeof StaffAppIntegrationsIdIdRouteWithChildren
}

const StaffAppIntegrationsIdRouteChildren: StaffAppIntegrationsIdRouteChildren =
  {
    StaffAppIntegrationsIdIdRoute: StaffAppIntegrationsIdIdRouteWithChildren,
  }

const StaffAppIntegrationsIdRouteWithChildren =
  StaffAppIntegrationsIdRoute._addFileChildren(
    StaffAppIntegrationsIdRouteChildren,
  )

interface StaffPersonIdProfileRouteChildren {
  StaffPersonIdProfileIndexRouteRoute: typeof StaffPersonIdProfileIndexRouteRoute
  StaffPersonIdProfileAppsIndexRoute: typeof StaffPersonIdProfileAppsIndexRoute
  StaffPersonIdProfileContractorInformationIndexRoute: typeof StaffPersonIdProfileContractorInformationIndexRoute
  StaffPersonIdProfileDevicesIndexRoute: typeof StaffPersonIdProfileDevicesIndexRoute
  StaffPersonIdProfileEducationAndQualificationIndexRoute: typeof StaffPersonIdProfileEducationAndQualificationIndexRoute
  StaffPersonIdProfileEmployeeInformationIndexRoute: typeof StaffPersonIdProfileEmployeeInformationIndexRoute
  StaffPersonIdProfileEquipmentIndexRoute: typeof StaffPersonIdProfileEquipmentIndexRoute
  StaffPersonIdProfileHistoryIndexRoute: typeof StaffPersonIdProfileHistoryIndexRoute
  StaffPersonIdProfileOperationActivityIndexRoute: typeof StaffPersonIdProfileOperationActivityIndexRoute
  StaffPersonIdProfilePersonalInformationIndexRoute: typeof StaffPersonIdProfilePersonalInformationIndexRoute
  StaffPersonIdProfilePublicIdIndexRoute: typeof StaffPersonIdProfilePublicIdIndexRoute
  StaffPersonIdProfileFamilyFamilyPersonIdIndexRoute: typeof StaffPersonIdProfileFamilyFamilyPersonIdIndexRoute
}

const StaffPersonIdProfileRouteChildren: StaffPersonIdProfileRouteChildren = {
  StaffPersonIdProfileIndexRouteRoute: StaffPersonIdProfileIndexRouteRoute,
  StaffPersonIdProfileAppsIndexRoute: StaffPersonIdProfileAppsIndexRoute,
  StaffPersonIdProfileContractorInformationIndexRoute:
    StaffPersonIdProfileContractorInformationIndexRoute,
  StaffPersonIdProfileDevicesIndexRoute: StaffPersonIdProfileDevicesIndexRoute,
  StaffPersonIdProfileEducationAndQualificationIndexRoute:
    StaffPersonIdProfileEducationAndQualificationIndexRoute,
  StaffPersonIdProfileEmployeeInformationIndexRoute:
    StaffPersonIdProfileEmployeeInformationIndexRoute,
  StaffPersonIdProfileEquipmentIndexRoute:
    StaffPersonIdProfileEquipmentIndexRoute,
  StaffPersonIdProfileHistoryIndexRoute: StaffPersonIdProfileHistoryIndexRoute,
  StaffPersonIdProfileOperationActivityIndexRoute:
    StaffPersonIdProfileOperationActivityIndexRoute,
  StaffPersonIdProfilePersonalInformationIndexRoute:
    StaffPersonIdProfilePersonalInformationIndexRoute,
  StaffPersonIdProfilePublicIdIndexRoute:
    StaffPersonIdProfilePublicIdIndexRoute,
  StaffPersonIdProfileFamilyFamilyPersonIdIndexRoute:
    StaffPersonIdProfileFamilyFamilyPersonIdIndexRoute,
}

const StaffPersonIdProfileRouteWithChildren =
  StaffPersonIdProfileRoute._addFileChildren(StaffPersonIdProfileRouteChildren)

interface StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRouteChildren {
  StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute: typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
}

const StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRouteChildren: StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRouteChildren =
  {
    StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute:
      StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute,
  }

const StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRouteWithChildren =
  StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRoute._addFileChildren(
    StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRouteChildren,
  )

interface StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRouteChildren {
  StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRoute: typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRouteWithChildren
}

const StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRouteChildren: StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRouteChildren =
  {
    StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRoute:
      StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRouteWithChildren,
  }

const StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRouteWithChildren =
  StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRoute._addFileChildren(
    StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRouteChildren,
  )

interface StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRouteChildren {
  StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute: typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
}

const StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRouteChildren: StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRouteChildren =
  {
    StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute:
      StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute,
  }

const StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRouteWithChildren =
  StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRoute._addFileChildren(
    StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRouteChildren,
  )

interface StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRouteChildren {
  StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRoute: typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRouteWithChildren
}

const StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRouteChildren: StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRouteChildren =
  {
    StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRoute:
      StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRouteWithChildren,
  }

const StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRouteWithChildren =
  StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRoute._addFileChildren(
    StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRouteChildren,
  )

interface StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRouteChildren {
  StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute: typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
}

const StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRouteChildren: StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRouteChildren =
  {
    StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute:
      StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute,
  }

const StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRouteWithChildren =
  StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRoute._addFileChildren(
    StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRouteChildren,
  )

interface StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRouteChildren {
  StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRoute: typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRouteWithChildren
}

const StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRouteChildren: StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRouteChildren =
  {
    StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRoute:
      StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRouteWithChildren,
  }

const StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRouteWithChildren =
  StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRoute._addFileChildren(
    StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRouteChildren,
  )

interface StaffPersonIdRouteChildren {
  StaffPersonIdProfileRoute: typeof StaffPersonIdProfileRouteWithChildren
  StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRoute: typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRouteWithChildren
  StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRoute: typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRouteWithChildren
  StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRoute: typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRouteWithChildren
}

const StaffPersonIdRouteChildren: StaffPersonIdRouteChildren = {
  StaffPersonIdProfileRoute: StaffPersonIdProfileRouteWithChildren,
  StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRoute:
    StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRouteWithChildren,
  StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRoute:
    StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRouteWithChildren,
  StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRoute:
    StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRouteWithChildren,
}

const StaffPersonIdRouteWithChildren = StaffPersonIdRoute._addFileChildren(
  StaffPersonIdRouteChildren,
)

interface StaffSettingsContractingCorporationProfileLayoutRouteChildren {
  StaffSettingsContractingCorporationProfileLayoutBoardMemberIndexRoute: typeof StaffSettingsContractingCorporationProfileLayoutBoardMemberIndexRoute
  StaffSettingsContractingCorporationProfileLayoutContactPointsIndexRoute: typeof StaffSettingsContractingCorporationProfileLayoutContactPointsIndexRoute
  StaffSettingsContractingCorporationProfileLayoutCorporateOverviewIndexRoute: typeof StaffSettingsContractingCorporationProfileLayoutCorporateOverviewIndexRoute
  StaffSettingsContractingCorporationProfileLayoutGroupCompaniesIndexRoute: typeof StaffSettingsContractingCorporationProfileLayoutGroupCompaniesIndexRoute
  StaffSettingsContractingCorporationProfileLayoutHistoryIndexRoute: typeof StaffSettingsContractingCorporationProfileLayoutHistoryIndexRoute
  StaffSettingsContractingCorporationProfileLayoutRegistrationIndexRoute: typeof StaffSettingsContractingCorporationProfileLayoutRegistrationIndexRoute
  StaffSettingsContractingCorporationProfileLayoutShareholdersIndexRoute: typeof StaffSettingsContractingCorporationProfileLayoutShareholdersIndexRoute
}

const StaffSettingsContractingCorporationProfileLayoutRouteChildren: StaffSettingsContractingCorporationProfileLayoutRouteChildren =
  {
    StaffSettingsContractingCorporationProfileLayoutBoardMemberIndexRoute:
      StaffSettingsContractingCorporationProfileLayoutBoardMemberIndexRoute,
    StaffSettingsContractingCorporationProfileLayoutContactPointsIndexRoute:
      StaffSettingsContractingCorporationProfileLayoutContactPointsIndexRoute,
    StaffSettingsContractingCorporationProfileLayoutCorporateOverviewIndexRoute:
      StaffSettingsContractingCorporationProfileLayoutCorporateOverviewIndexRoute,
    StaffSettingsContractingCorporationProfileLayoutGroupCompaniesIndexRoute:
      StaffSettingsContractingCorporationProfileLayoutGroupCompaniesIndexRoute,
    StaffSettingsContractingCorporationProfileLayoutHistoryIndexRoute:
      StaffSettingsContractingCorporationProfileLayoutHistoryIndexRoute,
    StaffSettingsContractingCorporationProfileLayoutRegistrationIndexRoute:
      StaffSettingsContractingCorporationProfileLayoutRegistrationIndexRoute,
    StaffSettingsContractingCorporationProfileLayoutShareholdersIndexRoute:
      StaffSettingsContractingCorporationProfileLayoutShareholdersIndexRoute,
  }

const StaffSettingsContractingCorporationProfileLayoutRouteWithChildren =
  StaffSettingsContractingCorporationProfileLayoutRoute._addFileChildren(
    StaffSettingsContractingCorporationProfileLayoutRouteChildren,
  )

interface StaffSettingsContractingCorporationProfileRouteChildren {
  StaffSettingsContractingCorporationProfileLayoutRoute: typeof StaffSettingsContractingCorporationProfileLayoutRouteWithChildren
  StaffSettingsContractingCorporationProfileIndexRoute: typeof StaffSettingsContractingCorporationProfileIndexRoute
}

const StaffSettingsContractingCorporationProfileRouteChildren: StaffSettingsContractingCorporationProfileRouteChildren =
  {
    StaffSettingsContractingCorporationProfileLayoutRoute:
      StaffSettingsContractingCorporationProfileLayoutRouteWithChildren,
    StaffSettingsContractingCorporationProfileIndexRoute:
      StaffSettingsContractingCorporationProfileIndexRoute,
  }

const StaffSettingsContractingCorporationProfileRouteWithChildren =
  StaffSettingsContractingCorporationProfileRoute._addFileChildren(
    StaffSettingsContractingCorporationProfileRouteChildren,
  )

interface StaffSettingsPermissionAndRolesDetailRouteChildren {
  StaffSettingsPermissionAndRolesDetailCategoryPermissionsIdIndexRoute: typeof StaffSettingsPermissionAndRolesDetailCategoryPermissionsIdIndexRoute
  StaffSettingsPermissionAndRolesDetailPeopleGroupsIdIndexRoute: typeof StaffSettingsPermissionAndRolesDetailPeopleGroupsIdIndexRoute
  StaffSettingsPermissionAndRolesDetailProductPermissionsIdIndexRoute: typeof StaffSettingsPermissionAndRolesDetailProductPermissionsIdIndexRoute
  StaffSettingsPermissionAndRolesDetailRolesIdIndexRoute: typeof StaffSettingsPermissionAndRolesDetailRolesIdIndexRoute
}

const StaffSettingsPermissionAndRolesDetailRouteChildren: StaffSettingsPermissionAndRolesDetailRouteChildren =
  {
    StaffSettingsPermissionAndRolesDetailCategoryPermissionsIdIndexRoute:
      StaffSettingsPermissionAndRolesDetailCategoryPermissionsIdIndexRoute,
    StaffSettingsPermissionAndRolesDetailPeopleGroupsIdIndexRoute:
      StaffSettingsPermissionAndRolesDetailPeopleGroupsIdIndexRoute,
    StaffSettingsPermissionAndRolesDetailProductPermissionsIdIndexRoute:
      StaffSettingsPermissionAndRolesDetailProductPermissionsIdIndexRoute,
    StaffSettingsPermissionAndRolesDetailRolesIdIndexRoute:
      StaffSettingsPermissionAndRolesDetailRolesIdIndexRoute,
  }

const StaffSettingsPermissionAndRolesDetailRouteWithChildren =
  StaffSettingsPermissionAndRolesDetailRoute._addFileChildren(
    StaffSettingsPermissionAndRolesDetailRouteChildren,
  )

interface StaffSettingsPermissionAndRolesFormRouteChildren {
  StaffSettingsPermissionAndRolesFormCategoryPermissionsNewIndexRoute: typeof StaffSettingsPermissionAndRolesFormCategoryPermissionsNewIndexRoute
  StaffSettingsPermissionAndRolesFormPeopleGroupsNewIndexRoute: typeof StaffSettingsPermissionAndRolesFormPeopleGroupsNewIndexRoute
  StaffSettingsPermissionAndRolesFormProductPermissionsNewIndexRoute: typeof StaffSettingsPermissionAndRolesFormProductPermissionsNewIndexRoute
  StaffSettingsPermissionAndRolesFormRolesNewIndexRoute: typeof StaffSettingsPermissionAndRolesFormRolesNewIndexRoute
  StaffSettingsPermissionAndRolesFormCategoryPermissionsIdEditIndexRoute: typeof StaffSettingsPermissionAndRolesFormCategoryPermissionsIdEditIndexRoute
  StaffSettingsPermissionAndRolesFormPeopleGroupsIdEditIndexRoute: typeof StaffSettingsPermissionAndRolesFormPeopleGroupsIdEditIndexRoute
  StaffSettingsPermissionAndRolesFormProductPermissionsIdEditIndexRoute: typeof StaffSettingsPermissionAndRolesFormProductPermissionsIdEditIndexRoute
  StaffSettingsPermissionAndRolesFormRolesIdEditIndexRoute: typeof StaffSettingsPermissionAndRolesFormRolesIdEditIndexRoute
}

const StaffSettingsPermissionAndRolesFormRouteChildren: StaffSettingsPermissionAndRolesFormRouteChildren =
  {
    StaffSettingsPermissionAndRolesFormCategoryPermissionsNewIndexRoute:
      StaffSettingsPermissionAndRolesFormCategoryPermissionsNewIndexRoute,
    StaffSettingsPermissionAndRolesFormPeopleGroupsNewIndexRoute:
      StaffSettingsPermissionAndRolesFormPeopleGroupsNewIndexRoute,
    StaffSettingsPermissionAndRolesFormProductPermissionsNewIndexRoute:
      StaffSettingsPermissionAndRolesFormProductPermissionsNewIndexRoute,
    StaffSettingsPermissionAndRolesFormRolesNewIndexRoute:
      StaffSettingsPermissionAndRolesFormRolesNewIndexRoute,
    StaffSettingsPermissionAndRolesFormCategoryPermissionsIdEditIndexRoute:
      StaffSettingsPermissionAndRolesFormCategoryPermissionsIdEditIndexRoute,
    StaffSettingsPermissionAndRolesFormPeopleGroupsIdEditIndexRoute:
      StaffSettingsPermissionAndRolesFormPeopleGroupsIdEditIndexRoute,
    StaffSettingsPermissionAndRolesFormProductPermissionsIdEditIndexRoute:
      StaffSettingsPermissionAndRolesFormProductPermissionsIdEditIndexRoute,
    StaffSettingsPermissionAndRolesFormRolesIdEditIndexRoute:
      StaffSettingsPermissionAndRolesFormRolesIdEditIndexRoute,
  }

const StaffSettingsPermissionAndRolesFormRouteWithChildren =
  StaffSettingsPermissionAndRolesFormRoute._addFileChildren(
    StaffSettingsPermissionAndRolesFormRouteChildren,
  )

interface StaffSettingsPermissionAndRolesListRouteChildren {
  StaffSettingsPermissionAndRolesListCategoryPermissionsIndexRoute: typeof StaffSettingsPermissionAndRolesListCategoryPermissionsIndexRoute
  StaffSettingsPermissionAndRolesListPeopleGroupsIndexRoute: typeof StaffSettingsPermissionAndRolesListPeopleGroupsIndexRoute
  StaffSettingsPermissionAndRolesListProductPermissionsIndexRoute: typeof StaffSettingsPermissionAndRolesListProductPermissionsIndexRoute
  StaffSettingsPermissionAndRolesListRolesIndexRoute: typeof StaffSettingsPermissionAndRolesListRolesIndexRoute
}

const StaffSettingsPermissionAndRolesListRouteChildren: StaffSettingsPermissionAndRolesListRouteChildren =
  {
    StaffSettingsPermissionAndRolesListCategoryPermissionsIndexRoute:
      StaffSettingsPermissionAndRolesListCategoryPermissionsIndexRoute,
    StaffSettingsPermissionAndRolesListPeopleGroupsIndexRoute:
      StaffSettingsPermissionAndRolesListPeopleGroupsIndexRoute,
    StaffSettingsPermissionAndRolesListProductPermissionsIndexRoute:
      StaffSettingsPermissionAndRolesListProductPermissionsIndexRoute,
    StaffSettingsPermissionAndRolesListRolesIndexRoute:
      StaffSettingsPermissionAndRolesListRolesIndexRoute,
  }

const StaffSettingsPermissionAndRolesListRouteWithChildren =
  StaffSettingsPermissionAndRolesListRoute._addFileChildren(
    StaffSettingsPermissionAndRolesListRouteChildren,
  )

interface StaffSettingsPermissionAndRolesRouteChildren {
  StaffSettingsPermissionAndRolesDetailRoute: typeof StaffSettingsPermissionAndRolesDetailRouteWithChildren
  StaffSettingsPermissionAndRolesFormRoute: typeof StaffSettingsPermissionAndRolesFormRouteWithChildren
  StaffSettingsPermissionAndRolesListRoute: typeof StaffSettingsPermissionAndRolesListRouteWithChildren
  StaffSettingsPermissionAndRolesIndexRoute: typeof StaffSettingsPermissionAndRolesIndexRoute
}

const StaffSettingsPermissionAndRolesRouteChildren: StaffSettingsPermissionAndRolesRouteChildren =
  {
    StaffSettingsPermissionAndRolesDetailRoute:
      StaffSettingsPermissionAndRolesDetailRouteWithChildren,
    StaffSettingsPermissionAndRolesFormRoute:
      StaffSettingsPermissionAndRolesFormRouteWithChildren,
    StaffSettingsPermissionAndRolesListRoute:
      StaffSettingsPermissionAndRolesListRouteWithChildren,
    StaffSettingsPermissionAndRolesIndexRoute:
      StaffSettingsPermissionAndRolesIndexRoute,
  }

const StaffSettingsPermissionAndRolesRouteWithChildren =
  StaffSettingsPermissionAndRolesRoute._addFileChildren(
    StaffSettingsPermissionAndRolesRouteChildren,
  )

interface StaffSettingsPersonsListAccountRouteChildren {
  StaffSettingsPersonsListAccountIndividualIndexRoute: typeof StaffSettingsPersonsListAccountIndividualIndexRoute
  StaffSettingsPersonsListAccountStaffIndexRoute: typeof StaffSettingsPersonsListAccountStaffIndexRoute
}

const StaffSettingsPersonsListAccountRouteChildren: StaffSettingsPersonsListAccountRouteChildren =
  {
    StaffSettingsPersonsListAccountIndividualIndexRoute:
      StaffSettingsPersonsListAccountIndividualIndexRoute,
    StaffSettingsPersonsListAccountStaffIndexRoute:
      StaffSettingsPersonsListAccountStaffIndexRoute,
  }

const StaffSettingsPersonsListAccountRouteWithChildren =
  StaffSettingsPersonsListAccountRoute._addFileChildren(
    StaffSettingsPersonsListAccountRouteChildren,
  )

interface StaffSettingsPersonsListRouteChildren {
  StaffSettingsPersonsListAccountRoute: typeof StaffSettingsPersonsListAccountRouteWithChildren
  StaffSettingsPersonsListSettingsIndexRoute: typeof StaffSettingsPersonsListSettingsIndexRoute
}

const StaffSettingsPersonsListRouteChildren: StaffSettingsPersonsListRouteChildren =
  {
    StaffSettingsPersonsListAccountRoute:
      StaffSettingsPersonsListAccountRouteWithChildren,
    StaffSettingsPersonsListSettingsIndexRoute:
      StaffSettingsPersonsListSettingsIndexRoute,
  }

const StaffSettingsPersonsListRouteWithChildren =
  StaffSettingsPersonsListRoute._addFileChildren(
    StaffSettingsPersonsListRouteChildren,
  )

interface StaffSettingsPersonsRouteChildren {
  StaffSettingsPersonsListRoute: typeof StaffSettingsPersonsListRouteWithChildren
  StaffSettingsPersonsIndexRoute: typeof StaffSettingsPersonsIndexRoute
  StaffSettingsPersonsInviteIndexRoute: typeof StaffSettingsPersonsInviteIndexRoute
}

const StaffSettingsPersonsRouteChildren: StaffSettingsPersonsRouteChildren = {
  StaffSettingsPersonsListRoute: StaffSettingsPersonsListRouteWithChildren,
  StaffSettingsPersonsIndexRoute: StaffSettingsPersonsIndexRoute,
  StaffSettingsPersonsInviteIndexRoute: StaffSettingsPersonsInviteIndexRoute,
}

const StaffSettingsPersonsRouteWithChildren =
  StaffSettingsPersonsRoute._addFileChildren(StaffSettingsPersonsRouteChildren)

interface StaffUsersUserIdLayoutRouteChildren {
  StaffUsersUserIdLayoutIdentityIndexRoute: typeof StaffUsersUserIdLayoutIdentityIndexRoute
  StaffUsersUserIdLayoutSessionsIndexRoute: typeof StaffUsersUserIdLayoutSessionsIndexRoute
}

const StaffUsersUserIdLayoutRouteChildren: StaffUsersUserIdLayoutRouteChildren =
  {
    StaffUsersUserIdLayoutIdentityIndexRoute:
      StaffUsersUserIdLayoutIdentityIndexRoute,
    StaffUsersUserIdLayoutSessionsIndexRoute:
      StaffUsersUserIdLayoutSessionsIndexRoute,
  }

const StaffUsersUserIdLayoutRouteWithChildren =
  StaffUsersUserIdLayoutRoute._addFileChildren(
    StaffUsersUserIdLayoutRouteChildren,
  )

interface StaffUsersUserIdRouteChildren {
  StaffUsersUserIdLayoutRoute: typeof StaffUsersUserIdLayoutRouteWithChildren
}

const StaffUsersUserIdRouteChildren: StaffUsersUserIdRouteChildren = {
  StaffUsersUserIdLayoutRoute: StaffUsersUserIdLayoutRouteWithChildren,
}

const StaffUsersUserIdRouteWithChildren =
  StaffUsersUserIdRoute._addFileChildren(StaffUsersUserIdRouteChildren)

interface StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealRouteChildren {
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealIndexRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealIndexRoute
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealAllIndexRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealAllIndexRoute
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealContractIndexRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealContractIndexRoute
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealEstimateIndexRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealEstimateIndexRoute
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealOrderIndexRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealOrderIndexRoute
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealPaymentIndexRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealPaymentIndexRoute
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute
}

const StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealRouteChildren: StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealRouteChildren =
  {
    StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealIndexRoute:
      StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealIndexRoute,
    StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealAllIndexRoute:
      StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealAllIndexRoute,
    StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealContractIndexRoute:
      StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealContractIndexRoute,
    StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealEstimateIndexRoute:
      StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealEstimateIndexRoute,
    StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealOrderIndexRoute:
      StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealOrderIndexRoute,
    StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealPaymentIndexRoute:
      StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealPaymentIndexRoute,
    StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute:
      StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute,
  }

const StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealRouteWithChildren =
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealRoute._addFileChildren(
    StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealRouteChildren,
  )

interface StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealRouteChildren {
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealRouteWithChildren
}

const StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealRouteChildren: StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealRouteChildren =
  {
    StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealRoute:
      StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealRouteWithChildren,
  }

const StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealRouteWithChildren =
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealRoute._addFileChildren(
    StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealRouteChildren,
  )

interface StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostRouteChildren {
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostIndexRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostIndexRoute
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealRouteWithChildren
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostCostIndexRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostCostIndexRoute
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostPaymentIndexRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostPaymentIndexRoute
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostCostPeriodIndexRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostCostPeriodIndexRoute
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute
}

const StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostRouteChildren: StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostRouteChildren =
  {
    StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostIndexRoute:
      StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostIndexRoute,
    StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealRoute:
      StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealRouteWithChildren,
    StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostCostIndexRoute:
      StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostCostIndexRoute,
    StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostPaymentIndexRoute:
      StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostPaymentIndexRoute,
    StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostCostPeriodIndexRoute:
      StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostCostPeriodIndexRoute,
    StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute:
      StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute,
  }

const StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostRouteWithChildren =
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostRoute._addFileChildren(
    StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostRouteChildren,
  )

interface StaffDeviceCatalogActiveIdLayoutContractAndCostRouteChildren {
  StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostRouteWithChildren
}

const StaffDeviceCatalogActiveIdLayoutContractAndCostRouteChildren: StaffDeviceCatalogActiveIdLayoutContractAndCostRouteChildren =
  {
    StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostRoute:
      StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostRouteWithChildren,
  }

const StaffDeviceCatalogActiveIdLayoutContractAndCostRouteWithChildren =
  StaffDeviceCatalogActiveIdLayoutContractAndCostRoute._addFileChildren(
    StaffDeviceCatalogActiveIdLayoutContractAndCostRouteChildren,
  )

interface StaffDeviceCatalogActiveIdLayoutRouteChildren {
  StaffDeviceCatalogActiveIdLayoutContractAndCostRoute: typeof StaffDeviceCatalogActiveIdLayoutContractAndCostRouteWithChildren
  StaffDeviceCatalogActiveIdLayoutProfileIndexRoute: typeof StaffDeviceCatalogActiveIdLayoutProfileIndexRoute
}

const StaffDeviceCatalogActiveIdLayoutRouteChildren: StaffDeviceCatalogActiveIdLayoutRouteChildren =
  {
    StaffDeviceCatalogActiveIdLayoutContractAndCostRoute:
      StaffDeviceCatalogActiveIdLayoutContractAndCostRouteWithChildren,
    StaffDeviceCatalogActiveIdLayoutProfileIndexRoute:
      StaffDeviceCatalogActiveIdLayoutProfileIndexRoute,
  }

const StaffDeviceCatalogActiveIdLayoutRouteWithChildren =
  StaffDeviceCatalogActiveIdLayoutRoute._addFileChildren(
    StaffDeviceCatalogActiveIdLayoutRouteChildren,
  )

interface StaffDeviceCatalogActiveIdRouteChildren {
  StaffDeviceCatalogActiveIdLayoutRoute: typeof StaffDeviceCatalogActiveIdLayoutRouteWithChildren
}

const StaffDeviceCatalogActiveIdRouteChildren: StaffDeviceCatalogActiveIdRouteChildren =
  {
    StaffDeviceCatalogActiveIdLayoutRoute:
      StaffDeviceCatalogActiveIdLayoutRouteWithChildren,
  }

const StaffDeviceCatalogActiveIdRouteWithChildren =
  StaffDeviceCatalogActiveIdRoute._addFileChildren(
    StaffDeviceCatalogActiveIdRouteChildren,
  )

interface StaffDeviceCatalogDraftIdLayoutRouteChildren {
  StaffDeviceCatalogDraftIdLayoutProfileIndexRoute: typeof StaffDeviceCatalogDraftIdLayoutProfileIndexRoute
}

const StaffDeviceCatalogDraftIdLayoutRouteChildren: StaffDeviceCatalogDraftIdLayoutRouteChildren =
  {
    StaffDeviceCatalogDraftIdLayoutProfileIndexRoute:
      StaffDeviceCatalogDraftIdLayoutProfileIndexRoute,
  }

const StaffDeviceCatalogDraftIdLayoutRouteWithChildren =
  StaffDeviceCatalogDraftIdLayoutRoute._addFileChildren(
    StaffDeviceCatalogDraftIdLayoutRouteChildren,
  )

interface StaffDeviceCatalogDraftIdRouteChildren {
  StaffDeviceCatalogDraftIdLayoutRoute: typeof StaffDeviceCatalogDraftIdLayoutRouteWithChildren
}

const StaffDeviceCatalogDraftIdRouteChildren: StaffDeviceCatalogDraftIdRouteChildren =
  {
    StaffDeviceCatalogDraftIdLayoutRoute:
      StaffDeviceCatalogDraftIdLayoutRouteWithChildren,
  }

const StaffDeviceCatalogDraftIdRouteWithChildren =
  StaffDeviceCatalogDraftIdRoute._addFileChildren(
    StaffDeviceCatalogDraftIdRouteChildren,
  )

interface StaffPersonAlumniIdProfileRouteChildren {
  StaffPersonAlumniIdProfileIndexRouteRoute: typeof StaffPersonAlumniIdProfileIndexRouteRoute
  StaffPersonAlumniIdProfileAppsIndexRoute: typeof StaffPersonAlumniIdProfileAppsIndexRoute
  StaffPersonAlumniIdProfileContractorInformationIndexRoute: typeof StaffPersonAlumniIdProfileContractorInformationIndexRoute
  StaffPersonAlumniIdProfileDevicesIndexRoute: typeof StaffPersonAlumniIdProfileDevicesIndexRoute
  StaffPersonAlumniIdProfileEducationAndQualificationIndexRoute: typeof StaffPersonAlumniIdProfileEducationAndQualificationIndexRoute
  StaffPersonAlumniIdProfileEmployeeInformationIndexRoute: typeof StaffPersonAlumniIdProfileEmployeeInformationIndexRoute
  StaffPersonAlumniIdProfileEquipmentIndexRoute: typeof StaffPersonAlumniIdProfileEquipmentIndexRoute
  StaffPersonAlumniIdProfileHistoryIndexRoute: typeof StaffPersonAlumniIdProfileHistoryIndexRoute
  StaffPersonAlumniIdProfileOperationActivityIndexRoute: typeof StaffPersonAlumniIdProfileOperationActivityIndexRoute
  StaffPersonAlumniIdProfilePersonalInformationIndexRoute: typeof StaffPersonAlumniIdProfilePersonalInformationIndexRoute
  StaffPersonAlumniIdProfilePublicIdIndexRoute: typeof StaffPersonAlumniIdProfilePublicIdIndexRoute
}

const StaffPersonAlumniIdProfileRouteChildren: StaffPersonAlumniIdProfileRouteChildren =
  {
    StaffPersonAlumniIdProfileIndexRouteRoute:
      StaffPersonAlumniIdProfileIndexRouteRoute,
    StaffPersonAlumniIdProfileAppsIndexRoute:
      StaffPersonAlumniIdProfileAppsIndexRoute,
    StaffPersonAlumniIdProfileContractorInformationIndexRoute:
      StaffPersonAlumniIdProfileContractorInformationIndexRoute,
    StaffPersonAlumniIdProfileDevicesIndexRoute:
      StaffPersonAlumniIdProfileDevicesIndexRoute,
    StaffPersonAlumniIdProfileEducationAndQualificationIndexRoute:
      StaffPersonAlumniIdProfileEducationAndQualificationIndexRoute,
    StaffPersonAlumniIdProfileEmployeeInformationIndexRoute:
      StaffPersonAlumniIdProfileEmployeeInformationIndexRoute,
    StaffPersonAlumniIdProfileEquipmentIndexRoute:
      StaffPersonAlumniIdProfileEquipmentIndexRoute,
    StaffPersonAlumniIdProfileHistoryIndexRoute:
      StaffPersonAlumniIdProfileHistoryIndexRoute,
    StaffPersonAlumniIdProfileOperationActivityIndexRoute:
      StaffPersonAlumniIdProfileOperationActivityIndexRoute,
    StaffPersonAlumniIdProfilePersonalInformationIndexRoute:
      StaffPersonAlumniIdProfilePersonalInformationIndexRoute,
    StaffPersonAlumniIdProfilePublicIdIndexRoute:
      StaffPersonAlumniIdProfilePublicIdIndexRoute,
  }

const StaffPersonAlumniIdProfileRouteWithChildren =
  StaffPersonAlumniIdProfileRoute._addFileChildren(
    StaffPersonAlumniIdProfileRouteChildren,
  )

interface StaffPersonAlumniIdRouteChildren {
  StaffPersonAlumniIdProfileRoute: typeof StaffPersonAlumniIdProfileRouteWithChildren
}

const StaffPersonAlumniIdRouteChildren: StaffPersonAlumniIdRouteChildren = {
  StaffPersonAlumniIdProfileRoute: StaffPersonAlumniIdProfileRouteWithChildren,
}

const StaffPersonAlumniIdRouteWithChildren =
  StaffPersonAlumniIdRoute._addFileChildren(StaffPersonAlumniIdRouteChildren)

interface StaffSettingsDataConnectorInboundAggregateDataPipelineListRouteChildren {
  StaffSettingsDataConnectorInboundAggregateDataPipelineListIndexRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineListIndexRoute
}

const StaffSettingsDataConnectorInboundAggregateDataPipelineListRouteChildren: StaffSettingsDataConnectorInboundAggregateDataPipelineListRouteChildren =
  {
    StaffSettingsDataConnectorInboundAggregateDataPipelineListIndexRoute:
      StaffSettingsDataConnectorInboundAggregateDataPipelineListIndexRoute,
  }

const StaffSettingsDataConnectorInboundAggregateDataPipelineListRouteWithChildren =
  StaffSettingsDataConnectorInboundAggregateDataPipelineListRoute._addFileChildren(
    StaffSettingsDataConnectorInboundAggregateDataPipelineListRouteChildren,
  )

interface StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailRouteChildren {
  StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailBasicInfoIndexRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailBasicInfoIndexRoute
  StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailExecutionPlanIndexRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailExecutionPlanIndexRoute
  StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailPrioritySettingIndexRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailPrioritySettingIndexRoute
  StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailTasksIndexRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailTasksIndexRoute
}

const StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailRouteChildren: StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailRouteChildren =
  {
    StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailBasicInfoIndexRoute:
      StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailBasicInfoIndexRoute,
    StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailExecutionPlanIndexRoute:
      StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailExecutionPlanIndexRoute,
    StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailPrioritySettingIndexRoute:
      StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailPrioritySettingIndexRoute,
    StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailTasksIndexRoute:
      StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailTasksIndexRoute,
  }

const StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailRouteWithChildren =
  StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailRoute._addFileChildren(
    StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailRouteChildren,
  )

interface StaffSettingsDataConnectorInboundAggregateDataPipelineIdRouteChildren {
  StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailRouteWithChildren
  StaffSettingsDataConnectorInboundAggregateDataPipelineIdTasksTaskIdChunksIndexRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdTasksTaskIdChunksIndexRoute
  StaffSettingsDataConnectorInboundAggregateDataPipelineIdTasksTaskIdChunksChunkIdResultIndexRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdTasksTaskIdChunksChunkIdResultIndexRoute
}

const StaffSettingsDataConnectorInboundAggregateDataPipelineIdRouteChildren: StaffSettingsDataConnectorInboundAggregateDataPipelineIdRouteChildren =
  {
    StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailRoute:
      StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailRouteWithChildren,
    StaffSettingsDataConnectorInboundAggregateDataPipelineIdTasksTaskIdChunksIndexRoute:
      StaffSettingsDataConnectorInboundAggregateDataPipelineIdTasksTaskIdChunksIndexRoute,
    StaffSettingsDataConnectorInboundAggregateDataPipelineIdTasksTaskIdChunksChunkIdResultIndexRoute:
      StaffSettingsDataConnectorInboundAggregateDataPipelineIdTasksTaskIdChunksChunkIdResultIndexRoute,
  }

const StaffSettingsDataConnectorInboundAggregateDataPipelineIdRouteWithChildren =
  StaffSettingsDataConnectorInboundAggregateDataPipelineIdRoute._addFileChildren(
    StaffSettingsDataConnectorInboundAggregateDataPipelineIdRouteChildren,
  )

interface StaffSettingsDataConnectorInboundAggregateDataPipelineRouteChildren {
  StaffSettingsDataConnectorInboundAggregateDataPipelineListRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineListRouteWithChildren
  StaffSettingsDataConnectorInboundAggregateDataPipelineIdRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdRouteWithChildren
  StaffSettingsDataConnectorInboundAggregateDataPipelineAddIndexRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineAddIndexRoute
}

const StaffSettingsDataConnectorInboundAggregateDataPipelineRouteChildren: StaffSettingsDataConnectorInboundAggregateDataPipelineRouteChildren =
  {
    StaffSettingsDataConnectorInboundAggregateDataPipelineListRoute:
      StaffSettingsDataConnectorInboundAggregateDataPipelineListRouteWithChildren,
    StaffSettingsDataConnectorInboundAggregateDataPipelineIdRoute:
      StaffSettingsDataConnectorInboundAggregateDataPipelineIdRouteWithChildren,
    StaffSettingsDataConnectorInboundAggregateDataPipelineAddIndexRoute:
      StaffSettingsDataConnectorInboundAggregateDataPipelineAddIndexRoute,
  }

const StaffSettingsDataConnectorInboundAggregateDataPipelineRouteWithChildren =
  StaffSettingsDataConnectorInboundAggregateDataPipelineRoute._addFileChildren(
    StaffSettingsDataConnectorInboundAggregateDataPipelineRouteChildren,
  )

interface StaffSettingsDataConnectorInboundDataPipelineListRouteChildren {
  StaffSettingsDataConnectorInboundDataPipelineListIndexRoute: typeof StaffSettingsDataConnectorInboundDataPipelineListIndexRoute
}

const StaffSettingsDataConnectorInboundDataPipelineListRouteChildren: StaffSettingsDataConnectorInboundDataPipelineListRouteChildren =
  {
    StaffSettingsDataConnectorInboundDataPipelineListIndexRoute:
      StaffSettingsDataConnectorInboundDataPipelineListIndexRoute,
  }

const StaffSettingsDataConnectorInboundDataPipelineListRouteWithChildren =
  StaffSettingsDataConnectorInboundDataPipelineListRoute._addFileChildren(
    StaffSettingsDataConnectorInboundDataPipelineListRouteChildren,
  )

interface StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailRouteChildren {
  StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailBasicSettingsIndexRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailBasicSettingsIndexRoute
  StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailDataLinkSettingsIndexRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailDataLinkSettingsIndexRoute
  StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailExecutionPlanIndexRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailExecutionPlanIndexRoute
  StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailExecutionResultsIndexRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailExecutionResultsIndexRoute
}

const StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailRouteChildren: StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailRouteChildren =
  {
    StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailBasicSettingsIndexRoute:
      StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailBasicSettingsIndexRoute,
    StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailDataLinkSettingsIndexRoute:
      StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailDataLinkSettingsIndexRoute,
    StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailExecutionPlanIndexRoute:
      StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailExecutionPlanIndexRoute,
    StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailExecutionResultsIndexRoute:
      StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailExecutionResultsIndexRoute,
  }

const StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailRouteWithChildren =
  StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailRoute._addFileChildren(
    StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailRouteChildren,
  )

interface StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailRouteChildren {
  StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailChunksIndexRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailChunksIndexRoute
}

const StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailRouteChildren: StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailRouteChildren =
  {
    StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailChunksIndexRoute:
      StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailChunksIndexRoute,
  }

const StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailRouteWithChildren =
  StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailRoute._addFileChildren(
    StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailRouteChildren,
  )

interface StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdRouteChildren {
  StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailRouteWithChildren
  StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdChunksChunkIdResultIndexRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdChunksChunkIdResultIndexRoute
}

const StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdRouteChildren: StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdRouteChildren =
  {
    StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailRoute:
      StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailRouteWithChildren,
    StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdChunksChunkIdResultIndexRoute:
      StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdChunksChunkIdResultIndexRoute,
  }

const StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdRouteWithChildren =
  StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdRoute._addFileChildren(
    StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdRouteChildren,
  )

interface StaffSettingsDataConnectorInboundDataPipelineIdRouteChildren {
  StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailRouteWithChildren
  StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdRouteWithChildren
}

const StaffSettingsDataConnectorInboundDataPipelineIdRouteChildren: StaffSettingsDataConnectorInboundDataPipelineIdRouteChildren =
  {
    StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailRoute:
      StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailRouteWithChildren,
    StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdRoute:
      StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdRouteWithChildren,
  }

const StaffSettingsDataConnectorInboundDataPipelineIdRouteWithChildren =
  StaffSettingsDataConnectorInboundDataPipelineIdRoute._addFileChildren(
    StaffSettingsDataConnectorInboundDataPipelineIdRouteChildren,
  )

interface StaffSettingsDataConnectorInboundDataPipelineRouteChildren {
  StaffSettingsDataConnectorInboundDataPipelineListRoute: typeof StaffSettingsDataConnectorInboundDataPipelineListRouteWithChildren
  StaffSettingsDataConnectorInboundDataPipelineIdRoute: typeof StaffSettingsDataConnectorInboundDataPipelineIdRouteWithChildren
  StaffSettingsDataConnectorInboundDataPipelineAddIndexRoute: typeof StaffSettingsDataConnectorInboundDataPipelineAddIndexRoute
}

const StaffSettingsDataConnectorInboundDataPipelineRouteChildren: StaffSettingsDataConnectorInboundDataPipelineRouteChildren =
  {
    StaffSettingsDataConnectorInboundDataPipelineListRoute:
      StaffSettingsDataConnectorInboundDataPipelineListRouteWithChildren,
    StaffSettingsDataConnectorInboundDataPipelineIdRoute:
      StaffSettingsDataConnectorInboundDataPipelineIdRouteWithChildren,
    StaffSettingsDataConnectorInboundDataPipelineAddIndexRoute:
      StaffSettingsDataConnectorInboundDataPipelineAddIndexRoute,
  }

const StaffSettingsDataConnectorInboundDataPipelineRouteWithChildren =
  StaffSettingsDataConnectorInboundDataPipelineRoute._addFileChildren(
    StaffSettingsDataConnectorInboundDataPipelineRouteChildren,
  )

interface StaffSettingsDataConnectorOutboundDataPipelineListRouteChildren {
  StaffSettingsDataConnectorOutboundDataPipelineListIndexRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineListIndexRoute
}

const StaffSettingsDataConnectorOutboundDataPipelineListRouteChildren: StaffSettingsDataConnectorOutboundDataPipelineListRouteChildren =
  {
    StaffSettingsDataConnectorOutboundDataPipelineListIndexRoute:
      StaffSettingsDataConnectorOutboundDataPipelineListIndexRoute,
  }

const StaffSettingsDataConnectorOutboundDataPipelineListRouteWithChildren =
  StaffSettingsDataConnectorOutboundDataPipelineListRoute._addFileChildren(
    StaffSettingsDataConnectorOutboundDataPipelineListRouteChildren,
  )

interface StaffSettingsDataConnectorOutboundDataPipelineIdDetailRouteChildren {
  StaffSettingsDataConnectorOutboundDataPipelineIdDetailBasicSettingsIndexRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailBasicSettingsIndexRoute
  StaffSettingsDataConnectorOutboundDataPipelineIdDetailDataLinkSettingsIndexRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailDataLinkSettingsIndexRoute
  StaffSettingsDataConnectorOutboundDataPipelineIdDetailExecutionPlanIndexRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailExecutionPlanIndexRoute
  StaffSettingsDataConnectorOutboundDataPipelineIdDetailExecutionResultsIndexRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailExecutionResultsIndexRoute
}

const StaffSettingsDataConnectorOutboundDataPipelineIdDetailRouteChildren: StaffSettingsDataConnectorOutboundDataPipelineIdDetailRouteChildren =
  {
    StaffSettingsDataConnectorOutboundDataPipelineIdDetailBasicSettingsIndexRoute:
      StaffSettingsDataConnectorOutboundDataPipelineIdDetailBasicSettingsIndexRoute,
    StaffSettingsDataConnectorOutboundDataPipelineIdDetailDataLinkSettingsIndexRoute:
      StaffSettingsDataConnectorOutboundDataPipelineIdDetailDataLinkSettingsIndexRoute,
    StaffSettingsDataConnectorOutboundDataPipelineIdDetailExecutionPlanIndexRoute:
      StaffSettingsDataConnectorOutboundDataPipelineIdDetailExecutionPlanIndexRoute,
    StaffSettingsDataConnectorOutboundDataPipelineIdDetailExecutionResultsIndexRoute:
      StaffSettingsDataConnectorOutboundDataPipelineIdDetailExecutionResultsIndexRoute,
  }

const StaffSettingsDataConnectorOutboundDataPipelineIdDetailRouteWithChildren =
  StaffSettingsDataConnectorOutboundDataPipelineIdDetailRoute._addFileChildren(
    StaffSettingsDataConnectorOutboundDataPipelineIdDetailRouteChildren,
  )

interface StaffSettingsDataConnectorOutboundDataPipelineIdRouteChildren {
  StaffSettingsDataConnectorOutboundDataPipelineIdDetailRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailRouteWithChildren
}

const StaffSettingsDataConnectorOutboundDataPipelineIdRouteChildren: StaffSettingsDataConnectorOutboundDataPipelineIdRouteChildren =
  {
    StaffSettingsDataConnectorOutboundDataPipelineIdDetailRoute:
      StaffSettingsDataConnectorOutboundDataPipelineIdDetailRouteWithChildren,
  }

const StaffSettingsDataConnectorOutboundDataPipelineIdRouteWithChildren =
  StaffSettingsDataConnectorOutboundDataPipelineIdRoute._addFileChildren(
    StaffSettingsDataConnectorOutboundDataPipelineIdRouteChildren,
  )

interface StaffSettingsDataConnectorOutboundDataPipelineRouteChildren {
  StaffSettingsDataConnectorOutboundDataPipelineListRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineListRouteWithChildren
  StaffSettingsDataConnectorOutboundDataPipelineIdRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineIdRouteWithChildren
  StaffSettingsDataConnectorOutboundDataPipelineAddIndexRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineAddIndexRoute
}

const StaffSettingsDataConnectorOutboundDataPipelineRouteChildren: StaffSettingsDataConnectorOutboundDataPipelineRouteChildren =
  {
    StaffSettingsDataConnectorOutboundDataPipelineListRoute:
      StaffSettingsDataConnectorOutboundDataPipelineListRouteWithChildren,
    StaffSettingsDataConnectorOutboundDataPipelineIdRoute:
      StaffSettingsDataConnectorOutboundDataPipelineIdRouteWithChildren,
    StaffSettingsDataConnectorOutboundDataPipelineAddIndexRoute:
      StaffSettingsDataConnectorOutboundDataPipelineAddIndexRoute,
  }

const StaffSettingsDataConnectorOutboundDataPipelineRouteWithChildren =
  StaffSettingsDataConnectorOutboundDataPipelineRoute._addFileChildren(
    StaffSettingsDataConnectorOutboundDataPipelineRouteChildren,
  )

interface StaffRouteChildren {
  StaffAppsRoute: typeof StaffAppsRouteWithChildren
  StaffIdManagementsRoute: typeof StaffIdManagementsRouteWithChildren
  StaffItOperationCoreDeviceInventoryRouteRoute: typeof StaffItOperationCoreDeviceInventoryRouteRouteWithChildren
  StaffPlacesImportCsvRouteRoute: typeof StaffPlacesImportCsvRouteRoute
  StaffAccessesRoute: typeof StaffAccessesRouteWithChildren
  StaffAttendanceCoreRoute: typeof StaffAttendanceCoreRouteWithChildren
  StaffAttendanceEngineRoute: typeof StaffAttendanceEngineRouteWithChildren
  StaffAttendancesRoute: typeof StaffAttendancesRouteWithChildren
  StaffBusinessOperationEventsRoute: typeof StaffBusinessOperationEventsRouteWithChildren
  StaffBusinessPartnerRoute: typeof StaffBusinessPartnerRouteWithChildren
  StaffCertificationRoute: typeof StaffCertificationRouteWithChildren
  StaffContractRoute: typeof StaffContractRouteWithChildren
  StaffContractorCoreRoute: typeof StaffContractorCoreRouteWithChildren
  StaffDealRoute: typeof StaffDealRouteWithChildren
  StaffDevicesRoute: typeof StaffDevicesRouteWithChildren
  StaffEquipmentRoute: typeof StaffEquipmentRouteWithChildren
  StaffFleetsRoute: typeof StaffFleetsRouteWithChildren
  StaffGaOperationCoreRoute: typeof StaffGaOperationCoreRouteWithChildren
  StaffIdsRoute: typeof StaffIdsRouteWithChildren
  StaffItOperationCoreRoute: typeof StaffItOperationCoreRouteWithChildren
  StaffLaborCoreRoute: typeof StaffLaborCoreRouteWithChildren
  StaffLicensesRoute: typeof StaffLicensesRouteWithChildren
  StaffMarketplaceRoute: typeof StaffMarketplaceRouteWithChildren
  StaffNetworksRoute: typeof StaffNetworksRouteWithChildren
  StaffOrganizationRoute: typeof StaffOrganizationRouteWithChildren
  StaffPayrollCoreRoute: typeof StaffPayrollCoreRouteWithChildren
  StaffPayrollEngineRoute: typeof StaffPayrollEngineRouteWithChildren
  StaffPayrollRoute: typeof StaffPayrollRouteWithChildren
  StaffPeopleRoute: typeof StaffPeopleRouteWithChildren
  StaffPlacesRoute: typeof StaffPlacesRouteWithChildren
  StaffPublicIdsIdRoute: typeof StaffPublicIdsIdRouteWithChildren
  StaffPublicIdsRoute: typeof StaffPublicIdsRouteWithChildren
  StaffSoftwareRoute: typeof StaffSoftwareRouteWithChildren
  StaffStarlinksRoute: typeof StaffStarlinksRouteWithChildren
  StaffStorageFilesRoute: typeof StaffStorageFilesRouteWithChildren
  StaffSupplierRoute: typeof StaffSupplierRouteWithChildren
  StaffTimeAndAttendanceRoute: typeof StaffTimeAndAttendanceRouteWithChildren
  StaffCockpitIndexRoute: typeof StaffCockpitIndexRoute
  StaffSettingsIndexRoute: typeof StaffSettingsIndexRoute
  StaffAppIntegrationsImportCsvIdRouteRoute: typeof StaffAppIntegrationsImportCsvIdRouteRoute
  StaffPersonImportCsvWorkerTypeRouteRoute: typeof StaffPersonImportCsvWorkerTypeRouteRoute
  StaffAppIntegrationsIdRoute: typeof StaffAppIntegrationsIdRouteWithChildren
  StaffPersonIdRoute: typeof StaffPersonIdRouteWithChildren
  StaffSettingsContractingCorporationProfileRoute: typeof StaffSettingsContractingCorporationProfileRouteWithChildren
  StaffSettingsPermissionAndRolesRoute: typeof StaffSettingsPermissionAndRolesRouteWithChildren
  StaffSettingsPersonsRoute: typeof StaffSettingsPersonsRouteWithChildren
  StaffUsersUserIdRoute: typeof StaffUsersUserIdRouteWithChildren
  StaffDeviceCatalogAddIndexRoute: typeof StaffDeviceCatalogAddIndexRoute
  StaffPersonAddPersonCertificationIndexRoute: typeof StaffPersonAddPersonCertificationIndexRoute
  StaffPersonAddIndexRoute: typeof StaffPersonAddIndexRoute
  StaffPersonExternalHrSaasIndexRoute: typeof StaffPersonExternalHrSaasIndexRoute
  StaffDeviceCatalogActiveIdRoute: typeof StaffDeviceCatalogActiveIdRouteWithChildren
  StaffDeviceCatalogAddDeviceTypeCompletedRoute: typeof StaffDeviceCatalogAddDeviceTypeCompletedRoute
  StaffDeviceCatalogDraftIdRoute: typeof StaffDeviceCatalogDraftIdRouteWithChildren
  StaffPersonAddPersonCertificationCertificationKindCompletedRoute: typeof StaffPersonAddPersonCertificationCertificationKindCompletedRoute
  StaffPersonAddWorkerTypeCompletedRoute: typeof StaffPersonAddWorkerTypeCompletedRoute
  StaffPersonAlumniIdRoute: typeof StaffPersonAlumniIdRouteWithChildren
  StaffProfileDeviceIdSplatRoute: typeof StaffProfileDeviceIdSplatRoute
  StaffCockpitApprovalIdIndexRoute: typeof StaffCockpitApprovalIdIndexRoute
  StaffCockpitTaskTaskIdIndexRoute: typeof StaffCockpitTaskTaskIdIndexRoute
  StaffDeviceCatalogAddDeviceTypeIndexRoute: typeof StaffDeviceCatalogAddDeviceTypeIndexRoute
  StaffPersonAddPersonCertificationCertificationKindIndexRoute: typeof StaffPersonAddPersonCertificationCertificationKindIndexRoute
  StaffPersonAddWorkerTypeIndexRoute: typeof StaffPersonAddWorkerTypeIndexRoute
  StaffPersonAutomapIngesterWorkerTypeIndexRoute: typeof StaffPersonAutomapIngesterWorkerTypeIndexRoute
  StaffProfileDeviceIdIndexRoute: typeof StaffProfileDeviceIdIndexRoute
  StaffSettingsDataConnectorInboundIndexRoute: typeof StaffSettingsDataConnectorInboundIndexRoute
  StaffSettingsDataConnectorOutboundIndexRoute: typeof StaffSettingsDataConnectorOutboundIndexRoute
  StaffSettingsDataConnectorInboundAggregateDataPipelineRoute: typeof StaffSettingsDataConnectorInboundAggregateDataPipelineRouteWithChildren
  StaffSettingsDataConnectorInboundDataPipelineRoute: typeof StaffSettingsDataConnectorInboundDataPipelineRouteWithChildren
  StaffSettingsDataConnectorOutboundDataPipelineRoute: typeof StaffSettingsDataConnectorOutboundDataPipelineRouteWithChildren
  StaffPersonExternalHrSaasAppIntegrationIdPreviewIndexRoute: typeof StaffPersonExternalHrSaasAppIntegrationIdPreviewIndexRoute
}

const StaffRouteChildren: StaffRouteChildren = {
  StaffAppsRoute: StaffAppsRouteWithChildren,
  StaffIdManagementsRoute: StaffIdManagementsRouteWithChildren,
  StaffItOperationCoreDeviceInventoryRouteRoute:
    StaffItOperationCoreDeviceInventoryRouteRouteWithChildren,
  StaffPlacesImportCsvRouteRoute: StaffPlacesImportCsvRouteRoute,
  StaffAccessesRoute: StaffAccessesRouteWithChildren,
  StaffAttendanceCoreRoute: StaffAttendanceCoreRouteWithChildren,
  StaffAttendanceEngineRoute: StaffAttendanceEngineRouteWithChildren,
  StaffAttendancesRoute: StaffAttendancesRouteWithChildren,
  StaffBusinessOperationEventsRoute:
    StaffBusinessOperationEventsRouteWithChildren,
  StaffBusinessPartnerRoute: StaffBusinessPartnerRouteWithChildren,
  StaffCertificationRoute: StaffCertificationRouteWithChildren,
  StaffContractRoute: StaffContractRouteWithChildren,
  StaffContractorCoreRoute: StaffContractorCoreRouteWithChildren,
  StaffDealRoute: StaffDealRouteWithChildren,
  StaffDevicesRoute: StaffDevicesRouteWithChildren,
  StaffEquipmentRoute: StaffEquipmentRouteWithChildren,
  StaffFleetsRoute: StaffFleetsRouteWithChildren,
  StaffGaOperationCoreRoute: StaffGaOperationCoreRouteWithChildren,
  StaffIdsRoute: StaffIdsRouteWithChildren,
  StaffItOperationCoreRoute: StaffItOperationCoreRouteWithChildren,
  StaffLaborCoreRoute: StaffLaborCoreRouteWithChildren,
  StaffLicensesRoute: StaffLicensesRouteWithChildren,
  StaffMarketplaceRoute: StaffMarketplaceRouteWithChildren,
  StaffNetworksRoute: StaffNetworksRouteWithChildren,
  StaffOrganizationRoute: StaffOrganizationRouteWithChildren,
  StaffPayrollCoreRoute: StaffPayrollCoreRouteWithChildren,
  StaffPayrollEngineRoute: StaffPayrollEngineRouteWithChildren,
  StaffPayrollRoute: StaffPayrollRouteWithChildren,
  StaffPeopleRoute: StaffPeopleRouteWithChildren,
  StaffPlacesRoute: StaffPlacesRouteWithChildren,
  StaffPublicIdsIdRoute: StaffPublicIdsIdRouteWithChildren,
  StaffPublicIdsRoute: StaffPublicIdsRouteWithChildren,
  StaffSoftwareRoute: StaffSoftwareRouteWithChildren,
  StaffStarlinksRoute: StaffStarlinksRouteWithChildren,
  StaffStorageFilesRoute: StaffStorageFilesRouteWithChildren,
  StaffSupplierRoute: StaffSupplierRouteWithChildren,
  StaffTimeAndAttendanceRoute: StaffTimeAndAttendanceRouteWithChildren,
  StaffCockpitIndexRoute: StaffCockpitIndexRoute,
  StaffSettingsIndexRoute: StaffSettingsIndexRoute,
  StaffAppIntegrationsImportCsvIdRouteRoute:
    StaffAppIntegrationsImportCsvIdRouteRoute,
  StaffPersonImportCsvWorkerTypeRouteRoute:
    StaffPersonImportCsvWorkerTypeRouteRoute,
  StaffAppIntegrationsIdRoute: StaffAppIntegrationsIdRouteWithChildren,
  StaffPersonIdRoute: StaffPersonIdRouteWithChildren,
  StaffSettingsContractingCorporationProfileRoute:
    StaffSettingsContractingCorporationProfileRouteWithChildren,
  StaffSettingsPermissionAndRolesRoute:
    StaffSettingsPermissionAndRolesRouteWithChildren,
  StaffSettingsPersonsRoute: StaffSettingsPersonsRouteWithChildren,
  StaffUsersUserIdRoute: StaffUsersUserIdRouteWithChildren,
  StaffDeviceCatalogAddIndexRoute: StaffDeviceCatalogAddIndexRoute,
  StaffPersonAddPersonCertificationIndexRoute:
    StaffPersonAddPersonCertificationIndexRoute,
  StaffPersonAddIndexRoute: StaffPersonAddIndexRoute,
  StaffPersonExternalHrSaasIndexRoute: StaffPersonExternalHrSaasIndexRoute,
  StaffDeviceCatalogActiveIdRoute: StaffDeviceCatalogActiveIdRouteWithChildren,
  StaffDeviceCatalogAddDeviceTypeCompletedRoute:
    StaffDeviceCatalogAddDeviceTypeCompletedRoute,
  StaffDeviceCatalogDraftIdRoute: StaffDeviceCatalogDraftIdRouteWithChildren,
  StaffPersonAddPersonCertificationCertificationKindCompletedRoute:
    StaffPersonAddPersonCertificationCertificationKindCompletedRoute,
  StaffPersonAddWorkerTypeCompletedRoute:
    StaffPersonAddWorkerTypeCompletedRoute,
  StaffPersonAlumniIdRoute: StaffPersonAlumniIdRouteWithChildren,
  StaffProfileDeviceIdSplatRoute: StaffProfileDeviceIdSplatRoute,
  StaffCockpitApprovalIdIndexRoute: StaffCockpitApprovalIdIndexRoute,
  StaffCockpitTaskTaskIdIndexRoute: StaffCockpitTaskTaskIdIndexRoute,
  StaffDeviceCatalogAddDeviceTypeIndexRoute:
    StaffDeviceCatalogAddDeviceTypeIndexRoute,
  StaffPersonAddPersonCertificationCertificationKindIndexRoute:
    StaffPersonAddPersonCertificationCertificationKindIndexRoute,
  StaffPersonAddWorkerTypeIndexRoute: StaffPersonAddWorkerTypeIndexRoute,
  StaffPersonAutomapIngesterWorkerTypeIndexRoute:
    StaffPersonAutomapIngesterWorkerTypeIndexRoute,
  StaffProfileDeviceIdIndexRoute: StaffProfileDeviceIdIndexRoute,
  StaffSettingsDataConnectorInboundIndexRoute:
    StaffSettingsDataConnectorInboundIndexRoute,
  StaffSettingsDataConnectorOutboundIndexRoute:
    StaffSettingsDataConnectorOutboundIndexRoute,
  StaffSettingsDataConnectorInboundAggregateDataPipelineRoute:
    StaffSettingsDataConnectorInboundAggregateDataPipelineRouteWithChildren,
  StaffSettingsDataConnectorInboundDataPipelineRoute:
    StaffSettingsDataConnectorInboundDataPipelineRouteWithChildren,
  StaffSettingsDataConnectorOutboundDataPipelineRoute:
    StaffSettingsDataConnectorOutboundDataPipelineRouteWithChildren,
  StaffPersonExternalHrSaasAppIntegrationIdPreviewIndexRoute:
    StaffPersonExternalHrSaasAppIntegrationIdPreviewIndexRoute,
}

const StaffRouteWithChildren = StaffRoute._addFileChildren(StaffRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof StaffRouteWithChildren
  '/planning-operations-core': typeof StacktracePlanningOperationsCoreRoute
  '/product-planning-core': typeof StacktraceProductPlanningCoreRoute
  '/qa-operations-core': typeof StacktraceQaOperationsCoreRoute
  '/apps': typeof StaffAppsRouteWithChildren
  '/id-managements': typeof StaffIdManagementsRouteWithChildren
  '/me': typeof MeIndexRoute
  '/development-tickets/import-csv': typeof StacktraceDevelopmentTicketsImportCsvRouteRoute
  '/issues/import-csv': typeof StacktraceIssuesImportCsvRouteRoute
  '/values/import-csv': typeof StacktraceValuesImportCsvRouteRoute
  '/it-operation-core/device-inventory': typeof StaffItOperationCoreDeviceInventoryRouteRouteWithChildren
  '/places/import-csv': typeof StaffPlacesImportCsvRouteRoute
  '/individual': typeof IndividualIndividualProfileRouteWithChildren
  '/individual/portal': typeof IndividualIndividualPortalRouteWithChildren
  '/issues': typeof StacktraceIssuesLayoutRouteWithChildren
  '/product-roadmap': typeof StacktraceProductRoadmapLayoutRouteWithChildren
  '/test-sets': typeof StacktraceTestSetsLayoutRouteWithChildren
  '/test-suites': typeof StacktraceTestSuitesLayoutRouteWithChildren
  '/values': typeof StacktraceValuesLayoutRouteWithChildren
  '/accesses': typeof StaffAccessesLayoutRouteWithChildren
  '/apps/$': typeof StaffAppsSplatRoute
  '/attendance-core': typeof StaffAttendanceCoreLayoutRouteWithChildren
  '/attendance-engine': typeof StaffAttendanceEngineLayoutRouteWithChildren
  '/attendances': typeof StaffAttendancesLayoutRouteWithChildren
  '/business-operation-events': typeof StaffBusinessOperationEventsListRouteWithChildren
  '/business-partner': typeof StaffBusinessPartnerListRouteWithChildren
  '/certification': typeof StaffCertificationListRouteWithChildren
  '/contract': typeof StaffContractListRouteWithChildren
  '/contractor-core': typeof StaffContractorCorePackagesRouteWithChildren
  '/contractor-core/anchor-date': typeof StaffContractorCoreAnchorDateRoute
  '/contractor-core/contract-targets': typeof StaffContractorCoreContractTargetsRoute
  '/contractor-core/person-targets': typeof StaffContractorCorePersonTargetsRoute
  '/deal': typeof StaffDealListRouteWithChildren
  '/devices': typeof StaffDevicesListRouteWithChildren
  '/equipment': typeof StaffEquipmentLayoutRouteWithChildren
  '/fleets': typeof StaffFleetsLayoutRouteWithChildren
  '/ga-operation-core': typeof StaffGaOperationCorePackagesRouteWithChildren
  '/id-managements/$': typeof StaffIdManagementsSplatRoute
  '/ids': typeof StaffIdsLayoutRouteWithChildren
  '/it-operation-core': typeof StaffItOperationCoreRootRouteWithChildren
  '/it-operation-core/anchor-date': typeof StaffItOperationCoreAnchorDateRoute
  '/it-operation-core/self-report-confirmation': typeof StaffItOperationCoreSelfReportConfirmationRoute
  '/labor-core': typeof StaffLaborCorePackagesRouteWithChildren
  '/labor-core/anchor-date': typeof StaffLaborCoreAnchorDateRoute
  '/labor-core/contract-targets': typeof StaffLaborCoreContractTargetsRoute
  '/labor-core/government-application-confirmation': typeof StaffLaborCoreGovernmentApplicationConfirmationRoute
  '/labor-core/person-targets': typeof StaffLaborCorePersonTargetsRoute
  '/labor-core/year-end-adjustment-confirmation': typeof StaffLaborCoreYearEndAdjustmentConfirmationRoute
  '/licenses': typeof StaffLicensesListRouteWithChildren
  '/marketplace': typeof StaffMarketplaceStoreRouteWithChildren
  '/networks': typeof StaffNetworksLayoutRouteWithChildren
  '/organization': typeof StaffOrganizationListRouteWithChildren
  '/payroll-core': typeof StaffPayrollCoreLayoutRouteWithChildren
  '/payroll-engine': typeof StaffPayrollEngineLayoutRouteWithChildren
  '/payroll': typeof StaffPayrollLayoutRouteWithChildren
  '/people': typeof StaffPeopleListRouteWithChildren
  '/places': typeof StaffPlacesLayoutRouteWithChildren
  '/public-ids/$id': typeof StaffPublicIdsIdRouteWithChildren
  '/public-ids': typeof StaffPublicIdsListRouteWithChildren
  '/software': typeof StaffSoftwareLayoutRouteWithChildren
  '/starlinks': typeof StaffStarlinksLayoutRouteWithChildren
  '/storage-files': typeof StaffStorageFilesListRouteWithChildren
  '/supplier': typeof StaffSupplierListRouteWithChildren
  '/time-and-attendance': typeof StaffTimeAndAttendanceLayoutRouteWithChildren
  '/labor-core/group-name': typeof StaffLaborCoreGroupNameLazyRoute
  '/chat': typeof ChatChatIndexRoute
  '/cockpit-mock': typeof CockpitMockCockpitMockIndexRoute
  '/individual/': typeof IndividualIndividualIndexRoute
  '/development-tickets': typeof StacktraceDevelopmentTicketsIndexRoute
  '/production': typeof StacktraceProductionIndexRoute
  '/products': typeof StacktraceProductsIndexRoute
  '/test-assets': typeof StacktraceTestAssetsIndexRoute
  '/cockpit': typeof StaffCockpitIndexRoute
  '/it-operation-core/': typeof StaffItOperationCoreIndexRoute
  '/organization/': typeof StaffOrganizationIndexRoute
  '/settings': typeof StaffSettingsIndexRoute
  '/account/sso': typeof AccountSsoIndexRoute
  '/auth/password-reset': typeof AuthPasswordResetIndexRoute
  '/auth/sign-in': typeof AuthSignInIndexRoute
  '/oauth2/consent': typeof Oauth2ConsentIndexRoute
  '/oauth2/error': typeof Oauth2ErrorIndexRoute
  '/oauth2/login': typeof Oauth2LoginIndexRoute
  '/oauth2/logout': typeof Oauth2LogoutIndexRoute
  '/certification/': typeof StaffCertificationListIndexRouteRoute
  '/licenses/': typeof StaffLicensesListIndexRouteRoute
  '/app-integrations/import-csv/$id': typeof StaffAppIntegrationsImportCsvIdRouteRoute
  '/business-partner/import-csv/corporation': typeof StaffBusinessPartnerImportCsvCorporationRouteRoute
  '/business-partner/import-csv/individual': typeof StaffBusinessPartnerImportCsvIndividualRouteRoute
  '/devices/import-csv/$deviceType': typeof StaffDevicesImportCsvDeviceTypeRouteRoute
  '/it-operation-core/in-house-packages': typeof StaffItOperationCoreRootInHousePackagesRouteRouteWithChildren
  '/it-operation-core/packages': typeof StaffItOperationCoreRootPackagesRouteRouteWithChildren
  '/person/import-csv/$workerType': typeof StaffPersonImportCsvWorkerTypeRouteRoute
  '/places/settings': typeof StaffPlacesLayoutSettingsRouteRouteWithChildren
  '/public-ids/import-csv/$publicIdType': typeof StaffPublicIdsImportCsvPublicIdTypeRouteRoute
  '/software/$id/import-csv': typeof StaffSoftwareIdImportCsvRouteRoute
  '/software/people': typeof StaffSoftwareLayoutPeopleRouteRouteWithChildren
  '/development-tickets/$ticketId': typeof StacktraceDevelopmentTicketsTicketIdLayoutRouteWithChildren
  '/issues/$id': typeof StacktraceIssuesIdLayoutRouteWithChildren
  '/product-roadmap/$roadmapId': typeof StacktraceProductRoadmapRoadmapIdLayoutRouteWithChildren
  '/production/$productionId': typeof StacktraceProductionProductionIdLayoutRouteWithChildren
  '/products/$id': typeof StacktraceProductsIdLayoutRouteWithChildren
  '/test-sets/$id': typeof StacktraceTestSetsIdLayoutRouteWithChildren
  '/test-suites/$id': typeof StacktraceTestSuitesIdLayoutRouteWithChildren
  '/values/$id': typeof StacktraceValuesIdLayoutRouteWithChildren
  '/app-integrations/$id': typeof StaffAppIntegrationsIdIdRouteWithChildren
  '/business-operation-events/archive': typeof StaffBusinessOperationEventsListArchiveRoute
  '/business-operation-events/config': typeof StaffBusinessOperationEventsListConfigRoute
  '/business-operation-events/operation-activity': typeof StaffBusinessOperationEventsListOperationActivityRoute
  '/business-operation-events/overview': typeof StaffBusinessOperationEventsListOverviewRoute
  '/business-operation-events/rule-and-policy': typeof StaffBusinessOperationEventsListRuleAndPolicyRoute
  '/business-operation-events/settings': typeof StaffBusinessOperationEventsListSettingsRoute
  '/business-partner/$id': typeof StaffBusinessPartnerIdLayoutRouteWithChildren
  '/certification/$id': typeof StaffCertificationIdLayoutRouteWithChildren
  '/contract/$id': typeof StaffContractIdLayoutRouteWithChildren
  '/deal/$dealId': typeof StaffDealDealIdLayoutRouteWithChildren
  '/devices/$id': typeof StaffDevicesIdLayoutRouteWithChildren
  '/devices/alerts': typeof StaffDevicesListAlertsRoute
  '/devices/operation-activity': typeof StaffDevicesListOperationActivityRoute
  '/devices/rule-and-policy': typeof StaffDevicesListRuleAndPolicyRoute
  '/equipment/$id': typeof StaffEquipmentIdLayoutRouteWithChildren
  '/fleets/$id': typeof StaffFleetsIdLayoutRouteWithChildren
  '/fleets/alerts': typeof StaffFleetsLayoutAlertsRoute
  '/fleets/overview': typeof StaffFleetsLayoutOverviewRoute
  '/fleets/rule-and-policy': typeof StaffFleetsLayoutRuleAndPolicyRoute
  '/fleets/settings': typeof StaffFleetsLayoutSettingsRoute
  '/it-operation-core/device-inventory/data': typeof StaffItOperationCoreDeviceInventoryDataRoute
  '/it-operation-core/device-inventory/detail': typeof StaffItOperationCoreDeviceInventoryDetailRoute
  '/labor-core/settings': typeof StaffLaborCorePackagesSettingsRouteWithChildren
  '/labor-core/settings/egov-callback': typeof StaffLaborCoreSettingsEgovCallbackRoute
  '/licenses/$id': typeof StaffLicensesIdProfileRouteWithChildren
  '/networks/$id': typeof StaffNetworksIdLayoutRouteWithChildren
  '/organization/$id': typeof StaffOrganizationIdLayoutRouteWithChildren
  '/people/alerts': typeof StaffPeopleListAlertsRoute
  '/people/community': typeof StaffPeopleListCommunityRoute
  '/people/people-graph': typeof StaffPeopleListPeopleGraphRoute
  '/people/rule-and-policy': typeof StaffPeopleListRuleAndPolicyRoute
  '/people/salary-and-payment': typeof StaffPeopleListSalaryAndPaymentRoute
  '/person/$id': typeof StaffPersonIdProfileRouteWithChildren
  '/places/$id': typeof StaffPlacesIdLayoutRouteWithChildren
  '/places/overview': typeof StaffPlacesLayoutOverviewRoute
  '/settings/contracting-corporation-profile': typeof StaffSettingsContractingCorporationProfileLayoutRouteWithChildren
  '/settings/permission-and-roles': typeof StaffSettingsPermissionAndRolesListRouteWithChildren
  '/settings/persons': typeof StaffSettingsPersonsListAccountRouteWithChildren
  '/software/$id': typeof StaffSoftwareIdIdRouteWithChildren
  '/software/integrations': typeof StaffSoftwareLayoutIntegrationsRoute
  '/starlinks/$id': typeof StaffStarlinksIdLayoutRouteWithChildren
  '/supplier/$supplierId': typeof StaffSupplierSupplierIdLayoutRouteWithChildren
  '/users/$userId': typeof StaffUsersUserIdLayoutRouteWithChildren
  '/devices/': typeof StaffDevicesListIndexRouteLazyRoute
  '/people/': typeof StaffPeopleListIndexRouteLazyRoute
  '/software/': typeof StaffSoftwareLayoutIndexRouteLazyRoute
  '/certification/settings': typeof StaffCertificationListSettingsRouteLazyRouteWithChildren
  '/devices/settings': typeof StaffDevicesListSettingsRouteLazyRouteWithChildren
  '/equipment/settings': typeof StaffEquipmentLayoutPlaceholdersSettingsRoute
  '/people/settings': typeof StaffPeopleListSettingsRouteLazyRouteWithChildren
  '/supplier/settings': typeof StaffSupplierListSettingsRouteLazyRouteWithChildren
  '/chat/$sessionId': typeof ChatChatSessionIdIndexRoute
  '/chat/new': typeof ChatChatNewIndexRoute
  '/idp-sso/google-workspace': typeof IdpSsoMockIdpSsoGoogleWorkspaceIndexRoute
  '/individual/portal/': typeof IndividualIndividualPortalIndexRoute
  '/development-tickets/add-select': typeof StacktraceDevelopmentTicketsAddSelectIndexRoute
  '/development-tickets/add': typeof StacktraceDevelopmentTicketsAddIndexRoute
  '/development-tickets/external-integrations': typeof StacktraceDevelopmentTicketsExternalIntegrationsIndexRoute
  '/issues/': typeof StacktraceIssuesLayoutIndexRoute
  '/issues/add-select': typeof StacktraceIssuesAddSelectIndexRoute
  '/issues/add': typeof StacktraceIssuesAddIndexRoute
  '/issues/external-integrations': typeof StacktraceIssuesExternalIntegrationsIndexRoute
  '/product-roadmap/': typeof StacktraceProductRoadmapLayoutIndexRoute
  '/products/add-select': typeof StacktraceProductsAddSelectIndexRoute
  '/products/add': typeof StacktraceProductsAddIndexRoute
  '/test-sets/': typeof StacktraceTestSetsLayoutIndexRoute
  '/test-suites/': typeof StacktraceTestSuitesLayoutIndexRoute
  '/values/': typeof StacktraceValuesLayoutIndexRoute
  '/values/add-select': typeof StacktraceValuesAddSelectIndexRoute
  '/values/add': typeof StacktraceValuesAddIndexRoute
  '/accesses/': typeof StaffAccessesLayoutIndexRoute
  '/attendance-core/': typeof StaffAttendanceCoreLayoutIndexRoute
  '/attendance-engine/': typeof StaffAttendanceEngineLayoutIndexRoute
  '/attendances/': typeof StaffAttendancesLayoutIndexRoute
  '/business-operation-events/$eventInstanceId': typeof StaffBusinessOperationEventsEventInstanceIdIndexRoute
  '/business-operation-events/': typeof StaffBusinessOperationEventsListIndexRoute
  '/business-partner/': typeof StaffBusinessPartnerListIndexRoute
  '/business-partner/add': typeof StaffBusinessPartnerAddIndexRoute
  '/certification/add': typeof StaffCertificationAddIndexRoute
  '/contract/': typeof StaffContractListIndexRoute
  '/contract/add': typeof StaffContractAddIndexRoute
  '/contractor-core/': typeof StaffContractorCorePackagesIndexRoute
  '/deal/': typeof StaffDealListIndexRoute
  '/deal/add': typeof StaffDealAddIndexRoute
  '/device-catalog/add': typeof StaffDeviceCatalogAddIndexRoute
  '/devices/add': typeof StaffDevicesAddIndexRoute
  '/devices/external-it-saas': typeof StaffDevicesExternalItSaasIndexRoute
  '/equipment/': typeof StaffEquipmentLayoutIndexRoute
  '/equipment/add-select': typeof StaffEquipmentAddSelectIndexRoute
  '/equipment/add': typeof StaffEquipmentAddIndexRoute
  '/equipment/import-csv': typeof StaffEquipmentImportCsvIndexRoute
  '/fleets/add-select': typeof StaffFleetsAddSelectIndexRoute
  '/fleets/add': typeof StaffFleetsAddIndexRoute
  '/ga-operation-core/': typeof StaffGaOperationCorePackagesIndexRoute
  '/ids/': typeof StaffIdsLayoutIndexRoute
  '/it-operation-core/device-targets': typeof StaffItOperationCoreDeviceTargetsIndexRoute
  '/it-operation-core/person-targets': typeof StaffItOperationCorePersonTargetsIndexRoute
  '/labor-core/': typeof StaffLaborCorePackagesIndexRoute
  '/licenses/add': typeof StaffLicensesAddIndexRoute
  '/marketplace/cart': typeof StaffMarketplaceCartIndexRoute
  '/marketplace/unavailable': typeof StaffMarketplaceUnavailableIndexRoute
  '/networks/': typeof StaffNetworksLayoutIndexRoute
  '/networks/add': typeof StaffNetworksAddIndexRoute
  '/organization/plan': typeof StaffOrganizationPlanIndexRoute
  '/payroll-core/': typeof StaffPayrollCoreLayoutIndexRoute
  '/payroll-engine/': typeof StaffPayrollEngineLayoutIndexRoute
  '/payroll/': typeof StaffPayrollLayoutIndexRoute
  '/person/add-person-certification': typeof StaffPersonAddPersonCertificationIndexRoute
  '/person/add': typeof StaffPersonAddIndexRoute
  '/person/external-hr-saas': typeof StaffPersonExternalHrSaasIndexRoute
  '/places/': typeof StaffPlacesLayoutIndexRoute
  '/places/add-select': typeof StaffPlacesAddSelectIndexRoute
  '/places/add': typeof StaffPlacesAddIndexRoute
  '/public-ids/$id/': typeof StaffPublicIdsIdIndexRoute
  '/public-ids/': typeof StaffPublicIdsListIndexRoute
  '/public-ids/add': typeof StaffPublicIdsAddIndexRoute
  '/settings/contracting-corporation-profile/': typeof StaffSettingsContractingCorporationProfileIndexRoute
  '/settings/permission-and-roles/': typeof StaffSettingsPermissionAndRolesIndexRoute
  '/settings/persons/': typeof StaffSettingsPersonsIndexRoute
  '/software/add': typeof StaffSoftwareAddIndexRoute
  '/starlinks/': typeof StaffStarlinksLayoutIndexRoute
  '/storage-files/': typeof StaffStorageFilesListIndexRoute
  '/supplier/': typeof StaffSupplierListIndexRoute
  '/time-and-attendance/': typeof StaffTimeAndAttendanceLayoutIndexRoute
  '/auth/invitation/$invitationCode': typeof AuthInvitationInvitationCodeIndexRoute
  '/auth/sign-in/error': typeof AuthSignInErrorIndexRoute
  '/person/$id/': typeof StaffPersonIdProfileIndexRouteRoute
  '/individual/portal/lookup/clocking-record': typeof IndividualIndividualPortalLookupClockingRecordRouteRouteWithChildren
  '/individual/portal/lookup/pay-slip': typeof IndividualIndividualPortalLookupPaySlipRouteRouteWithChildren
  '/attendances/clocking-records/$employeeId': typeof StaffAttendancesLayoutClockingRecordsEmployeeIdRouteRouteWithChildren
  '/business-partner/alerts': typeof StaffBusinessPartnerListPlaceholdersAlertsRouteRoute
  '/business-partner/contract-and-cost': typeof StaffBusinessPartnerListPlaceholdersContractAndCostRouteRoute
  '/business-partner/operation-activity': typeof StaffBusinessPartnerListPlaceholdersOperationActivityRouteRoute
  '/business-partner/rule-and-policy': typeof StaffBusinessPartnerListPlaceholdersRuleAndPolicyRouteRoute
  '/business-partner/settings': typeof StaffBusinessPartnerListPlaceholdersSettingsRouteRoute
  '/certification/alerts': typeof StaffCertificationListPlaceholdersAlertsRouteRoute
  '/certification/operation-activity': typeof StaffCertificationListPlaceholdersOperationActivityRouteRoute
  '/certification/overview': typeof StaffCertificationListPlaceholdersOverviewRouteRoute
  '/certification/rule-and-policy': typeof StaffCertificationListPlaceholdersRuleAndPolicyRouteRoute
  '/contract/alerts': typeof StaffContractListPlaceholdersAlertsRouteRoute
  '/contract/contract-and-cost': typeof StaffContractListPlaceholdersContractAndCostRouteRoute
  '/contract/operation-activity': typeof StaffContractListPlaceholdersOperationActivityRouteRoute
  '/contract/overview': typeof StaffContractListPlaceholdersOverviewRouteRoute
  '/contract/people': typeof StaffContractListPlaceholdersPeopleRouteRoute
  '/deal/$dealId/flow': typeof StaffDealDealIdLayoutFlowRouteRoute
  '/deal/$dealId/structure': typeof StaffDealDealIdLayoutStructureRouteRoute
  '/payroll/pay-slips/$employeeId': typeof StaffPayrollLayoutPaySlipsEmployeeIdRouteRouteWithChildren
  '/software/marketplace/$id': typeof StaffSoftwareLayoutMarketplaceIdRouteRouteWithChildren
  '/supplier/$supplierId/files': typeof StaffSupplierSupplierIdLayoutFilesRouteRoute
  '/supplier/$supplierId/rules-and-policy': typeof StaffSupplierSupplierIdLayoutRulesAndPolicyRouteRoute
  '/supplier/$supplierId/settings': typeof StaffSupplierSupplierIdLayoutSettingsRouteRoute
  '/supplier/alerts': typeof StaffSupplierListPlaceholdersAlertsRouteRoute
  '/supplier/contract-and-cost': typeof StaffSupplierListPlaceholdersContractAndCostRouteRoute
  '/supplier/operation-activity': typeof StaffSupplierListPlaceholdersOperationActivityRouteRoute
  '/supplier/overview': typeof StaffSupplierListPlaceholdersOverviewRouteRoute
  '/supplier/rule-and-policy': typeof StaffSupplierListPlaceholdersRuleAndPolicyRouteRoute
  '/individual/my-profile': typeof IndividualIndividualProfileMyProfileLayoutRouteWithChildren
  '/individual/task/$id/approval-dialog': typeof IndividualIndividualTaskIdApprovalDialogRoute
  '/accesses/contract-and-cost': typeof StaffAccessesLayoutPlaceholdersContractAndCostRoute
  '/accesses/overview': typeof StaffAccessesLayoutPlaceholdersOverviewRoute
  '/accesses/software': typeof StaffAccessesLayoutPlaceholdersSoftwareRoute
  '/app-integrations/$id/$': typeof StaffAppIntegrationsIdIdSplatRoute
  '/business-partner/add/$businessPartnerType/completed': typeof StaffBusinessPartnerAddBusinessPartnerTypeCompletedRoute
  '/certification/add/$certificationKind/completed': typeof StaffCertificationAddCertificationKindCompletedRoute
  '/certification/handling-certification/$id': typeof StaffCertificationHandlingCertificationIdLayoutRouteWithChildren
  '/certification/specialty-certification/$id': typeof StaffCertificationSpecialtyCertificationIdLayoutRouteWithChildren
  '/contract/add/subscription/completed': typeof StaffContractAddSubscriptionCompletedRoute
  '/deal/add/$direction/completed': typeof StaffDealAddDirectionCompletedRoute
  '/device-catalog/active/$id': typeof StaffDeviceCatalogActiveIdLayoutRouteWithChildren
  '/device-catalog/add/$deviceType/completed': typeof StaffDeviceCatalogAddDeviceTypeCompletedRoute
  '/device-catalog/draft/$id': typeof StaffDeviceCatalogDraftIdLayoutRouteWithChildren
  '/devices/contract-and-cost': typeof StaffDevicesListContractAndCostContractAndCostRouteWithChildren
  '/devices/add/$deviceType/completed': typeof StaffDevicesAddDeviceTypeCompletedRoute
  '/equipment/overview': typeof StaffEquipmentLayoutPlaceholdersOverviewRoute
  '/equipment/rule-and-policy': typeof StaffEquipmentLayoutPlaceholdersRuleAndPolicyRoute
  '/equipment/items/$id': typeof StaffEquipmentItemsIdDetailRouteWithChildren
  '/ids/alerts': typeof StaffIdsLayoutPlaceholdersAlertsRoute
  '/ids/group-id': typeof StaffIdsLayoutPlaceholdersGroupIdRoute
  '/ids/operation-activity': typeof StaffIdsLayoutPlaceholdersOperationActivityRoute
  '/ids/overview': typeof StaffIdsLayoutPlaceholdersOverviewRoute
  '/ids/rule-and-policy': typeof StaffIdsLayoutPlaceholdersRuleAndPolicyRoute
  '/ids/settings': typeof StaffIdsLayoutPlaceholdersSettingsRoute
  '/ids/group-id/$id': typeof StaffIdsGroupIdIdIdRouteWithChildren
  '/it-operation-core/in-house-packages/$packageId': typeof StaffItOperationCoreRootInHousePackagesPackageIdRouteWithChildren
  '/it-operation-core/packages/$packageId': typeof StaffItOperationCoreRootPackagesPackageIdRoute
  '/labor-core/settings/profile/$profileId': typeof StaffLaborCoreSettingsProfileProfileIdRoute
  '/licenses/add/$allocationType/completed': typeof StaffLicensesAddAllocationTypeCompletedRoute
  '/marketplace/sent-orders/$orderId': typeof StaffMarketplaceSentOrdersOrderIdLayoutRouteWithChildren
  '/networks/alerts': typeof StaffNetworksLayoutPlaceholdersAlertsRoute
  '/networks/contract-and-cost': typeof StaffNetworksLayoutPlaceholdersContractAndCostRoute
  '/networks/operation-activity': typeof StaffNetworksLayoutPlaceholdersOperationActivityRoute
  '/networks/overview': typeof StaffNetworksLayoutPlaceholdersOverviewRoute
  '/networks/rule-and-policy': typeof StaffNetworksLayoutPlaceholdersRuleAndPolicyRoute
  '/networks/settings': typeof StaffNetworksLayoutPlaceholdersSettingsRoute
  '/payroll/contract-and-cost': typeof StaffPayrollLayoutContractAndCostContractAndCostRouteWithChildren
  '/person/add-person-certification/$certificationKind/completed': typeof StaffPersonAddPersonCertificationCertificationKindCompletedRoute
  '/person/add/$workerType/completed': typeof StaffPersonAddWorkerTypeCompletedRoute
  '/person/alumni/$id': typeof StaffPersonAlumniIdProfileRouteWithChildren
  '/places/alerts': typeof StaffPlacesLayoutPlaceholdersAlertsRoute
  '/places/contract-and-cost': typeof StaffPlacesLayoutPlaceholdersContractAndCostRoute
  '/places/operation-activity': typeof StaffPlacesLayoutPlaceholdersOperationActivityRoute
  '/places/people': typeof StaffPlacesLayoutPlaceholdersPeopleRoute
  '/places/rule-and-policy': typeof StaffPlacesLayoutPlaceholdersRuleAndPolicyRoute
  '/places/store': typeof StaffPlacesLayoutPlaceholdersStoreRoute
  '/profile/device/$id/$': typeof StaffProfileDeviceIdSplatRoute
  '/software/$id/groups': typeof StaffSoftwareIdIdGroupsRoute
  '/software/$id/profiles': typeof StaffSoftwareIdIdProfilesRoute
  '/software/alerts': typeof StaffSoftwareLayoutAlertsAlertsRouteWithChildren
  '/software/contract-and-cost': typeof StaffSoftwareLayoutContractAndCostContractAndCostRouteWithChildren
  '/starlinks/billing-and-cost': typeof StaffStarlinksLayoutPlaceholdersBillingAndCostRoute
  '/starlinks/marketplace': typeof StaffStarlinksLayoutPlaceholdersMarketplaceRoute
  '/starlinks/operation-activity': typeof StaffStarlinksLayoutPlaceholdersOperationActivityRoute
  '/storage-files/files/$id': typeof StaffStorageFilesFilesIdIdRouteWithChildren
  '/storage-files/folders/$id': typeof StaffStorageFilesFoldersIdIdRouteWithChildren
  '/software/$id/settings': typeof StaffSoftwareIdIdSettingsRouteLazyRouteWithChildren
  '/individual/approval-tasks': typeof IndividualIndividualTasksApprovalTasksIndexRoute
  '/individual/operation-tasks': typeof IndividualIndividualTasksOperationTasksIndexRoute
  '/individual/request-tasks': typeof IndividualIndividualTasksRequestTasksIndexRoute
  '/individual/operation-package/$id': typeof IndividualIndividualOperationPackageIdIndexRoute
  '/individual/portal/approvals': typeof IndividualIndividualPortalApprovalsIndexRoute
  '/individual/portal/lookup': typeof IndividualIndividualPortalLookupIndexRoute
  '/individual/portal/requests': typeof IndividualIndividualPortalRequestsIndexRoute
  '/individual/task/$id': typeof IndividualIndividualTaskIdIndexRoute
  '/development-tickets/$ticketId/': typeof StacktraceDevelopmentTicketsTicketIdLayoutIndexRoute
  '/issues/$id/': typeof StacktraceIssuesIdLayoutIndexRoute
  '/issues/overview': typeof StacktraceIssuesLayoutOverviewIndexRoute
  '/product-roadmap/$roadmapId/': typeof StacktraceProductRoadmapRoadmapIdLayoutIndexRoute
  '/production/$productionId/': typeof StacktraceProductionProductionIdLayoutIndexRoute
  '/products/$id/': typeof StacktraceProductsIdLayoutIndexRoute
  '/test-sets/$id/': typeof StacktraceTestSetsIdLayoutIndexRoute
  '/test-suites/$id/': typeof StacktraceTestSuitesIdLayoutIndexRoute
  '/values/$id/': typeof StacktraceValuesIdLayoutIndexRoute
  '/accesses/alerts': typeof StaffAccessesLayoutAlertsIndexRoute
  '/accesses/list': typeof StaffAccessesLayoutListIndexRoute
  '/accesses/settings': typeof StaffAccessesLayoutSettingsIndexRoute
  '/attendance-core/archive': typeof StaffAttendanceCoreLayoutArchiveIndexRoute
  '/attendance-core/config': typeof StaffAttendanceCoreLayoutConfigIndexRoute
  '/attendance-core/dashboard': typeof StaffAttendanceCoreLayoutDashboardIndexRoute
  '/attendance-core/operation-packages': typeof StaffAttendanceCoreLayoutOperationPackagesIndexRoute
  '/attendance-engine/attendance-structures': typeof StaffAttendanceEngineLayoutAttendanceStructuresIndexRoute
  '/attendance-engine/attendance-units': typeof StaffAttendanceEngineLayoutAttendanceUnitsIndexRoute
  '/attendance-engine/items': typeof StaffAttendanceEngineLayoutItemsIndexRoute
  '/attendance-engine/logic-components': typeof StaffAttendanceEngineLayoutLogicComponentsIndexRoute
  '/attendances/alerts': typeof StaffAttendancesLayoutAlertsIndexRoute
  '/attendances/clocking-records': typeof StaffAttendancesLayoutClockingRecordsIndexRoute
  '/attendances/employees': typeof StaffAttendancesLayoutEmployeesIndexRoute
  '/attendances/operation-activity': typeof StaffAttendancesLayoutOperationActivityIndexRoute
  '/attendances/overview': typeof StaffAttendancesLayoutOverviewIndexRoute
  '/attendances/rule-and-policy': typeof StaffAttendancesLayoutRuleAndPolicyIndexRoute
  '/attendances/settings': typeof StaffAttendancesLayoutSettingsIndexRoute
  '/business-partner/terminated': typeof StaffBusinessPartnerListTerminatedIndexRoute
  '/business-partner/add/$businessPartnerType': typeof StaffBusinessPartnerAddBusinessPartnerTypeIndexRoute
  '/certification/people': typeof StaffCertificationListPeopleIndexRoute
  '/certification/settings/': typeof StaffCertificationListSettingsIndexRoute
  '/certification/add/$certificationKind': typeof StaffCertificationAddCertificationKindIndexRoute
  '/cockpit/approval/$id': typeof StaffCockpitApprovalIdIndexRoute
  '/cockpit/task/$taskId': typeof StaffCockpitTaskTaskIdIndexRoute
  '/contract/add/subscription': typeof StaffContractAddSubscriptionIndexRoute
  '/contract/import-csv/$contractType': typeof StaffContractImportCsvContractTypeIndexRoute
  '/contractor-core/archives': typeof StaffContractorCorePackagesArchivesIndexRoute
  '/contractor-core/configs': typeof StaffContractorCorePackagesConfigsIndexRoute
  '/contractor-core/config/$patternId': typeof StaffContractorCoreConfigPatternIdIndexRoute
  '/deal/add/$direction': typeof StaffDealAddDirectionIndexRoute
  '/device-catalog/add/$deviceType': typeof StaffDeviceCatalogAddDeviceTypeIndexRoute
  '/devices/$id/': typeof StaffDevicesIdLayoutIndexRoute
  '/devices/inventories': typeof StaffDevicesListInventoriesIndexRoute
  '/devices/inventory': typeof StaffDevicesListInventoryIndexRoute
  '/devices/people': typeof StaffDevicesListPeopleIndexRoute
  '/devices/settings/': typeof StaffDevicesListSettingsIndexRoute
  '/devices/add/$deviceType': typeof StaffDevicesAddDeviceTypeIndexRoute
  '/devices/add/catalog': typeof StaffDevicesAddCatalogIndexRoute
  '/equipment/alerts': typeof StaffEquipmentLayoutAlertsIndexRoute
  '/equipment/items': typeof StaffEquipmentLayoutItemsIndexRoute
  '/equipment/settings/': typeof StaffEquipmentLayoutSettingsIndexRoute
  '/fleets/': typeof StaffFleetsLayoutListIndexRoute
  '/ga-operation-core/archives': typeof StaffGaOperationCorePackagesArchivesIndexRoute
  '/ga-operation-core/configs': typeof StaffGaOperationCorePackagesConfigsIndexRoute
  '/ga-operation-core/config/$patternId': typeof StaffGaOperationCoreConfigPatternIdIndexRoute
  '/ids/people': typeof StaffIdsLayoutPeopleIndexRoute
  '/ids/group-id/add': typeof StaffIdsGroupIdAddIndexRoute
  '/it-operation-core/archives': typeof StaffItOperationCoreRootArchivesIndexRoute
  '/it-operation-core/config': typeof StaffItOperationCoreRootConfigIndexRoute
  '/it-operation-core/in-house-packages/': typeof StaffItOperationCoreRootInHousePackagesIndexRoute
  '/it-operation-core/packages/': typeof StaffItOperationCoreRootPackagesIndexRoute
  '/it-operation-core/config/$patternId': typeof StaffItOperationCoreConfigPatternIdIndexRoute
  '/it-operation-core/self-report-patterns/$patternId': typeof StaffItOperationCoreSelfReportPatternsPatternIdIndexRoute
  '/labor-core/archives': typeof StaffLaborCorePackagesArchivesIndexRoute
  '/labor-core/configs': typeof StaffLaborCorePackagesConfigsIndexRoute
  '/labor-core/settings/': typeof StaffLaborCorePackagesSettingsIndexRoute
  '/labor-core/config/$patternId': typeof StaffLaborCoreConfigPatternIdIndexRoute
  '/licenses/alerts': typeof StaffLicensesListAlertsIndexRoute
  '/licenses/contract-and-cost': typeof StaffLicensesListContractAndCostIndexRoute
  '/licenses/inventory': typeof StaffLicensesListInventoryIndexRoute
  '/licenses/operation-activity': typeof StaffLicensesListOperationActivityIndexRoute
  '/licenses/people': typeof StaffLicensesListPeopleIndexRoute
  '/licenses/rule-and-policy': typeof StaffLicensesListRuleAndPolicyIndexRoute
  '/licenses/settings': typeof StaffLicensesListSettingsIndexRoute
  '/licenses/add/$allocationType': typeof StaffLicensesAddAllocationTypeIndexRoute
  '/marketplace/sales-orders/$orderId': typeof StaffMarketplaceSalesOrdersOrderIdIndexRoute
  '/organization/$id/': typeof StaffOrganizationIdLayoutIndexRoute
  '/organization/alert': typeof StaffOrganizationListAlertIndexRoute
  '/organization/chart': typeof StaffOrganizationListChartIndexRoute
  '/organization/cost': typeof StaffOrganizationListCostIndexRoute
  '/organization/history': typeof StaffOrganizationListHistoryIndexRoute
  '/organization/rule-policy': typeof StaffOrganizationListRulePolicyIndexRoute
  '/organization/settings': typeof StaffOrganizationListSettingsIndexRoute
  '/organization/plan/$id': typeof StaffOrganizationPlanIdIndexRoute
  '/organization/plan/create': typeof StaffOrganizationPlanCreateIndexRoute
  '/payroll-core/archive': typeof StaffPayrollCoreLayoutArchiveIndexRoute
  '/payroll-core/config': typeof StaffPayrollCoreLayoutConfigIndexRoute
  '/payroll-core/dashboard': typeof StaffPayrollCoreLayoutDashboardIndexRoute
  '/payroll-core/operation-packages': typeof StaffPayrollCoreLayoutOperationPackagesIndexRoute
  '/payroll-core/person-targets': typeof StaffPayrollCoreLayoutPersonTargetsIndexRoute
  '/payroll-engine/items': typeof StaffPayrollEngineLayoutItemsIndexRoute
  '/payroll-engine/logic-components': typeof StaffPayrollEngineLayoutLogicComponentsIndexRoute
  '/payroll-engine/payroll-structures': typeof StaffPayrollEngineLayoutPayrollStructuresIndexRoute
  '/payroll-engine/payroll-units': typeof StaffPayrollEngineLayoutPayrollUnitsIndexRoute
  '/payroll/alerts': typeof StaffPayrollLayoutAlertsIndexRoute
  '/payroll/overview': typeof StaffPayrollLayoutOverviewIndexRoute
  '/payroll/pay-slips': typeof StaffPayrollLayoutPaySlipsIndexRoute
  '/payroll/rule-and-policy': typeof StaffPayrollLayoutRuleAndPolicyIndexRoute
  '/payroll/settings': typeof StaffPayrollLayoutSettingsIndexRoute
  '/people/alumni': typeof StaffPeopleListAlumniIndexRoute
  '/people/operation-activity': typeof StaffPeopleListOperationActivityIndexRoute
  '/people/settings/': typeof StaffPeopleListSettingsIndexRoute
  '/people/workforce': typeof StaffPeopleListWorkforceIndexRoute
  '/person/add-person-certification/$certificationKind': typeof StaffPersonAddPersonCertificationCertificationKindIndexRoute
  '/person/add/$workerType': typeof StaffPersonAddWorkerTypeIndexRoute
  '/person/automap-ingester/$workerType': typeof StaffPersonAutomapIngesterWorkerTypeIndexRoute
  '/places/settings/': typeof StaffPlacesLayoutSettingsIndexRoute
  '/profile/device/$id': typeof StaffProfileDeviceIdIndexRoute
  '/public-ids/$id/details': typeof StaffPublicIdsIdDetailsIndexRoute
  '/public-ids/$id/files': typeof StaffPublicIdsIdFilesIndexRoute
  '/public-ids/alerts': typeof StaffPublicIdsListAlertsIndexRoute
  '/public-ids/members': typeof StaffPublicIdsListMembersIndexRoute
  '/public-ids/operation-activity': typeof StaffPublicIdsListOperationActivityIndexRoute
  '/public-ids/registry': typeof StaffPublicIdsListRegistryIndexRoute
  '/public-ids/rules-and-policies': typeof StaffPublicIdsListRulesAndPoliciesIndexRoute
  '/public-ids/settings': typeof StaffPublicIdsListSettingsIndexRoute
  '/settings/data-connector/inbound': typeof StaffSettingsDataConnectorInboundIndexRoute
  '/settings/data-connector/outbound': typeof StaffSettingsDataConnectorOutboundIndexRoute
  '/settings/persons/invite': typeof StaffSettingsPersonsInviteIndexRoute
  '/software/$id/': typeof StaffSoftwareIdIdIndexRoute
  '/software/library': typeof StaffSoftwareLayoutLibraryIndexRoute
  '/software/operation-activity': typeof StaffSoftwareLayoutOperationActivityIndexRoute
  '/software/people/': typeof StaffSoftwareLayoutPeopleIndexRoute
  '/software/registry': typeof StaffSoftwareLayoutRegistryIndexRoute
  '/software/rule-and-policy': typeof StaffSoftwareLayoutRuleAndPolicyIndexRoute
  '/software/settings': typeof StaffSoftwareLayoutSettingsIndexRoute
  '/software/add/$type': typeof StaffSoftwareAddTypeIndexRoute
  '/starlinks/alerts': typeof StaffStarlinksLayoutAlertsIndexRoute
  '/starlinks/user-terminals': typeof StaffStarlinksLayoutUserTerminalsIndexRoute
  '/storage-files/files': typeof StaffStorageFilesListFilesIndexRoute
  '/storage-files/folders': typeof StaffStorageFilesListFoldersIndexRoute
  '/storage-files/settings': typeof StaffStorageFilesListSettingsIndexRoute
  '/supplier/settings/': typeof StaffSupplierListSettingsIndexRoute
  '/time-and-attendance/attendance-links': typeof StaffTimeAndAttendanceLayoutAttendanceLinksIndexRoute
  '/equipment/$id/': typeof StaffEquipmentIdLayoutIndexLazyRoute
  '/licenses/$id/': typeof StaffLicensesIdProfileIndexLazyRoute
  '/individual/my-profile/': typeof IndividualIndividualProfileMyProfileLayoutIndexRouteRoute
  '/person/alumni/$id/': typeof StaffPersonAlumniIdProfileIndexRouteRoute
  '/contract/$id/approval-info': typeof StaffContractIdLayoutPlaceholdersApprovalInfoRouteRoute
  '/contract/$id/history': typeof StaffContractIdLayoutPlaceholdersHistoryRouteRoute
  '/contract/$id/operation-activity': typeof StaffContractIdLayoutPlaceholdersOperationActivityRouteRoute
  '/contract/$id/risk-provisions': typeof StaffContractIdLayoutPlaceholdersRiskProvisionsRouteRoute
  '/contract/$id/rule-and-policy': typeof StaffContractIdLayoutPlaceholdersRuleAndPolicyRouteRoute
  '/products/$id/scope/$nodeId': typeof StacktraceProductsIdScopeNodeIdLayoutRouteWithChildren
  '/test-suites/$id/test-plan': typeof StacktraceTestSuitesIdLayoutTestPlanLayoutRouteWithChildren
  '/test-suites/$id/test-review': typeof StacktraceTestSuitesIdLayoutTestReviewLayoutRouteWithChildren
  '/attendance-engine/attendance-structures/$structureId': typeof StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutRouteWithChildren
  '/business-partner/$id/bp-role-info': typeof StaffBusinessPartnerIdLayoutBpRoleInfoLayoutRouteWithChildren
  '/devices/add/catalog/$deviceType/completed': typeof StaffDevicesAddCatalogDeviceTypeCompletedRoute
  '/ids/group-id/add/from-scratch/completed': typeof StaffIdsGroupIdAddFromScratchCompletedRoute
  '/it-operation-core/operation-instances/$instanceId': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRouteWithChildren
  '/it-operation-core/in-house-packages/$packageId/start-targets': typeof StaffItOperationCoreRootInHousePackagesPackageIdStartTargetsRoute
  '/licenses/$id/service-plans/$licenseServiceId': typeof StaffLicensesIdServicePlansLicenseServiceIdDetailRouteWithChildren
  '/marketplace/sent-orders/$orderId/activities': typeof StaffMarketplaceSentOrdersOrderIdLayoutActivitiesRoute
  '/payroll-engine/payroll-structures/$structureId': typeof StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutRouteWithChildren
  '/settings/data-connector/inbound/aggregate-data-pipeline': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineListRouteWithChildren
  '/settings/data-connector/inbound/data-pipeline': typeof StaffSettingsDataConnectorInboundDataPipelineListRouteWithChildren
  '/settings/data-connector/outbound/data-pipeline': typeof StaffSettingsDataConnectorOutboundDataPipelineListRouteWithChildren
  '/software/$id/contract-and-cost': typeof StaffSoftwareIdIdContractAndCostContractAndCostRouteWithChildren
  '/individual/portal/lookup/clocking-record/alerts': typeof IndividualIndividualPortalLookupClockingRecordAlertsLazyRoute
  '/individual/portal/lookup/clocking-record/files': typeof IndividualIndividualPortalLookupClockingRecordFilesLazyRoute
  '/individual/portal/lookup/clocking-record/overview': typeof IndividualIndividualPortalLookupClockingRecordOverviewLazyRoute
  '/individual/portal/lookup/clocking-record/schedule': typeof IndividualIndividualPortalLookupClockingRecordScheduleLazyRoute
  '/individual/portal/lookup/pay-slip/alerts': typeof IndividualIndividualPortalLookupPaySlipAlertsLazyRoute
  '/individual/portal/lookup/pay-slip/files': typeof IndividualIndividualPortalLookupPaySlipFilesLazyRoute
  '/individual/portal/lookup/pay-slip/history': typeof IndividualIndividualPortalLookupPaySlipHistoryLazyRoute
  '/individual/portal/lookup/pay-slip/overview': typeof IndividualIndividualPortalLookupPaySlipOverviewLazyRoute
  '/attendances/clocking-records/$employeeId/alerts': typeof StaffAttendancesLayoutClockingRecordsEmployeeIdAlertsLazyRoute
  '/attendances/clocking-records/$employeeId/files': typeof StaffAttendancesLayoutClockingRecordsEmployeeIdFilesLazyRoute
  '/attendances/clocking-records/$employeeId/overview': typeof StaffAttendancesLayoutClockingRecordsEmployeeIdOverviewLazyRoute
  '/attendances/clocking-records/$employeeId/schedule': typeof StaffAttendancesLayoutClockingRecordsEmployeeIdScheduleLazyRoute
  '/attendances/clocking-records/$employeeId/settings': typeof StaffAttendancesLayoutClockingRecordsEmployeeIdSettingsLazyRoute
  '/payroll/pay-slips/$employeeId/alerts': typeof StaffPayrollLayoutPaySlipsEmployeeIdAlertsLazyRoute
  '/payroll/pay-slips/$employeeId/files': typeof StaffPayrollLayoutPaySlipsEmployeeIdFilesLazyRoute
  '/payroll/pay-slips/$employeeId/history': typeof StaffPayrollLayoutPaySlipsEmployeeIdHistoryLazyRoute
  '/payroll/pay-slips/$employeeId/overview': typeof StaffPayrollLayoutPaySlipsEmployeeIdOverviewLazyRoute
  '/payroll/pay-slips/$employeeId/settings': typeof StaffPayrollLayoutPaySlipsEmployeeIdSettingsLazyRoute
  '/individual/task/$id/approval': typeof IndividualIndividualTaskIdApprovalIndexRoute
  '/development-tickets/$ticketId/history': typeof StacktraceDevelopmentTicketsTicketIdLayoutHistoryIndexRoute
  '/issues/$id/history': typeof StacktraceIssuesIdLayoutHistoryIndexRoute
  '/product-roadmap/$roadmapId/detail': typeof StacktraceProductRoadmapRoadmapIdLayoutDetailIndexRoute
  '/product-roadmap/$roadmapId/history': typeof StacktraceProductRoadmapRoadmapIdLayoutHistoryIndexRoute
  '/production/$productionId/dev-scope': typeof StacktraceProductionProductionIdLayoutDevScopeIndexRoute
  '/production/$productionId/issue-scope': typeof StacktraceProductionProductionIdLayoutIssueScopeIndexRoute
  '/production/$productionId/product-scope': typeof StacktraceProductionProductionIdLayoutProductScopeIndexRoute
  '/production/$productionId/quality-scope': typeof StacktraceProductionProductionIdLayoutQualityScopeIndexRoute
  '/production/$productionId/value': typeof StacktraceProductionProductionIdLayoutValueIndexRoute
  '/products/$id/product-scope': typeof StacktraceProductsIdLayoutProductScopeIndexRoute
  '/test-sets/$id/conditions': typeof StacktraceTestSetsIdLayoutConditionsIndexRoute
  '/test-sets/$id/target-functions': typeof StacktraceTestSetsIdLayoutTargetFunctionsIndexRoute
  '/test-suites/$id/document': typeof StacktraceTestSuitesIdLayoutDocumentIndexRoute
  '/test-suites/$id/issues': typeof StacktraceTestSuitesIdLayoutIssuesIndexRoute
  '/test-suites/$id/overview': typeof StacktraceTestSuitesIdLayoutOverviewIndexRoute
  '/test-suites/$id/target-functions': typeof StacktraceTestSuitesIdLayoutTargetFunctionsIndexRoute
  '/test-suites/$id/test-set': typeof StacktraceTestSuitesIdLayoutTestSetIndexRoute
  '/values/$id/history': typeof StacktraceValuesIdLayoutHistoryIndexRoute
  '/values/$id/product-scope': typeof StacktraceValuesIdLayoutProductScopeIndexRoute
  '/accesses/list/$traceableAppId': typeof StaffAccessesLayoutListTraceableAppIdIndexRoute
  '/attendance-engine/attendance-units/$unitId': typeof StaffAttendanceEngineLayoutAttendanceUnitsUnitIdIndexRoute
  '/attendance-engine/items/$componentId': typeof StaffAttendanceEngineLayoutItemsComponentIdIndexRoute
  '/attendance-engine/logic-components/$componentId': typeof StaffAttendanceEngineLayoutLogicComponentsComponentIdIndexRoute
  '/business-partner/$id/': typeof StaffBusinessPartnerIdLayoutIndexIndexRoute
  '/business-partner/$id/address-and-contact': typeof StaffBusinessPartnerIdLayoutAddressAndContactIndexRoute
  '/certification/$id/': typeof StaffCertificationIdLayoutIndexIndexRoute
  '/certification/$id/certification-holders': typeof StaffCertificationIdLayoutCertificationHoldersIndexRoute
  '/certification/$id/handling-certifications': typeof StaffCertificationIdLayoutHandlingCertificationsIndexRoute
  '/certification/$id/specialty-certifications': typeof StaffCertificationIdLayoutSpecialtyCertificationsIndexRoute
  '/certification/settings/issuing-organization': typeof StaffCertificationListSettingsIssuingOrganizationIndexRoute
  '/certification/settings/specialty-category-level': typeof StaffCertificationListSettingsSpecialtyCategoryLevelIndexRoute
  '/certification/settings/specialty-category': typeof StaffCertificationListSettingsSpecialtyCategoryIndexRoute
  '/deal/$dealId/': typeof StaffDealDealIdLayoutIndexIndexRoute
  '/devices/$id/control': typeof StaffDevicesIdLayoutControlIndexRoute
  '/devices/$id/files': typeof StaffDevicesIdLayoutFilesIndexRoute
  '/devices/$id/history': typeof StaffDevicesIdLayoutHistoryIndexRoute
  '/devices/$id/lifecycle': typeof StaffDevicesIdLayoutLifecycleIndexRoute
  '/devices/$id/mdm': typeof StaffDevicesIdLayoutMdmIndexRoute
  '/devices/$id/profile': typeof StaffDevicesIdLayoutProfileIndexRoute
  '/devices/$id/status': typeof StaffDevicesIdLayoutStatusIndexRoute
  '/devices/contract-and-cost/': typeof StaffDevicesListContractAndCostContractAndCostIndexRoute
  '/devices/settings/catalog': typeof StaffDevicesListSettingsCatalogIndexRoute
  '/devices/add/catalog/$deviceType': typeof StaffDevicesAddCatalogDeviceTypeIndexRoute
  '/devices/external-it-saas/$appIntegrationId/preview': typeof StaffDevicesExternalItSaasAppIntegrationIdPreviewIndexRoute
  '/equipment/settings/equipment-items': typeof StaffEquipmentLayoutSettingsEquipmentItemsIndexRoute
  '/equipment/settings/equipment-types': typeof StaffEquipmentLayoutSettingsEquipmentTypesIndexRoute
  '/equipment/items/$id/': typeof StaffEquipmentItemsIdDetailIndexRoute
  '/ids/group-id/$id/': typeof StaffIdsGroupIdIdIdIndexRoute
  '/ids/group-id/add/from-scratch': typeof StaffIdsGroupIdAddFromScratchIndexRoute
  '/it-operation-core/operation-instances/$instanceId/': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdIndexRoute
  '/licenses/$id/assignments': typeof StaffLicensesIdProfileAssignmentsIndexRoute
  '/licenses/$id/people': typeof StaffLicensesIdProfilePeopleIndexRoute
  '/licenses/$id/rule-and-policy': typeof StaffLicensesIdProfileRuleAndPolicyIndexRoute
  '/licenses/$id/service-plans': typeof StaffLicensesIdProfileServicePlansIndexRoute
  '/marketplace/store/devices': typeof StaffMarketplaceStoreStoreDevicesIndexRoute
  '/marketplace/store/licenses': typeof StaffMarketplaceStoreStoreLicensesIndexRoute
  '/marketplace/store/sales-orders': typeof StaffMarketplaceStoreStoreSalesOrdersIndexRoute
  '/marketplace/store/sent-orders': typeof StaffMarketplaceStoreStoreSentOrdersIndexRoute
  '/marketplace/store/starlinks': typeof StaffMarketplaceStoreStoreStarlinksIndexRoute
  '/marketplace/sent-orders/$orderId/': typeof StaffMarketplaceSentOrdersOrderIdLayoutIndexRoute
  '/organization/$id/history': typeof StaffOrganizationIdLayoutHistoryIndexRoute
  '/organization/plan/$id/add': typeof StaffOrganizationPlanIdAddIndexRoute
  '/organization/plan/$id/transfers': typeof StaffOrganizationPlanIdTransfersIndexRoute
  '/payroll-engine/items/$componentId': typeof StaffPayrollEngineLayoutItemsComponentIdIndexRoute
  '/payroll-engine/logic-components/$componentId': typeof StaffPayrollEngineLayoutLogicComponentsComponentIdIndexRoute
  '/payroll-engine/payroll-units/$unitId': typeof StaffPayrollEngineLayoutPayrollUnitsUnitIdIndexRoute
  '/payroll/contract-and-cost/': typeof StaffPayrollLayoutContractAndCostContractAndCostIndexRoute
  '/people/settings/board-member-types': typeof StaffPeopleListSettingsBoardMemberTypesIndexRoute
  '/people/settings/collaborator-types': typeof StaffPeopleListSettingsCollaboratorTypesIndexRoute
  '/people/settings/contract-end-reasons': typeof StaffPeopleListSettingsContractEndReasonsIndexRoute
  '/people/settings/contractor-types': typeof StaffPeopleListSettingsContractorTypesIndexRoute
  '/people/settings/employee-sub-id-names': typeof StaffPeopleListSettingsEmployeeSubIdNamesIndexRoute
  '/people/settings/employment-types': typeof StaffPeopleListSettingsEmploymentTypesIndexRoute
  '/people/settings/grades': typeof StaffPeopleListSettingsGradesIndexRoute
  '/people/settings/health-insurance-associations': typeof StaffPeopleListSettingsHealthInsuranceAssociationsIndexRoute
  '/people/settings/job-competencies': typeof StaffPeopleListSettingsJobCompetenciesIndexRoute
  '/people/settings/job-functions': typeof StaffPeopleListSettingsJobFunctionsIndexRoute
  '/people/settings/job-grades': typeof StaffPeopleListSettingsJobGradesIndexRoute
  '/people/settings/job-levels': typeof StaffPeopleListSettingsJobLevelsIndexRoute
  '/people/settings/job-titles': typeof StaffPeopleListSettingsJobTitlesIndexRoute
  '/people/settings/job-types': typeof StaffPeopleListSettingsJobTypesIndexRoute
  '/people/settings/place-social-insurances': typeof StaffPeopleListSettingsPlaceSocialInsurancesIndexRoute
  '/people/settings/positions': typeof StaffPeopleListSettingsPositionsIndexRoute
  '/people/settings/retirement-reasons': typeof StaffPeopleListSettingsRetirementReasonsIndexRoute
  '/people/settings/work-mode': typeof StaffPeopleListSettingsWorkModeIndexRoute
  '/person/$id/apps': typeof StaffPersonIdProfileAppsIndexRoute
  '/person/$id/contractor-information': typeof StaffPersonIdProfileContractorInformationIndexRoute
  '/person/$id/devices': typeof StaffPersonIdProfileDevicesIndexRoute
  '/person/$id/education-and-qualification': typeof StaffPersonIdProfileEducationAndQualificationIndexRoute
  '/person/$id/employee-information': typeof StaffPersonIdProfileEmployeeInformationIndexRoute
  '/person/$id/equipment': typeof StaffPersonIdProfileEquipmentIndexRoute
  '/person/$id/history': typeof StaffPersonIdProfileHistoryIndexRoute
  '/person/$id/operation-activity': typeof StaffPersonIdProfileOperationActivityIndexRoute
  '/person/$id/personal-information': typeof StaffPersonIdProfilePersonalInformationIndexRoute
  '/person/$id/public-id': typeof StaffPersonIdProfilePublicIdIndexRoute
  '/person/external-hr-saas/$appIntegrationId/preview': typeof StaffPersonExternalHrSaasAppIntegrationIdPreviewIndexRoute
  '/places/$id/administrators': typeof StaffPlacesIdLayoutAdministratorsIndexRoute
  '/places/$id/labor-core': typeof StaffPlacesIdLayoutLaborCoreIndexRoute
  '/places/settings/place-sub-codes': typeof StaffPlacesLayoutSettingsPlaceSubCodesIndexRoute
  '/settings/contracting-corporation-profile/board-member': typeof StaffSettingsContractingCorporationProfileLayoutBoardMemberIndexRoute
  '/settings/contracting-corporation-profile/contact-points': typeof StaffSettingsContractingCorporationProfileLayoutContactPointsIndexRoute
  '/settings/contracting-corporation-profile/corporate-overview': typeof StaffSettingsContractingCorporationProfileLayoutCorporateOverviewIndexRoute
  '/settings/contracting-corporation-profile/group-companies': typeof StaffSettingsContractingCorporationProfileLayoutGroupCompaniesIndexRoute
  '/settings/contracting-corporation-profile/history': typeof StaffSettingsContractingCorporationProfileLayoutHistoryIndexRoute
  '/settings/contracting-corporation-profile/registration': typeof StaffSettingsContractingCorporationProfileLayoutRegistrationIndexRoute
  '/settings/contracting-corporation-profile/shareholders': typeof StaffSettingsContractingCorporationProfileLayoutShareholdersIndexRoute
  '/settings/permission-and-roles/category-permissions': typeof StaffSettingsPermissionAndRolesListCategoryPermissionsIndexRoute
  '/settings/permission-and-roles/people-groups': typeof StaffSettingsPermissionAndRolesListPeopleGroupsIndexRoute
  '/settings/permission-and-roles/product-permissions': typeof StaffSettingsPermissionAndRolesListProductPermissionsIndexRoute
  '/settings/permission-and-roles/roles': typeof StaffSettingsPermissionAndRolesListRolesIndexRoute
  '/settings/persons/settings': typeof StaffSettingsPersonsListSettingsIndexRoute
  '/software/$id/accounts': typeof StaffSoftwareIdIdAccountsIndexRoute
  '/software/$id/activity-monitoring': typeof StaffSoftwareIdIdActivityMonitoringIndexRoute
  '/software/$id/alerts': typeof StaffSoftwareIdIdAlertsIndexRoute
  '/software/$id/architecture': typeof StaffSoftwareIdIdArchitectureIndexRoute
  '/software/$id/detail': typeof StaffSoftwareIdIdDetailIndexRoute
  '/software/$id/rule-and-policy': typeof StaffSoftwareIdIdRuleAndPolicyIndexRoute
  '/software/$id/settings/': typeof StaffSoftwareIdIdSettingsIndexRoute
  '/software/alerts/': typeof StaffSoftwareLayoutAlertsAlertsIndexRoute
  '/software/contract-and-cost/': typeof StaffSoftwareLayoutContractAndCostContractAndCostIndexRoute
  '/software/library/search': typeof StaffSoftwareLayoutLibrarySearchIndexRoute
  '/software/custom-saas/add/$customSaasType': typeof StaffSoftwareCustomSaasAddCustomSaasTypeIndexRoute
  '/supplier/$supplierId/': typeof StaffSupplierSupplierIdLayoutIndexIndexRoute
  '/supplier/settings/procurement-categories': typeof StaffSupplierListSettingsProcurementCategoriesIndexRoute
  '/supplier/settings/supplier-categories': typeof StaffSupplierListSettingsSupplierCategoriesIndexRoute
  '/supplier/settings/supplier-subcategories': typeof StaffSupplierListSettingsSupplierSubcategoriesIndexRoute
  '/time-and-attendance/summary': typeof StaffTimeAndAttendanceLayoutListSummaryIndexRoute
  '/time-and-attendance/attendance-links/$placeId': typeof StaffTimeAndAttendanceLayoutAttendanceLinksPlaceIdIndexRoute
  '/users/$userId/': typeof StaffUsersUserIdLayoutIdentityIndexRoute
  '/users/$userId/sessions': typeof StaffUsersUserIdLayoutSessionsIndexRoute
  '/individual/portal/lookup/clocking-record/': typeof IndividualIndividualPortalLookupClockingRecordIndexLazyRoute
  '/individual/portal/lookup/pay-slip/': typeof IndividualIndividualPortalLookupPaySlipIndexLazyRoute
  '/attendances/clocking-records/$employeeId/': typeof StaffAttendancesLayoutClockingRecordsEmployeeIdIndexLazyRoute
  '/contract/$id/': typeof StaffContractIdLayoutIndexIndexLazyRoute
  '/contract/$id/structure': typeof StaffContractIdLayoutStructureIndexLazyRoute
  '/equipment/$id/lifecycle': typeof StaffEquipmentIdLayoutLifecycleIndexLazyRoute
  '/equipment/$id/status': typeof StaffEquipmentIdLayoutStatusIndexLazyRoute
  '/fleets/$id/': typeof StaffFleetsIdLayoutProfileIndexLazyRoute
  '/networks/$id/': typeof StaffNetworksIdLayoutProfileIndexLazyRoute
  '/payroll/pay-slips/$employeeId/': typeof StaffPayrollLayoutPaySlipsEmployeeIdIndexLazyRoute
  '/places/$id/': typeof StaffPlacesIdLayoutProfileIndexLazyRoute
  '/starlinks/$id/': typeof StaffStarlinksIdLayoutOverviewIndexLazyRoute
  '/starlinks/$id/detail': typeof StaffStarlinksIdLayoutDetailIndexLazyRoute
  '/storage-files/files/$id/': typeof StaffStorageFilesFilesIdIdIndexLazyRoute
  '/storage-files/folders/$id/': typeof StaffStorageFilesFoldersIdIdIndexLazyRoute
  '/individual/certifications/base-certifications/$id': typeof IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutRouteWithChildren
  '/individual/certifications/handling-certifications/$id': typeof IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutRouteWithChildren
  '/individual/certifications/specialty-certifications/$id': typeof IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutRouteWithChildren
  '/device-catalog/active/$id/contract-and-cost': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostRouteWithChildren
  '/devices/contract-and-cost/deal': typeof StaffDevicesListContractAndCostContractAndCostDealDealRouteWithChildren
  '/person/$id/certifications/base-certifications/$personCertificationInformationId': typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRouteWithChildren
  '/person/$id/certifications/handling-certifications/$personCertificationInformationId': typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRouteWithChildren
  '/person/$id/certifications/specialty-certifications/$personCertificationInformationId': typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRouteWithChildren
  '/settings/data-connector/inbound/aggregate-data-pipeline/$id': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailRouteWithChildren
  '/settings/data-connector/inbound/data-pipeline/$id': typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailRouteWithChildren
  '/settings/data-connector/outbound/data-pipeline/$id': typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailRouteWithChildren
  '/software/contract-and-cost/deal': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealRouteWithChildren
  '/individual/my-profile/devices': typeof IndividualIndividualProfileMyProfileLayoutDevicesIndexRoute
  '/individual/my-profile/education-and-qualification': typeof IndividualIndividualProfileMyProfileLayoutEducationAndQualificationIndexRoute
  '/individual/my-profile/softwares': typeof IndividualIndividualProfileMyProfileLayoutSoftwaresIndexRoute
  '/individual/contract/$id/signature-request/$signatureRequestId': typeof IndividualIndividualContractIdSignatureRequestSignatureRequestIdIndexRoute
  '/individual/operation-package/$id/pattern/$patternId': typeof IndividualIndividualOperationPackageIdPatternPatternIdIndexRoute
  '/individual/operation-package/$id/target/$targetId': typeof IndividualIndividualOperationPackageIdTargetTargetIdIndexRoute
  '/production/$productionId/dev-scope/edit': typeof StacktraceProductionProductionIdLayoutDevScopeEditIndexRoute
  '/production/$productionId/issue-scope/edit': typeof StacktraceProductionProductionIdLayoutIssueScopeEditIndexRoute
  '/production/$productionId/value/edit': typeof StacktraceProductionProductionIdLayoutValueEditIndexRoute
  '/products/$id/scope/$nodeId/': typeof StacktraceProductsIdScopeNodeIdLayoutIndexRoute
  '/test-suites/$id/test-plan/': typeof StacktraceTestSuitesIdLayoutTestPlanLayoutIndexRoute
  '/test-suites/$id/test-review/': typeof StacktraceTestSuitesIdLayoutTestReviewLayoutIndexRoute
  '/accesses/alerts/detail/$shadowItAppId': typeof StaffAccessesLayoutAlertsDetailShadowItAppIdIndexRoute
  '/accesses/alerts/dormancy/$softwareId': typeof StaffAccessesLayoutAlertsDormancySoftwareIdIndexRoute
  '/attendance-engine/attendance-structures/$structureId/': typeof StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutIndexRoute
  '/business-partner/$id/bp-role-info/': typeof StaffBusinessPartnerIdLayoutBpRoleInfoLayoutIndexRoute
  '/certification/handling-certification/$id/': typeof StaffCertificationHandlingCertificationIdLayoutIndexIndexRoute
  '/certification/handling-certification/$id/certification-holders': typeof StaffCertificationHandlingCertificationIdLayoutCertificationHoldersIndexRoute
  '/certification/specialty-certification/$id/': typeof StaffCertificationSpecialtyCertificationIdLayoutIndexIndexRoute
  '/certification/specialty-certification/$id/certification-holders': typeof StaffCertificationSpecialtyCertificationIdLayoutCertificationHoldersIndexRoute
  '/certification/specialty-certification/$id/handling-certifications': typeof StaffCertificationSpecialtyCertificationIdLayoutHandlingCertificationsIndexRoute
  '/device-catalog/active/$id/profile': typeof StaffDeviceCatalogActiveIdLayoutProfileIndexRoute
  '/device-catalog/draft/$id/profile': typeof StaffDeviceCatalogDraftIdLayoutProfileIndexRoute
  '/devices/contract-and-cost/cost': typeof StaffDevicesListContractAndCostContractAndCostCostIndexRoute
  '/devices/contract-and-cost/payment': typeof StaffDevicesListContractAndCostContractAndCostPaymentIndexRoute
  '/equipment/items/$id/alerts': typeof StaffEquipmentItemsIdDetailAlertsIndexRoute
  '/equipment/items/$id/inventory': typeof StaffEquipmentItemsIdDetailInventoryIndexRoute
  '/equipment/items/$id/rule-and-policy': typeof StaffEquipmentItemsIdDetailRuleAndPolicyIndexRoute
  '/ids/group-id/$id/detail': typeof StaffIdsGroupIdIdIdDetailIndexRoute
  '/ids/group-id/$id/devices': typeof StaffIdsGroupIdIdIdDevicesIndexRoute
  '/ids/group-id/$id/members': typeof StaffIdsGroupIdIdIdMembersIndexRoute
  '/ids/group-id/$id/rule-and-policy': typeof StaffIdsGroupIdIdIdRuleAndPolicyIndexRoute
  '/ids/group-id/$id/security-and-auth': typeof StaffIdsGroupIdIdIdSecurityAndAuthIndexRoute
  '/ids/group-id/$id/softwares': typeof StaffIdsGroupIdIdIdSoftwaresIndexRoute
  '/marketplace/store/devices/$productId': typeof StaffMarketplaceStoreStoreDevicesProductIdIndexRoute
  '/marketplace/store/licenses/$productId': typeof StaffMarketplaceStoreStoreLicensesProductIdIndexRoute
  '/marketplace/store/starlinks/$productId': typeof StaffMarketplaceStoreStoreStarlinksProductIdIndexRoute
  '/organization/plan/$id/edit/$unitId': typeof StaffOrganizationPlanIdEditUnitIdIndexRoute
  '/payroll-engine/payroll-structures/$structureId/': typeof StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutIndexRoute
  '/payroll/contract-and-cost/cost': typeof StaffPayrollLayoutContractAndCostContractAndCostCostIndexRoute
  '/payroll/contract-and-cost/deal': typeof StaffPayrollLayoutContractAndCostContractAndCostDealIndexRoute
  '/payroll/contract-and-cost/payment': typeof StaffPayrollLayoutContractAndCostContractAndCostPaymentIndexRoute
  '/person/$id/family/$familyPersonId': typeof StaffPersonIdProfileFamilyFamilyPersonIdIndexRoute
  '/person/alumni/$id/apps': typeof StaffPersonAlumniIdProfileAppsIndexRoute
  '/person/alumni/$id/contractor-information': typeof StaffPersonAlumniIdProfileContractorInformationIndexRoute
  '/person/alumni/$id/devices': typeof StaffPersonAlumniIdProfileDevicesIndexRoute
  '/person/alumni/$id/education-and-qualification': typeof StaffPersonAlumniIdProfileEducationAndQualificationIndexRoute
  '/person/alumni/$id/employee-information': typeof StaffPersonAlumniIdProfileEmployeeInformationIndexRoute
  '/person/alumni/$id/equipment': typeof StaffPersonAlumniIdProfileEquipmentIndexRoute
  '/person/alumni/$id/history': typeof StaffPersonAlumniIdProfileHistoryIndexRoute
  '/person/alumni/$id/operation-activity': typeof StaffPersonAlumniIdProfileOperationActivityIndexRoute
  '/person/alumni/$id/personal-information': typeof StaffPersonAlumniIdProfilePersonalInformationIndexRoute
  '/person/alumni/$id/public-id': typeof StaffPersonAlumniIdProfilePublicIdIndexRoute
  '/settings/data-connector/inbound/aggregate-data-pipeline/': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineListIndexRoute
  '/settings/data-connector/inbound/aggregate-data-pipeline/add': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineAddIndexRoute
  '/settings/data-connector/inbound/data-pipeline/': typeof StaffSettingsDataConnectorInboundDataPipelineListIndexRoute
  '/settings/data-connector/inbound/data-pipeline/add': typeof StaffSettingsDataConnectorInboundDataPipelineAddIndexRoute
  '/settings/data-connector/outbound/data-pipeline/': typeof StaffSettingsDataConnectorOutboundDataPipelineListIndexRoute
  '/settings/data-connector/outbound/data-pipeline/add': typeof StaffSettingsDataConnectorOutboundDataPipelineAddIndexRoute
  '/settings/permission-and-roles/category-permissions/$id': typeof StaffSettingsPermissionAndRolesDetailCategoryPermissionsIdIndexRoute
  '/settings/permission-and-roles/people-groups/$id': typeof StaffSettingsPermissionAndRolesDetailPeopleGroupsIdIndexRoute
  '/settings/permission-and-roles/product-permissions/$id': typeof StaffSettingsPermissionAndRolesDetailProductPermissionsIdIndexRoute
  '/settings/permission-and-roles/roles/$id': typeof StaffSettingsPermissionAndRolesDetailRolesIdIndexRoute
  '/settings/permission-and-roles/category-permissions/new': typeof StaffSettingsPermissionAndRolesFormCategoryPermissionsNewIndexRoute
  '/settings/permission-and-roles/people-groups/new': typeof StaffSettingsPermissionAndRolesFormPeopleGroupsNewIndexRoute
  '/settings/permission-and-roles/product-permissions/new': typeof StaffSettingsPermissionAndRolesFormProductPermissionsNewIndexRoute
  '/settings/permission-and-roles/roles/new': typeof StaffSettingsPermissionAndRolesFormRolesNewIndexRoute
  '/settings/persons/individual': typeof StaffSettingsPersonsListAccountIndividualIndexRoute
  '/settings/persons/staff': typeof StaffSettingsPersonsListAccountStaffIndexRoute
  '/software/$id/contract-and-cost/': typeof StaffSoftwareIdIdContractAndCostContractAndCostIndexRoute
  '/software/$id/settings/integration': typeof StaffSoftwareIdIdSettingsIntegrationIndexRoute
  '/software/$id/settings/role': typeof StaffSoftwareIdIdSettingsRoleIndexRoute
  '/software/$id/settings/status': typeof StaffSoftwareIdIdSettingsStatusIndexRoute
  '/software/alerts/alumni': typeof StaffSoftwareLayoutAlertsAlertsAlumniIndexRoute
  '/software/alerts/inactive-user': typeof StaffSoftwareLayoutAlertsAlertsInactiveUserIndexRoute
  '/software/alerts/no-user': typeof StaffSoftwareLayoutAlertsAlertsNoUserIndexRoute
  '/software/alerts/no-worker': typeof StaffSoftwareLayoutAlertsAlertsNoWorkerIndexRoute
  '/software/alerts/violated-assignment': typeof StaffSoftwareLayoutAlertsAlertsViolatedAssignmentIndexRoute
  '/software/alerts/violated-role': typeof StaffSoftwareLayoutAlertsAlertsViolatedRoleIndexRoute
  '/software/contract-and-cost/cost': typeof StaffSoftwareLayoutContractAndCostContractAndCostCostIndexRoute
  '/software/contract-and-cost/payment': typeof StaffSoftwareLayoutContractAndCostContractAndCostPaymentIndexRoute
  '/software/library/category/$category': typeof StaffSoftwareLayoutLibraryCategoryCategoryIndexRoute
  '/software/library/detail/$softwareLibraryId': typeof StaffSoftwareLayoutLibraryDetailSoftwareLibraryIdIndexRoute
  '/storage-files/folders/$id/files': typeof StaffStorageFilesFoldersIdIdFilesIndexRoute
  '/storage-files/folders/$id/users': typeof StaffStorageFilesFoldersIdIdUsersIndexRoute
  '/time-and-attendance/summary/daily-place': typeof StaffTimeAndAttendanceLayoutListSummaryDailyPlaceIndexRoute
  '/time-and-attendance/summary/monthly-person': typeof StaffTimeAndAttendanceLayoutListSummaryMonthlyPersonIndexRoute
  '/time-and-attendance/summary/monthly-place': typeof StaffTimeAndAttendanceLayoutListSummaryMonthlyPlaceIndexRoute
  '/equipment/items/$id/profile': typeof StaffEquipmentItemsIdDetailProfileIndexLazyRoute
  '/software/$id/contract-and-cost/deal': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealRouteWithChildren
  '/products/$id/scope/$nodeId/value': typeof StacktraceProductsIdScopeNodeIdLayoutValueIndexRoute
  '/attendance-engine/attendance-structures/$structureId/structure': typeof StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutStructureIndexRoute
  '/business-partner/$id/bp-role-info/$bpRole': typeof StaffBusinessPartnerIdLayoutBpRoleInfoLayoutBpRoleIndexRoute
  '/device-catalog/active/$id/contract-and-cost/': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostIndexRoute
  '/devices/contract-and-cost/cost/$period': typeof StaffDevicesListContractAndCostContractAndCostCostPeriodIndexRoute
  '/devices/contract-and-cost/deal/': typeof StaffDevicesListContractAndCostContractAndCostDealDealIndexRoute
  '/devices/contract-and-cost/payment/$period': typeof StaffDevicesListContractAndCostContractAndCostPaymentPeriodIndexRoute
  '/it-operation-core/operation-instances/$instanceId/data': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDataIndexRoute
  '/it-operation-core/operation-instances/$instanceId/detail': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDetailIndexRoute
  '/it-operation-core/operation-instances/$instanceId/operation-activity': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutOperationActivityIndexRoute
  '/licenses/$id/service-plans/$licenseServiceId/accounts': typeof StaffLicensesIdServicePlansLicenseServiceIdDetailAccountsIndexRoute
  '/payroll-engine/payroll-structures/$structureId/structure': typeof StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutStructureIndexRoute
  '/payroll/contract-and-cost/cost/$period': typeof StaffPayrollLayoutContractAndCostContractAndCostCostPeriodIndexRoute
  '/payroll/contract-and-cost/payment/$period': typeof StaffPayrollLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute
  '/settings/permission-and-roles/category-permissions/$id/edit': typeof StaffSettingsPermissionAndRolesFormCategoryPermissionsIdEditIndexRoute
  '/settings/permission-and-roles/people-groups/$id/edit': typeof StaffSettingsPermissionAndRolesFormPeopleGroupsIdEditIndexRoute
  '/settings/permission-and-roles/product-permissions/$id/edit': typeof StaffSettingsPermissionAndRolesFormProductPermissionsIdEditIndexRoute
  '/settings/permission-and-roles/roles/$id/edit': typeof StaffSettingsPermissionAndRolesFormRolesIdEditIndexRoute
  '/software/$id/contract-and-cost/cost': typeof StaffSoftwareIdIdContractAndCostContractAndCostCostIndexRoute
  '/software/$id/contract-and-cost/payment': typeof StaffSoftwareIdIdContractAndCostContractAndCostPaymentIndexRoute
  '/software/contract-and-cost/cost/$period': typeof StaffSoftwareLayoutContractAndCostContractAndCostCostPeriodIndexRoute
  '/software/contract-and-cost/deal/': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealIndexRoute
  '/software/contract-and-cost/payment/$period': typeof StaffSoftwareLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute
  '/software/library/category/$category/search': typeof StaffSoftwareLayoutLibraryCategoryCategorySearchIndexRoute
  '/software/marketplace/$id/install/finish': typeof StaffSoftwareLayoutMarketplaceIdInstallFinishIndexRoute
  '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren
  '/device-catalog/active/$id/contract-and-cost/deal': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealRouteWithChildren
  '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren
  '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren
  '/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId': typeof StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailRouteWithChildren
  '/individual/certifications/base-certifications/$id/': typeof IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutIndexIndexRoute
  '/individual/certifications/handling-certifications/$id/': typeof IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutIndexIndexRoute
  '/individual/certifications/specialty-certifications/$id/': typeof IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutIndexIndexRoute
  '/individual/task/$id/form/$formId': typeof IndividualIndividualTaskIdOperationPackageCommonFormFormIdIndexRoute
  '/device-catalog/active/$id/contract-and-cost/cost': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostCostIndexRoute
  '/device-catalog/active/$id/contract-and-cost/payment': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostPaymentIndexRoute
  '/devices/contract-and-cost/deal/all': typeof StaffDevicesListContractAndCostContractAndCostDealDealAllIndexRoute
  '/devices/contract-and-cost/deal/contract': typeof StaffDevicesListContractAndCostContractAndCostDealDealContractIndexRoute
  '/devices/contract-and-cost/deal/estimate': typeof StaffDevicesListContractAndCostContractAndCostDealDealEstimateIndexRoute
  '/devices/contract-and-cost/deal/order': typeof StaffDevicesListContractAndCostContractAndCostDealDealOrderIndexRoute
  '/devices/contract-and-cost/deal/payment': typeof StaffDevicesListContractAndCostContractAndCostDealDealPaymentIndexRoute
  '/devices/contract-and-cost/deal/vendor-invoice': typeof StaffDevicesListContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute
  '/person/$id/certifications/base-certifications/$personCertificationInformationId/': typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
  '/person/$id/certifications/handling-certifications/$personCertificationInformationId/': typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
  '/person/$id/certifications/specialty-certifications/$personCertificationInformationId/': typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
  '/settings/data-connector/inbound/aggregate-data-pipeline/$id/basic-info': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailBasicInfoIndexRoute
  '/settings/data-connector/inbound/aggregate-data-pipeline/$id/execution-plan': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailExecutionPlanIndexRoute
  '/settings/data-connector/inbound/aggregate-data-pipeline/$id/priority-setting': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailPrioritySettingIndexRoute
  '/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailTasksIndexRoute
  '/settings/data-connector/inbound/data-pipeline/$id/basic-settings': typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailBasicSettingsIndexRoute
  '/settings/data-connector/inbound/data-pipeline/$id/data-link-settings': typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailDataLinkSettingsIndexRoute
  '/settings/data-connector/inbound/data-pipeline/$id/execution-plan': typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailExecutionPlanIndexRoute
  '/settings/data-connector/inbound/data-pipeline/$id/execution-results': typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailExecutionResultsIndexRoute
  '/settings/data-connector/outbound/data-pipeline/$id/basic-settings': typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailBasicSettingsIndexRoute
  '/settings/data-connector/outbound/data-pipeline/$id/data-link-settings': typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailDataLinkSettingsIndexRoute
  '/settings/data-connector/outbound/data-pipeline/$id/execution-plan': typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailExecutionPlanIndexRoute
  '/settings/data-connector/outbound/data-pipeline/$id/execution-results': typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailExecutionResultsIndexRoute
  '/software/$id/contract-and-cost/cost/$period': typeof StaffSoftwareIdIdContractAndCostContractAndCostCostPeriodIndexRoute
  '/software/$id/contract-and-cost/deal/': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealIndexRoute
  '/software/$id/contract-and-cost/payment/$period': typeof StaffSoftwareIdIdContractAndCostContractAndCostPaymentPeriodIndexRoute
  '/software/contract-and-cost/deal/all': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealAllIndexRoute
  '/software/contract-and-cost/deal/contract': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealContractIndexRoute
  '/software/contract-and-cost/deal/estimate': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealEstimateIndexRoute
  '/software/contract-and-cost/deal/order': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealOrderIndexRoute
  '/software/contract-and-cost/deal/payment': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealPaymentIndexRoute
  '/software/contract-and-cost/deal/vendor-invoice': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute
  '/attendance-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': typeof StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren
  '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/': typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  '/device-catalog/active/$id/contract-and-cost/cost/$period': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostCostPeriodIndexRoute
  '/device-catalog/active/$id/contract-and-cost/deal/': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealIndexRoute
  '/device-catalog/active/$id/contract-and-cost/payment/$period': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute
  '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/': typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/': typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  '/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdTasksTaskIdChunksIndexRoute
  '/software/$id/contract-and-cost/deal/all': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealAllIndexRoute
  '/software/$id/contract-and-cost/deal/contract': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealContractIndexRoute
  '/software/$id/contract-and-cost/deal/estimate': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealEstimateIndexRoute
  '/software/$id/contract-and-cost/deal/order': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealOrderIndexRoute
  '/software/$id/contract-and-cost/deal/payment': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealPaymentIndexRoute
  '/software/$id/contract-and-cost/deal/vendor-invoice': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute
  '/attendance-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/': typeof StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data': typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
  '/device-catalog/active/$id/contract-and-cost/deal/all': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealAllIndexRoute
  '/device-catalog/active/$id/contract-and-cost/deal/contract': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealContractIndexRoute
  '/device-catalog/active/$id/contract-and-cost/deal/estimate': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealEstimateIndexRoute
  '/device-catalog/active/$id/contract-and-cost/deal/order': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealOrderIndexRoute
  '/device-catalog/active/$id/contract-and-cost/deal/payment': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealPaymentIndexRoute
  '/device-catalog/active/$id/contract-and-cost/deal/vendor-invoice': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute
  '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data': typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
  '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data': typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
  '/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/chunks': typeof StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailChunksIndexRoute
  '/attendance-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data': typeof StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
  '/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/$chunkId/result': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdTasksTaskIdChunksChunkIdResultIndexRoute
  '/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/chunks/$chunkId/result': typeof StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdChunksChunkIdResultIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof StaffRouteWithChildren
  '/planning-operations-core': typeof StacktracePlanningOperationsCoreRoute
  '/product-planning-core': typeof StacktraceProductPlanningCoreRoute
  '/qa-operations-core': typeof StacktraceQaOperationsCoreRoute
  '/apps': typeof StaffAppsRouteWithChildren
  '/id-managements': typeof StaffIdManagementsRouteWithChildren
  '/me': typeof MeIndexRoute
  '/development-tickets/import-csv': typeof StacktraceDevelopmentTicketsImportCsvRouteRoute
  '/issues/import-csv': typeof StacktraceIssuesImportCsvRouteRoute
  '/values/import-csv': typeof StacktraceValuesImportCsvRouteRoute
  '/it-operation-core/device-inventory': typeof StaffItOperationCoreDeviceInventoryRouteRouteWithChildren
  '/places/import-csv': typeof StaffPlacesImportCsvRouteRoute
  '/individual': typeof IndividualIndividualIndexRoute
  '/issues': typeof StacktraceIssuesLayoutIndexRoute
  '/product-roadmap': typeof StacktraceProductRoadmapLayoutIndexRoute
  '/test-sets': typeof StacktraceTestSetsLayoutIndexRoute
  '/test-suites': typeof StacktraceTestSuitesLayoutIndexRoute
  '/values': typeof StacktraceValuesLayoutIndexRoute
  '/accesses': typeof StaffAccessesLayoutIndexRoute
  '/apps/$': typeof StaffAppsSplatRoute
  '/attendance-core': typeof StaffAttendanceCoreLayoutIndexRoute
  '/attendance-engine': typeof StaffAttendanceEngineLayoutIndexRoute
  '/attendances': typeof StaffAttendancesLayoutIndexRoute
  '/business-operation-events': typeof StaffBusinessOperationEventsListIndexRoute
  '/business-partner': typeof StaffBusinessPartnerListIndexRoute
  '/certification': typeof StaffCertificationListIndexRouteRoute
  '/contract': typeof StaffContractListIndexRoute
  '/contractor-core': typeof StaffContractorCorePackagesIndexRoute
  '/contractor-core/anchor-date': typeof StaffContractorCoreAnchorDateRoute
  '/contractor-core/contract-targets': typeof StaffContractorCoreContractTargetsRoute
  '/contractor-core/person-targets': typeof StaffContractorCorePersonTargetsRoute
  '/deal': typeof StaffDealListIndexRoute
  '/devices': typeof StaffDevicesListIndexRouteLazyRoute
  '/equipment': typeof StaffEquipmentLayoutIndexRoute
  '/fleets': typeof StaffFleetsLayoutListIndexRoute
  '/ga-operation-core': typeof StaffGaOperationCorePackagesIndexRoute
  '/id-managements/$': typeof StaffIdManagementsSplatRoute
  '/ids': typeof StaffIdsLayoutIndexRoute
  '/it-operation-core': typeof StaffItOperationCoreIndexRoute
  '/it-operation-core/anchor-date': typeof StaffItOperationCoreAnchorDateRoute
  '/it-operation-core/self-report-confirmation': typeof StaffItOperationCoreSelfReportConfirmationRoute
  '/labor-core': typeof StaffLaborCorePackagesIndexRoute
  '/labor-core/anchor-date': typeof StaffLaborCoreAnchorDateRoute
  '/labor-core/contract-targets': typeof StaffLaborCoreContractTargetsRoute
  '/labor-core/government-application-confirmation': typeof StaffLaborCoreGovernmentApplicationConfirmationRoute
  '/labor-core/person-targets': typeof StaffLaborCorePersonTargetsRoute
  '/labor-core/year-end-adjustment-confirmation': typeof StaffLaborCoreYearEndAdjustmentConfirmationRoute
  '/licenses': typeof StaffLicensesListIndexRouteRoute
  '/marketplace': typeof StaffMarketplaceStoreRouteWithChildren
  '/networks': typeof StaffNetworksLayoutIndexRoute
  '/organization': typeof StaffOrganizationIndexRoute
  '/payroll-core': typeof StaffPayrollCoreLayoutIndexRoute
  '/payroll-engine': typeof StaffPayrollEngineLayoutIndexRoute
  '/payroll': typeof StaffPayrollLayoutIndexRoute
  '/people': typeof StaffPeopleListIndexRouteLazyRoute
  '/places': typeof StaffPlacesLayoutIndexRoute
  '/public-ids': typeof StaffPublicIdsListIndexRoute
  '/software': typeof StaffSoftwareLayoutIndexRouteLazyRoute
  '/starlinks': typeof StaffStarlinksLayoutIndexRoute
  '/storage-files': typeof StaffStorageFilesListIndexRoute
  '/supplier': typeof StaffSupplierListIndexRoute
  '/time-and-attendance': typeof StaffTimeAndAttendanceLayoutIndexRoute
  '/labor-core/group-name': typeof StaffLaborCoreGroupNameLazyRoute
  '/chat': typeof ChatChatIndexRoute
  '/cockpit-mock': typeof CockpitMockCockpitMockIndexRoute
  '/development-tickets': typeof StacktraceDevelopmentTicketsIndexRoute
  '/production': typeof StacktraceProductionIndexRoute
  '/products': typeof StacktraceProductsIndexRoute
  '/test-assets': typeof StacktraceTestAssetsIndexRoute
  '/cockpit': typeof StaffCockpitIndexRoute
  '/settings': typeof StaffSettingsIndexRoute
  '/account/sso': typeof AccountSsoIndexRoute
  '/auth/password-reset': typeof AuthPasswordResetIndexRoute
  '/auth/sign-in': typeof AuthSignInIndexRoute
  '/oauth2/consent': typeof Oauth2ConsentIndexRoute
  '/oauth2/error': typeof Oauth2ErrorIndexRoute
  '/oauth2/login': typeof Oauth2LoginIndexRoute
  '/oauth2/logout': typeof Oauth2LogoutIndexRoute
  '/app-integrations/import-csv/$id': typeof StaffAppIntegrationsImportCsvIdRouteRoute
  '/business-partner/import-csv/corporation': typeof StaffBusinessPartnerImportCsvCorporationRouteRoute
  '/business-partner/import-csv/individual': typeof StaffBusinessPartnerImportCsvIndividualRouteRoute
  '/devices/import-csv/$deviceType': typeof StaffDevicesImportCsvDeviceTypeRouteRoute
  '/person/import-csv/$workerType': typeof StaffPersonImportCsvWorkerTypeRouteRoute
  '/public-ids/import-csv/$publicIdType': typeof StaffPublicIdsImportCsvPublicIdTypeRouteRoute
  '/software/$id/import-csv': typeof StaffSoftwareIdImportCsvRouteRoute
  '/development-tickets/$ticketId': typeof StacktraceDevelopmentTicketsTicketIdLayoutIndexRoute
  '/issues/$id': typeof StacktraceIssuesIdLayoutIndexRoute
  '/product-roadmap/$roadmapId': typeof StacktraceProductRoadmapRoadmapIdLayoutIndexRoute
  '/production/$productionId': typeof StacktraceProductionProductionIdLayoutIndexRoute
  '/products/$id': typeof StacktraceProductsIdLayoutIndexRoute
  '/test-sets/$id': typeof StacktraceTestSetsIdLayoutIndexRoute
  '/test-suites/$id': typeof StacktraceTestSuitesIdLayoutIndexRoute
  '/values/$id': typeof StacktraceValuesIdLayoutIndexRoute
  '/app-integrations/$id': typeof StaffAppIntegrationsIdIdRouteWithChildren
  '/business-operation-events/archive': typeof StaffBusinessOperationEventsListArchiveRoute
  '/business-operation-events/config': typeof StaffBusinessOperationEventsListConfigRoute
  '/business-operation-events/operation-activity': typeof StaffBusinessOperationEventsListOperationActivityRoute
  '/business-operation-events/overview': typeof StaffBusinessOperationEventsListOverviewRoute
  '/business-operation-events/rule-and-policy': typeof StaffBusinessOperationEventsListRuleAndPolicyRoute
  '/business-operation-events/settings': typeof StaffBusinessOperationEventsListSettingsRoute
  '/business-partner/$id': typeof StaffBusinessPartnerIdLayoutIndexIndexRoute
  '/certification/$id': typeof StaffCertificationIdLayoutIndexIndexRoute
  '/contract/$id': typeof StaffContractIdLayoutIndexIndexLazyRoute
  '/deal/$dealId': typeof StaffDealDealIdLayoutIndexIndexRoute
  '/devices/$id': typeof StaffDevicesIdLayoutIndexRoute
  '/devices/alerts': typeof StaffDevicesListAlertsRoute
  '/devices/operation-activity': typeof StaffDevicesListOperationActivityRoute
  '/devices/rule-and-policy': typeof StaffDevicesListRuleAndPolicyRoute
  '/equipment/$id': typeof StaffEquipmentIdLayoutIndexLazyRoute
  '/fleets/$id': typeof StaffFleetsIdLayoutProfileIndexLazyRoute
  '/fleets/alerts': typeof StaffFleetsLayoutAlertsRoute
  '/fleets/overview': typeof StaffFleetsLayoutOverviewRoute
  '/fleets/rule-and-policy': typeof StaffFleetsLayoutRuleAndPolicyRoute
  '/fleets/settings': typeof StaffFleetsLayoutSettingsRoute
  '/it-operation-core/device-inventory/data': typeof StaffItOperationCoreDeviceInventoryDataRoute
  '/it-operation-core/device-inventory/detail': typeof StaffItOperationCoreDeviceInventoryDetailRoute
  '/labor-core/settings/egov-callback': typeof StaffLaborCoreSettingsEgovCallbackRoute
  '/licenses/$id': typeof StaffLicensesIdProfileIndexLazyRoute
  '/networks/$id': typeof StaffNetworksIdLayoutProfileIndexLazyRoute
  '/organization/$id': typeof StaffOrganizationIdLayoutIndexRoute
  '/people/alerts': typeof StaffPeopleListAlertsRoute
  '/people/community': typeof StaffPeopleListCommunityRoute
  '/people/people-graph': typeof StaffPeopleListPeopleGraphRoute
  '/people/rule-and-policy': typeof StaffPeopleListRuleAndPolicyRoute
  '/people/salary-and-payment': typeof StaffPeopleListSalaryAndPaymentRoute
  '/person/$id': typeof StaffPersonIdProfileIndexRouteRoute
  '/places/$id': typeof StaffPlacesIdLayoutProfileIndexLazyRoute
  '/places/overview': typeof StaffPlacesLayoutOverviewRoute
  '/settings/contracting-corporation-profile': typeof StaffSettingsContractingCorporationProfileIndexRoute
  '/settings/permission-and-roles': typeof StaffSettingsPermissionAndRolesIndexRoute
  '/settings/persons': typeof StaffSettingsPersonsListAccountRouteWithChildren
  '/software/$id': typeof StaffSoftwareIdIdIndexRoute
  '/software/integrations': typeof StaffSoftwareLayoutIntegrationsRoute
  '/starlinks/$id': typeof StaffStarlinksIdLayoutOverviewIndexLazyRoute
  '/supplier/$supplierId': typeof StaffSupplierSupplierIdLayoutIndexIndexRoute
  '/users/$userId': typeof StaffUsersUserIdLayoutIdentityIndexRoute
  '/chat/$sessionId': typeof ChatChatSessionIdIndexRoute
  '/chat/new': typeof ChatChatNewIndexRoute
  '/idp-sso/google-workspace': typeof IdpSsoMockIdpSsoGoogleWorkspaceIndexRoute
  '/individual/portal': typeof IndividualIndividualPortalIndexRoute
  '/development-tickets/add-select': typeof StacktraceDevelopmentTicketsAddSelectIndexRoute
  '/development-tickets/add': typeof StacktraceDevelopmentTicketsAddIndexRoute
  '/development-tickets/external-integrations': typeof StacktraceDevelopmentTicketsExternalIntegrationsIndexRoute
  '/issues/add-select': typeof StacktraceIssuesAddSelectIndexRoute
  '/issues/add': typeof StacktraceIssuesAddIndexRoute
  '/issues/external-integrations': typeof StacktraceIssuesExternalIntegrationsIndexRoute
  '/products/add-select': typeof StacktraceProductsAddSelectIndexRoute
  '/products/add': typeof StacktraceProductsAddIndexRoute
  '/values/add-select': typeof StacktraceValuesAddSelectIndexRoute
  '/values/add': typeof StacktraceValuesAddIndexRoute
  '/business-operation-events/$eventInstanceId': typeof StaffBusinessOperationEventsEventInstanceIdIndexRoute
  '/business-partner/add': typeof StaffBusinessPartnerAddIndexRoute
  '/certification/add': typeof StaffCertificationAddIndexRoute
  '/contract/add': typeof StaffContractAddIndexRoute
  '/deal/add': typeof StaffDealAddIndexRoute
  '/device-catalog/add': typeof StaffDeviceCatalogAddIndexRoute
  '/devices/add': typeof StaffDevicesAddIndexRoute
  '/devices/external-it-saas': typeof StaffDevicesExternalItSaasIndexRoute
  '/equipment/add-select': typeof StaffEquipmentAddSelectIndexRoute
  '/equipment/add': typeof StaffEquipmentAddIndexRoute
  '/equipment/import-csv': typeof StaffEquipmentImportCsvIndexRoute
  '/fleets/add-select': typeof StaffFleetsAddSelectIndexRoute
  '/fleets/add': typeof StaffFleetsAddIndexRoute
  '/it-operation-core/device-targets': typeof StaffItOperationCoreDeviceTargetsIndexRoute
  '/it-operation-core/person-targets': typeof StaffItOperationCorePersonTargetsIndexRoute
  '/licenses/add': typeof StaffLicensesAddIndexRoute
  '/marketplace/cart': typeof StaffMarketplaceCartIndexRoute
  '/marketplace/unavailable': typeof StaffMarketplaceUnavailableIndexRoute
  '/networks/add': typeof StaffNetworksAddIndexRoute
  '/organization/plan': typeof StaffOrganizationPlanIndexRoute
  '/person/add-person-certification': typeof StaffPersonAddPersonCertificationIndexRoute
  '/person/add': typeof StaffPersonAddIndexRoute
  '/person/external-hr-saas': typeof StaffPersonExternalHrSaasIndexRoute
  '/places/add-select': typeof StaffPlacesAddSelectIndexRoute
  '/places/add': typeof StaffPlacesAddIndexRoute
  '/public-ids/$id': typeof StaffPublicIdsIdIndexRoute
  '/public-ids/add': typeof StaffPublicIdsAddIndexRoute
  '/software/add': typeof StaffSoftwareAddIndexRoute
  '/auth/invitation/$invitationCode': typeof AuthInvitationInvitationCodeIndexRoute
  '/auth/sign-in/error': typeof AuthSignInErrorIndexRoute
  '/business-partner/alerts': typeof StaffBusinessPartnerListPlaceholdersAlertsRouteRoute
  '/business-partner/contract-and-cost': typeof StaffBusinessPartnerListPlaceholdersContractAndCostRouteRoute
  '/business-partner/operation-activity': typeof StaffBusinessPartnerListPlaceholdersOperationActivityRouteRoute
  '/business-partner/rule-and-policy': typeof StaffBusinessPartnerListPlaceholdersRuleAndPolicyRouteRoute
  '/business-partner/settings': typeof StaffBusinessPartnerListPlaceholdersSettingsRouteRoute
  '/certification/alerts': typeof StaffCertificationListPlaceholdersAlertsRouteRoute
  '/certification/operation-activity': typeof StaffCertificationListPlaceholdersOperationActivityRouteRoute
  '/certification/overview': typeof StaffCertificationListPlaceholdersOverviewRouteRoute
  '/certification/rule-and-policy': typeof StaffCertificationListPlaceholdersRuleAndPolicyRouteRoute
  '/contract/alerts': typeof StaffContractListPlaceholdersAlertsRouteRoute
  '/contract/contract-and-cost': typeof StaffContractListPlaceholdersContractAndCostRouteRoute
  '/contract/operation-activity': typeof StaffContractListPlaceholdersOperationActivityRouteRoute
  '/contract/overview': typeof StaffContractListPlaceholdersOverviewRouteRoute
  '/contract/people': typeof StaffContractListPlaceholdersPeopleRouteRoute
  '/deal/$dealId/flow': typeof StaffDealDealIdLayoutFlowRouteRoute
  '/deal/$dealId/structure': typeof StaffDealDealIdLayoutStructureRouteRoute
  '/software/marketplace/$id': typeof StaffSoftwareLayoutMarketplaceIdRouteRouteWithChildren
  '/supplier/$supplierId/files': typeof StaffSupplierSupplierIdLayoutFilesRouteRoute
  '/supplier/$supplierId/rules-and-policy': typeof StaffSupplierSupplierIdLayoutRulesAndPolicyRouteRoute
  '/supplier/$supplierId/settings': typeof StaffSupplierSupplierIdLayoutSettingsRouteRoute
  '/supplier/alerts': typeof StaffSupplierListPlaceholdersAlertsRouteRoute
  '/supplier/contract-and-cost': typeof StaffSupplierListPlaceholdersContractAndCostRouteRoute
  '/supplier/operation-activity': typeof StaffSupplierListPlaceholdersOperationActivityRouteRoute
  '/supplier/overview': typeof StaffSupplierListPlaceholdersOverviewRouteRoute
  '/supplier/rule-and-policy': typeof StaffSupplierListPlaceholdersRuleAndPolicyRouteRoute
  '/individual/my-profile': typeof IndividualIndividualProfileMyProfileLayoutIndexRouteRoute
  '/individual/task/$id/approval-dialog': typeof IndividualIndividualTaskIdApprovalDialogRoute
  '/accesses/contract-and-cost': typeof StaffAccessesLayoutPlaceholdersContractAndCostRoute
  '/accesses/overview': typeof StaffAccessesLayoutPlaceholdersOverviewRoute
  '/accesses/software': typeof StaffAccessesLayoutPlaceholdersSoftwareRoute
  '/app-integrations/$id/$': typeof StaffAppIntegrationsIdIdSplatRoute
  '/business-partner/add/$businessPartnerType/completed': typeof StaffBusinessPartnerAddBusinessPartnerTypeCompletedRoute
  '/certification/add/$certificationKind/completed': typeof StaffCertificationAddCertificationKindCompletedRoute
  '/certification/handling-certification/$id': typeof StaffCertificationHandlingCertificationIdLayoutIndexIndexRoute
  '/certification/specialty-certification/$id': typeof StaffCertificationSpecialtyCertificationIdLayoutIndexIndexRoute
  '/contract/add/subscription/completed': typeof StaffContractAddSubscriptionCompletedRoute
  '/deal/add/$direction/completed': typeof StaffDealAddDirectionCompletedRoute
  '/device-catalog/active/$id': typeof StaffDeviceCatalogActiveIdLayoutRouteWithChildren
  '/device-catalog/add/$deviceType/completed': typeof StaffDeviceCatalogAddDeviceTypeCompletedRoute
  '/device-catalog/draft/$id': typeof StaffDeviceCatalogDraftIdLayoutRouteWithChildren
  '/devices/contract-and-cost': typeof StaffDevicesListContractAndCostContractAndCostIndexRoute
  '/devices/add/$deviceType/completed': typeof StaffDevicesAddDeviceTypeCompletedRoute
  '/equipment/overview': typeof StaffEquipmentLayoutPlaceholdersOverviewRoute
  '/equipment/rule-and-policy': typeof StaffEquipmentLayoutPlaceholdersRuleAndPolicyRoute
  '/equipment/settings': typeof StaffEquipmentLayoutSettingsIndexRoute
  '/equipment/items/$id': typeof StaffEquipmentItemsIdDetailIndexRoute
  '/ids/alerts': typeof StaffIdsLayoutPlaceholdersAlertsRoute
  '/ids/group-id': typeof StaffIdsLayoutPlaceholdersGroupIdRoute
  '/ids/operation-activity': typeof StaffIdsLayoutPlaceholdersOperationActivityRoute
  '/ids/overview': typeof StaffIdsLayoutPlaceholdersOverviewRoute
  '/ids/rule-and-policy': typeof StaffIdsLayoutPlaceholdersRuleAndPolicyRoute
  '/ids/settings': typeof StaffIdsLayoutPlaceholdersSettingsRoute
  '/ids/group-id/$id': typeof StaffIdsGroupIdIdIdIndexRoute
  '/it-operation-core/in-house-packages/$packageId': typeof StaffItOperationCoreRootInHousePackagesPackageIdRouteWithChildren
  '/it-operation-core/packages/$packageId': typeof StaffItOperationCoreRootPackagesPackageIdRoute
  '/labor-core/settings/profile/$profileId': typeof StaffLaborCoreSettingsProfileProfileIdRoute
  '/licenses/add/$allocationType/completed': typeof StaffLicensesAddAllocationTypeCompletedRoute
  '/marketplace/sent-orders/$orderId': typeof StaffMarketplaceSentOrdersOrderIdLayoutIndexRoute
  '/networks/alerts': typeof StaffNetworksLayoutPlaceholdersAlertsRoute
  '/networks/contract-and-cost': typeof StaffNetworksLayoutPlaceholdersContractAndCostRoute
  '/networks/operation-activity': typeof StaffNetworksLayoutPlaceholdersOperationActivityRoute
  '/networks/overview': typeof StaffNetworksLayoutPlaceholdersOverviewRoute
  '/networks/rule-and-policy': typeof StaffNetworksLayoutPlaceholdersRuleAndPolicyRoute
  '/networks/settings': typeof StaffNetworksLayoutPlaceholdersSettingsRoute
  '/payroll/contract-and-cost': typeof StaffPayrollLayoutContractAndCostContractAndCostIndexRoute
  '/person/add-person-certification/$certificationKind/completed': typeof StaffPersonAddPersonCertificationCertificationKindCompletedRoute
  '/person/add/$workerType/completed': typeof StaffPersonAddWorkerTypeCompletedRoute
  '/person/alumni/$id': typeof StaffPersonAlumniIdProfileIndexRouteRoute
  '/places/alerts': typeof StaffPlacesLayoutPlaceholdersAlertsRoute
  '/places/contract-and-cost': typeof StaffPlacesLayoutPlaceholdersContractAndCostRoute
  '/places/operation-activity': typeof StaffPlacesLayoutPlaceholdersOperationActivityRoute
  '/places/people': typeof StaffPlacesLayoutPlaceholdersPeopleRoute
  '/places/rule-and-policy': typeof StaffPlacesLayoutPlaceholdersRuleAndPolicyRoute
  '/places/store': typeof StaffPlacesLayoutPlaceholdersStoreRoute
  '/profile/device/$id/$': typeof StaffProfileDeviceIdSplatRoute
  '/software/$id/groups': typeof StaffSoftwareIdIdGroupsRoute
  '/software/$id/profiles': typeof StaffSoftwareIdIdProfilesRoute
  '/software/alerts': typeof StaffSoftwareLayoutAlertsAlertsIndexRoute
  '/software/contract-and-cost': typeof StaffSoftwareLayoutContractAndCostContractAndCostIndexRoute
  '/starlinks/billing-and-cost': typeof StaffStarlinksLayoutPlaceholdersBillingAndCostRoute
  '/starlinks/marketplace': typeof StaffStarlinksLayoutPlaceholdersMarketplaceRoute
  '/starlinks/operation-activity': typeof StaffStarlinksLayoutPlaceholdersOperationActivityRoute
  '/storage-files/files/$id': typeof StaffStorageFilesFilesIdIdIndexLazyRoute
  '/storage-files/folders/$id': typeof StaffStorageFilesFoldersIdIdIndexLazyRoute
  '/individual/approval-tasks': typeof IndividualIndividualTasksApprovalTasksIndexRoute
  '/individual/operation-tasks': typeof IndividualIndividualTasksOperationTasksIndexRoute
  '/individual/request-tasks': typeof IndividualIndividualTasksRequestTasksIndexRoute
  '/individual/operation-package/$id': typeof IndividualIndividualOperationPackageIdIndexRoute
  '/individual/portal/approvals': typeof IndividualIndividualPortalApprovalsIndexRoute
  '/individual/portal/lookup': typeof IndividualIndividualPortalLookupIndexRoute
  '/individual/portal/requests': typeof IndividualIndividualPortalRequestsIndexRoute
  '/individual/task/$id': typeof IndividualIndividualTaskIdIndexRoute
  '/issues/overview': typeof StacktraceIssuesLayoutOverviewIndexRoute
  '/accesses/alerts': typeof StaffAccessesLayoutAlertsIndexRoute
  '/accesses/list': typeof StaffAccessesLayoutListIndexRoute
  '/accesses/settings': typeof StaffAccessesLayoutSettingsIndexRoute
  '/attendance-core/archive': typeof StaffAttendanceCoreLayoutArchiveIndexRoute
  '/attendance-core/config': typeof StaffAttendanceCoreLayoutConfigIndexRoute
  '/attendance-core/dashboard': typeof StaffAttendanceCoreLayoutDashboardIndexRoute
  '/attendance-core/operation-packages': typeof StaffAttendanceCoreLayoutOperationPackagesIndexRoute
  '/attendance-engine/attendance-structures': typeof StaffAttendanceEngineLayoutAttendanceStructuresIndexRoute
  '/attendance-engine/attendance-units': typeof StaffAttendanceEngineLayoutAttendanceUnitsIndexRoute
  '/attendance-engine/items': typeof StaffAttendanceEngineLayoutItemsIndexRoute
  '/attendance-engine/logic-components': typeof StaffAttendanceEngineLayoutLogicComponentsIndexRoute
  '/attendances/alerts': typeof StaffAttendancesLayoutAlertsIndexRoute
  '/attendances/clocking-records': typeof StaffAttendancesLayoutClockingRecordsIndexRoute
  '/attendances/employees': typeof StaffAttendancesLayoutEmployeesIndexRoute
  '/attendances/operation-activity': typeof StaffAttendancesLayoutOperationActivityIndexRoute
  '/attendances/overview': typeof StaffAttendancesLayoutOverviewIndexRoute
  '/attendances/rule-and-policy': typeof StaffAttendancesLayoutRuleAndPolicyIndexRoute
  '/attendances/settings': typeof StaffAttendancesLayoutSettingsIndexRoute
  '/business-partner/terminated': typeof StaffBusinessPartnerListTerminatedIndexRoute
  '/business-partner/add/$businessPartnerType': typeof StaffBusinessPartnerAddBusinessPartnerTypeIndexRoute
  '/certification/people': typeof StaffCertificationListPeopleIndexRoute
  '/certification/settings': typeof StaffCertificationListSettingsIndexRoute
  '/certification/add/$certificationKind': typeof StaffCertificationAddCertificationKindIndexRoute
  '/cockpit/approval/$id': typeof StaffCockpitApprovalIdIndexRoute
  '/cockpit/task/$taskId': typeof StaffCockpitTaskTaskIdIndexRoute
  '/contract/add/subscription': typeof StaffContractAddSubscriptionIndexRoute
  '/contract/import-csv/$contractType': typeof StaffContractImportCsvContractTypeIndexRoute
  '/contractor-core/archives': typeof StaffContractorCorePackagesArchivesIndexRoute
  '/contractor-core/configs': typeof StaffContractorCorePackagesConfigsIndexRoute
  '/contractor-core/config/$patternId': typeof StaffContractorCoreConfigPatternIdIndexRoute
  '/deal/add/$direction': typeof StaffDealAddDirectionIndexRoute
  '/device-catalog/add/$deviceType': typeof StaffDeviceCatalogAddDeviceTypeIndexRoute
  '/devices/inventories': typeof StaffDevicesListInventoriesIndexRoute
  '/devices/inventory': typeof StaffDevicesListInventoryIndexRoute
  '/devices/people': typeof StaffDevicesListPeopleIndexRoute
  '/devices/settings': typeof StaffDevicesListSettingsIndexRoute
  '/devices/add/$deviceType': typeof StaffDevicesAddDeviceTypeIndexRoute
  '/devices/add/catalog': typeof StaffDevicesAddCatalogIndexRoute
  '/equipment/alerts': typeof StaffEquipmentLayoutAlertsIndexRoute
  '/equipment/items': typeof StaffEquipmentLayoutItemsIndexRoute
  '/ga-operation-core/archives': typeof StaffGaOperationCorePackagesArchivesIndexRoute
  '/ga-operation-core/configs': typeof StaffGaOperationCorePackagesConfigsIndexRoute
  '/ga-operation-core/config/$patternId': typeof StaffGaOperationCoreConfigPatternIdIndexRoute
  '/ids/people': typeof StaffIdsLayoutPeopleIndexRoute
  '/ids/group-id/add': typeof StaffIdsGroupIdAddIndexRoute
  '/it-operation-core/archives': typeof StaffItOperationCoreRootArchivesIndexRoute
  '/it-operation-core/config': typeof StaffItOperationCoreRootConfigIndexRoute
  '/it-operation-core/in-house-packages': typeof StaffItOperationCoreRootInHousePackagesIndexRoute
  '/it-operation-core/packages': typeof StaffItOperationCoreRootPackagesIndexRoute
  '/it-operation-core/config/$patternId': typeof StaffItOperationCoreConfigPatternIdIndexRoute
  '/it-operation-core/self-report-patterns/$patternId': typeof StaffItOperationCoreSelfReportPatternsPatternIdIndexRoute
  '/labor-core/archives': typeof StaffLaborCorePackagesArchivesIndexRoute
  '/labor-core/configs': typeof StaffLaborCorePackagesConfigsIndexRoute
  '/labor-core/settings': typeof StaffLaborCorePackagesSettingsIndexRoute
  '/labor-core/config/$patternId': typeof StaffLaborCoreConfigPatternIdIndexRoute
  '/licenses/alerts': typeof StaffLicensesListAlertsIndexRoute
  '/licenses/contract-and-cost': typeof StaffLicensesListContractAndCostIndexRoute
  '/licenses/inventory': typeof StaffLicensesListInventoryIndexRoute
  '/licenses/operation-activity': typeof StaffLicensesListOperationActivityIndexRoute
  '/licenses/people': typeof StaffLicensesListPeopleIndexRoute
  '/licenses/rule-and-policy': typeof StaffLicensesListRuleAndPolicyIndexRoute
  '/licenses/settings': typeof StaffLicensesListSettingsIndexRoute
  '/licenses/add/$allocationType': typeof StaffLicensesAddAllocationTypeIndexRoute
  '/marketplace/sales-orders/$orderId': typeof StaffMarketplaceSalesOrdersOrderIdIndexRoute
  '/organization/alert': typeof StaffOrganizationListAlertIndexRoute
  '/organization/chart': typeof StaffOrganizationListChartIndexRoute
  '/organization/cost': typeof StaffOrganizationListCostIndexRoute
  '/organization/history': typeof StaffOrganizationListHistoryIndexRoute
  '/organization/rule-policy': typeof StaffOrganizationListRulePolicyIndexRoute
  '/organization/settings': typeof StaffOrganizationListSettingsIndexRoute
  '/organization/plan/$id': typeof StaffOrganizationPlanIdIndexRoute
  '/organization/plan/create': typeof StaffOrganizationPlanCreateIndexRoute
  '/payroll-core/archive': typeof StaffPayrollCoreLayoutArchiveIndexRoute
  '/payroll-core/config': typeof StaffPayrollCoreLayoutConfigIndexRoute
  '/payroll-core/dashboard': typeof StaffPayrollCoreLayoutDashboardIndexRoute
  '/payroll-core/operation-packages': typeof StaffPayrollCoreLayoutOperationPackagesIndexRoute
  '/payroll-core/person-targets': typeof StaffPayrollCoreLayoutPersonTargetsIndexRoute
  '/payroll-engine/items': typeof StaffPayrollEngineLayoutItemsIndexRoute
  '/payroll-engine/logic-components': typeof StaffPayrollEngineLayoutLogicComponentsIndexRoute
  '/payroll-engine/payroll-structures': typeof StaffPayrollEngineLayoutPayrollStructuresIndexRoute
  '/payroll-engine/payroll-units': typeof StaffPayrollEngineLayoutPayrollUnitsIndexRoute
  '/payroll/alerts': typeof StaffPayrollLayoutAlertsIndexRoute
  '/payroll/overview': typeof StaffPayrollLayoutOverviewIndexRoute
  '/payroll/pay-slips': typeof StaffPayrollLayoutPaySlipsIndexRoute
  '/payroll/rule-and-policy': typeof StaffPayrollLayoutRuleAndPolicyIndexRoute
  '/payroll/settings': typeof StaffPayrollLayoutSettingsIndexRoute
  '/people/alumni': typeof StaffPeopleListAlumniIndexRoute
  '/people/operation-activity': typeof StaffPeopleListOperationActivityIndexRoute
  '/people/settings': typeof StaffPeopleListSettingsIndexRoute
  '/people/workforce': typeof StaffPeopleListWorkforceIndexRoute
  '/person/add-person-certification/$certificationKind': typeof StaffPersonAddPersonCertificationCertificationKindIndexRoute
  '/person/add/$workerType': typeof StaffPersonAddWorkerTypeIndexRoute
  '/person/automap-ingester/$workerType': typeof StaffPersonAutomapIngesterWorkerTypeIndexRoute
  '/places/settings': typeof StaffPlacesLayoutSettingsIndexRoute
  '/profile/device/$id': typeof StaffProfileDeviceIdIndexRoute
  '/public-ids/$id/details': typeof StaffPublicIdsIdDetailsIndexRoute
  '/public-ids/$id/files': typeof StaffPublicIdsIdFilesIndexRoute
  '/public-ids/alerts': typeof StaffPublicIdsListAlertsIndexRoute
  '/public-ids/members': typeof StaffPublicIdsListMembersIndexRoute
  '/public-ids/operation-activity': typeof StaffPublicIdsListOperationActivityIndexRoute
  '/public-ids/registry': typeof StaffPublicIdsListRegistryIndexRoute
  '/public-ids/rules-and-policies': typeof StaffPublicIdsListRulesAndPoliciesIndexRoute
  '/public-ids/settings': typeof StaffPublicIdsListSettingsIndexRoute
  '/settings/data-connector/inbound': typeof StaffSettingsDataConnectorInboundIndexRoute
  '/settings/data-connector/outbound': typeof StaffSettingsDataConnectorOutboundIndexRoute
  '/settings/persons/invite': typeof StaffSettingsPersonsInviteIndexRoute
  '/software/library': typeof StaffSoftwareLayoutLibraryIndexRoute
  '/software/operation-activity': typeof StaffSoftwareLayoutOperationActivityIndexRoute
  '/software/people': typeof StaffSoftwareLayoutPeopleIndexRoute
  '/software/registry': typeof StaffSoftwareLayoutRegistryIndexRoute
  '/software/rule-and-policy': typeof StaffSoftwareLayoutRuleAndPolicyIndexRoute
  '/software/settings': typeof StaffSoftwareLayoutSettingsIndexRoute
  '/software/add/$type': typeof StaffSoftwareAddTypeIndexRoute
  '/starlinks/alerts': typeof StaffStarlinksLayoutAlertsIndexRoute
  '/starlinks/user-terminals': typeof StaffStarlinksLayoutUserTerminalsIndexRoute
  '/storage-files/files': typeof StaffStorageFilesListFilesIndexRoute
  '/storage-files/folders': typeof StaffStorageFilesListFoldersIndexRoute
  '/storage-files/settings': typeof StaffStorageFilesListSettingsIndexRoute
  '/supplier/settings': typeof StaffSupplierListSettingsIndexRoute
  '/time-and-attendance/attendance-links': typeof StaffTimeAndAttendanceLayoutAttendanceLinksIndexRoute
  '/contract/$id/approval-info': typeof StaffContractIdLayoutPlaceholdersApprovalInfoRouteRoute
  '/contract/$id/history': typeof StaffContractIdLayoutPlaceholdersHistoryRouteRoute
  '/contract/$id/operation-activity': typeof StaffContractIdLayoutPlaceholdersOperationActivityRouteRoute
  '/contract/$id/risk-provisions': typeof StaffContractIdLayoutPlaceholdersRiskProvisionsRouteRoute
  '/contract/$id/rule-and-policy': typeof StaffContractIdLayoutPlaceholdersRuleAndPolicyRouteRoute
  '/products/$id/scope/$nodeId': typeof StacktraceProductsIdScopeNodeIdLayoutIndexRoute
  '/test-suites/$id/test-plan': typeof StacktraceTestSuitesIdLayoutTestPlanLayoutIndexRoute
  '/test-suites/$id/test-review': typeof StacktraceTestSuitesIdLayoutTestReviewLayoutIndexRoute
  '/attendance-engine/attendance-structures/$structureId': typeof StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutIndexRoute
  '/business-partner/$id/bp-role-info': typeof StaffBusinessPartnerIdLayoutBpRoleInfoLayoutIndexRoute
  '/devices/add/catalog/$deviceType/completed': typeof StaffDevicesAddCatalogDeviceTypeCompletedRoute
  '/ids/group-id/add/from-scratch/completed': typeof StaffIdsGroupIdAddFromScratchCompletedRoute
  '/it-operation-core/operation-instances/$instanceId': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdIndexRoute
  '/it-operation-core/in-house-packages/$packageId/start-targets': typeof StaffItOperationCoreRootInHousePackagesPackageIdStartTargetsRoute
  '/licenses/$id/service-plans/$licenseServiceId': typeof StaffLicensesIdServicePlansLicenseServiceIdDetailRouteWithChildren
  '/marketplace/sent-orders/$orderId/activities': typeof StaffMarketplaceSentOrdersOrderIdLayoutActivitiesRoute
  '/payroll-engine/payroll-structures/$structureId': typeof StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutIndexRoute
  '/settings/data-connector/inbound/aggregate-data-pipeline': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineListIndexRoute
  '/settings/data-connector/inbound/data-pipeline': typeof StaffSettingsDataConnectorInboundDataPipelineListIndexRoute
  '/settings/data-connector/outbound/data-pipeline': typeof StaffSettingsDataConnectorOutboundDataPipelineListIndexRoute
  '/software/$id/contract-and-cost': typeof StaffSoftwareIdIdContractAndCostContractAndCostIndexRoute
  '/individual/portal/lookup/clocking-record/alerts': typeof IndividualIndividualPortalLookupClockingRecordAlertsLazyRoute
  '/individual/portal/lookup/clocking-record/files': typeof IndividualIndividualPortalLookupClockingRecordFilesLazyRoute
  '/individual/portal/lookup/clocking-record/overview': typeof IndividualIndividualPortalLookupClockingRecordOverviewLazyRoute
  '/individual/portal/lookup/clocking-record/schedule': typeof IndividualIndividualPortalLookupClockingRecordScheduleLazyRoute
  '/individual/portal/lookup/pay-slip/alerts': typeof IndividualIndividualPortalLookupPaySlipAlertsLazyRoute
  '/individual/portal/lookup/pay-slip/files': typeof IndividualIndividualPortalLookupPaySlipFilesLazyRoute
  '/individual/portal/lookup/pay-slip/history': typeof IndividualIndividualPortalLookupPaySlipHistoryLazyRoute
  '/individual/portal/lookup/pay-slip/overview': typeof IndividualIndividualPortalLookupPaySlipOverviewLazyRoute
  '/attendances/clocking-records/$employeeId/alerts': typeof StaffAttendancesLayoutClockingRecordsEmployeeIdAlertsLazyRoute
  '/attendances/clocking-records/$employeeId/files': typeof StaffAttendancesLayoutClockingRecordsEmployeeIdFilesLazyRoute
  '/attendances/clocking-records/$employeeId/overview': typeof StaffAttendancesLayoutClockingRecordsEmployeeIdOverviewLazyRoute
  '/attendances/clocking-records/$employeeId/schedule': typeof StaffAttendancesLayoutClockingRecordsEmployeeIdScheduleLazyRoute
  '/attendances/clocking-records/$employeeId/settings': typeof StaffAttendancesLayoutClockingRecordsEmployeeIdSettingsLazyRoute
  '/payroll/pay-slips/$employeeId/alerts': typeof StaffPayrollLayoutPaySlipsEmployeeIdAlertsLazyRoute
  '/payroll/pay-slips/$employeeId/files': typeof StaffPayrollLayoutPaySlipsEmployeeIdFilesLazyRoute
  '/payroll/pay-slips/$employeeId/history': typeof StaffPayrollLayoutPaySlipsEmployeeIdHistoryLazyRoute
  '/payroll/pay-slips/$employeeId/overview': typeof StaffPayrollLayoutPaySlipsEmployeeIdOverviewLazyRoute
  '/payroll/pay-slips/$employeeId/settings': typeof StaffPayrollLayoutPaySlipsEmployeeIdSettingsLazyRoute
  '/individual/task/$id/approval': typeof IndividualIndividualTaskIdApprovalIndexRoute
  '/development-tickets/$ticketId/history': typeof StacktraceDevelopmentTicketsTicketIdLayoutHistoryIndexRoute
  '/issues/$id/history': typeof StacktraceIssuesIdLayoutHistoryIndexRoute
  '/product-roadmap/$roadmapId/detail': typeof StacktraceProductRoadmapRoadmapIdLayoutDetailIndexRoute
  '/product-roadmap/$roadmapId/history': typeof StacktraceProductRoadmapRoadmapIdLayoutHistoryIndexRoute
  '/production/$productionId/dev-scope': typeof StacktraceProductionProductionIdLayoutDevScopeIndexRoute
  '/production/$productionId/issue-scope': typeof StacktraceProductionProductionIdLayoutIssueScopeIndexRoute
  '/production/$productionId/product-scope': typeof StacktraceProductionProductionIdLayoutProductScopeIndexRoute
  '/production/$productionId/quality-scope': typeof StacktraceProductionProductionIdLayoutQualityScopeIndexRoute
  '/production/$productionId/value': typeof StacktraceProductionProductionIdLayoutValueIndexRoute
  '/products/$id/product-scope': typeof StacktraceProductsIdLayoutProductScopeIndexRoute
  '/test-sets/$id/conditions': typeof StacktraceTestSetsIdLayoutConditionsIndexRoute
  '/test-sets/$id/target-functions': typeof StacktraceTestSetsIdLayoutTargetFunctionsIndexRoute
  '/test-suites/$id/document': typeof StacktraceTestSuitesIdLayoutDocumentIndexRoute
  '/test-suites/$id/issues': typeof StacktraceTestSuitesIdLayoutIssuesIndexRoute
  '/test-suites/$id/overview': typeof StacktraceTestSuitesIdLayoutOverviewIndexRoute
  '/test-suites/$id/target-functions': typeof StacktraceTestSuitesIdLayoutTargetFunctionsIndexRoute
  '/test-suites/$id/test-set': typeof StacktraceTestSuitesIdLayoutTestSetIndexRoute
  '/values/$id/history': typeof StacktraceValuesIdLayoutHistoryIndexRoute
  '/values/$id/product-scope': typeof StacktraceValuesIdLayoutProductScopeIndexRoute
  '/accesses/list/$traceableAppId': typeof StaffAccessesLayoutListTraceableAppIdIndexRoute
  '/attendance-engine/attendance-units/$unitId': typeof StaffAttendanceEngineLayoutAttendanceUnitsUnitIdIndexRoute
  '/attendance-engine/items/$componentId': typeof StaffAttendanceEngineLayoutItemsComponentIdIndexRoute
  '/attendance-engine/logic-components/$componentId': typeof StaffAttendanceEngineLayoutLogicComponentsComponentIdIndexRoute
  '/business-partner/$id/address-and-contact': typeof StaffBusinessPartnerIdLayoutAddressAndContactIndexRoute
  '/certification/$id/certification-holders': typeof StaffCertificationIdLayoutCertificationHoldersIndexRoute
  '/certification/$id/handling-certifications': typeof StaffCertificationIdLayoutHandlingCertificationsIndexRoute
  '/certification/$id/specialty-certifications': typeof StaffCertificationIdLayoutSpecialtyCertificationsIndexRoute
  '/certification/settings/issuing-organization': typeof StaffCertificationListSettingsIssuingOrganizationIndexRoute
  '/certification/settings/specialty-category-level': typeof StaffCertificationListSettingsSpecialtyCategoryLevelIndexRoute
  '/certification/settings/specialty-category': typeof StaffCertificationListSettingsSpecialtyCategoryIndexRoute
  '/devices/$id/control': typeof StaffDevicesIdLayoutControlIndexRoute
  '/devices/$id/files': typeof StaffDevicesIdLayoutFilesIndexRoute
  '/devices/$id/history': typeof StaffDevicesIdLayoutHistoryIndexRoute
  '/devices/$id/lifecycle': typeof StaffDevicesIdLayoutLifecycleIndexRoute
  '/devices/$id/mdm': typeof StaffDevicesIdLayoutMdmIndexRoute
  '/devices/$id/profile': typeof StaffDevicesIdLayoutProfileIndexRoute
  '/devices/$id/status': typeof StaffDevicesIdLayoutStatusIndexRoute
  '/devices/settings/catalog': typeof StaffDevicesListSettingsCatalogIndexRoute
  '/devices/add/catalog/$deviceType': typeof StaffDevicesAddCatalogDeviceTypeIndexRoute
  '/devices/external-it-saas/$appIntegrationId/preview': typeof StaffDevicesExternalItSaasAppIntegrationIdPreviewIndexRoute
  '/equipment/settings/equipment-items': typeof StaffEquipmentLayoutSettingsEquipmentItemsIndexRoute
  '/equipment/settings/equipment-types': typeof StaffEquipmentLayoutSettingsEquipmentTypesIndexRoute
  '/ids/group-id/add/from-scratch': typeof StaffIdsGroupIdAddFromScratchIndexRoute
  '/licenses/$id/assignments': typeof StaffLicensesIdProfileAssignmentsIndexRoute
  '/licenses/$id/people': typeof StaffLicensesIdProfilePeopleIndexRoute
  '/licenses/$id/rule-and-policy': typeof StaffLicensesIdProfileRuleAndPolicyIndexRoute
  '/licenses/$id/service-plans': typeof StaffLicensesIdProfileServicePlansIndexRoute
  '/marketplace/store/devices': typeof StaffMarketplaceStoreStoreDevicesIndexRoute
  '/marketplace/store/licenses': typeof StaffMarketplaceStoreStoreLicensesIndexRoute
  '/marketplace/store/sales-orders': typeof StaffMarketplaceStoreStoreSalesOrdersIndexRoute
  '/marketplace/store/sent-orders': typeof StaffMarketplaceStoreStoreSentOrdersIndexRoute
  '/marketplace/store/starlinks': typeof StaffMarketplaceStoreStoreStarlinksIndexRoute
  '/organization/$id/history': typeof StaffOrganizationIdLayoutHistoryIndexRoute
  '/organization/plan/$id/add': typeof StaffOrganizationPlanIdAddIndexRoute
  '/organization/plan/$id/transfers': typeof StaffOrganizationPlanIdTransfersIndexRoute
  '/payroll-engine/items/$componentId': typeof StaffPayrollEngineLayoutItemsComponentIdIndexRoute
  '/payroll-engine/logic-components/$componentId': typeof StaffPayrollEngineLayoutLogicComponentsComponentIdIndexRoute
  '/payroll-engine/payroll-units/$unitId': typeof StaffPayrollEngineLayoutPayrollUnitsUnitIdIndexRoute
  '/people/settings/board-member-types': typeof StaffPeopleListSettingsBoardMemberTypesIndexRoute
  '/people/settings/collaborator-types': typeof StaffPeopleListSettingsCollaboratorTypesIndexRoute
  '/people/settings/contract-end-reasons': typeof StaffPeopleListSettingsContractEndReasonsIndexRoute
  '/people/settings/contractor-types': typeof StaffPeopleListSettingsContractorTypesIndexRoute
  '/people/settings/employee-sub-id-names': typeof StaffPeopleListSettingsEmployeeSubIdNamesIndexRoute
  '/people/settings/employment-types': typeof StaffPeopleListSettingsEmploymentTypesIndexRoute
  '/people/settings/grades': typeof StaffPeopleListSettingsGradesIndexRoute
  '/people/settings/health-insurance-associations': typeof StaffPeopleListSettingsHealthInsuranceAssociationsIndexRoute
  '/people/settings/job-competencies': typeof StaffPeopleListSettingsJobCompetenciesIndexRoute
  '/people/settings/job-functions': typeof StaffPeopleListSettingsJobFunctionsIndexRoute
  '/people/settings/job-grades': typeof StaffPeopleListSettingsJobGradesIndexRoute
  '/people/settings/job-levels': typeof StaffPeopleListSettingsJobLevelsIndexRoute
  '/people/settings/job-titles': typeof StaffPeopleListSettingsJobTitlesIndexRoute
  '/people/settings/job-types': typeof StaffPeopleListSettingsJobTypesIndexRoute
  '/people/settings/place-social-insurances': typeof StaffPeopleListSettingsPlaceSocialInsurancesIndexRoute
  '/people/settings/positions': typeof StaffPeopleListSettingsPositionsIndexRoute
  '/people/settings/retirement-reasons': typeof StaffPeopleListSettingsRetirementReasonsIndexRoute
  '/people/settings/work-mode': typeof StaffPeopleListSettingsWorkModeIndexRoute
  '/person/$id/apps': typeof StaffPersonIdProfileAppsIndexRoute
  '/person/$id/contractor-information': typeof StaffPersonIdProfileContractorInformationIndexRoute
  '/person/$id/devices': typeof StaffPersonIdProfileDevicesIndexRoute
  '/person/$id/education-and-qualification': typeof StaffPersonIdProfileEducationAndQualificationIndexRoute
  '/person/$id/employee-information': typeof StaffPersonIdProfileEmployeeInformationIndexRoute
  '/person/$id/equipment': typeof StaffPersonIdProfileEquipmentIndexRoute
  '/person/$id/history': typeof StaffPersonIdProfileHistoryIndexRoute
  '/person/$id/operation-activity': typeof StaffPersonIdProfileOperationActivityIndexRoute
  '/person/$id/personal-information': typeof StaffPersonIdProfilePersonalInformationIndexRoute
  '/person/$id/public-id': typeof StaffPersonIdProfilePublicIdIndexRoute
  '/person/external-hr-saas/$appIntegrationId/preview': typeof StaffPersonExternalHrSaasAppIntegrationIdPreviewIndexRoute
  '/places/$id/administrators': typeof StaffPlacesIdLayoutAdministratorsIndexRoute
  '/places/$id/labor-core': typeof StaffPlacesIdLayoutLaborCoreIndexRoute
  '/places/settings/place-sub-codes': typeof StaffPlacesLayoutSettingsPlaceSubCodesIndexRoute
  '/settings/contracting-corporation-profile/board-member': typeof StaffSettingsContractingCorporationProfileLayoutBoardMemberIndexRoute
  '/settings/contracting-corporation-profile/contact-points': typeof StaffSettingsContractingCorporationProfileLayoutContactPointsIndexRoute
  '/settings/contracting-corporation-profile/corporate-overview': typeof StaffSettingsContractingCorporationProfileLayoutCorporateOverviewIndexRoute
  '/settings/contracting-corporation-profile/group-companies': typeof StaffSettingsContractingCorporationProfileLayoutGroupCompaniesIndexRoute
  '/settings/contracting-corporation-profile/history': typeof StaffSettingsContractingCorporationProfileLayoutHistoryIndexRoute
  '/settings/contracting-corporation-profile/registration': typeof StaffSettingsContractingCorporationProfileLayoutRegistrationIndexRoute
  '/settings/contracting-corporation-profile/shareholders': typeof StaffSettingsContractingCorporationProfileLayoutShareholdersIndexRoute
  '/settings/permission-and-roles/category-permissions': typeof StaffSettingsPermissionAndRolesListCategoryPermissionsIndexRoute
  '/settings/permission-and-roles/people-groups': typeof StaffSettingsPermissionAndRolesListPeopleGroupsIndexRoute
  '/settings/permission-and-roles/product-permissions': typeof StaffSettingsPermissionAndRolesListProductPermissionsIndexRoute
  '/settings/permission-and-roles/roles': typeof StaffSettingsPermissionAndRolesListRolesIndexRoute
  '/settings/persons/settings': typeof StaffSettingsPersonsListSettingsIndexRoute
  '/software/$id/accounts': typeof StaffSoftwareIdIdAccountsIndexRoute
  '/software/$id/activity-monitoring': typeof StaffSoftwareIdIdActivityMonitoringIndexRoute
  '/software/$id/alerts': typeof StaffSoftwareIdIdAlertsIndexRoute
  '/software/$id/architecture': typeof StaffSoftwareIdIdArchitectureIndexRoute
  '/software/$id/detail': typeof StaffSoftwareIdIdDetailIndexRoute
  '/software/$id/rule-and-policy': typeof StaffSoftwareIdIdRuleAndPolicyIndexRoute
  '/software/$id/settings': typeof StaffSoftwareIdIdSettingsIndexRoute
  '/software/library/search': typeof StaffSoftwareLayoutLibrarySearchIndexRoute
  '/software/custom-saas/add/$customSaasType': typeof StaffSoftwareCustomSaasAddCustomSaasTypeIndexRoute
  '/supplier/settings/procurement-categories': typeof StaffSupplierListSettingsProcurementCategoriesIndexRoute
  '/supplier/settings/supplier-categories': typeof StaffSupplierListSettingsSupplierCategoriesIndexRoute
  '/supplier/settings/supplier-subcategories': typeof StaffSupplierListSettingsSupplierSubcategoriesIndexRoute
  '/time-and-attendance/summary': typeof StaffTimeAndAttendanceLayoutListSummaryIndexRoute
  '/time-and-attendance/attendance-links/$placeId': typeof StaffTimeAndAttendanceLayoutAttendanceLinksPlaceIdIndexRoute
  '/users/$userId/sessions': typeof StaffUsersUserIdLayoutSessionsIndexRoute
  '/individual/portal/lookup/clocking-record': typeof IndividualIndividualPortalLookupClockingRecordIndexLazyRoute
  '/individual/portal/lookup/pay-slip': typeof IndividualIndividualPortalLookupPaySlipIndexLazyRoute
  '/attendances/clocking-records/$employeeId': typeof StaffAttendancesLayoutClockingRecordsEmployeeIdIndexLazyRoute
  '/contract/$id/structure': typeof StaffContractIdLayoutStructureIndexLazyRoute
  '/equipment/$id/lifecycle': typeof StaffEquipmentIdLayoutLifecycleIndexLazyRoute
  '/equipment/$id/status': typeof StaffEquipmentIdLayoutStatusIndexLazyRoute
  '/payroll/pay-slips/$employeeId': typeof StaffPayrollLayoutPaySlipsEmployeeIdIndexLazyRoute
  '/starlinks/$id/detail': typeof StaffStarlinksIdLayoutDetailIndexLazyRoute
  '/individual/certifications/base-certifications/$id': typeof IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutIndexIndexRoute
  '/individual/certifications/handling-certifications/$id': typeof IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutIndexIndexRoute
  '/individual/certifications/specialty-certifications/$id': typeof IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutIndexIndexRoute
  '/device-catalog/active/$id/contract-and-cost': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostIndexRoute
  '/devices/contract-and-cost/deal': typeof StaffDevicesListContractAndCostContractAndCostDealDealIndexRoute
  '/person/$id/certifications/base-certifications/$personCertificationInformationId': typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
  '/person/$id/certifications/handling-certifications/$personCertificationInformationId': typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
  '/person/$id/certifications/specialty-certifications/$personCertificationInformationId': typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
  '/settings/data-connector/inbound/aggregate-data-pipeline/$id': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailRouteWithChildren
  '/settings/data-connector/inbound/data-pipeline/$id': typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailRouteWithChildren
  '/settings/data-connector/outbound/data-pipeline/$id': typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailRouteWithChildren
  '/software/contract-and-cost/deal': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealIndexRoute
  '/individual/my-profile/devices': typeof IndividualIndividualProfileMyProfileLayoutDevicesIndexRoute
  '/individual/my-profile/education-and-qualification': typeof IndividualIndividualProfileMyProfileLayoutEducationAndQualificationIndexRoute
  '/individual/my-profile/softwares': typeof IndividualIndividualProfileMyProfileLayoutSoftwaresIndexRoute
  '/individual/contract/$id/signature-request/$signatureRequestId': typeof IndividualIndividualContractIdSignatureRequestSignatureRequestIdIndexRoute
  '/individual/operation-package/$id/pattern/$patternId': typeof IndividualIndividualOperationPackageIdPatternPatternIdIndexRoute
  '/individual/operation-package/$id/target/$targetId': typeof IndividualIndividualOperationPackageIdTargetTargetIdIndexRoute
  '/production/$productionId/dev-scope/edit': typeof StacktraceProductionProductionIdLayoutDevScopeEditIndexRoute
  '/production/$productionId/issue-scope/edit': typeof StacktraceProductionProductionIdLayoutIssueScopeEditIndexRoute
  '/production/$productionId/value/edit': typeof StacktraceProductionProductionIdLayoutValueEditIndexRoute
  '/accesses/alerts/detail/$shadowItAppId': typeof StaffAccessesLayoutAlertsDetailShadowItAppIdIndexRoute
  '/accesses/alerts/dormancy/$softwareId': typeof StaffAccessesLayoutAlertsDormancySoftwareIdIndexRoute
  '/certification/handling-certification/$id/certification-holders': typeof StaffCertificationHandlingCertificationIdLayoutCertificationHoldersIndexRoute
  '/certification/specialty-certification/$id/certification-holders': typeof StaffCertificationSpecialtyCertificationIdLayoutCertificationHoldersIndexRoute
  '/certification/specialty-certification/$id/handling-certifications': typeof StaffCertificationSpecialtyCertificationIdLayoutHandlingCertificationsIndexRoute
  '/device-catalog/active/$id/profile': typeof StaffDeviceCatalogActiveIdLayoutProfileIndexRoute
  '/device-catalog/draft/$id/profile': typeof StaffDeviceCatalogDraftIdLayoutProfileIndexRoute
  '/devices/contract-and-cost/cost': typeof StaffDevicesListContractAndCostContractAndCostCostIndexRoute
  '/devices/contract-and-cost/payment': typeof StaffDevicesListContractAndCostContractAndCostPaymentIndexRoute
  '/equipment/items/$id/alerts': typeof StaffEquipmentItemsIdDetailAlertsIndexRoute
  '/equipment/items/$id/inventory': typeof StaffEquipmentItemsIdDetailInventoryIndexRoute
  '/equipment/items/$id/rule-and-policy': typeof StaffEquipmentItemsIdDetailRuleAndPolicyIndexRoute
  '/ids/group-id/$id/detail': typeof StaffIdsGroupIdIdIdDetailIndexRoute
  '/ids/group-id/$id/devices': typeof StaffIdsGroupIdIdIdDevicesIndexRoute
  '/ids/group-id/$id/members': typeof StaffIdsGroupIdIdIdMembersIndexRoute
  '/ids/group-id/$id/rule-and-policy': typeof StaffIdsGroupIdIdIdRuleAndPolicyIndexRoute
  '/ids/group-id/$id/security-and-auth': typeof StaffIdsGroupIdIdIdSecurityAndAuthIndexRoute
  '/ids/group-id/$id/softwares': typeof StaffIdsGroupIdIdIdSoftwaresIndexRoute
  '/marketplace/store/devices/$productId': typeof StaffMarketplaceStoreStoreDevicesProductIdIndexRoute
  '/marketplace/store/licenses/$productId': typeof StaffMarketplaceStoreStoreLicensesProductIdIndexRoute
  '/marketplace/store/starlinks/$productId': typeof StaffMarketplaceStoreStoreStarlinksProductIdIndexRoute
  '/organization/plan/$id/edit/$unitId': typeof StaffOrganizationPlanIdEditUnitIdIndexRoute
  '/payroll/contract-and-cost/cost': typeof StaffPayrollLayoutContractAndCostContractAndCostCostIndexRoute
  '/payroll/contract-and-cost/deal': typeof StaffPayrollLayoutContractAndCostContractAndCostDealIndexRoute
  '/payroll/contract-and-cost/payment': typeof StaffPayrollLayoutContractAndCostContractAndCostPaymentIndexRoute
  '/person/$id/family/$familyPersonId': typeof StaffPersonIdProfileFamilyFamilyPersonIdIndexRoute
  '/person/alumni/$id/apps': typeof StaffPersonAlumniIdProfileAppsIndexRoute
  '/person/alumni/$id/contractor-information': typeof StaffPersonAlumniIdProfileContractorInformationIndexRoute
  '/person/alumni/$id/devices': typeof StaffPersonAlumniIdProfileDevicesIndexRoute
  '/person/alumni/$id/education-and-qualification': typeof StaffPersonAlumniIdProfileEducationAndQualificationIndexRoute
  '/person/alumni/$id/employee-information': typeof StaffPersonAlumniIdProfileEmployeeInformationIndexRoute
  '/person/alumni/$id/equipment': typeof StaffPersonAlumniIdProfileEquipmentIndexRoute
  '/person/alumni/$id/history': typeof StaffPersonAlumniIdProfileHistoryIndexRoute
  '/person/alumni/$id/operation-activity': typeof StaffPersonAlumniIdProfileOperationActivityIndexRoute
  '/person/alumni/$id/personal-information': typeof StaffPersonAlumniIdProfilePersonalInformationIndexRoute
  '/person/alumni/$id/public-id': typeof StaffPersonAlumniIdProfilePublicIdIndexRoute
  '/settings/data-connector/inbound/aggregate-data-pipeline/add': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineAddIndexRoute
  '/settings/data-connector/inbound/data-pipeline/add': typeof StaffSettingsDataConnectorInboundDataPipelineAddIndexRoute
  '/settings/data-connector/outbound/data-pipeline/add': typeof StaffSettingsDataConnectorOutboundDataPipelineAddIndexRoute
  '/settings/permission-and-roles/category-permissions/$id': typeof StaffSettingsPermissionAndRolesDetailCategoryPermissionsIdIndexRoute
  '/settings/permission-and-roles/people-groups/$id': typeof StaffSettingsPermissionAndRolesDetailPeopleGroupsIdIndexRoute
  '/settings/permission-and-roles/product-permissions/$id': typeof StaffSettingsPermissionAndRolesDetailProductPermissionsIdIndexRoute
  '/settings/permission-and-roles/roles/$id': typeof StaffSettingsPermissionAndRolesDetailRolesIdIndexRoute
  '/settings/permission-and-roles/category-permissions/new': typeof StaffSettingsPermissionAndRolesFormCategoryPermissionsNewIndexRoute
  '/settings/permission-and-roles/people-groups/new': typeof StaffSettingsPermissionAndRolesFormPeopleGroupsNewIndexRoute
  '/settings/permission-and-roles/product-permissions/new': typeof StaffSettingsPermissionAndRolesFormProductPermissionsNewIndexRoute
  '/settings/permission-and-roles/roles/new': typeof StaffSettingsPermissionAndRolesFormRolesNewIndexRoute
  '/settings/persons/individual': typeof StaffSettingsPersonsListAccountIndividualIndexRoute
  '/settings/persons/staff': typeof StaffSettingsPersonsListAccountStaffIndexRoute
  '/software/$id/settings/integration': typeof StaffSoftwareIdIdSettingsIntegrationIndexRoute
  '/software/$id/settings/role': typeof StaffSoftwareIdIdSettingsRoleIndexRoute
  '/software/$id/settings/status': typeof StaffSoftwareIdIdSettingsStatusIndexRoute
  '/software/alerts/alumni': typeof StaffSoftwareLayoutAlertsAlertsAlumniIndexRoute
  '/software/alerts/inactive-user': typeof StaffSoftwareLayoutAlertsAlertsInactiveUserIndexRoute
  '/software/alerts/no-user': typeof StaffSoftwareLayoutAlertsAlertsNoUserIndexRoute
  '/software/alerts/no-worker': typeof StaffSoftwareLayoutAlertsAlertsNoWorkerIndexRoute
  '/software/alerts/violated-assignment': typeof StaffSoftwareLayoutAlertsAlertsViolatedAssignmentIndexRoute
  '/software/alerts/violated-role': typeof StaffSoftwareLayoutAlertsAlertsViolatedRoleIndexRoute
  '/software/contract-and-cost/cost': typeof StaffSoftwareLayoutContractAndCostContractAndCostCostIndexRoute
  '/software/contract-and-cost/payment': typeof StaffSoftwareLayoutContractAndCostContractAndCostPaymentIndexRoute
  '/software/library/category/$category': typeof StaffSoftwareLayoutLibraryCategoryCategoryIndexRoute
  '/software/library/detail/$softwareLibraryId': typeof StaffSoftwareLayoutLibraryDetailSoftwareLibraryIdIndexRoute
  '/storage-files/folders/$id/files': typeof StaffStorageFilesFoldersIdIdFilesIndexRoute
  '/storage-files/folders/$id/users': typeof StaffStorageFilesFoldersIdIdUsersIndexRoute
  '/time-and-attendance/summary/daily-place': typeof StaffTimeAndAttendanceLayoutListSummaryDailyPlaceIndexRoute
  '/time-and-attendance/summary/monthly-person': typeof StaffTimeAndAttendanceLayoutListSummaryMonthlyPersonIndexRoute
  '/time-and-attendance/summary/monthly-place': typeof StaffTimeAndAttendanceLayoutListSummaryMonthlyPlaceIndexRoute
  '/equipment/items/$id/profile': typeof StaffEquipmentItemsIdDetailProfileIndexLazyRoute
  '/software/$id/contract-and-cost/deal': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealIndexRoute
  '/products/$id/scope/$nodeId/value': typeof StacktraceProductsIdScopeNodeIdLayoutValueIndexRoute
  '/attendance-engine/attendance-structures/$structureId/structure': typeof StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutStructureIndexRoute
  '/business-partner/$id/bp-role-info/$bpRole': typeof StaffBusinessPartnerIdLayoutBpRoleInfoLayoutBpRoleIndexRoute
  '/devices/contract-and-cost/cost/$period': typeof StaffDevicesListContractAndCostContractAndCostCostPeriodIndexRoute
  '/devices/contract-and-cost/payment/$period': typeof StaffDevicesListContractAndCostContractAndCostPaymentPeriodIndexRoute
  '/it-operation-core/operation-instances/$instanceId/data': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDataIndexRoute
  '/it-operation-core/operation-instances/$instanceId/detail': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDetailIndexRoute
  '/it-operation-core/operation-instances/$instanceId/operation-activity': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutOperationActivityIndexRoute
  '/licenses/$id/service-plans/$licenseServiceId/accounts': typeof StaffLicensesIdServicePlansLicenseServiceIdDetailAccountsIndexRoute
  '/payroll-engine/payroll-structures/$structureId/structure': typeof StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutStructureIndexRoute
  '/payroll/contract-and-cost/cost/$period': typeof StaffPayrollLayoutContractAndCostContractAndCostCostPeriodIndexRoute
  '/payroll/contract-and-cost/payment/$period': typeof StaffPayrollLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute
  '/settings/permission-and-roles/category-permissions/$id/edit': typeof StaffSettingsPermissionAndRolesFormCategoryPermissionsIdEditIndexRoute
  '/settings/permission-and-roles/people-groups/$id/edit': typeof StaffSettingsPermissionAndRolesFormPeopleGroupsIdEditIndexRoute
  '/settings/permission-and-roles/product-permissions/$id/edit': typeof StaffSettingsPermissionAndRolesFormProductPermissionsIdEditIndexRoute
  '/settings/permission-and-roles/roles/$id/edit': typeof StaffSettingsPermissionAndRolesFormRolesIdEditIndexRoute
  '/software/$id/contract-and-cost/cost': typeof StaffSoftwareIdIdContractAndCostContractAndCostCostIndexRoute
  '/software/$id/contract-and-cost/payment': typeof StaffSoftwareIdIdContractAndCostContractAndCostPaymentIndexRoute
  '/software/contract-and-cost/cost/$period': typeof StaffSoftwareLayoutContractAndCostContractAndCostCostPeriodIndexRoute
  '/software/contract-and-cost/payment/$period': typeof StaffSoftwareLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute
  '/software/library/category/$category/search': typeof StaffSoftwareLayoutLibraryCategoryCategorySearchIndexRoute
  '/software/marketplace/$id/install/finish': typeof StaffSoftwareLayoutMarketplaceIdInstallFinishIndexRoute
  '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  '/device-catalog/active/$id/contract-and-cost/deal': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealIndexRoute
  '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  '/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId': typeof StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailRouteWithChildren
  '/individual/task/$id/form/$formId': typeof IndividualIndividualTaskIdOperationPackageCommonFormFormIdIndexRoute
  '/device-catalog/active/$id/contract-and-cost/cost': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostCostIndexRoute
  '/device-catalog/active/$id/contract-and-cost/payment': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostPaymentIndexRoute
  '/devices/contract-and-cost/deal/all': typeof StaffDevicesListContractAndCostContractAndCostDealDealAllIndexRoute
  '/devices/contract-and-cost/deal/contract': typeof StaffDevicesListContractAndCostContractAndCostDealDealContractIndexRoute
  '/devices/contract-and-cost/deal/estimate': typeof StaffDevicesListContractAndCostContractAndCostDealDealEstimateIndexRoute
  '/devices/contract-and-cost/deal/order': typeof StaffDevicesListContractAndCostContractAndCostDealDealOrderIndexRoute
  '/devices/contract-and-cost/deal/payment': typeof StaffDevicesListContractAndCostContractAndCostDealDealPaymentIndexRoute
  '/devices/contract-and-cost/deal/vendor-invoice': typeof StaffDevicesListContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute
  '/settings/data-connector/inbound/aggregate-data-pipeline/$id/basic-info': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailBasicInfoIndexRoute
  '/settings/data-connector/inbound/aggregate-data-pipeline/$id/execution-plan': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailExecutionPlanIndexRoute
  '/settings/data-connector/inbound/aggregate-data-pipeline/$id/priority-setting': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailPrioritySettingIndexRoute
  '/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailTasksIndexRoute
  '/settings/data-connector/inbound/data-pipeline/$id/basic-settings': typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailBasicSettingsIndexRoute
  '/settings/data-connector/inbound/data-pipeline/$id/data-link-settings': typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailDataLinkSettingsIndexRoute
  '/settings/data-connector/inbound/data-pipeline/$id/execution-plan': typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailExecutionPlanIndexRoute
  '/settings/data-connector/inbound/data-pipeline/$id/execution-results': typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailExecutionResultsIndexRoute
  '/settings/data-connector/outbound/data-pipeline/$id/basic-settings': typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailBasicSettingsIndexRoute
  '/settings/data-connector/outbound/data-pipeline/$id/data-link-settings': typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailDataLinkSettingsIndexRoute
  '/settings/data-connector/outbound/data-pipeline/$id/execution-plan': typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailExecutionPlanIndexRoute
  '/settings/data-connector/outbound/data-pipeline/$id/execution-results': typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailExecutionResultsIndexRoute
  '/software/$id/contract-and-cost/cost/$period': typeof StaffSoftwareIdIdContractAndCostContractAndCostCostPeriodIndexRoute
  '/software/$id/contract-and-cost/payment/$period': typeof StaffSoftwareIdIdContractAndCostContractAndCostPaymentPeriodIndexRoute
  '/software/contract-and-cost/deal/all': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealAllIndexRoute
  '/software/contract-and-cost/deal/contract': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealContractIndexRoute
  '/software/contract-and-cost/deal/estimate': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealEstimateIndexRoute
  '/software/contract-and-cost/deal/order': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealOrderIndexRoute
  '/software/contract-and-cost/deal/payment': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealPaymentIndexRoute
  '/software/contract-and-cost/deal/vendor-invoice': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute
  '/attendance-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': typeof StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  '/device-catalog/active/$id/contract-and-cost/cost/$period': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostCostPeriodIndexRoute
  '/device-catalog/active/$id/contract-and-cost/payment/$period': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute
  '/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdTasksTaskIdChunksIndexRoute
  '/software/$id/contract-and-cost/deal/all': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealAllIndexRoute
  '/software/$id/contract-and-cost/deal/contract': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealContractIndexRoute
  '/software/$id/contract-and-cost/deal/estimate': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealEstimateIndexRoute
  '/software/$id/contract-and-cost/deal/order': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealOrderIndexRoute
  '/software/$id/contract-and-cost/deal/payment': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealPaymentIndexRoute
  '/software/$id/contract-and-cost/deal/vendor-invoice': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute
  '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data': typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
  '/device-catalog/active/$id/contract-and-cost/deal/all': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealAllIndexRoute
  '/device-catalog/active/$id/contract-and-cost/deal/contract': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealContractIndexRoute
  '/device-catalog/active/$id/contract-and-cost/deal/estimate': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealEstimateIndexRoute
  '/device-catalog/active/$id/contract-and-cost/deal/order': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealOrderIndexRoute
  '/device-catalog/active/$id/contract-and-cost/deal/payment': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealPaymentIndexRoute
  '/device-catalog/active/$id/contract-and-cost/deal/vendor-invoice': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute
  '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data': typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
  '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data': typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
  '/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/chunks': typeof StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailChunksIndexRoute
  '/attendance-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data': typeof StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
  '/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/$chunkId/result': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdTasksTaskIdChunksChunkIdResultIndexRoute
  '/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/chunks/$chunkId/result': typeof StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdChunksChunkIdResultIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_chat': typeof ChatRouteWithChildren
  '/_cockpit-mock': typeof CockpitMockRouteWithChildren
  '/_idp-sso-mock': typeof IdpSsoMockRouteWithChildren
  '/_individual': typeof IndividualRouteWithChildren
  '/_stacktrace': typeof StacktraceRouteWithChildren
  '/_staff': typeof StaffRouteWithChildren
  '/_stacktrace/planning-operations-core': typeof StacktracePlanningOperationsCoreRoute
  '/_stacktrace/product-planning-core': typeof StacktraceProductPlanningCoreRoute
  '/_stacktrace/qa-operations-core': typeof StacktraceQaOperationsCoreRoute
  '/_staff/apps': typeof StaffAppsRouteWithChildren
  '/_staff/id-managements': typeof StaffIdManagementsRouteWithChildren
  '/me/': typeof MeIndexRoute
  '/_stacktrace/development-tickets/import-csv': typeof StacktraceDevelopmentTicketsImportCsvRouteRoute
  '/_stacktrace/issues/import-csv': typeof StacktraceIssuesImportCsvRouteRoute
  '/_stacktrace/values/import-csv': typeof StacktraceValuesImportCsvRouteRoute
  '/_staff/it-operation-core/device-inventory': typeof StaffItOperationCoreDeviceInventoryRouteRouteWithChildren
  '/_staff/places/import-csv': typeof StaffPlacesImportCsvRouteRoute
  '/_individual/individual': typeof IndividualIndividualRouteWithChildren
  '/_individual/individual/_profile': typeof IndividualIndividualProfileRouteWithChildren
  '/_individual/individual/portal': typeof IndividualIndividualPortalRouteWithChildren
  '/_stacktrace/issues': typeof StacktraceIssuesRouteWithChildren
  '/_stacktrace/issues/_layout': typeof StacktraceIssuesLayoutRouteWithChildren
  '/_stacktrace/product-roadmap': typeof StacktraceProductRoadmapRouteWithChildren
  '/_stacktrace/product-roadmap/_layout': typeof StacktraceProductRoadmapLayoutRouteWithChildren
  '/_stacktrace/test-sets': typeof StacktraceTestSetsRouteWithChildren
  '/_stacktrace/test-sets/_layout': typeof StacktraceTestSetsLayoutRouteWithChildren
  '/_stacktrace/test-suites': typeof StacktraceTestSuitesRouteWithChildren
  '/_stacktrace/test-suites/_layout': typeof StacktraceTestSuitesLayoutRouteWithChildren
  '/_stacktrace/values': typeof StacktraceValuesRouteWithChildren
  '/_stacktrace/values/_layout': typeof StacktraceValuesLayoutRouteWithChildren
  '/_staff/accesses': typeof StaffAccessesRouteWithChildren
  '/_staff/accesses/_layout': typeof StaffAccessesLayoutRouteWithChildren
  '/_staff/apps/$': typeof StaffAppsSplatRoute
  '/_staff/attendance-core': typeof StaffAttendanceCoreRouteWithChildren
  '/_staff/attendance-core/_layout': typeof StaffAttendanceCoreLayoutRouteWithChildren
  '/_staff/attendance-engine': typeof StaffAttendanceEngineRouteWithChildren
  '/_staff/attendance-engine/_layout': typeof StaffAttendanceEngineLayoutRouteWithChildren
  '/_staff/attendances': typeof StaffAttendancesRouteWithChildren
  '/_staff/attendances/_layout': typeof StaffAttendancesLayoutRouteWithChildren
  '/_staff/business-operation-events': typeof StaffBusinessOperationEventsRouteWithChildren
  '/_staff/business-operation-events/_list': typeof StaffBusinessOperationEventsListRouteWithChildren
  '/_staff/business-partner': typeof StaffBusinessPartnerRouteWithChildren
  '/_staff/business-partner/_list': typeof StaffBusinessPartnerListRouteWithChildren
  '/_staff/certification': typeof StaffCertificationRouteWithChildren
  '/_staff/certification/_list': typeof StaffCertificationListRouteWithChildren
  '/_staff/contract': typeof StaffContractRouteWithChildren
  '/_staff/contract/_list': typeof StaffContractListRouteWithChildren
  '/_staff/contractor-core': typeof StaffContractorCoreRouteWithChildren
  '/_staff/contractor-core/_packages': typeof StaffContractorCorePackagesRouteWithChildren
  '/_staff/contractor-core/anchor-date': typeof StaffContractorCoreAnchorDateRoute
  '/_staff/contractor-core/contract-targets': typeof StaffContractorCoreContractTargetsRoute
  '/_staff/contractor-core/person-targets': typeof StaffContractorCorePersonTargetsRoute
  '/_staff/deal': typeof StaffDealRouteWithChildren
  '/_staff/deal/_list': typeof StaffDealListRouteWithChildren
  '/_staff/devices': typeof StaffDevicesRouteWithChildren
  '/_staff/devices/_list': typeof StaffDevicesListRouteWithChildren
  '/_staff/equipment': typeof StaffEquipmentRouteWithChildren
  '/_staff/equipment/_layout': typeof StaffEquipmentLayoutRouteWithChildren
  '/_staff/fleets': typeof StaffFleetsRouteWithChildren
  '/_staff/fleets/_layout': typeof StaffFleetsLayoutRouteWithChildren
  '/_staff/ga-operation-core': typeof StaffGaOperationCoreRouteWithChildren
  '/_staff/ga-operation-core/_packages': typeof StaffGaOperationCorePackagesRouteWithChildren
  '/_staff/id-managements/$': typeof StaffIdManagementsSplatRoute
  '/_staff/ids': typeof StaffIdsRouteWithChildren
  '/_staff/ids/_layout': typeof StaffIdsLayoutRouteWithChildren
  '/_staff/it-operation-core': typeof StaffItOperationCoreRouteWithChildren
  '/_staff/it-operation-core/_detail': typeof StaffItOperationCoreDetailRouteWithChildren
  '/_staff/it-operation-core/_root': typeof StaffItOperationCoreRootRouteWithChildren
  '/_staff/it-operation-core/anchor-date': typeof StaffItOperationCoreAnchorDateRoute
  '/_staff/it-operation-core/self-report-confirmation': typeof StaffItOperationCoreSelfReportConfirmationRoute
  '/_staff/labor-core': typeof StaffLaborCoreRouteWithChildren
  '/_staff/labor-core/_packages': typeof StaffLaborCorePackagesRouteWithChildren
  '/_staff/labor-core/anchor-date': typeof StaffLaborCoreAnchorDateRoute
  '/_staff/labor-core/contract-targets': typeof StaffLaborCoreContractTargetsRoute
  '/_staff/labor-core/government-application-confirmation': typeof StaffLaborCoreGovernmentApplicationConfirmationRoute
  '/_staff/labor-core/person-targets': typeof StaffLaborCorePersonTargetsRoute
  '/_staff/labor-core/year-end-adjustment-confirmation': typeof StaffLaborCoreYearEndAdjustmentConfirmationRoute
  '/_staff/licenses': typeof StaffLicensesRouteWithChildren
  '/_staff/licenses/_list': typeof StaffLicensesListRouteWithChildren
  '/_staff/marketplace': typeof StaffMarketplaceRouteWithChildren
  '/_staff/marketplace/_store': typeof StaffMarketplaceStoreRouteWithChildren
  '/_staff/networks': typeof StaffNetworksRouteWithChildren
  '/_staff/networks/_layout': typeof StaffNetworksLayoutRouteWithChildren
  '/_staff/organization': typeof StaffOrganizationRouteWithChildren
  '/_staff/organization/_list': typeof StaffOrganizationListRouteWithChildren
  '/_staff/payroll-core': typeof StaffPayrollCoreRouteWithChildren
  '/_staff/payroll-core/_layout': typeof StaffPayrollCoreLayoutRouteWithChildren
  '/_staff/payroll-engine': typeof StaffPayrollEngineRouteWithChildren
  '/_staff/payroll-engine/_layout': typeof StaffPayrollEngineLayoutRouteWithChildren
  '/_staff/payroll': typeof StaffPayrollRouteWithChildren
  '/_staff/payroll/_layout': typeof StaffPayrollLayoutRouteWithChildren
  '/_staff/people': typeof StaffPeopleRouteWithChildren
  '/_staff/people/_list': typeof StaffPeopleListRouteWithChildren
  '/_staff/places': typeof StaffPlacesRouteWithChildren
  '/_staff/places/_layout': typeof StaffPlacesLayoutRouteWithChildren
  '/_staff/public-ids/$id': typeof StaffPublicIdsIdRouteWithChildren
  '/_staff/public-ids': typeof StaffPublicIdsRouteWithChildren
  '/_staff/public-ids/_list': typeof StaffPublicIdsListRouteWithChildren
  '/_staff/software': typeof StaffSoftwareRouteWithChildren
  '/_staff/software/_layout': typeof StaffSoftwareLayoutRouteWithChildren
  '/_staff/starlinks': typeof StaffStarlinksRouteWithChildren
  '/_staff/starlinks/_layout': typeof StaffStarlinksLayoutRouteWithChildren
  '/_staff/storage-files': typeof StaffStorageFilesRouteWithChildren
  '/_staff/storage-files/_list': typeof StaffStorageFilesListRouteWithChildren
  '/_staff/supplier': typeof StaffSupplierRouteWithChildren
  '/_staff/supplier/_list': typeof StaffSupplierListRouteWithChildren
  '/_staff/time-and-attendance': typeof StaffTimeAndAttendanceRouteWithChildren
  '/_staff/time-and-attendance/_layout': typeof StaffTimeAndAttendanceLayoutRouteWithChildren
  '/_staff/labor-core/group-name': typeof StaffLaborCoreGroupNameLazyRoute
  '/_chat/chat/': typeof ChatChatIndexRoute
  '/_cockpit-mock/cockpit-mock/': typeof CockpitMockCockpitMockIndexRoute
  '/_individual/individual/': typeof IndividualIndividualIndexRoute
  '/_stacktrace/development-tickets/': typeof StacktraceDevelopmentTicketsIndexRoute
  '/_stacktrace/production/': typeof StacktraceProductionIndexRoute
  '/_stacktrace/products/': typeof StacktraceProductsIndexRoute
  '/_stacktrace/test-assets/': typeof StacktraceTestAssetsIndexRoute
  '/_staff/cockpit/': typeof StaffCockpitIndexRoute
  '/_staff/it-operation-core/': typeof StaffItOperationCoreIndexRoute
  '/_staff/organization/': typeof StaffOrganizationIndexRoute
  '/_staff/settings/': typeof StaffSettingsIndexRoute
  '/account/sso/': typeof AccountSsoIndexRoute
  '/auth/password-reset/': typeof AuthPasswordResetIndexRoute
  '/auth/sign-in/': typeof AuthSignInIndexRoute
  '/oauth2/consent/': typeof Oauth2ConsentIndexRoute
  '/oauth2/error/': typeof Oauth2ErrorIndexRoute
  '/oauth2/login/': typeof Oauth2LoginIndexRoute
  '/oauth2/logout/': typeof Oauth2LogoutIndexRoute
  '/_staff/certification/_list/': typeof StaffCertificationListIndexRouteRoute
  '/_staff/licenses/_list/': typeof StaffLicensesListIndexRouteRoute
  '/_staff/app-integrations/import-csv/$id': typeof StaffAppIntegrationsImportCsvIdRouteRoute
  '/_staff/business-partner/import-csv/corporation': typeof StaffBusinessPartnerImportCsvCorporationRouteRoute
  '/_staff/business-partner/import-csv/individual': typeof StaffBusinessPartnerImportCsvIndividualRouteRoute
  '/_staff/devices/import-csv/$deviceType': typeof StaffDevicesImportCsvDeviceTypeRouteRoute
  '/_staff/it-operation-core/_root/in-house-packages': typeof StaffItOperationCoreRootInHousePackagesRouteRouteWithChildren
  '/_staff/it-operation-core/_root/packages': typeof StaffItOperationCoreRootPackagesRouteRouteWithChildren
  '/_staff/person/import-csv/$workerType': typeof StaffPersonImportCsvWorkerTypeRouteRoute
  '/_staff/places/_layout/settings': typeof StaffPlacesLayoutSettingsRouteRouteWithChildren
  '/_staff/public-ids/import-csv/$publicIdType': typeof StaffPublicIdsImportCsvPublicIdTypeRouteRoute
  '/_staff/software/$id/import-csv': typeof StaffSoftwareIdImportCsvRouteRoute
  '/_staff/software/_layout/people': typeof StaffSoftwareLayoutPeopleRouteRouteWithChildren
  '/_stacktrace/development-tickets/$ticketId': typeof StacktraceDevelopmentTicketsTicketIdRouteWithChildren
  '/_stacktrace/development-tickets/$ticketId/_layout': typeof StacktraceDevelopmentTicketsTicketIdLayoutRouteWithChildren
  '/_stacktrace/issues/$id': typeof StacktraceIssuesIdRouteWithChildren
  '/_stacktrace/issues/$id/_layout': typeof StacktraceIssuesIdLayoutRouteWithChildren
  '/_stacktrace/product-roadmap/$roadmapId': typeof StacktraceProductRoadmapRoadmapIdRouteWithChildren
  '/_stacktrace/product-roadmap/$roadmapId/_layout': typeof StacktraceProductRoadmapRoadmapIdLayoutRouteWithChildren
  '/_stacktrace/production/$productionId': typeof StacktraceProductionProductionIdRouteWithChildren
  '/_stacktrace/production/$productionId/_layout': typeof StacktraceProductionProductionIdLayoutRouteWithChildren
  '/_stacktrace/products/$id': typeof StacktraceProductsIdRouteWithChildren
  '/_stacktrace/products/$id/_layout': typeof StacktraceProductsIdLayoutRouteWithChildren
  '/_stacktrace/test-sets/$id': typeof StacktraceTestSetsIdRouteWithChildren
  '/_stacktrace/test-sets/$id/_layout': typeof StacktraceTestSetsIdLayoutRouteWithChildren
  '/_stacktrace/test-suites/$id': typeof StacktraceTestSuitesIdRouteWithChildren
  '/_stacktrace/test-suites/$id/_layout': typeof StacktraceTestSuitesIdLayoutRouteWithChildren
  '/_stacktrace/values/$id': typeof StacktraceValuesIdRouteWithChildren
  '/_stacktrace/values/$id/_layout': typeof StacktraceValuesIdLayoutRouteWithChildren
  '/_staff/app-integrations/$id': typeof StaffAppIntegrationsIdRouteWithChildren
  '/_staff/app-integrations/$id/_$id': typeof StaffAppIntegrationsIdIdRouteWithChildren
  '/_staff/business-operation-events/_list/archive': typeof StaffBusinessOperationEventsListArchiveRoute
  '/_staff/business-operation-events/_list/config': typeof StaffBusinessOperationEventsListConfigRoute
  '/_staff/business-operation-events/_list/operation-activity': typeof StaffBusinessOperationEventsListOperationActivityRoute
  '/_staff/business-operation-events/_list/overview': typeof StaffBusinessOperationEventsListOverviewRoute
  '/_staff/business-operation-events/_list/rule-and-policy': typeof StaffBusinessOperationEventsListRuleAndPolicyRoute
  '/_staff/business-operation-events/_list/settings': typeof StaffBusinessOperationEventsListSettingsRoute
  '/_staff/business-partner/$id': typeof StaffBusinessPartnerIdRouteWithChildren
  '/_staff/business-partner/$id/_layout': typeof StaffBusinessPartnerIdLayoutRouteWithChildren
  '/_staff/certification/$id': typeof StaffCertificationIdRouteWithChildren
  '/_staff/certification/$id/_layout': typeof StaffCertificationIdLayoutRouteWithChildren
  '/_staff/contract/$id': typeof StaffContractIdRouteWithChildren
  '/_staff/contract/$id/_layout': typeof StaffContractIdLayoutRouteWithChildren
  '/_staff/deal/$dealId': typeof StaffDealDealIdRouteWithChildren
  '/_staff/deal/$dealId/_layout': typeof StaffDealDealIdLayoutRouteWithChildren
  '/_staff/devices/$id': typeof StaffDevicesIdRouteWithChildren
  '/_staff/devices/$id/_layout': typeof StaffDevicesIdLayoutRouteWithChildren
  '/_staff/devices/_list/alerts': typeof StaffDevicesListAlertsRoute
  '/_staff/devices/_list/operation-activity': typeof StaffDevicesListOperationActivityRoute
  '/_staff/devices/_list/rule-and-policy': typeof StaffDevicesListRuleAndPolicyRoute
  '/_staff/equipment/$id': typeof StaffEquipmentIdRouteWithChildren
  '/_staff/equipment/$id/_layout': typeof StaffEquipmentIdLayoutRouteWithChildren
  '/_staff/fleets/$id': typeof StaffFleetsIdRouteWithChildren
  '/_staff/fleets/$id/_layout': typeof StaffFleetsIdLayoutRouteWithChildren
  '/_staff/fleets/_layout/alerts': typeof StaffFleetsLayoutAlertsRoute
  '/_staff/fleets/_layout/overview': typeof StaffFleetsLayoutOverviewRoute
  '/_staff/fleets/_layout/rule-and-policy': typeof StaffFleetsLayoutRuleAndPolicyRoute
  '/_staff/fleets/_layout/settings': typeof StaffFleetsLayoutSettingsRoute
  '/_staff/it-operation-core/device-inventory/data': typeof StaffItOperationCoreDeviceInventoryDataRoute
  '/_staff/it-operation-core/device-inventory/detail': typeof StaffItOperationCoreDeviceInventoryDetailRoute
  '/_staff/labor-core/_packages/settings': typeof StaffLaborCorePackagesSettingsRouteWithChildren
  '/_staff/labor-core/settings/egov-callback': typeof StaffLaborCoreSettingsEgovCallbackRoute
  '/_staff/licenses/$id': typeof StaffLicensesIdRouteWithChildren
  '/_staff/licenses/$id/_profile': typeof StaffLicensesIdProfileRouteWithChildren
  '/_staff/networks/$id': typeof StaffNetworksIdRouteWithChildren
  '/_staff/networks/$id/_layout': typeof StaffNetworksIdLayoutRouteWithChildren
  '/_staff/organization/$id': typeof StaffOrganizationIdRouteWithChildren
  '/_staff/organization/$id/_layout': typeof StaffOrganizationIdLayoutRouteWithChildren
  '/_staff/people/_list/alerts': typeof StaffPeopleListAlertsRoute
  '/_staff/people/_list/community': typeof StaffPeopleListCommunityRoute
  '/_staff/people/_list/people-graph': typeof StaffPeopleListPeopleGraphRoute
  '/_staff/people/_list/rule-and-policy': typeof StaffPeopleListRuleAndPolicyRoute
  '/_staff/people/_list/salary-and-payment': typeof StaffPeopleListSalaryAndPaymentRoute
  '/_staff/person/$id': typeof StaffPersonIdRouteWithChildren
  '/_staff/person/$id/_profile': typeof StaffPersonIdProfileRouteWithChildren
  '/_staff/places/$id': typeof StaffPlacesIdRouteWithChildren
  '/_staff/places/$id/_layout': typeof StaffPlacesIdLayoutRouteWithChildren
  '/_staff/places/_layout/overview': typeof StaffPlacesLayoutOverviewRoute
  '/_staff/settings/contracting-corporation-profile': typeof StaffSettingsContractingCorporationProfileRouteWithChildren
  '/_staff/settings/contracting-corporation-profile/_layout': typeof StaffSettingsContractingCorporationProfileLayoutRouteWithChildren
  '/_staff/settings/permission-and-roles': typeof StaffSettingsPermissionAndRolesRouteWithChildren
  '/_staff/settings/permission-and-roles/_detail': typeof StaffSettingsPermissionAndRolesDetailRouteWithChildren
  '/_staff/settings/permission-and-roles/_form': typeof StaffSettingsPermissionAndRolesFormRouteWithChildren
  '/_staff/settings/permission-and-roles/_list': typeof StaffSettingsPermissionAndRolesListRouteWithChildren
  '/_staff/settings/persons': typeof StaffSettingsPersonsRouteWithChildren
  '/_staff/settings/persons/_list': typeof StaffSettingsPersonsListRouteWithChildren
  '/_staff/software/$id': typeof StaffSoftwareIdRouteWithChildren
  '/_staff/software/$id/_$id': typeof StaffSoftwareIdIdRouteWithChildren
  '/_staff/software/_layout/integrations': typeof StaffSoftwareLayoutIntegrationsRoute
  '/_staff/starlinks/$id': typeof StaffStarlinksIdRouteWithChildren
  '/_staff/starlinks/$id/_layout': typeof StaffStarlinksIdLayoutRouteWithChildren
  '/_staff/supplier/$supplierId': typeof StaffSupplierSupplierIdRouteWithChildren
  '/_staff/supplier/$supplierId/_layout': typeof StaffSupplierSupplierIdLayoutRouteWithChildren
  '/_staff/users/$userId': typeof StaffUsersUserIdRouteWithChildren
  '/_staff/users/$userId/_layout': typeof StaffUsersUserIdLayoutRouteWithChildren
  '/_staff/devices/_list/': typeof StaffDevicesListIndexRouteLazyRoute
  '/_staff/people/_list/': typeof StaffPeopleListIndexRouteLazyRoute
  '/_staff/software/_layout/': typeof StaffSoftwareLayoutIndexRouteLazyRoute
  '/_staff/certification/_list/settings': typeof StaffCertificationListSettingsRouteLazyRouteWithChildren
  '/_staff/devices/_list/settings': typeof StaffDevicesListSettingsRouteLazyRouteWithChildren
  '/_staff/equipment/_layout/settings': typeof StaffEquipmentLayoutSettingsRouteLazyRouteWithChildren
  '/_staff/people/_list/settings': typeof StaffPeopleListSettingsRouteLazyRouteWithChildren
  '/_staff/supplier/_list/settings': typeof StaffSupplierListSettingsRouteLazyRouteWithChildren
  '/_chat/chat/$sessionId/': typeof ChatChatSessionIdIndexRoute
  '/_chat/chat/new/': typeof ChatChatNewIndexRoute
  '/_idp-sso-mock/idp-sso/google-workspace/': typeof IdpSsoMockIdpSsoGoogleWorkspaceIndexRoute
  '/_individual/individual/portal/': typeof IndividualIndividualPortalIndexRoute
  '/_stacktrace/development-tickets/add-select/': typeof StacktraceDevelopmentTicketsAddSelectIndexRoute
  '/_stacktrace/development-tickets/add/': typeof StacktraceDevelopmentTicketsAddIndexRoute
  '/_stacktrace/development-tickets/external-integrations/': typeof StacktraceDevelopmentTicketsExternalIntegrationsIndexRoute
  '/_stacktrace/issues/_layout/': typeof StacktraceIssuesLayoutIndexRoute
  '/_stacktrace/issues/add-select/': typeof StacktraceIssuesAddSelectIndexRoute
  '/_stacktrace/issues/add/': typeof StacktraceIssuesAddIndexRoute
  '/_stacktrace/issues/external-integrations/': typeof StacktraceIssuesExternalIntegrationsIndexRoute
  '/_stacktrace/product-roadmap/_layout/': typeof StacktraceProductRoadmapLayoutIndexRoute
  '/_stacktrace/products/add-select/': typeof StacktraceProductsAddSelectIndexRoute
  '/_stacktrace/products/add/': typeof StacktraceProductsAddIndexRoute
  '/_stacktrace/test-sets/_layout/': typeof StacktraceTestSetsLayoutIndexRoute
  '/_stacktrace/test-suites/_layout/': typeof StacktraceTestSuitesLayoutIndexRoute
  '/_stacktrace/values/_layout/': typeof StacktraceValuesLayoutIndexRoute
  '/_stacktrace/values/add-select/': typeof StacktraceValuesAddSelectIndexRoute
  '/_stacktrace/values/add/': typeof StacktraceValuesAddIndexRoute
  '/_staff/accesses/_layout/': typeof StaffAccessesLayoutIndexRoute
  '/_staff/attendance-core/_layout/': typeof StaffAttendanceCoreLayoutIndexRoute
  '/_staff/attendance-engine/_layout/': typeof StaffAttendanceEngineLayoutIndexRoute
  '/_staff/attendances/_layout/': typeof StaffAttendancesLayoutIndexRoute
  '/_staff/business-operation-events/$eventInstanceId/': typeof StaffBusinessOperationEventsEventInstanceIdIndexRoute
  '/_staff/business-operation-events/_list/': typeof StaffBusinessOperationEventsListIndexRoute
  '/_staff/business-partner/_list/': typeof StaffBusinessPartnerListIndexRoute
  '/_staff/business-partner/add/': typeof StaffBusinessPartnerAddIndexRoute
  '/_staff/certification/add/': typeof StaffCertificationAddIndexRoute
  '/_staff/contract/_list/': typeof StaffContractListIndexRoute
  '/_staff/contract/add/': typeof StaffContractAddIndexRoute
  '/_staff/contractor-core/_packages/': typeof StaffContractorCorePackagesIndexRoute
  '/_staff/deal/_list/': typeof StaffDealListIndexRoute
  '/_staff/deal/add/': typeof StaffDealAddIndexRoute
  '/_staff/device-catalog/add/': typeof StaffDeviceCatalogAddIndexRoute
  '/_staff/devices/add/': typeof StaffDevicesAddIndexRoute
  '/_staff/devices/external-it-saas/': typeof StaffDevicesExternalItSaasIndexRoute
  '/_staff/equipment/_layout/': typeof StaffEquipmentLayoutIndexRoute
  '/_staff/equipment/add-select/': typeof StaffEquipmentAddSelectIndexRoute
  '/_staff/equipment/add/': typeof StaffEquipmentAddIndexRoute
  '/_staff/equipment/import-csv/': typeof StaffEquipmentImportCsvIndexRoute
  '/_staff/fleets/add-select/': typeof StaffFleetsAddSelectIndexRoute
  '/_staff/fleets/add/': typeof StaffFleetsAddIndexRoute
  '/_staff/ga-operation-core/_packages/': typeof StaffGaOperationCorePackagesIndexRoute
  '/_staff/ids/_layout/': typeof StaffIdsLayoutIndexRoute
  '/_staff/it-operation-core/device-targets/': typeof StaffItOperationCoreDeviceTargetsIndexRoute
  '/_staff/it-operation-core/person-targets/': typeof StaffItOperationCorePersonTargetsIndexRoute
  '/_staff/labor-core/_packages/': typeof StaffLaborCorePackagesIndexRoute
  '/_staff/licenses/add/': typeof StaffLicensesAddIndexRoute
  '/_staff/marketplace/cart/': typeof StaffMarketplaceCartIndexRoute
  '/_staff/marketplace/unavailable/': typeof StaffMarketplaceUnavailableIndexRoute
  '/_staff/networks/_layout/': typeof StaffNetworksLayoutIndexRoute
  '/_staff/networks/add/': typeof StaffNetworksAddIndexRoute
  '/_staff/organization/plan/': typeof StaffOrganizationPlanIndexRoute
  '/_staff/payroll-core/_layout/': typeof StaffPayrollCoreLayoutIndexRoute
  '/_staff/payroll-engine/_layout/': typeof StaffPayrollEngineLayoutIndexRoute
  '/_staff/payroll/_layout/': typeof StaffPayrollLayoutIndexRoute
  '/_staff/person/add-person-certification/': typeof StaffPersonAddPersonCertificationIndexRoute
  '/_staff/person/add/': typeof StaffPersonAddIndexRoute
  '/_staff/person/external-hr-saas/': typeof StaffPersonExternalHrSaasIndexRoute
  '/_staff/places/_layout/': typeof StaffPlacesLayoutIndexRoute
  '/_staff/places/add-select/': typeof StaffPlacesAddSelectIndexRoute
  '/_staff/places/add/': typeof StaffPlacesAddIndexRoute
  '/_staff/public-ids/$id/': typeof StaffPublicIdsIdIndexRoute
  '/_staff/public-ids/_list/': typeof StaffPublicIdsListIndexRoute
  '/_staff/public-ids/add/': typeof StaffPublicIdsAddIndexRoute
  '/_staff/settings/contracting-corporation-profile/': typeof StaffSettingsContractingCorporationProfileIndexRoute
  '/_staff/settings/permission-and-roles/': typeof StaffSettingsPermissionAndRolesIndexRoute
  '/_staff/settings/persons/': typeof StaffSettingsPersonsIndexRoute
  '/_staff/software/add/': typeof StaffSoftwareAddIndexRoute
  '/_staff/starlinks/_layout/': typeof StaffStarlinksLayoutIndexRoute
  '/_staff/storage-files/_list/': typeof StaffStorageFilesListIndexRoute
  '/_staff/supplier/_list/': typeof StaffSupplierListIndexRoute
  '/_staff/time-and-attendance/_layout/': typeof StaffTimeAndAttendanceLayoutIndexRoute
  '/auth/invitation/$invitationCode/': typeof AuthInvitationInvitationCodeIndexRoute
  '/auth/sign-in/error/': typeof AuthSignInErrorIndexRoute
  '/_staff/person/$id/_profile/': typeof StaffPersonIdProfileIndexRouteRoute
  '/_individual/individual/portal/lookup/clocking-record': typeof IndividualIndividualPortalLookupClockingRecordRouteRouteWithChildren
  '/_individual/individual/portal/lookup/pay-slip': typeof IndividualIndividualPortalLookupPaySlipRouteRouteWithChildren
  '/_staff/attendances/_layout/clocking-records/$employeeId': typeof StaffAttendancesLayoutClockingRecordsEmployeeIdRouteRouteWithChildren
  '/_staff/business-partner/_list/_placeholders/alerts': typeof StaffBusinessPartnerListPlaceholdersAlertsRouteRoute
  '/_staff/business-partner/_list/_placeholders/contract-and-cost': typeof StaffBusinessPartnerListPlaceholdersContractAndCostRouteRoute
  '/_staff/business-partner/_list/_placeholders/operation-activity': typeof StaffBusinessPartnerListPlaceholdersOperationActivityRouteRoute
  '/_staff/business-partner/_list/_placeholders/rule-and-policy': typeof StaffBusinessPartnerListPlaceholdersRuleAndPolicyRouteRoute
  '/_staff/business-partner/_list/_placeholders/settings': typeof StaffBusinessPartnerListPlaceholdersSettingsRouteRoute
  '/_staff/certification/_list/_placeholders/alerts': typeof StaffCertificationListPlaceholdersAlertsRouteRoute
  '/_staff/certification/_list/_placeholders/operation-activity': typeof StaffCertificationListPlaceholdersOperationActivityRouteRoute
  '/_staff/certification/_list/_placeholders/overview': typeof StaffCertificationListPlaceholdersOverviewRouteRoute
  '/_staff/certification/_list/_placeholders/rule-and-policy': typeof StaffCertificationListPlaceholdersRuleAndPolicyRouteRoute
  '/_staff/contract/_list/_placeholders/alerts': typeof StaffContractListPlaceholdersAlertsRouteRoute
  '/_staff/contract/_list/_placeholders/contract-and-cost': typeof StaffContractListPlaceholdersContractAndCostRouteRoute
  '/_staff/contract/_list/_placeholders/operation-activity': typeof StaffContractListPlaceholdersOperationActivityRouteRoute
  '/_staff/contract/_list/_placeholders/overview': typeof StaffContractListPlaceholdersOverviewRouteRoute
  '/_staff/contract/_list/_placeholders/people': typeof StaffContractListPlaceholdersPeopleRouteRoute
  '/_staff/deal/$dealId/_layout/flow': typeof StaffDealDealIdLayoutFlowRouteRoute
  '/_staff/deal/$dealId/_layout/structure': typeof StaffDealDealIdLayoutStructureRouteRoute
  '/_staff/payroll/_layout/pay-slips/$employeeId': typeof StaffPayrollLayoutPaySlipsEmployeeIdRouteRouteWithChildren
  '/_staff/software/_layout/marketplace/$id': typeof StaffSoftwareLayoutMarketplaceIdRouteRouteWithChildren
  '/_staff/supplier/$supplierId/_layout/files': typeof StaffSupplierSupplierIdLayoutFilesRouteRoute
  '/_staff/supplier/$supplierId/_layout/rules-and-policy': typeof StaffSupplierSupplierIdLayoutRulesAndPolicyRouteRoute
  '/_staff/supplier/$supplierId/_layout/settings': typeof StaffSupplierSupplierIdLayoutSettingsRouteRoute
  '/_staff/supplier/_list/_placeholders/alerts': typeof StaffSupplierListPlaceholdersAlertsRouteRoute
  '/_staff/supplier/_list/_placeholders/contract-and-cost': typeof StaffSupplierListPlaceholdersContractAndCostRouteRoute
  '/_staff/supplier/_list/_placeholders/operation-activity': typeof StaffSupplierListPlaceholdersOperationActivityRouteRoute
  '/_staff/supplier/_list/_placeholders/overview': typeof StaffSupplierListPlaceholdersOverviewRouteRoute
  '/_staff/supplier/_list/_placeholders/rule-and-policy': typeof StaffSupplierListPlaceholdersRuleAndPolicyRouteRoute
  '/_individual/individual/_profile/my-profile': typeof IndividualIndividualProfileMyProfileRouteWithChildren
  '/_individual/individual/_profile/my-profile/_layout': typeof IndividualIndividualProfileMyProfileLayoutRouteWithChildren
  '/_individual/individual/task/$id/approval-dialog': typeof IndividualIndividualTaskIdApprovalDialogRoute
  '/_staff/accesses/_layout/_placeholders/contract-and-cost': typeof StaffAccessesLayoutPlaceholdersContractAndCostRoute
  '/_staff/accesses/_layout/_placeholders/overview': typeof StaffAccessesLayoutPlaceholdersOverviewRoute
  '/_staff/accesses/_layout/_placeholders/software': typeof StaffAccessesLayoutPlaceholdersSoftwareRoute
  '/_staff/app-integrations/$id/_$id/$': typeof StaffAppIntegrationsIdIdSplatRoute
  '/_staff/business-partner/add/$businessPartnerType/completed': typeof StaffBusinessPartnerAddBusinessPartnerTypeCompletedRoute
  '/_staff/certification/add/$certificationKind/completed': typeof StaffCertificationAddCertificationKindCompletedRoute
  '/_staff/certification/handling-certification/$id': typeof StaffCertificationHandlingCertificationIdRouteWithChildren
  '/_staff/certification/handling-certification/$id/_layout': typeof StaffCertificationHandlingCertificationIdLayoutRouteWithChildren
  '/_staff/certification/specialty-certification/$id': typeof StaffCertificationSpecialtyCertificationIdRouteWithChildren
  '/_staff/certification/specialty-certification/$id/_layout': typeof StaffCertificationSpecialtyCertificationIdLayoutRouteWithChildren
  '/_staff/contract/add/subscription/completed': typeof StaffContractAddSubscriptionCompletedRoute
  '/_staff/deal/add/$direction/completed': typeof StaffDealAddDirectionCompletedRoute
  '/_staff/device-catalog/active/$id': typeof StaffDeviceCatalogActiveIdRouteWithChildren
  '/_staff/device-catalog/active/$id/_layout': typeof StaffDeviceCatalogActiveIdLayoutRouteWithChildren
  '/_staff/device-catalog/add/$deviceType/completed': typeof StaffDeviceCatalogAddDeviceTypeCompletedRoute
  '/_staff/device-catalog/draft/$id': typeof StaffDeviceCatalogDraftIdRouteWithChildren
  '/_staff/device-catalog/draft/$id/_layout': typeof StaffDeviceCatalogDraftIdLayoutRouteWithChildren
  '/_staff/devices/_list/contract-and-cost': typeof StaffDevicesListContractAndCostRouteWithChildren
  '/_staff/devices/_list/contract-and-cost/_contract-and-cost': typeof StaffDevicesListContractAndCostContractAndCostRouteWithChildren
  '/_staff/devices/add/$deviceType/completed': typeof StaffDevicesAddDeviceTypeCompletedRoute
  '/_staff/equipment/_layout/_placeholders/overview': typeof StaffEquipmentLayoutPlaceholdersOverviewRoute
  '/_staff/equipment/_layout/_placeholders/rule-and-policy': typeof StaffEquipmentLayoutPlaceholdersRuleAndPolicyRoute
  '/_staff/equipment/_layout/_placeholders/settings': typeof StaffEquipmentLayoutPlaceholdersSettingsRoute
  '/_staff/equipment/items/$id': typeof StaffEquipmentItemsIdRouteWithChildren
  '/_staff/equipment/items/$id/_detail': typeof StaffEquipmentItemsIdDetailRouteWithChildren
  '/_staff/ids/_layout/_placeholders/alerts': typeof StaffIdsLayoutPlaceholdersAlertsRoute
  '/_staff/ids/_layout/_placeholders/group-id': typeof StaffIdsLayoutPlaceholdersGroupIdRoute
  '/_staff/ids/_layout/_placeholders/operation-activity': typeof StaffIdsLayoutPlaceholdersOperationActivityRoute
  '/_staff/ids/_layout/_placeholders/overview': typeof StaffIdsLayoutPlaceholdersOverviewRoute
  '/_staff/ids/_layout/_placeholders/rule-and-policy': typeof StaffIdsLayoutPlaceholdersRuleAndPolicyRoute
  '/_staff/ids/_layout/_placeholders/settings': typeof StaffIdsLayoutPlaceholdersSettingsRoute
  '/_staff/ids/group-id/$id': typeof StaffIdsGroupIdIdRouteWithChildren
  '/_staff/ids/group-id/$id/_$id': typeof StaffIdsGroupIdIdIdRouteWithChildren
  '/_staff/it-operation-core/_root/in-house-packages/$packageId': typeof StaffItOperationCoreRootInHousePackagesPackageIdRouteWithChildren
  '/_staff/it-operation-core/_root/packages/$packageId': typeof StaffItOperationCoreRootPackagesPackageIdRoute
  '/_staff/labor-core/settings/profile/$profileId': typeof StaffLaborCoreSettingsProfileProfileIdRoute
  '/_staff/licenses/add/$allocationType/completed': typeof StaffLicensesAddAllocationTypeCompletedRoute
  '/_staff/marketplace/sent-orders/$orderId': typeof StaffMarketplaceSentOrdersOrderIdRouteWithChildren
  '/_staff/marketplace/sent-orders/$orderId/_layout': typeof StaffMarketplaceSentOrdersOrderIdLayoutRouteWithChildren
  '/_staff/networks/_layout/_placeholders/alerts': typeof StaffNetworksLayoutPlaceholdersAlertsRoute
  '/_staff/networks/_layout/_placeholders/contract-and-cost': typeof StaffNetworksLayoutPlaceholdersContractAndCostRoute
  '/_staff/networks/_layout/_placeholders/operation-activity': typeof StaffNetworksLayoutPlaceholdersOperationActivityRoute
  '/_staff/networks/_layout/_placeholders/overview': typeof StaffNetworksLayoutPlaceholdersOverviewRoute
  '/_staff/networks/_layout/_placeholders/rule-and-policy': typeof StaffNetworksLayoutPlaceholdersRuleAndPolicyRoute
  '/_staff/networks/_layout/_placeholders/settings': typeof StaffNetworksLayoutPlaceholdersSettingsRoute
  '/_staff/payroll/_layout/contract-and-cost': typeof StaffPayrollLayoutContractAndCostRouteWithChildren
  '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost': typeof StaffPayrollLayoutContractAndCostContractAndCostRouteWithChildren
  '/_staff/person/add-person-certification/$certificationKind/completed': typeof StaffPersonAddPersonCertificationCertificationKindCompletedRoute
  '/_staff/person/add/$workerType/completed': typeof StaffPersonAddWorkerTypeCompletedRoute
  '/_staff/person/alumni/$id': typeof StaffPersonAlumniIdRouteWithChildren
  '/_staff/person/alumni/$id/_profile': typeof StaffPersonAlumniIdProfileRouteWithChildren
  '/_staff/places/_layout/_placeholders/alerts': typeof StaffPlacesLayoutPlaceholdersAlertsRoute
  '/_staff/places/_layout/_placeholders/contract-and-cost': typeof StaffPlacesLayoutPlaceholdersContractAndCostRoute
  '/_staff/places/_layout/_placeholders/operation-activity': typeof StaffPlacesLayoutPlaceholdersOperationActivityRoute
  '/_staff/places/_layout/_placeholders/people': typeof StaffPlacesLayoutPlaceholdersPeopleRoute
  '/_staff/places/_layout/_placeholders/rule-and-policy': typeof StaffPlacesLayoutPlaceholdersRuleAndPolicyRoute
  '/_staff/places/_layout/_placeholders/store': typeof StaffPlacesLayoutPlaceholdersStoreRoute
  '/_staff/profile/device/$id/$': typeof StaffProfileDeviceIdSplatRoute
  '/_staff/settings/persons/_list/_account': typeof StaffSettingsPersonsListAccountRouteWithChildren
  '/_staff/software/$id/_$id/groups': typeof StaffSoftwareIdIdGroupsRoute
  '/_staff/software/$id/_$id/profiles': typeof StaffSoftwareIdIdProfilesRoute
  '/_staff/software/_layout/alerts': typeof StaffSoftwareLayoutAlertsRouteWithChildren
  '/_staff/software/_layout/alerts/_alerts': typeof StaffSoftwareLayoutAlertsAlertsRouteWithChildren
  '/_staff/software/_layout/contract-and-cost': typeof StaffSoftwareLayoutContractAndCostRouteWithChildren
  '/_staff/software/_layout/contract-and-cost/_contract-and-cost': typeof StaffSoftwareLayoutContractAndCostContractAndCostRouteWithChildren
  '/_staff/starlinks/_layout/_placeholders/billing-and-cost': typeof StaffStarlinksLayoutPlaceholdersBillingAndCostRoute
  '/_staff/starlinks/_layout/_placeholders/marketplace': typeof StaffStarlinksLayoutPlaceholdersMarketplaceRoute
  '/_staff/starlinks/_layout/_placeholders/operation-activity': typeof StaffStarlinksLayoutPlaceholdersOperationActivityRoute
  '/_staff/storage-files/files/$id': typeof StaffStorageFilesFilesIdRouteWithChildren
  '/_staff/storage-files/files/$id/_$id': typeof StaffStorageFilesFilesIdIdRouteWithChildren
  '/_staff/storage-files/folders/$id': typeof StaffStorageFilesFoldersIdRouteWithChildren
  '/_staff/storage-files/folders/$id/_$id': typeof StaffStorageFilesFoldersIdIdRouteWithChildren
  '/_staff/software/$id/_$id/settings': typeof StaffSoftwareIdIdSettingsRouteLazyRouteWithChildren
  '/_individual/individual/_tasks/approval-tasks/': typeof IndividualIndividualTasksApprovalTasksIndexRoute
  '/_individual/individual/_tasks/operation-tasks/': typeof IndividualIndividualTasksOperationTasksIndexRoute
  '/_individual/individual/_tasks/request-tasks/': typeof IndividualIndividualTasksRequestTasksIndexRoute
  '/_individual/individual/operation-package/$id/': typeof IndividualIndividualOperationPackageIdIndexRoute
  '/_individual/individual/portal/approvals/': typeof IndividualIndividualPortalApprovalsIndexRoute
  '/_individual/individual/portal/lookup/': typeof IndividualIndividualPortalLookupIndexRoute
  '/_individual/individual/portal/requests/': typeof IndividualIndividualPortalRequestsIndexRoute
  '/_individual/individual/task/$id/': typeof IndividualIndividualTaskIdIndexRoute
  '/_stacktrace/development-tickets/$ticketId/_layout/': typeof StacktraceDevelopmentTicketsTicketIdLayoutIndexRoute
  '/_stacktrace/issues/$id/_layout/': typeof StacktraceIssuesIdLayoutIndexRoute
  '/_stacktrace/issues/_layout/overview/': typeof StacktraceIssuesLayoutOverviewIndexRoute
  '/_stacktrace/product-roadmap/$roadmapId/_layout/': typeof StacktraceProductRoadmapRoadmapIdLayoutIndexRoute
  '/_stacktrace/production/$productionId/_layout/': typeof StacktraceProductionProductionIdLayoutIndexRoute
  '/_stacktrace/products/$id/_layout/': typeof StacktraceProductsIdLayoutIndexRoute
  '/_stacktrace/test-sets/$id/_layout/': typeof StacktraceTestSetsIdLayoutIndexRoute
  '/_stacktrace/test-suites/$id/_layout/': typeof StacktraceTestSuitesIdLayoutIndexRoute
  '/_stacktrace/values/$id/_layout/': typeof StacktraceValuesIdLayoutIndexRoute
  '/_staff/accesses/_layout/alerts/': typeof StaffAccessesLayoutAlertsIndexRoute
  '/_staff/accesses/_layout/list/': typeof StaffAccessesLayoutListIndexRoute
  '/_staff/accesses/_layout/settings/': typeof StaffAccessesLayoutSettingsIndexRoute
  '/_staff/attendance-core/_layout/archive/': typeof StaffAttendanceCoreLayoutArchiveIndexRoute
  '/_staff/attendance-core/_layout/config/': typeof StaffAttendanceCoreLayoutConfigIndexRoute
  '/_staff/attendance-core/_layout/dashboard/': typeof StaffAttendanceCoreLayoutDashboardIndexRoute
  '/_staff/attendance-core/_layout/operation-packages/': typeof StaffAttendanceCoreLayoutOperationPackagesIndexRoute
  '/_staff/attendance-engine/_layout/attendance-structures/': typeof StaffAttendanceEngineLayoutAttendanceStructuresIndexRoute
  '/_staff/attendance-engine/_layout/attendance-units/': typeof StaffAttendanceEngineLayoutAttendanceUnitsIndexRoute
  '/_staff/attendance-engine/_layout/items/': typeof StaffAttendanceEngineLayoutItemsIndexRoute
  '/_staff/attendance-engine/_layout/logic-components/': typeof StaffAttendanceEngineLayoutLogicComponentsIndexRoute
  '/_staff/attendances/_layout/alerts/': typeof StaffAttendancesLayoutAlertsIndexRoute
  '/_staff/attendances/_layout/clocking-records/': typeof StaffAttendancesLayoutClockingRecordsIndexRoute
  '/_staff/attendances/_layout/employees/': typeof StaffAttendancesLayoutEmployeesIndexRoute
  '/_staff/attendances/_layout/operation-activity/': typeof StaffAttendancesLayoutOperationActivityIndexRoute
  '/_staff/attendances/_layout/overview/': typeof StaffAttendancesLayoutOverviewIndexRoute
  '/_staff/attendances/_layout/rule-and-policy/': typeof StaffAttendancesLayoutRuleAndPolicyIndexRoute
  '/_staff/attendances/_layout/settings/': typeof StaffAttendancesLayoutSettingsIndexRoute
  '/_staff/business-partner/_list/terminated/': typeof StaffBusinessPartnerListTerminatedIndexRoute
  '/_staff/business-partner/add/$businessPartnerType/': typeof StaffBusinessPartnerAddBusinessPartnerTypeIndexRoute
  '/_staff/certification/_list/people/': typeof StaffCertificationListPeopleIndexRoute
  '/_staff/certification/_list/settings/': typeof StaffCertificationListSettingsIndexRoute
  '/_staff/certification/add/$certificationKind/': typeof StaffCertificationAddCertificationKindIndexRoute
  '/_staff/cockpit/approval/$id/': typeof StaffCockpitApprovalIdIndexRoute
  '/_staff/cockpit/task/$taskId/': typeof StaffCockpitTaskTaskIdIndexRoute
  '/_staff/contract/add/subscription/': typeof StaffContractAddSubscriptionIndexRoute
  '/_staff/contract/import-csv/$contractType/': typeof StaffContractImportCsvContractTypeIndexRoute
  '/_staff/contractor-core/_packages/archives/': typeof StaffContractorCorePackagesArchivesIndexRoute
  '/_staff/contractor-core/_packages/configs/': typeof StaffContractorCorePackagesConfigsIndexRoute
  '/_staff/contractor-core/config/$patternId/': typeof StaffContractorCoreConfigPatternIdIndexRoute
  '/_staff/deal/add/$direction/': typeof StaffDealAddDirectionIndexRoute
  '/_staff/device-catalog/add/$deviceType/': typeof StaffDeviceCatalogAddDeviceTypeIndexRoute
  '/_staff/devices/$id/_layout/': typeof StaffDevicesIdLayoutIndexRoute
  '/_staff/devices/_list/inventories/': typeof StaffDevicesListInventoriesIndexRoute
  '/_staff/devices/_list/inventory/': typeof StaffDevicesListInventoryIndexRoute
  '/_staff/devices/_list/people/': typeof StaffDevicesListPeopleIndexRoute
  '/_staff/devices/_list/settings/': typeof StaffDevicesListSettingsIndexRoute
  '/_staff/devices/add/$deviceType/': typeof StaffDevicesAddDeviceTypeIndexRoute
  '/_staff/devices/add/catalog/': typeof StaffDevicesAddCatalogIndexRoute
  '/_staff/equipment/_layout/alerts/': typeof StaffEquipmentLayoutAlertsIndexRoute
  '/_staff/equipment/_layout/items/': typeof StaffEquipmentLayoutItemsIndexRoute
  '/_staff/equipment/_layout/settings/': typeof StaffEquipmentLayoutSettingsIndexRoute
  '/_staff/fleets/_layout/_list/': typeof StaffFleetsLayoutListIndexRoute
  '/_staff/ga-operation-core/_packages/archives/': typeof StaffGaOperationCorePackagesArchivesIndexRoute
  '/_staff/ga-operation-core/_packages/configs/': typeof StaffGaOperationCorePackagesConfigsIndexRoute
  '/_staff/ga-operation-core/config/$patternId/': typeof StaffGaOperationCoreConfigPatternIdIndexRoute
  '/_staff/ids/_layout/people/': typeof StaffIdsLayoutPeopleIndexRoute
  '/_staff/ids/group-id/add/': typeof StaffIdsGroupIdAddIndexRoute
  '/_staff/it-operation-core/_root/archives/': typeof StaffItOperationCoreRootArchivesIndexRoute
  '/_staff/it-operation-core/_root/config/': typeof StaffItOperationCoreRootConfigIndexRoute
  '/_staff/it-operation-core/_root/in-house-packages/': typeof StaffItOperationCoreRootInHousePackagesIndexRoute
  '/_staff/it-operation-core/_root/packages/': typeof StaffItOperationCoreRootPackagesIndexRoute
  '/_staff/it-operation-core/config/$patternId/': typeof StaffItOperationCoreConfigPatternIdIndexRoute
  '/_staff/it-operation-core/self-report-patterns/$patternId/': typeof StaffItOperationCoreSelfReportPatternsPatternIdIndexRoute
  '/_staff/labor-core/_packages/archives/': typeof StaffLaborCorePackagesArchivesIndexRoute
  '/_staff/labor-core/_packages/configs/': typeof StaffLaborCorePackagesConfigsIndexRoute
  '/_staff/labor-core/_packages/settings/': typeof StaffLaborCorePackagesSettingsIndexRoute
  '/_staff/labor-core/config/$patternId/': typeof StaffLaborCoreConfigPatternIdIndexRoute
  '/_staff/licenses/_list/alerts/': typeof StaffLicensesListAlertsIndexRoute
  '/_staff/licenses/_list/contract-and-cost/': typeof StaffLicensesListContractAndCostIndexRoute
  '/_staff/licenses/_list/inventory/': typeof StaffLicensesListInventoryIndexRoute
  '/_staff/licenses/_list/operation-activity/': typeof StaffLicensesListOperationActivityIndexRoute
  '/_staff/licenses/_list/people/': typeof StaffLicensesListPeopleIndexRoute
  '/_staff/licenses/_list/rule-and-policy/': typeof StaffLicensesListRuleAndPolicyIndexRoute
  '/_staff/licenses/_list/settings/': typeof StaffLicensesListSettingsIndexRoute
  '/_staff/licenses/add/$allocationType/': typeof StaffLicensesAddAllocationTypeIndexRoute
  '/_staff/marketplace/sales-orders/$orderId/': typeof StaffMarketplaceSalesOrdersOrderIdIndexRoute
  '/_staff/organization/$id/_layout/': typeof StaffOrganizationIdLayoutIndexRoute
  '/_staff/organization/_list/alert/': typeof StaffOrganizationListAlertIndexRoute
  '/_staff/organization/_list/chart/': typeof StaffOrganizationListChartIndexRoute
  '/_staff/organization/_list/cost/': typeof StaffOrganizationListCostIndexRoute
  '/_staff/organization/_list/history/': typeof StaffOrganizationListHistoryIndexRoute
  '/_staff/organization/_list/rule-policy/': typeof StaffOrganizationListRulePolicyIndexRoute
  '/_staff/organization/_list/settings/': typeof StaffOrganizationListSettingsIndexRoute
  '/_staff/organization/plan/$id/': typeof StaffOrganizationPlanIdIndexRoute
  '/_staff/organization/plan/create/': typeof StaffOrganizationPlanCreateIndexRoute
  '/_staff/payroll-core/_layout/archive/': typeof StaffPayrollCoreLayoutArchiveIndexRoute
  '/_staff/payroll-core/_layout/config/': typeof StaffPayrollCoreLayoutConfigIndexRoute
  '/_staff/payroll-core/_layout/dashboard/': typeof StaffPayrollCoreLayoutDashboardIndexRoute
  '/_staff/payroll-core/_layout/operation-packages/': typeof StaffPayrollCoreLayoutOperationPackagesIndexRoute
  '/_staff/payroll-core/_layout/person-targets/': typeof StaffPayrollCoreLayoutPersonTargetsIndexRoute
  '/_staff/payroll-engine/_layout/items/': typeof StaffPayrollEngineLayoutItemsIndexRoute
  '/_staff/payroll-engine/_layout/logic-components/': typeof StaffPayrollEngineLayoutLogicComponentsIndexRoute
  '/_staff/payroll-engine/_layout/payroll-structures/': typeof StaffPayrollEngineLayoutPayrollStructuresIndexRoute
  '/_staff/payroll-engine/_layout/payroll-units/': typeof StaffPayrollEngineLayoutPayrollUnitsIndexRoute
  '/_staff/payroll/_layout/alerts/': typeof StaffPayrollLayoutAlertsIndexRoute
  '/_staff/payroll/_layout/overview/': typeof StaffPayrollLayoutOverviewIndexRoute
  '/_staff/payroll/_layout/pay-slips/': typeof StaffPayrollLayoutPaySlipsIndexRoute
  '/_staff/payroll/_layout/rule-and-policy/': typeof StaffPayrollLayoutRuleAndPolicyIndexRoute
  '/_staff/payroll/_layout/settings/': typeof StaffPayrollLayoutSettingsIndexRoute
  '/_staff/people/_list/alumni/': typeof StaffPeopleListAlumniIndexRoute
  '/_staff/people/_list/operation-activity/': typeof StaffPeopleListOperationActivityIndexRoute
  '/_staff/people/_list/settings/': typeof StaffPeopleListSettingsIndexRoute
  '/_staff/people/_list/workforce/': typeof StaffPeopleListWorkforceIndexRoute
  '/_staff/person/add-person-certification/$certificationKind/': typeof StaffPersonAddPersonCertificationCertificationKindIndexRoute
  '/_staff/person/add/$workerType/': typeof StaffPersonAddWorkerTypeIndexRoute
  '/_staff/person/automap-ingester/$workerType/': typeof StaffPersonAutomapIngesterWorkerTypeIndexRoute
  '/_staff/places/_layout/settings/': typeof StaffPlacesLayoutSettingsIndexRoute
  '/_staff/profile/device/$id/': typeof StaffProfileDeviceIdIndexRoute
  '/_staff/public-ids/$id/details/': typeof StaffPublicIdsIdDetailsIndexRoute
  '/_staff/public-ids/$id/files/': typeof StaffPublicIdsIdFilesIndexRoute
  '/_staff/public-ids/_list/alerts/': typeof StaffPublicIdsListAlertsIndexRoute
  '/_staff/public-ids/_list/members/': typeof StaffPublicIdsListMembersIndexRoute
  '/_staff/public-ids/_list/operation-activity/': typeof StaffPublicIdsListOperationActivityIndexRoute
  '/_staff/public-ids/_list/registry/': typeof StaffPublicIdsListRegistryIndexRoute
  '/_staff/public-ids/_list/rules-and-policies/': typeof StaffPublicIdsListRulesAndPoliciesIndexRoute
  '/_staff/public-ids/_list/settings/': typeof StaffPublicIdsListSettingsIndexRoute
  '/_staff/settings/data-connector/inbound/': typeof StaffSettingsDataConnectorInboundIndexRoute
  '/_staff/settings/data-connector/outbound/': typeof StaffSettingsDataConnectorOutboundIndexRoute
  '/_staff/settings/persons/invite/': typeof StaffSettingsPersonsInviteIndexRoute
  '/_staff/software/$id/_$id/': typeof StaffSoftwareIdIdIndexRoute
  '/_staff/software/_layout/library/': typeof StaffSoftwareLayoutLibraryIndexRoute
  '/_staff/software/_layout/operation-activity/': typeof StaffSoftwareLayoutOperationActivityIndexRoute
  '/_staff/software/_layout/people/': typeof StaffSoftwareLayoutPeopleIndexRoute
  '/_staff/software/_layout/registry/': typeof StaffSoftwareLayoutRegistryIndexRoute
  '/_staff/software/_layout/rule-and-policy/': typeof StaffSoftwareLayoutRuleAndPolicyIndexRoute
  '/_staff/software/_layout/settings/': typeof StaffSoftwareLayoutSettingsIndexRoute
  '/_staff/software/add/$type/': typeof StaffSoftwareAddTypeIndexRoute
  '/_staff/starlinks/_layout/alerts/': typeof StaffStarlinksLayoutAlertsIndexRoute
  '/_staff/starlinks/_layout/user-terminals/': typeof StaffStarlinksLayoutUserTerminalsIndexRoute
  '/_staff/storage-files/_list/files/': typeof StaffStorageFilesListFilesIndexRoute
  '/_staff/storage-files/_list/folders/': typeof StaffStorageFilesListFoldersIndexRoute
  '/_staff/storage-files/_list/settings/': typeof StaffStorageFilesListSettingsIndexRoute
  '/_staff/supplier/_list/settings/': typeof StaffSupplierListSettingsIndexRoute
  '/_staff/time-and-attendance/_layout/attendance-links/': typeof StaffTimeAndAttendanceLayoutAttendanceLinksIndexRoute
  '/_staff/equipment/$id/_layout/': typeof StaffEquipmentIdLayoutIndexLazyRoute
  '/_staff/licenses/$id/_profile/': typeof StaffLicensesIdProfileIndexLazyRoute
  '/_individual/individual/_profile/my-profile/_layout/': typeof IndividualIndividualProfileMyProfileLayoutIndexRouteRoute
  '/_staff/person/alumni/$id/_profile/': typeof StaffPersonAlumniIdProfileIndexRouteRoute
  '/_staff/contract/$id/_layout/_placeholders/approval-info': typeof StaffContractIdLayoutPlaceholdersApprovalInfoRouteRoute
  '/_staff/contract/$id/_layout/_placeholders/history': typeof StaffContractIdLayoutPlaceholdersHistoryRouteRoute
  '/_staff/contract/$id/_layout/_placeholders/operation-activity': typeof StaffContractIdLayoutPlaceholdersOperationActivityRouteRoute
  '/_staff/contract/$id/_layout/_placeholders/risk-provisions': typeof StaffContractIdLayoutPlaceholdersRiskProvisionsRouteRoute
  '/_staff/contract/$id/_layout/_placeholders/rule-and-policy': typeof StaffContractIdLayoutPlaceholdersRuleAndPolicyRouteRoute
  '/_stacktrace/products/$id/scope/$nodeId': typeof StacktraceProductsIdScopeNodeIdRouteWithChildren
  '/_stacktrace/products/$id/scope/$nodeId/_layout': typeof StacktraceProductsIdScopeNodeIdLayoutRouteWithChildren
  '/_stacktrace/test-suites/$id/_layout/test-plan': typeof StacktraceTestSuitesIdLayoutTestPlanRouteWithChildren
  '/_stacktrace/test-suites/$id/_layout/test-plan/_layout': typeof StacktraceTestSuitesIdLayoutTestPlanLayoutRouteWithChildren
  '/_stacktrace/test-suites/$id/_layout/test-review': typeof StacktraceTestSuitesIdLayoutTestReviewRouteWithChildren
  '/_stacktrace/test-suites/$id/_layout/test-review/_layout': typeof StacktraceTestSuitesIdLayoutTestReviewLayoutRouteWithChildren
  '/_staff/attendance-engine/_layout/attendance-structures/$structureId': typeof StaffAttendanceEngineLayoutAttendanceStructuresStructureIdRouteWithChildren
  '/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout': typeof StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutRouteWithChildren
  '/_staff/business-partner/$id/_layout/bp-role-info': typeof StaffBusinessPartnerIdLayoutBpRoleInfoRouteWithChildren
  '/_staff/business-partner/$id/_layout/bp-role-info/_layout': typeof StaffBusinessPartnerIdLayoutBpRoleInfoLayoutRouteWithChildren
  '/_staff/devices/add/catalog/$deviceType/completed': typeof StaffDevicesAddCatalogDeviceTypeCompletedRoute
  '/_staff/ids/group-id/add/from-scratch/completed': typeof StaffIdsGroupIdAddFromScratchCompletedRoute
  '/_staff/it-operation-core/_detail/operation-instances/$instanceId': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdRouteWithChildren
  '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRouteWithChildren
  '/_staff/it-operation-core/_root/in-house-packages/$packageId/start-targets': typeof StaffItOperationCoreRootInHousePackagesPackageIdStartTargetsRoute
  '/_staff/licenses/$id/service-plans/$licenseServiceId': typeof StaffLicensesIdServicePlansLicenseServiceIdRouteWithChildren
  '/_staff/licenses/$id/service-plans/$licenseServiceId/_detail': typeof StaffLicensesIdServicePlansLicenseServiceIdDetailRouteWithChildren
  '/_staff/marketplace/sent-orders/$orderId/_layout/activities': typeof StaffMarketplaceSentOrdersOrderIdLayoutActivitiesRoute
  '/_staff/payroll-engine/_layout/payroll-structures/$structureId': typeof StaffPayrollEngineLayoutPayrollStructuresStructureIdRouteWithChildren
  '/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout': typeof StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutRouteWithChildren
  '/_staff/settings/data-connector/inbound/aggregate-data-pipeline': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineRouteWithChildren
  '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/_list': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineListRouteWithChildren
  '/_staff/settings/data-connector/inbound/data-pipeline': typeof StaffSettingsDataConnectorInboundDataPipelineRouteWithChildren
  '/_staff/settings/data-connector/inbound/data-pipeline/_list': typeof StaffSettingsDataConnectorInboundDataPipelineListRouteWithChildren
  '/_staff/settings/data-connector/outbound/data-pipeline': typeof StaffSettingsDataConnectorOutboundDataPipelineRouteWithChildren
  '/_staff/settings/data-connector/outbound/data-pipeline/_list': typeof StaffSettingsDataConnectorOutboundDataPipelineListRouteWithChildren
  '/_staff/software/$id/_$id/contract-and-cost': typeof StaffSoftwareIdIdContractAndCostRouteWithChildren
  '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost': typeof StaffSoftwareIdIdContractAndCostContractAndCostRouteWithChildren
  '/_individual/individual/portal/lookup/clocking-record/alerts': typeof IndividualIndividualPortalLookupClockingRecordAlertsLazyRoute
  '/_individual/individual/portal/lookup/clocking-record/files': typeof IndividualIndividualPortalLookupClockingRecordFilesLazyRoute
  '/_individual/individual/portal/lookup/clocking-record/overview': typeof IndividualIndividualPortalLookupClockingRecordOverviewLazyRoute
  '/_individual/individual/portal/lookup/clocking-record/schedule': typeof IndividualIndividualPortalLookupClockingRecordScheduleLazyRoute
  '/_individual/individual/portal/lookup/pay-slip/alerts': typeof IndividualIndividualPortalLookupPaySlipAlertsLazyRoute
  '/_individual/individual/portal/lookup/pay-slip/files': typeof IndividualIndividualPortalLookupPaySlipFilesLazyRoute
  '/_individual/individual/portal/lookup/pay-slip/history': typeof IndividualIndividualPortalLookupPaySlipHistoryLazyRoute
  '/_individual/individual/portal/lookup/pay-slip/overview': typeof IndividualIndividualPortalLookupPaySlipOverviewLazyRoute
  '/_staff/attendances/_layout/clocking-records/$employeeId/alerts': typeof StaffAttendancesLayoutClockingRecordsEmployeeIdAlertsLazyRoute
  '/_staff/attendances/_layout/clocking-records/$employeeId/files': typeof StaffAttendancesLayoutClockingRecordsEmployeeIdFilesLazyRoute
  '/_staff/attendances/_layout/clocking-records/$employeeId/overview': typeof StaffAttendancesLayoutClockingRecordsEmployeeIdOverviewLazyRoute
  '/_staff/attendances/_layout/clocking-records/$employeeId/schedule': typeof StaffAttendancesLayoutClockingRecordsEmployeeIdScheduleLazyRoute
  '/_staff/attendances/_layout/clocking-records/$employeeId/settings': typeof StaffAttendancesLayoutClockingRecordsEmployeeIdSettingsLazyRoute
  '/_staff/payroll/_layout/pay-slips/$employeeId/alerts': typeof StaffPayrollLayoutPaySlipsEmployeeIdAlertsLazyRoute
  '/_staff/payroll/_layout/pay-slips/$employeeId/files': typeof StaffPayrollLayoutPaySlipsEmployeeIdFilesLazyRoute
  '/_staff/payroll/_layout/pay-slips/$employeeId/history': typeof StaffPayrollLayoutPaySlipsEmployeeIdHistoryLazyRoute
  '/_staff/payroll/_layout/pay-slips/$employeeId/overview': typeof StaffPayrollLayoutPaySlipsEmployeeIdOverviewLazyRoute
  '/_staff/payroll/_layout/pay-slips/$employeeId/settings': typeof StaffPayrollLayoutPaySlipsEmployeeIdSettingsLazyRoute
  '/_individual/individual/task/$id/approval/': typeof IndividualIndividualTaskIdApprovalIndexRoute
  '/_stacktrace/development-tickets/$ticketId/_layout/history/': typeof StacktraceDevelopmentTicketsTicketIdLayoutHistoryIndexRoute
  '/_stacktrace/issues/$id/_layout/history/': typeof StacktraceIssuesIdLayoutHistoryIndexRoute
  '/_stacktrace/product-roadmap/$roadmapId/_layout/detail/': typeof StacktraceProductRoadmapRoadmapIdLayoutDetailIndexRoute
  '/_stacktrace/product-roadmap/$roadmapId/_layout/history/': typeof StacktraceProductRoadmapRoadmapIdLayoutHistoryIndexRoute
  '/_stacktrace/production/$productionId/_layout/dev-scope/': typeof StacktraceProductionProductionIdLayoutDevScopeIndexRoute
  '/_stacktrace/production/$productionId/_layout/issue-scope/': typeof StacktraceProductionProductionIdLayoutIssueScopeIndexRoute
  '/_stacktrace/production/$productionId/_layout/product-scope/': typeof StacktraceProductionProductionIdLayoutProductScopeIndexRoute
  '/_stacktrace/production/$productionId/_layout/quality-scope/': typeof StacktraceProductionProductionIdLayoutQualityScopeIndexRoute
  '/_stacktrace/production/$productionId/_layout/value/': typeof StacktraceProductionProductionIdLayoutValueIndexRoute
  '/_stacktrace/products/$id/_layout/product-scope/': typeof StacktraceProductsIdLayoutProductScopeIndexRoute
  '/_stacktrace/test-sets/$id/_layout/conditions/': typeof StacktraceTestSetsIdLayoutConditionsIndexRoute
  '/_stacktrace/test-sets/$id/_layout/target-functions/': typeof StacktraceTestSetsIdLayoutTargetFunctionsIndexRoute
  '/_stacktrace/test-suites/$id/_layout/document/': typeof StacktraceTestSuitesIdLayoutDocumentIndexRoute
  '/_stacktrace/test-suites/$id/_layout/issues/': typeof StacktraceTestSuitesIdLayoutIssuesIndexRoute
  '/_stacktrace/test-suites/$id/_layout/overview/': typeof StacktraceTestSuitesIdLayoutOverviewIndexRoute
  '/_stacktrace/test-suites/$id/_layout/target-functions/': typeof StacktraceTestSuitesIdLayoutTargetFunctionsIndexRoute
  '/_stacktrace/test-suites/$id/_layout/test-set/': typeof StacktraceTestSuitesIdLayoutTestSetIndexRoute
  '/_stacktrace/values/$id/_layout/history/': typeof StacktraceValuesIdLayoutHistoryIndexRoute
  '/_stacktrace/values/$id/_layout/product-scope/': typeof StacktraceValuesIdLayoutProductScopeIndexRoute
  '/_staff/accesses/_layout/list/$traceableAppId/': typeof StaffAccessesLayoutListTraceableAppIdIndexRoute
  '/_staff/attendance-engine/_layout/attendance-units/$unitId/': typeof StaffAttendanceEngineLayoutAttendanceUnitsUnitIdIndexRoute
  '/_staff/attendance-engine/_layout/items/$componentId/': typeof StaffAttendanceEngineLayoutItemsComponentIdIndexRoute
  '/_staff/attendance-engine/_layout/logic-components/$componentId/': typeof StaffAttendanceEngineLayoutLogicComponentsComponentIdIndexRoute
  '/_staff/business-partner/$id/_layout/_index/': typeof StaffBusinessPartnerIdLayoutIndexIndexRoute
  '/_staff/business-partner/$id/_layout/address-and-contact/': typeof StaffBusinessPartnerIdLayoutAddressAndContactIndexRoute
  '/_staff/certification/$id/_layout/_index/': typeof StaffCertificationIdLayoutIndexIndexRoute
  '/_staff/certification/$id/_layout/certification-holders/': typeof StaffCertificationIdLayoutCertificationHoldersIndexRoute
  '/_staff/certification/$id/_layout/handling-certifications/': typeof StaffCertificationIdLayoutHandlingCertificationsIndexRoute
  '/_staff/certification/$id/_layout/specialty-certifications/': typeof StaffCertificationIdLayoutSpecialtyCertificationsIndexRoute
  '/_staff/certification/_list/settings/issuing-organization/': typeof StaffCertificationListSettingsIssuingOrganizationIndexRoute
  '/_staff/certification/_list/settings/specialty-category-level/': typeof StaffCertificationListSettingsSpecialtyCategoryLevelIndexRoute
  '/_staff/certification/_list/settings/specialty-category/': typeof StaffCertificationListSettingsSpecialtyCategoryIndexRoute
  '/_staff/deal/$dealId/_layout/_index/': typeof StaffDealDealIdLayoutIndexIndexRoute
  '/_staff/devices/$id/_layout/control/': typeof StaffDevicesIdLayoutControlIndexRoute
  '/_staff/devices/$id/_layout/files/': typeof StaffDevicesIdLayoutFilesIndexRoute
  '/_staff/devices/$id/_layout/history/': typeof StaffDevicesIdLayoutHistoryIndexRoute
  '/_staff/devices/$id/_layout/lifecycle/': typeof StaffDevicesIdLayoutLifecycleIndexRoute
  '/_staff/devices/$id/_layout/mdm/': typeof StaffDevicesIdLayoutMdmIndexRoute
  '/_staff/devices/$id/_layout/profile/': typeof StaffDevicesIdLayoutProfileIndexRoute
  '/_staff/devices/$id/_layout/status/': typeof StaffDevicesIdLayoutStatusIndexRoute
  '/_staff/devices/_list/contract-and-cost/_contract-and-cost/': typeof StaffDevicesListContractAndCostContractAndCostIndexRoute
  '/_staff/devices/_list/settings/catalog/': typeof StaffDevicesListSettingsCatalogIndexRoute
  '/_staff/devices/add/catalog/$deviceType/': typeof StaffDevicesAddCatalogDeviceTypeIndexRoute
  '/_staff/devices/external-it-saas/$appIntegrationId/preview/': typeof StaffDevicesExternalItSaasAppIntegrationIdPreviewIndexRoute
  '/_staff/equipment/_layout/settings/equipment-items/': typeof StaffEquipmentLayoutSettingsEquipmentItemsIndexRoute
  '/_staff/equipment/_layout/settings/equipment-types/': typeof StaffEquipmentLayoutSettingsEquipmentTypesIndexRoute
  '/_staff/equipment/items/$id/_detail/': typeof StaffEquipmentItemsIdDetailIndexRoute
  '/_staff/ids/group-id/$id/_$id/': typeof StaffIdsGroupIdIdIdIndexRoute
  '/_staff/ids/group-id/add/from-scratch/': typeof StaffIdsGroupIdAddFromScratchIndexRoute
  '/_staff/it-operation-core/_detail/operation-instances/$instanceId/': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdIndexRoute
  '/_staff/licenses/$id/_profile/assignments/': typeof StaffLicensesIdProfileAssignmentsIndexRoute
  '/_staff/licenses/$id/_profile/people/': typeof StaffLicensesIdProfilePeopleIndexRoute
  '/_staff/licenses/$id/_profile/rule-and-policy/': typeof StaffLicensesIdProfileRuleAndPolicyIndexRoute
  '/_staff/licenses/$id/_profile/service-plans/': typeof StaffLicensesIdProfileServicePlansIndexRoute
  '/_staff/marketplace/_store/store/devices/': typeof StaffMarketplaceStoreStoreDevicesIndexRoute
  '/_staff/marketplace/_store/store/licenses/': typeof StaffMarketplaceStoreStoreLicensesIndexRoute
  '/_staff/marketplace/_store/store/sales-orders/': typeof StaffMarketplaceStoreStoreSalesOrdersIndexRoute
  '/_staff/marketplace/_store/store/sent-orders/': typeof StaffMarketplaceStoreStoreSentOrdersIndexRoute
  '/_staff/marketplace/_store/store/starlinks/': typeof StaffMarketplaceStoreStoreStarlinksIndexRoute
  '/_staff/marketplace/sent-orders/$orderId/_layout/': typeof StaffMarketplaceSentOrdersOrderIdLayoutIndexRoute
  '/_staff/organization/$id/_layout/history/': typeof StaffOrganizationIdLayoutHistoryIndexRoute
  '/_staff/organization/plan/$id/add/': typeof StaffOrganizationPlanIdAddIndexRoute
  '/_staff/organization/plan/$id/transfers/': typeof StaffOrganizationPlanIdTransfersIndexRoute
  '/_staff/payroll-engine/_layout/items/$componentId/': typeof StaffPayrollEngineLayoutItemsComponentIdIndexRoute
  '/_staff/payroll-engine/_layout/logic-components/$componentId/': typeof StaffPayrollEngineLayoutLogicComponentsComponentIdIndexRoute
  '/_staff/payroll-engine/_layout/payroll-units/$unitId/': typeof StaffPayrollEngineLayoutPayrollUnitsUnitIdIndexRoute
  '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/': typeof StaffPayrollLayoutContractAndCostContractAndCostIndexRoute
  '/_staff/people/_list/settings/board-member-types/': typeof StaffPeopleListSettingsBoardMemberTypesIndexRoute
  '/_staff/people/_list/settings/collaborator-types/': typeof StaffPeopleListSettingsCollaboratorTypesIndexRoute
  '/_staff/people/_list/settings/contract-end-reasons/': typeof StaffPeopleListSettingsContractEndReasonsIndexRoute
  '/_staff/people/_list/settings/contractor-types/': typeof StaffPeopleListSettingsContractorTypesIndexRoute
  '/_staff/people/_list/settings/employee-sub-id-names/': typeof StaffPeopleListSettingsEmployeeSubIdNamesIndexRoute
  '/_staff/people/_list/settings/employment-types/': typeof StaffPeopleListSettingsEmploymentTypesIndexRoute
  '/_staff/people/_list/settings/grades/': typeof StaffPeopleListSettingsGradesIndexRoute
  '/_staff/people/_list/settings/health-insurance-associations/': typeof StaffPeopleListSettingsHealthInsuranceAssociationsIndexRoute
  '/_staff/people/_list/settings/job-competencies/': typeof StaffPeopleListSettingsJobCompetenciesIndexRoute
  '/_staff/people/_list/settings/job-functions/': typeof StaffPeopleListSettingsJobFunctionsIndexRoute
  '/_staff/people/_list/settings/job-grades/': typeof StaffPeopleListSettingsJobGradesIndexRoute
  '/_staff/people/_list/settings/job-levels/': typeof StaffPeopleListSettingsJobLevelsIndexRoute
  '/_staff/people/_list/settings/job-titles/': typeof StaffPeopleListSettingsJobTitlesIndexRoute
  '/_staff/people/_list/settings/job-types/': typeof StaffPeopleListSettingsJobTypesIndexRoute
  '/_staff/people/_list/settings/place-social-insurances/': typeof StaffPeopleListSettingsPlaceSocialInsurancesIndexRoute
  '/_staff/people/_list/settings/positions/': typeof StaffPeopleListSettingsPositionsIndexRoute
  '/_staff/people/_list/settings/retirement-reasons/': typeof StaffPeopleListSettingsRetirementReasonsIndexRoute
  '/_staff/people/_list/settings/work-mode/': typeof StaffPeopleListSettingsWorkModeIndexRoute
  '/_staff/person/$id/_profile/apps/': typeof StaffPersonIdProfileAppsIndexRoute
  '/_staff/person/$id/_profile/contractor-information/': typeof StaffPersonIdProfileContractorInformationIndexRoute
  '/_staff/person/$id/_profile/devices/': typeof StaffPersonIdProfileDevicesIndexRoute
  '/_staff/person/$id/_profile/education-and-qualification/': typeof StaffPersonIdProfileEducationAndQualificationIndexRoute
  '/_staff/person/$id/_profile/employee-information/': typeof StaffPersonIdProfileEmployeeInformationIndexRoute
  '/_staff/person/$id/_profile/equipment/': typeof StaffPersonIdProfileEquipmentIndexRoute
  '/_staff/person/$id/_profile/history/': typeof StaffPersonIdProfileHistoryIndexRoute
  '/_staff/person/$id/_profile/operation-activity/': typeof StaffPersonIdProfileOperationActivityIndexRoute
  '/_staff/person/$id/_profile/personal-information/': typeof StaffPersonIdProfilePersonalInformationIndexRoute
  '/_staff/person/$id/_profile/public-id/': typeof StaffPersonIdProfilePublicIdIndexRoute
  '/_staff/person/external-hr-saas/$appIntegrationId/preview/': typeof StaffPersonExternalHrSaasAppIntegrationIdPreviewIndexRoute
  '/_staff/places/$id/_layout/administrators/': typeof StaffPlacesIdLayoutAdministratorsIndexRoute
  '/_staff/places/$id/_layout/labor-core/': typeof StaffPlacesIdLayoutLaborCoreIndexRoute
  '/_staff/places/_layout/settings/place-sub-codes/': typeof StaffPlacesLayoutSettingsPlaceSubCodesIndexRoute
  '/_staff/settings/contracting-corporation-profile/_layout/board-member/': typeof StaffSettingsContractingCorporationProfileLayoutBoardMemberIndexRoute
  '/_staff/settings/contracting-corporation-profile/_layout/contact-points/': typeof StaffSettingsContractingCorporationProfileLayoutContactPointsIndexRoute
  '/_staff/settings/contracting-corporation-profile/_layout/corporate-overview/': typeof StaffSettingsContractingCorporationProfileLayoutCorporateOverviewIndexRoute
  '/_staff/settings/contracting-corporation-profile/_layout/group-companies/': typeof StaffSettingsContractingCorporationProfileLayoutGroupCompaniesIndexRoute
  '/_staff/settings/contracting-corporation-profile/_layout/history/': typeof StaffSettingsContractingCorporationProfileLayoutHistoryIndexRoute
  '/_staff/settings/contracting-corporation-profile/_layout/registration/': typeof StaffSettingsContractingCorporationProfileLayoutRegistrationIndexRoute
  '/_staff/settings/contracting-corporation-profile/_layout/shareholders/': typeof StaffSettingsContractingCorporationProfileLayoutShareholdersIndexRoute
  '/_staff/settings/permission-and-roles/_list/category-permissions/': typeof StaffSettingsPermissionAndRolesListCategoryPermissionsIndexRoute
  '/_staff/settings/permission-and-roles/_list/people-groups/': typeof StaffSettingsPermissionAndRolesListPeopleGroupsIndexRoute
  '/_staff/settings/permission-and-roles/_list/product-permissions/': typeof StaffSettingsPermissionAndRolesListProductPermissionsIndexRoute
  '/_staff/settings/permission-and-roles/_list/roles/': typeof StaffSettingsPermissionAndRolesListRolesIndexRoute
  '/_staff/settings/persons/_list/settings/': typeof StaffSettingsPersonsListSettingsIndexRoute
  '/_staff/software/$id/_$id/accounts/': typeof StaffSoftwareIdIdAccountsIndexRoute
  '/_staff/software/$id/_$id/activity-monitoring/': typeof StaffSoftwareIdIdActivityMonitoringIndexRoute
  '/_staff/software/$id/_$id/alerts/': typeof StaffSoftwareIdIdAlertsIndexRoute
  '/_staff/software/$id/_$id/architecture/': typeof StaffSoftwareIdIdArchitectureIndexRoute
  '/_staff/software/$id/_$id/detail/': typeof StaffSoftwareIdIdDetailIndexRoute
  '/_staff/software/$id/_$id/rule-and-policy/': typeof StaffSoftwareIdIdRuleAndPolicyIndexRoute
  '/_staff/software/$id/_$id/settings/': typeof StaffSoftwareIdIdSettingsIndexRoute
  '/_staff/software/_layout/alerts/_alerts/': typeof StaffSoftwareLayoutAlertsAlertsIndexRoute
  '/_staff/software/_layout/contract-and-cost/_contract-and-cost/': typeof StaffSoftwareLayoutContractAndCostContractAndCostIndexRoute
  '/_staff/software/_layout/library/search/': typeof StaffSoftwareLayoutLibrarySearchIndexRoute
  '/_staff/software/custom-saas/add/$customSaasType/': typeof StaffSoftwareCustomSaasAddCustomSaasTypeIndexRoute
  '/_staff/supplier/$supplierId/_layout/_index/': typeof StaffSupplierSupplierIdLayoutIndexIndexRoute
  '/_staff/supplier/_list/settings/procurement-categories/': typeof StaffSupplierListSettingsProcurementCategoriesIndexRoute
  '/_staff/supplier/_list/settings/supplier-categories/': typeof StaffSupplierListSettingsSupplierCategoriesIndexRoute
  '/_staff/supplier/_list/settings/supplier-subcategories/': typeof StaffSupplierListSettingsSupplierSubcategoriesIndexRoute
  '/_staff/time-and-attendance/_layout/_list/summary/': typeof StaffTimeAndAttendanceLayoutListSummaryIndexRoute
  '/_staff/time-and-attendance/_layout/attendance-links/$placeId/': typeof StaffTimeAndAttendanceLayoutAttendanceLinksPlaceIdIndexRoute
  '/_staff/users/$userId/_layout/_identity/': typeof StaffUsersUserIdLayoutIdentityIndexRoute
  '/_staff/users/$userId/_layout/sessions/': typeof StaffUsersUserIdLayoutSessionsIndexRoute
  '/_individual/individual/portal/lookup/clocking-record/': typeof IndividualIndividualPortalLookupClockingRecordIndexLazyRoute
  '/_individual/individual/portal/lookup/pay-slip/': typeof IndividualIndividualPortalLookupPaySlipIndexLazyRoute
  '/_staff/attendances/_layout/clocking-records/$employeeId/': typeof StaffAttendancesLayoutClockingRecordsEmployeeIdIndexLazyRoute
  '/_staff/contract/$id/_layout/_index/': typeof StaffContractIdLayoutIndexIndexLazyRoute
  '/_staff/contract/$id/_layout/structure/': typeof StaffContractIdLayoutStructureIndexLazyRoute
  '/_staff/equipment/$id/_layout/lifecycle/': typeof StaffEquipmentIdLayoutLifecycleIndexLazyRoute
  '/_staff/equipment/$id/_layout/status/': typeof StaffEquipmentIdLayoutStatusIndexLazyRoute
  '/_staff/fleets/$id/_layout/_profile/': typeof StaffFleetsIdLayoutProfileIndexLazyRoute
  '/_staff/networks/$id/_layout/_profile/': typeof StaffNetworksIdLayoutProfileIndexLazyRoute
  '/_staff/payroll/_layout/pay-slips/$employeeId/': typeof StaffPayrollLayoutPaySlipsEmployeeIdIndexLazyRoute
  '/_staff/places/$id/_layout/_profile/': typeof StaffPlacesIdLayoutProfileIndexLazyRoute
  '/_staff/starlinks/$id/_layout/_overview/': typeof StaffStarlinksIdLayoutOverviewIndexLazyRoute
  '/_staff/starlinks/$id/_layout/detail/': typeof StaffStarlinksIdLayoutDetailIndexLazyRoute
  '/_staff/storage-files/files/$id/_$id/': typeof StaffStorageFilesFilesIdIdIndexLazyRoute
  '/_staff/storage-files/folders/$id/_$id/': typeof StaffStorageFilesFoldersIdIdIndexLazyRoute
  '/_individual/individual/_profile/certifications/base-certifications/$id': typeof IndividualIndividualProfileCertificationsBaseCertificationsIdRouteWithChildren
  '/_individual/individual/_profile/certifications/base-certifications/$id/_layout': typeof IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutRouteWithChildren
  '/_individual/individual/_profile/certifications/handling-certifications/$id': typeof IndividualIndividualProfileCertificationsHandlingCertificationsIdRouteWithChildren
  '/_individual/individual/_profile/certifications/handling-certifications/$id/_layout': typeof IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutRouteWithChildren
  '/_individual/individual/_profile/certifications/specialty-certifications/$id': typeof IndividualIndividualProfileCertificationsSpecialtyCertificationsIdRouteWithChildren
  '/_individual/individual/_profile/certifications/specialty-certifications/$id/_layout': typeof IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutRouteWithChildren
  '/_staff/device-catalog/active/$id/_layout/contract-and-cost': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostRouteWithChildren
  '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostRouteWithChildren
  '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal': typeof StaffDevicesListContractAndCostContractAndCostDealRouteWithChildren
  '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal': typeof StaffDevicesListContractAndCostContractAndCostDealDealRouteWithChildren
  '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId': typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRouteWithChildren
  '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout': typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRouteWithChildren
  '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId': typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRouteWithChildren
  '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout': typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRouteWithChildren
  '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId': typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRouteWithChildren
  '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout': typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRouteWithChildren
  '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdRouteWithChildren
  '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailRouteWithChildren
  '/_staff/settings/data-connector/inbound/data-pipeline/$id': typeof StaffSettingsDataConnectorInboundDataPipelineIdRouteWithChildren
  '/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail': typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailRouteWithChildren
  '/_staff/settings/data-connector/outbound/data-pipeline/$id': typeof StaffSettingsDataConnectorOutboundDataPipelineIdRouteWithChildren
  '/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail': typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailRouteWithChildren
  '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealRouteWithChildren
  '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealRouteWithChildren
  '/_individual/individual/_profile/my-profile/_layout/devices/': typeof IndividualIndividualProfileMyProfileLayoutDevicesIndexRoute
  '/_individual/individual/_profile/my-profile/_layout/education-and-qualification/': typeof IndividualIndividualProfileMyProfileLayoutEducationAndQualificationIndexRoute
  '/_individual/individual/_profile/my-profile/_layout/softwares/': typeof IndividualIndividualProfileMyProfileLayoutSoftwaresIndexRoute
  '/_individual/individual/contract/$id/signature-request/$signatureRequestId/': typeof IndividualIndividualContractIdSignatureRequestSignatureRequestIdIndexRoute
  '/_individual/individual/operation-package/$id/pattern/$patternId/': typeof IndividualIndividualOperationPackageIdPatternPatternIdIndexRoute
  '/_individual/individual/operation-package/$id/target/$targetId/': typeof IndividualIndividualOperationPackageIdTargetTargetIdIndexRoute
  '/_stacktrace/production/$productionId/_layout/dev-scope/edit/': typeof StacktraceProductionProductionIdLayoutDevScopeEditIndexRoute
  '/_stacktrace/production/$productionId/_layout/issue-scope/edit/': typeof StacktraceProductionProductionIdLayoutIssueScopeEditIndexRoute
  '/_stacktrace/production/$productionId/_layout/value/edit/': typeof StacktraceProductionProductionIdLayoutValueEditIndexRoute
  '/_stacktrace/products/$id/scope/$nodeId/_layout/': typeof StacktraceProductsIdScopeNodeIdLayoutIndexRoute
  '/_stacktrace/test-suites/$id/_layout/test-plan/_layout/': typeof StacktraceTestSuitesIdLayoutTestPlanLayoutIndexRoute
  '/_stacktrace/test-suites/$id/_layout/test-review/_layout/': typeof StacktraceTestSuitesIdLayoutTestReviewLayoutIndexRoute
  '/_staff/accesses/_layout/alerts/detail/$shadowItAppId/': typeof StaffAccessesLayoutAlertsDetailShadowItAppIdIndexRoute
  '/_staff/accesses/_layout/alerts/dormancy/$softwareId/': typeof StaffAccessesLayoutAlertsDormancySoftwareIdIndexRoute
  '/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout/': typeof StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutIndexRoute
  '/_staff/business-partner/$id/_layout/bp-role-info/_layout/': typeof StaffBusinessPartnerIdLayoutBpRoleInfoLayoutIndexRoute
  '/_staff/certification/handling-certification/$id/_layout/_index/': typeof StaffCertificationHandlingCertificationIdLayoutIndexIndexRoute
  '/_staff/certification/handling-certification/$id/_layout/certification-holders/': typeof StaffCertificationHandlingCertificationIdLayoutCertificationHoldersIndexRoute
  '/_staff/certification/specialty-certification/$id/_layout/_index/': typeof StaffCertificationSpecialtyCertificationIdLayoutIndexIndexRoute
  '/_staff/certification/specialty-certification/$id/_layout/certification-holders/': typeof StaffCertificationSpecialtyCertificationIdLayoutCertificationHoldersIndexRoute
  '/_staff/certification/specialty-certification/$id/_layout/handling-certifications/': typeof StaffCertificationSpecialtyCertificationIdLayoutHandlingCertificationsIndexRoute
  '/_staff/device-catalog/active/$id/_layout/profile/': typeof StaffDeviceCatalogActiveIdLayoutProfileIndexRoute
  '/_staff/device-catalog/draft/$id/_layout/profile/': typeof StaffDeviceCatalogDraftIdLayoutProfileIndexRoute
  '/_staff/devices/_list/contract-and-cost/_contract-and-cost/cost/': typeof StaffDevicesListContractAndCostContractAndCostCostIndexRoute
  '/_staff/devices/_list/contract-and-cost/_contract-and-cost/payment/': typeof StaffDevicesListContractAndCostContractAndCostPaymentIndexRoute
  '/_staff/equipment/items/$id/_detail/alerts/': typeof StaffEquipmentItemsIdDetailAlertsIndexRoute
  '/_staff/equipment/items/$id/_detail/inventory/': typeof StaffEquipmentItemsIdDetailInventoryIndexRoute
  '/_staff/equipment/items/$id/_detail/rule-and-policy/': typeof StaffEquipmentItemsIdDetailRuleAndPolicyIndexRoute
  '/_staff/ids/group-id/$id/_$id/detail/': typeof StaffIdsGroupIdIdIdDetailIndexRoute
  '/_staff/ids/group-id/$id/_$id/devices/': typeof StaffIdsGroupIdIdIdDevicesIndexRoute
  '/_staff/ids/group-id/$id/_$id/members/': typeof StaffIdsGroupIdIdIdMembersIndexRoute
  '/_staff/ids/group-id/$id/_$id/rule-and-policy/': typeof StaffIdsGroupIdIdIdRuleAndPolicyIndexRoute
  '/_staff/ids/group-id/$id/_$id/security-and-auth/': typeof StaffIdsGroupIdIdIdSecurityAndAuthIndexRoute
  '/_staff/ids/group-id/$id/_$id/softwares/': typeof StaffIdsGroupIdIdIdSoftwaresIndexRoute
  '/_staff/marketplace/_store/store/devices/$productId/': typeof StaffMarketplaceStoreStoreDevicesProductIdIndexRoute
  '/_staff/marketplace/_store/store/licenses/$productId/': typeof StaffMarketplaceStoreStoreLicensesProductIdIndexRoute
  '/_staff/marketplace/_store/store/starlinks/$productId/': typeof StaffMarketplaceStoreStoreStarlinksProductIdIndexRoute
  '/_staff/organization/plan/$id/edit/$unitId/': typeof StaffOrganizationPlanIdEditUnitIdIndexRoute
  '/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout/': typeof StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutIndexRoute
  '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/cost/': typeof StaffPayrollLayoutContractAndCostContractAndCostCostIndexRoute
  '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/deal/': typeof StaffPayrollLayoutContractAndCostContractAndCostDealIndexRoute
  '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/payment/': typeof StaffPayrollLayoutContractAndCostContractAndCostPaymentIndexRoute
  '/_staff/person/$id/_profile/family/$familyPersonId/': typeof StaffPersonIdProfileFamilyFamilyPersonIdIndexRoute
  '/_staff/person/alumni/$id/_profile/apps/': typeof StaffPersonAlumniIdProfileAppsIndexRoute
  '/_staff/person/alumni/$id/_profile/contractor-information/': typeof StaffPersonAlumniIdProfileContractorInformationIndexRoute
  '/_staff/person/alumni/$id/_profile/devices/': typeof StaffPersonAlumniIdProfileDevicesIndexRoute
  '/_staff/person/alumni/$id/_profile/education-and-qualification/': typeof StaffPersonAlumniIdProfileEducationAndQualificationIndexRoute
  '/_staff/person/alumni/$id/_profile/employee-information/': typeof StaffPersonAlumniIdProfileEmployeeInformationIndexRoute
  '/_staff/person/alumni/$id/_profile/equipment/': typeof StaffPersonAlumniIdProfileEquipmentIndexRoute
  '/_staff/person/alumni/$id/_profile/history/': typeof StaffPersonAlumniIdProfileHistoryIndexRoute
  '/_staff/person/alumni/$id/_profile/operation-activity/': typeof StaffPersonAlumniIdProfileOperationActivityIndexRoute
  '/_staff/person/alumni/$id/_profile/personal-information/': typeof StaffPersonAlumniIdProfilePersonalInformationIndexRoute
  '/_staff/person/alumni/$id/_profile/public-id/': typeof StaffPersonAlumniIdProfilePublicIdIndexRoute
  '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/_list/': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineListIndexRoute
  '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/add/': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineAddIndexRoute
  '/_staff/settings/data-connector/inbound/data-pipeline/_list/': typeof StaffSettingsDataConnectorInboundDataPipelineListIndexRoute
  '/_staff/settings/data-connector/inbound/data-pipeline/add/': typeof StaffSettingsDataConnectorInboundDataPipelineAddIndexRoute
  '/_staff/settings/data-connector/outbound/data-pipeline/_list/': typeof StaffSettingsDataConnectorOutboundDataPipelineListIndexRoute
  '/_staff/settings/data-connector/outbound/data-pipeline/add/': typeof StaffSettingsDataConnectorOutboundDataPipelineAddIndexRoute
  '/_staff/settings/permission-and-roles/_detail/category-permissions/$id/': typeof StaffSettingsPermissionAndRolesDetailCategoryPermissionsIdIndexRoute
  '/_staff/settings/permission-and-roles/_detail/people-groups/$id/': typeof StaffSettingsPermissionAndRolesDetailPeopleGroupsIdIndexRoute
  '/_staff/settings/permission-and-roles/_detail/product-permissions/$id/': typeof StaffSettingsPermissionAndRolesDetailProductPermissionsIdIndexRoute
  '/_staff/settings/permission-and-roles/_detail/roles/$id/': typeof StaffSettingsPermissionAndRolesDetailRolesIdIndexRoute
  '/_staff/settings/permission-and-roles/_form/category-permissions/new/': typeof StaffSettingsPermissionAndRolesFormCategoryPermissionsNewIndexRoute
  '/_staff/settings/permission-and-roles/_form/people-groups/new/': typeof StaffSettingsPermissionAndRolesFormPeopleGroupsNewIndexRoute
  '/_staff/settings/permission-and-roles/_form/product-permissions/new/': typeof StaffSettingsPermissionAndRolesFormProductPermissionsNewIndexRoute
  '/_staff/settings/permission-and-roles/_form/roles/new/': typeof StaffSettingsPermissionAndRolesFormRolesNewIndexRoute
  '/_staff/settings/persons/_list/_account/individual/': typeof StaffSettingsPersonsListAccountIndividualIndexRoute
  '/_staff/settings/persons/_list/_account/staff/': typeof StaffSettingsPersonsListAccountStaffIndexRoute
  '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/': typeof StaffSoftwareIdIdContractAndCostContractAndCostIndexRoute
  '/_staff/software/$id/_$id/settings/integration/': typeof StaffSoftwareIdIdSettingsIntegrationIndexRoute
  '/_staff/software/$id/_$id/settings/role/': typeof StaffSoftwareIdIdSettingsRoleIndexRoute
  '/_staff/software/$id/_$id/settings/status/': typeof StaffSoftwareIdIdSettingsStatusIndexRoute
  '/_staff/software/_layout/alerts/_alerts/alumni/': typeof StaffSoftwareLayoutAlertsAlertsAlumniIndexRoute
  '/_staff/software/_layout/alerts/_alerts/inactive-user/': typeof StaffSoftwareLayoutAlertsAlertsInactiveUserIndexRoute
  '/_staff/software/_layout/alerts/_alerts/no-user/': typeof StaffSoftwareLayoutAlertsAlertsNoUserIndexRoute
  '/_staff/software/_layout/alerts/_alerts/no-worker/': typeof StaffSoftwareLayoutAlertsAlertsNoWorkerIndexRoute
  '/_staff/software/_layout/alerts/_alerts/violated-assignment/': typeof StaffSoftwareLayoutAlertsAlertsViolatedAssignmentIndexRoute
  '/_staff/software/_layout/alerts/_alerts/violated-role/': typeof StaffSoftwareLayoutAlertsAlertsViolatedRoleIndexRoute
  '/_staff/software/_layout/contract-and-cost/_contract-and-cost/cost/': typeof StaffSoftwareLayoutContractAndCostContractAndCostCostIndexRoute
  '/_staff/software/_layout/contract-and-cost/_contract-and-cost/payment/': typeof StaffSoftwareLayoutContractAndCostContractAndCostPaymentIndexRoute
  '/_staff/software/_layout/library/category/$category/': typeof StaffSoftwareLayoutLibraryCategoryCategoryIndexRoute
  '/_staff/software/_layout/library/detail/$softwareLibraryId/': typeof StaffSoftwareLayoutLibraryDetailSoftwareLibraryIdIndexRoute
  '/_staff/storage-files/folders/$id/_$id/files/': typeof StaffStorageFilesFoldersIdIdFilesIndexRoute
  '/_staff/storage-files/folders/$id/_$id/users/': typeof StaffStorageFilesFoldersIdIdUsersIndexRoute
  '/_staff/time-and-attendance/_layout/_list/summary/daily-place/': typeof StaffTimeAndAttendanceLayoutListSummaryDailyPlaceIndexRoute
  '/_staff/time-and-attendance/_layout/_list/summary/monthly-person/': typeof StaffTimeAndAttendanceLayoutListSummaryMonthlyPersonIndexRoute
  '/_staff/time-and-attendance/_layout/_list/summary/monthly-place/': typeof StaffTimeAndAttendanceLayoutListSummaryMonthlyPlaceIndexRoute
  '/_staff/equipment/items/$id/_detail/profile/': typeof StaffEquipmentItemsIdDetailProfileIndexLazyRoute
  '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealRouteWithChildren
  '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealRouteWithChildren
  '/_stacktrace/products/$id/scope/$nodeId/_layout/value/': typeof StacktraceProductsIdScopeNodeIdLayoutValueIndexRoute
  '/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout/structure/': typeof StaffAttendanceEngineLayoutAttendanceStructuresStructureIdLayoutStructureIndexRoute
  '/_staff/business-partner/$id/_layout/bp-role-info/_layout/$bpRole/': typeof StaffBusinessPartnerIdLayoutBpRoleInfoLayoutBpRoleIndexRoute
  '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostIndexRoute
  '/_staff/devices/_list/contract-and-cost/_contract-and-cost/cost/$period/': typeof StaffDevicesListContractAndCostContractAndCostCostPeriodIndexRoute
  '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/': typeof StaffDevicesListContractAndCostContractAndCostDealDealIndexRoute
  '/_staff/devices/_list/contract-and-cost/_contract-and-cost/payment/$period/': typeof StaffDevicesListContractAndCostContractAndCostPaymentPeriodIndexRoute
  '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/data/': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDataIndexRoute
  '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/detail/': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDetailIndexRoute
  '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/operation-activity/': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutOperationActivityIndexRoute
  '/_staff/licenses/$id/service-plans/$licenseServiceId/_detail/accounts/': typeof StaffLicensesIdServicePlansLicenseServiceIdDetailAccountsIndexRoute
  '/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout/structure/': typeof StaffPayrollEngineLayoutPayrollStructuresStructureIdLayoutStructureIndexRoute
  '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/cost/$period/': typeof StaffPayrollLayoutContractAndCostContractAndCostCostPeriodIndexRoute
  '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/payment/$period/': typeof StaffPayrollLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute
  '/_staff/settings/permission-and-roles/_form/category-permissions/$id/edit/': typeof StaffSettingsPermissionAndRolesFormCategoryPermissionsIdEditIndexRoute
  '/_staff/settings/permission-and-roles/_form/people-groups/$id/edit/': typeof StaffSettingsPermissionAndRolesFormPeopleGroupsIdEditIndexRoute
  '/_staff/settings/permission-and-roles/_form/product-permissions/$id/edit/': typeof StaffSettingsPermissionAndRolesFormProductPermissionsIdEditIndexRoute
  '/_staff/settings/permission-and-roles/_form/roles/$id/edit/': typeof StaffSettingsPermissionAndRolesFormRolesIdEditIndexRoute
  '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/cost/': typeof StaffSoftwareIdIdContractAndCostContractAndCostCostIndexRoute
  '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/payment/': typeof StaffSoftwareIdIdContractAndCostContractAndCostPaymentIndexRoute
  '/_staff/software/_layout/contract-and-cost/_contract-and-cost/cost/$period/': typeof StaffSoftwareLayoutContractAndCostContractAndCostCostPeriodIndexRoute
  '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealIndexRoute
  '/_staff/software/_layout/contract-and-cost/_contract-and-cost/payment/$period/': typeof StaffSoftwareLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute
  '/_staff/software/_layout/library/category/$category/search/': typeof StaffSoftwareLayoutLibraryCategoryCategorySearchIndexRoute
  '/_staff/software/_layout/marketplace/$id/install/finish/': typeof StaffSoftwareLayoutMarketplaceIdInstallFinishIndexRoute
  '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren
  '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile': typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren
  '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealRouteWithChildren
  '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealRouteWithChildren
  '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren
  '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile': typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren
  '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren
  '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile': typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren
  '/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId': typeof StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdRouteWithChildren
  '/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/_task-detail': typeof StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailRouteWithChildren
  '/_individual/individual/_profile/certifications/base-certifications/$id/_layout/_index/': typeof IndividualIndividualProfileCertificationsBaseCertificationsIdLayoutIndexIndexRoute
  '/_individual/individual/_profile/certifications/handling-certifications/$id/_layout/_index/': typeof IndividualIndividualProfileCertificationsHandlingCertificationsIdLayoutIndexIndexRoute
  '/_individual/individual/_profile/certifications/specialty-certifications/$id/_layout/_index/': typeof IndividualIndividualProfileCertificationsSpecialtyCertificationsIdLayoutIndexIndexRoute
  '/_individual/individual/task/$id/_operation-package/_common/form/$formId/': typeof IndividualIndividualTaskIdOperationPackageCommonFormFormIdIndexRoute
  '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/cost/': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostCostIndexRoute
  '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/payment/': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostPaymentIndexRoute
  '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/all/': typeof StaffDevicesListContractAndCostContractAndCostDealDealAllIndexRoute
  '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/contract/': typeof StaffDevicesListContractAndCostContractAndCostDealDealContractIndexRoute
  '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/estimate/': typeof StaffDevicesListContractAndCostContractAndCostDealDealEstimateIndexRoute
  '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/order/': typeof StaffDevicesListContractAndCostContractAndCostDealDealOrderIndexRoute
  '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/payment/': typeof StaffDevicesListContractAndCostContractAndCostDealDealPaymentIndexRoute
  '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/': typeof StaffDevicesListContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute
  '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout/_index/': typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
  '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout/_index/': typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
  '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout/_index/': typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
  '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/basic-info/': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailBasicInfoIndexRoute
  '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/execution-plan/': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailExecutionPlanIndexRoute
  '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/priority-setting/': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailPrioritySettingIndexRoute
  '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/tasks/': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdAggregateDetailTasksIndexRoute
  '/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/basic-settings/': typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailBasicSettingsIndexRoute
  '/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/data-link-settings/': typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailDataLinkSettingsIndexRoute
  '/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/execution-plan/': typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailExecutionPlanIndexRoute
  '/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/execution-results/': typeof StaffSettingsDataConnectorInboundDataPipelineIdPipelineDetailExecutionResultsIndexRoute
  '/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/basic-settings/': typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailBasicSettingsIndexRoute
  '/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/data-link-settings/': typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailDataLinkSettingsIndexRoute
  '/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/execution-plan/': typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailExecutionPlanIndexRoute
  '/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/execution-results/': typeof StaffSettingsDataConnectorOutboundDataPipelineIdDetailExecutionResultsIndexRoute
  '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/cost/$period/': typeof StaffSoftwareIdIdContractAndCostContractAndCostCostPeriodIndexRoute
  '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealIndexRoute
  '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/payment/$period/': typeof StaffSoftwareIdIdContractAndCostContractAndCostPaymentPeriodIndexRoute
  '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/all/': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealAllIndexRoute
  '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/contract/': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealContractIndexRoute
  '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/estimate/': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealEstimateIndexRoute
  '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/order/': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealOrderIndexRoute
  '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/payment/': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealPaymentIndexRoute
  '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/': typeof StaffSoftwareLayoutContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute
  '/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId': typeof StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren
  '/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile': typeof StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren
  '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/': typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/cost/$period/': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostCostPeriodIndexRoute
  '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealIndexRoute
  '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/payment/$period/': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostPaymentPeriodIndexRoute
  '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/': typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/': typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdTasksTaskIdChunksIndexRoute
  '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/all/': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealAllIndexRoute
  '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/contract/': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealContractIndexRoute
  '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/estimate/': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealEstimateIndexRoute
  '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/order/': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealOrderIndexRoute
  '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/payment/': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealPaymentIndexRoute
  '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/': typeof StaffSoftwareIdIdContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute
  '/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/': typeof StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/': typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
  '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/all/': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealAllIndexRoute
  '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/contract/': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealContractIndexRoute
  '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/estimate/': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealEstimateIndexRoute
  '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/order/': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealOrderIndexRoute
  '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/payment/': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealPaymentIndexRoute
  '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/': typeof StaffDeviceCatalogActiveIdLayoutContractAndCostContractAndCostDealDealVendorInvoiceIndexRoute
  '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/': typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
  '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/': typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
  '/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/_task-detail/chunks/': typeof StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdTaskDetailChunksIndexRoute
  '/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/': typeof StaffAttendanceCoreLayoutOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
  '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/$chunkId/result/': typeof StaffSettingsDataConnectorInboundAggregateDataPipelineIdTasksTaskIdChunksChunkIdResultIndexRoute
  '/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/chunks/$chunkId/result/': typeof StaffSettingsDataConnectorInboundDataPipelineIdExecutionResultsTaskIdChunksChunkIdResultIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/planning-operations-core'
    | '/product-planning-core'
    | '/qa-operations-core'
    | '/apps'
    | '/id-managements'
    | '/me'
    | '/development-tickets/import-csv'
    | '/issues/import-csv'
    | '/values/import-csv'
    | '/it-operation-core/device-inventory'
    | '/places/import-csv'
    | '/individual'
    | '/individual/portal'
    | '/issues'
    | '/product-roadmap'
    | '/test-sets'
    | '/test-suites'
    | '/values'
    | '/accesses'
    | '/apps/$'
    | '/attendance-core'
    | '/attendance-engine'
    | '/attendances'
    | '/business-operation-events'
    | '/business-partner'
    | '/certification'
    | '/contract'
    | '/contractor-core'
    | '/contractor-core/anchor-date'
    | '/contractor-core/contract-targets'
    | '/contractor-core/person-targets'
    | '/deal'
    | '/devices'
    | '/equipment'
    | '/fleets'
    | '/ga-operation-core'
    | '/id-managements/$'
    | '/ids'
    | '/it-operation-core'
    | '/it-operation-core/anchor-date'
    | '/it-operation-core/self-report-confirmation'
    | '/labor-core'
    | '/labor-core/anchor-date'
    | '/labor-core/contract-targets'
    | '/labor-core/government-application-confirmation'
    | '/labor-core/person-targets'
    | '/labor-core/year-end-adjustment-confirmation'
    | '/licenses'
    | '/marketplace'
    | '/networks'
    | '/organization'
    | '/payroll-core'
    | '/payroll-engine'
    | '/payroll'
    | '/people'
    | '/places'
    | '/public-ids/$id'
    | '/public-ids'
    | '/software'
    | '/starlinks'
    | '/storage-files'
    | '/supplier'
    | '/time-and-attendance'
    | '/labor-core/group-name'
    | '/chat'
    | '/cockpit-mock'
    | '/individual/'
    | '/development-tickets'
    | '/production'
    | '/products'
    | '/test-assets'
    | '/cockpit'
    | '/it-operation-core/'
    | '/organization/'
    | '/settings'
    | '/account/sso'
    | '/auth/password-reset'
    | '/auth/sign-in'
    | '/oauth2/consent'
    | '/oauth2/error'
    | '/oauth2/login'
    | '/oauth2/logout'
    | '/certification/'
    | '/licenses/'
    | '/app-integrations/import-csv/$id'
    | '/business-partner/import-csv/corporation'
    | '/business-partner/import-csv/individual'
    | '/devices/import-csv/$deviceType'
    | '/it-operation-core/in-house-packages'
    | '/it-operation-core/packages'
    | '/person/import-csv/$workerType'
    | '/places/settings'
    | '/public-ids/import-csv/$publicIdType'
    | '/software/$id/import-csv'
    | '/software/people'
    | '/development-tickets/$ticketId'
    | '/issues/$id'
    | '/product-roadmap/$roadmapId'
    | '/production/$productionId'
    | '/products/$id'
    | '/test-sets/$id'
    | '/test-suites/$id'
    | '/values/$id'
    | '/app-integrations/$id'
    | '/business-operation-events/archive'
    | '/business-operation-events/config'
    | '/business-operation-events/operation-activity'
    | '/business-operation-events/overview'
    | '/business-operation-events/rule-and-policy'
    | '/business-operation-events/settings'
    | '/business-partner/$id'
    | '/certification/$id'
    | '/contract/$id'
    | '/deal/$dealId'
    | '/devices/$id'
    | '/devices/alerts'
    | '/devices/operation-activity'
    | '/devices/rule-and-policy'
    | '/equipment/$id'
    | '/fleets/$id'
    | '/fleets/alerts'
    | '/fleets/overview'
    | '/fleets/rule-and-policy'
    | '/fleets/settings'
    | '/it-operation-core/device-inventory/data'
    | '/it-operation-core/device-inventory/detail'
    | '/labor-core/settings'
    | '/labor-core/settings/egov-callback'
    | '/licenses/$id'
    | '/networks/$id'
    | '/organization/$id'
    | '/people/alerts'
    | '/people/community'
    | '/people/people-graph'
    | '/people/rule-and-policy'
    | '/people/salary-and-payment'
    | '/person/$id'
    | '/places/$id'
    | '/places/overview'
    | '/settings/contracting-corporation-profile'
    | '/settings/permission-and-roles'
    | '/settings/persons'
    | '/software/$id'
    | '/software/integrations'
    | '/starlinks/$id'
    | '/supplier/$supplierId'
    | '/users/$userId'
    | '/devices/'
    | '/people/'
    | '/software/'
    | '/certification/settings'
    | '/devices/settings'
    | '/equipment/settings'
    | '/people/settings'
    | '/supplier/settings'
    | '/chat/$sessionId'
    | '/chat/new'
    | '/idp-sso/google-workspace'
    | '/individual/portal/'
    | '/development-tickets/add-select'
    | '/development-tickets/add'
    | '/development-tickets/external-integrations'
    | '/issues/'
    | '/issues/add-select'
    | '/issues/add'
    | '/issues/external-integrations'
    | '/product-roadmap/'
    | '/products/add-select'
    | '/products/add'
    | '/test-sets/'
    | '/test-suites/'
    | '/values/'
    | '/values/add-select'
    | '/values/add'
    | '/accesses/'
    | '/attendance-core/'
    | '/attendance-engine/'
    | '/attendances/'
    | '/business-operation-events/$eventInstanceId'
    | '/business-operation-events/'
    | '/business-partner/'
    | '/business-partner/add'
    | '/certification/add'
    | '/contract/'
    | '/contract/add'
    | '/contractor-core/'
    | '/deal/'
    | '/deal/add'
    | '/device-catalog/add'
    | '/devices/add'
    | '/devices/external-it-saas'
    | '/equipment/'
    | '/equipment/add-select'
    | '/equipment/add'
    | '/equipment/import-csv'
    | '/fleets/add-select'
    | '/fleets/add'
    | '/ga-operation-core/'
    | '/ids/'
    | '/it-operation-core/device-targets'
    | '/it-operation-core/person-targets'
    | '/labor-core/'
    | '/licenses/add'
    | '/marketplace/cart'
    | '/marketplace/unavailable'
    | '/networks/'
    | '/networks/add'
    | '/organization/plan'
    | '/payroll-core/'
    | '/payroll-engine/'
    | '/payroll/'
    | '/person/add-person-certification'
    | '/person/add'
    | '/person/external-hr-saas'
    | '/places/'
    | '/places/add-select'
    | '/places/add'
    | '/public-ids/$id/'
    | '/public-ids/'
    | '/public-ids/add'
    | '/settings/contracting-corporation-profile/'
    | '/settings/permission-and-roles/'
    | '/settings/persons/'
    | '/software/add'
    | '/starlinks/'
    | '/storage-files/'
    | '/supplier/'
    | '/time-and-attendance/'
    | '/auth/invitation/$invitationCode'
    | '/auth/sign-in/error'
    | '/person/$id/'
    | '/individual/portal/lookup/clocking-record'
    | '/individual/portal/lookup/pay-slip'
    | '/attendances/clocking-records/$employeeId'
    | '/business-partner/alerts'
    | '/business-partner/contract-and-cost'
    | '/business-partner/operation-activity'
    | '/business-partner/rule-and-policy'
    | '/business-partner/settings'
    | '/certification/alerts'
    | '/certification/operation-activity'
    | '/certification/overview'
    | '/certification/rule-and-policy'
    | '/contract/alerts'
    | '/contract/contract-and-cost'
    | '/contract/operation-activity'
    | '/contract/overview'
    | '/contract/people'
    | '/deal/$dealId/flow'
    | '/deal/$dealId/structure'
    | '/payroll/pay-slips/$employeeId'
    | '/software/marketplace/$id'
    | '/supplier/$supplierId/files'
    | '/supplier/$supplierId/rules-and-policy'
    | '/supplier/$supplierId/settings'
    | '/supplier/alerts'
    | '/supplier/contract-and-cost'
    | '/supplier/operation-activity'
    | '/supplier/overview'
    | '/supplier/rule-and-policy'
    | '/individual/my-profile'
    | '/individual/task/$id/approval-dialog'
    | '/accesses/contract-and-cost'
    | '/accesses/overview'
    | '/accesses/software'
    | '/app-integrations/$id/$'
    | '/business-partner/add/$businessPartnerType/completed'
    | '/certification/add/$certificationKind/completed'
    | '/certification/handling-certification/$id'
    | '/certification/specialty-certification/$id'
    | '/contract/add/subscription/completed'
    | '/deal/add/$direction/completed'
    | '/device-catalog/active/$id'
    | '/device-catalog/add/$deviceType/completed'
    | '/device-catalog/draft/$id'
    | '/devices/contract-and-cost'
    | '/devices/add/$deviceType/completed'
    | '/equipment/overview'
    | '/equipment/rule-and-policy'
    | '/equipment/items/$id'
    | '/ids/alerts'
    | '/ids/group-id'
    | '/ids/operation-activity'
    | '/ids/overview'
    | '/ids/rule-and-policy'
    | '/ids/settings'
    | '/ids/group-id/$id'
    | '/it-operation-core/in-house-packages/$packageId'
    | '/it-operation-core/packages/$packageId'
    | '/labor-core/settings/profile/$profileId'
    | '/licenses/add/$allocationType/completed'
    | '/marketplace/sent-orders/$orderId'
    | '/networks/alerts'
    | '/networks/contract-and-cost'
    | '/networks/operation-activity'
    | '/networks/overview'
    | '/networks/rule-and-policy'
    | '/networks/settings'
    | '/payroll/contract-and-cost'
    | '/person/add-person-certification/$certificationKind/completed'
    | '/person/add/$workerType/completed'
    | '/person/alumni/$id'
    | '/places/alerts'
    | '/places/contract-and-cost'
    | '/places/operation-activity'
    | '/places/people'
    | '/places/rule-and-policy'
    | '/places/store'
    | '/profile/device/$id/$'
    | '/software/$id/groups'
    | '/software/$id/profiles'
    | '/software/alerts'
    | '/software/contract-and-cost'
    | '/starlinks/billing-and-cost'
    | '/starlinks/marketplace'
    | '/starlinks/operation-activity'
    | '/storage-files/files/$id'
    | '/storage-files/folders/$id'
    | '/software/$id/settings'
    | '/individual/approval-tasks'
    | '/individual/operation-tasks'
    | '/individual/request-tasks'
    | '/individual/operation-package/$id'
    | '/individual/portal/approvals'
    | '/individual/portal/lookup'
    | '/individual/portal/requests'
    | '/individual/task/$id'
    | '/development-tickets/$ticketId/'
    | '/issues/$id/'
    | '/issues/overview'
    | '/product-roadmap/$roadmapId/'
    | '/production/$productionId/'
    | '/products/$id/'
    | '/test-sets/$id/'
    | '/test-suites/$id/'
    | '/values/$id/'
    | '/accesses/alerts'
    | '/accesses/list'
    | '/accesses/settings'
    | '/attendance-core/archive'
    | '/attendance-core/config'
    | '/attendance-core/dashboard'
    | '/attendance-core/operation-packages'
    | '/attendance-engine/attendance-structures'
    | '/attendance-engine/attendance-units'
    | '/attendance-engine/items'
    | '/attendance-engine/logic-components'
    | '/attendances/alerts'
    | '/attendances/clocking-records'
    | '/attendances/employees'
    | '/attendances/operation-activity'
    | '/attendances/overview'
    | '/attendances/rule-and-policy'
    | '/attendances/settings'
    | '/business-partner/terminated'
    | '/business-partner/add/$businessPartnerType'
    | '/certification/people'
    | '/certification/settings/'
    | '/certification/add/$certificationKind'
    | '/cockpit/approval/$id'
    | '/cockpit/task/$taskId'
    | '/contract/add/subscription'
    | '/contract/import-csv/$contractType'
    | '/contractor-core/archives'
    | '/contractor-core/configs'
    | '/contractor-core/config/$patternId'
    | '/deal/add/$direction'
    | '/device-catalog/add/$deviceType'
    | '/devices/$id/'
    | '/devices/inventories'
    | '/devices/inventory'
    | '/devices/people'
    | '/devices/settings/'
    | '/devices/add/$deviceType'
    | '/devices/add/catalog'
    | '/equipment/alerts'
    | '/equipment/items'
    | '/equipment/settings/'
    | '/fleets/'
    | '/ga-operation-core/archives'
    | '/ga-operation-core/configs'
    | '/ga-operation-core/config/$patternId'
    | '/ids/people'
    | '/ids/group-id/add'
    | '/it-operation-core/archives'
    | '/it-operation-core/config'
    | '/it-operation-core/in-house-packages/'
    | '/it-operation-core/packages/'
    | '/it-operation-core/config/$patternId'
    | '/it-operation-core/self-report-patterns/$patternId'
    | '/labor-core/archives'
    | '/labor-core/configs'
    | '/labor-core/settings/'
    | '/labor-core/config/$patternId'
    | '/licenses/alerts'
    | '/licenses/contract-and-cost'
    | '/licenses/inventory'
    | '/licenses/operation-activity'
    | '/licenses/people'
    | '/licenses/rule-and-policy'
    | '/licenses/settings'
    | '/licenses/add/$allocationType'
    | '/marketplace/sales-orders/$orderId'
    | '/organization/$id/'
    | '/organization/alert'
    | '/organization/chart'
    | '/organization/cost'
    | '/organization/history'
    | '/organization/rule-policy'
    | '/organization/settings'
    | '/organization/plan/$id'
    | '/organization/plan/create'
    | '/payroll-core/archive'
    | '/payroll-core/config'
    | '/payroll-core/dashboard'
    | '/payroll-core/operation-packages'
    | '/payroll-core/person-targets'
    | '/payroll-engine/items'
    | '/payroll-engine/logic-components'
    | '/payroll-engine/payroll-structures'
    | '/payroll-engine/payroll-units'
    | '/payroll/alerts'
    | '/payroll/overview'
    | '/payroll/pay-slips'
    | '/payroll/rule-and-policy'
    | '/payroll/settings'
    | '/people/alumni'
    | '/people/operation-activity'
    | '/people/settings/'
    | '/people/workforce'
    | '/person/add-person-certification/$certificationKind'
    | '/person/add/$workerType'
    | '/person/automap-ingester/$workerType'
    | '/places/settings/'
    | '/profile/device/$id'
    | '/public-ids/$id/details'
    | '/public-ids/$id/files'
    | '/public-ids/alerts'
    | '/public-ids/members'
    | '/public-ids/operation-activity'
    | '/public-ids/registry'
    | '/public-ids/rules-and-policies'
    | '/public-ids/settings'
    | '/settings/data-connector/inbound'
    | '/settings/data-connector/outbound'
    | '/settings/persons/invite'
    | '/software/$id/'
    | '/software/library'
    | '/software/operation-activity'
    | '/software/people/'
    | '/software/registry'
    | '/software/rule-and-policy'
    | '/software/settings'
    | '/software/add/$type'
    | '/starlinks/alerts'
    | '/starlinks/user-terminals'
    | '/storage-files/files'
    | '/storage-files/folders'
    | '/storage-files/settings'
    | '/supplier/settings/'
    | '/time-and-attendance/attendance-links'
    | '/equipment/$id/'
    | '/licenses/$id/'
    | '/individual/my-profile/'
    | '/person/alumni/$id/'
    | '/contract/$id/approval-info'
    | '/contract/$id/history'
    | '/contract/$id/operation-activity'
    | '/contract/$id/risk-provisions'
    | '/contract/$id/rule-and-policy'
    | '/products/$id/scope/$nodeId'
    | '/test-suites/$id/test-plan'
    | '/test-suites/$id/test-review'
    | '/attendance-engine/attendance-structures/$structureId'
    | '/business-partner/$id/bp-role-info'
    | '/devices/add/catalog/$deviceType/completed'
    | '/ids/group-id/add/from-scratch/completed'
    | '/it-operation-core/operation-instances/$instanceId'
    | '/it-operation-core/in-house-packages/$packageId/start-targets'
    | '/licenses/$id/service-plans/$licenseServiceId'
    | '/marketplace/sent-orders/$orderId/activities'
    | '/payroll-engine/payroll-structures/$structureId'
    | '/settings/data-connector/inbound/aggregate-data-pipeline'
    | '/settings/data-connector/inbound/data-pipeline'
    | '/settings/data-connector/outbound/data-pipeline'
    | '/software/$id/contract-and-cost'
    | '/individual/portal/lookup/clocking-record/alerts'
    | '/individual/portal/lookup/clocking-record/files'
    | '/individual/portal/lookup/clocking-record/overview'
    | '/individual/portal/lookup/clocking-record/schedule'
    | '/individual/portal/lookup/pay-slip/alerts'
    | '/individual/portal/lookup/pay-slip/files'
    | '/individual/portal/lookup/pay-slip/history'
    | '/individual/portal/lookup/pay-slip/overview'
    | '/attendances/clocking-records/$employeeId/alerts'
    | '/attendances/clocking-records/$employeeId/files'
    | '/attendances/clocking-records/$employeeId/overview'
    | '/attendances/clocking-records/$employeeId/schedule'
    | '/attendances/clocking-records/$employeeId/settings'
    | '/payroll/pay-slips/$employeeId/alerts'
    | '/payroll/pay-slips/$employeeId/files'
    | '/payroll/pay-slips/$employeeId/history'
    | '/payroll/pay-slips/$employeeId/overview'
    | '/payroll/pay-slips/$employeeId/settings'
    | '/individual/task/$id/approval'
    | '/development-tickets/$ticketId/history'
    | '/issues/$id/history'
    | '/product-roadmap/$roadmapId/detail'
    | '/product-roadmap/$roadmapId/history'
    | '/production/$productionId/dev-scope'
    | '/production/$productionId/issue-scope'
    | '/production/$productionId/product-scope'
    | '/production/$productionId/quality-scope'
    | '/production/$productionId/value'
    | '/products/$id/product-scope'
    | '/test-sets/$id/conditions'
    | '/test-sets/$id/target-functions'
    | '/test-suites/$id/document'
    | '/test-suites/$id/issues'
    | '/test-suites/$id/overview'
    | '/test-suites/$id/target-functions'
    | '/test-suites/$id/test-set'
    | '/values/$id/history'
    | '/values/$id/product-scope'
    | '/accesses/list/$traceableAppId'
    | '/attendance-engine/attendance-units/$unitId'
    | '/attendance-engine/items/$componentId'
    | '/attendance-engine/logic-components/$componentId'
    | '/business-partner/$id/'
    | '/business-partner/$id/address-and-contact'
    | '/certification/$id/'
    | '/certification/$id/certification-holders'
    | '/certification/$id/handling-certifications'
    | '/certification/$id/specialty-certifications'
    | '/certification/settings/issuing-organization'
    | '/certification/settings/specialty-category-level'
    | '/certification/settings/specialty-category'
    | '/deal/$dealId/'
    | '/devices/$id/control'
    | '/devices/$id/files'
    | '/devices/$id/history'
    | '/devices/$id/lifecycle'
    | '/devices/$id/mdm'
    | '/devices/$id/profile'
    | '/devices/$id/status'
    | '/devices/contract-and-cost/'
    | '/devices/settings/catalog'
    | '/devices/add/catalog/$deviceType'
    | '/devices/external-it-saas/$appIntegrationId/preview'
    | '/equipment/settings/equipment-items'
    | '/equipment/settings/equipment-types'
    | '/equipment/items/$id/'
    | '/ids/group-id/$id/'
    | '/ids/group-id/add/from-scratch'
    | '/it-operation-core/operation-instances/$instanceId/'
    | '/licenses/$id/assignments'
    | '/licenses/$id/people'
    | '/licenses/$id/rule-and-policy'
    | '/licenses/$id/service-plans'
    | '/marketplace/store/devices'
    | '/marketplace/store/licenses'
    | '/marketplace/store/sales-orders'
    | '/marketplace/store/sent-orders'
    | '/marketplace/store/starlinks'
    | '/marketplace/sent-orders/$orderId/'
    | '/organization/$id/history'
    | '/organization/plan/$id/add'
    | '/organization/plan/$id/transfers'
    | '/payroll-engine/items/$componentId'
    | '/payroll-engine/logic-components/$componentId'
    | '/payroll-engine/payroll-units/$unitId'
    | '/payroll/contract-and-cost/'
    | '/people/settings/board-member-types'
    | '/people/settings/collaborator-types'
    | '/people/settings/contract-end-reasons'
    | '/people/settings/contractor-types'
    | '/people/settings/employee-sub-id-names'
    | '/people/settings/employment-types'
    | '/people/settings/grades'
    | '/people/settings/health-insurance-associations'
    | '/people/settings/job-competencies'
    | '/people/settings/job-functions'
    | '/people/settings/job-grades'
    | '/people/settings/job-levels'
    | '/people/settings/job-titles'
    | '/people/settings/job-types'
    | '/people/settings/place-social-insurances'
    | '/people/settings/positions'
    | '/people/settings/retirement-reasons'
    | '/people/settings/work-mode'
    | '/person/$id/apps'
    | '/person/$id/contractor-information'
    | '/person/$id/devices'
    | '/person/$id/education-and-qualification'
    | '/person/$id/employee-information'
    | '/person/$id/equipment'
    | '/person/$id/history'
    | '/person/$id/operation-activity'
    | '/person/$id/personal-information'
    | '/person/$id/public-id'
    | '/person/external-hr-saas/$appIntegrationId/preview'
    | '/places/$id/administrators'
    | '/places/$id/labor-core'
    | '/places/settings/place-sub-codes'
    | '/settings/contracting-corporation-profile/board-member'
    | '/settings/contracting-corporation-profile/contact-points'
    | '/settings/contracting-corporation-profile/corporate-overview'
    | '/settings/contracting-corporation-profile/group-companies'
    | '/settings/contracting-corporation-profile/history'
    | '/settings/contracting-corporation-profile/registration'
    | '/settings/contracting-corporation-profile/shareholders'
    | '/settings/permission-and-roles/category-permissions'
    | '/settings/permission-and-roles/people-groups'
    | '/settings/permission-and-roles/product-permissions'
    | '/settings/permission-and-roles/roles'
    | '/settings/persons/settings'
    | '/software/$id/accounts'
    | '/software/$id/activity-monitoring'
    | '/software/$id/alerts'
    | '/software/$id/architecture'
    | '/software/$id/detail'
    | '/software/$id/rule-and-policy'
    | '/software/$id/settings/'
    | '/software/alerts/'
    | '/software/contract-and-cost/'
    | '/software/library/search'
    | '/software/custom-saas/add/$customSaasType'
    | '/supplier/$supplierId/'
    | '/supplier/settings/procurement-categories'
    | '/supplier/settings/supplier-categories'
    | '/supplier/settings/supplier-subcategories'
    | '/time-and-attendance/summary'
    | '/time-and-attendance/attendance-links/$placeId'
    | '/users/$userId/'
    | '/users/$userId/sessions'
    | '/individual/portal/lookup/clocking-record/'
    | '/individual/portal/lookup/pay-slip/'
    | '/attendances/clocking-records/$employeeId/'
    | '/contract/$id/'
    | '/contract/$id/structure'
    | '/equipment/$id/lifecycle'
    | '/equipment/$id/status'
    | '/fleets/$id/'
    | '/networks/$id/'
    | '/payroll/pay-slips/$employeeId/'
    | '/places/$id/'
    | '/starlinks/$id/'
    | '/starlinks/$id/detail'
    | '/storage-files/files/$id/'
    | '/storage-files/folders/$id/'
    | '/individual/certifications/base-certifications/$id'
    | '/individual/certifications/handling-certifications/$id'
    | '/individual/certifications/specialty-certifications/$id'
    | '/device-catalog/active/$id/contract-and-cost'
    | '/devices/contract-and-cost/deal'
    | '/person/$id/certifications/base-certifications/$personCertificationInformationId'
    | '/person/$id/certifications/handling-certifications/$personCertificationInformationId'
    | '/person/$id/certifications/specialty-certifications/$personCertificationInformationId'
    | '/settings/data-connector/inbound/aggregate-data-pipeline/$id'
    | '/settings/data-connector/inbound/data-pipeline/$id'
    | '/settings/data-connector/outbound/data-pipeline/$id'
    | '/software/contract-and-cost/deal'
    | '/individual/my-profile/devices'
    | '/individual/my-profile/education-and-qualification'
    | '/individual/my-profile/softwares'
    | '/individual/contract/$id/signature-request/$signatureRequestId'
    | '/individual/operation-package/$id/pattern/$patternId'
    | '/individual/operation-package/$id/target/$targetId'
    | '/production/$productionId/dev-scope/edit'
    | '/production/$productionId/issue-scope/edit'
    | '/production/$productionId/value/edit'
    | '/products/$id/scope/$nodeId/'
    | '/test-suites/$id/test-plan/'
    | '/test-suites/$id/test-review/'
    | '/accesses/alerts/detail/$shadowItAppId'
    | '/accesses/alerts/dormancy/$softwareId'
    | '/attendance-engine/attendance-structures/$structureId/'
    | '/business-partner/$id/bp-role-info/'
    | '/certification/handling-certification/$id/'
    | '/certification/handling-certification/$id/certification-holders'
    | '/certification/specialty-certification/$id/'
    | '/certification/specialty-certification/$id/certification-holders'
    | '/certification/specialty-certification/$id/handling-certifications'
    | '/device-catalog/active/$id/profile'
    | '/device-catalog/draft/$id/profile'
    | '/devices/contract-and-cost/cost'
    | '/devices/contract-and-cost/payment'
    | '/equipment/items/$id/alerts'
    | '/equipment/items/$id/inventory'
    | '/equipment/items/$id/rule-and-policy'
    | '/ids/group-id/$id/detail'
    | '/ids/group-id/$id/devices'
    | '/ids/group-id/$id/members'
    | '/ids/group-id/$id/rule-and-policy'
    | '/ids/group-id/$id/security-and-auth'
    | '/ids/group-id/$id/softwares'
    | '/marketplace/store/devices/$productId'
    | '/marketplace/store/licenses/$productId'
    | '/marketplace/store/starlinks/$productId'
    | '/organization/plan/$id/edit/$unitId'
    | '/payroll-engine/payroll-structures/$structureId/'
    | '/payroll/contract-and-cost/cost'
    | '/payroll/contract-and-cost/deal'
    | '/payroll/contract-and-cost/payment'
    | '/person/$id/family/$familyPersonId'
    | '/person/alumni/$id/apps'
    | '/person/alumni/$id/contractor-information'
    | '/person/alumni/$id/devices'
    | '/person/alumni/$id/education-and-qualification'
    | '/person/alumni/$id/employee-information'
    | '/person/alumni/$id/equipment'
    | '/person/alumni/$id/history'
    | '/person/alumni/$id/operation-activity'
    | '/person/alumni/$id/personal-information'
    | '/person/alumni/$id/public-id'
    | '/settings/data-connector/inbound/aggregate-data-pipeline/'
    | '/settings/data-connector/inbound/aggregate-data-pipeline/add'
    | '/settings/data-connector/inbound/data-pipeline/'
    | '/settings/data-connector/inbound/data-pipeline/add'
    | '/settings/data-connector/outbound/data-pipeline/'
    | '/settings/data-connector/outbound/data-pipeline/add'
    | '/settings/permission-and-roles/category-permissions/$id'
    | '/settings/permission-and-roles/people-groups/$id'
    | '/settings/permission-and-roles/product-permissions/$id'
    | '/settings/permission-and-roles/roles/$id'
    | '/settings/permission-and-roles/category-permissions/new'
    | '/settings/permission-and-roles/people-groups/new'
    | '/settings/permission-and-roles/product-permissions/new'
    | '/settings/permission-and-roles/roles/new'
    | '/settings/persons/individual'
    | '/settings/persons/staff'
    | '/software/$id/contract-and-cost/'
    | '/software/$id/settings/integration'
    | '/software/$id/settings/role'
    | '/software/$id/settings/status'
    | '/software/alerts/alumni'
    | '/software/alerts/inactive-user'
    | '/software/alerts/no-user'
    | '/software/alerts/no-worker'
    | '/software/alerts/violated-assignment'
    | '/software/alerts/violated-role'
    | '/software/contract-and-cost/cost'
    | '/software/contract-and-cost/payment'
    | '/software/library/category/$category'
    | '/software/library/detail/$softwareLibraryId'
    | '/storage-files/folders/$id/files'
    | '/storage-files/folders/$id/users'
    | '/time-and-attendance/summary/daily-place'
    | '/time-and-attendance/summary/monthly-person'
    | '/time-and-attendance/summary/monthly-place'
    | '/equipment/items/$id/profile'
    | '/software/$id/contract-and-cost/deal'
    | '/products/$id/scope/$nodeId/value'
    | '/attendance-engine/attendance-structures/$structureId/structure'
    | '/business-partner/$id/bp-role-info/$bpRole'
    | '/device-catalog/active/$id/contract-and-cost/'
    | '/devices/contract-and-cost/cost/$period'
    | '/devices/contract-and-cost/deal/'
    | '/devices/contract-and-cost/payment/$period'
    | '/it-operation-core/operation-instances/$instanceId/data'
    | '/it-operation-core/operation-instances/$instanceId/detail'
    | '/it-operation-core/operation-instances/$instanceId/operation-activity'
    | '/licenses/$id/service-plans/$licenseServiceId/accounts'
    | '/payroll-engine/payroll-structures/$structureId/structure'
    | '/payroll/contract-and-cost/cost/$period'
    | '/payroll/contract-and-cost/payment/$period'
    | '/settings/permission-and-roles/category-permissions/$id/edit'
    | '/settings/permission-and-roles/people-groups/$id/edit'
    | '/settings/permission-and-roles/product-permissions/$id/edit'
    | '/settings/permission-and-roles/roles/$id/edit'
    | '/software/$id/contract-and-cost/cost'
    | '/software/$id/contract-and-cost/payment'
    | '/software/contract-and-cost/cost/$period'
    | '/software/contract-and-cost/deal/'
    | '/software/contract-and-cost/payment/$period'
    | '/software/library/category/$category/search'
    | '/software/marketplace/$id/install/finish'
    | '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
    | '/device-catalog/active/$id/contract-and-cost/deal'
    | '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
    | '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
    | '/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId'
    | '/individual/certifications/base-certifications/$id/'
    | '/individual/certifications/handling-certifications/$id/'
    | '/individual/certifications/specialty-certifications/$id/'
    | '/individual/task/$id/form/$formId'
    | '/device-catalog/active/$id/contract-and-cost/cost'
    | '/device-catalog/active/$id/contract-and-cost/payment'
    | '/devices/contract-and-cost/deal/all'
    | '/devices/contract-and-cost/deal/contract'
    | '/devices/contract-and-cost/deal/estimate'
    | '/devices/contract-and-cost/deal/order'
    | '/devices/contract-and-cost/deal/payment'
    | '/devices/contract-and-cost/deal/vendor-invoice'
    | '/person/$id/certifications/base-certifications/$personCertificationInformationId/'
    | '/person/$id/certifications/handling-certifications/$personCertificationInformationId/'
    | '/person/$id/certifications/specialty-certifications/$personCertificationInformationId/'
    | '/settings/data-connector/inbound/aggregate-data-pipeline/$id/basic-info'
    | '/settings/data-connector/inbound/aggregate-data-pipeline/$id/execution-plan'
    | '/settings/data-connector/inbound/aggregate-data-pipeline/$id/priority-setting'
    | '/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks'
    | '/settings/data-connector/inbound/data-pipeline/$id/basic-settings'
    | '/settings/data-connector/inbound/data-pipeline/$id/data-link-settings'
    | '/settings/data-connector/inbound/data-pipeline/$id/execution-plan'
    | '/settings/data-connector/inbound/data-pipeline/$id/execution-results'
    | '/settings/data-connector/outbound/data-pipeline/$id/basic-settings'
    | '/settings/data-connector/outbound/data-pipeline/$id/data-link-settings'
    | '/settings/data-connector/outbound/data-pipeline/$id/execution-plan'
    | '/settings/data-connector/outbound/data-pipeline/$id/execution-results'
    | '/software/$id/contract-and-cost/cost/$period'
    | '/software/$id/contract-and-cost/deal/'
    | '/software/$id/contract-and-cost/payment/$period'
    | '/software/contract-and-cost/deal/all'
    | '/software/contract-and-cost/deal/contract'
    | '/software/contract-and-cost/deal/estimate'
    | '/software/contract-and-cost/deal/order'
    | '/software/contract-and-cost/deal/payment'
    | '/software/contract-and-cost/deal/vendor-invoice'
    | '/attendance-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
    | '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/'
    | '/device-catalog/active/$id/contract-and-cost/cost/$period'
    | '/device-catalog/active/$id/contract-and-cost/deal/'
    | '/device-catalog/active/$id/contract-and-cost/payment/$period'
    | '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/'
    | '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/'
    | '/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks'
    | '/software/$id/contract-and-cost/deal/all'
    | '/software/$id/contract-and-cost/deal/contract'
    | '/software/$id/contract-and-cost/deal/estimate'
    | '/software/$id/contract-and-cost/deal/order'
    | '/software/$id/contract-and-cost/deal/payment'
    | '/software/$id/contract-and-cost/deal/vendor-invoice'
    | '/attendance-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/'
    | '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data'
    | '/device-catalog/active/$id/contract-and-cost/deal/all'
    | '/device-catalog/active/$id/contract-and-cost/deal/contract'
    | '/device-catalog/active/$id/contract-and-cost/deal/estimate'
    | '/device-catalog/active/$id/contract-and-cost/deal/order'
    | '/device-catalog/active/$id/contract-and-cost/deal/payment'
    | '/device-catalog/active/$id/contract-and-cost/deal/vendor-invoice'
    | '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data'
    | '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data'
    | '/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/chunks'
    | '/attendance-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data'
    | '/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/$chunkId/result'
    | '/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/chunks/$chunkId/result'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/planning-operations-core'
    | '/product-planning-core'
    | '/qa-operations-core'
    | '/apps'
    | '/id-managements'
    | '/me'
    | '/development-tickets/import-csv'
    | '/issues/import-csv'
    | '/values/import-csv'
    | '/it-operation-core/device-inventory'
    | '/places/import-csv'
    | '/individual'
    | '/issues'
    | '/product-roadmap'
    | '/test-sets'
    | '/test-suites'
    | '/values'
    | '/accesses'
    | '/apps/$'
    | '/attendance-core'
    | '/attendance-engine'
    | '/attendances'
    | '/business-operation-events'
    | '/business-partner'
    | '/certification'
    | '/contract'
    | '/contractor-core'
    | '/contractor-core/anchor-date'
    | '/contractor-core/contract-targets'
    | '/contractor-core/person-targets'
    | '/deal'
    | '/devices'
    | '/equipment'
    | '/fleets'
    | '/ga-operation-core'
    | '/id-managements/$'
    | '/ids'
    | '/it-operation-core'
    | '/it-operation-core/anchor-date'
    | '/it-operation-core/self-report-confirmation'
    | '/labor-core'
    | '/labor-core/anchor-date'
    | '/labor-core/contract-targets'
    | '/labor-core/government-application-confirmation'
    | '/labor-core/person-targets'
    | '/labor-core/year-end-adjustment-confirmation'
    | '/licenses'
    | '/marketplace'
    | '/networks'
    | '/organization'
    | '/payroll-core'
    | '/payroll-engine'
    | '/payroll'
    | '/people'
    | '/places'
    | '/public-ids'
    | '/software'
    | '/starlinks'
    | '/storage-files'
    | '/supplier'
    | '/time-and-attendance'
    | '/labor-core/group-name'
    | '/chat'
    | '/cockpit-mock'
    | '/development-tickets'
    | '/production'
    | '/products'
    | '/test-assets'
    | '/cockpit'
    | '/settings'
    | '/account/sso'
    | '/auth/password-reset'
    | '/auth/sign-in'
    | '/oauth2/consent'
    | '/oauth2/error'
    | '/oauth2/login'
    | '/oauth2/logout'
    | '/app-integrations/import-csv/$id'
    | '/business-partner/import-csv/corporation'
    | '/business-partner/import-csv/individual'
    | '/devices/import-csv/$deviceType'
    | '/person/import-csv/$workerType'
    | '/public-ids/import-csv/$publicIdType'
    | '/software/$id/import-csv'
    | '/development-tickets/$ticketId'
    | '/issues/$id'
    | '/product-roadmap/$roadmapId'
    | '/production/$productionId'
    | '/products/$id'
    | '/test-sets/$id'
    | '/test-suites/$id'
    | '/values/$id'
    | '/app-integrations/$id'
    | '/business-operation-events/archive'
    | '/business-operation-events/config'
    | '/business-operation-events/operation-activity'
    | '/business-operation-events/overview'
    | '/business-operation-events/rule-and-policy'
    | '/business-operation-events/settings'
    | '/business-partner/$id'
    | '/certification/$id'
    | '/contract/$id'
    | '/deal/$dealId'
    | '/devices/$id'
    | '/devices/alerts'
    | '/devices/operation-activity'
    | '/devices/rule-and-policy'
    | '/equipment/$id'
    | '/fleets/$id'
    | '/fleets/alerts'
    | '/fleets/overview'
    | '/fleets/rule-and-policy'
    | '/fleets/settings'
    | '/it-operation-core/device-inventory/data'
    | '/it-operation-core/device-inventory/detail'
    | '/labor-core/settings/egov-callback'
    | '/licenses/$id'
    | '/networks/$id'
    | '/organization/$id'
    | '/people/alerts'
    | '/people/community'
    | '/people/people-graph'
    | '/people/rule-and-policy'
    | '/people/salary-and-payment'
    | '/person/$id'
    | '/places/$id'
    | '/places/overview'
    | '/settings/contracting-corporation-profile'
    | '/settings/permission-and-roles'
    | '/settings/persons'
    | '/software/$id'
    | '/software/integrations'
    | '/starlinks/$id'
    | '/supplier/$supplierId'
    | '/users/$userId'
    | '/chat/$sessionId'
    | '/chat/new'
    | '/idp-sso/google-workspace'
    | '/individual/portal'
    | '/development-tickets/add-select'
    | '/development-tickets/add'
    | '/development-tickets/external-integrations'
    | '/issues/add-select'
    | '/issues/add'
    | '/issues/external-integrations'
    | '/products/add-select'
    | '/products/add'
    | '/values/add-select'
    | '/values/add'
    | '/business-operation-events/$eventInstanceId'
    | '/business-partner/add'
    | '/certification/add'
    | '/contract/add'
    | '/deal/add'
    | '/device-catalog/add'
    | '/devices/add'
    | '/devices/external-it-saas'
    | '/equipment/add-select'
    | '/equipment/add'
    | '/equipment/import-csv'
    | '/fleets/add-select'
    | '/fleets/add'
    | '/it-operation-core/device-targets'
    | '/it-operation-core/person-targets'
    | '/licenses/add'
    | '/marketplace/cart'
    | '/marketplace/unavailable'
    | '/networks/add'
    | '/organization/plan'
    | '/person/add-person-certification'
    | '/person/add'
    | '/person/external-hr-saas'
    | '/places/add-select'
    | '/places/add'
    | '/public-ids/$id'
    | '/public-ids/add'
    | '/software/add'
    | '/auth/invitation/$invitationCode'
    | '/auth/sign-in/error'
    | '/business-partner/alerts'
    | '/business-partner/contract-and-cost'
    | '/business-partner/operation-activity'
    | '/business-partner/rule-and-policy'
    | '/business-partner/settings'
    | '/certification/alerts'
    | '/certification/operation-activity'
    | '/certification/overview'
    | '/certification/rule-and-policy'
    | '/contract/alerts'
    | '/contract/contract-and-cost'
    | '/contract/operation-activity'
    | '/contract/overview'
    | '/contract/people'
    | '/deal/$dealId/flow'
    | '/deal/$dealId/structure'
    | '/software/marketplace/$id'
    | '/supplier/$supplierId/files'
    | '/supplier/$supplierId/rules-and-policy'
    | '/supplier/$supplierId/settings'
    | '/supplier/alerts'
    | '/supplier/contract-and-cost'
    | '/supplier/operation-activity'
    | '/supplier/overview'
    | '/supplier/rule-and-policy'
    | '/individual/my-profile'
    | '/individual/task/$id/approval-dialog'
    | '/accesses/contract-and-cost'
    | '/accesses/overview'
    | '/accesses/software'
    | '/app-integrations/$id/$'
    | '/business-partner/add/$businessPartnerType/completed'
    | '/certification/add/$certificationKind/completed'
    | '/certification/handling-certification/$id'
    | '/certification/specialty-certification/$id'
    | '/contract/add/subscription/completed'
    | '/deal/add/$direction/completed'
    | '/device-catalog/active/$id'
    | '/device-catalog/add/$deviceType/completed'
    | '/device-catalog/draft/$id'
    | '/devices/contract-and-cost'
    | '/devices/add/$deviceType/completed'
    | '/equipment/overview'
    | '/equipment/rule-and-policy'
    | '/equipment/settings'
    | '/equipment/items/$id'
    | '/ids/alerts'
    | '/ids/group-id'
    | '/ids/operation-activity'
    | '/ids/overview'
    | '/ids/rule-and-policy'
    | '/ids/settings'
    | '/ids/group-id/$id'
    | '/it-operation-core/in-house-packages/$packageId'
    | '/it-operation-core/packages/$packageId'
    | '/labor-core/settings/profile/$profileId'
    | '/licenses/add/$allocationType/completed'
    | '/marketplace/sent-orders/$orderId'
    | '/networks/alerts'
    | '/networks/contract-and-cost'
    | '/networks/operation-activity'
    | '/networks/overview'
    | '/networks/rule-and-policy'
    | '/networks/settings'
    | '/payroll/contract-and-cost'
    | '/person/add-person-certification/$certificationKind/completed'
    | '/person/add/$workerType/completed'
    | '/person/alumni/$id'
    | '/places/alerts'
    | '/places/contract-and-cost'
    | '/places/operation-activity'
    | '/places/people'
    | '/places/rule-and-policy'
    | '/places/store'
    | '/profile/device/$id/$'
    | '/software/$id/groups'
    | '/software/$id/profiles'
    | '/software/alerts'
    | '/software/contract-and-cost'
    | '/starlinks/billing-and-cost'
    | '/starlinks/marketplace'
    | '/starlinks/operation-activity'
    | '/storage-files/files/$id'
    | '/storage-files/folders/$id'
    | '/individual/approval-tasks'
    | '/individual/operation-tasks'
    | '/individual/request-tasks'
    | '/individual/operation-package/$id'
    | '/individual/portal/approvals'
    | '/individual/portal/lookup'
    | '/individual/portal/requests'
    | '/individual/task/$id'
    | '/issues/overview'
    | '/accesses/alerts'
    | '/accesses/list'
    | '/accesses/settings'
    | '/attendance-core/archive'
    | '/attendance-core/config'
    | '/attendance-core/dashboard'
    | '/attendance-core/operation-packages'
    | '/attendance-engine/attendance-structures'
    | '/attendance-engine/attendance-units'
    | '/attendance-engine/items'
    | '/attendance-engine/logic-components'
    | '/attendances/alerts'
    | '/attendances/clocking-records'
    | '/attendances/employees'
    | '/attendances/operation-activity'
    | '/attendances/overview'
    | '/attendances/rule-and-policy'
    | '/attendances/settings'
    | '/business-partner/terminated'
    | '/business-partner/add/$businessPartnerType'
    | '/certification/people'
    | '/certification/settings'
    | '/certification/add/$certificationKind'
    | '/cockpit/approval/$id'
    | '/cockpit/task/$taskId'
    | '/contract/add/subscription'
    | '/contract/import-csv/$contractType'
    | '/contractor-core/archives'
    | '/contractor-core/configs'
    | '/contractor-core/config/$patternId'
    | '/deal/add/$direction'
    | '/device-catalog/add/$deviceType'
    | '/devices/inventories'
    | '/devices/inventory'
    | '/devices/people'
    | '/devices/settings'
    | '/devices/add/$deviceType'
    | '/devices/add/catalog'
    | '/equipment/alerts'
    | '/equipment/items'
    | '/ga-operation-core/archives'
    | '/ga-operation-core/configs'
    | '/ga-operation-core/config/$patternId'
    | '/ids/people'
    | '/ids/group-id/add'
    | '/it-operation-core/archives'
    | '/it-operation-core/config'
    | '/it-operation-core/in-house-packages'
    | '/it-operation-core/packages'
    | '/it-operation-core/config/$patternId'
    | '/it-operation-core/self-report-patterns/$patternId'
    | '/labor-core/archives'
    | '/labor-core/configs'
    | '/labor-core/settings'
    | '/labor-core/config/$patternId'
    | '/licenses/alerts'
    | '/licenses/contract-and-cost'
    | '/licenses/inventory'
    | '/licenses/operation-activity'
    | '/licenses/people'
    | '/licenses/rule-and-policy'
    | '/licenses/settings'
    | '/licenses/add/$allocationType'
    | '/marketplace/sales-orders/$orderId'
    | '/organization/alert'
    | '/organization/chart'
    | '/organization/cost'
    | '/organization/history'
    | '/organization/rule-policy'
    | '/organization/settings'
    | '/organization/plan/$id'
    | '/organization/plan/create'
    | '/payroll-core/archive'
    | '/payroll-core/config'
    | '/payroll-core/dashboard'
    | '/payroll-core/operation-packages'
    | '/payroll-core/person-targets'
    | '/payroll-engine/items'
    | '/payroll-engine/logic-components'
    | '/payroll-engine/payroll-structures'
    | '/payroll-engine/payroll-units'
    | '/payroll/alerts'
    | '/payroll/overview'
    | '/payroll/pay-slips'
    | '/payroll/rule-and-policy'
    | '/payroll/settings'
    | '/people/alumni'
    | '/people/operation-activity'
    | '/people/settings'
    | '/people/workforce'
    | '/person/add-person-certification/$certificationKind'
    | '/person/add/$workerType'
    | '/person/automap-ingester/$workerType'
    | '/places/settings'
    | '/profile/device/$id'
    | '/public-ids/$id/details'
    | '/public-ids/$id/files'
    | '/public-ids/alerts'
    | '/public-ids/members'
    | '/public-ids/operation-activity'
    | '/public-ids/registry'
    | '/public-ids/rules-and-policies'
    | '/public-ids/settings'
    | '/settings/data-connector/inbound'
    | '/settings/data-connector/outbound'
    | '/settings/persons/invite'
    | '/software/library'
    | '/software/operation-activity'
    | '/software/people'
    | '/software/registry'
    | '/software/rule-and-policy'
    | '/software/settings'
    | '/software/add/$type'
    | '/starlinks/alerts'
    | '/starlinks/user-terminals'
    | '/storage-files/files'
    | '/storage-files/folders'
    | '/storage-files/settings'
    | '/supplier/settings'
    | '/time-and-attendance/attendance-links'
    | '/contract/$id/approval-info'
    | '/contract/$id/history'
    | '/contract/$id/operation-activity'
    | '/contract/$id/risk-provisions'
    | '/contract/$id/rule-and-policy'
    | '/products/$id/scope/$nodeId'
    | '/test-suites/$id/test-plan'
    | '/test-suites/$id/test-review'
    | '/attendance-engine/attendance-structures/$structureId'
    | '/business-partner/$id/bp-role-info'
    | '/devices/add/catalog/$deviceType/completed'
    | '/ids/group-id/add/from-scratch/completed'
    | '/it-operation-core/operation-instances/$instanceId'
    | '/it-operation-core/in-house-packages/$packageId/start-targets'
    | '/licenses/$id/service-plans/$licenseServiceId'
    | '/marketplace/sent-orders/$orderId/activities'
    | '/payroll-engine/payroll-structures/$structureId'
    | '/settings/data-connector/inbound/aggregate-data-pipeline'
    | '/settings/data-connector/inbound/data-pipeline'
    | '/settings/data-connector/outbound/data-pipeline'
    | '/software/$id/contract-and-cost'
    | '/individual/portal/lookup/clocking-record/alerts'
    | '/individual/portal/lookup/clocking-record/files'
    | '/individual/portal/lookup/clocking-record/overview'
    | '/individual/portal/lookup/clocking-record/schedule'
    | '/individual/portal/lookup/pay-slip/alerts'
    | '/individual/portal/lookup/pay-slip/files'
    | '/individual/portal/lookup/pay-slip/history'
    | '/individual/portal/lookup/pay-slip/overview'
    | '/attendances/clocking-records/$employeeId/alerts'
    | '/attendances/clocking-records/$employeeId/files'
    | '/attendances/clocking-records/$employeeId/overview'
    | '/attendances/clocking-records/$employeeId/schedule'
    | '/attendances/clocking-records/$employeeId/settings'
    | '/payroll/pay-slips/$employeeId/alerts'
    | '/payroll/pay-slips/$employeeId/files'
    | '/payroll/pay-slips/$employeeId/history'
    | '/payroll/pay-slips/$employeeId/overview'
    | '/payroll/pay-slips/$employeeId/settings'
    | '/individual/task/$id/approval'
    | '/development-tickets/$ticketId/history'
    | '/issues/$id/history'
    | '/product-roadmap/$roadmapId/detail'
    | '/product-roadmap/$roadmapId/history'
    | '/production/$productionId/dev-scope'
    | '/production/$productionId/issue-scope'
    | '/production/$productionId/product-scope'
    | '/production/$productionId/quality-scope'
    | '/production/$productionId/value'
    | '/products/$id/product-scope'
    | '/test-sets/$id/conditions'
    | '/test-sets/$id/target-functions'
    | '/test-suites/$id/document'
    | '/test-suites/$id/issues'
    | '/test-suites/$id/overview'
    | '/test-suites/$id/target-functions'
    | '/test-suites/$id/test-set'
    | '/values/$id/history'
    | '/values/$id/product-scope'
    | '/accesses/list/$traceableAppId'
    | '/attendance-engine/attendance-units/$unitId'
    | '/attendance-engine/items/$componentId'
    | '/attendance-engine/logic-components/$componentId'
    | '/business-partner/$id/address-and-contact'
    | '/certification/$id/certification-holders'
    | '/certification/$id/handling-certifications'
    | '/certification/$id/specialty-certifications'
    | '/certification/settings/issuing-organization'
    | '/certification/settings/specialty-category-level'
    | '/certification/settings/specialty-category'
    | '/devices/$id/control'
    | '/devices/$id/files'
    | '/devices/$id/history'
    | '/devices/$id/lifecycle'
    | '/devices/$id/mdm'
    | '/devices/$id/profile'
    | '/devices/$id/status'
    | '/devices/settings/catalog'
    | '/devices/add/catalog/$deviceType'
    | '/devices/external-it-saas/$appIntegrationId/preview'
    | '/equipment/settings/equipment-items'
    | '/equipment/settings/equipment-types'
    | '/ids/group-id/add/from-scratch'
    | '/licenses/$id/assignments'
    | '/licenses/$id/people'
    | '/licenses/$id/rule-and-policy'
    | '/licenses/$id/service-plans'
    | '/marketplace/store/devices'
    | '/marketplace/store/licenses'
    | '/marketplace/store/sales-orders'
    | '/marketplace/store/sent-orders'
    | '/marketplace/store/starlinks'
    | '/organization/$id/history'
    | '/organization/plan/$id/add'
    | '/organization/plan/$id/transfers'
    | '/payroll-engine/items/$componentId'
    | '/payroll-engine/logic-components/$componentId'
    | '/payroll-engine/payroll-units/$unitId'
    | '/people/settings/board-member-types'
    | '/people/settings/collaborator-types'
    | '/people/settings/contract-end-reasons'
    | '/people/settings/contractor-types'
    | '/people/settings/employee-sub-id-names'
    | '/people/settings/employment-types'
    | '/people/settings/grades'
    | '/people/settings/health-insurance-associations'
    | '/people/settings/job-competencies'
    | '/people/settings/job-functions'
    | '/people/settings/job-grades'
    | '/people/settings/job-levels'
    | '/people/settings/job-titles'
    | '/people/settings/job-types'
    | '/people/settings/place-social-insurances'
    | '/people/settings/positions'
    | '/people/settings/retirement-reasons'
    | '/people/settings/work-mode'
    | '/person/$id/apps'
    | '/person/$id/contractor-information'
    | '/person/$id/devices'
    | '/person/$id/education-and-qualification'
    | '/person/$id/employee-information'
    | '/person/$id/equipment'
    | '/person/$id/history'
    | '/person/$id/operation-activity'
    | '/person/$id/personal-information'
    | '/person/$id/public-id'
    | '/person/external-hr-saas/$appIntegrationId/preview'
    | '/places/$id/administrators'
    | '/places/$id/labor-core'
    | '/places/settings/place-sub-codes'
    | '/settings/contracting-corporation-profile/board-member'
    | '/settings/contracting-corporation-profile/contact-points'
    | '/settings/contracting-corporation-profile/corporate-overview'
    | '/settings/contracting-corporation-profile/group-companies'
    | '/settings/contracting-corporation-profile/history'
    | '/settings/contracting-corporation-profile/registration'
    | '/settings/contracting-corporation-profile/shareholders'
    | '/settings/permission-and-roles/category-permissions'
    | '/settings/permission-and-roles/people-groups'
    | '/settings/permission-and-roles/product-permissions'
    | '/settings/permission-and-roles/roles'
    | '/settings/persons/settings'
    | '/software/$id/accounts'
    | '/software/$id/activity-monitoring'
    | '/software/$id/alerts'
    | '/software/$id/architecture'
    | '/software/$id/detail'
    | '/software/$id/rule-and-policy'
    | '/software/$id/settings'
    | '/software/library/search'
    | '/software/custom-saas/add/$customSaasType'
    | '/supplier/settings/procurement-categories'
    | '/supplier/settings/supplier-categories'
    | '/supplier/settings/supplier-subcategories'
    | '/time-and-attendance/summary'
    | '/time-and-attendance/attendance-links/$placeId'
    | '/users/$userId/sessions'
    | '/individual/portal/lookup/clocking-record'
    | '/individual/portal/lookup/pay-slip'
    | '/attendances/clocking-records/$employeeId'
    | '/contract/$id/structure'
    | '/equipment/$id/lifecycle'
    | '/equipment/$id/status'
    | '/payroll/pay-slips/$employeeId'
    | '/starlinks/$id/detail'
    | '/individual/certifications/base-certifications/$id'
    | '/individual/certifications/handling-certifications/$id'
    | '/individual/certifications/specialty-certifications/$id'
    | '/device-catalog/active/$id/contract-and-cost'
    | '/devices/contract-and-cost/deal'
    | '/person/$id/certifications/base-certifications/$personCertificationInformationId'
    | '/person/$id/certifications/handling-certifications/$personCertificationInformationId'
    | '/person/$id/certifications/specialty-certifications/$personCertificationInformationId'
    | '/settings/data-connector/inbound/aggregate-data-pipeline/$id'
    | '/settings/data-connector/inbound/data-pipeline/$id'
    | '/settings/data-connector/outbound/data-pipeline/$id'
    | '/software/contract-and-cost/deal'
    | '/individual/my-profile/devices'
    | '/individual/my-profile/education-and-qualification'
    | '/individual/my-profile/softwares'
    | '/individual/contract/$id/signature-request/$signatureRequestId'
    | '/individual/operation-package/$id/pattern/$patternId'
    | '/individual/operation-package/$id/target/$targetId'
    | '/production/$productionId/dev-scope/edit'
    | '/production/$productionId/issue-scope/edit'
    | '/production/$productionId/value/edit'
    | '/accesses/alerts/detail/$shadowItAppId'
    | '/accesses/alerts/dormancy/$softwareId'
    | '/certification/handling-certification/$id/certification-holders'
    | '/certification/specialty-certification/$id/certification-holders'
    | '/certification/specialty-certification/$id/handling-certifications'
    | '/device-catalog/active/$id/profile'
    | '/device-catalog/draft/$id/profile'
    | '/devices/contract-and-cost/cost'
    | '/devices/contract-and-cost/payment'
    | '/equipment/items/$id/alerts'
    | '/equipment/items/$id/inventory'
    | '/equipment/items/$id/rule-and-policy'
    | '/ids/group-id/$id/detail'
    | '/ids/group-id/$id/devices'
    | '/ids/group-id/$id/members'
    | '/ids/group-id/$id/rule-and-policy'
    | '/ids/group-id/$id/security-and-auth'
    | '/ids/group-id/$id/softwares'
    | '/marketplace/store/devices/$productId'
    | '/marketplace/store/licenses/$productId'
    | '/marketplace/store/starlinks/$productId'
    | '/organization/plan/$id/edit/$unitId'
    | '/payroll/contract-and-cost/cost'
    | '/payroll/contract-and-cost/deal'
    | '/payroll/contract-and-cost/payment'
    | '/person/$id/family/$familyPersonId'
    | '/person/alumni/$id/apps'
    | '/person/alumni/$id/contractor-information'
    | '/person/alumni/$id/devices'
    | '/person/alumni/$id/education-and-qualification'
    | '/person/alumni/$id/employee-information'
    | '/person/alumni/$id/equipment'
    | '/person/alumni/$id/history'
    | '/person/alumni/$id/operation-activity'
    | '/person/alumni/$id/personal-information'
    | '/person/alumni/$id/public-id'
    | '/settings/data-connector/inbound/aggregate-data-pipeline/add'
    | '/settings/data-connector/inbound/data-pipeline/add'
    | '/settings/data-connector/outbound/data-pipeline/add'
    | '/settings/permission-and-roles/category-permissions/$id'
    | '/settings/permission-and-roles/people-groups/$id'
    | '/settings/permission-and-roles/product-permissions/$id'
    | '/settings/permission-and-roles/roles/$id'
    | '/settings/permission-and-roles/category-permissions/new'
    | '/settings/permission-and-roles/people-groups/new'
    | '/settings/permission-and-roles/product-permissions/new'
    | '/settings/permission-and-roles/roles/new'
    | '/settings/persons/individual'
    | '/settings/persons/staff'
    | '/software/$id/settings/integration'
    | '/software/$id/settings/role'
    | '/software/$id/settings/status'
    | '/software/alerts/alumni'
    | '/software/alerts/inactive-user'
    | '/software/alerts/no-user'
    | '/software/alerts/no-worker'
    | '/software/alerts/violated-assignment'
    | '/software/alerts/violated-role'
    | '/software/contract-and-cost/cost'
    | '/software/contract-and-cost/payment'
    | '/software/library/category/$category'
    | '/software/library/detail/$softwareLibraryId'
    | '/storage-files/folders/$id/files'
    | '/storage-files/folders/$id/users'
    | '/time-and-attendance/summary/daily-place'
    | '/time-and-attendance/summary/monthly-person'
    | '/time-and-attendance/summary/monthly-place'
    | '/equipment/items/$id/profile'
    | '/software/$id/contract-and-cost/deal'
    | '/products/$id/scope/$nodeId/value'
    | '/attendance-engine/attendance-structures/$structureId/structure'
    | '/business-partner/$id/bp-role-info/$bpRole'
    | '/devices/contract-and-cost/cost/$period'
    | '/devices/contract-and-cost/payment/$period'
    | '/it-operation-core/operation-instances/$instanceId/data'
    | '/it-operation-core/operation-instances/$instanceId/detail'
    | '/it-operation-core/operation-instances/$instanceId/operation-activity'
    | '/licenses/$id/service-plans/$licenseServiceId/accounts'
    | '/payroll-engine/payroll-structures/$structureId/structure'
    | '/payroll/contract-and-cost/cost/$period'
    | '/payroll/contract-and-cost/payment/$period'
    | '/settings/permission-and-roles/category-permissions/$id/edit'
    | '/settings/permission-and-roles/people-groups/$id/edit'
    | '/settings/permission-and-roles/product-permissions/$id/edit'
    | '/settings/permission-and-roles/roles/$id/edit'
    | '/software/$id/contract-and-cost/cost'
    | '/software/$id/contract-and-cost/payment'
    | '/software/contract-and-cost/cost/$period'
    | '/software/contract-and-cost/payment/$period'
    | '/software/library/category/$category/search'
    | '/software/marketplace/$id/install/finish'
    | '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
    | '/device-catalog/active/$id/contract-and-cost/deal'
    | '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
    | '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
    | '/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId'
    | '/individual/task/$id/form/$formId'
    | '/device-catalog/active/$id/contract-and-cost/cost'
    | '/device-catalog/active/$id/contract-and-cost/payment'
    | '/devices/contract-and-cost/deal/all'
    | '/devices/contract-and-cost/deal/contract'
    | '/devices/contract-and-cost/deal/estimate'
    | '/devices/contract-and-cost/deal/order'
    | '/devices/contract-and-cost/deal/payment'
    | '/devices/contract-and-cost/deal/vendor-invoice'
    | '/settings/data-connector/inbound/aggregate-data-pipeline/$id/basic-info'
    | '/settings/data-connector/inbound/aggregate-data-pipeline/$id/execution-plan'
    | '/settings/data-connector/inbound/aggregate-data-pipeline/$id/priority-setting'
    | '/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks'
    | '/settings/data-connector/inbound/data-pipeline/$id/basic-settings'
    | '/settings/data-connector/inbound/data-pipeline/$id/data-link-settings'
    | '/settings/data-connector/inbound/data-pipeline/$id/execution-plan'
    | '/settings/data-connector/inbound/data-pipeline/$id/execution-results'
    | '/settings/data-connector/outbound/data-pipeline/$id/basic-settings'
    | '/settings/data-connector/outbound/data-pipeline/$id/data-link-settings'
    | '/settings/data-connector/outbound/data-pipeline/$id/execution-plan'
    | '/settings/data-connector/outbound/data-pipeline/$id/execution-results'
    | '/software/$id/contract-and-cost/cost/$period'
    | '/software/$id/contract-and-cost/payment/$period'
    | '/software/contract-and-cost/deal/all'
    | '/software/contract-and-cost/deal/contract'
    | '/software/contract-and-cost/deal/estimate'
    | '/software/contract-and-cost/deal/order'
    | '/software/contract-and-cost/deal/payment'
    | '/software/contract-and-cost/deal/vendor-invoice'
    | '/attendance-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
    | '/device-catalog/active/$id/contract-and-cost/cost/$period'
    | '/device-catalog/active/$id/contract-and-cost/payment/$period'
    | '/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks'
    | '/software/$id/contract-and-cost/deal/all'
    | '/software/$id/contract-and-cost/deal/contract'
    | '/software/$id/contract-and-cost/deal/estimate'
    | '/software/$id/contract-and-cost/deal/order'
    | '/software/$id/contract-and-cost/deal/payment'
    | '/software/$id/contract-and-cost/deal/vendor-invoice'
    | '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data'
    | '/device-catalog/active/$id/contract-and-cost/deal/all'
    | '/device-catalog/active/$id/contract-and-cost/deal/contract'
    | '/device-catalog/active/$id/contract-and-cost/deal/estimate'
    | '/device-catalog/active/$id/contract-and-cost/deal/order'
    | '/device-catalog/active/$id/contract-and-cost/deal/payment'
    | '/device-catalog/active/$id/contract-and-cost/deal/vendor-invoice'
    | '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data'
    | '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data'
    | '/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/chunks'
    | '/attendance-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data'
    | '/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/$chunkId/result'
    | '/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/chunks/$chunkId/result'
  id:
    | '__root__'
    | '/'
    | '/_chat'
    | '/_cockpit-mock'
    | '/_idp-sso-mock'
    | '/_individual'
    | '/_stacktrace'
    | '/_staff'
    | '/_stacktrace/planning-operations-core'
    | '/_stacktrace/product-planning-core'
    | '/_stacktrace/qa-operations-core'
    | '/_staff/apps'
    | '/_staff/id-managements'
    | '/me/'
    | '/_stacktrace/development-tickets/import-csv'
    | '/_stacktrace/issues/import-csv'
    | '/_stacktrace/values/import-csv'
    | '/_staff/it-operation-core/device-inventory'
    | '/_staff/places/import-csv'
    | '/_individual/individual'
    | '/_individual/individual/_profile'
    | '/_individual/individual/portal'
    | '/_stacktrace/issues'
    | '/_stacktrace/issues/_layout'
    | '/_stacktrace/product-roadmap'
    | '/_stacktrace/product-roadmap/_layout'
    | '/_stacktrace/test-sets'
    | '/_stacktrace/test-sets/_layout'
    | '/_stacktrace/test-suites'
    | '/_stacktrace/test-suites/_layout'
    | '/_stacktrace/values'
    | '/_stacktrace/values/_layout'
    | '/_staff/accesses'
    | '/_staff/accesses/_layout'
    | '/_staff/apps/$'
    | '/_staff/attendance-core'
    | '/_staff/attendance-core/_layout'
    | '/_staff/attendance-engine'
    | '/_staff/attendance-engine/_layout'
    | '/_staff/attendances'
    | '/_staff/attendances/_layout'
    | '/_staff/business-operation-events'
    | '/_staff/business-operation-events/_list'
    | '/_staff/business-partner'
    | '/_staff/business-partner/_list'
    | '/_staff/certification'
    | '/_staff/certification/_list'
    | '/_staff/contract'
    | '/_staff/contract/_list'
    | '/_staff/contractor-core'
    | '/_staff/contractor-core/_packages'
    | '/_staff/contractor-core/anchor-date'
    | '/_staff/contractor-core/contract-targets'
    | '/_staff/contractor-core/person-targets'
    | '/_staff/deal'
    | '/_staff/deal/_list'
    | '/_staff/devices'
    | '/_staff/devices/_list'
    | '/_staff/equipment'
    | '/_staff/equipment/_layout'
    | '/_staff/fleets'
    | '/_staff/fleets/_layout'
    | '/_staff/ga-operation-core'
    | '/_staff/ga-operation-core/_packages'
    | '/_staff/id-managements/$'
    | '/_staff/ids'
    | '/_staff/ids/_layout'
    | '/_staff/it-operation-core'
    | '/_staff/it-operation-core/_detail'
    | '/_staff/it-operation-core/_root'
    | '/_staff/it-operation-core/anchor-date'
    | '/_staff/it-operation-core/self-report-confirmation'
    | '/_staff/labor-core'
    | '/_staff/labor-core/_packages'
    | '/_staff/labor-core/anchor-date'
    | '/_staff/labor-core/contract-targets'
    | '/_staff/labor-core/government-application-confirmation'
    | '/_staff/labor-core/person-targets'
    | '/_staff/labor-core/year-end-adjustment-confirmation'
    | '/_staff/licenses'
    | '/_staff/licenses/_list'
    | '/_staff/marketplace'
    | '/_staff/marketplace/_store'
    | '/_staff/networks'
    | '/_staff/networks/_layout'
    | '/_staff/organization'
    | '/_staff/organization/_list'
    | '/_staff/payroll-core'
    | '/_staff/payroll-core/_layout'
    | '/_staff/payroll-engine'
    | '/_staff/payroll-engine/_layout'
    | '/_staff/payroll'
    | '/_staff/payroll/_layout'
    | '/_staff/people'
    | '/_staff/people/_list'
    | '/_staff/places'
    | '/_staff/places/_layout'
    | '/_staff/public-ids/$id'
    | '/_staff/public-ids'
    | '/_staff/public-ids/_list'
    | '/_staff/software'
    | '/_staff/software/_layout'
    | '/_staff/starlinks'
    | '/_staff/starlinks/_layout'
    | '/_staff/storage-files'
    | '/_staff/storage-files/_list'
    | '/_staff/supplier'
    | '/_staff/supplier/_list'
    | '/_staff/time-and-attendance'
    | '/_staff/time-and-attendance/_layout'
    | '/_staff/labor-core/group-name'
    | '/_chat/chat/'
    | '/_cockpit-mock/cockpit-mock/'
    | '/_individual/individual/'
    | '/_stacktrace/development-tickets/'
    | '/_stacktrace/production/'
    | '/_stacktrace/products/'
    | '/_stacktrace/test-assets/'
    | '/_staff/cockpit/'
    | '/_staff/it-operation-core/'
    | '/_staff/organization/'
    | '/_staff/settings/'
    | '/account/sso/'
    | '/auth/password-reset/'
    | '/auth/sign-in/'
    | '/oauth2/consent/'
    | '/oauth2/error/'
    | '/oauth2/login/'
    | '/oauth2/logout/'
    | '/_staff/certification/_list/'
    | '/_staff/licenses/_list/'
    | '/_staff/app-integrations/import-csv/$id'
    | '/_staff/business-partner/import-csv/corporation'
    | '/_staff/business-partner/import-csv/individual'
    | '/_staff/devices/import-csv/$deviceType'
    | '/_staff/it-operation-core/_root/in-house-packages'
    | '/_staff/it-operation-core/_root/packages'
    | '/_staff/person/import-csv/$workerType'
    | '/_staff/places/_layout/settings'
    | '/_staff/public-ids/import-csv/$publicIdType'
    | '/_staff/software/$id/import-csv'
    | '/_staff/software/_layout/people'
    | '/_stacktrace/development-tickets/$ticketId'
    | '/_stacktrace/development-tickets/$ticketId/_layout'
    | '/_stacktrace/issues/$id'
    | '/_stacktrace/issues/$id/_layout'
    | '/_stacktrace/product-roadmap/$roadmapId'
    | '/_stacktrace/product-roadmap/$roadmapId/_layout'
    | '/_stacktrace/production/$productionId'
    | '/_stacktrace/production/$productionId/_layout'
    | '/_stacktrace/products/$id'
    | '/_stacktrace/products/$id/_layout'
    | '/_stacktrace/test-sets/$id'
    | '/_stacktrace/test-sets/$id/_layout'
    | '/_stacktrace/test-suites/$id'
    | '/_stacktrace/test-suites/$id/_layout'
    | '/_stacktrace/values/$id'
    | '/_stacktrace/values/$id/_layout'
    | '/_staff/app-integrations/$id'
    | '/_staff/app-integrations/$id/_$id'
    | '/_staff/business-operation-events/_list/archive'
    | '/_staff/business-operation-events/_list/config'
    | '/_staff/business-operation-events/_list/operation-activity'
    | '/_staff/business-operation-events/_list/overview'
    | '/_staff/business-operation-events/_list/rule-and-policy'
    | '/_staff/business-operation-events/_list/settings'
    | '/_staff/business-partner/$id'
    | '/_staff/business-partner/$id/_layout'
    | '/_staff/certification/$id'
    | '/_staff/certification/$id/_layout'
    | '/_staff/contract/$id'
    | '/_staff/contract/$id/_layout'
    | '/_staff/deal/$dealId'
    | '/_staff/deal/$dealId/_layout'
    | '/_staff/devices/$id'
    | '/_staff/devices/$id/_layout'
    | '/_staff/devices/_list/alerts'
    | '/_staff/devices/_list/operation-activity'
    | '/_staff/devices/_list/rule-and-policy'
    | '/_staff/equipment/$id'
    | '/_staff/equipment/$id/_layout'
    | '/_staff/fleets/$id'
    | '/_staff/fleets/$id/_layout'
    | '/_staff/fleets/_layout/alerts'
    | '/_staff/fleets/_layout/overview'
    | '/_staff/fleets/_layout/rule-and-policy'
    | '/_staff/fleets/_layout/settings'
    | '/_staff/it-operation-core/device-inventory/data'
    | '/_staff/it-operation-core/device-inventory/detail'
    | '/_staff/labor-core/_packages/settings'
    | '/_staff/labor-core/settings/egov-callback'
    | '/_staff/licenses/$id'
    | '/_staff/licenses/$id/_profile'
    | '/_staff/networks/$id'
    | '/_staff/networks/$id/_layout'
    | '/_staff/organization/$id'
    | '/_staff/organization/$id/_layout'
    | '/_staff/people/_list/alerts'
    | '/_staff/people/_list/community'
    | '/_staff/people/_list/people-graph'
    | '/_staff/people/_list/rule-and-policy'
    | '/_staff/people/_list/salary-and-payment'
    | '/_staff/person/$id'
    | '/_staff/person/$id/_profile'
    | '/_staff/places/$id'
    | '/_staff/places/$id/_layout'
    | '/_staff/places/_layout/overview'
    | '/_staff/settings/contracting-corporation-profile'
    | '/_staff/settings/contracting-corporation-profile/_layout'
    | '/_staff/settings/permission-and-roles'
    | '/_staff/settings/permission-and-roles/_detail'
    | '/_staff/settings/permission-and-roles/_form'
    | '/_staff/settings/permission-and-roles/_list'
    | '/_staff/settings/persons'
    | '/_staff/settings/persons/_list'
    | '/_staff/software/$id'
    | '/_staff/software/$id/_$id'
    | '/_staff/software/_layout/integrations'
    | '/_staff/starlinks/$id'
    | '/_staff/starlinks/$id/_layout'
    | '/_staff/supplier/$supplierId'
    | '/_staff/supplier/$supplierId/_layout'
    | '/_staff/users/$userId'
    | '/_staff/users/$userId/_layout'
    | '/_staff/devices/_list/'
    | '/_staff/people/_list/'
    | '/_staff/software/_layout/'
    | '/_staff/certification/_list/settings'
    | '/_staff/devices/_list/settings'
    | '/_staff/equipment/_layout/settings'
    | '/_staff/people/_list/settings'
    | '/_staff/supplier/_list/settings'
    | '/_chat/chat/$sessionId/'
    | '/_chat/chat/new/'
    | '/_idp-sso-mock/idp-sso/google-workspace/'
    | '/_individual/individual/portal/'
    | '/_stacktrace/development-tickets/add-select/'
    | '/_stacktrace/development-tickets/add/'
    | '/_stacktrace/development-tickets/external-integrations/'
    | '/_stacktrace/issues/_layout/'
    | '/_stacktrace/issues/add-select/'
    | '/_stacktrace/issues/add/'
    | '/_stacktrace/issues/external-integrations/'
    | '/_stacktrace/product-roadmap/_layout/'
    | '/_stacktrace/products/add-select/'
    | '/_stacktrace/products/add/'
    | '/_stacktrace/test-sets/_layout/'
    | '/_stacktrace/test-suites/_layout/'
    | '/_stacktrace/values/_layout/'
    | '/_stacktrace/values/add-select/'
    | '/_stacktrace/values/add/'
    | '/_staff/accesses/_layout/'
    | '/_staff/attendance-core/_layout/'
    | '/_staff/attendance-engine/_layout/'
    | '/_staff/attendances/_layout/'
    | '/_staff/business-operation-events/$eventInstanceId/'
    | '/_staff/business-operation-events/_list/'
    | '/_staff/business-partner/_list/'
    | '/_staff/business-partner/add/'
    | '/_staff/certification/add/'
    | '/_staff/contract/_list/'
    | '/_staff/contract/add/'
    | '/_staff/contractor-core/_packages/'
    | '/_staff/deal/_list/'
    | '/_staff/deal/add/'
    | '/_staff/device-catalog/add/'
    | '/_staff/devices/add/'
    | '/_staff/devices/external-it-saas/'
    | '/_staff/equipment/_layout/'
    | '/_staff/equipment/add-select/'
    | '/_staff/equipment/add/'
    | '/_staff/equipment/import-csv/'
    | '/_staff/fleets/add-select/'
    | '/_staff/fleets/add/'
    | '/_staff/ga-operation-core/_packages/'
    | '/_staff/ids/_layout/'
    | '/_staff/it-operation-core/device-targets/'
    | '/_staff/it-operation-core/person-targets/'
    | '/_staff/labor-core/_packages/'
    | '/_staff/licenses/add/'
    | '/_staff/marketplace/cart/'
    | '/_staff/marketplace/unavailable/'
    | '/_staff/networks/_layout/'
    | '/_staff/networks/add/'
    | '/_staff/organization/plan/'
    | '/_staff/payroll-core/_layout/'
    | '/_staff/payroll-engine/_layout/'
    | '/_staff/payroll/_layout/'
    | '/_staff/person/add-person-certification/'
    | '/_staff/person/add/'
    | '/_staff/person/external-hr-saas/'
    | '/_staff/places/_layout/'
    | '/_staff/places/add-select/'
    | '/_staff/places/add/'
    | '/_staff/public-ids/$id/'
    | '/_staff/public-ids/_list/'
    | '/_staff/public-ids/add/'
    | '/_staff/settings/contracting-corporation-profile/'
    | '/_staff/settings/permission-and-roles/'
    | '/_staff/settings/persons/'
    | '/_staff/software/add/'
    | '/_staff/starlinks/_layout/'
    | '/_staff/storage-files/_list/'
    | '/_staff/supplier/_list/'
    | '/_staff/time-and-attendance/_layout/'
    | '/auth/invitation/$invitationCode/'
    | '/auth/sign-in/error/'
    | '/_staff/person/$id/_profile/'
    | '/_individual/individual/portal/lookup/clocking-record'
    | '/_individual/individual/portal/lookup/pay-slip'
    | '/_staff/attendances/_layout/clocking-records/$employeeId'
    | '/_staff/business-partner/_list/_placeholders/alerts'
    | '/_staff/business-partner/_list/_placeholders/contract-and-cost'
    | '/_staff/business-partner/_list/_placeholders/operation-activity'
    | '/_staff/business-partner/_list/_placeholders/rule-and-policy'
    | '/_staff/business-partner/_list/_placeholders/settings'
    | '/_staff/certification/_list/_placeholders/alerts'
    | '/_staff/certification/_list/_placeholders/operation-activity'
    | '/_staff/certification/_list/_placeholders/overview'
    | '/_staff/certification/_list/_placeholders/rule-and-policy'
    | '/_staff/contract/_list/_placeholders/alerts'
    | '/_staff/contract/_list/_placeholders/contract-and-cost'
    | '/_staff/contract/_list/_placeholders/operation-activity'
    | '/_staff/contract/_list/_placeholders/overview'
    | '/_staff/contract/_list/_placeholders/people'
    | '/_staff/deal/$dealId/_layout/flow'
    | '/_staff/deal/$dealId/_layout/structure'
    | '/_staff/payroll/_layout/pay-slips/$employeeId'
    | '/_staff/software/_layout/marketplace/$id'
    | '/_staff/supplier/$supplierId/_layout/files'
    | '/_staff/supplier/$supplierId/_layout/rules-and-policy'
    | '/_staff/supplier/$supplierId/_layout/settings'
    | '/_staff/supplier/_list/_placeholders/alerts'
    | '/_staff/supplier/_list/_placeholders/contract-and-cost'
    | '/_staff/supplier/_list/_placeholders/operation-activity'
    | '/_staff/supplier/_list/_placeholders/overview'
    | '/_staff/supplier/_list/_placeholders/rule-and-policy'
    | '/_individual/individual/_profile/my-profile'
    | '/_individual/individual/_profile/my-profile/_layout'
    | '/_individual/individual/task/$id/approval-dialog'
    | '/_staff/accesses/_layout/_placeholders/contract-and-cost'
    | '/_staff/accesses/_layout/_placeholders/overview'
    | '/_staff/accesses/_layout/_placeholders/software'
    | '/_staff/app-integrations/$id/_$id/$'
    | '/_staff/business-partner/add/$businessPartnerType/completed'
    | '/_staff/certification/add/$certificationKind/completed'
    | '/_staff/certification/handling-certification/$id'
    | '/_staff/certification/handling-certification/$id/_layout'
    | '/_staff/certification/specialty-certification/$id'
    | '/_staff/certification/specialty-certification/$id/_layout'
    | '/_staff/contract/add/subscription/completed'
    | '/_staff/deal/add/$direction/completed'
    | '/_staff/device-catalog/active/$id'
    | '/_staff/device-catalog/active/$id/_layout'
    | '/_staff/device-catalog/add/$deviceType/completed'
    | '/_staff/device-catalog/draft/$id'
    | '/_staff/device-catalog/draft/$id/_layout'
    | '/_staff/devices/_list/contract-and-cost'
    | '/_staff/devices/_list/contract-and-cost/_contract-and-cost'
    | '/_staff/devices/add/$deviceType/completed'
    | '/_staff/equipment/_layout/_placeholders/overview'
    | '/_staff/equipment/_layout/_placeholders/rule-and-policy'
    | '/_staff/equipment/_layout/_placeholders/settings'
    | '/_staff/equipment/items/$id'
    | '/_staff/equipment/items/$id/_detail'
    | '/_staff/ids/_layout/_placeholders/alerts'
    | '/_staff/ids/_layout/_placeholders/group-id'
    | '/_staff/ids/_layout/_placeholders/operation-activity'
    | '/_staff/ids/_layout/_placeholders/overview'
    | '/_staff/ids/_layout/_placeholders/rule-and-policy'
    | '/_staff/ids/_layout/_placeholders/settings'
    | '/_staff/ids/group-id/$id'
    | '/_staff/ids/group-id/$id/_$id'
    | '/_staff/it-operation-core/_root/in-house-packages/$packageId'
    | '/_staff/it-operation-core/_root/packages/$packageId'
    | '/_staff/labor-core/settings/profile/$profileId'
    | '/_staff/licenses/add/$allocationType/completed'
    | '/_staff/marketplace/sent-orders/$orderId'
    | '/_staff/marketplace/sent-orders/$orderId/_layout'
    | '/_staff/networks/_layout/_placeholders/alerts'
    | '/_staff/networks/_layout/_placeholders/contract-and-cost'
    | '/_staff/networks/_layout/_placeholders/operation-activity'
    | '/_staff/networks/_layout/_placeholders/overview'
    | '/_staff/networks/_layout/_placeholders/rule-and-policy'
    | '/_staff/networks/_layout/_placeholders/settings'
    | '/_staff/payroll/_layout/contract-and-cost'
    | '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost'
    | '/_staff/person/add-person-certification/$certificationKind/completed'
    | '/_staff/person/add/$workerType/completed'
    | '/_staff/person/alumni/$id'
    | '/_staff/person/alumni/$id/_profile'
    | '/_staff/places/_layout/_placeholders/alerts'
    | '/_staff/places/_layout/_placeholders/contract-and-cost'
    | '/_staff/places/_layout/_placeholders/operation-activity'
    | '/_staff/places/_layout/_placeholders/people'
    | '/_staff/places/_layout/_placeholders/rule-and-policy'
    | '/_staff/places/_layout/_placeholders/store'
    | '/_staff/profile/device/$id/$'
    | '/_staff/settings/persons/_list/_account'
    | '/_staff/software/$id/_$id/groups'
    | '/_staff/software/$id/_$id/profiles'
    | '/_staff/software/_layout/alerts'
    | '/_staff/software/_layout/alerts/_alerts'
    | '/_staff/software/_layout/contract-and-cost'
    | '/_staff/software/_layout/contract-and-cost/_contract-and-cost'
    | '/_staff/starlinks/_layout/_placeholders/billing-and-cost'
    | '/_staff/starlinks/_layout/_placeholders/marketplace'
    | '/_staff/starlinks/_layout/_placeholders/operation-activity'
    | '/_staff/storage-files/files/$id'
    | '/_staff/storage-files/files/$id/_$id'
    | '/_staff/storage-files/folders/$id'
    | '/_staff/storage-files/folders/$id/_$id'
    | '/_staff/software/$id/_$id/settings'
    | '/_individual/individual/_tasks/approval-tasks/'
    | '/_individual/individual/_tasks/operation-tasks/'
    | '/_individual/individual/_tasks/request-tasks/'
    | '/_individual/individual/operation-package/$id/'
    | '/_individual/individual/portal/approvals/'
    | '/_individual/individual/portal/lookup/'
    | '/_individual/individual/portal/requests/'
    | '/_individual/individual/task/$id/'
    | '/_stacktrace/development-tickets/$ticketId/_layout/'
    | '/_stacktrace/issues/$id/_layout/'
    | '/_stacktrace/issues/_layout/overview/'
    | '/_stacktrace/product-roadmap/$roadmapId/_layout/'
    | '/_stacktrace/production/$productionId/_layout/'
    | '/_stacktrace/products/$id/_layout/'
    | '/_stacktrace/test-sets/$id/_layout/'
    | '/_stacktrace/test-suites/$id/_layout/'
    | '/_stacktrace/values/$id/_layout/'
    | '/_staff/accesses/_layout/alerts/'
    | '/_staff/accesses/_layout/list/'
    | '/_staff/accesses/_layout/settings/'
    | '/_staff/attendance-core/_layout/archive/'
    | '/_staff/attendance-core/_layout/config/'
    | '/_staff/attendance-core/_layout/dashboard/'
    | '/_staff/attendance-core/_layout/operation-packages/'
    | '/_staff/attendance-engine/_layout/attendance-structures/'
    | '/_staff/attendance-engine/_layout/attendance-units/'
    | '/_staff/attendance-engine/_layout/items/'
    | '/_staff/attendance-engine/_layout/logic-components/'
    | '/_staff/attendances/_layout/alerts/'
    | '/_staff/attendances/_layout/clocking-records/'
    | '/_staff/attendances/_layout/employees/'
    | '/_staff/attendances/_layout/operation-activity/'
    | '/_staff/attendances/_layout/overview/'
    | '/_staff/attendances/_layout/rule-and-policy/'
    | '/_staff/attendances/_layout/settings/'
    | '/_staff/business-partner/_list/terminated/'
    | '/_staff/business-partner/add/$businessPartnerType/'
    | '/_staff/certification/_list/people/'
    | '/_staff/certification/_list/settings/'
    | '/_staff/certification/add/$certificationKind/'
    | '/_staff/cockpit/approval/$id/'
    | '/_staff/cockpit/task/$taskId/'
    | '/_staff/contract/add/subscription/'
    | '/_staff/contract/import-csv/$contractType/'
    | '/_staff/contractor-core/_packages/archives/'
    | '/_staff/contractor-core/_packages/configs/'
    | '/_staff/contractor-core/config/$patternId/'
    | '/_staff/deal/add/$direction/'
    | '/_staff/device-catalog/add/$deviceType/'
    | '/_staff/devices/$id/_layout/'
    | '/_staff/devices/_list/inventories/'
    | '/_staff/devices/_list/inventory/'
    | '/_staff/devices/_list/people/'
    | '/_staff/devices/_list/settings/'
    | '/_staff/devices/add/$deviceType/'
    | '/_staff/devices/add/catalog/'
    | '/_staff/equipment/_layout/alerts/'
    | '/_staff/equipment/_layout/items/'
    | '/_staff/equipment/_layout/settings/'
    | '/_staff/fleets/_layout/_list/'
    | '/_staff/ga-operation-core/_packages/archives/'
    | '/_staff/ga-operation-core/_packages/configs/'
    | '/_staff/ga-operation-core/config/$patternId/'
    | '/_staff/ids/_layout/people/'
    | '/_staff/ids/group-id/add/'
    | '/_staff/it-operation-core/_root/archives/'
    | '/_staff/it-operation-core/_root/config/'
    | '/_staff/it-operation-core/_root/in-house-packages/'
    | '/_staff/it-operation-core/_root/packages/'
    | '/_staff/it-operation-core/config/$patternId/'
    | '/_staff/it-operation-core/self-report-patterns/$patternId/'
    | '/_staff/labor-core/_packages/archives/'
    | '/_staff/labor-core/_packages/configs/'
    | '/_staff/labor-core/_packages/settings/'
    | '/_staff/labor-core/config/$patternId/'
    | '/_staff/licenses/_list/alerts/'
    | '/_staff/licenses/_list/contract-and-cost/'
    | '/_staff/licenses/_list/inventory/'
    | '/_staff/licenses/_list/operation-activity/'
    | '/_staff/licenses/_list/people/'
    | '/_staff/licenses/_list/rule-and-policy/'
    | '/_staff/licenses/_list/settings/'
    | '/_staff/licenses/add/$allocationType/'
    | '/_staff/marketplace/sales-orders/$orderId/'
    | '/_staff/organization/$id/_layout/'
    | '/_staff/organization/_list/alert/'
    | '/_staff/organization/_list/chart/'
    | '/_staff/organization/_list/cost/'
    | '/_staff/organization/_list/history/'
    | '/_staff/organization/_list/rule-policy/'
    | '/_staff/organization/_list/settings/'
    | '/_staff/organization/plan/$id/'
    | '/_staff/organization/plan/create/'
    | '/_staff/payroll-core/_layout/archive/'
    | '/_staff/payroll-core/_layout/config/'
    | '/_staff/payroll-core/_layout/dashboard/'
    | '/_staff/payroll-core/_layout/operation-packages/'
    | '/_staff/payroll-core/_layout/person-targets/'
    | '/_staff/payroll-engine/_layout/items/'
    | '/_staff/payroll-engine/_layout/logic-components/'
    | '/_staff/payroll-engine/_layout/payroll-structures/'
    | '/_staff/payroll-engine/_layout/payroll-units/'
    | '/_staff/payroll/_layout/alerts/'
    | '/_staff/payroll/_layout/overview/'
    | '/_staff/payroll/_layout/pay-slips/'
    | '/_staff/payroll/_layout/rule-and-policy/'
    | '/_staff/payroll/_layout/settings/'
    | '/_staff/people/_list/alumni/'
    | '/_staff/people/_list/operation-activity/'
    | '/_staff/people/_list/settings/'
    | '/_staff/people/_list/workforce/'
    | '/_staff/person/add-person-certification/$certificationKind/'
    | '/_staff/person/add/$workerType/'
    | '/_staff/person/automap-ingester/$workerType/'
    | '/_staff/places/_layout/settings/'
    | '/_staff/profile/device/$id/'
    | '/_staff/public-ids/$id/details/'
    | '/_staff/public-ids/$id/files/'
    | '/_staff/public-ids/_list/alerts/'
    | '/_staff/public-ids/_list/members/'
    | '/_staff/public-ids/_list/operation-activity/'
    | '/_staff/public-ids/_list/registry/'
    | '/_staff/public-ids/_list/rules-and-policies/'
    | '/_staff/public-ids/_list/settings/'
    | '/_staff/settings/data-connector/inbound/'
    | '/_staff/settings/data-connector/outbound/'
    | '/_staff/settings/persons/invite/'
    | '/_staff/software/$id/_$id/'
    | '/_staff/software/_layout/library/'
    | '/_staff/software/_layout/operation-activity/'
    | '/_staff/software/_layout/people/'
    | '/_staff/software/_layout/registry/'
    | '/_staff/software/_layout/rule-and-policy/'
    | '/_staff/software/_layout/settings/'
    | '/_staff/software/add/$type/'
    | '/_staff/starlinks/_layout/alerts/'
    | '/_staff/starlinks/_layout/user-terminals/'
    | '/_staff/storage-files/_list/files/'
    | '/_staff/storage-files/_list/folders/'
    | '/_staff/storage-files/_list/settings/'
    | '/_staff/supplier/_list/settings/'
    | '/_staff/time-and-attendance/_layout/attendance-links/'
    | '/_staff/equipment/$id/_layout/'
    | '/_staff/licenses/$id/_profile/'
    | '/_individual/individual/_profile/my-profile/_layout/'
    | '/_staff/person/alumni/$id/_profile/'
    | '/_staff/contract/$id/_layout/_placeholders/approval-info'
    | '/_staff/contract/$id/_layout/_placeholders/history'
    | '/_staff/contract/$id/_layout/_placeholders/operation-activity'
    | '/_staff/contract/$id/_layout/_placeholders/risk-provisions'
    | '/_staff/contract/$id/_layout/_placeholders/rule-and-policy'
    | '/_stacktrace/products/$id/scope/$nodeId'
    | '/_stacktrace/products/$id/scope/$nodeId/_layout'
    | '/_stacktrace/test-suites/$id/_layout/test-plan'
    | '/_stacktrace/test-suites/$id/_layout/test-plan/_layout'
    | '/_stacktrace/test-suites/$id/_layout/test-review'
    | '/_stacktrace/test-suites/$id/_layout/test-review/_layout'
    | '/_staff/attendance-engine/_layout/attendance-structures/$structureId'
    | '/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout'
    | '/_staff/business-partner/$id/_layout/bp-role-info'
    | '/_staff/business-partner/$id/_layout/bp-role-info/_layout'
    | '/_staff/devices/add/catalog/$deviceType/completed'
    | '/_staff/ids/group-id/add/from-scratch/completed'
    | '/_staff/it-operation-core/_detail/operation-instances/$instanceId'
    | '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout'
    | '/_staff/it-operation-core/_root/in-house-packages/$packageId/start-targets'
    | '/_staff/licenses/$id/service-plans/$licenseServiceId'
    | '/_staff/licenses/$id/service-plans/$licenseServiceId/_detail'
    | '/_staff/marketplace/sent-orders/$orderId/_layout/activities'
    | '/_staff/payroll-engine/_layout/payroll-structures/$structureId'
    | '/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout'
    | '/_staff/settings/data-connector/inbound/aggregate-data-pipeline'
    | '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/_list'
    | '/_staff/settings/data-connector/inbound/data-pipeline'
    | '/_staff/settings/data-connector/inbound/data-pipeline/_list'
    | '/_staff/settings/data-connector/outbound/data-pipeline'
    | '/_staff/settings/data-connector/outbound/data-pipeline/_list'
    | '/_staff/software/$id/_$id/contract-and-cost'
    | '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost'
    | '/_individual/individual/portal/lookup/clocking-record/alerts'
    | '/_individual/individual/portal/lookup/clocking-record/files'
    | '/_individual/individual/portal/lookup/clocking-record/overview'
    | '/_individual/individual/portal/lookup/clocking-record/schedule'
    | '/_individual/individual/portal/lookup/pay-slip/alerts'
    | '/_individual/individual/portal/lookup/pay-slip/files'
    | '/_individual/individual/portal/lookup/pay-slip/history'
    | '/_individual/individual/portal/lookup/pay-slip/overview'
    | '/_staff/attendances/_layout/clocking-records/$employeeId/alerts'
    | '/_staff/attendances/_layout/clocking-records/$employeeId/files'
    | '/_staff/attendances/_layout/clocking-records/$employeeId/overview'
    | '/_staff/attendances/_layout/clocking-records/$employeeId/schedule'
    | '/_staff/attendances/_layout/clocking-records/$employeeId/settings'
    | '/_staff/payroll/_layout/pay-slips/$employeeId/alerts'
    | '/_staff/payroll/_layout/pay-slips/$employeeId/files'
    | '/_staff/payroll/_layout/pay-slips/$employeeId/history'
    | '/_staff/payroll/_layout/pay-slips/$employeeId/overview'
    | '/_staff/payroll/_layout/pay-slips/$employeeId/settings'
    | '/_individual/individual/task/$id/approval/'
    | '/_stacktrace/development-tickets/$ticketId/_layout/history/'
    | '/_stacktrace/issues/$id/_layout/history/'
    | '/_stacktrace/product-roadmap/$roadmapId/_layout/detail/'
    | '/_stacktrace/product-roadmap/$roadmapId/_layout/history/'
    | '/_stacktrace/production/$productionId/_layout/dev-scope/'
    | '/_stacktrace/production/$productionId/_layout/issue-scope/'
    | '/_stacktrace/production/$productionId/_layout/product-scope/'
    | '/_stacktrace/production/$productionId/_layout/quality-scope/'
    | '/_stacktrace/production/$productionId/_layout/value/'
    | '/_stacktrace/products/$id/_layout/product-scope/'
    | '/_stacktrace/test-sets/$id/_layout/conditions/'
    | '/_stacktrace/test-sets/$id/_layout/target-functions/'
    | '/_stacktrace/test-suites/$id/_layout/document/'
    | '/_stacktrace/test-suites/$id/_layout/issues/'
    | '/_stacktrace/test-suites/$id/_layout/overview/'
    | '/_stacktrace/test-suites/$id/_layout/target-functions/'
    | '/_stacktrace/test-suites/$id/_layout/test-set/'
    | '/_stacktrace/values/$id/_layout/history/'
    | '/_stacktrace/values/$id/_layout/product-scope/'
    | '/_staff/accesses/_layout/list/$traceableAppId/'
    | '/_staff/attendance-engine/_layout/attendance-units/$unitId/'
    | '/_staff/attendance-engine/_layout/items/$componentId/'
    | '/_staff/attendance-engine/_layout/logic-components/$componentId/'
    | '/_staff/business-partner/$id/_layout/_index/'
    | '/_staff/business-partner/$id/_layout/address-and-contact/'
    | '/_staff/certification/$id/_layout/_index/'
    | '/_staff/certification/$id/_layout/certification-holders/'
    | '/_staff/certification/$id/_layout/handling-certifications/'
    | '/_staff/certification/$id/_layout/specialty-certifications/'
    | '/_staff/certification/_list/settings/issuing-organization/'
    | '/_staff/certification/_list/settings/specialty-category-level/'
    | '/_staff/certification/_list/settings/specialty-category/'
    | '/_staff/deal/$dealId/_layout/_index/'
    | '/_staff/devices/$id/_layout/control/'
    | '/_staff/devices/$id/_layout/files/'
    | '/_staff/devices/$id/_layout/history/'
    | '/_staff/devices/$id/_layout/lifecycle/'
    | '/_staff/devices/$id/_layout/mdm/'
    | '/_staff/devices/$id/_layout/profile/'
    | '/_staff/devices/$id/_layout/status/'
    | '/_staff/devices/_list/contract-and-cost/_contract-and-cost/'
    | '/_staff/devices/_list/settings/catalog/'
    | '/_staff/devices/add/catalog/$deviceType/'
    | '/_staff/devices/external-it-saas/$appIntegrationId/preview/'
    | '/_staff/equipment/_layout/settings/equipment-items/'
    | '/_staff/equipment/_layout/settings/equipment-types/'
    | '/_staff/equipment/items/$id/_detail/'
    | '/_staff/ids/group-id/$id/_$id/'
    | '/_staff/ids/group-id/add/from-scratch/'
    | '/_staff/it-operation-core/_detail/operation-instances/$instanceId/'
    | '/_staff/licenses/$id/_profile/assignments/'
    | '/_staff/licenses/$id/_profile/people/'
    | '/_staff/licenses/$id/_profile/rule-and-policy/'
    | '/_staff/licenses/$id/_profile/service-plans/'
    | '/_staff/marketplace/_store/store/devices/'
    | '/_staff/marketplace/_store/store/licenses/'
    | '/_staff/marketplace/_store/store/sales-orders/'
    | '/_staff/marketplace/_store/store/sent-orders/'
    | '/_staff/marketplace/_store/store/starlinks/'
    | '/_staff/marketplace/sent-orders/$orderId/_layout/'
    | '/_staff/organization/$id/_layout/history/'
    | '/_staff/organization/plan/$id/add/'
    | '/_staff/organization/plan/$id/transfers/'
    | '/_staff/payroll-engine/_layout/items/$componentId/'
    | '/_staff/payroll-engine/_layout/logic-components/$componentId/'
    | '/_staff/payroll-engine/_layout/payroll-units/$unitId/'
    | '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/'
    | '/_staff/people/_list/settings/board-member-types/'
    | '/_staff/people/_list/settings/collaborator-types/'
    | '/_staff/people/_list/settings/contract-end-reasons/'
    | '/_staff/people/_list/settings/contractor-types/'
    | '/_staff/people/_list/settings/employee-sub-id-names/'
    | '/_staff/people/_list/settings/employment-types/'
    | '/_staff/people/_list/settings/grades/'
    | '/_staff/people/_list/settings/health-insurance-associations/'
    | '/_staff/people/_list/settings/job-competencies/'
    | '/_staff/people/_list/settings/job-functions/'
    | '/_staff/people/_list/settings/job-grades/'
    | '/_staff/people/_list/settings/job-levels/'
    | '/_staff/people/_list/settings/job-titles/'
    | '/_staff/people/_list/settings/job-types/'
    | '/_staff/people/_list/settings/place-social-insurances/'
    | '/_staff/people/_list/settings/positions/'
    | '/_staff/people/_list/settings/retirement-reasons/'
    | '/_staff/people/_list/settings/work-mode/'
    | '/_staff/person/$id/_profile/apps/'
    | '/_staff/person/$id/_profile/contractor-information/'
    | '/_staff/person/$id/_profile/devices/'
    | '/_staff/person/$id/_profile/education-and-qualification/'
    | '/_staff/person/$id/_profile/employee-information/'
    | '/_staff/person/$id/_profile/equipment/'
    | '/_staff/person/$id/_profile/history/'
    | '/_staff/person/$id/_profile/operation-activity/'
    | '/_staff/person/$id/_profile/personal-information/'
    | '/_staff/person/$id/_profile/public-id/'
    | '/_staff/person/external-hr-saas/$appIntegrationId/preview/'
    | '/_staff/places/$id/_layout/administrators/'
    | '/_staff/places/$id/_layout/labor-core/'
    | '/_staff/places/_layout/settings/place-sub-codes/'
    | '/_staff/settings/contracting-corporation-profile/_layout/board-member/'
    | '/_staff/settings/contracting-corporation-profile/_layout/contact-points/'
    | '/_staff/settings/contracting-corporation-profile/_layout/corporate-overview/'
    | '/_staff/settings/contracting-corporation-profile/_layout/group-companies/'
    | '/_staff/settings/contracting-corporation-profile/_layout/history/'
    | '/_staff/settings/contracting-corporation-profile/_layout/registration/'
    | '/_staff/settings/contracting-corporation-profile/_layout/shareholders/'
    | '/_staff/settings/permission-and-roles/_list/category-permissions/'
    | '/_staff/settings/permission-and-roles/_list/people-groups/'
    | '/_staff/settings/permission-and-roles/_list/product-permissions/'
    | '/_staff/settings/permission-and-roles/_list/roles/'
    | '/_staff/settings/persons/_list/settings/'
    | '/_staff/software/$id/_$id/accounts/'
    | '/_staff/software/$id/_$id/activity-monitoring/'
    | '/_staff/software/$id/_$id/alerts/'
    | '/_staff/software/$id/_$id/architecture/'
    | '/_staff/software/$id/_$id/detail/'
    | '/_staff/software/$id/_$id/rule-and-policy/'
    | '/_staff/software/$id/_$id/settings/'
    | '/_staff/software/_layout/alerts/_alerts/'
    | '/_staff/software/_layout/contract-and-cost/_contract-and-cost/'
    | '/_staff/software/_layout/library/search/'
    | '/_staff/software/custom-saas/add/$customSaasType/'
    | '/_staff/supplier/$supplierId/_layout/_index/'
    | '/_staff/supplier/_list/settings/procurement-categories/'
    | '/_staff/supplier/_list/settings/supplier-categories/'
    | '/_staff/supplier/_list/settings/supplier-subcategories/'
    | '/_staff/time-and-attendance/_layout/_list/summary/'
    | '/_staff/time-and-attendance/_layout/attendance-links/$placeId/'
    | '/_staff/users/$userId/_layout/_identity/'
    | '/_staff/users/$userId/_layout/sessions/'
    | '/_individual/individual/portal/lookup/clocking-record/'
    | '/_individual/individual/portal/lookup/pay-slip/'
    | '/_staff/attendances/_layout/clocking-records/$employeeId/'
    | '/_staff/contract/$id/_layout/_index/'
    | '/_staff/contract/$id/_layout/structure/'
    | '/_staff/equipment/$id/_layout/lifecycle/'
    | '/_staff/equipment/$id/_layout/status/'
    | '/_staff/fleets/$id/_layout/_profile/'
    | '/_staff/networks/$id/_layout/_profile/'
    | '/_staff/payroll/_layout/pay-slips/$employeeId/'
    | '/_staff/places/$id/_layout/_profile/'
    | '/_staff/starlinks/$id/_layout/_overview/'
    | '/_staff/starlinks/$id/_layout/detail/'
    | '/_staff/storage-files/files/$id/_$id/'
    | '/_staff/storage-files/folders/$id/_$id/'
    | '/_individual/individual/_profile/certifications/base-certifications/$id'
    | '/_individual/individual/_profile/certifications/base-certifications/$id/_layout'
    | '/_individual/individual/_profile/certifications/handling-certifications/$id'
    | '/_individual/individual/_profile/certifications/handling-certifications/$id/_layout'
    | '/_individual/individual/_profile/certifications/specialty-certifications/$id'
    | '/_individual/individual/_profile/certifications/specialty-certifications/$id/_layout'
    | '/_staff/device-catalog/active/$id/_layout/contract-and-cost'
    | '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost'
    | '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal'
    | '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal'
    | '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId'
    | '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout'
    | '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId'
    | '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout'
    | '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId'
    | '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout'
    | '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id'
    | '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail'
    | '/_staff/settings/data-connector/inbound/data-pipeline/$id'
    | '/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail'
    | '/_staff/settings/data-connector/outbound/data-pipeline/$id'
    | '/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail'
    | '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal'
    | '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal'
    | '/_individual/individual/_profile/my-profile/_layout/devices/'
    | '/_individual/individual/_profile/my-profile/_layout/education-and-qualification/'
    | '/_individual/individual/_profile/my-profile/_layout/softwares/'
    | '/_individual/individual/contract/$id/signature-request/$signatureRequestId/'
    | '/_individual/individual/operation-package/$id/pattern/$patternId/'
    | '/_individual/individual/operation-package/$id/target/$targetId/'
    | '/_stacktrace/production/$productionId/_layout/dev-scope/edit/'
    | '/_stacktrace/production/$productionId/_layout/issue-scope/edit/'
    | '/_stacktrace/production/$productionId/_layout/value/edit/'
    | '/_stacktrace/products/$id/scope/$nodeId/_layout/'
    | '/_stacktrace/test-suites/$id/_layout/test-plan/_layout/'
    | '/_stacktrace/test-suites/$id/_layout/test-review/_layout/'
    | '/_staff/accesses/_layout/alerts/detail/$shadowItAppId/'
    | '/_staff/accesses/_layout/alerts/dormancy/$softwareId/'
    | '/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout/'
    | '/_staff/business-partner/$id/_layout/bp-role-info/_layout/'
    | '/_staff/certification/handling-certification/$id/_layout/_index/'
    | '/_staff/certification/handling-certification/$id/_layout/certification-holders/'
    | '/_staff/certification/specialty-certification/$id/_layout/_index/'
    | '/_staff/certification/specialty-certification/$id/_layout/certification-holders/'
    | '/_staff/certification/specialty-certification/$id/_layout/handling-certifications/'
    | '/_staff/device-catalog/active/$id/_layout/profile/'
    | '/_staff/device-catalog/draft/$id/_layout/profile/'
    | '/_staff/devices/_list/contract-and-cost/_contract-and-cost/cost/'
    | '/_staff/devices/_list/contract-and-cost/_contract-and-cost/payment/'
    | '/_staff/equipment/items/$id/_detail/alerts/'
    | '/_staff/equipment/items/$id/_detail/inventory/'
    | '/_staff/equipment/items/$id/_detail/rule-and-policy/'
    | '/_staff/ids/group-id/$id/_$id/detail/'
    | '/_staff/ids/group-id/$id/_$id/devices/'
    | '/_staff/ids/group-id/$id/_$id/members/'
    | '/_staff/ids/group-id/$id/_$id/rule-and-policy/'
    | '/_staff/ids/group-id/$id/_$id/security-and-auth/'
    | '/_staff/ids/group-id/$id/_$id/softwares/'
    | '/_staff/marketplace/_store/store/devices/$productId/'
    | '/_staff/marketplace/_store/store/licenses/$productId/'
    | '/_staff/marketplace/_store/store/starlinks/$productId/'
    | '/_staff/organization/plan/$id/edit/$unitId/'
    | '/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout/'
    | '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/cost/'
    | '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/deal/'
    | '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/payment/'
    | '/_staff/person/$id/_profile/family/$familyPersonId/'
    | '/_staff/person/alumni/$id/_profile/apps/'
    | '/_staff/person/alumni/$id/_profile/contractor-information/'
    | '/_staff/person/alumni/$id/_profile/devices/'
    | '/_staff/person/alumni/$id/_profile/education-and-qualification/'
    | '/_staff/person/alumni/$id/_profile/employee-information/'
    | '/_staff/person/alumni/$id/_profile/equipment/'
    | '/_staff/person/alumni/$id/_profile/history/'
    | '/_staff/person/alumni/$id/_profile/operation-activity/'
    | '/_staff/person/alumni/$id/_profile/personal-information/'
    | '/_staff/person/alumni/$id/_profile/public-id/'
    | '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/_list/'
    | '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/add/'
    | '/_staff/settings/data-connector/inbound/data-pipeline/_list/'
    | '/_staff/settings/data-connector/inbound/data-pipeline/add/'
    | '/_staff/settings/data-connector/outbound/data-pipeline/_list/'
    | '/_staff/settings/data-connector/outbound/data-pipeline/add/'
    | '/_staff/settings/permission-and-roles/_detail/category-permissions/$id/'
    | '/_staff/settings/permission-and-roles/_detail/people-groups/$id/'
    | '/_staff/settings/permission-and-roles/_detail/product-permissions/$id/'
    | '/_staff/settings/permission-and-roles/_detail/roles/$id/'
    | '/_staff/settings/permission-and-roles/_form/category-permissions/new/'
    | '/_staff/settings/permission-and-roles/_form/people-groups/new/'
    | '/_staff/settings/permission-and-roles/_form/product-permissions/new/'
    | '/_staff/settings/permission-and-roles/_form/roles/new/'
    | '/_staff/settings/persons/_list/_account/individual/'
    | '/_staff/settings/persons/_list/_account/staff/'
    | '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/'
    | '/_staff/software/$id/_$id/settings/integration/'
    | '/_staff/software/$id/_$id/settings/role/'
    | '/_staff/software/$id/_$id/settings/status/'
    | '/_staff/software/_layout/alerts/_alerts/alumni/'
    | '/_staff/software/_layout/alerts/_alerts/inactive-user/'
    | '/_staff/software/_layout/alerts/_alerts/no-user/'
    | '/_staff/software/_layout/alerts/_alerts/no-worker/'
    | '/_staff/software/_layout/alerts/_alerts/violated-assignment/'
    | '/_staff/software/_layout/alerts/_alerts/violated-role/'
    | '/_staff/software/_layout/contract-and-cost/_contract-and-cost/cost/'
    | '/_staff/software/_layout/contract-and-cost/_contract-and-cost/payment/'
    | '/_staff/software/_layout/library/category/$category/'
    | '/_staff/software/_layout/library/detail/$softwareLibraryId/'
    | '/_staff/storage-files/folders/$id/_$id/files/'
    | '/_staff/storage-files/folders/$id/_$id/users/'
    | '/_staff/time-and-attendance/_layout/_list/summary/daily-place/'
    | '/_staff/time-and-attendance/_layout/_list/summary/monthly-person/'
    | '/_staff/time-and-attendance/_layout/_list/summary/monthly-place/'
    | '/_staff/equipment/items/$id/_detail/profile/'
    | '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal'
    | '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal'
    | '/_stacktrace/products/$id/scope/$nodeId/_layout/value/'
    | '/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout/structure/'
    | '/_staff/business-partner/$id/_layout/bp-role-info/_layout/$bpRole/'
    | '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/'
    | '/_staff/devices/_list/contract-and-cost/_contract-and-cost/cost/$period/'
    | '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/'
    | '/_staff/devices/_list/contract-and-cost/_contract-and-cost/payment/$period/'
    | '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/data/'
    | '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/detail/'
    | '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/operation-activity/'
    | '/_staff/licenses/$id/service-plans/$licenseServiceId/_detail/accounts/'
    | '/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout/structure/'
    | '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/cost/$period/'
    | '/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/payment/$period/'
    | '/_staff/settings/permission-and-roles/_form/category-permissions/$id/edit/'
    | '/_staff/settings/permission-and-roles/_form/people-groups/$id/edit/'
    | '/_staff/settings/permission-and-roles/_form/product-permissions/$id/edit/'
    | '/_staff/settings/permission-and-roles/_form/roles/$id/edit/'
    | '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/cost/'
    | '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/payment/'
    | '/_staff/software/_layout/contract-and-cost/_contract-and-cost/cost/$period/'
    | '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/'
    | '/_staff/software/_layout/contract-and-cost/_contract-and-cost/payment/$period/'
    | '/_staff/software/_layout/library/category/$category/search/'
    | '/_staff/software/_layout/marketplace/$id/install/finish/'
    | '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
    | '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile'
    | '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal'
    | '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal'
    | '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
    | '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile'
    | '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
    | '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile'
    | '/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId'
    | '/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/_task-detail'
    | '/_individual/individual/_profile/certifications/base-certifications/$id/_layout/_index/'
    | '/_individual/individual/_profile/certifications/handling-certifications/$id/_layout/_index/'
    | '/_individual/individual/_profile/certifications/specialty-certifications/$id/_layout/_index/'
    | '/_individual/individual/task/$id/_operation-package/_common/form/$formId/'
    | '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/cost/'
    | '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/payment/'
    | '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/all/'
    | '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/contract/'
    | '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/estimate/'
    | '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/order/'
    | '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/payment/'
    | '/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/'
    | '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout/_index/'
    | '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout/_index/'
    | '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout/_index/'
    | '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/basic-info/'
    | '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/execution-plan/'
    | '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/priority-setting/'
    | '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/tasks/'
    | '/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/basic-settings/'
    | '/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/data-link-settings/'
    | '/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/execution-plan/'
    | '/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/execution-results/'
    | '/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/basic-settings/'
    | '/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/data-link-settings/'
    | '/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/execution-plan/'
    | '/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/execution-results/'
    | '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/cost/$period/'
    | '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/'
    | '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/payment/$period/'
    | '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/all/'
    | '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/contract/'
    | '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/estimate/'
    | '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/order/'
    | '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/payment/'
    | '/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/'
    | '/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId'
    | '/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile'
    | '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/'
    | '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/cost/$period/'
    | '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/'
    | '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/payment/$period/'
    | '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/'
    | '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/'
    | '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/'
    | '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/all/'
    | '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/contract/'
    | '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/estimate/'
    | '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/order/'
    | '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/payment/'
    | '/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/'
    | '/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/'
    | '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/'
    | '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/all/'
    | '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/contract/'
    | '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/estimate/'
    | '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/order/'
    | '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/payment/'
    | '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/'
    | '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/'
    | '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/'
    | '/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/_task-detail/chunks/'
    | '/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/'
    | '/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/$chunkId/result/'
    | '/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/chunks/$chunkId/result/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ChatRoute: typeof ChatRouteWithChildren
  CockpitMockRoute: typeof CockpitMockRouteWithChildren
  IdpSsoMockRoute: typeof IdpSsoMockRouteWithChildren
  IndividualRoute: typeof IndividualRouteWithChildren
  StacktraceRoute: typeof StacktraceRouteWithChildren
  StaffRoute: typeof StaffRouteWithChildren
  MeIndexRoute: typeof MeIndexRoute
  AccountSsoIndexRoute: typeof AccountSsoIndexRoute
  AuthPasswordResetIndexRoute: typeof AuthPasswordResetIndexRoute
  AuthSignInIndexRoute: typeof AuthSignInIndexRoute
  Oauth2ConsentIndexRoute: typeof Oauth2ConsentIndexRoute
  Oauth2ErrorIndexRoute: typeof Oauth2ErrorIndexRoute
  Oauth2LoginIndexRoute: typeof Oauth2LoginIndexRoute
  Oauth2LogoutIndexRoute: typeof Oauth2LogoutIndexRoute
  AuthInvitationInvitationCodeIndexRoute: typeof AuthInvitationInvitationCodeIndexRoute
  AuthSignInErrorIndexRoute: typeof AuthSignInErrorIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ChatRoute: ChatRouteWithChildren,
  CockpitMockRoute: CockpitMockRouteWithChildren,
  IdpSsoMockRoute: IdpSsoMockRouteWithChildren,
  IndividualRoute: IndividualRouteWithChildren,
  StacktraceRoute: StacktraceRouteWithChildren,
  StaffRoute: StaffRouteWithChildren,
  MeIndexRoute: MeIndexRoute,
  AccountSsoIndexRoute: AccountSsoIndexRoute,
  AuthPasswordResetIndexRoute: AuthPasswordResetIndexRoute,
  AuthSignInIndexRoute: AuthSignInIndexRoute,
  Oauth2ConsentIndexRoute: Oauth2ConsentIndexRoute,
  Oauth2ErrorIndexRoute: Oauth2ErrorIndexRoute,
  Oauth2LoginIndexRoute: Oauth2LoginIndexRoute,
  Oauth2LogoutIndexRoute: Oauth2LogoutIndexRoute,
  AuthInvitationInvitationCodeIndexRoute:
    AuthInvitationInvitationCodeIndexRoute,
  AuthSignInErrorIndexRoute: AuthSignInErrorIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_chat",
        "/_cockpit-mock",
        "/_idp-sso-mock",
        "/_individual",
        "/_stacktrace",
        "/_staff",
        "/me/",
        "/account/sso/",
        "/auth/password-reset/",
        "/auth/sign-in/",
        "/oauth2/consent/",
        "/oauth2/error/",
        "/oauth2/login/",
        "/oauth2/logout/",
        "/auth/invitation/$invitationCode/",
        "/auth/sign-in/error/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_chat": {
      "filePath": "_chat.tsx",
      "children": [
        "/_chat/chat/",
        "/_chat/chat/$sessionId/",
        "/_chat/chat/new/"
      ]
    },
    "/_cockpit-mock": {
      "filePath": "_cockpit-mock.tsx",
      "children": [
        "/_cockpit-mock/cockpit-mock/"
      ]
    },
    "/_idp-sso-mock": {
      "filePath": "_idp-sso-mock.tsx",
      "children": [
        "/_idp-sso-mock/idp-sso/google-workspace/"
      ]
    },
    "/_individual": {
      "filePath": "_individual.tsx",
      "children": [
        "/_individual/individual"
      ]
    },
    "/_stacktrace": {
      "filePath": "_stacktrace.tsx",
      "children": [
        "/_stacktrace/planning-operations-core",
        "/_stacktrace/product-planning-core",
        "/_stacktrace/qa-operations-core",
        "/_stacktrace/development-tickets/import-csv",
        "/_stacktrace/issues/import-csv",
        "/_stacktrace/values/import-csv",
        "/_stacktrace/issues",
        "/_stacktrace/product-roadmap",
        "/_stacktrace/test-sets",
        "/_stacktrace/test-suites",
        "/_stacktrace/values",
        "/_stacktrace/development-tickets/",
        "/_stacktrace/production/",
        "/_stacktrace/products/",
        "/_stacktrace/test-assets/",
        "/_stacktrace/development-tickets/$ticketId",
        "/_stacktrace/production/$productionId",
        "/_stacktrace/products/$id",
        "/_stacktrace/development-tickets/add-select/",
        "/_stacktrace/development-tickets/add/",
        "/_stacktrace/development-tickets/external-integrations/",
        "/_stacktrace/products/add-select/",
        "/_stacktrace/products/add/"
      ]
    },
    "/_staff": {
      "filePath": "_staff.tsx",
      "children": [
        "/_staff/apps",
        "/_staff/id-managements",
        "/_staff/it-operation-core/device-inventory",
        "/_staff/places/import-csv",
        "/_staff/accesses",
        "/_staff/attendance-core",
        "/_staff/attendance-engine",
        "/_staff/attendances",
        "/_staff/business-operation-events",
        "/_staff/business-partner",
        "/_staff/certification",
        "/_staff/contract",
        "/_staff/contractor-core",
        "/_staff/deal",
        "/_staff/devices",
        "/_staff/equipment",
        "/_staff/fleets",
        "/_staff/ga-operation-core",
        "/_staff/ids",
        "/_staff/it-operation-core",
        "/_staff/labor-core",
        "/_staff/licenses",
        "/_staff/marketplace",
        "/_staff/networks",
        "/_staff/organization",
        "/_staff/payroll-core",
        "/_staff/payroll-engine",
        "/_staff/payroll",
        "/_staff/people",
        "/_staff/places",
        "/_staff/public-ids/$id",
        "/_staff/public-ids",
        "/_staff/software",
        "/_staff/starlinks",
        "/_staff/storage-files",
        "/_staff/supplier",
        "/_staff/time-and-attendance",
        "/_staff/cockpit/",
        "/_staff/settings/",
        "/_staff/app-integrations/import-csv/$id",
        "/_staff/person/import-csv/$workerType",
        "/_staff/app-integrations/$id",
        "/_staff/person/$id",
        "/_staff/settings/contracting-corporation-profile",
        "/_staff/settings/permission-and-roles",
        "/_staff/settings/persons",
        "/_staff/users/$userId",
        "/_staff/device-catalog/add/",
        "/_staff/person/add-person-certification/",
        "/_staff/person/add/",
        "/_staff/person/external-hr-saas/",
        "/_staff/device-catalog/active/$id",
        "/_staff/device-catalog/add/$deviceType/completed",
        "/_staff/device-catalog/draft/$id",
        "/_staff/person/add-person-certification/$certificationKind/completed",
        "/_staff/person/add/$workerType/completed",
        "/_staff/person/alumni/$id",
        "/_staff/profile/device/$id/$",
        "/_staff/cockpit/approval/$id/",
        "/_staff/cockpit/task/$taskId/",
        "/_staff/device-catalog/add/$deviceType/",
        "/_staff/person/add-person-certification/$certificationKind/",
        "/_staff/person/add/$workerType/",
        "/_staff/person/automap-ingester/$workerType/",
        "/_staff/profile/device/$id/",
        "/_staff/settings/data-connector/inbound/",
        "/_staff/settings/data-connector/outbound/",
        "/_staff/settings/data-connector/inbound/aggregate-data-pipeline",
        "/_staff/settings/data-connector/inbound/data-pipeline",
        "/_staff/settings/data-connector/outbound/data-pipeline",
        "/_staff/person/external-hr-saas/$appIntegrationId/preview/"
      ]
    },
    "/_stacktrace/planning-operations-core": {
      "filePath": "_stacktrace/planning-operations-core.tsx",
      "parent": "/_stacktrace"
    },
    "/_stacktrace/product-planning-core": {
      "filePath": "_stacktrace/product-planning-core.tsx",
      "parent": "/_stacktrace"
    },
    "/_stacktrace/qa-operations-core": {
      "filePath": "_stacktrace/qa-operations-core.tsx",
      "parent": "/_stacktrace"
    },
    "/_staff/apps": {
      "filePath": "_staff/apps.tsx",
      "parent": "/_staff",
      "children": [
        "/_staff/apps/$"
      ]
    },
    "/_staff/id-managements": {
      "filePath": "_staff/id-managements.tsx",
      "parent": "/_staff",
      "children": [
        "/_staff/id-managements/$"
      ]
    },
    "/me/": {
      "filePath": "me/index.tsx"
    },
    "/_stacktrace/development-tickets/import-csv": {
      "filePath": "_stacktrace/development-tickets/import-csv/route.tsx",
      "parent": "/_stacktrace"
    },
    "/_stacktrace/issues/import-csv": {
      "filePath": "_stacktrace/issues/import-csv/route.tsx",
      "parent": "/_stacktrace"
    },
    "/_stacktrace/values/import-csv": {
      "filePath": "_stacktrace/values/import-csv/route.tsx",
      "parent": "/_stacktrace"
    },
    "/_staff/it-operation-core/device-inventory": {
      "filePath": "_staff/it-operation-core/device-inventory/route.tsx",
      "parent": "/_staff",
      "children": [
        "/_staff/it-operation-core/device-inventory/data",
        "/_staff/it-operation-core/device-inventory/detail"
      ]
    },
    "/_staff/places/import-csv": {
      "filePath": "_staff/places/import-csv/route.tsx",
      "parent": "/_staff"
    },
    "/_individual/individual": {
      "filePath": "_individual/individual",
      "parent": "/_individual",
      "children": [
        "/_individual/individual/_profile",
        "/_individual/individual/portal",
        "/_individual/individual/",
        "/_individual/individual/task/$id/approval-dialog",
        "/_individual/individual/_tasks/approval-tasks/",
        "/_individual/individual/_tasks/operation-tasks/",
        "/_individual/individual/_tasks/request-tasks/",
        "/_individual/individual/operation-package/$id/",
        "/_individual/individual/task/$id/",
        "/_individual/individual/task/$id/approval/",
        "/_individual/individual/contract/$id/signature-request/$signatureRequestId/",
        "/_individual/individual/operation-package/$id/pattern/$patternId/",
        "/_individual/individual/operation-package/$id/target/$targetId/",
        "/_individual/individual/task/$id/_operation-package/_common/form/$formId/"
      ]
    },
    "/_individual/individual/_profile": {
      "filePath": "_individual/individual/_profile.tsx",
      "parent": "/_individual/individual",
      "children": [
        "/_individual/individual/_profile/my-profile",
        "/_individual/individual/_profile/certifications/base-certifications/$id",
        "/_individual/individual/_profile/certifications/handling-certifications/$id",
        "/_individual/individual/_profile/certifications/specialty-certifications/$id"
      ]
    },
    "/_individual/individual/portal": {
      "filePath": "_individual/individual/portal.tsx",
      "parent": "/_individual/individual",
      "children": [
        "/_individual/individual/portal/",
        "/_individual/individual/portal/lookup/clocking-record",
        "/_individual/individual/portal/lookup/pay-slip",
        "/_individual/individual/portal/approvals/",
        "/_individual/individual/portal/lookup/",
        "/_individual/individual/portal/requests/"
      ]
    },
    "/_stacktrace/issues": {
      "filePath": "_stacktrace/issues",
      "parent": "/_stacktrace",
      "children": [
        "/_stacktrace/issues/_layout",
        "/_stacktrace/issues/$id",
        "/_stacktrace/issues/add-select/",
        "/_stacktrace/issues/add/",
        "/_stacktrace/issues/external-integrations/"
      ]
    },
    "/_stacktrace/issues/_layout": {
      "filePath": "_stacktrace/issues/_layout.tsx",
      "parent": "/_stacktrace/issues",
      "children": [
        "/_stacktrace/issues/_layout/",
        "/_stacktrace/issues/_layout/overview/"
      ]
    },
    "/_stacktrace/product-roadmap": {
      "filePath": "_stacktrace/product-roadmap",
      "parent": "/_stacktrace",
      "children": [
        "/_stacktrace/product-roadmap/_layout",
        "/_stacktrace/product-roadmap/$roadmapId"
      ]
    },
    "/_stacktrace/product-roadmap/_layout": {
      "filePath": "_stacktrace/product-roadmap/_layout.tsx",
      "parent": "/_stacktrace/product-roadmap",
      "children": [
        "/_stacktrace/product-roadmap/_layout/"
      ]
    },
    "/_stacktrace/test-sets": {
      "filePath": "_stacktrace/test-sets",
      "parent": "/_stacktrace",
      "children": [
        "/_stacktrace/test-sets/_layout",
        "/_stacktrace/test-sets/$id"
      ]
    },
    "/_stacktrace/test-sets/_layout": {
      "filePath": "_stacktrace/test-sets/_layout.tsx",
      "parent": "/_stacktrace/test-sets",
      "children": [
        "/_stacktrace/test-sets/_layout/"
      ]
    },
    "/_stacktrace/test-suites": {
      "filePath": "_stacktrace/test-suites",
      "parent": "/_stacktrace",
      "children": [
        "/_stacktrace/test-suites/_layout",
        "/_stacktrace/test-suites/$id"
      ]
    },
    "/_stacktrace/test-suites/_layout": {
      "filePath": "_stacktrace/test-suites/_layout.tsx",
      "parent": "/_stacktrace/test-suites",
      "children": [
        "/_stacktrace/test-suites/_layout/"
      ]
    },
    "/_stacktrace/values": {
      "filePath": "_stacktrace/values",
      "parent": "/_stacktrace",
      "children": [
        "/_stacktrace/values/_layout",
        "/_stacktrace/values/$id",
        "/_stacktrace/values/add-select/",
        "/_stacktrace/values/add/"
      ]
    },
    "/_stacktrace/values/_layout": {
      "filePath": "_stacktrace/values/_layout.tsx",
      "parent": "/_stacktrace/values",
      "children": [
        "/_stacktrace/values/_layout/"
      ]
    },
    "/_staff/accesses": {
      "filePath": "_staff/accesses",
      "parent": "/_staff",
      "children": [
        "/_staff/accesses/_layout"
      ]
    },
    "/_staff/accesses/_layout": {
      "filePath": "_staff/accesses/_layout.tsx",
      "parent": "/_staff/accesses",
      "children": [
        "/_staff/accesses/_layout/",
        "/_staff/accesses/_layout/_placeholders/contract-and-cost",
        "/_staff/accesses/_layout/_placeholders/overview",
        "/_staff/accesses/_layout/_placeholders/software",
        "/_staff/accesses/_layout/alerts/",
        "/_staff/accesses/_layout/list/",
        "/_staff/accesses/_layout/settings/",
        "/_staff/accesses/_layout/list/$traceableAppId/",
        "/_staff/accesses/_layout/alerts/detail/$shadowItAppId/",
        "/_staff/accesses/_layout/alerts/dormancy/$softwareId/"
      ]
    },
    "/_staff/apps/$": {
      "filePath": "_staff/apps/$.tsx",
      "parent": "/_staff/apps"
    },
    "/_staff/attendance-core": {
      "filePath": "_staff/attendance-core",
      "parent": "/_staff",
      "children": [
        "/_staff/attendance-core/_layout"
      ]
    },
    "/_staff/attendance-core/_layout": {
      "filePath": "_staff/attendance-core/_layout.tsx",
      "parent": "/_staff/attendance-core",
      "children": [
        "/_staff/attendance-core/_layout/",
        "/_staff/attendance-core/_layout/archive/",
        "/_staff/attendance-core/_layout/config/",
        "/_staff/attendance-core/_layout/dashboard/",
        "/_staff/attendance-core/_layout/operation-packages/",
        "/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId"
      ]
    },
    "/_staff/attendance-engine": {
      "filePath": "_staff/attendance-engine",
      "parent": "/_staff",
      "children": [
        "/_staff/attendance-engine/_layout"
      ]
    },
    "/_staff/attendance-engine/_layout": {
      "filePath": "_staff/attendance-engine/_layout.tsx",
      "parent": "/_staff/attendance-engine",
      "children": [
        "/_staff/attendance-engine/_layout/",
        "/_staff/attendance-engine/_layout/attendance-structures/",
        "/_staff/attendance-engine/_layout/attendance-units/",
        "/_staff/attendance-engine/_layout/items/",
        "/_staff/attendance-engine/_layout/logic-components/",
        "/_staff/attendance-engine/_layout/attendance-structures/$structureId",
        "/_staff/attendance-engine/_layout/attendance-units/$unitId/",
        "/_staff/attendance-engine/_layout/items/$componentId/",
        "/_staff/attendance-engine/_layout/logic-components/$componentId/"
      ]
    },
    "/_staff/attendances": {
      "filePath": "_staff/attendances",
      "parent": "/_staff",
      "children": [
        "/_staff/attendances/_layout"
      ]
    },
    "/_staff/attendances/_layout": {
      "filePath": "_staff/attendances/_layout.tsx",
      "parent": "/_staff/attendances",
      "children": [
        "/_staff/attendances/_layout/",
        "/_staff/attendances/_layout/clocking-records/$employeeId",
        "/_staff/attendances/_layout/alerts/",
        "/_staff/attendances/_layout/clocking-records/",
        "/_staff/attendances/_layout/employees/",
        "/_staff/attendances/_layout/operation-activity/",
        "/_staff/attendances/_layout/overview/",
        "/_staff/attendances/_layout/rule-and-policy/",
        "/_staff/attendances/_layout/settings/"
      ]
    },
    "/_staff/business-operation-events": {
      "filePath": "_staff/business-operation-events",
      "parent": "/_staff",
      "children": [
        "/_staff/business-operation-events/_list",
        "/_staff/business-operation-events/$eventInstanceId/"
      ]
    },
    "/_staff/business-operation-events/_list": {
      "filePath": "_staff/business-operation-events/_list.tsx",
      "parent": "/_staff/business-operation-events",
      "children": [
        "/_staff/business-operation-events/_list/archive",
        "/_staff/business-operation-events/_list/config",
        "/_staff/business-operation-events/_list/operation-activity",
        "/_staff/business-operation-events/_list/overview",
        "/_staff/business-operation-events/_list/rule-and-policy",
        "/_staff/business-operation-events/_list/settings",
        "/_staff/business-operation-events/_list/"
      ]
    },
    "/_staff/business-partner": {
      "filePath": "_staff/business-partner",
      "parent": "/_staff",
      "children": [
        "/_staff/business-partner/_list",
        "/_staff/business-partner/import-csv/corporation",
        "/_staff/business-partner/import-csv/individual",
        "/_staff/business-partner/$id",
        "/_staff/business-partner/add/",
        "/_staff/business-partner/add/$businessPartnerType/completed",
        "/_staff/business-partner/add/$businessPartnerType/"
      ]
    },
    "/_staff/business-partner/_list": {
      "filePath": "_staff/business-partner/_list.tsx",
      "parent": "/_staff/business-partner",
      "children": [
        "/_staff/business-partner/_list/",
        "/_staff/business-partner/_list/_placeholders/alerts",
        "/_staff/business-partner/_list/_placeholders/contract-and-cost",
        "/_staff/business-partner/_list/_placeholders/operation-activity",
        "/_staff/business-partner/_list/_placeholders/rule-and-policy",
        "/_staff/business-partner/_list/_placeholders/settings",
        "/_staff/business-partner/_list/terminated/"
      ]
    },
    "/_staff/certification": {
      "filePath": "_staff/certification",
      "parent": "/_staff",
      "children": [
        "/_staff/certification/_list",
        "/_staff/certification/$id",
        "/_staff/certification/add/",
        "/_staff/certification/add/$certificationKind/completed",
        "/_staff/certification/handling-certification/$id",
        "/_staff/certification/specialty-certification/$id",
        "/_staff/certification/add/$certificationKind/"
      ]
    },
    "/_staff/certification/_list": {
      "filePath": "_staff/certification/_list.tsx",
      "parent": "/_staff/certification",
      "children": [
        "/_staff/certification/_list/",
        "/_staff/certification/_list/settings",
        "/_staff/certification/_list/_placeholders/alerts",
        "/_staff/certification/_list/_placeholders/operation-activity",
        "/_staff/certification/_list/_placeholders/overview",
        "/_staff/certification/_list/_placeholders/rule-and-policy",
        "/_staff/certification/_list/people/"
      ]
    },
    "/_staff/contract": {
      "filePath": "_staff/contract",
      "parent": "/_staff",
      "children": [
        "/_staff/contract/_list",
        "/_staff/contract/$id",
        "/_staff/contract/add/",
        "/_staff/contract/add/subscription/completed",
        "/_staff/contract/add/subscription/",
        "/_staff/contract/import-csv/$contractType/"
      ]
    },
    "/_staff/contract/_list": {
      "filePath": "_staff/contract/_list.tsx",
      "parent": "/_staff/contract",
      "children": [
        "/_staff/contract/_list/",
        "/_staff/contract/_list/_placeholders/alerts",
        "/_staff/contract/_list/_placeholders/contract-and-cost",
        "/_staff/contract/_list/_placeholders/operation-activity",
        "/_staff/contract/_list/_placeholders/overview",
        "/_staff/contract/_list/_placeholders/people"
      ]
    },
    "/_staff/contractor-core": {
      "filePath": "_staff/contractor-core",
      "parent": "/_staff",
      "children": [
        "/_staff/contractor-core/_packages",
        "/_staff/contractor-core/anchor-date",
        "/_staff/contractor-core/contract-targets",
        "/_staff/contractor-core/person-targets",
        "/_staff/contractor-core/config/$patternId/",
        "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId"
      ]
    },
    "/_staff/contractor-core/_packages": {
      "filePath": "_staff/contractor-core/_packages.tsx",
      "parent": "/_staff/contractor-core",
      "children": [
        "/_staff/contractor-core/_packages/",
        "/_staff/contractor-core/_packages/archives/",
        "/_staff/contractor-core/_packages/configs/"
      ]
    },
    "/_staff/contractor-core/anchor-date": {
      "filePath": "_staff/contractor-core/anchor-date.tsx",
      "parent": "/_staff/contractor-core"
    },
    "/_staff/contractor-core/contract-targets": {
      "filePath": "_staff/contractor-core/contract-targets.tsx",
      "parent": "/_staff/contractor-core"
    },
    "/_staff/contractor-core/person-targets": {
      "filePath": "_staff/contractor-core/person-targets.tsx",
      "parent": "/_staff/contractor-core"
    },
    "/_staff/deal": {
      "filePath": "_staff/deal",
      "parent": "/_staff",
      "children": [
        "/_staff/deal/_list",
        "/_staff/deal/$dealId",
        "/_staff/deal/add/",
        "/_staff/deal/add/$direction/completed",
        "/_staff/deal/add/$direction/"
      ]
    },
    "/_staff/deal/_list": {
      "filePath": "_staff/deal/_list.tsx",
      "parent": "/_staff/deal",
      "children": [
        "/_staff/deal/_list/"
      ]
    },
    "/_staff/devices": {
      "filePath": "_staff/devices",
      "parent": "/_staff",
      "children": [
        "/_staff/devices/_list",
        "/_staff/devices/import-csv/$deviceType",
        "/_staff/devices/$id",
        "/_staff/devices/add/",
        "/_staff/devices/external-it-saas/",
        "/_staff/devices/add/$deviceType/completed",
        "/_staff/devices/add/$deviceType/",
        "/_staff/devices/add/catalog/",
        "/_staff/devices/add/catalog/$deviceType/completed",
        "/_staff/devices/add/catalog/$deviceType/",
        "/_staff/devices/external-it-saas/$appIntegrationId/preview/"
      ]
    },
    "/_staff/devices/_list": {
      "filePath": "_staff/devices/_list.tsx",
      "parent": "/_staff/devices",
      "children": [
        "/_staff/devices/_list/alerts",
        "/_staff/devices/_list/operation-activity",
        "/_staff/devices/_list/rule-and-policy",
        "/_staff/devices/_list/",
        "/_staff/devices/_list/settings",
        "/_staff/devices/_list/contract-and-cost",
        "/_staff/devices/_list/inventories/",
        "/_staff/devices/_list/inventory/",
        "/_staff/devices/_list/people/"
      ]
    },
    "/_staff/equipment": {
      "filePath": "_staff/equipment",
      "parent": "/_staff",
      "children": [
        "/_staff/equipment/_layout",
        "/_staff/equipment/$id",
        "/_staff/equipment/add-select/",
        "/_staff/equipment/add/",
        "/_staff/equipment/import-csv/",
        "/_staff/equipment/items/$id"
      ]
    },
    "/_staff/equipment/_layout": {
      "filePath": "_staff/equipment/_layout.tsx",
      "parent": "/_staff/equipment",
      "children": [
        "/_staff/equipment/_layout/settings",
        "/_staff/equipment/_layout/",
        "/_staff/equipment/_layout/_placeholders/overview",
        "/_staff/equipment/_layout/_placeholders/rule-and-policy",
        "/_staff/equipment/_layout/_placeholders/settings",
        "/_staff/equipment/_layout/alerts/",
        "/_staff/equipment/_layout/items/"
      ]
    },
    "/_staff/fleets": {
      "filePath": "_staff/fleets",
      "parent": "/_staff",
      "children": [
        "/_staff/fleets/_layout",
        "/_staff/fleets/$id",
        "/_staff/fleets/add-select/",
        "/_staff/fleets/add/"
      ]
    },
    "/_staff/fleets/_layout": {
      "filePath": "_staff/fleets/_layout.tsx",
      "parent": "/_staff/fleets",
      "children": [
        "/_staff/fleets/_layout/alerts",
        "/_staff/fleets/_layout/overview",
        "/_staff/fleets/_layout/rule-and-policy",
        "/_staff/fleets/_layout/settings",
        "/_staff/fleets/_layout/_list/"
      ]
    },
    "/_staff/ga-operation-core": {
      "filePath": "_staff/ga-operation-core",
      "parent": "/_staff",
      "children": [
        "/_staff/ga-operation-core/_packages",
        "/_staff/ga-operation-core/config/$patternId/",
        "/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId"
      ]
    },
    "/_staff/ga-operation-core/_packages": {
      "filePath": "_staff/ga-operation-core/_packages.tsx",
      "parent": "/_staff/ga-operation-core",
      "children": [
        "/_staff/ga-operation-core/_packages/",
        "/_staff/ga-operation-core/_packages/archives/",
        "/_staff/ga-operation-core/_packages/configs/"
      ]
    },
    "/_staff/id-managements/$": {
      "filePath": "_staff/id-managements/$.tsx",
      "parent": "/_staff/id-managements"
    },
    "/_staff/ids": {
      "filePath": "_staff/ids",
      "parent": "/_staff",
      "children": [
        "/_staff/ids/_layout",
        "/_staff/ids/group-id/$id",
        "/_staff/ids/group-id/add/",
        "/_staff/ids/group-id/add/from-scratch/completed",
        "/_staff/ids/group-id/add/from-scratch/"
      ]
    },
    "/_staff/ids/_layout": {
      "filePath": "_staff/ids/_layout.tsx",
      "parent": "/_staff/ids",
      "children": [
        "/_staff/ids/_layout/",
        "/_staff/ids/_layout/_placeholders/alerts",
        "/_staff/ids/_layout/_placeholders/group-id",
        "/_staff/ids/_layout/_placeholders/operation-activity",
        "/_staff/ids/_layout/_placeholders/overview",
        "/_staff/ids/_layout/_placeholders/rule-and-policy",
        "/_staff/ids/_layout/_placeholders/settings",
        "/_staff/ids/_layout/people/"
      ]
    },
    "/_staff/it-operation-core": {
      "filePath": "_staff/it-operation-core",
      "parent": "/_staff",
      "children": [
        "/_staff/it-operation-core/_detail",
        "/_staff/it-operation-core/_root",
        "/_staff/it-operation-core/anchor-date",
        "/_staff/it-operation-core/self-report-confirmation",
        "/_staff/it-operation-core/",
        "/_staff/it-operation-core/device-targets/",
        "/_staff/it-operation-core/person-targets/",
        "/_staff/it-operation-core/config/$patternId/",
        "/_staff/it-operation-core/self-report-patterns/$patternId/"
      ]
    },
    "/_staff/it-operation-core/_detail": {
      "filePath": "_staff/it-operation-core/_detail.tsx",
      "parent": "/_staff/it-operation-core",
      "children": [
        "/_staff/it-operation-core/_detail/operation-instances/$instanceId"
      ]
    },
    "/_staff/it-operation-core/_root": {
      "filePath": "_staff/it-operation-core/_root.tsx",
      "parent": "/_staff/it-operation-core",
      "children": [
        "/_staff/it-operation-core/_root/in-house-packages",
        "/_staff/it-operation-core/_root/packages",
        "/_staff/it-operation-core/_root/archives/",
        "/_staff/it-operation-core/_root/config/"
      ]
    },
    "/_staff/it-operation-core/anchor-date": {
      "filePath": "_staff/it-operation-core/anchor-date.tsx",
      "parent": "/_staff/it-operation-core"
    },
    "/_staff/it-operation-core/self-report-confirmation": {
      "filePath": "_staff/it-operation-core/self-report-confirmation.tsx",
      "parent": "/_staff/it-operation-core"
    },
    "/_staff/labor-core": {
      "filePath": "_staff/labor-core",
      "parent": "/_staff",
      "children": [
        "/_staff/labor-core/_packages",
        "/_staff/labor-core/anchor-date",
        "/_staff/labor-core/contract-targets",
        "/_staff/labor-core/government-application-confirmation",
        "/_staff/labor-core/person-targets",
        "/_staff/labor-core/year-end-adjustment-confirmation",
        "/_staff/labor-core/group-name",
        "/_staff/labor-core/settings/egov-callback",
        "/_staff/labor-core/settings/profile/$profileId",
        "/_staff/labor-core/config/$patternId/",
        "/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId"
      ]
    },
    "/_staff/labor-core/_packages": {
      "filePath": "_staff/labor-core/_packages.tsx",
      "parent": "/_staff/labor-core",
      "children": [
        "/_staff/labor-core/_packages/settings",
        "/_staff/labor-core/_packages/",
        "/_staff/labor-core/_packages/archives/",
        "/_staff/labor-core/_packages/configs/"
      ]
    },
    "/_staff/labor-core/anchor-date": {
      "filePath": "_staff/labor-core/anchor-date.tsx",
      "parent": "/_staff/labor-core"
    },
    "/_staff/labor-core/contract-targets": {
      "filePath": "_staff/labor-core/contract-targets.tsx",
      "parent": "/_staff/labor-core"
    },
    "/_staff/labor-core/government-application-confirmation": {
      "filePath": "_staff/labor-core/government-application-confirmation.tsx",
      "parent": "/_staff/labor-core"
    },
    "/_staff/labor-core/person-targets": {
      "filePath": "_staff/labor-core/person-targets.tsx",
      "parent": "/_staff/labor-core"
    },
    "/_staff/labor-core/year-end-adjustment-confirmation": {
      "filePath": "_staff/labor-core/year-end-adjustment-confirmation.tsx",
      "parent": "/_staff/labor-core"
    },
    "/_staff/licenses": {
      "filePath": "_staff/licenses",
      "parent": "/_staff",
      "children": [
        "/_staff/licenses/_list",
        "/_staff/licenses/$id",
        "/_staff/licenses/add/",
        "/_staff/licenses/add/$allocationType/completed",
        "/_staff/licenses/add/$allocationType/"
      ]
    },
    "/_staff/licenses/_list": {
      "filePath": "_staff/licenses/_list.tsx",
      "parent": "/_staff/licenses",
      "children": [
        "/_staff/licenses/_list/",
        "/_staff/licenses/_list/alerts/",
        "/_staff/licenses/_list/contract-and-cost/",
        "/_staff/licenses/_list/inventory/",
        "/_staff/licenses/_list/operation-activity/",
        "/_staff/licenses/_list/people/",
        "/_staff/licenses/_list/rule-and-policy/",
        "/_staff/licenses/_list/settings/"
      ]
    },
    "/_staff/marketplace": {
      "filePath": "_staff/marketplace",
      "parent": "/_staff",
      "children": [
        "/_staff/marketplace/_store",
        "/_staff/marketplace/cart/",
        "/_staff/marketplace/unavailable/",
        "/_staff/marketplace/sent-orders/$orderId",
        "/_staff/marketplace/sales-orders/$orderId/"
      ]
    },
    "/_staff/marketplace/_store": {
      "filePath": "_staff/marketplace/_store.tsx",
      "parent": "/_staff/marketplace",
      "children": [
        "/_staff/marketplace/_store/store/devices/",
        "/_staff/marketplace/_store/store/licenses/",
        "/_staff/marketplace/_store/store/sales-orders/",
        "/_staff/marketplace/_store/store/sent-orders/",
        "/_staff/marketplace/_store/store/starlinks/",
        "/_staff/marketplace/_store/store/devices/$productId/",
        "/_staff/marketplace/_store/store/licenses/$productId/",
        "/_staff/marketplace/_store/store/starlinks/$productId/"
      ]
    },
    "/_staff/networks": {
      "filePath": "_staff/networks",
      "parent": "/_staff",
      "children": [
        "/_staff/networks/_layout",
        "/_staff/networks/$id",
        "/_staff/networks/add/"
      ]
    },
    "/_staff/networks/_layout": {
      "filePath": "_staff/networks/_layout.tsx",
      "parent": "/_staff/networks",
      "children": [
        "/_staff/networks/_layout/",
        "/_staff/networks/_layout/_placeholders/alerts",
        "/_staff/networks/_layout/_placeholders/contract-and-cost",
        "/_staff/networks/_layout/_placeholders/operation-activity",
        "/_staff/networks/_layout/_placeholders/overview",
        "/_staff/networks/_layout/_placeholders/rule-and-policy",
        "/_staff/networks/_layout/_placeholders/settings"
      ]
    },
    "/_staff/organization": {
      "filePath": "_staff/organization",
      "parent": "/_staff",
      "children": [
        "/_staff/organization/_list",
        "/_staff/organization/",
        "/_staff/organization/$id",
        "/_staff/organization/plan/",
        "/_staff/organization/plan/$id/",
        "/_staff/organization/plan/create/",
        "/_staff/organization/plan/$id/add/",
        "/_staff/organization/plan/$id/transfers/",
        "/_staff/organization/plan/$id/edit/$unitId/"
      ]
    },
    "/_staff/organization/_list": {
      "filePath": "_staff/organization/_list.tsx",
      "parent": "/_staff/organization",
      "children": [
        "/_staff/organization/_list/alert/",
        "/_staff/organization/_list/chart/",
        "/_staff/organization/_list/cost/",
        "/_staff/organization/_list/history/",
        "/_staff/organization/_list/rule-policy/",
        "/_staff/organization/_list/settings/"
      ]
    },
    "/_staff/payroll-core": {
      "filePath": "_staff/payroll-core",
      "parent": "/_staff",
      "children": [
        "/_staff/payroll-core/_layout"
      ]
    },
    "/_staff/payroll-core/_layout": {
      "filePath": "_staff/payroll-core/_layout.tsx",
      "parent": "/_staff/payroll-core",
      "children": [
        "/_staff/payroll-core/_layout/",
        "/_staff/payroll-core/_layout/archive/",
        "/_staff/payroll-core/_layout/config/",
        "/_staff/payroll-core/_layout/dashboard/",
        "/_staff/payroll-core/_layout/operation-packages/",
        "/_staff/payroll-core/_layout/person-targets/"
      ]
    },
    "/_staff/payroll-engine": {
      "filePath": "_staff/payroll-engine",
      "parent": "/_staff",
      "children": [
        "/_staff/payroll-engine/_layout"
      ]
    },
    "/_staff/payroll-engine/_layout": {
      "filePath": "_staff/payroll-engine/_layout.tsx",
      "parent": "/_staff/payroll-engine",
      "children": [
        "/_staff/payroll-engine/_layout/",
        "/_staff/payroll-engine/_layout/items/",
        "/_staff/payroll-engine/_layout/logic-components/",
        "/_staff/payroll-engine/_layout/payroll-structures/",
        "/_staff/payroll-engine/_layout/payroll-units/",
        "/_staff/payroll-engine/_layout/payroll-structures/$structureId",
        "/_staff/payroll-engine/_layout/items/$componentId/",
        "/_staff/payroll-engine/_layout/logic-components/$componentId/",
        "/_staff/payroll-engine/_layout/payroll-units/$unitId/"
      ]
    },
    "/_staff/payroll": {
      "filePath": "_staff/payroll",
      "parent": "/_staff",
      "children": [
        "/_staff/payroll/_layout"
      ]
    },
    "/_staff/payroll/_layout": {
      "filePath": "_staff/payroll/_layout.tsx",
      "parent": "/_staff/payroll",
      "children": [
        "/_staff/payroll/_layout/",
        "/_staff/payroll/_layout/pay-slips/$employeeId",
        "/_staff/payroll/_layout/contract-and-cost",
        "/_staff/payroll/_layout/alerts/",
        "/_staff/payroll/_layout/overview/",
        "/_staff/payroll/_layout/pay-slips/",
        "/_staff/payroll/_layout/rule-and-policy/",
        "/_staff/payroll/_layout/settings/"
      ]
    },
    "/_staff/people": {
      "filePath": "_staff/people",
      "parent": "/_staff",
      "children": [
        "/_staff/people/_list"
      ]
    },
    "/_staff/people/_list": {
      "filePath": "_staff/people/_list.tsx",
      "parent": "/_staff/people",
      "children": [
        "/_staff/people/_list/alerts",
        "/_staff/people/_list/community",
        "/_staff/people/_list/people-graph",
        "/_staff/people/_list/rule-and-policy",
        "/_staff/people/_list/salary-and-payment",
        "/_staff/people/_list/",
        "/_staff/people/_list/settings",
        "/_staff/people/_list/alumni/",
        "/_staff/people/_list/operation-activity/",
        "/_staff/people/_list/workforce/"
      ]
    },
    "/_staff/places": {
      "filePath": "_staff/places",
      "parent": "/_staff",
      "children": [
        "/_staff/places/_layout",
        "/_staff/places/$id",
        "/_staff/places/add-select/",
        "/_staff/places/add/"
      ]
    },
    "/_staff/places/_layout": {
      "filePath": "_staff/places/_layout.tsx",
      "parent": "/_staff/places",
      "children": [
        "/_staff/places/_layout/settings",
        "/_staff/places/_layout/overview",
        "/_staff/places/_layout/",
        "/_staff/places/_layout/_placeholders/alerts",
        "/_staff/places/_layout/_placeholders/contract-and-cost",
        "/_staff/places/_layout/_placeholders/operation-activity",
        "/_staff/places/_layout/_placeholders/people",
        "/_staff/places/_layout/_placeholders/rule-and-policy",
        "/_staff/places/_layout/_placeholders/store"
      ]
    },
    "/_staff/public-ids/$id": {
      "filePath": "_staff/public-ids/$id.tsx",
      "parent": "/_staff",
      "children": [
        "/_staff/public-ids/$id/",
        "/_staff/public-ids/$id/details/",
        "/_staff/public-ids/$id/files/"
      ]
    },
    "/_staff/public-ids": {
      "filePath": "_staff/public-ids",
      "parent": "/_staff",
      "children": [
        "/_staff/public-ids/_list",
        "/_staff/public-ids/import-csv/$publicIdType",
        "/_staff/public-ids/add/"
      ]
    },
    "/_staff/public-ids/_list": {
      "filePath": "_staff/public-ids/_list.tsx",
      "parent": "/_staff/public-ids",
      "children": [
        "/_staff/public-ids/_list/",
        "/_staff/public-ids/_list/alerts/",
        "/_staff/public-ids/_list/members/",
        "/_staff/public-ids/_list/operation-activity/",
        "/_staff/public-ids/_list/registry/",
        "/_staff/public-ids/_list/rules-and-policies/",
        "/_staff/public-ids/_list/settings/"
      ]
    },
    "/_staff/software": {
      "filePath": "_staff/software",
      "parent": "/_staff",
      "children": [
        "/_staff/software/_layout",
        "/_staff/software/$id/import-csv",
        "/_staff/software/$id",
        "/_staff/software/add/",
        "/_staff/software/add/$type/",
        "/_staff/software/custom-saas/add/$customSaasType/"
      ]
    },
    "/_staff/software/_layout": {
      "filePath": "_staff/software/_layout.tsx",
      "parent": "/_staff/software",
      "children": [
        "/_staff/software/_layout/people",
        "/_staff/software/_layout/integrations",
        "/_staff/software/_layout/",
        "/_staff/software/_layout/marketplace/$id",
        "/_staff/software/_layout/alerts",
        "/_staff/software/_layout/contract-and-cost",
        "/_staff/software/_layout/library/",
        "/_staff/software/_layout/operation-activity/",
        "/_staff/software/_layout/registry/",
        "/_staff/software/_layout/rule-and-policy/",
        "/_staff/software/_layout/settings/",
        "/_staff/software/_layout/library/search/",
        "/_staff/software/_layout/library/category/$category/",
        "/_staff/software/_layout/library/detail/$softwareLibraryId/",
        "/_staff/software/_layout/library/category/$category/search/"
      ]
    },
    "/_staff/starlinks": {
      "filePath": "_staff/starlinks",
      "parent": "/_staff",
      "children": [
        "/_staff/starlinks/_layout",
        "/_staff/starlinks/$id"
      ]
    },
    "/_staff/starlinks/_layout": {
      "filePath": "_staff/starlinks/_layout.tsx",
      "parent": "/_staff/starlinks",
      "children": [
        "/_staff/starlinks/_layout/",
        "/_staff/starlinks/_layout/_placeholders/billing-and-cost",
        "/_staff/starlinks/_layout/_placeholders/marketplace",
        "/_staff/starlinks/_layout/_placeholders/operation-activity",
        "/_staff/starlinks/_layout/alerts/",
        "/_staff/starlinks/_layout/user-terminals/"
      ]
    },
    "/_staff/storage-files": {
      "filePath": "_staff/storage-files",
      "parent": "/_staff",
      "children": [
        "/_staff/storage-files/_list",
        "/_staff/storage-files/files/$id",
        "/_staff/storage-files/folders/$id"
      ]
    },
    "/_staff/storage-files/_list": {
      "filePath": "_staff/storage-files/_list.tsx",
      "parent": "/_staff/storage-files",
      "children": [
        "/_staff/storage-files/_list/",
        "/_staff/storage-files/_list/files/",
        "/_staff/storage-files/_list/folders/",
        "/_staff/storage-files/_list/settings/"
      ]
    },
    "/_staff/supplier": {
      "filePath": "_staff/supplier",
      "parent": "/_staff",
      "children": [
        "/_staff/supplier/_list",
        "/_staff/supplier/$supplierId"
      ]
    },
    "/_staff/supplier/_list": {
      "filePath": "_staff/supplier/_list.tsx",
      "parent": "/_staff/supplier",
      "children": [
        "/_staff/supplier/_list/settings",
        "/_staff/supplier/_list/",
        "/_staff/supplier/_list/_placeholders/alerts",
        "/_staff/supplier/_list/_placeholders/contract-and-cost",
        "/_staff/supplier/_list/_placeholders/operation-activity",
        "/_staff/supplier/_list/_placeholders/overview",
        "/_staff/supplier/_list/_placeholders/rule-and-policy"
      ]
    },
    "/_staff/time-and-attendance": {
      "filePath": "_staff/time-and-attendance",
      "parent": "/_staff",
      "children": [
        "/_staff/time-and-attendance/_layout"
      ]
    },
    "/_staff/time-and-attendance/_layout": {
      "filePath": "_staff/time-and-attendance/_layout.tsx",
      "parent": "/_staff/time-and-attendance",
      "children": [
        "/_staff/time-and-attendance/_layout/",
        "/_staff/time-and-attendance/_layout/attendance-links/",
        "/_staff/time-and-attendance/_layout/_list/summary/",
        "/_staff/time-and-attendance/_layout/attendance-links/$placeId/",
        "/_staff/time-and-attendance/_layout/_list/summary/daily-place/",
        "/_staff/time-and-attendance/_layout/_list/summary/monthly-person/",
        "/_staff/time-and-attendance/_layout/_list/summary/monthly-place/"
      ]
    },
    "/_staff/labor-core/group-name": {
      "filePath": "_staff/labor-core/group-name.lazy.tsx",
      "parent": "/_staff/labor-core"
    },
    "/_chat/chat/": {
      "filePath": "_chat/chat/index.tsx",
      "parent": "/_chat"
    },
    "/_cockpit-mock/cockpit-mock/": {
      "filePath": "_cockpit-mock/cockpit-mock/index.tsx",
      "parent": "/_cockpit-mock"
    },
    "/_individual/individual/": {
      "filePath": "_individual/individual/index.tsx",
      "parent": "/_individual/individual"
    },
    "/_stacktrace/development-tickets/": {
      "filePath": "_stacktrace/development-tickets/index.tsx",
      "parent": "/_stacktrace"
    },
    "/_stacktrace/production/": {
      "filePath": "_stacktrace/production/index.tsx",
      "parent": "/_stacktrace"
    },
    "/_stacktrace/products/": {
      "filePath": "_stacktrace/products/index.tsx",
      "parent": "/_stacktrace"
    },
    "/_stacktrace/test-assets/": {
      "filePath": "_stacktrace/test-assets/index.tsx",
      "parent": "/_stacktrace"
    },
    "/_staff/cockpit/": {
      "filePath": "_staff/cockpit/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/it-operation-core/": {
      "filePath": "_staff/it-operation-core/index.tsx",
      "parent": "/_staff/it-operation-core"
    },
    "/_staff/organization/": {
      "filePath": "_staff/organization/index.tsx",
      "parent": "/_staff/organization"
    },
    "/_staff/settings/": {
      "filePath": "_staff/settings/index.tsx",
      "parent": "/_staff"
    },
    "/account/sso/": {
      "filePath": "account/sso/index.tsx"
    },
    "/auth/password-reset/": {
      "filePath": "auth/password-reset/index.tsx"
    },
    "/auth/sign-in/": {
      "filePath": "auth/sign-in/index.tsx"
    },
    "/oauth2/consent/": {
      "filePath": "oauth2/consent/index.tsx"
    },
    "/oauth2/error/": {
      "filePath": "oauth2/error/index.tsx"
    },
    "/oauth2/login/": {
      "filePath": "oauth2/login/index.tsx"
    },
    "/oauth2/logout/": {
      "filePath": "oauth2/logout/index.tsx"
    },
    "/_staff/certification/_list/": {
      "filePath": "_staff/certification/_list/index/route.tsx",
      "parent": "/_staff/certification/_list"
    },
    "/_staff/licenses/_list/": {
      "filePath": "_staff/licenses/_list/index/route.tsx",
      "parent": "/_staff/licenses/_list"
    },
    "/_staff/app-integrations/import-csv/$id": {
      "filePath": "_staff/app-integrations/import-csv/$id/route.tsx",
      "parent": "/_staff"
    },
    "/_staff/business-partner/import-csv/corporation": {
      "filePath": "_staff/business-partner/import-csv/corporation/route.tsx",
      "parent": "/_staff/business-partner"
    },
    "/_staff/business-partner/import-csv/individual": {
      "filePath": "_staff/business-partner/import-csv/individual/route.tsx",
      "parent": "/_staff/business-partner"
    },
    "/_staff/devices/import-csv/$deviceType": {
      "filePath": "_staff/devices/import-csv/$deviceType/route.tsx",
      "parent": "/_staff/devices"
    },
    "/_staff/it-operation-core/_root/in-house-packages": {
      "filePath": "_staff/it-operation-core/_root/in-house-packages/route.tsx",
      "parent": "/_staff/it-operation-core/_root",
      "children": [
        "/_staff/it-operation-core/_root/in-house-packages/$packageId",
        "/_staff/it-operation-core/_root/in-house-packages/"
      ]
    },
    "/_staff/it-operation-core/_root/packages": {
      "filePath": "_staff/it-operation-core/_root/packages/route.tsx",
      "parent": "/_staff/it-operation-core/_root",
      "children": [
        "/_staff/it-operation-core/_root/packages/$packageId",
        "/_staff/it-operation-core/_root/packages/"
      ]
    },
    "/_staff/person/import-csv/$workerType": {
      "filePath": "_staff/person/import-csv/$workerType/route.tsx",
      "parent": "/_staff"
    },
    "/_staff/places/_layout/settings": {
      "filePath": "_staff/places/_layout/settings/route.tsx",
      "parent": "/_staff/places/_layout",
      "children": [
        "/_staff/places/_layout/settings/",
        "/_staff/places/_layout/settings/place-sub-codes/"
      ]
    },
    "/_staff/public-ids/import-csv/$publicIdType": {
      "filePath": "_staff/public-ids/import-csv/$publicIdType/route.tsx",
      "parent": "/_staff/public-ids"
    },
    "/_staff/software/$id/import-csv": {
      "filePath": "_staff/software/$id/import-csv/route.tsx",
      "parent": "/_staff/software"
    },
    "/_staff/software/_layout/people": {
      "filePath": "_staff/software/_layout/people/route.tsx",
      "parent": "/_staff/software/_layout",
      "children": [
        "/_staff/software/_layout/people/"
      ]
    },
    "/_stacktrace/development-tickets/$ticketId": {
      "filePath": "_stacktrace/development-tickets/$ticketId",
      "parent": "/_stacktrace",
      "children": [
        "/_stacktrace/development-tickets/$ticketId/_layout"
      ]
    },
    "/_stacktrace/development-tickets/$ticketId/_layout": {
      "filePath": "_stacktrace/development-tickets/$ticketId/_layout.tsx",
      "parent": "/_stacktrace/development-tickets/$ticketId",
      "children": [
        "/_stacktrace/development-tickets/$ticketId/_layout/",
        "/_stacktrace/development-tickets/$ticketId/_layout/history/"
      ]
    },
    "/_stacktrace/issues/$id": {
      "filePath": "_stacktrace/issues/$id",
      "parent": "/_stacktrace/issues",
      "children": [
        "/_stacktrace/issues/$id/_layout"
      ]
    },
    "/_stacktrace/issues/$id/_layout": {
      "filePath": "_stacktrace/issues/$id/_layout.tsx",
      "parent": "/_stacktrace/issues/$id",
      "children": [
        "/_stacktrace/issues/$id/_layout/",
        "/_stacktrace/issues/$id/_layout/history/"
      ]
    },
    "/_stacktrace/product-roadmap/$roadmapId": {
      "filePath": "_stacktrace/product-roadmap/$roadmapId",
      "parent": "/_stacktrace/product-roadmap",
      "children": [
        "/_stacktrace/product-roadmap/$roadmapId/_layout"
      ]
    },
    "/_stacktrace/product-roadmap/$roadmapId/_layout": {
      "filePath": "_stacktrace/product-roadmap/$roadmapId/_layout.tsx",
      "parent": "/_stacktrace/product-roadmap/$roadmapId",
      "children": [
        "/_stacktrace/product-roadmap/$roadmapId/_layout/",
        "/_stacktrace/product-roadmap/$roadmapId/_layout/detail/",
        "/_stacktrace/product-roadmap/$roadmapId/_layout/history/"
      ]
    },
    "/_stacktrace/production/$productionId": {
      "filePath": "_stacktrace/production/$productionId",
      "parent": "/_stacktrace",
      "children": [
        "/_stacktrace/production/$productionId/_layout"
      ]
    },
    "/_stacktrace/production/$productionId/_layout": {
      "filePath": "_stacktrace/production/$productionId/_layout.tsx",
      "parent": "/_stacktrace/production/$productionId",
      "children": [
        "/_stacktrace/production/$productionId/_layout/",
        "/_stacktrace/production/$productionId/_layout/dev-scope/",
        "/_stacktrace/production/$productionId/_layout/issue-scope/",
        "/_stacktrace/production/$productionId/_layout/product-scope/",
        "/_stacktrace/production/$productionId/_layout/quality-scope/",
        "/_stacktrace/production/$productionId/_layout/value/",
        "/_stacktrace/production/$productionId/_layout/dev-scope/edit/",
        "/_stacktrace/production/$productionId/_layout/issue-scope/edit/",
        "/_stacktrace/production/$productionId/_layout/value/edit/"
      ]
    },
    "/_stacktrace/products/$id": {
      "filePath": "_stacktrace/products/$id",
      "parent": "/_stacktrace",
      "children": [
        "/_stacktrace/products/$id/_layout",
        "/_stacktrace/products/$id/scope/$nodeId"
      ]
    },
    "/_stacktrace/products/$id/_layout": {
      "filePath": "_stacktrace/products/$id/_layout.tsx",
      "parent": "/_stacktrace/products/$id",
      "children": [
        "/_stacktrace/products/$id/_layout/",
        "/_stacktrace/products/$id/_layout/product-scope/"
      ]
    },
    "/_stacktrace/test-sets/$id": {
      "filePath": "_stacktrace/test-sets/$id",
      "parent": "/_stacktrace/test-sets",
      "children": [
        "/_stacktrace/test-sets/$id/_layout"
      ]
    },
    "/_stacktrace/test-sets/$id/_layout": {
      "filePath": "_stacktrace/test-sets/$id/_layout.tsx",
      "parent": "/_stacktrace/test-sets/$id",
      "children": [
        "/_stacktrace/test-sets/$id/_layout/",
        "/_stacktrace/test-sets/$id/_layout/conditions/",
        "/_stacktrace/test-sets/$id/_layout/target-functions/"
      ]
    },
    "/_stacktrace/test-suites/$id": {
      "filePath": "_stacktrace/test-suites/$id",
      "parent": "/_stacktrace/test-suites",
      "children": [
        "/_stacktrace/test-suites/$id/_layout"
      ]
    },
    "/_stacktrace/test-suites/$id/_layout": {
      "filePath": "_stacktrace/test-suites/$id/_layout.tsx",
      "parent": "/_stacktrace/test-suites/$id",
      "children": [
        "/_stacktrace/test-suites/$id/_layout/",
        "/_stacktrace/test-suites/$id/_layout/test-plan",
        "/_stacktrace/test-suites/$id/_layout/test-review",
        "/_stacktrace/test-suites/$id/_layout/document/",
        "/_stacktrace/test-suites/$id/_layout/issues/",
        "/_stacktrace/test-suites/$id/_layout/overview/",
        "/_stacktrace/test-suites/$id/_layout/target-functions/",
        "/_stacktrace/test-suites/$id/_layout/test-set/"
      ]
    },
    "/_stacktrace/values/$id": {
      "filePath": "_stacktrace/values/$id",
      "parent": "/_stacktrace/values",
      "children": [
        "/_stacktrace/values/$id/_layout"
      ]
    },
    "/_stacktrace/values/$id/_layout": {
      "filePath": "_stacktrace/values/$id/_layout.tsx",
      "parent": "/_stacktrace/values/$id",
      "children": [
        "/_stacktrace/values/$id/_layout/",
        "/_stacktrace/values/$id/_layout/history/",
        "/_stacktrace/values/$id/_layout/product-scope/"
      ]
    },
    "/_staff/app-integrations/$id": {
      "filePath": "_staff/app-integrations/$id",
      "parent": "/_staff",
      "children": [
        "/_staff/app-integrations/$id/_$id"
      ]
    },
    "/_staff/app-integrations/$id/_$id": {
      "filePath": "_staff/app-integrations/$id/_$id.tsx",
      "parent": "/_staff/app-integrations/$id",
      "children": [
        "/_staff/app-integrations/$id/_$id/$"
      ]
    },
    "/_staff/business-operation-events/_list/archive": {
      "filePath": "_staff/business-operation-events/_list/archive.tsx",
      "parent": "/_staff/business-operation-events/_list"
    },
    "/_staff/business-operation-events/_list/config": {
      "filePath": "_staff/business-operation-events/_list/config.tsx",
      "parent": "/_staff/business-operation-events/_list"
    },
    "/_staff/business-operation-events/_list/operation-activity": {
      "filePath": "_staff/business-operation-events/_list/operation-activity.tsx",
      "parent": "/_staff/business-operation-events/_list"
    },
    "/_staff/business-operation-events/_list/overview": {
      "filePath": "_staff/business-operation-events/_list/overview.tsx",
      "parent": "/_staff/business-operation-events/_list"
    },
    "/_staff/business-operation-events/_list/rule-and-policy": {
      "filePath": "_staff/business-operation-events/_list/rule-and-policy.tsx",
      "parent": "/_staff/business-operation-events/_list"
    },
    "/_staff/business-operation-events/_list/settings": {
      "filePath": "_staff/business-operation-events/_list/settings.tsx",
      "parent": "/_staff/business-operation-events/_list"
    },
    "/_staff/business-partner/$id": {
      "filePath": "_staff/business-partner/$id",
      "parent": "/_staff/business-partner",
      "children": [
        "/_staff/business-partner/$id/_layout"
      ]
    },
    "/_staff/business-partner/$id/_layout": {
      "filePath": "_staff/business-partner/$id/_layout.tsx",
      "parent": "/_staff/business-partner/$id",
      "children": [
        "/_staff/business-partner/$id/_layout/bp-role-info",
        "/_staff/business-partner/$id/_layout/_index/",
        "/_staff/business-partner/$id/_layout/address-and-contact/"
      ]
    },
    "/_staff/certification/$id": {
      "filePath": "_staff/certification/$id",
      "parent": "/_staff/certification",
      "children": [
        "/_staff/certification/$id/_layout"
      ]
    },
    "/_staff/certification/$id/_layout": {
      "filePath": "_staff/certification/$id/_layout.tsx",
      "parent": "/_staff/certification/$id",
      "children": [
        "/_staff/certification/$id/_layout/_index/",
        "/_staff/certification/$id/_layout/certification-holders/",
        "/_staff/certification/$id/_layout/handling-certifications/",
        "/_staff/certification/$id/_layout/specialty-certifications/"
      ]
    },
    "/_staff/contract/$id": {
      "filePath": "_staff/contract/$id",
      "parent": "/_staff/contract",
      "children": [
        "/_staff/contract/$id/_layout"
      ]
    },
    "/_staff/contract/$id/_layout": {
      "filePath": "_staff/contract/$id/_layout.tsx",
      "parent": "/_staff/contract/$id",
      "children": [
        "/_staff/contract/$id/_layout/_placeholders/approval-info",
        "/_staff/contract/$id/_layout/_placeholders/history",
        "/_staff/contract/$id/_layout/_placeholders/operation-activity",
        "/_staff/contract/$id/_layout/_placeholders/risk-provisions",
        "/_staff/contract/$id/_layout/_placeholders/rule-and-policy",
        "/_staff/contract/$id/_layout/_index/",
        "/_staff/contract/$id/_layout/structure/"
      ]
    },
    "/_staff/deal/$dealId": {
      "filePath": "_staff/deal/$dealId",
      "parent": "/_staff/deal",
      "children": [
        "/_staff/deal/$dealId/_layout"
      ]
    },
    "/_staff/deal/$dealId/_layout": {
      "filePath": "_staff/deal/$dealId/_layout.tsx",
      "parent": "/_staff/deal/$dealId",
      "children": [
        "/_staff/deal/$dealId/_layout/flow",
        "/_staff/deal/$dealId/_layout/structure",
        "/_staff/deal/$dealId/_layout/_index/"
      ]
    },
    "/_staff/devices/$id": {
      "filePath": "_staff/devices/$id",
      "parent": "/_staff/devices",
      "children": [
        "/_staff/devices/$id/_layout"
      ]
    },
    "/_staff/devices/$id/_layout": {
      "filePath": "_staff/devices/$id/_layout.tsx",
      "parent": "/_staff/devices/$id",
      "children": [
        "/_staff/devices/$id/_layout/",
        "/_staff/devices/$id/_layout/control/",
        "/_staff/devices/$id/_layout/files/",
        "/_staff/devices/$id/_layout/history/",
        "/_staff/devices/$id/_layout/lifecycle/",
        "/_staff/devices/$id/_layout/mdm/",
        "/_staff/devices/$id/_layout/profile/",
        "/_staff/devices/$id/_layout/status/"
      ]
    },
    "/_staff/devices/_list/alerts": {
      "filePath": "_staff/devices/_list/alerts.tsx",
      "parent": "/_staff/devices/_list"
    },
    "/_staff/devices/_list/operation-activity": {
      "filePath": "_staff/devices/_list/operation-activity.tsx",
      "parent": "/_staff/devices/_list"
    },
    "/_staff/devices/_list/rule-and-policy": {
      "filePath": "_staff/devices/_list/rule-and-policy.tsx",
      "parent": "/_staff/devices/_list"
    },
    "/_staff/equipment/$id": {
      "filePath": "_staff/equipment/$id",
      "parent": "/_staff/equipment",
      "children": [
        "/_staff/equipment/$id/_layout"
      ]
    },
    "/_staff/equipment/$id/_layout": {
      "filePath": "_staff/equipment/$id/_layout.tsx",
      "parent": "/_staff/equipment/$id",
      "children": [
        "/_staff/equipment/$id/_layout/",
        "/_staff/equipment/$id/_layout/lifecycle/",
        "/_staff/equipment/$id/_layout/status/"
      ]
    },
    "/_staff/fleets/$id": {
      "filePath": "_staff/fleets/$id",
      "parent": "/_staff/fleets",
      "children": [
        "/_staff/fleets/$id/_layout"
      ]
    },
    "/_staff/fleets/$id/_layout": {
      "filePath": "_staff/fleets/$id/_layout.tsx",
      "parent": "/_staff/fleets/$id",
      "children": [
        "/_staff/fleets/$id/_layout/_profile/"
      ]
    },
    "/_staff/fleets/_layout/alerts": {
      "filePath": "_staff/fleets/_layout/alerts.tsx",
      "parent": "/_staff/fleets/_layout"
    },
    "/_staff/fleets/_layout/overview": {
      "filePath": "_staff/fleets/_layout/overview.tsx",
      "parent": "/_staff/fleets/_layout"
    },
    "/_staff/fleets/_layout/rule-and-policy": {
      "filePath": "_staff/fleets/_layout/rule-and-policy.tsx",
      "parent": "/_staff/fleets/_layout"
    },
    "/_staff/fleets/_layout/settings": {
      "filePath": "_staff/fleets/_layout/settings.tsx",
      "parent": "/_staff/fleets/_layout"
    },
    "/_staff/it-operation-core/device-inventory/data": {
      "filePath": "_staff/it-operation-core/device-inventory/data.tsx",
      "parent": "/_staff/it-operation-core/device-inventory"
    },
    "/_staff/it-operation-core/device-inventory/detail": {
      "filePath": "_staff/it-operation-core/device-inventory/detail.tsx",
      "parent": "/_staff/it-operation-core/device-inventory"
    },
    "/_staff/labor-core/_packages/settings": {
      "filePath": "_staff/labor-core/_packages/settings.tsx",
      "parent": "/_staff/labor-core/_packages",
      "children": [
        "/_staff/labor-core/_packages/settings/"
      ]
    },
    "/_staff/labor-core/settings/egov-callback": {
      "filePath": "_staff/labor-core/settings/egov-callback.tsx",
      "parent": "/_staff/labor-core"
    },
    "/_staff/licenses/$id": {
      "filePath": "_staff/licenses/$id",
      "parent": "/_staff/licenses",
      "children": [
        "/_staff/licenses/$id/_profile",
        "/_staff/licenses/$id/service-plans/$licenseServiceId"
      ]
    },
    "/_staff/licenses/$id/_profile": {
      "filePath": "_staff/licenses/$id/_profile.tsx",
      "parent": "/_staff/licenses/$id",
      "children": [
        "/_staff/licenses/$id/_profile/",
        "/_staff/licenses/$id/_profile/assignments/",
        "/_staff/licenses/$id/_profile/people/",
        "/_staff/licenses/$id/_profile/rule-and-policy/",
        "/_staff/licenses/$id/_profile/service-plans/"
      ]
    },
    "/_staff/networks/$id": {
      "filePath": "_staff/networks/$id",
      "parent": "/_staff/networks",
      "children": [
        "/_staff/networks/$id/_layout"
      ]
    },
    "/_staff/networks/$id/_layout": {
      "filePath": "_staff/networks/$id/_layout.tsx",
      "parent": "/_staff/networks/$id",
      "children": [
        "/_staff/networks/$id/_layout/_profile/"
      ]
    },
    "/_staff/organization/$id": {
      "filePath": "_staff/organization/$id",
      "parent": "/_staff/organization",
      "children": [
        "/_staff/organization/$id/_layout"
      ]
    },
    "/_staff/organization/$id/_layout": {
      "filePath": "_staff/organization/$id/_layout.tsx",
      "parent": "/_staff/organization/$id",
      "children": [
        "/_staff/organization/$id/_layout/",
        "/_staff/organization/$id/_layout/history/"
      ]
    },
    "/_staff/people/_list/alerts": {
      "filePath": "_staff/people/_list/alerts.tsx",
      "parent": "/_staff/people/_list"
    },
    "/_staff/people/_list/community": {
      "filePath": "_staff/people/_list/community.tsx",
      "parent": "/_staff/people/_list"
    },
    "/_staff/people/_list/people-graph": {
      "filePath": "_staff/people/_list/people-graph.tsx",
      "parent": "/_staff/people/_list"
    },
    "/_staff/people/_list/rule-and-policy": {
      "filePath": "_staff/people/_list/rule-and-policy.tsx",
      "parent": "/_staff/people/_list"
    },
    "/_staff/people/_list/salary-and-payment": {
      "filePath": "_staff/people/_list/salary-and-payment.tsx",
      "parent": "/_staff/people/_list"
    },
    "/_staff/person/$id": {
      "filePath": "_staff/person/$id",
      "parent": "/_staff",
      "children": [
        "/_staff/person/$id/_profile",
        "/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId",
        "/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId",
        "/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId"
      ]
    },
    "/_staff/person/$id/_profile": {
      "filePath": "_staff/person/$id/_profile.tsx",
      "parent": "/_staff/person/$id",
      "children": [
        "/_staff/person/$id/_profile/",
        "/_staff/person/$id/_profile/apps/",
        "/_staff/person/$id/_profile/contractor-information/",
        "/_staff/person/$id/_profile/devices/",
        "/_staff/person/$id/_profile/education-and-qualification/",
        "/_staff/person/$id/_profile/employee-information/",
        "/_staff/person/$id/_profile/equipment/",
        "/_staff/person/$id/_profile/history/",
        "/_staff/person/$id/_profile/operation-activity/",
        "/_staff/person/$id/_profile/personal-information/",
        "/_staff/person/$id/_profile/public-id/",
        "/_staff/person/$id/_profile/family/$familyPersonId/"
      ]
    },
    "/_staff/places/$id": {
      "filePath": "_staff/places/$id",
      "parent": "/_staff/places",
      "children": [
        "/_staff/places/$id/_layout"
      ]
    },
    "/_staff/places/$id/_layout": {
      "filePath": "_staff/places/$id/_layout.tsx",
      "parent": "/_staff/places/$id",
      "children": [
        "/_staff/places/$id/_layout/administrators/",
        "/_staff/places/$id/_layout/labor-core/",
        "/_staff/places/$id/_layout/_profile/"
      ]
    },
    "/_staff/places/_layout/overview": {
      "filePath": "_staff/places/_layout/overview.tsx",
      "parent": "/_staff/places/_layout"
    },
    "/_staff/settings/contracting-corporation-profile": {
      "filePath": "_staff/settings/contracting-corporation-profile",
      "parent": "/_staff",
      "children": [
        "/_staff/settings/contracting-corporation-profile/_layout",
        "/_staff/settings/contracting-corporation-profile/"
      ]
    },
    "/_staff/settings/contracting-corporation-profile/_layout": {
      "filePath": "_staff/settings/contracting-corporation-profile/_layout.tsx",
      "parent": "/_staff/settings/contracting-corporation-profile",
      "children": [
        "/_staff/settings/contracting-corporation-profile/_layout/board-member/",
        "/_staff/settings/contracting-corporation-profile/_layout/contact-points/",
        "/_staff/settings/contracting-corporation-profile/_layout/corporate-overview/",
        "/_staff/settings/contracting-corporation-profile/_layout/group-companies/",
        "/_staff/settings/contracting-corporation-profile/_layout/history/",
        "/_staff/settings/contracting-corporation-profile/_layout/registration/",
        "/_staff/settings/contracting-corporation-profile/_layout/shareholders/"
      ]
    },
    "/_staff/settings/permission-and-roles": {
      "filePath": "_staff/settings/permission-and-roles",
      "parent": "/_staff",
      "children": [
        "/_staff/settings/permission-and-roles/_detail",
        "/_staff/settings/permission-and-roles/_form",
        "/_staff/settings/permission-and-roles/_list",
        "/_staff/settings/permission-and-roles/"
      ]
    },
    "/_staff/settings/permission-and-roles/_detail": {
      "filePath": "_staff/settings/permission-and-roles/_detail.tsx",
      "parent": "/_staff/settings/permission-and-roles",
      "children": [
        "/_staff/settings/permission-and-roles/_detail/category-permissions/$id/",
        "/_staff/settings/permission-and-roles/_detail/people-groups/$id/",
        "/_staff/settings/permission-and-roles/_detail/product-permissions/$id/",
        "/_staff/settings/permission-and-roles/_detail/roles/$id/"
      ]
    },
    "/_staff/settings/permission-and-roles/_form": {
      "filePath": "_staff/settings/permission-and-roles/_form.tsx",
      "parent": "/_staff/settings/permission-and-roles",
      "children": [
        "/_staff/settings/permission-and-roles/_form/category-permissions/new/",
        "/_staff/settings/permission-and-roles/_form/people-groups/new/",
        "/_staff/settings/permission-and-roles/_form/product-permissions/new/",
        "/_staff/settings/permission-and-roles/_form/roles/new/",
        "/_staff/settings/permission-and-roles/_form/category-permissions/$id/edit/",
        "/_staff/settings/permission-and-roles/_form/people-groups/$id/edit/",
        "/_staff/settings/permission-and-roles/_form/product-permissions/$id/edit/",
        "/_staff/settings/permission-and-roles/_form/roles/$id/edit/"
      ]
    },
    "/_staff/settings/permission-and-roles/_list": {
      "filePath": "_staff/settings/permission-and-roles/_list.tsx",
      "parent": "/_staff/settings/permission-and-roles",
      "children": [
        "/_staff/settings/permission-and-roles/_list/category-permissions/",
        "/_staff/settings/permission-and-roles/_list/people-groups/",
        "/_staff/settings/permission-and-roles/_list/product-permissions/",
        "/_staff/settings/permission-and-roles/_list/roles/"
      ]
    },
    "/_staff/settings/persons": {
      "filePath": "_staff/settings/persons",
      "parent": "/_staff",
      "children": [
        "/_staff/settings/persons/_list",
        "/_staff/settings/persons/",
        "/_staff/settings/persons/invite/"
      ]
    },
    "/_staff/settings/persons/_list": {
      "filePath": "_staff/settings/persons/_list.tsx",
      "parent": "/_staff/settings/persons",
      "children": [
        "/_staff/settings/persons/_list/_account",
        "/_staff/settings/persons/_list/settings/"
      ]
    },
    "/_staff/software/$id": {
      "filePath": "_staff/software/$id",
      "parent": "/_staff/software",
      "children": [
        "/_staff/software/$id/_$id"
      ]
    },
    "/_staff/software/$id/_$id": {
      "filePath": "_staff/software/$id/_$id.tsx",
      "parent": "/_staff/software/$id",
      "children": [
        "/_staff/software/$id/_$id/groups",
        "/_staff/software/$id/_$id/profiles",
        "/_staff/software/$id/_$id/settings",
        "/_staff/software/$id/_$id/",
        "/_staff/software/$id/_$id/contract-and-cost",
        "/_staff/software/$id/_$id/accounts/",
        "/_staff/software/$id/_$id/activity-monitoring/",
        "/_staff/software/$id/_$id/alerts/",
        "/_staff/software/$id/_$id/architecture/",
        "/_staff/software/$id/_$id/detail/",
        "/_staff/software/$id/_$id/rule-and-policy/"
      ]
    },
    "/_staff/software/_layout/integrations": {
      "filePath": "_staff/software/_layout/integrations.tsx",
      "parent": "/_staff/software/_layout"
    },
    "/_staff/starlinks/$id": {
      "filePath": "_staff/starlinks/$id",
      "parent": "/_staff/starlinks",
      "children": [
        "/_staff/starlinks/$id/_layout"
      ]
    },
    "/_staff/starlinks/$id/_layout": {
      "filePath": "_staff/starlinks/$id/_layout.tsx",
      "parent": "/_staff/starlinks/$id",
      "children": [
        "/_staff/starlinks/$id/_layout/_overview/",
        "/_staff/starlinks/$id/_layout/detail/"
      ]
    },
    "/_staff/supplier/$supplierId": {
      "filePath": "_staff/supplier/$supplierId",
      "parent": "/_staff/supplier",
      "children": [
        "/_staff/supplier/$supplierId/_layout"
      ]
    },
    "/_staff/supplier/$supplierId/_layout": {
      "filePath": "_staff/supplier/$supplierId/_layout.tsx",
      "parent": "/_staff/supplier/$supplierId",
      "children": [
        "/_staff/supplier/$supplierId/_layout/files",
        "/_staff/supplier/$supplierId/_layout/rules-and-policy",
        "/_staff/supplier/$supplierId/_layout/settings",
        "/_staff/supplier/$supplierId/_layout/_index/"
      ]
    },
    "/_staff/users/$userId": {
      "filePath": "_staff/users/$userId",
      "parent": "/_staff",
      "children": [
        "/_staff/users/$userId/_layout"
      ]
    },
    "/_staff/users/$userId/_layout": {
      "filePath": "_staff/users/$userId/_layout.tsx",
      "parent": "/_staff/users/$userId",
      "children": [
        "/_staff/users/$userId/_layout/_identity/",
        "/_staff/users/$userId/_layout/sessions/"
      ]
    },
    "/_staff/devices/_list/": {
      "filePath": "_staff/devices/_list/index/route.lazy.tsx",
      "parent": "/_staff/devices/_list"
    },
    "/_staff/people/_list/": {
      "filePath": "_staff/people/_list/index/route.lazy.tsx",
      "parent": "/_staff/people/_list"
    },
    "/_staff/software/_layout/": {
      "filePath": "_staff/software/_layout/index/route.lazy.tsx",
      "parent": "/_staff/software/_layout"
    },
    "/_staff/certification/_list/settings": {
      "filePath": "_staff/certification/_list/settings/route.lazy.tsx",
      "parent": "/_staff/certification/_list",
      "children": [
        "/_staff/certification/_list/settings/",
        "/_staff/certification/_list/settings/issuing-organization/",
        "/_staff/certification/_list/settings/specialty-category-level/",
        "/_staff/certification/_list/settings/specialty-category/"
      ]
    },
    "/_staff/devices/_list/settings": {
      "filePath": "_staff/devices/_list/settings/route.lazy.tsx",
      "parent": "/_staff/devices/_list",
      "children": [
        "/_staff/devices/_list/settings/",
        "/_staff/devices/_list/settings/catalog/"
      ]
    },
    "/_staff/equipment/_layout/settings": {
      "filePath": "_staff/equipment/_layout/settings/route.lazy.tsx",
      "parent": "/_staff/equipment/_layout",
      "children": [
        "/_staff/equipment/_layout/settings/",
        "/_staff/equipment/_layout/settings/equipment-items/",
        "/_staff/equipment/_layout/settings/equipment-types/"
      ]
    },
    "/_staff/people/_list/settings": {
      "filePath": "_staff/people/_list/settings/route.lazy.tsx",
      "parent": "/_staff/people/_list",
      "children": [
        "/_staff/people/_list/settings/",
        "/_staff/people/_list/settings/board-member-types/",
        "/_staff/people/_list/settings/collaborator-types/",
        "/_staff/people/_list/settings/contract-end-reasons/",
        "/_staff/people/_list/settings/contractor-types/",
        "/_staff/people/_list/settings/employee-sub-id-names/",
        "/_staff/people/_list/settings/employment-types/",
        "/_staff/people/_list/settings/grades/",
        "/_staff/people/_list/settings/health-insurance-associations/",
        "/_staff/people/_list/settings/job-competencies/",
        "/_staff/people/_list/settings/job-functions/",
        "/_staff/people/_list/settings/job-grades/",
        "/_staff/people/_list/settings/job-levels/",
        "/_staff/people/_list/settings/job-titles/",
        "/_staff/people/_list/settings/job-types/",
        "/_staff/people/_list/settings/place-social-insurances/",
        "/_staff/people/_list/settings/positions/",
        "/_staff/people/_list/settings/retirement-reasons/",
        "/_staff/people/_list/settings/work-mode/"
      ]
    },
    "/_staff/supplier/_list/settings": {
      "filePath": "_staff/supplier/_list/settings/route.lazy.tsx",
      "parent": "/_staff/supplier/_list",
      "children": [
        "/_staff/supplier/_list/settings/",
        "/_staff/supplier/_list/settings/procurement-categories/",
        "/_staff/supplier/_list/settings/supplier-categories/",
        "/_staff/supplier/_list/settings/supplier-subcategories/"
      ]
    },
    "/_chat/chat/$sessionId/": {
      "filePath": "_chat/chat/$sessionId/index.tsx",
      "parent": "/_chat"
    },
    "/_chat/chat/new/": {
      "filePath": "_chat/chat/new/index.tsx",
      "parent": "/_chat"
    },
    "/_idp-sso-mock/idp-sso/google-workspace/": {
      "filePath": "_idp-sso-mock/idp-sso/google-workspace/index.tsx",
      "parent": "/_idp-sso-mock"
    },
    "/_individual/individual/portal/": {
      "filePath": "_individual/individual/portal/index.tsx",
      "parent": "/_individual/individual/portal"
    },
    "/_stacktrace/development-tickets/add-select/": {
      "filePath": "_stacktrace/development-tickets/add-select/index.tsx",
      "parent": "/_stacktrace"
    },
    "/_stacktrace/development-tickets/add/": {
      "filePath": "_stacktrace/development-tickets/add/index.tsx",
      "parent": "/_stacktrace"
    },
    "/_stacktrace/development-tickets/external-integrations/": {
      "filePath": "_stacktrace/development-tickets/external-integrations/index.tsx",
      "parent": "/_stacktrace"
    },
    "/_stacktrace/issues/_layout/": {
      "filePath": "_stacktrace/issues/_layout/index.tsx",
      "parent": "/_stacktrace/issues/_layout"
    },
    "/_stacktrace/issues/add-select/": {
      "filePath": "_stacktrace/issues/add-select/index.tsx",
      "parent": "/_stacktrace/issues"
    },
    "/_stacktrace/issues/add/": {
      "filePath": "_stacktrace/issues/add/index.tsx",
      "parent": "/_stacktrace/issues"
    },
    "/_stacktrace/issues/external-integrations/": {
      "filePath": "_stacktrace/issues/external-integrations/index.tsx",
      "parent": "/_stacktrace/issues"
    },
    "/_stacktrace/product-roadmap/_layout/": {
      "filePath": "_stacktrace/product-roadmap/_layout/index.tsx",
      "parent": "/_stacktrace/product-roadmap/_layout"
    },
    "/_stacktrace/products/add-select/": {
      "filePath": "_stacktrace/products/add-select/index.tsx",
      "parent": "/_stacktrace"
    },
    "/_stacktrace/products/add/": {
      "filePath": "_stacktrace/products/add/index.tsx",
      "parent": "/_stacktrace"
    },
    "/_stacktrace/test-sets/_layout/": {
      "filePath": "_stacktrace/test-sets/_layout/index.tsx",
      "parent": "/_stacktrace/test-sets/_layout"
    },
    "/_stacktrace/test-suites/_layout/": {
      "filePath": "_stacktrace/test-suites/_layout/index.tsx",
      "parent": "/_stacktrace/test-suites/_layout"
    },
    "/_stacktrace/values/_layout/": {
      "filePath": "_stacktrace/values/_layout/index.tsx",
      "parent": "/_stacktrace/values/_layout"
    },
    "/_stacktrace/values/add-select/": {
      "filePath": "_stacktrace/values/add-select/index.tsx",
      "parent": "/_stacktrace/values"
    },
    "/_stacktrace/values/add/": {
      "filePath": "_stacktrace/values/add/index.tsx",
      "parent": "/_stacktrace/values"
    },
    "/_staff/accesses/_layout/": {
      "filePath": "_staff/accesses/_layout/index.tsx",
      "parent": "/_staff/accesses/_layout"
    },
    "/_staff/attendance-core/_layout/": {
      "filePath": "_staff/attendance-core/_layout/index.tsx",
      "parent": "/_staff/attendance-core/_layout"
    },
    "/_staff/attendance-engine/_layout/": {
      "filePath": "_staff/attendance-engine/_layout/index.tsx",
      "parent": "/_staff/attendance-engine/_layout"
    },
    "/_staff/attendances/_layout/": {
      "filePath": "_staff/attendances/_layout/index.tsx",
      "parent": "/_staff/attendances/_layout"
    },
    "/_staff/business-operation-events/$eventInstanceId/": {
      "filePath": "_staff/business-operation-events/$eventInstanceId/index.tsx",
      "parent": "/_staff/business-operation-events"
    },
    "/_staff/business-operation-events/_list/": {
      "filePath": "_staff/business-operation-events/_list/index.tsx",
      "parent": "/_staff/business-operation-events/_list"
    },
    "/_staff/business-partner/_list/": {
      "filePath": "_staff/business-partner/_list/index.tsx",
      "parent": "/_staff/business-partner/_list"
    },
    "/_staff/business-partner/add/": {
      "filePath": "_staff/business-partner/add/index.tsx",
      "parent": "/_staff/business-partner"
    },
    "/_staff/certification/add/": {
      "filePath": "_staff/certification/add/index.tsx",
      "parent": "/_staff/certification"
    },
    "/_staff/contract/_list/": {
      "filePath": "_staff/contract/_list/index.tsx",
      "parent": "/_staff/contract/_list"
    },
    "/_staff/contract/add/": {
      "filePath": "_staff/contract/add/index.tsx",
      "parent": "/_staff/contract"
    },
    "/_staff/contractor-core/_packages/": {
      "filePath": "_staff/contractor-core/_packages/index.tsx",
      "parent": "/_staff/contractor-core/_packages"
    },
    "/_staff/deal/_list/": {
      "filePath": "_staff/deal/_list/index.tsx",
      "parent": "/_staff/deal/_list"
    },
    "/_staff/deal/add/": {
      "filePath": "_staff/deal/add/index.tsx",
      "parent": "/_staff/deal"
    },
    "/_staff/device-catalog/add/": {
      "filePath": "_staff/device-catalog/add/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/devices/add/": {
      "filePath": "_staff/devices/add/index.tsx",
      "parent": "/_staff/devices"
    },
    "/_staff/devices/external-it-saas/": {
      "filePath": "_staff/devices/external-it-saas/index.tsx",
      "parent": "/_staff/devices"
    },
    "/_staff/equipment/_layout/": {
      "filePath": "_staff/equipment/_layout/index.tsx",
      "parent": "/_staff/equipment/_layout"
    },
    "/_staff/equipment/add-select/": {
      "filePath": "_staff/equipment/add-select/index.tsx",
      "parent": "/_staff/equipment"
    },
    "/_staff/equipment/add/": {
      "filePath": "_staff/equipment/add/index.tsx",
      "parent": "/_staff/equipment"
    },
    "/_staff/equipment/import-csv/": {
      "filePath": "_staff/equipment/import-csv/index.tsx",
      "parent": "/_staff/equipment"
    },
    "/_staff/fleets/add-select/": {
      "filePath": "_staff/fleets/add-select/index.tsx",
      "parent": "/_staff/fleets"
    },
    "/_staff/fleets/add/": {
      "filePath": "_staff/fleets/add/index.tsx",
      "parent": "/_staff/fleets"
    },
    "/_staff/ga-operation-core/_packages/": {
      "filePath": "_staff/ga-operation-core/_packages/index.tsx",
      "parent": "/_staff/ga-operation-core/_packages"
    },
    "/_staff/ids/_layout/": {
      "filePath": "_staff/ids/_layout/index.tsx",
      "parent": "/_staff/ids/_layout"
    },
    "/_staff/it-operation-core/device-targets/": {
      "filePath": "_staff/it-operation-core/device-targets/index.tsx",
      "parent": "/_staff/it-operation-core"
    },
    "/_staff/it-operation-core/person-targets/": {
      "filePath": "_staff/it-operation-core/person-targets/index.tsx",
      "parent": "/_staff/it-operation-core"
    },
    "/_staff/labor-core/_packages/": {
      "filePath": "_staff/labor-core/_packages/index.tsx",
      "parent": "/_staff/labor-core/_packages"
    },
    "/_staff/licenses/add/": {
      "filePath": "_staff/licenses/add/index.tsx",
      "parent": "/_staff/licenses"
    },
    "/_staff/marketplace/cart/": {
      "filePath": "_staff/marketplace/cart/index.tsx",
      "parent": "/_staff/marketplace"
    },
    "/_staff/marketplace/unavailable/": {
      "filePath": "_staff/marketplace/unavailable/index.tsx",
      "parent": "/_staff/marketplace"
    },
    "/_staff/networks/_layout/": {
      "filePath": "_staff/networks/_layout/index.tsx",
      "parent": "/_staff/networks/_layout"
    },
    "/_staff/networks/add/": {
      "filePath": "_staff/networks/add/index.tsx",
      "parent": "/_staff/networks"
    },
    "/_staff/organization/plan/": {
      "filePath": "_staff/organization/plan/index.tsx",
      "parent": "/_staff/organization"
    },
    "/_staff/payroll-core/_layout/": {
      "filePath": "_staff/payroll-core/_layout/index.tsx",
      "parent": "/_staff/payroll-core/_layout"
    },
    "/_staff/payroll-engine/_layout/": {
      "filePath": "_staff/payroll-engine/_layout/index.tsx",
      "parent": "/_staff/payroll-engine/_layout"
    },
    "/_staff/payroll/_layout/": {
      "filePath": "_staff/payroll/_layout/index.tsx",
      "parent": "/_staff/payroll/_layout"
    },
    "/_staff/person/add-person-certification/": {
      "filePath": "_staff/person/add-person-certification/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/person/add/": {
      "filePath": "_staff/person/add/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/person/external-hr-saas/": {
      "filePath": "_staff/person/external-hr-saas/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/places/_layout/": {
      "filePath": "_staff/places/_layout/index.tsx",
      "parent": "/_staff/places/_layout"
    },
    "/_staff/places/add-select/": {
      "filePath": "_staff/places/add-select/index.tsx",
      "parent": "/_staff/places"
    },
    "/_staff/places/add/": {
      "filePath": "_staff/places/add/index.tsx",
      "parent": "/_staff/places"
    },
    "/_staff/public-ids/$id/": {
      "filePath": "_staff/public-ids/$id/index.tsx",
      "parent": "/_staff/public-ids/$id"
    },
    "/_staff/public-ids/_list/": {
      "filePath": "_staff/public-ids/_list/index.tsx",
      "parent": "/_staff/public-ids/_list"
    },
    "/_staff/public-ids/add/": {
      "filePath": "_staff/public-ids/add/index.tsx",
      "parent": "/_staff/public-ids"
    },
    "/_staff/settings/contracting-corporation-profile/": {
      "filePath": "_staff/settings/contracting-corporation-profile/index.tsx",
      "parent": "/_staff/settings/contracting-corporation-profile"
    },
    "/_staff/settings/permission-and-roles/": {
      "filePath": "_staff/settings/permission-and-roles/index.tsx",
      "parent": "/_staff/settings/permission-and-roles"
    },
    "/_staff/settings/persons/": {
      "filePath": "_staff/settings/persons/index.tsx",
      "parent": "/_staff/settings/persons"
    },
    "/_staff/software/add/": {
      "filePath": "_staff/software/add/index.tsx",
      "parent": "/_staff/software"
    },
    "/_staff/starlinks/_layout/": {
      "filePath": "_staff/starlinks/_layout/index.tsx",
      "parent": "/_staff/starlinks/_layout"
    },
    "/_staff/storage-files/_list/": {
      "filePath": "_staff/storage-files/_list/index.tsx",
      "parent": "/_staff/storage-files/_list"
    },
    "/_staff/supplier/_list/": {
      "filePath": "_staff/supplier/_list/index.tsx",
      "parent": "/_staff/supplier/_list"
    },
    "/_staff/time-and-attendance/_layout/": {
      "filePath": "_staff/time-and-attendance/_layout/index.tsx",
      "parent": "/_staff/time-and-attendance/_layout"
    },
    "/auth/invitation/$invitationCode/": {
      "filePath": "auth/invitation/$invitationCode/index.tsx"
    },
    "/auth/sign-in/error/": {
      "filePath": "auth/sign-in/error/index.tsx"
    },
    "/_staff/person/$id/_profile/": {
      "filePath": "_staff/person/$id/_profile/index/route.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_individual/individual/portal/lookup/clocking-record": {
      "filePath": "_individual/individual/portal/lookup/clocking-record/route.tsx",
      "parent": "/_individual/individual/portal",
      "children": [
        "/_individual/individual/portal/lookup/clocking-record/alerts",
        "/_individual/individual/portal/lookup/clocking-record/files",
        "/_individual/individual/portal/lookup/clocking-record/overview",
        "/_individual/individual/portal/lookup/clocking-record/schedule",
        "/_individual/individual/portal/lookup/clocking-record/"
      ]
    },
    "/_individual/individual/portal/lookup/pay-slip": {
      "filePath": "_individual/individual/portal/lookup/pay-slip/route.tsx",
      "parent": "/_individual/individual/portal",
      "children": [
        "/_individual/individual/portal/lookup/pay-slip/alerts",
        "/_individual/individual/portal/lookup/pay-slip/files",
        "/_individual/individual/portal/lookup/pay-slip/history",
        "/_individual/individual/portal/lookup/pay-slip/overview",
        "/_individual/individual/portal/lookup/pay-slip/"
      ]
    },
    "/_staff/attendances/_layout/clocking-records/$employeeId": {
      "filePath": "_staff/attendances/_layout/clocking-records/$employeeId/route.tsx",
      "parent": "/_staff/attendances/_layout",
      "children": [
        "/_staff/attendances/_layout/clocking-records/$employeeId/alerts",
        "/_staff/attendances/_layout/clocking-records/$employeeId/files",
        "/_staff/attendances/_layout/clocking-records/$employeeId/overview",
        "/_staff/attendances/_layout/clocking-records/$employeeId/schedule",
        "/_staff/attendances/_layout/clocking-records/$employeeId/settings",
        "/_staff/attendances/_layout/clocking-records/$employeeId/"
      ]
    },
    "/_staff/business-partner/_list/_placeholders/alerts": {
      "filePath": "_staff/business-partner/_list/_placeholders/alerts/route.tsx",
      "parent": "/_staff/business-partner/_list"
    },
    "/_staff/business-partner/_list/_placeholders/contract-and-cost": {
      "filePath": "_staff/business-partner/_list/_placeholders/contract-and-cost/route.tsx",
      "parent": "/_staff/business-partner/_list"
    },
    "/_staff/business-partner/_list/_placeholders/operation-activity": {
      "filePath": "_staff/business-partner/_list/_placeholders/operation-activity/route.tsx",
      "parent": "/_staff/business-partner/_list"
    },
    "/_staff/business-partner/_list/_placeholders/rule-and-policy": {
      "filePath": "_staff/business-partner/_list/_placeholders/rule-and-policy/route.tsx",
      "parent": "/_staff/business-partner/_list"
    },
    "/_staff/business-partner/_list/_placeholders/settings": {
      "filePath": "_staff/business-partner/_list/_placeholders/settings/route.tsx",
      "parent": "/_staff/business-partner/_list"
    },
    "/_staff/certification/_list/_placeholders/alerts": {
      "filePath": "_staff/certification/_list/_placeholders/alerts/route.tsx",
      "parent": "/_staff/certification/_list"
    },
    "/_staff/certification/_list/_placeholders/operation-activity": {
      "filePath": "_staff/certification/_list/_placeholders/operation-activity/route.tsx",
      "parent": "/_staff/certification/_list"
    },
    "/_staff/certification/_list/_placeholders/overview": {
      "filePath": "_staff/certification/_list/_placeholders/overview/route.tsx",
      "parent": "/_staff/certification/_list"
    },
    "/_staff/certification/_list/_placeholders/rule-and-policy": {
      "filePath": "_staff/certification/_list/_placeholders/rule-and-policy/route.tsx",
      "parent": "/_staff/certification/_list"
    },
    "/_staff/contract/_list/_placeholders/alerts": {
      "filePath": "_staff/contract/_list/_placeholders/alerts/route.tsx",
      "parent": "/_staff/contract/_list"
    },
    "/_staff/contract/_list/_placeholders/contract-and-cost": {
      "filePath": "_staff/contract/_list/_placeholders/contract-and-cost/route.tsx",
      "parent": "/_staff/contract/_list"
    },
    "/_staff/contract/_list/_placeholders/operation-activity": {
      "filePath": "_staff/contract/_list/_placeholders/operation-activity/route.tsx",
      "parent": "/_staff/contract/_list"
    },
    "/_staff/contract/_list/_placeholders/overview": {
      "filePath": "_staff/contract/_list/_placeholders/overview/route.tsx",
      "parent": "/_staff/contract/_list"
    },
    "/_staff/contract/_list/_placeholders/people": {
      "filePath": "_staff/contract/_list/_placeholders/people/route.tsx",
      "parent": "/_staff/contract/_list"
    },
    "/_staff/deal/$dealId/_layout/flow": {
      "filePath": "_staff/deal/$dealId/_layout/flow/route.tsx",
      "parent": "/_staff/deal/$dealId/_layout"
    },
    "/_staff/deal/$dealId/_layout/structure": {
      "filePath": "_staff/deal/$dealId/_layout/structure/route.tsx",
      "parent": "/_staff/deal/$dealId/_layout"
    },
    "/_staff/payroll/_layout/pay-slips/$employeeId": {
      "filePath": "_staff/payroll/_layout/pay-slips/$employeeId/route.tsx",
      "parent": "/_staff/payroll/_layout",
      "children": [
        "/_staff/payroll/_layout/pay-slips/$employeeId/alerts",
        "/_staff/payroll/_layout/pay-slips/$employeeId/files",
        "/_staff/payroll/_layout/pay-slips/$employeeId/history",
        "/_staff/payroll/_layout/pay-slips/$employeeId/overview",
        "/_staff/payroll/_layout/pay-slips/$employeeId/settings",
        "/_staff/payroll/_layout/pay-slips/$employeeId/"
      ]
    },
    "/_staff/software/_layout/marketplace/$id": {
      "filePath": "_staff/software/_layout/marketplace/$id/route.tsx",
      "parent": "/_staff/software/_layout",
      "children": [
        "/_staff/software/_layout/marketplace/$id/install/finish/"
      ]
    },
    "/_staff/supplier/$supplierId/_layout/files": {
      "filePath": "_staff/supplier/$supplierId/_layout/files/route.tsx",
      "parent": "/_staff/supplier/$supplierId/_layout"
    },
    "/_staff/supplier/$supplierId/_layout/rules-and-policy": {
      "filePath": "_staff/supplier/$supplierId/_layout/rules-and-policy/route.tsx",
      "parent": "/_staff/supplier/$supplierId/_layout"
    },
    "/_staff/supplier/$supplierId/_layout/settings": {
      "filePath": "_staff/supplier/$supplierId/_layout/settings/route.tsx",
      "parent": "/_staff/supplier/$supplierId/_layout"
    },
    "/_staff/supplier/_list/_placeholders/alerts": {
      "filePath": "_staff/supplier/_list/_placeholders/alerts/route.tsx",
      "parent": "/_staff/supplier/_list"
    },
    "/_staff/supplier/_list/_placeholders/contract-and-cost": {
      "filePath": "_staff/supplier/_list/_placeholders/contract-and-cost/route.tsx",
      "parent": "/_staff/supplier/_list"
    },
    "/_staff/supplier/_list/_placeholders/operation-activity": {
      "filePath": "_staff/supplier/_list/_placeholders/operation-activity/route.tsx",
      "parent": "/_staff/supplier/_list"
    },
    "/_staff/supplier/_list/_placeholders/overview": {
      "filePath": "_staff/supplier/_list/_placeholders/overview/route.tsx",
      "parent": "/_staff/supplier/_list"
    },
    "/_staff/supplier/_list/_placeholders/rule-and-policy": {
      "filePath": "_staff/supplier/_list/_placeholders/rule-and-policy/route.tsx",
      "parent": "/_staff/supplier/_list"
    },
    "/_individual/individual/_profile/my-profile": {
      "filePath": "_individual/individual/_profile/my-profile",
      "parent": "/_individual/individual/_profile",
      "children": [
        "/_individual/individual/_profile/my-profile/_layout"
      ]
    },
    "/_individual/individual/_profile/my-profile/_layout": {
      "filePath": "_individual/individual/_profile/my-profile/_layout.tsx",
      "parent": "/_individual/individual/_profile/my-profile",
      "children": [
        "/_individual/individual/_profile/my-profile/_layout/",
        "/_individual/individual/_profile/my-profile/_layout/devices/",
        "/_individual/individual/_profile/my-profile/_layout/education-and-qualification/",
        "/_individual/individual/_profile/my-profile/_layout/softwares/"
      ]
    },
    "/_individual/individual/task/$id/approval-dialog": {
      "filePath": "_individual/individual/task/$id/approval-dialog.tsx",
      "parent": "/_individual/individual"
    },
    "/_staff/accesses/_layout/_placeholders/contract-and-cost": {
      "filePath": "_staff/accesses/_layout/_placeholders/contract-and-cost.tsx",
      "parent": "/_staff/accesses/_layout"
    },
    "/_staff/accesses/_layout/_placeholders/overview": {
      "filePath": "_staff/accesses/_layout/_placeholders/overview.tsx",
      "parent": "/_staff/accesses/_layout"
    },
    "/_staff/accesses/_layout/_placeholders/software": {
      "filePath": "_staff/accesses/_layout/_placeholders/software.tsx",
      "parent": "/_staff/accesses/_layout"
    },
    "/_staff/app-integrations/$id/_$id/$": {
      "filePath": "_staff/app-integrations/$id/_$id/$.tsx",
      "parent": "/_staff/app-integrations/$id/_$id"
    },
    "/_staff/business-partner/add/$businessPartnerType/completed": {
      "filePath": "_staff/business-partner/add/$businessPartnerType/completed.tsx",
      "parent": "/_staff/business-partner"
    },
    "/_staff/certification/add/$certificationKind/completed": {
      "filePath": "_staff/certification/add/$certificationKind/completed.tsx",
      "parent": "/_staff/certification"
    },
    "/_staff/certification/handling-certification/$id": {
      "filePath": "_staff/certification/handling-certification/$id",
      "parent": "/_staff/certification",
      "children": [
        "/_staff/certification/handling-certification/$id/_layout"
      ]
    },
    "/_staff/certification/handling-certification/$id/_layout": {
      "filePath": "_staff/certification/handling-certification/$id/_layout.tsx",
      "parent": "/_staff/certification/handling-certification/$id",
      "children": [
        "/_staff/certification/handling-certification/$id/_layout/_index/",
        "/_staff/certification/handling-certification/$id/_layout/certification-holders/"
      ]
    },
    "/_staff/certification/specialty-certification/$id": {
      "filePath": "_staff/certification/specialty-certification/$id",
      "parent": "/_staff/certification",
      "children": [
        "/_staff/certification/specialty-certification/$id/_layout"
      ]
    },
    "/_staff/certification/specialty-certification/$id/_layout": {
      "filePath": "_staff/certification/specialty-certification/$id/_layout.tsx",
      "parent": "/_staff/certification/specialty-certification/$id",
      "children": [
        "/_staff/certification/specialty-certification/$id/_layout/_index/",
        "/_staff/certification/specialty-certification/$id/_layout/certification-holders/",
        "/_staff/certification/specialty-certification/$id/_layout/handling-certifications/"
      ]
    },
    "/_staff/contract/add/subscription/completed": {
      "filePath": "_staff/contract/add/subscription/completed.tsx",
      "parent": "/_staff/contract"
    },
    "/_staff/deal/add/$direction/completed": {
      "filePath": "_staff/deal/add/$direction/completed.tsx",
      "parent": "/_staff/deal"
    },
    "/_staff/device-catalog/active/$id": {
      "filePath": "_staff/device-catalog/active/$id",
      "parent": "/_staff",
      "children": [
        "/_staff/device-catalog/active/$id/_layout"
      ]
    },
    "/_staff/device-catalog/active/$id/_layout": {
      "filePath": "_staff/device-catalog/active/$id/_layout.tsx",
      "parent": "/_staff/device-catalog/active/$id",
      "children": [
        "/_staff/device-catalog/active/$id/_layout/contract-and-cost",
        "/_staff/device-catalog/active/$id/_layout/profile/"
      ]
    },
    "/_staff/device-catalog/add/$deviceType/completed": {
      "filePath": "_staff/device-catalog/add/$deviceType/completed.tsx",
      "parent": "/_staff"
    },
    "/_staff/device-catalog/draft/$id": {
      "filePath": "_staff/device-catalog/draft/$id",
      "parent": "/_staff",
      "children": [
        "/_staff/device-catalog/draft/$id/_layout"
      ]
    },
    "/_staff/device-catalog/draft/$id/_layout": {
      "filePath": "_staff/device-catalog/draft/$id/_layout.tsx",
      "parent": "/_staff/device-catalog/draft/$id",
      "children": [
        "/_staff/device-catalog/draft/$id/_layout/profile/"
      ]
    },
    "/_staff/devices/_list/contract-and-cost": {
      "filePath": "_staff/devices/_list/contract-and-cost",
      "parent": "/_staff/devices/_list",
      "children": [
        "/_staff/devices/_list/contract-and-cost/_contract-and-cost"
      ]
    },
    "/_staff/devices/_list/contract-and-cost/_contract-and-cost": {
      "filePath": "_staff/devices/_list/contract-and-cost/_contract-and-cost.tsx",
      "parent": "/_staff/devices/_list/contract-and-cost",
      "children": [
        "/_staff/devices/_list/contract-and-cost/_contract-and-cost/",
        "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal",
        "/_staff/devices/_list/contract-and-cost/_contract-and-cost/cost/",
        "/_staff/devices/_list/contract-and-cost/_contract-and-cost/payment/",
        "/_staff/devices/_list/contract-and-cost/_contract-and-cost/cost/$period/",
        "/_staff/devices/_list/contract-and-cost/_contract-and-cost/payment/$period/"
      ]
    },
    "/_staff/devices/add/$deviceType/completed": {
      "filePath": "_staff/devices/add/$deviceType/completed.tsx",
      "parent": "/_staff/devices"
    },
    "/_staff/equipment/_layout/_placeholders/overview": {
      "filePath": "_staff/equipment/_layout/_placeholders/overview.tsx",
      "parent": "/_staff/equipment/_layout"
    },
    "/_staff/equipment/_layout/_placeholders/rule-and-policy": {
      "filePath": "_staff/equipment/_layout/_placeholders/rule-and-policy.tsx",
      "parent": "/_staff/equipment/_layout"
    },
    "/_staff/equipment/_layout/_placeholders/settings": {
      "filePath": "_staff/equipment/_layout/_placeholders/settings.tsx",
      "parent": "/_staff/equipment/_layout"
    },
    "/_staff/equipment/items/$id": {
      "filePath": "_staff/equipment/items/$id",
      "parent": "/_staff/equipment",
      "children": [
        "/_staff/equipment/items/$id/_detail"
      ]
    },
    "/_staff/equipment/items/$id/_detail": {
      "filePath": "_staff/equipment/items/$id/_detail.tsx",
      "parent": "/_staff/equipment/items/$id",
      "children": [
        "/_staff/equipment/items/$id/_detail/",
        "/_staff/equipment/items/$id/_detail/alerts/",
        "/_staff/equipment/items/$id/_detail/inventory/",
        "/_staff/equipment/items/$id/_detail/rule-and-policy/",
        "/_staff/equipment/items/$id/_detail/profile/"
      ]
    },
    "/_staff/ids/_layout/_placeholders/alerts": {
      "filePath": "_staff/ids/_layout/_placeholders/alerts.tsx",
      "parent": "/_staff/ids/_layout"
    },
    "/_staff/ids/_layout/_placeholders/group-id": {
      "filePath": "_staff/ids/_layout/_placeholders/group-id.tsx",
      "parent": "/_staff/ids/_layout"
    },
    "/_staff/ids/_layout/_placeholders/operation-activity": {
      "filePath": "_staff/ids/_layout/_placeholders/operation-activity.tsx",
      "parent": "/_staff/ids/_layout"
    },
    "/_staff/ids/_layout/_placeholders/overview": {
      "filePath": "_staff/ids/_layout/_placeholders/overview.tsx",
      "parent": "/_staff/ids/_layout"
    },
    "/_staff/ids/_layout/_placeholders/rule-and-policy": {
      "filePath": "_staff/ids/_layout/_placeholders/rule-and-policy.tsx",
      "parent": "/_staff/ids/_layout"
    },
    "/_staff/ids/_layout/_placeholders/settings": {
      "filePath": "_staff/ids/_layout/_placeholders/settings.tsx",
      "parent": "/_staff/ids/_layout"
    },
    "/_staff/ids/group-id/$id": {
      "filePath": "_staff/ids/group-id/$id",
      "parent": "/_staff/ids",
      "children": [
        "/_staff/ids/group-id/$id/_$id"
      ]
    },
    "/_staff/ids/group-id/$id/_$id": {
      "filePath": "_staff/ids/group-id/$id/_$id.tsx",
      "parent": "/_staff/ids/group-id/$id",
      "children": [
        "/_staff/ids/group-id/$id/_$id/",
        "/_staff/ids/group-id/$id/_$id/detail/",
        "/_staff/ids/group-id/$id/_$id/devices/",
        "/_staff/ids/group-id/$id/_$id/members/",
        "/_staff/ids/group-id/$id/_$id/rule-and-policy/",
        "/_staff/ids/group-id/$id/_$id/security-and-auth/",
        "/_staff/ids/group-id/$id/_$id/softwares/"
      ]
    },
    "/_staff/it-operation-core/_root/in-house-packages/$packageId": {
      "filePath": "_staff/it-operation-core/_root/in-house-packages/$packageId.tsx",
      "parent": "/_staff/it-operation-core/_root/in-house-packages",
      "children": [
        "/_staff/it-operation-core/_root/in-house-packages/$packageId/start-targets"
      ]
    },
    "/_staff/it-operation-core/_root/packages/$packageId": {
      "filePath": "_staff/it-operation-core/_root/packages/$packageId.tsx",
      "parent": "/_staff/it-operation-core/_root/packages"
    },
    "/_staff/labor-core/settings/profile/$profileId": {
      "filePath": "_staff/labor-core/settings/profile.$profileId.tsx",
      "parent": "/_staff/labor-core"
    },
    "/_staff/licenses/add/$allocationType/completed": {
      "filePath": "_staff/licenses/add/$allocationType/completed.tsx",
      "parent": "/_staff/licenses"
    },
    "/_staff/marketplace/sent-orders/$orderId": {
      "filePath": "_staff/marketplace/sent-orders/$orderId",
      "parent": "/_staff/marketplace",
      "children": [
        "/_staff/marketplace/sent-orders/$orderId/_layout"
      ]
    },
    "/_staff/marketplace/sent-orders/$orderId/_layout": {
      "filePath": "_staff/marketplace/sent-orders/$orderId/_layout.tsx",
      "parent": "/_staff/marketplace/sent-orders/$orderId",
      "children": [
        "/_staff/marketplace/sent-orders/$orderId/_layout/activities",
        "/_staff/marketplace/sent-orders/$orderId/_layout/"
      ]
    },
    "/_staff/networks/_layout/_placeholders/alerts": {
      "filePath": "_staff/networks/_layout/_placeholders/alerts.tsx",
      "parent": "/_staff/networks/_layout"
    },
    "/_staff/networks/_layout/_placeholders/contract-and-cost": {
      "filePath": "_staff/networks/_layout/_placeholders/contract-and-cost.tsx",
      "parent": "/_staff/networks/_layout"
    },
    "/_staff/networks/_layout/_placeholders/operation-activity": {
      "filePath": "_staff/networks/_layout/_placeholders/operation-activity.tsx",
      "parent": "/_staff/networks/_layout"
    },
    "/_staff/networks/_layout/_placeholders/overview": {
      "filePath": "_staff/networks/_layout/_placeholders/overview.tsx",
      "parent": "/_staff/networks/_layout"
    },
    "/_staff/networks/_layout/_placeholders/rule-and-policy": {
      "filePath": "_staff/networks/_layout/_placeholders/rule-and-policy.tsx",
      "parent": "/_staff/networks/_layout"
    },
    "/_staff/networks/_layout/_placeholders/settings": {
      "filePath": "_staff/networks/_layout/_placeholders/settings.tsx",
      "parent": "/_staff/networks/_layout"
    },
    "/_staff/payroll/_layout/contract-and-cost": {
      "filePath": "_staff/payroll/_layout/contract-and-cost",
      "parent": "/_staff/payroll/_layout",
      "children": [
        "/_staff/payroll/_layout/contract-and-cost/_contract-and-cost"
      ]
    },
    "/_staff/payroll/_layout/contract-and-cost/_contract-and-cost": {
      "filePath": "_staff/payroll/_layout/contract-and-cost/_contract-and-cost.tsx",
      "parent": "/_staff/payroll/_layout/contract-and-cost",
      "children": [
        "/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/",
        "/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/cost/",
        "/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/deal/",
        "/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/payment/",
        "/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/cost/$period/",
        "/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/payment/$period/"
      ]
    },
    "/_staff/person/add-person-certification/$certificationKind/completed": {
      "filePath": "_staff/person/add-person-certification/$certificationKind/completed.tsx",
      "parent": "/_staff"
    },
    "/_staff/person/add/$workerType/completed": {
      "filePath": "_staff/person/add/$workerType/completed.tsx",
      "parent": "/_staff"
    },
    "/_staff/person/alumni/$id": {
      "filePath": "_staff/person/alumni/$id",
      "parent": "/_staff",
      "children": [
        "/_staff/person/alumni/$id/_profile"
      ]
    },
    "/_staff/person/alumni/$id/_profile": {
      "filePath": "_staff/person/alumni/$id/_profile.tsx",
      "parent": "/_staff/person/alumni/$id",
      "children": [
        "/_staff/person/alumni/$id/_profile/",
        "/_staff/person/alumni/$id/_profile/apps/",
        "/_staff/person/alumni/$id/_profile/contractor-information/",
        "/_staff/person/alumni/$id/_profile/devices/",
        "/_staff/person/alumni/$id/_profile/education-and-qualification/",
        "/_staff/person/alumni/$id/_profile/employee-information/",
        "/_staff/person/alumni/$id/_profile/equipment/",
        "/_staff/person/alumni/$id/_profile/history/",
        "/_staff/person/alumni/$id/_profile/operation-activity/",
        "/_staff/person/alumni/$id/_profile/personal-information/",
        "/_staff/person/alumni/$id/_profile/public-id/"
      ]
    },
    "/_staff/places/_layout/_placeholders/alerts": {
      "filePath": "_staff/places/_layout/_placeholders/alerts.tsx",
      "parent": "/_staff/places/_layout"
    },
    "/_staff/places/_layout/_placeholders/contract-and-cost": {
      "filePath": "_staff/places/_layout/_placeholders/contract-and-cost.tsx",
      "parent": "/_staff/places/_layout"
    },
    "/_staff/places/_layout/_placeholders/operation-activity": {
      "filePath": "_staff/places/_layout/_placeholders/operation-activity.tsx",
      "parent": "/_staff/places/_layout"
    },
    "/_staff/places/_layout/_placeholders/people": {
      "filePath": "_staff/places/_layout/_placeholders/people.tsx",
      "parent": "/_staff/places/_layout"
    },
    "/_staff/places/_layout/_placeholders/rule-and-policy": {
      "filePath": "_staff/places/_layout/_placeholders/rule-and-policy.tsx",
      "parent": "/_staff/places/_layout"
    },
    "/_staff/places/_layout/_placeholders/store": {
      "filePath": "_staff/places/_layout/_placeholders/store.tsx",
      "parent": "/_staff/places/_layout"
    },
    "/_staff/profile/device/$id/$": {
      "filePath": "_staff/profile/device/$id/$.tsx",
      "parent": "/_staff"
    },
    "/_staff/settings/persons/_list/_account": {
      "filePath": "_staff/settings/persons/_list/_account.tsx",
      "parent": "/_staff/settings/persons/_list",
      "children": [
        "/_staff/settings/persons/_list/_account/individual/",
        "/_staff/settings/persons/_list/_account/staff/"
      ]
    },
    "/_staff/software/$id/_$id/groups": {
      "filePath": "_staff/software/$id/_$id/groups.tsx",
      "parent": "/_staff/software/$id/_$id"
    },
    "/_staff/software/$id/_$id/profiles": {
      "filePath": "_staff/software/$id/_$id/profiles.tsx",
      "parent": "/_staff/software/$id/_$id"
    },
    "/_staff/software/_layout/alerts": {
      "filePath": "_staff/software/_layout/alerts",
      "parent": "/_staff/software/_layout",
      "children": [
        "/_staff/software/_layout/alerts/_alerts"
      ]
    },
    "/_staff/software/_layout/alerts/_alerts": {
      "filePath": "_staff/software/_layout/alerts/_alerts.tsx",
      "parent": "/_staff/software/_layout/alerts",
      "children": [
        "/_staff/software/_layout/alerts/_alerts/",
        "/_staff/software/_layout/alerts/_alerts/alumni/",
        "/_staff/software/_layout/alerts/_alerts/inactive-user/",
        "/_staff/software/_layout/alerts/_alerts/no-user/",
        "/_staff/software/_layout/alerts/_alerts/no-worker/",
        "/_staff/software/_layout/alerts/_alerts/violated-assignment/",
        "/_staff/software/_layout/alerts/_alerts/violated-role/"
      ]
    },
    "/_staff/software/_layout/contract-and-cost": {
      "filePath": "_staff/software/_layout/contract-and-cost",
      "parent": "/_staff/software/_layout",
      "children": [
        "/_staff/software/_layout/contract-and-cost/_contract-and-cost"
      ]
    },
    "/_staff/software/_layout/contract-and-cost/_contract-and-cost": {
      "filePath": "_staff/software/_layout/contract-and-cost/_contract-and-cost.tsx",
      "parent": "/_staff/software/_layout/contract-and-cost",
      "children": [
        "/_staff/software/_layout/contract-and-cost/_contract-and-cost/",
        "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal",
        "/_staff/software/_layout/contract-and-cost/_contract-and-cost/cost/",
        "/_staff/software/_layout/contract-and-cost/_contract-and-cost/payment/",
        "/_staff/software/_layout/contract-and-cost/_contract-and-cost/cost/$period/",
        "/_staff/software/_layout/contract-and-cost/_contract-and-cost/payment/$period/"
      ]
    },
    "/_staff/starlinks/_layout/_placeholders/billing-and-cost": {
      "filePath": "_staff/starlinks/_layout/_placeholders/billing-and-cost.tsx",
      "parent": "/_staff/starlinks/_layout"
    },
    "/_staff/starlinks/_layout/_placeholders/marketplace": {
      "filePath": "_staff/starlinks/_layout/_placeholders/marketplace.tsx",
      "parent": "/_staff/starlinks/_layout"
    },
    "/_staff/starlinks/_layout/_placeholders/operation-activity": {
      "filePath": "_staff/starlinks/_layout/_placeholders/operation-activity.tsx",
      "parent": "/_staff/starlinks/_layout"
    },
    "/_staff/storage-files/files/$id": {
      "filePath": "_staff/storage-files/files/$id",
      "parent": "/_staff/storage-files",
      "children": [
        "/_staff/storage-files/files/$id/_$id"
      ]
    },
    "/_staff/storage-files/files/$id/_$id": {
      "filePath": "_staff/storage-files/files/$id/_$id.tsx",
      "parent": "/_staff/storage-files/files/$id",
      "children": [
        "/_staff/storage-files/files/$id/_$id/"
      ]
    },
    "/_staff/storage-files/folders/$id": {
      "filePath": "_staff/storage-files/folders/$id",
      "parent": "/_staff/storage-files",
      "children": [
        "/_staff/storage-files/folders/$id/_$id"
      ]
    },
    "/_staff/storage-files/folders/$id/_$id": {
      "filePath": "_staff/storage-files/folders/$id/_$id.tsx",
      "parent": "/_staff/storage-files/folders/$id",
      "children": [
        "/_staff/storage-files/folders/$id/_$id/",
        "/_staff/storage-files/folders/$id/_$id/files/",
        "/_staff/storage-files/folders/$id/_$id/users/"
      ]
    },
    "/_staff/software/$id/_$id/settings": {
      "filePath": "_staff/software/$id/_$id/settings/route.lazy.tsx",
      "parent": "/_staff/software/$id/_$id",
      "children": [
        "/_staff/software/$id/_$id/settings/",
        "/_staff/software/$id/_$id/settings/integration/",
        "/_staff/software/$id/_$id/settings/role/",
        "/_staff/software/$id/_$id/settings/status/"
      ]
    },
    "/_individual/individual/_tasks/approval-tasks/": {
      "filePath": "_individual/individual/_tasks/approval-tasks/index.tsx",
      "parent": "/_individual/individual"
    },
    "/_individual/individual/_tasks/operation-tasks/": {
      "filePath": "_individual/individual/_tasks/operation-tasks/index.tsx",
      "parent": "/_individual/individual"
    },
    "/_individual/individual/_tasks/request-tasks/": {
      "filePath": "_individual/individual/_tasks/request-tasks/index.tsx",
      "parent": "/_individual/individual"
    },
    "/_individual/individual/operation-package/$id/": {
      "filePath": "_individual/individual/operation-package/$id/index.tsx",
      "parent": "/_individual/individual"
    },
    "/_individual/individual/portal/approvals/": {
      "filePath": "_individual/individual/portal/approvals/index.tsx",
      "parent": "/_individual/individual/portal"
    },
    "/_individual/individual/portal/lookup/": {
      "filePath": "_individual/individual/portal/lookup/index.tsx",
      "parent": "/_individual/individual/portal"
    },
    "/_individual/individual/portal/requests/": {
      "filePath": "_individual/individual/portal/requests/index.tsx",
      "parent": "/_individual/individual/portal"
    },
    "/_individual/individual/task/$id/": {
      "filePath": "_individual/individual/task/$id/index.tsx",
      "parent": "/_individual/individual"
    },
    "/_stacktrace/development-tickets/$ticketId/_layout/": {
      "filePath": "_stacktrace/development-tickets/$ticketId/_layout/index.tsx",
      "parent": "/_stacktrace/development-tickets/$ticketId/_layout"
    },
    "/_stacktrace/issues/$id/_layout/": {
      "filePath": "_stacktrace/issues/$id/_layout/index.tsx",
      "parent": "/_stacktrace/issues/$id/_layout"
    },
    "/_stacktrace/issues/_layout/overview/": {
      "filePath": "_stacktrace/issues/_layout/overview/index.tsx",
      "parent": "/_stacktrace/issues/_layout"
    },
    "/_stacktrace/product-roadmap/$roadmapId/_layout/": {
      "filePath": "_stacktrace/product-roadmap/$roadmapId/_layout/index.tsx",
      "parent": "/_stacktrace/product-roadmap/$roadmapId/_layout"
    },
    "/_stacktrace/production/$productionId/_layout/": {
      "filePath": "_stacktrace/production/$productionId/_layout/index.tsx",
      "parent": "/_stacktrace/production/$productionId/_layout"
    },
    "/_stacktrace/products/$id/_layout/": {
      "filePath": "_stacktrace/products/$id/_layout/index.tsx",
      "parent": "/_stacktrace/products/$id/_layout"
    },
    "/_stacktrace/test-sets/$id/_layout/": {
      "filePath": "_stacktrace/test-sets/$id/_layout/index.tsx",
      "parent": "/_stacktrace/test-sets/$id/_layout"
    },
    "/_stacktrace/test-suites/$id/_layout/": {
      "filePath": "_stacktrace/test-suites/$id/_layout/index.tsx",
      "parent": "/_stacktrace/test-suites/$id/_layout"
    },
    "/_stacktrace/values/$id/_layout/": {
      "filePath": "_stacktrace/values/$id/_layout/index.tsx",
      "parent": "/_stacktrace/values/$id/_layout"
    },
    "/_staff/accesses/_layout/alerts/": {
      "filePath": "_staff/accesses/_layout/alerts/index.tsx",
      "parent": "/_staff/accesses/_layout"
    },
    "/_staff/accesses/_layout/list/": {
      "filePath": "_staff/accesses/_layout/list/index.tsx",
      "parent": "/_staff/accesses/_layout"
    },
    "/_staff/accesses/_layout/settings/": {
      "filePath": "_staff/accesses/_layout/settings/index.tsx",
      "parent": "/_staff/accesses/_layout"
    },
    "/_staff/attendance-core/_layout/archive/": {
      "filePath": "_staff/attendance-core/_layout/archive/index.tsx",
      "parent": "/_staff/attendance-core/_layout"
    },
    "/_staff/attendance-core/_layout/config/": {
      "filePath": "_staff/attendance-core/_layout/config/index.tsx",
      "parent": "/_staff/attendance-core/_layout"
    },
    "/_staff/attendance-core/_layout/dashboard/": {
      "filePath": "_staff/attendance-core/_layout/dashboard/index.tsx",
      "parent": "/_staff/attendance-core/_layout"
    },
    "/_staff/attendance-core/_layout/operation-packages/": {
      "filePath": "_staff/attendance-core/_layout/operation-packages/index.tsx",
      "parent": "/_staff/attendance-core/_layout"
    },
    "/_staff/attendance-engine/_layout/attendance-structures/": {
      "filePath": "_staff/attendance-engine/_layout/attendance-structures/index.tsx",
      "parent": "/_staff/attendance-engine/_layout"
    },
    "/_staff/attendance-engine/_layout/attendance-units/": {
      "filePath": "_staff/attendance-engine/_layout/attendance-units/index.tsx",
      "parent": "/_staff/attendance-engine/_layout"
    },
    "/_staff/attendance-engine/_layout/items/": {
      "filePath": "_staff/attendance-engine/_layout/items/index.tsx",
      "parent": "/_staff/attendance-engine/_layout"
    },
    "/_staff/attendance-engine/_layout/logic-components/": {
      "filePath": "_staff/attendance-engine/_layout/logic-components/index.tsx",
      "parent": "/_staff/attendance-engine/_layout"
    },
    "/_staff/attendances/_layout/alerts/": {
      "filePath": "_staff/attendances/_layout/alerts/index.tsx",
      "parent": "/_staff/attendances/_layout"
    },
    "/_staff/attendances/_layout/clocking-records/": {
      "filePath": "_staff/attendances/_layout/clocking-records/index.tsx",
      "parent": "/_staff/attendances/_layout"
    },
    "/_staff/attendances/_layout/employees/": {
      "filePath": "_staff/attendances/_layout/employees/index.tsx",
      "parent": "/_staff/attendances/_layout"
    },
    "/_staff/attendances/_layout/operation-activity/": {
      "filePath": "_staff/attendances/_layout/operation-activity/index.tsx",
      "parent": "/_staff/attendances/_layout"
    },
    "/_staff/attendances/_layout/overview/": {
      "filePath": "_staff/attendances/_layout/overview/index.tsx",
      "parent": "/_staff/attendances/_layout"
    },
    "/_staff/attendances/_layout/rule-and-policy/": {
      "filePath": "_staff/attendances/_layout/rule-and-policy/index.tsx",
      "parent": "/_staff/attendances/_layout"
    },
    "/_staff/attendances/_layout/settings/": {
      "filePath": "_staff/attendances/_layout/settings/index.tsx",
      "parent": "/_staff/attendances/_layout"
    },
    "/_staff/business-partner/_list/terminated/": {
      "filePath": "_staff/business-partner/_list/terminated/index.tsx",
      "parent": "/_staff/business-partner/_list"
    },
    "/_staff/business-partner/add/$businessPartnerType/": {
      "filePath": "_staff/business-partner/add/$businessPartnerType/index.tsx",
      "parent": "/_staff/business-partner"
    },
    "/_staff/certification/_list/people/": {
      "filePath": "_staff/certification/_list/people/index.tsx",
      "parent": "/_staff/certification/_list"
    },
    "/_staff/certification/_list/settings/": {
      "filePath": "_staff/certification/_list/settings/index.tsx",
      "parent": "/_staff/certification/_list/settings"
    },
    "/_staff/certification/add/$certificationKind/": {
      "filePath": "_staff/certification/add/$certificationKind/index.tsx",
      "parent": "/_staff/certification"
    },
    "/_staff/cockpit/approval/$id/": {
      "filePath": "_staff/cockpit/approval/$id/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/cockpit/task/$taskId/": {
      "filePath": "_staff/cockpit/task/$taskId/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/contract/add/subscription/": {
      "filePath": "_staff/contract/add/subscription/index.tsx",
      "parent": "/_staff/contract"
    },
    "/_staff/contract/import-csv/$contractType/": {
      "filePath": "_staff/contract/import-csv/$contractType/index.tsx",
      "parent": "/_staff/contract"
    },
    "/_staff/contractor-core/_packages/archives/": {
      "filePath": "_staff/contractor-core/_packages/archives/index.tsx",
      "parent": "/_staff/contractor-core/_packages"
    },
    "/_staff/contractor-core/_packages/configs/": {
      "filePath": "_staff/contractor-core/_packages/configs/index.tsx",
      "parent": "/_staff/contractor-core/_packages"
    },
    "/_staff/contractor-core/config/$patternId/": {
      "filePath": "_staff/contractor-core/config/$patternId/index.tsx",
      "parent": "/_staff/contractor-core"
    },
    "/_staff/deal/add/$direction/": {
      "filePath": "_staff/deal/add/$direction/index.tsx",
      "parent": "/_staff/deal"
    },
    "/_staff/device-catalog/add/$deviceType/": {
      "filePath": "_staff/device-catalog/add/$deviceType/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/devices/$id/_layout/": {
      "filePath": "_staff/devices/$id/_layout/index.tsx",
      "parent": "/_staff/devices/$id/_layout"
    },
    "/_staff/devices/_list/inventories/": {
      "filePath": "_staff/devices/_list/inventories/index.tsx",
      "parent": "/_staff/devices/_list"
    },
    "/_staff/devices/_list/inventory/": {
      "filePath": "_staff/devices/_list/inventory/index.tsx",
      "parent": "/_staff/devices/_list"
    },
    "/_staff/devices/_list/people/": {
      "filePath": "_staff/devices/_list/people/index.tsx",
      "parent": "/_staff/devices/_list"
    },
    "/_staff/devices/_list/settings/": {
      "filePath": "_staff/devices/_list/settings/index.tsx",
      "parent": "/_staff/devices/_list/settings"
    },
    "/_staff/devices/add/$deviceType/": {
      "filePath": "_staff/devices/add/$deviceType/index.tsx",
      "parent": "/_staff/devices"
    },
    "/_staff/devices/add/catalog/": {
      "filePath": "_staff/devices/add/catalog/index.tsx",
      "parent": "/_staff/devices"
    },
    "/_staff/equipment/_layout/alerts/": {
      "filePath": "_staff/equipment/_layout/alerts/index.tsx",
      "parent": "/_staff/equipment/_layout"
    },
    "/_staff/equipment/_layout/items/": {
      "filePath": "_staff/equipment/_layout/items/index.tsx",
      "parent": "/_staff/equipment/_layout"
    },
    "/_staff/equipment/_layout/settings/": {
      "filePath": "_staff/equipment/_layout/settings/index.tsx",
      "parent": "/_staff/equipment/_layout/settings"
    },
    "/_staff/fleets/_layout/_list/": {
      "filePath": "_staff/fleets/_layout/_list/index.tsx",
      "parent": "/_staff/fleets/_layout"
    },
    "/_staff/ga-operation-core/_packages/archives/": {
      "filePath": "_staff/ga-operation-core/_packages/archives/index.tsx",
      "parent": "/_staff/ga-operation-core/_packages"
    },
    "/_staff/ga-operation-core/_packages/configs/": {
      "filePath": "_staff/ga-operation-core/_packages/configs/index.tsx",
      "parent": "/_staff/ga-operation-core/_packages"
    },
    "/_staff/ga-operation-core/config/$patternId/": {
      "filePath": "_staff/ga-operation-core/config/$patternId/index.tsx",
      "parent": "/_staff/ga-operation-core"
    },
    "/_staff/ids/_layout/people/": {
      "filePath": "_staff/ids/_layout/people/index.tsx",
      "parent": "/_staff/ids/_layout"
    },
    "/_staff/ids/group-id/add/": {
      "filePath": "_staff/ids/group-id/add/index.tsx",
      "parent": "/_staff/ids"
    },
    "/_staff/it-operation-core/_root/archives/": {
      "filePath": "_staff/it-operation-core/_root/archives/index.tsx",
      "parent": "/_staff/it-operation-core/_root"
    },
    "/_staff/it-operation-core/_root/config/": {
      "filePath": "_staff/it-operation-core/_root/config/index.tsx",
      "parent": "/_staff/it-operation-core/_root"
    },
    "/_staff/it-operation-core/_root/in-house-packages/": {
      "filePath": "_staff/it-operation-core/_root/in-house-packages/index.tsx",
      "parent": "/_staff/it-operation-core/_root/in-house-packages"
    },
    "/_staff/it-operation-core/_root/packages/": {
      "filePath": "_staff/it-operation-core/_root/packages/index.tsx",
      "parent": "/_staff/it-operation-core/_root/packages"
    },
    "/_staff/it-operation-core/config/$patternId/": {
      "filePath": "_staff/it-operation-core/config/$patternId/index.tsx",
      "parent": "/_staff/it-operation-core"
    },
    "/_staff/it-operation-core/self-report-patterns/$patternId/": {
      "filePath": "_staff/it-operation-core/self-report-patterns/$patternId/index.tsx",
      "parent": "/_staff/it-operation-core"
    },
    "/_staff/labor-core/_packages/archives/": {
      "filePath": "_staff/labor-core/_packages/archives/index.tsx",
      "parent": "/_staff/labor-core/_packages"
    },
    "/_staff/labor-core/_packages/configs/": {
      "filePath": "_staff/labor-core/_packages/configs/index.tsx",
      "parent": "/_staff/labor-core/_packages"
    },
    "/_staff/labor-core/_packages/settings/": {
      "filePath": "_staff/labor-core/_packages/settings/index.tsx",
      "parent": "/_staff/labor-core/_packages/settings"
    },
    "/_staff/labor-core/config/$patternId/": {
      "filePath": "_staff/labor-core/config/$patternId/index.tsx",
      "parent": "/_staff/labor-core"
    },
    "/_staff/licenses/_list/alerts/": {
      "filePath": "_staff/licenses/_list/alerts/index.tsx",
      "parent": "/_staff/licenses/_list"
    },
    "/_staff/licenses/_list/contract-and-cost/": {
      "filePath": "_staff/licenses/_list/contract-and-cost/index.tsx",
      "parent": "/_staff/licenses/_list"
    },
    "/_staff/licenses/_list/inventory/": {
      "filePath": "_staff/licenses/_list/inventory/index.tsx",
      "parent": "/_staff/licenses/_list"
    },
    "/_staff/licenses/_list/operation-activity/": {
      "filePath": "_staff/licenses/_list/operation-activity/index.tsx",
      "parent": "/_staff/licenses/_list"
    },
    "/_staff/licenses/_list/people/": {
      "filePath": "_staff/licenses/_list/people/index.tsx",
      "parent": "/_staff/licenses/_list"
    },
    "/_staff/licenses/_list/rule-and-policy/": {
      "filePath": "_staff/licenses/_list/rule-and-policy/index.tsx",
      "parent": "/_staff/licenses/_list"
    },
    "/_staff/licenses/_list/settings/": {
      "filePath": "_staff/licenses/_list/settings/index.tsx",
      "parent": "/_staff/licenses/_list"
    },
    "/_staff/licenses/add/$allocationType/": {
      "filePath": "_staff/licenses/add/$allocationType/index.tsx",
      "parent": "/_staff/licenses"
    },
    "/_staff/marketplace/sales-orders/$orderId/": {
      "filePath": "_staff/marketplace/sales-orders/$orderId/index.tsx",
      "parent": "/_staff/marketplace"
    },
    "/_staff/organization/$id/_layout/": {
      "filePath": "_staff/organization/$id/_layout/index.tsx",
      "parent": "/_staff/organization/$id/_layout"
    },
    "/_staff/organization/_list/alert/": {
      "filePath": "_staff/organization/_list/alert/index.tsx",
      "parent": "/_staff/organization/_list"
    },
    "/_staff/organization/_list/chart/": {
      "filePath": "_staff/organization/_list/chart/index.tsx",
      "parent": "/_staff/organization/_list"
    },
    "/_staff/organization/_list/cost/": {
      "filePath": "_staff/organization/_list/cost/index.tsx",
      "parent": "/_staff/organization/_list"
    },
    "/_staff/organization/_list/history/": {
      "filePath": "_staff/organization/_list/history/index.tsx",
      "parent": "/_staff/organization/_list"
    },
    "/_staff/organization/_list/rule-policy/": {
      "filePath": "_staff/organization/_list/rule-policy/index.tsx",
      "parent": "/_staff/organization/_list"
    },
    "/_staff/organization/_list/settings/": {
      "filePath": "_staff/organization/_list/settings/index.tsx",
      "parent": "/_staff/organization/_list"
    },
    "/_staff/organization/plan/$id/": {
      "filePath": "_staff/organization/plan/$id/index.tsx",
      "parent": "/_staff/organization"
    },
    "/_staff/organization/plan/create/": {
      "filePath": "_staff/organization/plan/create/index.tsx",
      "parent": "/_staff/organization"
    },
    "/_staff/payroll-core/_layout/archive/": {
      "filePath": "_staff/payroll-core/_layout/archive/index.tsx",
      "parent": "/_staff/payroll-core/_layout"
    },
    "/_staff/payroll-core/_layout/config/": {
      "filePath": "_staff/payroll-core/_layout/config/index.tsx",
      "parent": "/_staff/payroll-core/_layout"
    },
    "/_staff/payroll-core/_layout/dashboard/": {
      "filePath": "_staff/payroll-core/_layout/dashboard/index.tsx",
      "parent": "/_staff/payroll-core/_layout"
    },
    "/_staff/payroll-core/_layout/operation-packages/": {
      "filePath": "_staff/payroll-core/_layout/operation-packages/index.tsx",
      "parent": "/_staff/payroll-core/_layout"
    },
    "/_staff/payroll-core/_layout/person-targets/": {
      "filePath": "_staff/payroll-core/_layout/person-targets/index.tsx",
      "parent": "/_staff/payroll-core/_layout"
    },
    "/_staff/payroll-engine/_layout/items/": {
      "filePath": "_staff/payroll-engine/_layout/items/index.tsx",
      "parent": "/_staff/payroll-engine/_layout"
    },
    "/_staff/payroll-engine/_layout/logic-components/": {
      "filePath": "_staff/payroll-engine/_layout/logic-components/index.tsx",
      "parent": "/_staff/payroll-engine/_layout"
    },
    "/_staff/payroll-engine/_layout/payroll-structures/": {
      "filePath": "_staff/payroll-engine/_layout/payroll-structures/index.tsx",
      "parent": "/_staff/payroll-engine/_layout"
    },
    "/_staff/payroll-engine/_layout/payroll-units/": {
      "filePath": "_staff/payroll-engine/_layout/payroll-units/index.tsx",
      "parent": "/_staff/payroll-engine/_layout"
    },
    "/_staff/payroll/_layout/alerts/": {
      "filePath": "_staff/payroll/_layout/alerts/index.tsx",
      "parent": "/_staff/payroll/_layout"
    },
    "/_staff/payroll/_layout/overview/": {
      "filePath": "_staff/payroll/_layout/overview/index.tsx",
      "parent": "/_staff/payroll/_layout"
    },
    "/_staff/payroll/_layout/pay-slips/": {
      "filePath": "_staff/payroll/_layout/pay-slips/index.tsx",
      "parent": "/_staff/payroll/_layout"
    },
    "/_staff/payroll/_layout/rule-and-policy/": {
      "filePath": "_staff/payroll/_layout/rule-and-policy/index.tsx",
      "parent": "/_staff/payroll/_layout"
    },
    "/_staff/payroll/_layout/settings/": {
      "filePath": "_staff/payroll/_layout/settings/index.tsx",
      "parent": "/_staff/payroll/_layout"
    },
    "/_staff/people/_list/alumni/": {
      "filePath": "_staff/people/_list/alumni/index.tsx",
      "parent": "/_staff/people/_list"
    },
    "/_staff/people/_list/operation-activity/": {
      "filePath": "_staff/people/_list/operation-activity/index.tsx",
      "parent": "/_staff/people/_list"
    },
    "/_staff/people/_list/settings/": {
      "filePath": "_staff/people/_list/settings/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/workforce/": {
      "filePath": "_staff/people/_list/workforce/index.tsx",
      "parent": "/_staff/people/_list"
    },
    "/_staff/person/add-person-certification/$certificationKind/": {
      "filePath": "_staff/person/add-person-certification/$certificationKind/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/person/add/$workerType/": {
      "filePath": "_staff/person/add/$workerType/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/person/automap-ingester/$workerType/": {
      "filePath": "_staff/person/automap-ingester/$workerType/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/places/_layout/settings/": {
      "filePath": "_staff/places/_layout/settings/index.tsx",
      "parent": "/_staff/places/_layout/settings"
    },
    "/_staff/profile/device/$id/": {
      "filePath": "_staff/profile/device/$id/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/public-ids/$id/details/": {
      "filePath": "_staff/public-ids/$id/details/index.tsx",
      "parent": "/_staff/public-ids/$id"
    },
    "/_staff/public-ids/$id/files/": {
      "filePath": "_staff/public-ids/$id/files/index.tsx",
      "parent": "/_staff/public-ids/$id"
    },
    "/_staff/public-ids/_list/alerts/": {
      "filePath": "_staff/public-ids/_list/alerts/index.tsx",
      "parent": "/_staff/public-ids/_list"
    },
    "/_staff/public-ids/_list/members/": {
      "filePath": "_staff/public-ids/_list/members/index.tsx",
      "parent": "/_staff/public-ids/_list"
    },
    "/_staff/public-ids/_list/operation-activity/": {
      "filePath": "_staff/public-ids/_list/operation-activity/index.tsx",
      "parent": "/_staff/public-ids/_list"
    },
    "/_staff/public-ids/_list/registry/": {
      "filePath": "_staff/public-ids/_list/registry/index.tsx",
      "parent": "/_staff/public-ids/_list"
    },
    "/_staff/public-ids/_list/rules-and-policies/": {
      "filePath": "_staff/public-ids/_list/rules-and-policies/index.tsx",
      "parent": "/_staff/public-ids/_list"
    },
    "/_staff/public-ids/_list/settings/": {
      "filePath": "_staff/public-ids/_list/settings/index.tsx",
      "parent": "/_staff/public-ids/_list"
    },
    "/_staff/settings/data-connector/inbound/": {
      "filePath": "_staff/settings/data-connector/inbound/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/settings/data-connector/outbound/": {
      "filePath": "_staff/settings/data-connector/outbound/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/settings/persons/invite/": {
      "filePath": "_staff/settings/persons/invite/index.tsx",
      "parent": "/_staff/settings/persons"
    },
    "/_staff/software/$id/_$id/": {
      "filePath": "_staff/software/$id/_$id/index.tsx",
      "parent": "/_staff/software/$id/_$id"
    },
    "/_staff/software/_layout/library/": {
      "filePath": "_staff/software/_layout/library/index.tsx",
      "parent": "/_staff/software/_layout"
    },
    "/_staff/software/_layout/operation-activity/": {
      "filePath": "_staff/software/_layout/operation-activity/index.tsx",
      "parent": "/_staff/software/_layout"
    },
    "/_staff/software/_layout/people/": {
      "filePath": "_staff/software/_layout/people/index.tsx",
      "parent": "/_staff/software/_layout/people"
    },
    "/_staff/software/_layout/registry/": {
      "filePath": "_staff/software/_layout/registry/index.tsx",
      "parent": "/_staff/software/_layout"
    },
    "/_staff/software/_layout/rule-and-policy/": {
      "filePath": "_staff/software/_layout/rule-and-policy/index.tsx",
      "parent": "/_staff/software/_layout"
    },
    "/_staff/software/_layout/settings/": {
      "filePath": "_staff/software/_layout/settings/index.tsx",
      "parent": "/_staff/software/_layout"
    },
    "/_staff/software/add/$type/": {
      "filePath": "_staff/software/add/$type/index.tsx",
      "parent": "/_staff/software"
    },
    "/_staff/starlinks/_layout/alerts/": {
      "filePath": "_staff/starlinks/_layout/alerts/index.tsx",
      "parent": "/_staff/starlinks/_layout"
    },
    "/_staff/starlinks/_layout/user-terminals/": {
      "filePath": "_staff/starlinks/_layout/user-terminals/index.tsx",
      "parent": "/_staff/starlinks/_layout"
    },
    "/_staff/storage-files/_list/files/": {
      "filePath": "_staff/storage-files/_list/files/index.tsx",
      "parent": "/_staff/storage-files/_list"
    },
    "/_staff/storage-files/_list/folders/": {
      "filePath": "_staff/storage-files/_list/folders/index.tsx",
      "parent": "/_staff/storage-files/_list"
    },
    "/_staff/storage-files/_list/settings/": {
      "filePath": "_staff/storage-files/_list/settings/index.tsx",
      "parent": "/_staff/storage-files/_list"
    },
    "/_staff/supplier/_list/settings/": {
      "filePath": "_staff/supplier/_list/settings/index.tsx",
      "parent": "/_staff/supplier/_list/settings"
    },
    "/_staff/time-and-attendance/_layout/attendance-links/": {
      "filePath": "_staff/time-and-attendance/_layout/attendance-links/index.tsx",
      "parent": "/_staff/time-and-attendance/_layout"
    },
    "/_staff/equipment/$id/_layout/": {
      "filePath": "_staff/equipment/$id/_layout/index.lazy.tsx",
      "parent": "/_staff/equipment/$id/_layout"
    },
    "/_staff/licenses/$id/_profile/": {
      "filePath": "_staff/licenses/$id/_profile/index.lazy.tsx",
      "parent": "/_staff/licenses/$id/_profile"
    },
    "/_individual/individual/_profile/my-profile/_layout/": {
      "filePath": "_individual/individual/_profile/my-profile/_layout/index/route.tsx",
      "parent": "/_individual/individual/_profile/my-profile/_layout"
    },
    "/_staff/person/alumni/$id/_profile/": {
      "filePath": "_staff/person/alumni/$id/_profile/index/route.tsx",
      "parent": "/_staff/person/alumni/$id/_profile"
    },
    "/_staff/contract/$id/_layout/_placeholders/approval-info": {
      "filePath": "_staff/contract/$id/_layout/_placeholders/approval-info/route.tsx",
      "parent": "/_staff/contract/$id/_layout"
    },
    "/_staff/contract/$id/_layout/_placeholders/history": {
      "filePath": "_staff/contract/$id/_layout/_placeholders/history/route.tsx",
      "parent": "/_staff/contract/$id/_layout"
    },
    "/_staff/contract/$id/_layout/_placeholders/operation-activity": {
      "filePath": "_staff/contract/$id/_layout/_placeholders/operation-activity/route.tsx",
      "parent": "/_staff/contract/$id/_layout"
    },
    "/_staff/contract/$id/_layout/_placeholders/risk-provisions": {
      "filePath": "_staff/contract/$id/_layout/_placeholders/risk-provisions/route.tsx",
      "parent": "/_staff/contract/$id/_layout"
    },
    "/_staff/contract/$id/_layout/_placeholders/rule-and-policy": {
      "filePath": "_staff/contract/$id/_layout/_placeholders/rule-and-policy/route.tsx",
      "parent": "/_staff/contract/$id/_layout"
    },
    "/_stacktrace/products/$id/scope/$nodeId": {
      "filePath": "_stacktrace/products/$id/scope/$nodeId",
      "parent": "/_stacktrace/products/$id",
      "children": [
        "/_stacktrace/products/$id/scope/$nodeId/_layout"
      ]
    },
    "/_stacktrace/products/$id/scope/$nodeId/_layout": {
      "filePath": "_stacktrace/products/$id/scope/$nodeId/_layout.tsx",
      "parent": "/_stacktrace/products/$id/scope/$nodeId",
      "children": [
        "/_stacktrace/products/$id/scope/$nodeId/_layout/",
        "/_stacktrace/products/$id/scope/$nodeId/_layout/value/"
      ]
    },
    "/_stacktrace/test-suites/$id/_layout/test-plan": {
      "filePath": "_stacktrace/test-suites/$id/_layout/test-plan",
      "parent": "/_stacktrace/test-suites/$id/_layout",
      "children": [
        "/_stacktrace/test-suites/$id/_layout/test-plan/_layout"
      ]
    },
    "/_stacktrace/test-suites/$id/_layout/test-plan/_layout": {
      "filePath": "_stacktrace/test-suites/$id/_layout/test-plan/_layout.tsx",
      "parent": "/_stacktrace/test-suites/$id/_layout/test-plan",
      "children": [
        "/_stacktrace/test-suites/$id/_layout/test-plan/_layout/"
      ]
    },
    "/_stacktrace/test-suites/$id/_layout/test-review": {
      "filePath": "_stacktrace/test-suites/$id/_layout/test-review",
      "parent": "/_stacktrace/test-suites/$id/_layout",
      "children": [
        "/_stacktrace/test-suites/$id/_layout/test-review/_layout"
      ]
    },
    "/_stacktrace/test-suites/$id/_layout/test-review/_layout": {
      "filePath": "_stacktrace/test-suites/$id/_layout/test-review/_layout.tsx",
      "parent": "/_stacktrace/test-suites/$id/_layout/test-review",
      "children": [
        "/_stacktrace/test-suites/$id/_layout/test-review/_layout/"
      ]
    },
    "/_staff/attendance-engine/_layout/attendance-structures/$structureId": {
      "filePath": "_staff/attendance-engine/_layout/attendance-structures/$structureId",
      "parent": "/_staff/attendance-engine/_layout",
      "children": [
        "/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout"
      ]
    },
    "/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout": {
      "filePath": "_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout.tsx",
      "parent": "/_staff/attendance-engine/_layout/attendance-structures/$structureId",
      "children": [
        "/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout/",
        "/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout/structure/"
      ]
    },
    "/_staff/business-partner/$id/_layout/bp-role-info": {
      "filePath": "_staff/business-partner/$id/_layout/bp-role-info",
      "parent": "/_staff/business-partner/$id/_layout",
      "children": [
        "/_staff/business-partner/$id/_layout/bp-role-info/_layout"
      ]
    },
    "/_staff/business-partner/$id/_layout/bp-role-info/_layout": {
      "filePath": "_staff/business-partner/$id/_layout/bp-role-info/_layout.tsx",
      "parent": "/_staff/business-partner/$id/_layout/bp-role-info",
      "children": [
        "/_staff/business-partner/$id/_layout/bp-role-info/_layout/",
        "/_staff/business-partner/$id/_layout/bp-role-info/_layout/$bpRole/"
      ]
    },
    "/_staff/devices/add/catalog/$deviceType/completed": {
      "filePath": "_staff/devices/add/catalog/$deviceType/completed.tsx",
      "parent": "/_staff/devices"
    },
    "/_staff/ids/group-id/add/from-scratch/completed": {
      "filePath": "_staff/ids/group-id/add/from-scratch/completed.tsx",
      "parent": "/_staff/ids"
    },
    "/_staff/it-operation-core/_detail/operation-instances/$instanceId": {
      "filePath": "_staff/it-operation-core/_detail/operation-instances/$instanceId",
      "parent": "/_staff/it-operation-core/_detail",
      "children": [
        "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout",
        "/_staff/it-operation-core/_detail/operation-instances/$instanceId/"
      ]
    },
    "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout": {
      "filePath": "_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout.tsx",
      "parent": "/_staff/it-operation-core/_detail/operation-instances/$instanceId",
      "children": [
        "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/data/",
        "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/detail/",
        "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/operation-activity/"
      ]
    },
    "/_staff/it-operation-core/_root/in-house-packages/$packageId/start-targets": {
      "filePath": "_staff/it-operation-core/_root/in-house-packages/$packageId/start-targets.tsx",
      "parent": "/_staff/it-operation-core/_root/in-house-packages/$packageId"
    },
    "/_staff/licenses/$id/service-plans/$licenseServiceId": {
      "filePath": "_staff/licenses/$id/service-plans/$licenseServiceId",
      "parent": "/_staff/licenses/$id",
      "children": [
        "/_staff/licenses/$id/service-plans/$licenseServiceId/_detail"
      ]
    },
    "/_staff/licenses/$id/service-plans/$licenseServiceId/_detail": {
      "filePath": "_staff/licenses/$id/service-plans/$licenseServiceId/_detail.tsx",
      "parent": "/_staff/licenses/$id/service-plans/$licenseServiceId",
      "children": [
        "/_staff/licenses/$id/service-plans/$licenseServiceId/_detail/accounts/"
      ]
    },
    "/_staff/marketplace/sent-orders/$orderId/_layout/activities": {
      "filePath": "_staff/marketplace/sent-orders/$orderId/_layout/activities.tsx",
      "parent": "/_staff/marketplace/sent-orders/$orderId/_layout"
    },
    "/_staff/payroll-engine/_layout/payroll-structures/$structureId": {
      "filePath": "_staff/payroll-engine/_layout/payroll-structures/$structureId",
      "parent": "/_staff/payroll-engine/_layout",
      "children": [
        "/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout"
      ]
    },
    "/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout": {
      "filePath": "_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout.tsx",
      "parent": "/_staff/payroll-engine/_layout/payroll-structures/$structureId",
      "children": [
        "/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout/",
        "/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout/structure/"
      ]
    },
    "/_staff/settings/data-connector/inbound/aggregate-data-pipeline": {
      "filePath": "_staff/settings/data-connector/inbound/aggregate-data-pipeline",
      "parent": "/_staff",
      "children": [
        "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/_list",
        "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id",
        "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/add/"
      ]
    },
    "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/_list": {
      "filePath": "_staff/settings/data-connector/inbound/aggregate-data-pipeline/_list.tsx",
      "parent": "/_staff/settings/data-connector/inbound/aggregate-data-pipeline",
      "children": [
        "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/_list/"
      ]
    },
    "/_staff/settings/data-connector/inbound/data-pipeline": {
      "filePath": "_staff/settings/data-connector/inbound/data-pipeline",
      "parent": "/_staff",
      "children": [
        "/_staff/settings/data-connector/inbound/data-pipeline/_list",
        "/_staff/settings/data-connector/inbound/data-pipeline/$id",
        "/_staff/settings/data-connector/inbound/data-pipeline/add/"
      ]
    },
    "/_staff/settings/data-connector/inbound/data-pipeline/_list": {
      "filePath": "_staff/settings/data-connector/inbound/data-pipeline/_list.tsx",
      "parent": "/_staff/settings/data-connector/inbound/data-pipeline",
      "children": [
        "/_staff/settings/data-connector/inbound/data-pipeline/_list/"
      ]
    },
    "/_staff/settings/data-connector/outbound/data-pipeline": {
      "filePath": "_staff/settings/data-connector/outbound/data-pipeline",
      "parent": "/_staff",
      "children": [
        "/_staff/settings/data-connector/outbound/data-pipeline/_list",
        "/_staff/settings/data-connector/outbound/data-pipeline/$id",
        "/_staff/settings/data-connector/outbound/data-pipeline/add/"
      ]
    },
    "/_staff/settings/data-connector/outbound/data-pipeline/_list": {
      "filePath": "_staff/settings/data-connector/outbound/data-pipeline/_list.tsx",
      "parent": "/_staff/settings/data-connector/outbound/data-pipeline",
      "children": [
        "/_staff/settings/data-connector/outbound/data-pipeline/_list/"
      ]
    },
    "/_staff/software/$id/_$id/contract-and-cost": {
      "filePath": "_staff/software/$id/_$id/contract-and-cost",
      "parent": "/_staff/software/$id/_$id",
      "children": [
        "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost"
      ]
    },
    "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost": {
      "filePath": "_staff/software/$id/_$id/contract-and-cost/_contract-and-cost.tsx",
      "parent": "/_staff/software/$id/_$id/contract-and-cost",
      "children": [
        "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/",
        "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal",
        "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/cost/",
        "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/payment/",
        "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/cost/$period/",
        "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/payment/$period/"
      ]
    },
    "/_individual/individual/portal/lookup/clocking-record/alerts": {
      "filePath": "_individual/individual/portal/lookup/clocking-record/alerts.lazy.tsx",
      "parent": "/_individual/individual/portal/lookup/clocking-record"
    },
    "/_individual/individual/portal/lookup/clocking-record/files": {
      "filePath": "_individual/individual/portal/lookup/clocking-record/files.lazy.tsx",
      "parent": "/_individual/individual/portal/lookup/clocking-record"
    },
    "/_individual/individual/portal/lookup/clocking-record/overview": {
      "filePath": "_individual/individual/portal/lookup/clocking-record/overview.lazy.tsx",
      "parent": "/_individual/individual/portal/lookup/clocking-record"
    },
    "/_individual/individual/portal/lookup/clocking-record/schedule": {
      "filePath": "_individual/individual/portal/lookup/clocking-record/schedule.lazy.tsx",
      "parent": "/_individual/individual/portal/lookup/clocking-record"
    },
    "/_individual/individual/portal/lookup/pay-slip/alerts": {
      "filePath": "_individual/individual/portal/lookup/pay-slip/alerts.lazy.tsx",
      "parent": "/_individual/individual/portal/lookup/pay-slip"
    },
    "/_individual/individual/portal/lookup/pay-slip/files": {
      "filePath": "_individual/individual/portal/lookup/pay-slip/files.lazy.tsx",
      "parent": "/_individual/individual/portal/lookup/pay-slip"
    },
    "/_individual/individual/portal/lookup/pay-slip/history": {
      "filePath": "_individual/individual/portal/lookup/pay-slip/history.lazy.tsx",
      "parent": "/_individual/individual/portal/lookup/pay-slip"
    },
    "/_individual/individual/portal/lookup/pay-slip/overview": {
      "filePath": "_individual/individual/portal/lookup/pay-slip/overview.lazy.tsx",
      "parent": "/_individual/individual/portal/lookup/pay-slip"
    },
    "/_staff/attendances/_layout/clocking-records/$employeeId/alerts": {
      "filePath": "_staff/attendances/_layout/clocking-records/$employeeId/alerts.lazy.tsx",
      "parent": "/_staff/attendances/_layout/clocking-records/$employeeId"
    },
    "/_staff/attendances/_layout/clocking-records/$employeeId/files": {
      "filePath": "_staff/attendances/_layout/clocking-records/$employeeId/files.lazy.tsx",
      "parent": "/_staff/attendances/_layout/clocking-records/$employeeId"
    },
    "/_staff/attendances/_layout/clocking-records/$employeeId/overview": {
      "filePath": "_staff/attendances/_layout/clocking-records/$employeeId/overview.lazy.tsx",
      "parent": "/_staff/attendances/_layout/clocking-records/$employeeId"
    },
    "/_staff/attendances/_layout/clocking-records/$employeeId/schedule": {
      "filePath": "_staff/attendances/_layout/clocking-records/$employeeId/schedule.lazy.tsx",
      "parent": "/_staff/attendances/_layout/clocking-records/$employeeId"
    },
    "/_staff/attendances/_layout/clocking-records/$employeeId/settings": {
      "filePath": "_staff/attendances/_layout/clocking-records/$employeeId/settings.lazy.tsx",
      "parent": "/_staff/attendances/_layout/clocking-records/$employeeId"
    },
    "/_staff/payroll/_layout/pay-slips/$employeeId/alerts": {
      "filePath": "_staff/payroll/_layout/pay-slips/$employeeId/alerts.lazy.tsx",
      "parent": "/_staff/payroll/_layout/pay-slips/$employeeId"
    },
    "/_staff/payroll/_layout/pay-slips/$employeeId/files": {
      "filePath": "_staff/payroll/_layout/pay-slips/$employeeId/files.lazy.tsx",
      "parent": "/_staff/payroll/_layout/pay-slips/$employeeId"
    },
    "/_staff/payroll/_layout/pay-slips/$employeeId/history": {
      "filePath": "_staff/payroll/_layout/pay-slips/$employeeId/history.lazy.tsx",
      "parent": "/_staff/payroll/_layout/pay-slips/$employeeId"
    },
    "/_staff/payroll/_layout/pay-slips/$employeeId/overview": {
      "filePath": "_staff/payroll/_layout/pay-slips/$employeeId/overview.lazy.tsx",
      "parent": "/_staff/payroll/_layout/pay-slips/$employeeId"
    },
    "/_staff/payroll/_layout/pay-slips/$employeeId/settings": {
      "filePath": "_staff/payroll/_layout/pay-slips/$employeeId/settings.lazy.tsx",
      "parent": "/_staff/payroll/_layout/pay-slips/$employeeId"
    },
    "/_individual/individual/task/$id/approval/": {
      "filePath": "_individual/individual/task/$id/approval/index.tsx",
      "parent": "/_individual/individual"
    },
    "/_stacktrace/development-tickets/$ticketId/_layout/history/": {
      "filePath": "_stacktrace/development-tickets/$ticketId/_layout/history/index.tsx",
      "parent": "/_stacktrace/development-tickets/$ticketId/_layout"
    },
    "/_stacktrace/issues/$id/_layout/history/": {
      "filePath": "_stacktrace/issues/$id/_layout/history/index.tsx",
      "parent": "/_stacktrace/issues/$id/_layout"
    },
    "/_stacktrace/product-roadmap/$roadmapId/_layout/detail/": {
      "filePath": "_stacktrace/product-roadmap/$roadmapId/_layout/detail/index.tsx",
      "parent": "/_stacktrace/product-roadmap/$roadmapId/_layout"
    },
    "/_stacktrace/product-roadmap/$roadmapId/_layout/history/": {
      "filePath": "_stacktrace/product-roadmap/$roadmapId/_layout/history/index.tsx",
      "parent": "/_stacktrace/product-roadmap/$roadmapId/_layout"
    },
    "/_stacktrace/production/$productionId/_layout/dev-scope/": {
      "filePath": "_stacktrace/production/$productionId/_layout/dev-scope/index.tsx",
      "parent": "/_stacktrace/production/$productionId/_layout"
    },
    "/_stacktrace/production/$productionId/_layout/issue-scope/": {
      "filePath": "_stacktrace/production/$productionId/_layout/issue-scope/index.tsx",
      "parent": "/_stacktrace/production/$productionId/_layout"
    },
    "/_stacktrace/production/$productionId/_layout/product-scope/": {
      "filePath": "_stacktrace/production/$productionId/_layout/product-scope/index.tsx",
      "parent": "/_stacktrace/production/$productionId/_layout"
    },
    "/_stacktrace/production/$productionId/_layout/quality-scope/": {
      "filePath": "_stacktrace/production/$productionId/_layout/quality-scope/index.tsx",
      "parent": "/_stacktrace/production/$productionId/_layout"
    },
    "/_stacktrace/production/$productionId/_layout/value/": {
      "filePath": "_stacktrace/production/$productionId/_layout/value/index.tsx",
      "parent": "/_stacktrace/production/$productionId/_layout"
    },
    "/_stacktrace/products/$id/_layout/product-scope/": {
      "filePath": "_stacktrace/products/$id/_layout/product-scope/index.tsx",
      "parent": "/_stacktrace/products/$id/_layout"
    },
    "/_stacktrace/test-sets/$id/_layout/conditions/": {
      "filePath": "_stacktrace/test-sets/$id/_layout/conditions/index.tsx",
      "parent": "/_stacktrace/test-sets/$id/_layout"
    },
    "/_stacktrace/test-sets/$id/_layout/target-functions/": {
      "filePath": "_stacktrace/test-sets/$id/_layout/target-functions/index.tsx",
      "parent": "/_stacktrace/test-sets/$id/_layout"
    },
    "/_stacktrace/test-suites/$id/_layout/document/": {
      "filePath": "_stacktrace/test-suites/$id/_layout/document/index.tsx",
      "parent": "/_stacktrace/test-suites/$id/_layout"
    },
    "/_stacktrace/test-suites/$id/_layout/issues/": {
      "filePath": "_stacktrace/test-suites/$id/_layout/issues/index.tsx",
      "parent": "/_stacktrace/test-suites/$id/_layout"
    },
    "/_stacktrace/test-suites/$id/_layout/overview/": {
      "filePath": "_stacktrace/test-suites/$id/_layout/overview/index.tsx",
      "parent": "/_stacktrace/test-suites/$id/_layout"
    },
    "/_stacktrace/test-suites/$id/_layout/target-functions/": {
      "filePath": "_stacktrace/test-suites/$id/_layout/target-functions/index.tsx",
      "parent": "/_stacktrace/test-suites/$id/_layout"
    },
    "/_stacktrace/test-suites/$id/_layout/test-set/": {
      "filePath": "_stacktrace/test-suites/$id/_layout/test-set/index.tsx",
      "parent": "/_stacktrace/test-suites/$id/_layout"
    },
    "/_stacktrace/values/$id/_layout/history/": {
      "filePath": "_stacktrace/values/$id/_layout/history/index.tsx",
      "parent": "/_stacktrace/values/$id/_layout"
    },
    "/_stacktrace/values/$id/_layout/product-scope/": {
      "filePath": "_stacktrace/values/$id/_layout/product-scope/index.tsx",
      "parent": "/_stacktrace/values/$id/_layout"
    },
    "/_staff/accesses/_layout/list/$traceableAppId/": {
      "filePath": "_staff/accesses/_layout/list/$traceableAppId/index.tsx",
      "parent": "/_staff/accesses/_layout"
    },
    "/_staff/attendance-engine/_layout/attendance-units/$unitId/": {
      "filePath": "_staff/attendance-engine/_layout/attendance-units/$unitId/index.tsx",
      "parent": "/_staff/attendance-engine/_layout"
    },
    "/_staff/attendance-engine/_layout/items/$componentId/": {
      "filePath": "_staff/attendance-engine/_layout/items/$componentId/index.tsx",
      "parent": "/_staff/attendance-engine/_layout"
    },
    "/_staff/attendance-engine/_layout/logic-components/$componentId/": {
      "filePath": "_staff/attendance-engine/_layout/logic-components/$componentId/index.tsx",
      "parent": "/_staff/attendance-engine/_layout"
    },
    "/_staff/business-partner/$id/_layout/_index/": {
      "filePath": "_staff/business-partner/$id/_layout/_index/index.tsx",
      "parent": "/_staff/business-partner/$id/_layout"
    },
    "/_staff/business-partner/$id/_layout/address-and-contact/": {
      "filePath": "_staff/business-partner/$id/_layout/address-and-contact/index.tsx",
      "parent": "/_staff/business-partner/$id/_layout"
    },
    "/_staff/certification/$id/_layout/_index/": {
      "filePath": "_staff/certification/$id/_layout/_index/index.tsx",
      "parent": "/_staff/certification/$id/_layout"
    },
    "/_staff/certification/$id/_layout/certification-holders/": {
      "filePath": "_staff/certification/$id/_layout/certification-holders/index.tsx",
      "parent": "/_staff/certification/$id/_layout"
    },
    "/_staff/certification/$id/_layout/handling-certifications/": {
      "filePath": "_staff/certification/$id/_layout/handling-certifications/index.tsx",
      "parent": "/_staff/certification/$id/_layout"
    },
    "/_staff/certification/$id/_layout/specialty-certifications/": {
      "filePath": "_staff/certification/$id/_layout/specialty-certifications/index.tsx",
      "parent": "/_staff/certification/$id/_layout"
    },
    "/_staff/certification/_list/settings/issuing-organization/": {
      "filePath": "_staff/certification/_list/settings/issuing-organization/index.tsx",
      "parent": "/_staff/certification/_list/settings"
    },
    "/_staff/certification/_list/settings/specialty-category-level/": {
      "filePath": "_staff/certification/_list/settings/specialty-category-level/index.tsx",
      "parent": "/_staff/certification/_list/settings"
    },
    "/_staff/certification/_list/settings/specialty-category/": {
      "filePath": "_staff/certification/_list/settings/specialty-category/index.tsx",
      "parent": "/_staff/certification/_list/settings"
    },
    "/_staff/deal/$dealId/_layout/_index/": {
      "filePath": "_staff/deal/$dealId/_layout/_index/index.tsx",
      "parent": "/_staff/deal/$dealId/_layout"
    },
    "/_staff/devices/$id/_layout/control/": {
      "filePath": "_staff/devices/$id/_layout/control/index.tsx",
      "parent": "/_staff/devices/$id/_layout"
    },
    "/_staff/devices/$id/_layout/files/": {
      "filePath": "_staff/devices/$id/_layout/files/index.tsx",
      "parent": "/_staff/devices/$id/_layout"
    },
    "/_staff/devices/$id/_layout/history/": {
      "filePath": "_staff/devices/$id/_layout/history/index.tsx",
      "parent": "/_staff/devices/$id/_layout"
    },
    "/_staff/devices/$id/_layout/lifecycle/": {
      "filePath": "_staff/devices/$id/_layout/lifecycle/index.tsx",
      "parent": "/_staff/devices/$id/_layout"
    },
    "/_staff/devices/$id/_layout/mdm/": {
      "filePath": "_staff/devices/$id/_layout/mdm/index.tsx",
      "parent": "/_staff/devices/$id/_layout"
    },
    "/_staff/devices/$id/_layout/profile/": {
      "filePath": "_staff/devices/$id/_layout/profile/index.tsx",
      "parent": "/_staff/devices/$id/_layout"
    },
    "/_staff/devices/$id/_layout/status/": {
      "filePath": "_staff/devices/$id/_layout/status/index.tsx",
      "parent": "/_staff/devices/$id/_layout"
    },
    "/_staff/devices/_list/contract-and-cost/_contract-and-cost/": {
      "filePath": "_staff/devices/_list/contract-and-cost/_contract-and-cost/index.tsx",
      "parent": "/_staff/devices/_list/contract-and-cost/_contract-and-cost"
    },
    "/_staff/devices/_list/settings/catalog/": {
      "filePath": "_staff/devices/_list/settings/catalog/index.tsx",
      "parent": "/_staff/devices/_list/settings"
    },
    "/_staff/devices/add/catalog/$deviceType/": {
      "filePath": "_staff/devices/add/catalog/$deviceType/index.tsx",
      "parent": "/_staff/devices"
    },
    "/_staff/devices/external-it-saas/$appIntegrationId/preview/": {
      "filePath": "_staff/devices/external-it-saas/$appIntegrationId/preview/index.tsx",
      "parent": "/_staff/devices"
    },
    "/_staff/equipment/_layout/settings/equipment-items/": {
      "filePath": "_staff/equipment/_layout/settings/equipment-items/index.tsx",
      "parent": "/_staff/equipment/_layout/settings"
    },
    "/_staff/equipment/_layout/settings/equipment-types/": {
      "filePath": "_staff/equipment/_layout/settings/equipment-types/index.tsx",
      "parent": "/_staff/equipment/_layout/settings"
    },
    "/_staff/equipment/items/$id/_detail/": {
      "filePath": "_staff/equipment/items/$id/_detail/index.tsx",
      "parent": "/_staff/equipment/items/$id/_detail"
    },
    "/_staff/ids/group-id/$id/_$id/": {
      "filePath": "_staff/ids/group-id/$id/_$id/index.tsx",
      "parent": "/_staff/ids/group-id/$id/_$id"
    },
    "/_staff/ids/group-id/add/from-scratch/": {
      "filePath": "_staff/ids/group-id/add/from-scratch/index.tsx",
      "parent": "/_staff/ids"
    },
    "/_staff/it-operation-core/_detail/operation-instances/$instanceId/": {
      "filePath": "_staff/it-operation-core/_detail/operation-instances/$instanceId/index.tsx",
      "parent": "/_staff/it-operation-core/_detail/operation-instances/$instanceId"
    },
    "/_staff/licenses/$id/_profile/assignments/": {
      "filePath": "_staff/licenses/$id/_profile/assignments/index.tsx",
      "parent": "/_staff/licenses/$id/_profile"
    },
    "/_staff/licenses/$id/_profile/people/": {
      "filePath": "_staff/licenses/$id/_profile/people/index.tsx",
      "parent": "/_staff/licenses/$id/_profile"
    },
    "/_staff/licenses/$id/_profile/rule-and-policy/": {
      "filePath": "_staff/licenses/$id/_profile/rule-and-policy/index.tsx",
      "parent": "/_staff/licenses/$id/_profile"
    },
    "/_staff/licenses/$id/_profile/service-plans/": {
      "filePath": "_staff/licenses/$id/_profile/service-plans/index.tsx",
      "parent": "/_staff/licenses/$id/_profile"
    },
    "/_staff/marketplace/_store/store/devices/": {
      "filePath": "_staff/marketplace/_store/store/devices/index.tsx",
      "parent": "/_staff/marketplace/_store"
    },
    "/_staff/marketplace/_store/store/licenses/": {
      "filePath": "_staff/marketplace/_store/store/licenses/index.tsx",
      "parent": "/_staff/marketplace/_store"
    },
    "/_staff/marketplace/_store/store/sales-orders/": {
      "filePath": "_staff/marketplace/_store/store/sales-orders/index.tsx",
      "parent": "/_staff/marketplace/_store"
    },
    "/_staff/marketplace/_store/store/sent-orders/": {
      "filePath": "_staff/marketplace/_store/store/sent-orders/index.tsx",
      "parent": "/_staff/marketplace/_store"
    },
    "/_staff/marketplace/_store/store/starlinks/": {
      "filePath": "_staff/marketplace/_store/store/starlinks/index.tsx",
      "parent": "/_staff/marketplace/_store"
    },
    "/_staff/marketplace/sent-orders/$orderId/_layout/": {
      "filePath": "_staff/marketplace/sent-orders/$orderId/_layout/index.tsx",
      "parent": "/_staff/marketplace/sent-orders/$orderId/_layout"
    },
    "/_staff/organization/$id/_layout/history/": {
      "filePath": "_staff/organization/$id/_layout/history/index.tsx",
      "parent": "/_staff/organization/$id/_layout"
    },
    "/_staff/organization/plan/$id/add/": {
      "filePath": "_staff/organization/plan/$id/add/index.tsx",
      "parent": "/_staff/organization"
    },
    "/_staff/organization/plan/$id/transfers/": {
      "filePath": "_staff/organization/plan/$id/transfers/index.tsx",
      "parent": "/_staff/organization"
    },
    "/_staff/payroll-engine/_layout/items/$componentId/": {
      "filePath": "_staff/payroll-engine/_layout/items/$componentId/index.tsx",
      "parent": "/_staff/payroll-engine/_layout"
    },
    "/_staff/payroll-engine/_layout/logic-components/$componentId/": {
      "filePath": "_staff/payroll-engine/_layout/logic-components/$componentId/index.tsx",
      "parent": "/_staff/payroll-engine/_layout"
    },
    "/_staff/payroll-engine/_layout/payroll-units/$unitId/": {
      "filePath": "_staff/payroll-engine/_layout/payroll-units/$unitId/index.tsx",
      "parent": "/_staff/payroll-engine/_layout"
    },
    "/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/": {
      "filePath": "_staff/payroll/_layout/contract-and-cost/_contract-and-cost/index.tsx",
      "parent": "/_staff/payroll/_layout/contract-and-cost/_contract-and-cost"
    },
    "/_staff/people/_list/settings/board-member-types/": {
      "filePath": "_staff/people/_list/settings/board-member-types/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/collaborator-types/": {
      "filePath": "_staff/people/_list/settings/collaborator-types/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/contract-end-reasons/": {
      "filePath": "_staff/people/_list/settings/contract-end-reasons/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/contractor-types/": {
      "filePath": "_staff/people/_list/settings/contractor-types/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/employee-sub-id-names/": {
      "filePath": "_staff/people/_list/settings/employee-sub-id-names/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/employment-types/": {
      "filePath": "_staff/people/_list/settings/employment-types/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/grades/": {
      "filePath": "_staff/people/_list/settings/grades/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/health-insurance-associations/": {
      "filePath": "_staff/people/_list/settings/health-insurance-associations/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/job-competencies/": {
      "filePath": "_staff/people/_list/settings/job-competencies/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/job-functions/": {
      "filePath": "_staff/people/_list/settings/job-functions/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/job-grades/": {
      "filePath": "_staff/people/_list/settings/job-grades/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/job-levels/": {
      "filePath": "_staff/people/_list/settings/job-levels/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/job-titles/": {
      "filePath": "_staff/people/_list/settings/job-titles/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/job-types/": {
      "filePath": "_staff/people/_list/settings/job-types/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/place-social-insurances/": {
      "filePath": "_staff/people/_list/settings/place-social-insurances/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/positions/": {
      "filePath": "_staff/people/_list/settings/positions/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/retirement-reasons/": {
      "filePath": "_staff/people/_list/settings/retirement-reasons/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/work-mode/": {
      "filePath": "_staff/people/_list/settings/work-mode/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/person/$id/_profile/apps/": {
      "filePath": "_staff/person/$id/_profile/apps/index.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_staff/person/$id/_profile/contractor-information/": {
      "filePath": "_staff/person/$id/_profile/contractor-information/index.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_staff/person/$id/_profile/devices/": {
      "filePath": "_staff/person/$id/_profile/devices/index.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_staff/person/$id/_profile/education-and-qualification/": {
      "filePath": "_staff/person/$id/_profile/education-and-qualification/index.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_staff/person/$id/_profile/employee-information/": {
      "filePath": "_staff/person/$id/_profile/employee-information/index.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_staff/person/$id/_profile/equipment/": {
      "filePath": "_staff/person/$id/_profile/equipment/index.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_staff/person/$id/_profile/history/": {
      "filePath": "_staff/person/$id/_profile/history/index.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_staff/person/$id/_profile/operation-activity/": {
      "filePath": "_staff/person/$id/_profile/operation-activity/index.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_staff/person/$id/_profile/personal-information/": {
      "filePath": "_staff/person/$id/_profile/personal-information/index.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_staff/person/$id/_profile/public-id/": {
      "filePath": "_staff/person/$id/_profile/public-id/index.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_staff/person/external-hr-saas/$appIntegrationId/preview/": {
      "filePath": "_staff/person/external-hr-saas/$appIntegrationId/preview/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/places/$id/_layout/administrators/": {
      "filePath": "_staff/places/$id/_layout/administrators/index.tsx",
      "parent": "/_staff/places/$id/_layout"
    },
    "/_staff/places/$id/_layout/labor-core/": {
      "filePath": "_staff/places/$id/_layout/labor-core/index.tsx",
      "parent": "/_staff/places/$id/_layout"
    },
    "/_staff/places/_layout/settings/place-sub-codes/": {
      "filePath": "_staff/places/_layout/settings/place-sub-codes/index.tsx",
      "parent": "/_staff/places/_layout/settings"
    },
    "/_staff/settings/contracting-corporation-profile/_layout/board-member/": {
      "filePath": "_staff/settings/contracting-corporation-profile/_layout/board-member/index.tsx",
      "parent": "/_staff/settings/contracting-corporation-profile/_layout"
    },
    "/_staff/settings/contracting-corporation-profile/_layout/contact-points/": {
      "filePath": "_staff/settings/contracting-corporation-profile/_layout/contact-points/index.tsx",
      "parent": "/_staff/settings/contracting-corporation-profile/_layout"
    },
    "/_staff/settings/contracting-corporation-profile/_layout/corporate-overview/": {
      "filePath": "_staff/settings/contracting-corporation-profile/_layout/corporate-overview/index.tsx",
      "parent": "/_staff/settings/contracting-corporation-profile/_layout"
    },
    "/_staff/settings/contracting-corporation-profile/_layout/group-companies/": {
      "filePath": "_staff/settings/contracting-corporation-profile/_layout/group-companies/index.tsx",
      "parent": "/_staff/settings/contracting-corporation-profile/_layout"
    },
    "/_staff/settings/contracting-corporation-profile/_layout/history/": {
      "filePath": "_staff/settings/contracting-corporation-profile/_layout/history/index.tsx",
      "parent": "/_staff/settings/contracting-corporation-profile/_layout"
    },
    "/_staff/settings/contracting-corporation-profile/_layout/registration/": {
      "filePath": "_staff/settings/contracting-corporation-profile/_layout/registration/index.tsx",
      "parent": "/_staff/settings/contracting-corporation-profile/_layout"
    },
    "/_staff/settings/contracting-corporation-profile/_layout/shareholders/": {
      "filePath": "_staff/settings/contracting-corporation-profile/_layout/shareholders/index.tsx",
      "parent": "/_staff/settings/contracting-corporation-profile/_layout"
    },
    "/_staff/settings/permission-and-roles/_list/category-permissions/": {
      "filePath": "_staff/settings/permission-and-roles/_list/category-permissions/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_list"
    },
    "/_staff/settings/permission-and-roles/_list/people-groups/": {
      "filePath": "_staff/settings/permission-and-roles/_list/people-groups/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_list"
    },
    "/_staff/settings/permission-and-roles/_list/product-permissions/": {
      "filePath": "_staff/settings/permission-and-roles/_list/product-permissions/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_list"
    },
    "/_staff/settings/permission-and-roles/_list/roles/": {
      "filePath": "_staff/settings/permission-and-roles/_list/roles/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_list"
    },
    "/_staff/settings/persons/_list/settings/": {
      "filePath": "_staff/settings/persons/_list/settings/index.tsx",
      "parent": "/_staff/settings/persons/_list"
    },
    "/_staff/software/$id/_$id/accounts/": {
      "filePath": "_staff/software/$id/_$id/accounts/index.tsx",
      "parent": "/_staff/software/$id/_$id"
    },
    "/_staff/software/$id/_$id/activity-monitoring/": {
      "filePath": "_staff/software/$id/_$id/activity-monitoring/index.tsx",
      "parent": "/_staff/software/$id/_$id"
    },
    "/_staff/software/$id/_$id/alerts/": {
      "filePath": "_staff/software/$id/_$id/alerts/index.tsx",
      "parent": "/_staff/software/$id/_$id"
    },
    "/_staff/software/$id/_$id/architecture/": {
      "filePath": "_staff/software/$id/_$id/architecture/index.tsx",
      "parent": "/_staff/software/$id/_$id"
    },
    "/_staff/software/$id/_$id/detail/": {
      "filePath": "_staff/software/$id/_$id/detail/index.tsx",
      "parent": "/_staff/software/$id/_$id"
    },
    "/_staff/software/$id/_$id/rule-and-policy/": {
      "filePath": "_staff/software/$id/_$id/rule-and-policy/index.tsx",
      "parent": "/_staff/software/$id/_$id"
    },
    "/_staff/software/$id/_$id/settings/": {
      "filePath": "_staff/software/$id/_$id/settings/index.tsx",
      "parent": "/_staff/software/$id/_$id/settings"
    },
    "/_staff/software/_layout/alerts/_alerts/": {
      "filePath": "_staff/software/_layout/alerts/_alerts/index.tsx",
      "parent": "/_staff/software/_layout/alerts/_alerts"
    },
    "/_staff/software/_layout/contract-and-cost/_contract-and-cost/": {
      "filePath": "_staff/software/_layout/contract-and-cost/_contract-and-cost/index.tsx",
      "parent": "/_staff/software/_layout/contract-and-cost/_contract-and-cost"
    },
    "/_staff/software/_layout/library/search/": {
      "filePath": "_staff/software/_layout/library/search/index.tsx",
      "parent": "/_staff/software/_layout"
    },
    "/_staff/software/custom-saas/add/$customSaasType/": {
      "filePath": "_staff/software/custom-saas/add/$customSaasType/index.tsx",
      "parent": "/_staff/software"
    },
    "/_staff/supplier/$supplierId/_layout/_index/": {
      "filePath": "_staff/supplier/$supplierId/_layout/_index/index.tsx",
      "parent": "/_staff/supplier/$supplierId/_layout"
    },
    "/_staff/supplier/_list/settings/procurement-categories/": {
      "filePath": "_staff/supplier/_list/settings/procurement-categories/index.tsx",
      "parent": "/_staff/supplier/_list/settings"
    },
    "/_staff/supplier/_list/settings/supplier-categories/": {
      "filePath": "_staff/supplier/_list/settings/supplier-categories/index.tsx",
      "parent": "/_staff/supplier/_list/settings"
    },
    "/_staff/supplier/_list/settings/supplier-subcategories/": {
      "filePath": "_staff/supplier/_list/settings/supplier-subcategories/index.tsx",
      "parent": "/_staff/supplier/_list/settings"
    },
    "/_staff/time-and-attendance/_layout/_list/summary/": {
      "filePath": "_staff/time-and-attendance/_layout/_list/summary/index.tsx",
      "parent": "/_staff/time-and-attendance/_layout"
    },
    "/_staff/time-and-attendance/_layout/attendance-links/$placeId/": {
      "filePath": "_staff/time-and-attendance/_layout/attendance-links/$placeId/index.tsx",
      "parent": "/_staff/time-and-attendance/_layout"
    },
    "/_staff/users/$userId/_layout/_identity/": {
      "filePath": "_staff/users/$userId/_layout/_identity/index.tsx",
      "parent": "/_staff/users/$userId/_layout"
    },
    "/_staff/users/$userId/_layout/sessions/": {
      "filePath": "_staff/users/$userId/_layout/sessions/index.tsx",
      "parent": "/_staff/users/$userId/_layout"
    },
    "/_individual/individual/portal/lookup/clocking-record/": {
      "filePath": "_individual/individual/portal/lookup/clocking-record/index.lazy.tsx",
      "parent": "/_individual/individual/portal/lookup/clocking-record"
    },
    "/_individual/individual/portal/lookup/pay-slip/": {
      "filePath": "_individual/individual/portal/lookup/pay-slip/index.lazy.tsx",
      "parent": "/_individual/individual/portal/lookup/pay-slip"
    },
    "/_staff/attendances/_layout/clocking-records/$employeeId/": {
      "filePath": "_staff/attendances/_layout/clocking-records/$employeeId/index.lazy.tsx",
      "parent": "/_staff/attendances/_layout/clocking-records/$employeeId"
    },
    "/_staff/contract/$id/_layout/_index/": {
      "filePath": "_staff/contract/$id/_layout/_index/index.lazy.tsx",
      "parent": "/_staff/contract/$id/_layout"
    },
    "/_staff/contract/$id/_layout/structure/": {
      "filePath": "_staff/contract/$id/_layout/structure/index.lazy.tsx",
      "parent": "/_staff/contract/$id/_layout"
    },
    "/_staff/equipment/$id/_layout/lifecycle/": {
      "filePath": "_staff/equipment/$id/_layout/lifecycle/index.lazy.tsx",
      "parent": "/_staff/equipment/$id/_layout"
    },
    "/_staff/equipment/$id/_layout/status/": {
      "filePath": "_staff/equipment/$id/_layout/status/index.lazy.tsx",
      "parent": "/_staff/equipment/$id/_layout"
    },
    "/_staff/fleets/$id/_layout/_profile/": {
      "filePath": "_staff/fleets/$id/_layout/_profile/index.lazy.tsx",
      "parent": "/_staff/fleets/$id/_layout"
    },
    "/_staff/networks/$id/_layout/_profile/": {
      "filePath": "_staff/networks/$id/_layout/_profile/index.lazy.tsx",
      "parent": "/_staff/networks/$id/_layout"
    },
    "/_staff/payroll/_layout/pay-slips/$employeeId/": {
      "filePath": "_staff/payroll/_layout/pay-slips/$employeeId/index.lazy.tsx",
      "parent": "/_staff/payroll/_layout/pay-slips/$employeeId"
    },
    "/_staff/places/$id/_layout/_profile/": {
      "filePath": "_staff/places/$id/_layout/_profile/index.lazy.tsx",
      "parent": "/_staff/places/$id/_layout"
    },
    "/_staff/starlinks/$id/_layout/_overview/": {
      "filePath": "_staff/starlinks/$id/_layout/_overview/index.lazy.tsx",
      "parent": "/_staff/starlinks/$id/_layout"
    },
    "/_staff/starlinks/$id/_layout/detail/": {
      "filePath": "_staff/starlinks/$id/_layout/detail/index.lazy.tsx",
      "parent": "/_staff/starlinks/$id/_layout"
    },
    "/_staff/storage-files/files/$id/_$id/": {
      "filePath": "_staff/storage-files/files/$id/_$id/index.lazy.tsx",
      "parent": "/_staff/storage-files/files/$id/_$id"
    },
    "/_staff/storage-files/folders/$id/_$id/": {
      "filePath": "_staff/storage-files/folders/$id/_$id/index.lazy.tsx",
      "parent": "/_staff/storage-files/folders/$id/_$id"
    },
    "/_individual/individual/_profile/certifications/base-certifications/$id": {
      "filePath": "_individual/individual/_profile/certifications/base-certifications/$id",
      "parent": "/_individual/individual/_profile",
      "children": [
        "/_individual/individual/_profile/certifications/base-certifications/$id/_layout"
      ]
    },
    "/_individual/individual/_profile/certifications/base-certifications/$id/_layout": {
      "filePath": "_individual/individual/_profile/certifications/base-certifications/$id/_layout.tsx",
      "parent": "/_individual/individual/_profile/certifications/base-certifications/$id",
      "children": [
        "/_individual/individual/_profile/certifications/base-certifications/$id/_layout/_index/"
      ]
    },
    "/_individual/individual/_profile/certifications/handling-certifications/$id": {
      "filePath": "_individual/individual/_profile/certifications/handling-certifications/$id",
      "parent": "/_individual/individual/_profile",
      "children": [
        "/_individual/individual/_profile/certifications/handling-certifications/$id/_layout"
      ]
    },
    "/_individual/individual/_profile/certifications/handling-certifications/$id/_layout": {
      "filePath": "_individual/individual/_profile/certifications/handling-certifications/$id/_layout.tsx",
      "parent": "/_individual/individual/_profile/certifications/handling-certifications/$id",
      "children": [
        "/_individual/individual/_profile/certifications/handling-certifications/$id/_layout/_index/"
      ]
    },
    "/_individual/individual/_profile/certifications/specialty-certifications/$id": {
      "filePath": "_individual/individual/_profile/certifications/specialty-certifications/$id",
      "parent": "/_individual/individual/_profile",
      "children": [
        "/_individual/individual/_profile/certifications/specialty-certifications/$id/_layout"
      ]
    },
    "/_individual/individual/_profile/certifications/specialty-certifications/$id/_layout": {
      "filePath": "_individual/individual/_profile/certifications/specialty-certifications/$id/_layout.tsx",
      "parent": "/_individual/individual/_profile/certifications/specialty-certifications/$id",
      "children": [
        "/_individual/individual/_profile/certifications/specialty-certifications/$id/_layout/_index/"
      ]
    },
    "/_staff/device-catalog/active/$id/_layout/contract-and-cost": {
      "filePath": "_staff/device-catalog/active/$id/_layout/contract-and-cost",
      "parent": "/_staff/device-catalog/active/$id/_layout",
      "children": [
        "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost"
      ]
    },
    "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost": {
      "filePath": "_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost.tsx",
      "parent": "/_staff/device-catalog/active/$id/_layout/contract-and-cost",
      "children": [
        "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/",
        "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal",
        "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/cost/",
        "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/payment/",
        "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/cost/$period/",
        "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/payment/$period/"
      ]
    },
    "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal": {
      "filePath": "_staff/devices/_list/contract-and-cost/_contract-and-cost/deal",
      "parent": "/_staff/devices/_list/contract-and-cost/_contract-and-cost",
      "children": [
        "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal"
      ]
    },
    "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal": {
      "filePath": "_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal.tsx",
      "parent": "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal",
      "children": [
        "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/",
        "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/all/",
        "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/contract/",
        "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/estimate/",
        "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/order/",
        "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/payment/",
        "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/"
      ]
    },
    "/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId": {
      "filePath": "_staff/person/$id/certifications/base-certifications/$personCertificationInformationId",
      "parent": "/_staff/person/$id",
      "children": [
        "/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout"
      ]
    },
    "/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout": {
      "filePath": "_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout.tsx",
      "parent": "/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId",
      "children": [
        "/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout/_index/"
      ]
    },
    "/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId": {
      "filePath": "_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId",
      "parent": "/_staff/person/$id",
      "children": [
        "/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout"
      ]
    },
    "/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout": {
      "filePath": "_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout.tsx",
      "parent": "/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId",
      "children": [
        "/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout/_index/"
      ]
    },
    "/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId": {
      "filePath": "_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId",
      "parent": "/_staff/person/$id",
      "children": [
        "/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout"
      ]
    },
    "/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout": {
      "filePath": "_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout.tsx",
      "parent": "/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId",
      "children": [
        "/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout/_index/"
      ]
    },
    "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id": {
      "filePath": "_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id",
      "parent": "/_staff/settings/data-connector/inbound/aggregate-data-pipeline",
      "children": [
        "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail",
        "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/",
        "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/$chunkId/result/"
      ]
    },
    "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail": {
      "filePath": "_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail.tsx",
      "parent": "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id",
      "children": [
        "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/basic-info/",
        "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/execution-plan/",
        "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/priority-setting/",
        "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/tasks/"
      ]
    },
    "/_staff/settings/data-connector/inbound/data-pipeline/$id": {
      "filePath": "_staff/settings/data-connector/inbound/data-pipeline/$id",
      "parent": "/_staff/settings/data-connector/inbound/data-pipeline",
      "children": [
        "/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail",
        "/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId"
      ]
    },
    "/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail": {
      "filePath": "_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail.tsx",
      "parent": "/_staff/settings/data-connector/inbound/data-pipeline/$id",
      "children": [
        "/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/basic-settings/",
        "/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/data-link-settings/",
        "/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/execution-plan/",
        "/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/execution-results/"
      ]
    },
    "/_staff/settings/data-connector/outbound/data-pipeline/$id": {
      "filePath": "_staff/settings/data-connector/outbound/data-pipeline/$id",
      "parent": "/_staff/settings/data-connector/outbound/data-pipeline",
      "children": [
        "/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail"
      ]
    },
    "/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail": {
      "filePath": "_staff/settings/data-connector/outbound/data-pipeline/$id/_detail.tsx",
      "parent": "/_staff/settings/data-connector/outbound/data-pipeline/$id",
      "children": [
        "/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/basic-settings/",
        "/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/data-link-settings/",
        "/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/execution-plan/",
        "/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/execution-results/"
      ]
    },
    "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal": {
      "filePath": "_staff/software/_layout/contract-and-cost/_contract-and-cost/deal",
      "parent": "/_staff/software/_layout/contract-and-cost/_contract-and-cost",
      "children": [
        "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal"
      ]
    },
    "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal": {
      "filePath": "_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal.tsx",
      "parent": "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal",
      "children": [
        "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/",
        "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/all/",
        "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/contract/",
        "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/estimate/",
        "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/order/",
        "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/payment/",
        "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/"
      ]
    },
    "/_individual/individual/_profile/my-profile/_layout/devices/": {
      "filePath": "_individual/individual/_profile/my-profile/_layout/devices/index.tsx",
      "parent": "/_individual/individual/_profile/my-profile/_layout"
    },
    "/_individual/individual/_profile/my-profile/_layout/education-and-qualification/": {
      "filePath": "_individual/individual/_profile/my-profile/_layout/education-and-qualification/index.tsx",
      "parent": "/_individual/individual/_profile/my-profile/_layout"
    },
    "/_individual/individual/_profile/my-profile/_layout/softwares/": {
      "filePath": "_individual/individual/_profile/my-profile/_layout/softwares/index.tsx",
      "parent": "/_individual/individual/_profile/my-profile/_layout"
    },
    "/_individual/individual/contract/$id/signature-request/$signatureRequestId/": {
      "filePath": "_individual/individual/contract/$id/signature-request/$signatureRequestId/index.tsx",
      "parent": "/_individual/individual"
    },
    "/_individual/individual/operation-package/$id/pattern/$patternId/": {
      "filePath": "_individual/individual/operation-package/$id/pattern/$patternId/index.tsx",
      "parent": "/_individual/individual"
    },
    "/_individual/individual/operation-package/$id/target/$targetId/": {
      "filePath": "_individual/individual/operation-package/$id/target/$targetId/index.tsx",
      "parent": "/_individual/individual"
    },
    "/_stacktrace/production/$productionId/_layout/dev-scope/edit/": {
      "filePath": "_stacktrace/production/$productionId/_layout/dev-scope/edit/index.tsx",
      "parent": "/_stacktrace/production/$productionId/_layout"
    },
    "/_stacktrace/production/$productionId/_layout/issue-scope/edit/": {
      "filePath": "_stacktrace/production/$productionId/_layout/issue-scope/edit/index.tsx",
      "parent": "/_stacktrace/production/$productionId/_layout"
    },
    "/_stacktrace/production/$productionId/_layout/value/edit/": {
      "filePath": "_stacktrace/production/$productionId/_layout/value/edit/index.tsx",
      "parent": "/_stacktrace/production/$productionId/_layout"
    },
    "/_stacktrace/products/$id/scope/$nodeId/_layout/": {
      "filePath": "_stacktrace/products/$id/scope/$nodeId/_layout/index.tsx",
      "parent": "/_stacktrace/products/$id/scope/$nodeId/_layout"
    },
    "/_stacktrace/test-suites/$id/_layout/test-plan/_layout/": {
      "filePath": "_stacktrace/test-suites/$id/_layout/test-plan/_layout/index.tsx",
      "parent": "/_stacktrace/test-suites/$id/_layout/test-plan/_layout"
    },
    "/_stacktrace/test-suites/$id/_layout/test-review/_layout/": {
      "filePath": "_stacktrace/test-suites/$id/_layout/test-review/_layout/index.tsx",
      "parent": "/_stacktrace/test-suites/$id/_layout/test-review/_layout"
    },
    "/_staff/accesses/_layout/alerts/detail/$shadowItAppId/": {
      "filePath": "_staff/accesses/_layout/alerts/detail/$shadowItAppId/index.tsx",
      "parent": "/_staff/accesses/_layout"
    },
    "/_staff/accesses/_layout/alerts/dormancy/$softwareId/": {
      "filePath": "_staff/accesses/_layout/alerts/dormancy/$softwareId/index.tsx",
      "parent": "/_staff/accesses/_layout"
    },
    "/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout/": {
      "filePath": "_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout/index.tsx",
      "parent": "/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout"
    },
    "/_staff/business-partner/$id/_layout/bp-role-info/_layout/": {
      "filePath": "_staff/business-partner/$id/_layout/bp-role-info/_layout/index.tsx",
      "parent": "/_staff/business-partner/$id/_layout/bp-role-info/_layout"
    },
    "/_staff/certification/handling-certification/$id/_layout/_index/": {
      "filePath": "_staff/certification/handling-certification/$id/_layout/_index/index.tsx",
      "parent": "/_staff/certification/handling-certification/$id/_layout"
    },
    "/_staff/certification/handling-certification/$id/_layout/certification-holders/": {
      "filePath": "_staff/certification/handling-certification/$id/_layout/certification-holders/index.tsx",
      "parent": "/_staff/certification/handling-certification/$id/_layout"
    },
    "/_staff/certification/specialty-certification/$id/_layout/_index/": {
      "filePath": "_staff/certification/specialty-certification/$id/_layout/_index/index.tsx",
      "parent": "/_staff/certification/specialty-certification/$id/_layout"
    },
    "/_staff/certification/specialty-certification/$id/_layout/certification-holders/": {
      "filePath": "_staff/certification/specialty-certification/$id/_layout/certification-holders/index.tsx",
      "parent": "/_staff/certification/specialty-certification/$id/_layout"
    },
    "/_staff/certification/specialty-certification/$id/_layout/handling-certifications/": {
      "filePath": "_staff/certification/specialty-certification/$id/_layout/handling-certifications/index.tsx",
      "parent": "/_staff/certification/specialty-certification/$id/_layout"
    },
    "/_staff/device-catalog/active/$id/_layout/profile/": {
      "filePath": "_staff/device-catalog/active/$id/_layout/profile/index.tsx",
      "parent": "/_staff/device-catalog/active/$id/_layout"
    },
    "/_staff/device-catalog/draft/$id/_layout/profile/": {
      "filePath": "_staff/device-catalog/draft/$id/_layout/profile/index.tsx",
      "parent": "/_staff/device-catalog/draft/$id/_layout"
    },
    "/_staff/devices/_list/contract-and-cost/_contract-and-cost/cost/": {
      "filePath": "_staff/devices/_list/contract-and-cost/_contract-and-cost/cost/index.tsx",
      "parent": "/_staff/devices/_list/contract-and-cost/_contract-and-cost"
    },
    "/_staff/devices/_list/contract-and-cost/_contract-and-cost/payment/": {
      "filePath": "_staff/devices/_list/contract-and-cost/_contract-and-cost/payment/index.tsx",
      "parent": "/_staff/devices/_list/contract-and-cost/_contract-and-cost"
    },
    "/_staff/equipment/items/$id/_detail/alerts/": {
      "filePath": "_staff/equipment/items/$id/_detail/alerts/index.tsx",
      "parent": "/_staff/equipment/items/$id/_detail"
    },
    "/_staff/equipment/items/$id/_detail/inventory/": {
      "filePath": "_staff/equipment/items/$id/_detail/inventory/index.tsx",
      "parent": "/_staff/equipment/items/$id/_detail"
    },
    "/_staff/equipment/items/$id/_detail/rule-and-policy/": {
      "filePath": "_staff/equipment/items/$id/_detail/rule-and-policy/index.tsx",
      "parent": "/_staff/equipment/items/$id/_detail"
    },
    "/_staff/ids/group-id/$id/_$id/detail/": {
      "filePath": "_staff/ids/group-id/$id/_$id/detail/index.tsx",
      "parent": "/_staff/ids/group-id/$id/_$id"
    },
    "/_staff/ids/group-id/$id/_$id/devices/": {
      "filePath": "_staff/ids/group-id/$id/_$id/devices/index.tsx",
      "parent": "/_staff/ids/group-id/$id/_$id"
    },
    "/_staff/ids/group-id/$id/_$id/members/": {
      "filePath": "_staff/ids/group-id/$id/_$id/members/index.tsx",
      "parent": "/_staff/ids/group-id/$id/_$id"
    },
    "/_staff/ids/group-id/$id/_$id/rule-and-policy/": {
      "filePath": "_staff/ids/group-id/$id/_$id/rule-and-policy/index.tsx",
      "parent": "/_staff/ids/group-id/$id/_$id"
    },
    "/_staff/ids/group-id/$id/_$id/security-and-auth/": {
      "filePath": "_staff/ids/group-id/$id/_$id/security-and-auth/index.tsx",
      "parent": "/_staff/ids/group-id/$id/_$id"
    },
    "/_staff/ids/group-id/$id/_$id/softwares/": {
      "filePath": "_staff/ids/group-id/$id/_$id/softwares/index.tsx",
      "parent": "/_staff/ids/group-id/$id/_$id"
    },
    "/_staff/marketplace/_store/store/devices/$productId/": {
      "filePath": "_staff/marketplace/_store/store/devices/$productId/index.tsx",
      "parent": "/_staff/marketplace/_store"
    },
    "/_staff/marketplace/_store/store/licenses/$productId/": {
      "filePath": "_staff/marketplace/_store/store/licenses/$productId/index.tsx",
      "parent": "/_staff/marketplace/_store"
    },
    "/_staff/marketplace/_store/store/starlinks/$productId/": {
      "filePath": "_staff/marketplace/_store/store/starlinks/$productId/index.tsx",
      "parent": "/_staff/marketplace/_store"
    },
    "/_staff/organization/plan/$id/edit/$unitId/": {
      "filePath": "_staff/organization/plan/$id/edit/$unitId/index.tsx",
      "parent": "/_staff/organization"
    },
    "/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout/": {
      "filePath": "_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout/index.tsx",
      "parent": "/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout"
    },
    "/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/cost/": {
      "filePath": "_staff/payroll/_layout/contract-and-cost/_contract-and-cost/cost/index.tsx",
      "parent": "/_staff/payroll/_layout/contract-and-cost/_contract-and-cost"
    },
    "/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/deal/": {
      "filePath": "_staff/payroll/_layout/contract-and-cost/_contract-and-cost/deal/index.tsx",
      "parent": "/_staff/payroll/_layout/contract-and-cost/_contract-and-cost"
    },
    "/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/payment/": {
      "filePath": "_staff/payroll/_layout/contract-and-cost/_contract-and-cost/payment/index.tsx",
      "parent": "/_staff/payroll/_layout/contract-and-cost/_contract-and-cost"
    },
    "/_staff/person/$id/_profile/family/$familyPersonId/": {
      "filePath": "_staff/person/$id/_profile/family/$familyPersonId/index.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_staff/person/alumni/$id/_profile/apps/": {
      "filePath": "_staff/person/alumni/$id/_profile/apps/index.tsx",
      "parent": "/_staff/person/alumni/$id/_profile"
    },
    "/_staff/person/alumni/$id/_profile/contractor-information/": {
      "filePath": "_staff/person/alumni/$id/_profile/contractor-information/index.tsx",
      "parent": "/_staff/person/alumni/$id/_profile"
    },
    "/_staff/person/alumni/$id/_profile/devices/": {
      "filePath": "_staff/person/alumni/$id/_profile/devices/index.tsx",
      "parent": "/_staff/person/alumni/$id/_profile"
    },
    "/_staff/person/alumni/$id/_profile/education-and-qualification/": {
      "filePath": "_staff/person/alumni/$id/_profile/education-and-qualification/index.tsx",
      "parent": "/_staff/person/alumni/$id/_profile"
    },
    "/_staff/person/alumni/$id/_profile/employee-information/": {
      "filePath": "_staff/person/alumni/$id/_profile/employee-information/index.tsx",
      "parent": "/_staff/person/alumni/$id/_profile"
    },
    "/_staff/person/alumni/$id/_profile/equipment/": {
      "filePath": "_staff/person/alumni/$id/_profile/equipment/index.tsx",
      "parent": "/_staff/person/alumni/$id/_profile"
    },
    "/_staff/person/alumni/$id/_profile/history/": {
      "filePath": "_staff/person/alumni/$id/_profile/history/index.tsx",
      "parent": "/_staff/person/alumni/$id/_profile"
    },
    "/_staff/person/alumni/$id/_profile/operation-activity/": {
      "filePath": "_staff/person/alumni/$id/_profile/operation-activity/index.tsx",
      "parent": "/_staff/person/alumni/$id/_profile"
    },
    "/_staff/person/alumni/$id/_profile/personal-information/": {
      "filePath": "_staff/person/alumni/$id/_profile/personal-information/index.tsx",
      "parent": "/_staff/person/alumni/$id/_profile"
    },
    "/_staff/person/alumni/$id/_profile/public-id/": {
      "filePath": "_staff/person/alumni/$id/_profile/public-id/index.tsx",
      "parent": "/_staff/person/alumni/$id/_profile"
    },
    "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/_list/": {
      "filePath": "_staff/settings/data-connector/inbound/aggregate-data-pipeline/_list/index.tsx",
      "parent": "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/_list"
    },
    "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/add/": {
      "filePath": "_staff/settings/data-connector/inbound/aggregate-data-pipeline/add/index.tsx",
      "parent": "/_staff/settings/data-connector/inbound/aggregate-data-pipeline"
    },
    "/_staff/settings/data-connector/inbound/data-pipeline/_list/": {
      "filePath": "_staff/settings/data-connector/inbound/data-pipeline/_list/index.tsx",
      "parent": "/_staff/settings/data-connector/inbound/data-pipeline/_list"
    },
    "/_staff/settings/data-connector/inbound/data-pipeline/add/": {
      "filePath": "_staff/settings/data-connector/inbound/data-pipeline/add/index.tsx",
      "parent": "/_staff/settings/data-connector/inbound/data-pipeline"
    },
    "/_staff/settings/data-connector/outbound/data-pipeline/_list/": {
      "filePath": "_staff/settings/data-connector/outbound/data-pipeline/_list/index.tsx",
      "parent": "/_staff/settings/data-connector/outbound/data-pipeline/_list"
    },
    "/_staff/settings/data-connector/outbound/data-pipeline/add/": {
      "filePath": "_staff/settings/data-connector/outbound/data-pipeline/add/index.tsx",
      "parent": "/_staff/settings/data-connector/outbound/data-pipeline"
    },
    "/_staff/settings/permission-and-roles/_detail/category-permissions/$id/": {
      "filePath": "_staff/settings/permission-and-roles/_detail/category-permissions/$id/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_detail"
    },
    "/_staff/settings/permission-and-roles/_detail/people-groups/$id/": {
      "filePath": "_staff/settings/permission-and-roles/_detail/people-groups/$id/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_detail"
    },
    "/_staff/settings/permission-and-roles/_detail/product-permissions/$id/": {
      "filePath": "_staff/settings/permission-and-roles/_detail/product-permissions/$id/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_detail"
    },
    "/_staff/settings/permission-and-roles/_detail/roles/$id/": {
      "filePath": "_staff/settings/permission-and-roles/_detail/roles/$id/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_detail"
    },
    "/_staff/settings/permission-and-roles/_form/category-permissions/new/": {
      "filePath": "_staff/settings/permission-and-roles/_form/category-permissions/new/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_form"
    },
    "/_staff/settings/permission-and-roles/_form/people-groups/new/": {
      "filePath": "_staff/settings/permission-and-roles/_form/people-groups/new/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_form"
    },
    "/_staff/settings/permission-and-roles/_form/product-permissions/new/": {
      "filePath": "_staff/settings/permission-and-roles/_form/product-permissions/new/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_form"
    },
    "/_staff/settings/permission-and-roles/_form/roles/new/": {
      "filePath": "_staff/settings/permission-and-roles/_form/roles/new/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_form"
    },
    "/_staff/settings/persons/_list/_account/individual/": {
      "filePath": "_staff/settings/persons/_list/_account/individual/index.tsx",
      "parent": "/_staff/settings/persons/_list/_account"
    },
    "/_staff/settings/persons/_list/_account/staff/": {
      "filePath": "_staff/settings/persons/_list/_account/staff/index.tsx",
      "parent": "/_staff/settings/persons/_list/_account"
    },
    "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/": {
      "filePath": "_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/index.tsx",
      "parent": "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost"
    },
    "/_staff/software/$id/_$id/settings/integration/": {
      "filePath": "_staff/software/$id/_$id/settings/integration/index.tsx",
      "parent": "/_staff/software/$id/_$id/settings"
    },
    "/_staff/software/$id/_$id/settings/role/": {
      "filePath": "_staff/software/$id/_$id/settings/role/index.tsx",
      "parent": "/_staff/software/$id/_$id/settings"
    },
    "/_staff/software/$id/_$id/settings/status/": {
      "filePath": "_staff/software/$id/_$id/settings/status/index.tsx",
      "parent": "/_staff/software/$id/_$id/settings"
    },
    "/_staff/software/_layout/alerts/_alerts/alumni/": {
      "filePath": "_staff/software/_layout/alerts/_alerts/alumni/index.tsx",
      "parent": "/_staff/software/_layout/alerts/_alerts"
    },
    "/_staff/software/_layout/alerts/_alerts/inactive-user/": {
      "filePath": "_staff/software/_layout/alerts/_alerts/inactive-user/index.tsx",
      "parent": "/_staff/software/_layout/alerts/_alerts"
    },
    "/_staff/software/_layout/alerts/_alerts/no-user/": {
      "filePath": "_staff/software/_layout/alerts/_alerts/no-user/index.tsx",
      "parent": "/_staff/software/_layout/alerts/_alerts"
    },
    "/_staff/software/_layout/alerts/_alerts/no-worker/": {
      "filePath": "_staff/software/_layout/alerts/_alerts/no-worker/index.tsx",
      "parent": "/_staff/software/_layout/alerts/_alerts"
    },
    "/_staff/software/_layout/alerts/_alerts/violated-assignment/": {
      "filePath": "_staff/software/_layout/alerts/_alerts/violated-assignment/index.tsx",
      "parent": "/_staff/software/_layout/alerts/_alerts"
    },
    "/_staff/software/_layout/alerts/_alerts/violated-role/": {
      "filePath": "_staff/software/_layout/alerts/_alerts/violated-role/index.tsx",
      "parent": "/_staff/software/_layout/alerts/_alerts"
    },
    "/_staff/software/_layout/contract-and-cost/_contract-and-cost/cost/": {
      "filePath": "_staff/software/_layout/contract-and-cost/_contract-and-cost/cost/index.tsx",
      "parent": "/_staff/software/_layout/contract-and-cost/_contract-and-cost"
    },
    "/_staff/software/_layout/contract-and-cost/_contract-and-cost/payment/": {
      "filePath": "_staff/software/_layout/contract-and-cost/_contract-and-cost/payment/index.tsx",
      "parent": "/_staff/software/_layout/contract-and-cost/_contract-and-cost"
    },
    "/_staff/software/_layout/library/category/$category/": {
      "filePath": "_staff/software/_layout/library/category/$category/index.tsx",
      "parent": "/_staff/software/_layout"
    },
    "/_staff/software/_layout/library/detail/$softwareLibraryId/": {
      "filePath": "_staff/software/_layout/library/detail/$softwareLibraryId/index.tsx",
      "parent": "/_staff/software/_layout"
    },
    "/_staff/storage-files/folders/$id/_$id/files/": {
      "filePath": "_staff/storage-files/folders/$id/_$id/files/index.tsx",
      "parent": "/_staff/storage-files/folders/$id/_$id"
    },
    "/_staff/storage-files/folders/$id/_$id/users/": {
      "filePath": "_staff/storage-files/folders/$id/_$id/users/index.tsx",
      "parent": "/_staff/storage-files/folders/$id/_$id"
    },
    "/_staff/time-and-attendance/_layout/_list/summary/daily-place/": {
      "filePath": "_staff/time-and-attendance/_layout/_list/summary/daily-place/index.tsx",
      "parent": "/_staff/time-and-attendance/_layout"
    },
    "/_staff/time-and-attendance/_layout/_list/summary/monthly-person/": {
      "filePath": "_staff/time-and-attendance/_layout/_list/summary/monthly-person/index.tsx",
      "parent": "/_staff/time-and-attendance/_layout"
    },
    "/_staff/time-and-attendance/_layout/_list/summary/monthly-place/": {
      "filePath": "_staff/time-and-attendance/_layout/_list/summary/monthly-place/index.tsx",
      "parent": "/_staff/time-and-attendance/_layout"
    },
    "/_staff/equipment/items/$id/_detail/profile/": {
      "filePath": "_staff/equipment/items/$id/_detail/profile/index.lazy.tsx",
      "parent": "/_staff/equipment/items/$id/_detail"
    },
    "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal": {
      "filePath": "_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal",
      "parent": "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost",
      "children": [
        "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal"
      ]
    },
    "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal": {
      "filePath": "_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal.tsx",
      "parent": "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal",
      "children": [
        "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/",
        "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/all/",
        "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/contract/",
        "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/estimate/",
        "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/order/",
        "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/payment/",
        "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/"
      ]
    },
    "/_stacktrace/products/$id/scope/$nodeId/_layout/value/": {
      "filePath": "_stacktrace/products/$id/scope/$nodeId/_layout/value/index.tsx",
      "parent": "/_stacktrace/products/$id/scope/$nodeId/_layout"
    },
    "/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout/structure/": {
      "filePath": "_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout/structure/index.tsx",
      "parent": "/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout"
    },
    "/_staff/business-partner/$id/_layout/bp-role-info/_layout/$bpRole/": {
      "filePath": "_staff/business-partner/$id/_layout/bp-role-info/_layout/$bpRole/index.tsx",
      "parent": "/_staff/business-partner/$id/_layout/bp-role-info/_layout"
    },
    "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/": {
      "filePath": "_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/index.tsx",
      "parent": "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost"
    },
    "/_staff/devices/_list/contract-and-cost/_contract-and-cost/cost/$period/": {
      "filePath": "_staff/devices/_list/contract-and-cost/_contract-and-cost/cost/$period/index.tsx",
      "parent": "/_staff/devices/_list/contract-and-cost/_contract-and-cost"
    },
    "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/": {
      "filePath": "_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/index.tsx",
      "parent": "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/devices/_list/contract-and-cost/_contract-and-cost/payment/$period/": {
      "filePath": "_staff/devices/_list/contract-and-cost/_contract-and-cost/payment/$period/index.tsx",
      "parent": "/_staff/devices/_list/contract-and-cost/_contract-and-cost"
    },
    "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/data/": {
      "filePath": "_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/data/index.tsx",
      "parent": "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout"
    },
    "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/detail/": {
      "filePath": "_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/detail/index.tsx",
      "parent": "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout"
    },
    "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/operation-activity/": {
      "filePath": "_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/operation-activity/index.tsx",
      "parent": "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout"
    },
    "/_staff/licenses/$id/service-plans/$licenseServiceId/_detail/accounts/": {
      "filePath": "_staff/licenses/$id/service-plans/$licenseServiceId/_detail/accounts/index.tsx",
      "parent": "/_staff/licenses/$id/service-plans/$licenseServiceId/_detail"
    },
    "/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout/structure/": {
      "filePath": "_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout/structure/index.tsx",
      "parent": "/_staff/payroll-engine/_layout/payroll-structures/$structureId/_layout"
    },
    "/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/cost/$period/": {
      "filePath": "_staff/payroll/_layout/contract-and-cost/_contract-and-cost/cost/$period/index.tsx",
      "parent": "/_staff/payroll/_layout/contract-and-cost/_contract-and-cost"
    },
    "/_staff/payroll/_layout/contract-and-cost/_contract-and-cost/payment/$period/": {
      "filePath": "_staff/payroll/_layout/contract-and-cost/_contract-and-cost/payment/$period/index.tsx",
      "parent": "/_staff/payroll/_layout/contract-and-cost/_contract-and-cost"
    },
    "/_staff/settings/permission-and-roles/_form/category-permissions/$id/edit/": {
      "filePath": "_staff/settings/permission-and-roles/_form/category-permissions/$id/edit/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_form"
    },
    "/_staff/settings/permission-and-roles/_form/people-groups/$id/edit/": {
      "filePath": "_staff/settings/permission-and-roles/_form/people-groups/$id/edit/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_form"
    },
    "/_staff/settings/permission-and-roles/_form/product-permissions/$id/edit/": {
      "filePath": "_staff/settings/permission-and-roles/_form/product-permissions/$id/edit/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_form"
    },
    "/_staff/settings/permission-and-roles/_form/roles/$id/edit/": {
      "filePath": "_staff/settings/permission-and-roles/_form/roles/$id/edit/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_form"
    },
    "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/cost/": {
      "filePath": "_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/cost/index.tsx",
      "parent": "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost"
    },
    "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/payment/": {
      "filePath": "_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/payment/index.tsx",
      "parent": "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost"
    },
    "/_staff/software/_layout/contract-and-cost/_contract-and-cost/cost/$period/": {
      "filePath": "_staff/software/_layout/contract-and-cost/_contract-and-cost/cost/$period/index.tsx",
      "parent": "/_staff/software/_layout/contract-and-cost/_contract-and-cost"
    },
    "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/": {
      "filePath": "_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/index.tsx",
      "parent": "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/software/_layout/contract-and-cost/_contract-and-cost/payment/$period/": {
      "filePath": "_staff/software/_layout/contract-and-cost/_contract-and-cost/payment/$period/index.tsx",
      "parent": "/_staff/software/_layout/contract-and-cost/_contract-and-cost"
    },
    "/_staff/software/_layout/library/category/$category/search/": {
      "filePath": "_staff/software/_layout/library/category/$category/search/index.tsx",
      "parent": "/_staff/software/_layout"
    },
    "/_staff/software/_layout/marketplace/$id/install/finish/": {
      "filePath": "_staff/software/_layout/marketplace/$id/install.finish/index.tsx",
      "parent": "/_staff/software/_layout/marketplace/$id"
    },
    "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId": {
      "filePath": "_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId",
      "parent": "/_staff/contractor-core",
      "children": [
        "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile"
      ]
    },
    "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile": {
      "filePath": "_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile.tsx",
      "parent": "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId",
      "children": [
        "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/",
        "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/"
      ]
    },
    "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal": {
      "filePath": "_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal",
      "parent": "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost",
      "children": [
        "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal"
      ]
    },
    "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal": {
      "filePath": "_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal.tsx",
      "parent": "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal",
      "children": [
        "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/",
        "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/all/",
        "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/contract/",
        "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/estimate/",
        "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/order/",
        "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/payment/",
        "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/"
      ]
    },
    "/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId": {
      "filePath": "_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId",
      "parent": "/_staff/ga-operation-core",
      "children": [
        "/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile"
      ]
    },
    "/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile": {
      "filePath": "_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile.tsx",
      "parent": "/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId",
      "children": [
        "/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/",
        "/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/"
      ]
    },
    "/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId": {
      "filePath": "_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId",
      "parent": "/_staff/labor-core",
      "children": [
        "/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile"
      ]
    },
    "/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile": {
      "filePath": "_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile.tsx",
      "parent": "/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId",
      "children": [
        "/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/",
        "/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/"
      ]
    },
    "/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId": {
      "filePath": "_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId",
      "parent": "/_staff/settings/data-connector/inbound/data-pipeline/$id",
      "children": [
        "/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/_task-detail",
        "/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/chunks/$chunkId/result/"
      ]
    },
    "/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/_task-detail": {
      "filePath": "_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/_task-detail.tsx",
      "parent": "/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId",
      "children": [
        "/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/_task-detail/chunks/"
      ]
    },
    "/_individual/individual/_profile/certifications/base-certifications/$id/_layout/_index/": {
      "filePath": "_individual/individual/_profile/certifications/base-certifications/$id/_layout/_index/index.tsx",
      "parent": "/_individual/individual/_profile/certifications/base-certifications/$id/_layout"
    },
    "/_individual/individual/_profile/certifications/handling-certifications/$id/_layout/_index/": {
      "filePath": "_individual/individual/_profile/certifications/handling-certifications/$id/_layout/_index/index.tsx",
      "parent": "/_individual/individual/_profile/certifications/handling-certifications/$id/_layout"
    },
    "/_individual/individual/_profile/certifications/specialty-certifications/$id/_layout/_index/": {
      "filePath": "_individual/individual/_profile/certifications/specialty-certifications/$id/_layout/_index/index.tsx",
      "parent": "/_individual/individual/_profile/certifications/specialty-certifications/$id/_layout"
    },
    "/_individual/individual/task/$id/_operation-package/_common/form/$formId/": {
      "filePath": "_individual/individual/task/$id/_operation-package/_common/form/$formId/index.tsx",
      "parent": "/_individual/individual"
    },
    "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/cost/": {
      "filePath": "_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/cost/index.tsx",
      "parent": "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost"
    },
    "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/payment/": {
      "filePath": "_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/payment/index.tsx",
      "parent": "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost"
    },
    "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/all/": {
      "filePath": "_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/all/index.tsx",
      "parent": "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/contract/": {
      "filePath": "_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/contract/index.tsx",
      "parent": "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/estimate/": {
      "filePath": "_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/estimate/index.tsx",
      "parent": "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/order/": {
      "filePath": "_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/order/index.tsx",
      "parent": "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/payment/": {
      "filePath": "_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/payment/index.tsx",
      "parent": "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/": {
      "filePath": "_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/index.tsx",
      "parent": "/_staff/devices/_list/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout/_index/": {
      "filePath": "_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout/_index/index.tsx",
      "parent": "/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout"
    },
    "/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout/_index/": {
      "filePath": "_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout/_index/index.tsx",
      "parent": "/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout"
    },
    "/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout/_index/": {
      "filePath": "_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout/_index/index.tsx",
      "parent": "/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout"
    },
    "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/basic-info/": {
      "filePath": "_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/basic-info/index.tsx",
      "parent": "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail"
    },
    "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/execution-plan/": {
      "filePath": "_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/execution-plan/index.tsx",
      "parent": "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail"
    },
    "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/priority-setting/": {
      "filePath": "_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/priority-setting/index.tsx",
      "parent": "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail"
    },
    "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/tasks/": {
      "filePath": "_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail/tasks/index.tsx",
      "parent": "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/_aggregate-detail"
    },
    "/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/basic-settings/": {
      "filePath": "_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/basic-settings/index.tsx",
      "parent": "/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail"
    },
    "/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/data-link-settings/": {
      "filePath": "_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/data-link-settings/index.tsx",
      "parent": "/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail"
    },
    "/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/execution-plan/": {
      "filePath": "_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/execution-plan/index.tsx",
      "parent": "/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail"
    },
    "/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/execution-results/": {
      "filePath": "_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail/execution-results/index.tsx",
      "parent": "/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail"
    },
    "/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/basic-settings/": {
      "filePath": "_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/basic-settings/index.tsx",
      "parent": "/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail"
    },
    "/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/data-link-settings/": {
      "filePath": "_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/data-link-settings/index.tsx",
      "parent": "/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail"
    },
    "/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/execution-plan/": {
      "filePath": "_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/execution-plan/index.tsx",
      "parent": "/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail"
    },
    "/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/execution-results/": {
      "filePath": "_staff/settings/data-connector/outbound/data-pipeline/$id/_detail/execution-results/index.tsx",
      "parent": "/_staff/settings/data-connector/outbound/data-pipeline/$id/_detail"
    },
    "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/cost/$period/": {
      "filePath": "_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/cost/$period/index.tsx",
      "parent": "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost"
    },
    "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/": {
      "filePath": "_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/index.tsx",
      "parent": "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/payment/$period/": {
      "filePath": "_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/payment/$period/index.tsx",
      "parent": "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost"
    },
    "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/all/": {
      "filePath": "_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/all/index.tsx",
      "parent": "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/contract/": {
      "filePath": "_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/contract/index.tsx",
      "parent": "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/estimate/": {
      "filePath": "_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/estimate/index.tsx",
      "parent": "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/order/": {
      "filePath": "_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/order/index.tsx",
      "parent": "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/payment/": {
      "filePath": "_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/payment/index.tsx",
      "parent": "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/": {
      "filePath": "_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/index.tsx",
      "parent": "/_staff/software/_layout/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId": {
      "filePath": "_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId",
      "parent": "/_staff/attendance-core/_layout",
      "children": [
        "/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile"
      ]
    },
    "/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile": {
      "filePath": "_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile.tsx",
      "parent": "/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId",
      "children": [
        "/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/",
        "/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/"
      ]
    },
    "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/": {
      "filePath": "_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/index.tsx",
      "parent": "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile"
    },
    "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/cost/$period/": {
      "filePath": "_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/cost/$period/index.tsx",
      "parent": "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost"
    },
    "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/": {
      "filePath": "_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/index.tsx",
      "parent": "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/payment/$period/": {
      "filePath": "_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/payment/$period/index.tsx",
      "parent": "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost"
    },
    "/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/": {
      "filePath": "_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/index.tsx",
      "parent": "/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile"
    },
    "/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/": {
      "filePath": "_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/index.tsx",
      "parent": "/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile"
    },
    "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/": {
      "filePath": "_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/index.tsx",
      "parent": "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id"
    },
    "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/all/": {
      "filePath": "_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/all/index.tsx",
      "parent": "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/contract/": {
      "filePath": "_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/contract/index.tsx",
      "parent": "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/estimate/": {
      "filePath": "_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/estimate/index.tsx",
      "parent": "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/order/": {
      "filePath": "_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/order/index.tsx",
      "parent": "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/payment/": {
      "filePath": "_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/payment/index.tsx",
      "parent": "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/": {
      "filePath": "_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/index.tsx",
      "parent": "/_staff/software/$id/_$id/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/": {
      "filePath": "_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/index.tsx",
      "parent": "/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile"
    },
    "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/": {
      "filePath": "_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/index.tsx",
      "parent": "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile"
    },
    "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/all/": {
      "filePath": "_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/all/index.tsx",
      "parent": "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/contract/": {
      "filePath": "_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/contract/index.tsx",
      "parent": "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/estimate/": {
      "filePath": "_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/estimate/index.tsx",
      "parent": "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/order/": {
      "filePath": "_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/order/index.tsx",
      "parent": "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/payment/": {
      "filePath": "_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/payment/index.tsx",
      "parent": "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/": {
      "filePath": "_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/vendor-invoice/index.tsx",
      "parent": "/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal"
    },
    "/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/": {
      "filePath": "_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/index.tsx",
      "parent": "/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile"
    },
    "/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/": {
      "filePath": "_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/index.tsx",
      "parent": "/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile"
    },
    "/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/_task-detail/chunks/": {
      "filePath": "_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/_task-detail/chunks/index.tsx",
      "parent": "/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/_task-detail"
    },
    "/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/": {
      "filePath": "_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/index.tsx",
      "parent": "/_staff/attendance-core/_layout/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile"
    },
    "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/$chunkId/result/": {
      "filePath": "_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id/tasks/$taskId/chunks/$chunkId/result/index.tsx",
      "parent": "/_staff/settings/data-connector/inbound/aggregate-data-pipeline/$id"
    },
    "/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/chunks/$chunkId/result/": {
      "filePath": "_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId/chunks/$chunkId/result/index.tsx",
      "parent": "/_staff/settings/data-connector/inbound/data-pipeline/$id/execution-results/$taskId"
    }
  }
}
ROUTE_MANIFEST_END */
